if ( ! Object.extend ) {
	Object.extend = function(destination, source) {
	    return $.extend(true, destination, source) ;
      // for (var property in source) {
	    //     if (source.hasOwnProperty(property)) {
	    //         destination[property] = source[property];
	    //     }
	    // }
	    // return destination;
	};
}

if ( ! Object.values ) {
  Object.values = function(object) {
    var values = [];
    for(var property in object) {
      if ( object.hasOwnProperty(property))
        values.push(object[property]);
    }
    return values;
  }
}


if ( ! Number.isNumeric ) {
	Number.isNumeric = function(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	};
}

function isFunction(functionToCheck) {
	var getType = {};
	return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.angularCreditCards = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
exports = module.exports = ap;
function ap (args, fn) {
    return function () {
        var rest = [].slice.call(arguments)
            , first = args.slice()
        first.push.apply(first, rest)
        return fn.apply(this, first);
    };
}

exports.pa = pa;
function pa (args, fn) {
    return function () {
        var rest = [].slice.call(arguments)
        rest.push.apply(rest, args)
        return fn.apply(this, rest);
    };
}

exports.apa = apa;
function apa (left, right, fn) {
    return function () {
        return fn.apply(this,
            left.concat.apply(left, arguments).concat(right)
        );
    };
}

exports.partial = partial;
function partial (fn) {
    var args = [].slice.call(arguments, 1);
    return ap(args, fn);
}

exports.partialRight = partialRight;
function partialRight (fn) {
    var args = [].slice.call(arguments, 1);
    return pa(args, fn);
}

exports.curry = curry;
function curry (fn) {
    return partial(partial, fn);
}

exports.curryRight = function curryRight (fn) {
    return partial(partialRight, fn);
}

},{}],2:[function(_dereq_,module,exports){
var upperCase = _dereq_('upper-case')
var sentenceCase = _dereq_('sentence-case')

/**
 * Camel case a string.
 *
 * @param  {String} string
 * @param  {String} [locale]
 * @return {String}
 */
module.exports = function (string, locale) {
  return sentenceCase(string, locale)
    // Replace periods between numeric entities with an underscore.
    .replace(/(\d) (?=\d)/g, '$1_')
    // Replace spaces between words with an upper cased character.
    .replace(/ (.)/g, function (m, $1) {
      return upperCase($1, locale)
    })
}

},{"sentence-case":23,"upper-case":27}],3:[function(_dereq_,module,exports){
'use strict'

var isArray = _dereq_('isarray')

module.exports = function castArray (value) {
  return isArray(value) ? value : [value]
}

},{"isarray":18}],4:[function(_dereq_,module,exports){
'use strict'

var types = exports.types = _dereq_('./src/types')
exports.Type = _dereq_('./src/type')

exports.find = function findCardType (callback) {
  for (var typeName in types) {
    var type = types[typeName]
    var result = callback(type)
    if (result) return type
  }
}

},{"./src/type":5,"./src/types":6}],5:[function(_dereq_,module,exports){
'use strict'

var extend = _dereq_('xtend/mutable')

module.exports = CardType

function CardType (name, config) {
  extend(this, {name: name}, config)
}

CardType.prototype.cvcLength = 3
CardType.prototype.luhn = true
CardType.prototype.groupPattern = /(\d{1,4})(\d{1,4})?(\d{1,4})?(\d{1,4})?/

CardType.prototype.group = function (number) {
  return (number.match(this.groupPattern) || [])
    .slice(1)
    .filter(Boolean)
}

CardType.prototype.test = function (number, eager) {
  return this[eager ? 'eagerPattern' : 'pattern'].test(number)
}

},{"xtend/mutable":29}],6:[function(_dereq_,module,exports){
'use strict'

var Type = _dereq_('./type')

var group19 = /(\d{1,4})(\d{1,4})?(\d{1,4})?(\d{1,4})?(\d{1,3})?/

exports.visa = new Type('Visa', {
  pattern: /^4\d{12}(\d{3}|\d{6})?$/,
  eagerPattern: /^4/,
  groupPattern: group19
})

exports.maestro = new Type('Maestro', {
  pattern: /^(?:5[06789]\d\d|(?!6011[0234])(?!60117[4789])(?!60118[6789])(?!60119)(?!64[456789])(?!65)6\d{3})\d{8,15}$/,
  eagerPattern: /^(5(018|0[23]|[68])|6[37]|60111|60115|60117([56]|7[56])|60118[0-5]|64[0-3]|66)/,
  groupPattern: group19
})

exports.forbrugsforeningen = new Type('Forbrugsforeningen', {
  pattern: /^600722\d{10}$/,
  eagerPattern: /^600/
})

exports.dankort = new Type('Dankort', {
  pattern: /^5019\d{12}$/,
  eagerPattern: /^5019/
})

exports.masterCard = new Type('MasterCard', {
  pattern: /^5[1-5]\d{14}$/,
  eagerPattern: /^5[1-5]/
})

exports.americanExpress = new Type('American Express', {
  pattern: /^3[47]\d{13}$/,
  eagerPattern: /^3[47]/,
  groupPattern: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
  cvcLength: 4
})

exports.dinersClub = new Type('Diners Club', {
  pattern: /^3(0[0-5]|[68]\d)\d{11}$/,
  eagerPattern: /^3(0|[68])/,
  groupPattern: /(\d{1,4})?(\d{1,6})?(\d{1,4})?/
})

exports.discover = new Type('Discover', {
  pattern: /^6(011(0[0-9]|[2-4]\d|74|7[7-9]|8[6-9]|9[0-9])|4[4-9]\d{3}|5\d{4})\d{10}$/,
  eagerPattern: /^6(011(0[0-9]|[2-4]|74|7[7-9]|8[6-9]|9[0-9])|4[4-9]|5)/
})

exports.jcb = new Type('JCB', {
  pattern: /^35\d{14}$/,
  eagerPattern: /^35/
})

exports.unionPay = new Type('UnionPay', {
  pattern: /^62[0-5]\d{13,16}$/,
  eagerPattern: /^62/,
  groupPattern: group19,
  luhn: false
})

},{"./type":5}],7:[function(_dereq_,module,exports){
'use strict'

exports.card = _dereq_('./src/card')
exports.cvc = _dereq_('./src/cvc')
exports.expiration = _dereq_('./src/expiration')

},{"./src/card":8,"./src/cvc":9,"./src/expiration":10}],8:[function(_dereq_,module,exports){
'use strict'

var luhn = _dereq_('fast-luhn')
var types = _dereq_('./types')

module.exports = {
  types: types,
  parse: parseCard,
  format: formatCard,
  type: cardType,
  luhn: luhn,
  isValid: isCardValid
}

function parseCard (number) {
  if (typeof number !== 'string') return ''
  return number.replace(/[^\d]/g, '')
}

function formatCard (number, separator) {
  var type = getType(number, true)
  if (!type) return number
  return type.group(number).join(separator || ' ')
}

function cardType (number, eager) {
  var type = getType(number, eager)
  return type ? type.name : undefined
}

function isCardValid (number, type) {
  if (type) {
    type = types.get(type)
  } else {
    type = getType(number)
  }
  if (!type) return false
  return (!type.luhn || luhn(number)) && type.test(number)
}

function getType (number, eager) {
  return types.find(function (type) {
    return type.test(number, eager)
  })
}

},{"./types":11,"fast-luhn":13}],9:[function(_dereq_,module,exports){
'use strict'

var types = _dereq_('./types')
var cvcRegex = /^\d{3,4}$/

module.exports = {
  isValid: cvcIsValid
}

function cvcIsValid (cvc, type) {
  if (typeof cvc !== 'string') return false
  if (!cvcRegex.test(cvc)) return false
  if (!type) return true
  return types.get(type).cvcLength === cvc.length
}

},{"./types":11}],10:[function(_dereq_,module,exports){
'use strict'

var isValidMonth = _dereq_('is-valid-month')
var parseIntStrict = _dereq_('parse-int')
var parseYear = _dereq_('parse-year')

module.exports = {
  isPast: isPast,
  month: {
    parse: parseMonth,
    isValid: isValidMonth
  },
  year: {
    parse: parseYear,
    format: formatExpYear,
    isValid: isExpYearValid,
    isPast: isExpYearPast
  }
}

function isPast (month, year) {
  return Date.now() >= new Date(year, month)
}

function parseMonth (month) {
  return parseIntStrict(month)
}

function formatExpYear (year, strip) {
  year = year.toString()
  return strip ? year.substr(2, 4) : year
}

function isExpYearValid (year) {
  if (typeof year !== 'number') return false
  year = parseIntStrict(year)
  return year > 0
}

function isExpYearPast (year) {
  return new Date().getFullYear() > year
}

},{"is-valid-month":17,"parse-int":21,"parse-year":22}],11:[function(_dereq_,module,exports){
'use strict'

var ccTypes = _dereq_('creditcards-types')
var camel = _dereq_('camel-case')
var extend = _dereq_('xtend')

module.exports = extend(ccTypes, {
  get: function getTypeByName (name) {
    return ccTypes.types[camel(name)]
  }
})

},{"camel-case":2,"creditcards-types":4,"xtend":28}],12:[function(_dereq_,module,exports){
'use strict'

var zeroFill = _dereq_('zero-fill')
var parseIntStrict = _dereq_('parse-int')

var pad = zeroFill(2)

module.exports = function expandYear (year, now) {
  now = now || new Date()
  var base = now.getFullYear().toString().substr(0, 2)
  year = parseIntStrict(year)
  return parseIntStrict(base + pad(year))
}

},{"parse-int":21,"zero-fill":30}],13:[function(_dereq_,module,exports){
'use strict'

module.exports = (function (array) {
  return function luhn (number) {
    if (!number) return false
    var length = number.length
    var bit = 1
    var sum = 0
    var value

    while (length) {
      value = parseInt(number.charAt(--length), 10)
      sum += (bit ^= 1) ? array[value] : value
    }

    return !!sum && sum % 10 === 0
  }
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]))

},{}],14:[function(_dereq_,module,exports){
var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    var bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


},{}],15:[function(_dereq_,module,exports){
'use strict';
var numberIsNan = _dereq_('number-is-nan');

module.exports = Number.isFinite || function (val) {
	return !(typeof val !== 'number' || numberIsNan(val) || val === Infinity || val === -Infinity);
};

},{"number-is-nan":20}],16:[function(_dereq_,module,exports){
// https://github.com/paulmillr/es6-shim
// http://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.isinteger
var isFinite = _dereq_("is-finite");
module.exports = Number.isInteger || function(val) {
  return typeof val === "number" &&
    isFinite(val) &&
    Math.floor(val) === val;
};

},{"is-finite":15}],17:[function(_dereq_,module,exports){
'use strict'

var isInteger = _dereq_('is-integer')

module.exports = function isValidMonth (month) {
  if (typeof month !== 'number' || !isInteger(month)) return false
  return month >= 1 && month <= 12
}

},{"is-integer":16}],18:[function(_dereq_,module,exports){
module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

},{}],19:[function(_dereq_,module,exports){
/**
 * Special language-specific overrides.
 *
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 *
 * @type {Object}
 */
var LANGUAGES = {
  tr: {
    regexp: /\u0130|\u0049|\u0049\u0307/g,
    map: {
      '\u0130': '\u0069',
      '\u0049': '\u0131',
      '\u0049\u0307': '\u0069'
    }
  },
  az: {
    regexp: /[\u0130]/g,
    map: {
      '\u0130': '\u0069',
      '\u0049': '\u0131',
      '\u0049\u0307': '\u0069'
    }
  },
  lt: {
    regexp: /[\u0049\u004A\u012E\u00CC\u00CD\u0128]/g,
    map: {
      '\u0049': '\u0069\u0307',
      '\u004A': '\u006A\u0307',
      '\u012E': '\u012F\u0307',
      '\u00CC': '\u0069\u0307\u0300',
      '\u00CD': '\u0069\u0307\u0301',
      '\u0128': '\u0069\u0307\u0303'
    }
  }
}

/**
 * Lowercase a string.
 *
 * @param  {String} str
 * @return {String}
 */
module.exports = function (str, locale) {
  var lang = LANGUAGES[locale]

  str = str == null ? '' : String(str)

  if (lang) {
    str = str.replace(lang.regexp, function (m) { return lang.map[m] })
  }

  return str.toLowerCase()
}

},{}],20:[function(_dereq_,module,exports){
'use strict';
module.exports = Number.isNaN || function (x) {
	return x !== x;
};

},{}],21:[function(_dereq_,module,exports){
'use strict'

var isInteger = _dereq_('is-integer')

module.exports = function parseIntStrict (int) {
  if (typeof int === 'number') {
    return isInteger(int) ? int : undefined
  }
  if (typeof int === 'string') {
    return /^\d+$/.test(int) ? parseInt(int, 10) : undefined
  }
}

},{"is-integer":16}],22:[function(_dereq_,module,exports){
'use strict'

var parseIntStrict = _dereq_('parse-int')
var expandYear = _dereq_('expand-year')

module.exports = function parseYear (year, expand, now) {
  year = parseIntStrict(year)
  if (year == null) return
  if (!expand) return year
  return expandYear(year, now)
}

},{"expand-year":12,"parse-int":21}],23:[function(_dereq_,module,exports){
var lowerCase = _dereq_('lower-case')

var NON_WORD_REGEXP = _dereq_('./vendor/non-word-regexp')
var CAMEL_CASE_REGEXP = _dereq_('./vendor/camel-case-regexp')
var TRAILING_DIGIT_REGEXP = _dereq_('./vendor/trailing-digit-regexp')

/**
 * Sentence case a string.
 *
 * @param  {String} str
 * @param  {String} locale
 * @param  {String} replacement
 * @return {String}
 */
module.exports = function (str, locale, replacement) {
  if (str == null) {
    return ''
  }

  replacement = replacement || ' '

  function replace (match, index, string) {
    if (index === 0 || index === (string.length - match.length)) {
      return ''
    }

    return replacement
  }

  str = String(str)
    // Support camel case ("camelCase" -> "camel Case").
    .replace(CAMEL_CASE_REGEXP, '$1 $2')
    // Support digit groups ("test2012" -> "test 2012").
    .replace(TRAILING_DIGIT_REGEXP, '$1 $2')
    // Remove all non-word characters and replace with a single space.
    .replace(NON_WORD_REGEXP, replace)

  // Lower case the entire string.
  return lowerCase(str, locale)
}

},{"./vendor/camel-case-regexp":24,"./vendor/non-word-regexp":25,"./vendor/trailing-digit-regexp":26,"lower-case":19}],24:[function(_dereq_,module,exports){
module.exports = /([\u0061-\u007A\u00B5\u00DF-\u00F6\u00F8-\u00FF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0561-\u0587\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7FA\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A])([\u0041-\u005A\u00C0-\u00D6\u00D8-\u00DE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA\uFF21-\uFF3A\u0030-\u0039\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])/g

},{}],25:[function(_dereq_,module,exports){
module.exports = /[^\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC\u0030-\u0039\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+/g

},{}],26:[function(_dereq_,module,exports){
module.exports = /([\u0030-\u0039\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])([^\u0030-\u0039\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])/g

},{}],27:[function(_dereq_,module,exports){
/**
 * Special language-specific overrides.
 *
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 *
 * @type {Object}
 */
var LANGUAGES = {
  tr: {
    regexp: /[\u0069]/g,
    map: {
      '\u0069': '\u0130'
    }
  },
  az: {
    regexp: /[\u0069]/g,
    map: {
      '\u0069': '\u0130'
    }
  },
  lt: {
    regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
    map: {
      '\u0069\u0307': '\u0049',
      '\u006A\u0307': '\u004A',
      '\u012F\u0307': '\u012E',
      '\u0069\u0307\u0300': '\u00CC',
      '\u0069\u0307\u0301': '\u00CD',
      '\u0069\u0307\u0303': '\u0128'
    }
  }
}

/**
 * Upper case a string.
 *
 * @param  {String} str
 * @return {String}
 */
module.exports = function (str, locale) {
  var lang = LANGUAGES[locale]

  str = str == null ? '' : String(str)

  if (lang) {
    str = str.replace(lang.regexp, function (m) { return lang.map[m] })
  }

  return str.toUpperCase()
}

},{}],28:[function(_dereq_,module,exports){
module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}

},{}],29:[function(_dereq_,module,exports){
module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}

},{}],30:[function(_dereq_,module,exports){
/**
 * Given a number, return a zero-filled string.
 * From http://stackoverflow.com/questions/1267283/
 * @param  {number} width
 * @param  {number} number
 * @return {string}
 */
module.exports = function zeroFill (width, number, pad) {
  if (number === undefined) {
    return function (number, pad) {
      return zeroFill(width, number, pad)
    }
  }
  if (pad === undefined) pad = '0'
  width -= number.toString().length
  if (width > 0) return new Array(width + (/\./.test(number) ? 2 : 1)).join(pad) + number
  return number + ''
}

},{}],31:[function(_dereq_,module,exports){
'use strict'

var cvc = _dereq_('creditcards').cvc
var bind = _dereq_('function-bind')

module.exports = factory

factory.$inject = ['$parse']
function factory ($parse) {
  return {
    restrict: 'A',
    require: 'ngModel',
    compile: function (element, attributes) {
      attributes.$set('maxlength', 4)
      attributes.$set('pattern', '[0-9]*')
      attributes.$set('xAutocompletetype', 'cc-csc')

      return function (scope, element, attributes, ngModel) {

        ngModel.$validators.ccCvc = function (value) {
          return ngModel.$isEmpty(ngModel.$viewValue) || cvc.isValid(value, $parse(attributes.ccType)(scope))
        }

        if (attributes.ccType) {
          scope.$watch(attributes.ccType, bind.call(ngModel.$validate, ngModel))
        }
      }
    }
  }
}

},{"creditcards":7,"function-bind":14}],32:[function(_dereq_,module,exports){
'use strict'

var expiration = _dereq_('creditcards').expiration
var month = expiration.month
var year = expiration.year
var ap = _dereq_('ap')

exports = module.exports = function ccExp () {
  return {
    restrict: 'AE',
    require: 'ccExp',
    controller: CcExpController,
    link: function (scope, element, attributes, ccExp) {
      ccExp.$watch()
    }
  }
}

CcExpController.$inject = ['$scope', '$element']
function CcExpController ($scope, $element) {
  var nullFormCtrl = {
    $setValidity: noop
  }
  var parentForm = $element.inheritedData('$formController') || nullFormCtrl
  var ngModel = {
    year: {},
    month: {}
  }

  this.setMonth = function (monthCtrl) {
    ngModel.month = monthCtrl
  }
  this.setYear = function (yearCtrl) {
    ngModel.year = yearCtrl
  }

  function setValidity (exp) {
    var expMonth = exp.month
    var expYear = exp.year
    var valid = (expMonth == null && expYear == null) || !!expMonth && !!expYear && !expiration.isPast(expMonth, expYear)
    parentForm.$setValidity('ccExp', valid, $element)
  }

  this.$watch = function $watchExp () {
    $scope.$watch(function watchExp () {
      return {
        month: ngModel.month.$modelValue,
        year: ngModel.year.$modelValue
      }
    }, setValidity, true)
  }
}

var nullCcExp = {
  setMonth: noop,
  setYear: noop
}

exports.month = function ccExpMonth () {
  return {
    restrict: 'A',
    require: ['ngModel', '^?ccExp'],
    compile: function (element, attributes) {
      attributes.$set('maxlength', 2)
      attributes.$set('pattern', '[0-9]*')
      attributes.$set('xAutocompletetype', 'cc-exp-month')

      return function (scope, element, attributes, controllers) {
        var ngModel = controllers[0]
        var ccExp = controllers[1] || nullCcExp

        ccExp.setMonth(ngModel)
        ngModel.$parsers.unshift(month.parse)
        ngModel.$validators.ccExpMonth = function validateExpMonth (value) {
          return ngModel.$isEmpty(ngModel.$viewValue) || month.isValid(value)
        }
      }
    }
  }
}

exports.year = function ccExpYear () {
  return {
    restrict: 'A',
    require: ['ngModel', '^?ccExp'],
    compile: function (element, attributes) {
      var fullYear = attributes.fullYear !== undefined

      attributes.$set('maxlength', fullYear ? 4 : 2)
      attributes.$set('pattern', '[0-9]*')
      attributes.$set('xAutocompletetype', 'cc-exp-year')

      return function (scope, element, attributes, controllers) {
        var ngModel = controllers[0]
        var ccExp = controllers[1] || nullCcExp

        ccExp.setYear(ngModel)

        ngModel.$parsers.unshift(ap.partialRight(year.parse, !fullYear))

        ngModel.$formatters.unshift(function formatExpYear (value) {
          return value ? year.format(value, !fullYear) : ''
        })

        ngModel.$validators.ccExpYear = function validateExpYear (value) {
          return ngModel.$isEmpty(ngModel.$viewValue) || (year.isValid(value) && !year.isPast(value))
        }
      }
    }
  }
}

function noop () {}

},{"ap":1,"creditcards":7}],33:[function(_dereq_,module,exports){
'use strict'

var card = _dereq_('creditcards').card
var array = _dereq_('cast-array')
var partial = _dereq_('ap').partial

module.exports = factory

factory.$inject = ['$parse']
function factory ($parse) {
  return {
    restrict: 'A',
    require: ['ngModel', 'ccNumber'],
    controller: function () {
      this.type = null
      this.eagerType = null
    },
    compile: function ($element, $attributes) {
      $attributes.$set('pattern', '[0-9]*')
      $attributes.$set('xAutocompletetype', 'cc-number')

      return function ($scope, $element, $attributes, controllers) {
        var ngModel = controllers[0]
        var ccNumber = controllers[1]

        $scope.$watch($attributes.ngModel, function (number) {
          ngModel.$ccType = ccNumber.type = card.type(number)
        })

        function $viewValue () {
          return ngModel.$viewValue
        }

        function setCursorPostion (element, position) {
          if (element.setSelectionRange) {
            element.setSelectionRange(position, position)
          } else if (element.createTextRange) {
            var range = element.createTextRange()
            range.move('character', position)
            range.select()
          }
        }

        if ($attributes.ccEagerType != null) {
          $scope.$watch($viewValue, function eagerTypeCheck (number) {
            if (!number) return
            number = card.parse(number)
            ngModel.$ccEagerType = ccNumber.eagerType = card.type(number, true)
          })
        }

        if ($attributes.ccType) {
          $scope.$watch($attributes.ccType, function () {
            ngModel.$validate()
          })
        }

        if ($attributes.ccFormat != null) {
          $element.on('input', function formatInput () {
            var input = $element.val()
            var previous = $viewValue()
            if (!input) return
            var element = $element[0]
            var formatted = card.format(card.parse(input))

            var selectionEnd = element.selectionEnd
            ngModel.$setViewValue(formatted)
            ngModel.$render()
            if (formatted && (!formatted.charAt(selectionEnd - 1).trim())) {
              if (previous && previous.length < formatted.length) {
                selectionEnd++
              } else {
                selectionEnd--
              }
            }
            setCursorPostion(element, selectionEnd)

          })
        }

        ngModel.$parsers.unshift(card.parse)

        ngModel.$validators.ccNumber = function validateCcNumber (number) {
          return ngModel.$isEmpty(ngModel.$viewValue) || card.isValid(number)
        }

        ngModel.$validators.ccNumberType = function validateCcNumberType (number) {
          if (ngModel.$isEmpty(ngModel.$viewValue)) return true
          var type = $parse($attributes.ccType)($scope)
          if (!type) card.isValid(number)
          return array(type).some(partial(card.isValid, number))
        }
      }
    }
  }
}

},{"ap":1,"cast-array":3,"creditcards":7}],34:[function(_dereq_,module,exports){
(function (global){
'use strict'

var angular = (typeof window !== "undefined" ? window['angular'] : typeof global !== "undefined" ? global['angular'] : null)
var creditcards = _dereq_('creditcards')
var number = _dereq_('./number')
var cvc = _dereq_('./cvc')
var expiration = _dereq_('./expiration')

module.exports = angular
  .module('credit-cards', [])
  .value('creditcards', creditcards)
  .directive('ccNumber', number)
  .directive('ccExp', expiration)
  .directive('ccExpMonth', expiration.month)
  .directive('ccExpYear', expiration.year)
  .directive('ccCvc', cvc)
  .name

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./cvc":31,"./expiration":32,"./number":33,"creditcards":7}]},{},[34])(34)
});
/**
 * Deloitte Digital global namespace for modules
 * @namespace DD
 */
;(function() {
	'use strict';

	window.DD = window.DD || {};

	/**
	 * Breakpoints for JavaScript. Works with the Deloitte Digital SCSS @bp mixin
	 *
	 * @namespace bp
	 * @memberof DD
	 * @version 1.0.0
	 * @copyright 2012-2014 Deloitte Digital Australia - http://www.deloittedigital.com/au
	 * @author Deloitte Digital Australia deloittedigital@deloitte.com.au
	 * @license BSD 3-Clause (http://opensource.org/licenses/BSD-3-Clause)
	 */
	window.DD.bp = (function() {
		var _minBreakpoints,
			_maxBreakpoints,
			_options = {
				isResponsive: true,
				baseFontSize: 16,
				breakpoints: [
					{
						name: 'xxs',
						px: 359
					},
					{
						name: 'xs',
						px: 480
					},
					{
						name: 's',
						px: 640
					},
					{
						name: 'm',
						px: 768
					},
					{
						name: 'l',
						px: 1024
					},
					{
						name: 'xl',
						px: 1244
					},
					{
						name: 'xxl',
						px: 1410
					}
				],
				staticRange: {
					min: 0,
					max: 'xl'
				}
			},
			_initBreakpoints,
			_parseMinMaxInputs,
			_pxToEms,
			_bpToEms,
			_bpIsValidForStatic,
			_bpMin,
			_bpMax,
			_bpBetween,
			get,
			getHeight,
			is,
			isHeight,
			options;

		/**
		 * Sorts the breakpoints and assigns them to an associative array for more efficient lookup.
		 * Immediately invoked on initialisation
		 *
		 * @memberof DD.bp
		 * @private
		 */
		_initBreakpoints = function() {
			//sort the breakpoints into order of smallest to largest
			var sortedBreakpoints = _options.breakpoints.sort(function(a, b) {
				// only sort if the correct objects are present
				if (a.px < b.px) {
					return -1;
				}

				if (a.px > b.px) {
					return 1;
				}

				return 0;
			});

			// reset the breakpoints
			_minBreakpoints = {};
			_maxBreakpoints = {};

			// loop through sorted breakpoints to generate a quick lookup object using the name as a key
			for (var i = 0, len = sortedBreakpoints.length, last = len - 1; i < len; i += 1) {
				_minBreakpoints[sortedBreakpoints[i].name] = parseInt(sortedBreakpoints[i].px, 10);

				// skip the last item in the list as we assume there is no maximum for the last
				if (i < last) {
					// the max breakpoint of the current size is the next breakpoints
					// width minus 1px so there is no overlap between breakpoints
					_maxBreakpoints[sortedBreakpoints[i].name] = parseInt(sortedBreakpoints[i + 1].px - 1, 10);
				}
			}
		};
		_initBreakpoints();

		/**
		 * Splits string syntax 'xs,m' into separate values 'xs' and 'm'
		 * Converts string '5' to numeric 5
		 *
		 * @memberof DD.bp
		 * @private
		 * @param  {String|Number} min Number in pixels or string notation
		 * @param  {String|Number} max Number in pixels or string notation
		 * @return {Object} Object containing the min and max values parsed as a number
		 */
		_parseMinMaxInputs = function(min, max) {
			var parseValue = function(val) {
					if (typeof (val) === 'string') {
						// Strip whitespace
						val = val.replace(/\s/g, '');

						// If val only contains digits, convert it to a number
						if (/^\d+$/.test(val)) {
							val = parseInt(val, 10);
						}
					}

					return val;
				},
				bpArray,
				resultMin = min,
				resultMax = max || 0;

			// check if it's using the string syntax, if so - split it
			if (typeof (min) === 'string' && min.indexOf(',') !== -1 && resultMax === 0) {
				bpArray = min.split(',');
				if (bpArray.length === 2) {
					resultMin = bpArray[0];
					resultMax = bpArray[1];
				}
			}

			return {
				min: parseValue(resultMin),
				max: parseValue(resultMax)
			};
		};

		/**
		 * Converts a number of pixels into em
		 *
		 * @memberof DD.bp
		 * @private
		 * @param  {Number} px Number in pixels
		 * @return {String} The converted number in em as a string
		 */
		_pxToEms = function(px) {
			return px / _options.baseFontSize;
		};

		/**
		 * Converts a breakpoint name/value (e.g. l) to the px variable then to ems
		 *
		 * @memberof DD.bp
		 * @private
		 * @param  {String|Number} breakpoint Breakpoint name as a string, or as a number in pixels
		 * @param  {Boolean} [isMax=false] Flag to determine if the min or max of the breakpoint needs to be used
		 * @return {String} The converted number in em as a string
		 */
		_bpToEms = function(breakpoint, isMax) {
			if (typeof (breakpoint) === 'number') {
				return _pxToEms(breakpoint);
			}

			var list = (isMax === true) ? _maxBreakpoints : _minBreakpoints,
				ems = '0';

			for (var key in list) {
				if (list.hasOwnProperty(key)) {
					if (breakpoint === key.toLowerCase()) {
						ems = _pxToEms(list[key]);
					}
				}
			}

			if (ems === '0') {
				void 0;
			}

			return ems;
		};

		/**
		 * Checks if the breakpoint provided falls inside the valid static min/max region
		 *
		 * @memberof DD.bp
		 * @private
		 * @param  {String|Number} min Breakpoint name as a string, as a number in pixels, or as string notation containing both breakpoints
		 * @param  {String|Number} max Breakpoint name as a string, or as a number in pixels
		 * @param  {Boolean} [property='width'] which property to check for (e.g. width or height)
		 * @return {Boolean} If the breakpoint fits inside the static range or not
		 */
		_bpIsValidForStatic = function(min, max, property) {
			if (typeof (property) !== 'string') {
				property = 'width'; //default to width based media query
			}

			if (property !== 'width') {
				return false;
			}

			var bpValidMin = _bpToEms(_options.staticRange.min),
				bpValidMax = _bpToEms(_options.staticRange.max, true),
				parsed = _parseMinMaxInputs(min, max),
				bpMin = _bpToEms(parsed.min),
				bpMax = _bpToEms(parsed.max);

			// if max is 0 we have a min-and-above situation
			if (parsed.max === 0) {
				// need to check that the min is greater than the valid min,
				// AND also that the min is less than the valid maximum
				if (bpMin >= bpValidMin && bpMin < bpValidMax) {
					return true;
				}

				return false;
			}

			// if min is 0 we have a max-and-below situation
			if (parsed.min === 0) {
				if (bpMax >= bpValidMax) {
					return true;
				}

				return false;
			}

			// if the min is above the valid max, or the max is below the valid min
			if (bpMin > bpValidMax || bpMax < bpValidMin) {
				return false;
			}

			// if the breakpoint is a bp-between (assumed because $max and $min aren't 0)
			// don't show if the max isn't above the valid max
			if (bpMax < bpValidMax) {
				return false;
			}

			return true;
		};

		/**
		 * Returns a min-width media query based on bp name or px
		 *
		 * @memberof DD.bp
		 * @private
		 * @param  {String|Number} min Breakpoint name as a string, or as a number in pixels
		 * @param  {String} [property='width'] Property to check using a media query. e.g. width or height
		 * @return {String} Media query string
		 */
		_bpMin = function(min, property) {
			var bpMin = _bpToEms(min),
				bpType = (typeof (property) === 'string') ? property : 'width';

			return '(min-' + bpType + ': ' + bpMin + 'em)';
		};

		/**
		 * Returns a max-width media query based on bp name or px
		 *
		 * @memberof DD.bp
		 * @private
		 * @param  {String|Number} max Breakpoint name as a string, or as a number in pixels
		 * @param  {String} [property='width'] Property to check using a media query. e.g. width or height
		 * @return {String} Media query string
		 */
		_bpMax = function(max, property) {
			var bpMax = _bpToEms(max, true),
				bpType = (typeof (property) === 'string') ? property : 'width';

			return '(max-' + bpType + ': ' + bpMax + 'em)';
		};

		/**
		 * Returns a min-width and max-width media query based on bp name (can be the same bp name) or px
		 *
		 * @memberof DD.bp
		 * @private
		 * @param  {String|Number} min Breakpoint name as a string, or as a number in pixels
		 * @param  {String|Number} max Breakpoint name as a string, or as a number in pixels
		 * @param  {String} [property='width'] Property to check using a media query. e.g. width or height
		 * @return {String} Media query string
		 */
		_bpBetween = function(min, max, property) {
			var bpMin = _bpToEms(min),
				bpMax = _bpToEms(max, true),
				bpType = (typeof (property) === 'string') ? property : 'width';

			return '(min-' + bpType + ': ' + bpMin + 'em) and (max-' + bpType + ': ' + bpMax + 'em)';
		};

		/**
		 * Breakpoint function that can take the input of a min and max
		 * breakpoint by name or number (in px) along with a property
		 * (like width or height) and returns the media query as a string
		 *
		 * @memberof DD.bp
		 * @example
		 * // large and above
		 * DD.bp.get('l');
		 *
		 * @example
		 * // 300px and above
		 * DD.bp.get(300);
		 *
		 * @example
		 * // large and below
		 * DD.bp.get(0, 'l');
		 *
		 * @example
		 * // 300px and below
		 * DD.bp.get(0, 300);
		 *
		 * @example
		 * // Between small and large
		 * DD.bp.get('s', 'l');
		 *
		 * @example
		 * // Between 100px and 300px
		 * DD.bp.get(100, 300);
		 *
		 * @example
		 * // High resolution displays (can use 'hdpi' as well)
		 * DD.bp.get('retina');
		 *
		 * @example
		 * // Can mix and match names and numbers - between 200px and xlarge
		 * DD.bp.get(200, 'xl');
		 *
		 * @example
		 * // Between small and 960px
		 * DD.bp.get('s', 960);
		 *
		 * @example
		 * // Can use a single string (no spaces) - useful for passing through from HTML to JS
		 * DD.bp.get('m,l');
		 *
		 * @example
		 * // Can also mix names and numbers
		 * DD.bp.get('xs,1000');
		 *
		 * @param  {String|Number} min Breakpoint name as a string, or as a number in pixels, or in comma separated string notation
		 * @param  {String|Number} [max=0] Breakpoint name as a string, or as a number in pixels
		 * @param  {String} [property='width'] Property to check using a media query. e.g. width or height
		 * @return {String} Media query string
		 */
		get = function(min, max, property) {
			var parsed = _parseMinMaxInputs(min, max),
				bpMin = parsed.min,
				bpMax = parsed.max;

			if (typeof (property) !== 'string') {
				property = 'width'; //default to width based media query
			}

			//check what type of bp it is
			if (bpMin === 'retina' || bpMin === 'hdpi') {
				return '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-device-pixel-ratio: 1.5)';
			} else if (bpMax === 0) {
				return _bpMin(bpMin, property);
			} else if (bpMin === 0) {
				return _bpMax(bpMax, property);
			} else {
				return _bpBetween(bpMin, bpMax, property);
			}
		};

		/**
		 * Shortcut for the get() function that returns a height
		 * based media query and returns the media query as a string
		 *
		 * @memberof DD.bp
		 * @example
		 * // Height of 300px and above
		 * DD.bp.getHeight(300);
		 *
		 * @example
		 * // Height of 300px and below
		 * DD.bp.getHeight(0, 300);
		 *
		 * @example
		 * // Between 100px and 300px high
		 * DD.bp.getHeight(100, 300);
		 *
		 * @param  {String|Number} min Breakpoint name as a string, or as a number in pixels, or in comma separated string notation
		 * @param  {String|Number} [max=0] Breakpoint name as a string, or as a number in pixels
		 * @return {String} Media query string
		 */
		getHeight = function(min, max) {
			return get(min, max, 'height');
		};

		/**
		 * Breakpoint function that takes the same inputs as get() but
		 * instead of returning the media query as a string returns
		 * if the current page matches that query as a boolean using
		 * window.matchMedia(mq).matches
		 *
		 * @memberof DD.bp
		 * @example
		 * // returns true if the page is between xs and s
		 * DD.bp.is('xs,s');
		 * DD.bp.is('xs','s');
		 *
		 * @example
		 * // returns true if the page is between 0 and 300px wide
		 * DD.bp.is('0,300');
		 * DD.bp.is(0, 300);
		 *
		 * @param  {String|Number} min Breakpoint name as a string, or as a number in pixels, or in comma separated string notation
		 * @param  {String|Number} [max=0] Breakpoint name as a string, or as a number in pixels
		 * @param  {String} [property='width'] Property to check using a media query. e.g. width or height
		 * @return {Boolean}
		 */
		is = function(min, max, property) {
			if (_options.isResponsive === false) {
				return _bpIsValidForStatic(min, max, property);
			}

			if (window.matchMedia) {
				return window.matchMedia(get(min, max, property)).matches;
			}

			void 0;

			return false;
		};

		/**
		 * Shortcut for the is() function that returns a height
		 * based media query and returns the media query as a boolean
		 *
		 * @memberof DD.bp
		 * @example
		 * // returns true if the page is between 0 and 300px high
		 * DD.bp.isHeight('0,300');
		 * DD.bp.isHeight(0, 300);
		 *
		 * @param  {String|Number} min Breakpoint name as a string, or as a number in pixels, or in comma separated string notation
		 * @param  {String|Number} [max=0] Breakpoint name as a string, or as a number in pixels
		 * @return {Boolean}
		 */
		isHeight = function(min, max) {
			return is(min, max, 'height');
		};

		/**
		 * Valid options for the Breakpoints array
		 *
		 * @typedef  {Object} DD.bp.BreakpointOptions
		 * @property {String} name Name of the breakpoint e.g. 's', 'm', 'l'
		 * @property {Number} px Number in px for the size of the breakpoint
		 */

		/**
		 * Valid options for the Breakpoints library
		 *
		 * @typedef  {Object} DD.bp.Options
		 * @property {Number} [baseFontSize] Number in px to be used as a base font size in order to calculate em values
		 * @property {DD.bp.BreakpointOptions[]} [breakpoints]
		 */

		/**
		 * User updatable options
		 *
		 * @memberof DD.bp
		 * @example
		 * // update the base font size only
		 * DD.bp.options({
		 *   baseFontSize: 14
		 * });
		 *
		 * @example
		 * // update the breakpoints
		 * DD.bp.options({
		 *   breakpoints: [
		 *     { name: 'small', px: 400 },
		 *     { name: 'medium', px: 800 },
		 *     { name: 'large', px: 1200 }
		 *   ]
		 * });
		 *
		 * @param  {DD.bp.Options} opts Options inside the library to be updated
		 * @return {Boolean}
		 */
		options = function(opts) {
			if (typeof (opts.isResponsive) === 'boolean') {
				_options.isResponsive = opts.isResponsive;
			}

			if (typeof (opts.baseFontSize) === 'number') {
				_options.baseFontSize = opts.baseFontSize;
			}

			if (typeof (opts.breakpoints) === 'object' && opts.breakpoints.length > 0) {
				var isValid = true,
					bps = opts.breakpoints;

				// loop through the breakpoints to check validity
				for (var i = 0, len = bps.length; i < len; i += 1) {
					if ((bps[i].hasOwnProperty('name') && bps[i].hasOwnProperty('px')) === false) {
						isValid = false;
					}
				}

				if (isValid) {
					_options.breakpoints = opts.breakpoints;
					_initBreakpoints();
				} else {
					void 0;
					return false;
				}
			}

			return true;
		};

		return {
			get: get,
			getHeight: getHeight,
			is: is,
			isHeight: isHeight,
			options: options
		};
	}());

}());

//! moment.js
//! version : 2.13.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
!function(a,b){"object"==typeof exports&&"undefined"!=typeof module?module.exports=b():"function"==typeof define&&define.amd?define(b):a.moment=b()}(this,function(){"use strict";function a(){return fd.apply(null,arguments)}function b(a){fd=a}function c(a){return a instanceof Array||"[object Array]"===Object.prototype.toString.call(a)}function d(a){return a instanceof Date||"[object Date]"===Object.prototype.toString.call(a)}function e(a,b){var c,d=[];for(c=0;c<a.length;++c)d.push(b(a[c],c));return d}function f(a,b){return Object.prototype.hasOwnProperty.call(a,b)}function g(a,b){for(var c in b)f(b,c)&&(a[c]=b[c]);return f(b,"toString")&&(a.toString=b.toString),f(b,"valueOf")&&(a.valueOf=b.valueOf),a}function h(a,b,c,d){return Ja(a,b,c,d,!0).utc()}function i(){return{empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1,parsedDateParts:[],meridiem:null}}function j(a){return null==a._pf&&(a._pf=i()),a._pf}function k(a){if(null==a._isValid){var b=j(a),c=gd.call(b.parsedDateParts,function(a){return null!=a});a._isValid=!isNaN(a._d.getTime())&&b.overflow<0&&!b.empty&&!b.invalidMonth&&!b.invalidWeekday&&!b.nullInput&&!b.invalidFormat&&!b.userInvalidated&&(!b.meridiem||b.meridiem&&c),a._strict&&(a._isValid=a._isValid&&0===b.charsLeftOver&&0===b.unusedTokens.length&&void 0===b.bigHour)}return a._isValid}function l(a){var b=h(NaN);return null!=a?g(j(b),a):j(b).userInvalidated=!0,b}function m(a){return void 0===a}function n(a,b){var c,d,e;if(m(b._isAMomentObject)||(a._isAMomentObject=b._isAMomentObject),m(b._i)||(a._i=b._i),m(b._f)||(a._f=b._f),m(b._l)||(a._l=b._l),m(b._strict)||(a._strict=b._strict),m(b._tzm)||(a._tzm=b._tzm),m(b._isUTC)||(a._isUTC=b._isUTC),m(b._offset)||(a._offset=b._offset),m(b._pf)||(a._pf=j(b)),m(b._locale)||(a._locale=b._locale),hd.length>0)for(c in hd)d=hd[c],e=b[d],m(e)||(a[d]=e);return a}function o(b){n(this,b),this._d=new Date(null!=b._d?b._d.getTime():NaN),id===!1&&(id=!0,a.updateOffset(this),id=!1)}function p(a){return a instanceof o||null!=a&&null!=a._isAMomentObject}function q(a){return 0>a?Math.ceil(a):Math.floor(a)}function r(a){var b=+a,c=0;return 0!==b&&isFinite(b)&&(c=q(b)),c}function s(a,b,c){var d,e=Math.min(a.length,b.length),f=Math.abs(a.length-b.length),g=0;for(d=0;e>d;d++)(c&&a[d]!==b[d]||!c&&r(a[d])!==r(b[d]))&&g++;return g+f}function t(b){a.suppressDeprecationWarnings===!1&&"undefined"!=typeof console&&console.warn&&void 0}function u(b,c){var d=!0;return g(function(){return null!=a.deprecationHandler&&a.deprecationHandler(null,b),d&&(t(b+"\nArguments: "+Array.prototype.slice.call(arguments).join(", ")+"\n"+(new Error).stack),d=!1),c.apply(this,arguments)},c)}function v(b,c){null!=a.deprecationHandler&&a.deprecationHandler(b,c),jd[b]||(t(c),jd[b]=!0)}function w(a){return a instanceof Function||"[object Function]"===Object.prototype.toString.call(a)}function x(a){return"[object Object]"===Object.prototype.toString.call(a)}function y(a){var b,c;for(c in a)b=a[c],w(b)?this[c]=b:this["_"+c]=b;this._config=a,this._ordinalParseLenient=new RegExp(this._ordinalParse.source+"|"+/\d{1,2}/.source)}function z(a,b){var c,d=g({},a);for(c in b)f(b,c)&&(x(a[c])&&x(b[c])?(d[c]={},g(d[c],a[c]),g(d[c],b[c])):null!=b[c]?d[c]=b[c]:delete d[c]);return d}function A(a){null!=a&&this.set(a)}function B(a){return a?a.toLowerCase().replace("_","-"):a}function C(a){for(var b,c,d,e,f=0;f<a.length;){for(e=B(a[f]).split("-"),b=e.length,c=B(a[f+1]),c=c?c.split("-"):null;b>0;){if(d=D(e.slice(0,b).join("-")))return d;if(c&&c.length>=b&&s(e,c,!0)>=b-1)break;b--}f++}return null}function D(a){var b=null;if(!nd[a]&&"undefined"!=typeof module&&module&&module.exports)try{b=ld._abbr,require("./locale/"+a),E(b)}catch(c){}return nd[a]}function E(a,b){var c;return a&&(c=m(b)?H(a):F(a,b),c&&(ld=c)),ld._abbr}function F(a,b){return null!==b?(b.abbr=a,null!=nd[a]?(v("defineLocaleOverride","use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale"),b=z(nd[a]._config,b)):null!=b.parentLocale&&(null!=nd[b.parentLocale]?b=z(nd[b.parentLocale]._config,b):v("parentLocaleUndefined","specified parentLocale is not defined yet")),nd[a]=new A(b),E(a),nd[a]):(delete nd[a],null)}function G(a,b){if(null!=b){var c;null!=nd[a]&&(b=z(nd[a]._config,b)),c=new A(b),c.parentLocale=nd[a],nd[a]=c,E(a)}else null!=nd[a]&&(null!=nd[a].parentLocale?nd[a]=nd[a].parentLocale:null!=nd[a]&&delete nd[a]);return nd[a]}function H(a){var b;if(a&&a._locale&&a._locale._abbr&&(a=a._locale._abbr),!a)return ld;if(!c(a)){if(b=D(a))return b;a=[a]}return C(a)}function I(){return kd(nd)}function J(a,b){var c=a.toLowerCase();od[c]=od[c+"s"]=od[b]=a}function K(a){return"string"==typeof a?od[a]||od[a.toLowerCase()]:void 0}function L(a){var b,c,d={};for(c in a)f(a,c)&&(b=K(c),b&&(d[b]=a[c]));return d}function M(b,c){return function(d){return null!=d?(O(this,b,d),a.updateOffset(this,c),this):N(this,b)}}function N(a,b){return a.isValid()?a._d["get"+(a._isUTC?"UTC":"")+b]():NaN}function O(a,b,c){a.isValid()&&a._d["set"+(a._isUTC?"UTC":"")+b](c)}function P(a,b){var c;if("object"==typeof a)for(c in a)this.set(c,a[c]);else if(a=K(a),w(this[a]))return this[a](b);return this}function Q(a,b,c){var d=""+Math.abs(a),e=b-d.length,f=a>=0;return(f?c?"+":"":"-")+Math.pow(10,Math.max(0,e)).toString().substr(1)+d}function R(a,b,c,d){var e=d;"string"==typeof d&&(e=function(){return this[d]()}),a&&(sd[a]=e),b&&(sd[b[0]]=function(){return Q(e.apply(this,arguments),b[1],b[2])}),c&&(sd[c]=function(){return this.localeData().ordinal(e.apply(this,arguments),a)})}function S(a){return a.match(/\[[\s\S]/)?a.replace(/^\[|\]$/g,""):a.replace(/\\/g,"")}function T(a){var b,c,d=a.match(pd);for(b=0,c=d.length;c>b;b++)sd[d[b]]?d[b]=sd[d[b]]:d[b]=S(d[b]);return function(b){var e,f="";for(e=0;c>e;e++)f+=d[e]instanceof Function?d[e].call(b,a):d[e];return f}}function U(a,b){return a.isValid()?(b=V(b,a.localeData()),rd[b]=rd[b]||T(b),rd[b](a)):a.localeData().invalidDate()}function V(a,b){function c(a){return b.longDateFormat(a)||a}var d=5;for(qd.lastIndex=0;d>=0&&qd.test(a);)a=a.replace(qd,c),qd.lastIndex=0,d-=1;return a}function W(a,b,c){Kd[a]=w(b)?b:function(a,d){return a&&c?c:b}}function X(a,b){return f(Kd,a)?Kd[a](b._strict,b._locale):new RegExp(Y(a))}function Y(a){return Z(a.replace("\\","").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,function(a,b,c,d,e){return b||c||d||e}))}function Z(a){return a.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&")}function $(a,b){var c,d=b;for("string"==typeof a&&(a=[a]),"number"==typeof b&&(d=function(a,c){c[b]=r(a)}),c=0;c<a.length;c++)Ld[a[c]]=d}function _(a,b){$(a,function(a,c,d,e){d._w=d._w||{},b(a,d._w,d,e)})}function aa(a,b,c){null!=b&&f(Ld,a)&&Ld[a](b,c._a,c,a)}function ba(a,b){return new Date(Date.UTC(a,b+1,0)).getUTCDate()}function ca(a,b){return c(this._months)?this._months[a.month()]:this._months[Vd.test(b)?"format":"standalone"][a.month()]}function da(a,b){return c(this._monthsShort)?this._monthsShort[a.month()]:this._monthsShort[Vd.test(b)?"format":"standalone"][a.month()]}function ea(a,b,c){var d,e,f,g=a.toLocaleLowerCase();if(!this._monthsParse)for(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[],d=0;12>d;++d)f=h([2e3,d]),this._shortMonthsParse[d]=this.monthsShort(f,"").toLocaleLowerCase(),this._longMonthsParse[d]=this.months(f,"").toLocaleLowerCase();return c?"MMM"===b?(e=md.call(this._shortMonthsParse,g),-1!==e?e:null):(e=md.call(this._longMonthsParse,g),-1!==e?e:null):"MMM"===b?(e=md.call(this._shortMonthsParse,g),-1!==e?e:(e=md.call(this._longMonthsParse,g),-1!==e?e:null)):(e=md.call(this._longMonthsParse,g),-1!==e?e:(e=md.call(this._shortMonthsParse,g),-1!==e?e:null))}function fa(a,b,c){var d,e,f;if(this._monthsParseExact)return ea.call(this,a,b,c);for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),d=0;12>d;d++){if(e=h([2e3,d]),c&&!this._longMonthsParse[d]&&(this._longMonthsParse[d]=new RegExp("^"+this.months(e,"").replace(".","")+"$","i"),this._shortMonthsParse[d]=new RegExp("^"+this.monthsShort(e,"").replace(".","")+"$","i")),c||this._monthsParse[d]||(f="^"+this.months(e,"")+"|^"+this.monthsShort(e,""),this._monthsParse[d]=new RegExp(f.replace(".",""),"i")),c&&"MMMM"===b&&this._longMonthsParse[d].test(a))return d;if(c&&"MMM"===b&&this._shortMonthsParse[d].test(a))return d;if(!c&&this._monthsParse[d].test(a))return d}}function ga(a,b){var c;if(!a.isValid())return a;if("string"==typeof b)if(/^\d+$/.test(b))b=r(b);else if(b=a.localeData().monthsParse(b),"number"!=typeof b)return a;return c=Math.min(a.date(),ba(a.year(),b)),a._d["set"+(a._isUTC?"UTC":"")+"Month"](b,c),a}function ha(b){return null!=b?(ga(this,b),a.updateOffset(this,!0),this):N(this,"Month")}function ia(){return ba(this.year(),this.month())}function ja(a){return this._monthsParseExact?(f(this,"_monthsRegex")||la.call(this),a?this._monthsShortStrictRegex:this._monthsShortRegex):this._monthsShortStrictRegex&&a?this._monthsShortStrictRegex:this._monthsShortRegex}function ka(a){return this._monthsParseExact?(f(this,"_monthsRegex")||la.call(this),a?this._monthsStrictRegex:this._monthsRegex):this._monthsStrictRegex&&a?this._monthsStrictRegex:this._monthsRegex}function la(){function a(a,b){return b.length-a.length}var b,c,d=[],e=[],f=[];for(b=0;12>b;b++)c=h([2e3,b]),d.push(this.monthsShort(c,"")),e.push(this.months(c,"")),f.push(this.months(c,"")),f.push(this.monthsShort(c,""));for(d.sort(a),e.sort(a),f.sort(a),b=0;12>b;b++)d[b]=Z(d[b]),e[b]=Z(e[b]),f[b]=Z(f[b]);this._monthsRegex=new RegExp("^("+f.join("|")+")","i"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp("^("+e.join("|")+")","i"),this._monthsShortStrictRegex=new RegExp("^("+d.join("|")+")","i")}function ma(a){var b,c=a._a;return c&&-2===j(a).overflow&&(b=c[Nd]<0||c[Nd]>11?Nd:c[Od]<1||c[Od]>ba(c[Md],c[Nd])?Od:c[Pd]<0||c[Pd]>24||24===c[Pd]&&(0!==c[Qd]||0!==c[Rd]||0!==c[Sd])?Pd:c[Qd]<0||c[Qd]>59?Qd:c[Rd]<0||c[Rd]>59?Rd:c[Sd]<0||c[Sd]>999?Sd:-1,j(a)._overflowDayOfYear&&(Md>b||b>Od)&&(b=Od),j(a)._overflowWeeks&&-1===b&&(b=Td),j(a)._overflowWeekday&&-1===b&&(b=Ud),j(a).overflow=b),a}function na(a){var b,c,d,e,f,g,h=a._i,i=$d.exec(h)||_d.exec(h);if(i){for(j(a).iso=!0,b=0,c=be.length;c>b;b++)if(be[b][1].exec(i[1])){e=be[b][0],d=be[b][2]!==!1;break}if(null==e)return void(a._isValid=!1);if(i[3]){for(b=0,c=ce.length;c>b;b++)if(ce[b][1].exec(i[3])){f=(i[2]||" ")+ce[b][0];break}if(null==f)return void(a._isValid=!1)}if(!d&&null!=f)return void(a._isValid=!1);if(i[4]){if(!ae.exec(i[4]))return void(a._isValid=!1);g="Z"}a._f=e+(f||"")+(g||""),Ca(a)}else a._isValid=!1}function oa(b){var c=de.exec(b._i);return null!==c?void(b._d=new Date(+c[1])):(na(b),void(b._isValid===!1&&(delete b._isValid,a.createFromInputFallback(b))))}function pa(a,b,c,d,e,f,g){var h=new Date(a,b,c,d,e,f,g);return 100>a&&a>=0&&isFinite(h.getFullYear())&&h.setFullYear(a),h}function qa(a){var b=new Date(Date.UTC.apply(null,arguments));return 100>a&&a>=0&&isFinite(b.getUTCFullYear())&&b.setUTCFullYear(a),b}function ra(a){return sa(a)?366:365}function sa(a){return a%4===0&&a%100!==0||a%400===0}function ta(){return sa(this.year())}function ua(a,b,c){var d=7+b-c,e=(7+qa(a,0,d).getUTCDay()-b)%7;return-e+d-1}function va(a,b,c,d,e){var f,g,h=(7+c-d)%7,i=ua(a,d,e),j=1+7*(b-1)+h+i;return 0>=j?(f=a-1,g=ra(f)+j):j>ra(a)?(f=a+1,g=j-ra(a)):(f=a,g=j),{year:f,dayOfYear:g}}function wa(a,b,c){var d,e,f=ua(a.year(),b,c),g=Math.floor((a.dayOfYear()-f-1)/7)+1;return 1>g?(e=a.year()-1,d=g+xa(e,b,c)):g>xa(a.year(),b,c)?(d=g-xa(a.year(),b,c),e=a.year()+1):(e=a.year(),d=g),{week:d,year:e}}function xa(a,b,c){var d=ua(a,b,c),e=ua(a+1,b,c);return(ra(a)-d+e)/7}function ya(a,b,c){return null!=a?a:null!=b?b:c}function za(b){var c=new Date(a.now());return b._useUTC?[c.getUTCFullYear(),c.getUTCMonth(),c.getUTCDate()]:[c.getFullYear(),c.getMonth(),c.getDate()]}function Aa(a){var b,c,d,e,f=[];if(!a._d){for(d=za(a),a._w&&null==a._a[Od]&&null==a._a[Nd]&&Ba(a),a._dayOfYear&&(e=ya(a._a[Md],d[Md]),a._dayOfYear>ra(e)&&(j(a)._overflowDayOfYear=!0),c=qa(e,0,a._dayOfYear),a._a[Nd]=c.getUTCMonth(),a._a[Od]=c.getUTCDate()),b=0;3>b&&null==a._a[b];++b)a._a[b]=f[b]=d[b];for(;7>b;b++)a._a[b]=f[b]=null==a._a[b]?2===b?1:0:a._a[b];24===a._a[Pd]&&0===a._a[Qd]&&0===a._a[Rd]&&0===a._a[Sd]&&(a._nextDay=!0,a._a[Pd]=0),a._d=(a._useUTC?qa:pa).apply(null,f),null!=a._tzm&&a._d.setUTCMinutes(a._d.getUTCMinutes()-a._tzm),a._nextDay&&(a._a[Pd]=24)}}function Ba(a){var b,c,d,e,f,g,h,i;b=a._w,null!=b.GG||null!=b.W||null!=b.E?(f=1,g=4,c=ya(b.GG,a._a[Md],wa(Ka(),1,4).year),d=ya(b.W,1),e=ya(b.E,1),(1>e||e>7)&&(i=!0)):(f=a._locale._week.dow,g=a._locale._week.doy,c=ya(b.gg,a._a[Md],wa(Ka(),f,g).year),d=ya(b.w,1),null!=b.d?(e=b.d,(0>e||e>6)&&(i=!0)):null!=b.e?(e=b.e+f,(b.e<0||b.e>6)&&(i=!0)):e=f),1>d||d>xa(c,f,g)?j(a)._overflowWeeks=!0:null!=i?j(a)._overflowWeekday=!0:(h=va(c,d,e,f,g),a._a[Md]=h.year,a._dayOfYear=h.dayOfYear)}function Ca(b){if(b._f===a.ISO_8601)return void na(b);b._a=[],j(b).empty=!0;var c,d,e,f,g,h=""+b._i,i=h.length,k=0;for(e=V(b._f,b._locale).match(pd)||[],c=0;c<e.length;c++)f=e[c],d=(h.match(X(f,b))||[])[0],d&&(g=h.substr(0,h.indexOf(d)),g.length>0&&j(b).unusedInput.push(g),h=h.slice(h.indexOf(d)+d.length),k+=d.length),sd[f]?(d?j(b).empty=!1:j(b).unusedTokens.push(f),aa(f,d,b)):b._strict&&!d&&j(b).unusedTokens.push(f);j(b).charsLeftOver=i-k,h.length>0&&j(b).unusedInput.push(h),j(b).bigHour===!0&&b._a[Pd]<=12&&b._a[Pd]>0&&(j(b).bigHour=void 0),j(b).parsedDateParts=b._a.slice(0),j(b).meridiem=b._meridiem,b._a[Pd]=Da(b._locale,b._a[Pd],b._meridiem),Aa(b),ma(b)}function Da(a,b,c){var d;return null==c?b:null!=a.meridiemHour?a.meridiemHour(b,c):null!=a.isPM?(d=a.isPM(c),d&&12>b&&(b+=12),d||12!==b||(b=0),b):b}function Ea(a){var b,c,d,e,f;if(0===a._f.length)return j(a).invalidFormat=!0,void(a._d=new Date(NaN));for(e=0;e<a._f.length;e++)f=0,b=n({},a),null!=a._useUTC&&(b._useUTC=a._useUTC),b._f=a._f[e],Ca(b),k(b)&&(f+=j(b).charsLeftOver,f+=10*j(b).unusedTokens.length,j(b).score=f,(null==d||d>f)&&(d=f,c=b));g(a,c||b)}function Fa(a){if(!a._d){var b=L(a._i);a._a=e([b.year,b.month,b.day||b.date,b.hour,b.minute,b.second,b.millisecond],function(a){return a&&parseInt(a,10)}),Aa(a)}}function Ga(a){var b=new o(ma(Ha(a)));return b._nextDay&&(b.add(1,"d"),b._nextDay=void 0),b}function Ha(a){var b=a._i,e=a._f;return a._locale=a._locale||H(a._l),null===b||void 0===e&&""===b?l({nullInput:!0}):("string"==typeof b&&(a._i=b=a._locale.preparse(b)),p(b)?new o(ma(b)):(c(e)?Ea(a):e?Ca(a):d(b)?a._d=b:Ia(a),k(a)||(a._d=null),a))}function Ia(b){var f=b._i;void 0===f?b._d=new Date(a.now()):d(f)?b._d=new Date(f.valueOf()):"string"==typeof f?oa(b):c(f)?(b._a=e(f.slice(0),function(a){return parseInt(a,10)}),Aa(b)):"object"==typeof f?Fa(b):"number"==typeof f?b._d=new Date(f):a.createFromInputFallback(b)}function Ja(a,b,c,d,e){var f={};return"boolean"==typeof c&&(d=c,c=void 0),f._isAMomentObject=!0,f._useUTC=f._isUTC=e,f._l=c,f._i=a,f._f=b,f._strict=d,Ga(f)}function Ka(a,b,c,d){return Ja(a,b,c,d,!1)}function La(a,b){var d,e;if(1===b.length&&c(b[0])&&(b=b[0]),!b.length)return Ka();for(d=b[0],e=1;e<b.length;++e)(!b[e].isValid()||b[e][a](d))&&(d=b[e]);return d}function Ma(){var a=[].slice.call(arguments,0);return La("isBefore",a)}function Na(){var a=[].slice.call(arguments,0);return La("isAfter",a)}function Oa(a){var b=L(a),c=b.year||0,d=b.quarter||0,e=b.month||0,f=b.week||0,g=b.day||0,h=b.hour||0,i=b.minute||0,j=b.second||0,k=b.millisecond||0;this._milliseconds=+k+1e3*j+6e4*i+1e3*h*60*60,this._days=+g+7*f,this._months=+e+3*d+12*c,this._data={},this._locale=H(),this._bubble()}function Pa(a){return a instanceof Oa}function Qa(a,b){R(a,0,0,function(){var a=this.utcOffset(),c="+";return 0>a&&(a=-a,c="-"),c+Q(~~(a/60),2)+b+Q(~~a%60,2)})}function Ra(a,b){var c=(b||"").match(a)||[],d=c[c.length-1]||[],e=(d+"").match(ie)||["-",0,0],f=+(60*e[1])+r(e[2]);return"+"===e[0]?f:-f}function Sa(b,c){var e,f;return c._isUTC?(e=c.clone(),f=(p(b)||d(b)?b.valueOf():Ka(b).valueOf())-e.valueOf(),e._d.setTime(e._d.valueOf()+f),a.updateOffset(e,!1),e):Ka(b).local()}function Ta(a){return 15*-Math.round(a._d.getTimezoneOffset()/15)}function Ua(b,c){var d,e=this._offset||0;return this.isValid()?null!=b?("string"==typeof b?b=Ra(Hd,b):Math.abs(b)<16&&(b=60*b),!this._isUTC&&c&&(d=Ta(this)),this._offset=b,this._isUTC=!0,null!=d&&this.add(d,"m"),e!==b&&(!c||this._changeInProgress?jb(this,db(b-e,"m"),1,!1):this._changeInProgress||(this._changeInProgress=!0,a.updateOffset(this,!0),this._changeInProgress=null)),this):this._isUTC?e:Ta(this):null!=b?this:NaN}function Va(a,b){return null!=a?("string"!=typeof a&&(a=-a),this.utcOffset(a,b),this):-this.utcOffset()}function Wa(a){return this.utcOffset(0,a)}function Xa(a){return this._isUTC&&(this.utcOffset(0,a),this._isUTC=!1,a&&this.subtract(Ta(this),"m")),this}function Ya(){return this._tzm?this.utcOffset(this._tzm):"string"==typeof this._i&&this.utcOffset(Ra(Gd,this._i)),this}function Za(a){return this.isValid()?(a=a?Ka(a).utcOffset():0,(this.utcOffset()-a)%60===0):!1}function $a(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()}function _a(){if(!m(this._isDSTShifted))return this._isDSTShifted;var a={};if(n(a,this),a=Ha(a),a._a){var b=a._isUTC?h(a._a):Ka(a._a);this._isDSTShifted=this.isValid()&&s(a._a,b.toArray())>0}else this._isDSTShifted=!1;return this._isDSTShifted}function ab(){return this.isValid()?!this._isUTC:!1}function bb(){return this.isValid()?this._isUTC:!1}function cb(){return this.isValid()?this._isUTC&&0===this._offset:!1}function db(a,b){var c,d,e,g=a,h=null;return Pa(a)?g={ms:a._milliseconds,d:a._days,M:a._months}:"number"==typeof a?(g={},b?g[b]=a:g.milliseconds=a):(h=je.exec(a))?(c="-"===h[1]?-1:1,g={y:0,d:r(h[Od])*c,h:r(h[Pd])*c,m:r(h[Qd])*c,s:r(h[Rd])*c,ms:r(h[Sd])*c}):(h=ke.exec(a))?(c="-"===h[1]?-1:1,g={y:eb(h[2],c),M:eb(h[3],c),w:eb(h[4],c),d:eb(h[5],c),h:eb(h[6],c),m:eb(h[7],c),s:eb(h[8],c)}):null==g?g={}:"object"==typeof g&&("from"in g||"to"in g)&&(e=gb(Ka(g.from),Ka(g.to)),g={},g.ms=e.milliseconds,g.M=e.months),d=new Oa(g),Pa(a)&&f(a,"_locale")&&(d._locale=a._locale),d}function eb(a,b){var c=a&&parseFloat(a.replace(",","."));return(isNaN(c)?0:c)*b}function fb(a,b){var c={milliseconds:0,months:0};return c.months=b.month()-a.month()+12*(b.year()-a.year()),a.clone().add(c.months,"M").isAfter(b)&&--c.months,c.milliseconds=+b-+a.clone().add(c.months,"M"),c}function gb(a,b){var c;return a.isValid()&&b.isValid()?(b=Sa(b,a),a.isBefore(b)?c=fb(a,b):(c=fb(b,a),c.milliseconds=-c.milliseconds,c.months=-c.months),c):{milliseconds:0,months:0}}function hb(a){return 0>a?-1*Math.round(-1*a):Math.round(a)}function ib(a,b){return function(c,d){var e,f;return null===d||isNaN(+d)||(v(b,"moment()."+b+"(period, number) is deprecated. Please use moment()."+b+"(number, period)."),f=c,c=d,d=f),c="string"==typeof c?+c:c,e=db(c,d),jb(this,e,a),this}}function jb(b,c,d,e){var f=c._milliseconds,g=hb(c._days),h=hb(c._months);b.isValid()&&(e=null==e?!0:e,f&&b._d.setTime(b._d.valueOf()+f*d),g&&O(b,"Date",N(b,"Date")+g*d),h&&ga(b,N(b,"Month")+h*d),e&&a.updateOffset(b,g||h))}function kb(a,b){var c=a||Ka(),d=Sa(c,this).startOf("day"),e=this.diff(d,"days",!0),f=-6>e?"sameElse":-1>e?"lastWeek":0>e?"lastDay":1>e?"sameDay":2>e?"nextDay":7>e?"nextWeek":"sameElse",g=b&&(w(b[f])?b[f]():b[f]);return this.format(g||this.localeData().calendar(f,this,Ka(c)))}function lb(){return new o(this)}function mb(a,b){var c=p(a)?a:Ka(a);return this.isValid()&&c.isValid()?(b=K(m(b)?"millisecond":b),"millisecond"===b?this.valueOf()>c.valueOf():c.valueOf()<this.clone().startOf(b).valueOf()):!1}function nb(a,b){var c=p(a)?a:Ka(a);return this.isValid()&&c.isValid()?(b=K(m(b)?"millisecond":b),"millisecond"===b?this.valueOf()<c.valueOf():this.clone().endOf(b).valueOf()<c.valueOf()):!1}function ob(a,b,c,d){return d=d||"()",("("===d[0]?this.isAfter(a,c):!this.isBefore(a,c))&&(")"===d[1]?this.isBefore(b,c):!this.isAfter(b,c))}function pb(a,b){var c,d=p(a)?a:Ka(a);return this.isValid()&&d.isValid()?(b=K(b||"millisecond"),"millisecond"===b?this.valueOf()===d.valueOf():(c=d.valueOf(),this.clone().startOf(b).valueOf()<=c&&c<=this.clone().endOf(b).valueOf())):!1}function qb(a,b){return this.isSame(a,b)||this.isAfter(a,b)}function rb(a,b){return this.isSame(a,b)||this.isBefore(a,b)}function sb(a,b,c){var d,e,f,g;return this.isValid()?(d=Sa(a,this),d.isValid()?(e=6e4*(d.utcOffset()-this.utcOffset()),b=K(b),"year"===b||"month"===b||"quarter"===b?(g=tb(this,d),"quarter"===b?g/=3:"year"===b&&(g/=12)):(f=this-d,g="second"===b?f/1e3:"minute"===b?f/6e4:"hour"===b?f/36e5:"day"===b?(f-e)/864e5:"week"===b?(f-e)/6048e5:f),c?g:q(g)):NaN):NaN}function tb(a,b){var c,d,e=12*(b.year()-a.year())+(b.month()-a.month()),f=a.clone().add(e,"months");return 0>b-f?(c=a.clone().add(e-1,"months"),d=(b-f)/(f-c)):(c=a.clone().add(e+1,"months"),d=(b-f)/(c-f)),-(e+d)||0}function ub(){return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")}function vb(){var a=this.clone().utc();return 0<a.year()&&a.year()<=9999?w(Date.prototype.toISOString)?this.toDate().toISOString():U(a,"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"):U(a,"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]")}function wb(b){b||(b=this.isUtc()?a.defaultFormatUtc:a.defaultFormat);var c=U(this,b);return this.localeData().postformat(c)}function xb(a,b){return this.isValid()&&(p(a)&&a.isValid()||Ka(a).isValid())?db({to:this,from:a}).locale(this.locale()).humanize(!b):this.localeData().invalidDate()}function yb(a){return this.from(Ka(),a)}function zb(a,b){return this.isValid()&&(p(a)&&a.isValid()||Ka(a).isValid())?db({from:this,to:a}).locale(this.locale()).humanize(!b):this.localeData().invalidDate()}function Ab(a){return this.to(Ka(),a)}function Bb(a){var b;return void 0===a?this._locale._abbr:(b=H(a),null!=b&&(this._locale=b),this)}function Cb(){return this._locale}function Db(a){switch(a=K(a)){case"year":this.month(0);case"quarter":case"month":this.date(1);case"week":case"isoWeek":case"day":case"date":this.hours(0);case"hour":this.minutes(0);case"minute":this.seconds(0);case"second":this.milliseconds(0)}return"week"===a&&this.weekday(0),"isoWeek"===a&&this.isoWeekday(1),"quarter"===a&&this.month(3*Math.floor(this.month()/3)),this}function Eb(a){return a=K(a),void 0===a||"millisecond"===a?this:("date"===a&&(a="day"),this.startOf(a).add(1,"isoWeek"===a?"week":a).subtract(1,"ms"))}function Fb(){return this._d.valueOf()-6e4*(this._offset||0)}function Gb(){return Math.floor(this.valueOf()/1e3)}function Hb(){return this._offset?new Date(this.valueOf()):this._d}function Ib(){var a=this;return[a.year(),a.month(),a.date(),a.hour(),a.minute(),a.second(),a.millisecond()]}function Jb(){var a=this;return{years:a.year(),months:a.month(),date:a.date(),hours:a.hours(),minutes:a.minutes(),seconds:a.seconds(),milliseconds:a.milliseconds()}}function Kb(){return this.isValid()?this.toISOString():null}function Lb(){return k(this)}function Mb(){return g({},j(this))}function Nb(){return j(this).overflow}function Ob(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}}function Pb(a,b){R(0,[a,a.length],0,b)}function Qb(a){return Ub.call(this,a,this.week(),this.weekday(),this.localeData()._week.dow,this.localeData()._week.doy)}function Rb(a){return Ub.call(this,a,this.isoWeek(),this.isoWeekday(),1,4)}function Sb(){return xa(this.year(),1,4)}function Tb(){var a=this.localeData()._week;return xa(this.year(),a.dow,a.doy)}function Ub(a,b,c,d,e){var f;return null==a?wa(this,d,e).year:(f=xa(a,d,e),b>f&&(b=f),Vb.call(this,a,b,c,d,e))}function Vb(a,b,c,d,e){var f=va(a,b,c,d,e),g=qa(f.year,0,f.dayOfYear);return this.year(g.getUTCFullYear()),this.month(g.getUTCMonth()),this.date(g.getUTCDate()),this}function Wb(a){return null==a?Math.ceil((this.month()+1)/3):this.month(3*(a-1)+this.month()%3)}function Xb(a){return wa(a,this._week.dow,this._week.doy).week}function Yb(){return this._week.dow}function Zb(){return this._week.doy}function $b(a){var b=this.localeData().week(this);return null==a?b:this.add(7*(a-b),"d")}function _b(a){var b=wa(this,1,4).week;return null==a?b:this.add(7*(a-b),"d")}function ac(a,b){return"string"!=typeof a?a:isNaN(a)?(a=b.weekdaysParse(a),"number"==typeof a?a:null):parseInt(a,10)}function bc(a,b){return c(this._weekdays)?this._weekdays[a.day()]:this._weekdays[this._weekdays.isFormat.test(b)?"format":"standalone"][a.day()]}function cc(a){return this._weekdaysShort[a.day()]}function dc(a){return this._weekdaysMin[a.day()]}function ec(a,b,c){var d,e,f,g=a.toLocaleLowerCase();if(!this._weekdaysParse)for(this._weekdaysParse=[],this._shortWeekdaysParse=[],this._minWeekdaysParse=[],d=0;7>d;++d)f=h([2e3,1]).day(d),this._minWeekdaysParse[d]=this.weekdaysMin(f,"").toLocaleLowerCase(),this._shortWeekdaysParse[d]=this.weekdaysShort(f,"").toLocaleLowerCase(),this._weekdaysParse[d]=this.weekdays(f,"").toLocaleLowerCase();return c?"dddd"===b?(e=md.call(this._weekdaysParse,g),-1!==e?e:null):"ddd"===b?(e=md.call(this._shortWeekdaysParse,g),-1!==e?e:null):(e=md.call(this._minWeekdaysParse,g),-1!==e?e:null):"dddd"===b?(e=md.call(this._weekdaysParse,g),-1!==e?e:(e=md.call(this._shortWeekdaysParse,g),-1!==e?e:(e=md.call(this._minWeekdaysParse,g),-1!==e?e:null))):"ddd"===b?(e=md.call(this._shortWeekdaysParse,g),-1!==e?e:(e=md.call(this._weekdaysParse,g),-1!==e?e:(e=md.call(this._minWeekdaysParse,g),-1!==e?e:null))):(e=md.call(this._minWeekdaysParse,g),-1!==e?e:(e=md.call(this._weekdaysParse,g),-1!==e?e:(e=md.call(this._shortWeekdaysParse,g),-1!==e?e:null)))}function fc(a,b,c){var d,e,f;if(this._weekdaysParseExact)return ec.call(this,a,b,c);for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),d=0;7>d;d++){if(e=h([2e3,1]).day(d),c&&!this._fullWeekdaysParse[d]&&(this._fullWeekdaysParse[d]=new RegExp("^"+this.weekdays(e,"").replace(".",".?")+"$","i"),this._shortWeekdaysParse[d]=new RegExp("^"+this.weekdaysShort(e,"").replace(".",".?")+"$","i"),this._minWeekdaysParse[d]=new RegExp("^"+this.weekdaysMin(e,"").replace(".",".?")+"$","i")),this._weekdaysParse[d]||(f="^"+this.weekdays(e,"")+"|^"+this.weekdaysShort(e,"")+"|^"+this.weekdaysMin(e,""),this._weekdaysParse[d]=new RegExp(f.replace(".",""),"i")),c&&"dddd"===b&&this._fullWeekdaysParse[d].test(a))return d;if(c&&"ddd"===b&&this._shortWeekdaysParse[d].test(a))return d;if(c&&"dd"===b&&this._minWeekdaysParse[d].test(a))return d;if(!c&&this._weekdaysParse[d].test(a))return d}}function gc(a){if(!this.isValid())return null!=a?this:NaN;var b=this._isUTC?this._d.getUTCDay():this._d.getDay();return null!=a?(a=ac(a,this.localeData()),this.add(a-b,"d")):b}function hc(a){if(!this.isValid())return null!=a?this:NaN;var b=(this.day()+7-this.localeData()._week.dow)%7;return null==a?b:this.add(a-b,"d")}function ic(a){return this.isValid()?null==a?this.day()||7:this.day(this.day()%7?a:a-7):null!=a?this:NaN}function jc(a){return this._weekdaysParseExact?(f(this,"_weekdaysRegex")||mc.call(this),a?this._weekdaysStrictRegex:this._weekdaysRegex):this._weekdaysStrictRegex&&a?this._weekdaysStrictRegex:this._weekdaysRegex}function kc(a){return this._weekdaysParseExact?(f(this,"_weekdaysRegex")||mc.call(this),a?this._weekdaysShortStrictRegex:this._weekdaysShortRegex):this._weekdaysShortStrictRegex&&a?this._weekdaysShortStrictRegex:this._weekdaysShortRegex}function lc(a){return this._weekdaysParseExact?(f(this,"_weekdaysRegex")||mc.call(this),a?this._weekdaysMinStrictRegex:this._weekdaysMinRegex):this._weekdaysMinStrictRegex&&a?this._weekdaysMinStrictRegex:this._weekdaysMinRegex}function mc(){function a(a,b){return b.length-a.length}var b,c,d,e,f,g=[],i=[],j=[],k=[];for(b=0;7>b;b++)c=h([2e3,1]).day(b),d=this.weekdaysMin(c,""),e=this.weekdaysShort(c,""),f=this.weekdays(c,""),g.push(d),i.push(e),j.push(f),k.push(d),k.push(e),k.push(f);for(g.sort(a),i.sort(a),j.sort(a),k.sort(a),b=0;7>b;b++)i[b]=Z(i[b]),j[b]=Z(j[b]),k[b]=Z(k[b]);this._weekdaysRegex=new RegExp("^("+k.join("|")+")","i"),this._weekdaysShortRegex=this._weekdaysRegex,this._weekdaysMinRegex=this._weekdaysRegex,this._weekdaysStrictRegex=new RegExp("^("+j.join("|")+")","i"),this._weekdaysShortStrictRegex=new RegExp("^("+i.join("|")+")","i"),this._weekdaysMinStrictRegex=new RegExp("^("+g.join("|")+")","i")}function nc(a){var b=Math.round((this.clone().startOf("day")-this.clone().startOf("year"))/864e5)+1;return null==a?b:this.add(a-b,"d")}function oc(){return this.hours()%12||12}function pc(){return this.hours()||24}function qc(a,b){R(a,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),b)})}function rc(a,b){return b._meridiemParse}function sc(a){return"p"===(a+"").toLowerCase().charAt(0)}function tc(a,b,c){return a>11?c?"pm":"PM":c?"am":"AM"}function uc(a,b){b[Sd]=r(1e3*("0."+a))}function vc(){return this._isUTC?"UTC":""}function wc(){return this._isUTC?"Coordinated Universal Time":""}function xc(a){return Ka(1e3*a)}function yc(){return Ka.apply(null,arguments).parseZone()}function zc(a,b,c){var d=this._calendar[a];return w(d)?d.call(b,c):d}function Ac(a){var b=this._longDateFormat[a],c=this._longDateFormat[a.toUpperCase()];return b||!c?b:(this._longDateFormat[a]=c.replace(/MMMM|MM|DD|dddd/g,function(a){return a.slice(1)}),this._longDateFormat[a])}function Bc(){return this._invalidDate}function Cc(a){return this._ordinal.replace("%d",a)}function Dc(a){return a}function Ec(a,b,c,d){var e=this._relativeTime[c];return w(e)?e(a,b,c,d):e.replace(/%d/i,a)}function Fc(a,b){var c=this._relativeTime[a>0?"future":"past"];return w(c)?c(b):c.replace(/%s/i,b)}function Gc(a,b,c,d){var e=H(),f=h().set(d,b);return e[c](f,a)}function Hc(a,b,c){if("number"==typeof a&&(b=a,a=void 0),a=a||"",null!=b)return Gc(a,b,c,"month");var d,e=[];for(d=0;12>d;d++)e[d]=Gc(a,d,c,"month");return e}function Ic(a,b,c,d){"boolean"==typeof a?("number"==typeof b&&(c=b,b=void 0),b=b||""):(b=a,c=b,a=!1,"number"==typeof b&&(c=b,b=void 0),b=b||"");var e=H(),f=a?e._week.dow:0;if(null!=c)return Gc(b,(c+f)%7,d,"day");var g,h=[];for(g=0;7>g;g++)h[g]=Gc(b,(g+f)%7,d,"day");return h}function Jc(a,b){return Hc(a,b,"months")}function Kc(a,b){return Hc(a,b,"monthsShort")}function Lc(a,b,c){return Ic(a,b,c,"weekdays")}function Mc(a,b,c){return Ic(a,b,c,"weekdaysShort")}function Nc(a,b,c){return Ic(a,b,c,"weekdaysMin")}function Oc(){var a=this._data;return this._milliseconds=Le(this._milliseconds),this._days=Le(this._days),this._months=Le(this._months),a.milliseconds=Le(a.milliseconds),a.seconds=Le(a.seconds),a.minutes=Le(a.minutes),a.hours=Le(a.hours),a.months=Le(a.months),a.years=Le(a.years),this}function Pc(a,b,c,d){var e=db(b,c);return a._milliseconds+=d*e._milliseconds,a._days+=d*e._days,a._months+=d*e._months,a._bubble()}function Qc(a,b){return Pc(this,a,b,1)}function Rc(a,b){return Pc(this,a,b,-1)}function Sc(a){return 0>a?Math.floor(a):Math.ceil(a)}function Tc(){var a,b,c,d,e,f=this._milliseconds,g=this._days,h=this._months,i=this._data;return f>=0&&g>=0&&h>=0||0>=f&&0>=g&&0>=h||(f+=864e5*Sc(Vc(h)+g),g=0,h=0),i.milliseconds=f%1e3,a=q(f/1e3),i.seconds=a%60,b=q(a/60),i.minutes=b%60,c=q(b/60),i.hours=c%24,g+=q(c/24),e=q(Uc(g)),h+=e,g-=Sc(Vc(e)),d=q(h/12),h%=12,i.days=g,i.months=h,i.years=d,this}function Uc(a){return 4800*a/146097}function Vc(a){return 146097*a/4800}function Wc(a){var b,c,d=this._milliseconds;if(a=K(a),"month"===a||"year"===a)return b=this._days+d/864e5,c=this._months+Uc(b),"month"===a?c:c/12;switch(b=this._days+Math.round(Vc(this._months)),a){case"week":return b/7+d/6048e5;case"day":return b+d/864e5;case"hour":return 24*b+d/36e5;case"minute":return 1440*b+d/6e4;case"second":return 86400*b+d/1e3;case"millisecond":return Math.floor(864e5*b)+d;default:throw new Error("Unknown unit "+a)}}function Xc(){return this._milliseconds+864e5*this._days+this._months%12*2592e6+31536e6*r(this._months/12)}function Yc(a){return function(){return this.as(a)}}function Zc(a){
return a=K(a),this[a+"s"]()}function $c(a){return function(){return this._data[a]}}function _c(){return q(this.days()/7)}function ad(a,b,c,d,e){return e.relativeTime(b||1,!!c,a,d)}function bd(a,b,c){var d=db(a).abs(),e=_e(d.as("s")),f=_e(d.as("m")),g=_e(d.as("h")),h=_e(d.as("d")),i=_e(d.as("M")),j=_e(d.as("y")),k=e<af.s&&["s",e]||1>=f&&["m"]||f<af.m&&["mm",f]||1>=g&&["h"]||g<af.h&&["hh",g]||1>=h&&["d"]||h<af.d&&["dd",h]||1>=i&&["M"]||i<af.M&&["MM",i]||1>=j&&["y"]||["yy",j];return k[2]=b,k[3]=+a>0,k[4]=c,ad.apply(null,k)}function cd(a,b){return void 0===af[a]?!1:void 0===b?af[a]:(af[a]=b,!0)}function dd(a){var b=this.localeData(),c=bd(this,!a,b);return a&&(c=b.pastFuture(+this,c)),b.postformat(c)}function ed(){var a,b,c,d=bf(this._milliseconds)/1e3,e=bf(this._days),f=bf(this._months);a=q(d/60),b=q(a/60),d%=60,a%=60,c=q(f/12),f%=12;var g=c,h=f,i=e,j=b,k=a,l=d,m=this.asSeconds();return m?(0>m?"-":"")+"P"+(g?g+"Y":"")+(h?h+"M":"")+(i?i+"D":"")+(j||k||l?"T":"")+(j?j+"H":"")+(k?k+"M":"")+(l?l+"S":""):"P0D"}var fd,gd;gd=Array.prototype.some?Array.prototype.some:function(a){for(var b=Object(this),c=b.length>>>0,d=0;c>d;d++)if(d in b&&a.call(this,b[d],d,b))return!0;return!1};var hd=a.momentProperties=[],id=!1,jd={};a.suppressDeprecationWarnings=!1,a.deprecationHandler=null;var kd;kd=Object.keys?Object.keys:function(a){var b,c=[];for(b in a)f(a,b)&&c.push(b);return c};var ld,md,nd={},od={},pd=/(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,qd=/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,rd={},sd={},td=/\d/,ud=/\d\d/,vd=/\d{3}/,wd=/\d{4}/,xd=/[+-]?\d{6}/,yd=/\d\d?/,zd=/\d\d\d\d?/,Ad=/\d\d\d\d\d\d?/,Bd=/\d{1,3}/,Cd=/\d{1,4}/,Dd=/[+-]?\d{1,6}/,Ed=/\d+/,Fd=/[+-]?\d+/,Gd=/Z|[+-]\d\d:?\d\d/gi,Hd=/Z|[+-]\d\d(?::?\d\d)?/gi,Id=/[+-]?\d+(\.\d{1,3})?/,Jd=/[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i,Kd={},Ld={},Md=0,Nd=1,Od=2,Pd=3,Qd=4,Rd=5,Sd=6,Td=7,Ud=8;md=Array.prototype.indexOf?Array.prototype.indexOf:function(a){var b;for(b=0;b<this.length;++b)if(this[b]===a)return b;return-1},R("M",["MM",2],"Mo",function(){return this.month()+1}),R("MMM",0,0,function(a){return this.localeData().monthsShort(this,a)}),R("MMMM",0,0,function(a){return this.localeData().months(this,a)}),J("month","M"),W("M",yd),W("MM",yd,ud),W("MMM",function(a,b){return b.monthsShortRegex(a)}),W("MMMM",function(a,b){return b.monthsRegex(a)}),$(["M","MM"],function(a,b){b[Nd]=r(a)-1}),$(["MMM","MMMM"],function(a,b,c,d){var e=c._locale.monthsParse(a,d,c._strict);null!=e?b[Nd]=e:j(c).invalidMonth=a});var Vd=/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/,Wd="January_February_March_April_May_June_July_August_September_October_November_December".split("_"),Xd="Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),Yd=Jd,Zd=Jd,$d=/^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/,_d=/^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/,ae=/Z|[+-]\d\d(?::?\d\d)?/,be=[["YYYYYY-MM-DD",/[+-]\d{6}-\d\d-\d\d/],["YYYY-MM-DD",/\d{4}-\d\d-\d\d/],["GGGG-[W]WW-E",/\d{4}-W\d\d-\d/],["GGGG-[W]WW",/\d{4}-W\d\d/,!1],["YYYY-DDD",/\d{4}-\d{3}/],["YYYY-MM",/\d{4}-\d\d/,!1],["YYYYYYMMDD",/[+-]\d{10}/],["YYYYMMDD",/\d{8}/],["GGGG[W]WWE",/\d{4}W\d{3}/],["GGGG[W]WW",/\d{4}W\d{2}/,!1],["YYYYDDD",/\d{7}/]],ce=[["HH:mm:ss.SSSS",/\d\d:\d\d:\d\d\.\d+/],["HH:mm:ss,SSSS",/\d\d:\d\d:\d\d,\d+/],["HH:mm:ss",/\d\d:\d\d:\d\d/],["HH:mm",/\d\d:\d\d/],["HHmmss.SSSS",/\d\d\d\d\d\d\.\d+/],["HHmmss,SSSS",/\d\d\d\d\d\d,\d+/],["HHmmss",/\d\d\d\d\d\d/],["HHmm",/\d\d\d\d/],["HH",/\d\d/]],de=/^\/?Date\((\-?\d+)/i;a.createFromInputFallback=u("moment construction falls back to js Date. This is discouraged and will be removed in upcoming major release. Please refer to https://github.com/moment/moment/issues/1407 for more info.",function(a){a._d=new Date(a._i+(a._useUTC?" UTC":""))}),R("Y",0,0,function(){var a=this.year();return 9999>=a?""+a:"+"+a}),R(0,["YY",2],0,function(){return this.year()%100}),R(0,["YYYY",4],0,"year"),R(0,["YYYYY",5],0,"year"),R(0,["YYYYYY",6,!0],0,"year"),J("year","y"),W("Y",Fd),W("YY",yd,ud),W("YYYY",Cd,wd),W("YYYYY",Dd,xd),W("YYYYYY",Dd,xd),$(["YYYYY","YYYYYY"],Md),$("YYYY",function(b,c){c[Md]=2===b.length?a.parseTwoDigitYear(b):r(b)}),$("YY",function(b,c){c[Md]=a.parseTwoDigitYear(b)}),$("Y",function(a,b){b[Md]=parseInt(a,10)}),a.parseTwoDigitYear=function(a){return r(a)+(r(a)>68?1900:2e3)};var ee=M("FullYear",!0);a.ISO_8601=function(){};var fe=u("moment().min is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548",function(){var a=Ka.apply(null,arguments);return this.isValid()&&a.isValid()?this>a?this:a:l()}),ge=u("moment().max is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548",function(){var a=Ka.apply(null,arguments);return this.isValid()&&a.isValid()?a>this?this:a:l()}),he=function(){return Date.now?Date.now():+new Date};Qa("Z",":"),Qa("ZZ",""),W("Z",Hd),W("ZZ",Hd),$(["Z","ZZ"],function(a,b,c){c._useUTC=!0,c._tzm=Ra(Hd,a)});var ie=/([\+\-]|\d\d)/gi;a.updateOffset=function(){};var je=/^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?\d*)?$/,ke=/^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;db.fn=Oa.prototype;var le=ib(1,"add"),me=ib(-1,"subtract");a.defaultFormat="YYYY-MM-DDTHH:mm:ssZ",a.defaultFormatUtc="YYYY-MM-DDTHH:mm:ss[Z]";var ne=u("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",function(a){return void 0===a?this.localeData():this.locale(a)});R(0,["gg",2],0,function(){return this.weekYear()%100}),R(0,["GG",2],0,function(){return this.isoWeekYear()%100}),Pb("gggg","weekYear"),Pb("ggggg","weekYear"),Pb("GGGG","isoWeekYear"),Pb("GGGGG","isoWeekYear"),J("weekYear","gg"),J("isoWeekYear","GG"),W("G",Fd),W("g",Fd),W("GG",yd,ud),W("gg",yd,ud),W("GGGG",Cd,wd),W("gggg",Cd,wd),W("GGGGG",Dd,xd),W("ggggg",Dd,xd),_(["gggg","ggggg","GGGG","GGGGG"],function(a,b,c,d){b[d.substr(0,2)]=r(a)}),_(["gg","GG"],function(b,c,d,e){c[e]=a.parseTwoDigitYear(b)}),R("Q",0,"Qo","quarter"),J("quarter","Q"),W("Q",td),$("Q",function(a,b){b[Nd]=3*(r(a)-1)}),R("w",["ww",2],"wo","week"),R("W",["WW",2],"Wo","isoWeek"),J("week","w"),J("isoWeek","W"),W("w",yd),W("ww",yd,ud),W("W",yd),W("WW",yd,ud),_(["w","ww","W","WW"],function(a,b,c,d){b[d.substr(0,1)]=r(a)});var oe={dow:0,doy:6};R("D",["DD",2],"Do","date"),J("date","D"),W("D",yd),W("DD",yd,ud),W("Do",function(a,b){return a?b._ordinalParse:b._ordinalParseLenient}),$(["D","DD"],Od),$("Do",function(a,b){b[Od]=r(a.match(yd)[0],10)});var pe=M("Date",!0);R("d",0,"do","day"),R("dd",0,0,function(a){return this.localeData().weekdaysMin(this,a)}),R("ddd",0,0,function(a){return this.localeData().weekdaysShort(this,a)}),R("dddd",0,0,function(a){return this.localeData().weekdays(this,a)}),R("e",0,0,"weekday"),R("E",0,0,"isoWeekday"),J("day","d"),J("weekday","e"),J("isoWeekday","E"),W("d",yd),W("e",yd),W("E",yd),W("dd",function(a,b){return b.weekdaysMinRegex(a)}),W("ddd",function(a,b){return b.weekdaysShortRegex(a)}),W("dddd",function(a,b){return b.weekdaysRegex(a)}),_(["dd","ddd","dddd"],function(a,b,c,d){var e=c._locale.weekdaysParse(a,d,c._strict);null!=e?b.d=e:j(c).invalidWeekday=a}),_(["d","e","E"],function(a,b,c,d){b[d]=r(a)});var qe="Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),re="Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),se="Su_Mo_Tu_We_Th_Fr_Sa".split("_"),te=Jd,ue=Jd,ve=Jd;R("DDD",["DDDD",3],"DDDo","dayOfYear"),J("dayOfYear","DDD"),W("DDD",Bd),W("DDDD",vd),$(["DDD","DDDD"],function(a,b,c){c._dayOfYear=r(a)}),R("H",["HH",2],0,"hour"),R("h",["hh",2],0,oc),R("k",["kk",2],0,pc),R("hmm",0,0,function(){return""+oc.apply(this)+Q(this.minutes(),2)}),R("hmmss",0,0,function(){return""+oc.apply(this)+Q(this.minutes(),2)+Q(this.seconds(),2)}),R("Hmm",0,0,function(){return""+this.hours()+Q(this.minutes(),2)}),R("Hmmss",0,0,function(){return""+this.hours()+Q(this.minutes(),2)+Q(this.seconds(),2)}),qc("a",!0),qc("A",!1),J("hour","h"),W("a",rc),W("A",rc),W("H",yd),W("h",yd),W("HH",yd,ud),W("hh",yd,ud),W("hmm",zd),W("hmmss",Ad),W("Hmm",zd),W("Hmmss",Ad),$(["H","HH"],Pd),$(["a","A"],function(a,b,c){c._isPm=c._locale.isPM(a),c._meridiem=a}),$(["h","hh"],function(a,b,c){b[Pd]=r(a),j(c).bigHour=!0}),$("hmm",function(a,b,c){var d=a.length-2;b[Pd]=r(a.substr(0,d)),b[Qd]=r(a.substr(d)),j(c).bigHour=!0}),$("hmmss",function(a,b,c){var d=a.length-4,e=a.length-2;b[Pd]=r(a.substr(0,d)),b[Qd]=r(a.substr(d,2)),b[Rd]=r(a.substr(e)),j(c).bigHour=!0}),$("Hmm",function(a,b,c){var d=a.length-2;b[Pd]=r(a.substr(0,d)),b[Qd]=r(a.substr(d))}),$("Hmmss",function(a,b,c){var d=a.length-4,e=a.length-2;b[Pd]=r(a.substr(0,d)),b[Qd]=r(a.substr(d,2)),b[Rd]=r(a.substr(e))});var we=/[ap]\.?m?\.?/i,xe=M("Hours",!0);R("m",["mm",2],0,"minute"),J("minute","m"),W("m",yd),W("mm",yd,ud),$(["m","mm"],Qd);var ye=M("Minutes",!1);R("s",["ss",2],0,"second"),J("second","s"),W("s",yd),W("ss",yd,ud),$(["s","ss"],Rd);var ze=M("Seconds",!1);R("S",0,0,function(){return~~(this.millisecond()/100)}),R(0,["SS",2],0,function(){return~~(this.millisecond()/10)}),R(0,["SSS",3],0,"millisecond"),R(0,["SSSS",4],0,function(){return 10*this.millisecond()}),R(0,["SSSSS",5],0,function(){return 100*this.millisecond()}),R(0,["SSSSSS",6],0,function(){return 1e3*this.millisecond()}),R(0,["SSSSSSS",7],0,function(){return 1e4*this.millisecond()}),R(0,["SSSSSSSS",8],0,function(){return 1e5*this.millisecond()}),R(0,["SSSSSSSSS",9],0,function(){return 1e6*this.millisecond()}),J("millisecond","ms"),W("S",Bd,td),W("SS",Bd,ud),W("SSS",Bd,vd);var Ae;for(Ae="SSSS";Ae.length<=9;Ae+="S")W(Ae,Ed);for(Ae="S";Ae.length<=9;Ae+="S")$(Ae,uc);var Be=M("Milliseconds",!1);R("z",0,0,"zoneAbbr"),R("zz",0,0,"zoneName");var Ce=o.prototype;Ce.add=le,Ce.calendar=kb,Ce.clone=lb,Ce.diff=sb,Ce.endOf=Eb,Ce.format=wb,Ce.from=xb,Ce.fromNow=yb,Ce.to=zb,Ce.toNow=Ab,Ce.get=P,Ce.invalidAt=Nb,Ce.isAfter=mb,Ce.isBefore=nb,Ce.isBetween=ob,Ce.isSame=pb,Ce.isSameOrAfter=qb,Ce.isSameOrBefore=rb,Ce.isValid=Lb,Ce.lang=ne,Ce.locale=Bb,Ce.localeData=Cb,Ce.max=ge,Ce.min=fe,Ce.parsingFlags=Mb,Ce.set=P,Ce.startOf=Db,Ce.subtract=me,Ce.toArray=Ib,Ce.toObject=Jb,Ce.toDate=Hb,Ce.toISOString=vb,Ce.toJSON=Kb,Ce.toString=ub,Ce.unix=Gb,Ce.valueOf=Fb,Ce.creationData=Ob,Ce.year=ee,Ce.isLeapYear=ta,Ce.weekYear=Qb,Ce.isoWeekYear=Rb,Ce.quarter=Ce.quarters=Wb,Ce.month=ha,Ce.daysInMonth=ia,Ce.week=Ce.weeks=$b,Ce.isoWeek=Ce.isoWeeks=_b,Ce.weeksInYear=Tb,Ce.isoWeeksInYear=Sb,Ce.date=pe,Ce.day=Ce.days=gc,Ce.weekday=hc,Ce.isoWeekday=ic,Ce.dayOfYear=nc,Ce.hour=Ce.hours=xe,Ce.minute=Ce.minutes=ye,Ce.second=Ce.seconds=ze,Ce.millisecond=Ce.milliseconds=Be,Ce.utcOffset=Ua,Ce.utc=Wa,Ce.local=Xa,Ce.parseZone=Ya,Ce.hasAlignedHourOffset=Za,Ce.isDST=$a,Ce.isDSTShifted=_a,Ce.isLocal=ab,Ce.isUtcOffset=bb,Ce.isUtc=cb,Ce.isUTC=cb,Ce.zoneAbbr=vc,Ce.zoneName=wc,Ce.dates=u("dates accessor is deprecated. Use date instead.",pe),Ce.months=u("months accessor is deprecated. Use month instead",ha),Ce.years=u("years accessor is deprecated. Use year instead",ee),Ce.zone=u("moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779",Va);var De=Ce,Ee={sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},Fe={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},Ge="Invalid date",He="%d",Ie=/\d{1,2}/,Je={future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},Ke=A.prototype;Ke._calendar=Ee,Ke.calendar=zc,Ke._longDateFormat=Fe,Ke.longDateFormat=Ac,Ke._invalidDate=Ge,Ke.invalidDate=Bc,Ke._ordinal=He,Ke.ordinal=Cc,Ke._ordinalParse=Ie,Ke.preparse=Dc,Ke.postformat=Dc,Ke._relativeTime=Je,Ke.relativeTime=Ec,Ke.pastFuture=Fc,Ke.set=y,Ke.months=ca,Ke._months=Wd,Ke.monthsShort=da,Ke._monthsShort=Xd,Ke.monthsParse=fa,Ke._monthsRegex=Zd,Ke.monthsRegex=ka,Ke._monthsShortRegex=Yd,Ke.monthsShortRegex=ja,Ke.week=Xb,Ke._week=oe,Ke.firstDayOfYear=Zb,Ke.firstDayOfWeek=Yb,Ke.weekdays=bc,Ke._weekdays=qe,Ke.weekdaysMin=dc,Ke._weekdaysMin=se,Ke.weekdaysShort=cc,Ke._weekdaysShort=re,Ke.weekdaysParse=fc,Ke._weekdaysRegex=te,Ke.weekdaysRegex=jc,Ke._weekdaysShortRegex=ue,Ke.weekdaysShortRegex=kc,Ke._weekdaysMinRegex=ve,Ke.weekdaysMinRegex=lc,Ke.isPM=sc,Ke._meridiemParse=we,Ke.meridiem=tc,E("en",{ordinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(a){var b=a%10,c=1===r(a%100/10)?"th":1===b?"st":2===b?"nd":3===b?"rd":"th";return a+c}}),a.lang=u("moment.lang is deprecated. Use moment.locale instead.",E),a.langData=u("moment.langData is deprecated. Use moment.localeData instead.",H);var Le=Math.abs,Me=Yc("ms"),Ne=Yc("s"),Oe=Yc("m"),Pe=Yc("h"),Qe=Yc("d"),Re=Yc("w"),Se=Yc("M"),Te=Yc("y"),Ue=$c("milliseconds"),Ve=$c("seconds"),We=$c("minutes"),Xe=$c("hours"),Ye=$c("days"),Ze=$c("months"),$e=$c("years"),_e=Math.round,af={s:45,m:45,h:22,d:26,M:11},bf=Math.abs,cf=Oa.prototype;cf.abs=Oc,cf.add=Qc,cf.subtract=Rc,cf.as=Wc,cf.asMilliseconds=Me,cf.asSeconds=Ne,cf.asMinutes=Oe,cf.asHours=Pe,cf.asDays=Qe,cf.asWeeks=Re,cf.asMonths=Se,cf.asYears=Te,cf.valueOf=Xc,cf._bubble=Tc,cf.get=Zc,cf.milliseconds=Ue,cf.seconds=Ve,cf.minutes=We,cf.hours=Xe,cf.days=Ye,cf.weeks=_c,cf.months=Ze,cf.years=$e,cf.humanize=dd,cf.toISOString=ed,cf.toString=ed,cf.toJSON=ed,cf.locale=Bb,cf.localeData=Cb,cf.toIsoString=u("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",ed),cf.lang=ne,R("X",0,0,"unix"),R("x",0,0,"valueOf"),W("x",Fd),W("X",Id),$("X",function(a,b,c){c._d=new Date(1e3*parseFloat(a,10))}),$("x",function(a,b,c){c._d=new Date(r(a))}),a.version="2.13.0",b(Ka),a.fn=De,a.min=Ma,a.max=Na,a.now=he,a.utc=h,a.unix=xc,a.months=Jc,a.isDate=d,a.locale=E,a.invalid=l,a.duration=db,a.isMoment=p,a.weekdays=Lc,a.parseZone=yc,a.localeData=H,a.isDuration=Pa,a.monthsShort=Kc,a.weekdaysMin=Nc,a.defineLocale=F,a.updateLocale=G,a.locales=I,a.weekdaysShort=Mc,a.normalizeUnits=K,a.relativeTimeThreshold=cd,a.prototype=De;var df=a;return df});
/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.9.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */
!function(){"use strict";function t(t,i){i?(d[0]=d[16]=d[1]=d[2]=d[3]=d[4]=d[5]=d[6]=d[7]=d[8]=d[9]=d[10]=d[11]=d[12]=d[13]=d[14]=d[15]=0,this.blocks=d):this.blocks=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],t?(this.h0=3238371032,this.h1=914150663,this.h2=812702999,this.h3=4144912697,this.h4=4290775857,this.h5=1750603025,this.h6=1694076839,this.h7=3204075428):(this.h0=1779033703,this.h1=3144134277,this.h2=1013904242,this.h3=2773480762,this.h4=1359893119,this.h5=2600822924,this.h6=528734635,this.h7=1541459225),this.block=this.start=this.bytes=this.hBytes=0,this.finalized=this.hashed=!1,this.first=!0,this.is224=t}function i(i,r,s){var e,n=typeof i;if("string"===n){var o,a=[],u=i.length,c=0;for(e=0;e<u;++e)(o=i.charCodeAt(e))<128?a[c++]=o:o<2048?(a[c++]=192|o>>6,a[c++]=128|63&o):o<55296||o>=57344?(a[c++]=224|o>>12,a[c++]=128|o>>6&63,a[c++]=128|63&o):(o=65536+((1023&o)<<10|1023&i.charCodeAt(++e)),a[c++]=240|o>>18,a[c++]=128|o>>12&63,a[c++]=128|o>>6&63,a[c++]=128|63&o);i=a}else{if("object"!==n)throw new Error(h);if(null===i)throw new Error(h);if(f&&i.constructor===ArrayBuffer)i=new Uint8Array(i);else if(!(Array.isArray(i)||f&&ArrayBuffer.isView(i)))throw new Error(h)}i.length>64&&(i=new t(r,!0).update(i).array());var y=[],p=[];for(e=0;e<64;++e){var l=i[e]||0;y[e]=92^l,p[e]=54^l}t.call(this,r,s),this.update(p),this.oKeyPad=y,this.inner=!0,this.sharedMemory=s}var h="input is invalid type",r="object"==typeof window,s=r?window:{};s.JS_SHA256_NO_WINDOW&&(r=!1);var e=!r&&"object"==typeof self,n=!s.JS_SHA256_NO_NODE_JS&&"object"==typeof process&&process.versions&&process.versions.node;n?s=global:e&&(s=self);var o=!s.JS_SHA256_NO_COMMON_JS&&"object"==typeof module&&module.exports,a="function"==typeof define&&define.amd,f=!s.JS_SHA256_NO_ARRAY_BUFFER&&"undefined"!=typeof ArrayBuffer,u="0123456789abcdef".split(""),c=[-2147483648,8388608,32768,128],y=[24,16,8,0],p=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298],l=["hex","array","digest","arrayBuffer"],d=[];!s.JS_SHA256_NO_NODE_JS&&Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),!f||!s.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW&&ArrayBuffer.isView||(ArrayBuffer.isView=function(t){return"object"==typeof t&&t.buffer&&t.buffer.constructor===ArrayBuffer});var A=function(i,h){return function(r){return new t(h,!0).update(r)[i]()}},w=function(i){var h=A("hex",i);n&&(h=b(h,i)),h.create=function(){return new t(i)},h.update=function(t){return h.create().update(t)};for(var r=0;r<l.length;++r){var s=l[r];h[s]=A(s,i)}return h},b=function(t,i){var r=eval("require('crypto')"),s=eval("require('buffer').Buffer"),e=i?"sha224":"sha256",n=function(i){if("string"==typeof i)return r.createHash(e).update(i,"utf8").digest("hex");if(null===i||void 0===i)throw new Error(h);return i.constructor===ArrayBuffer&&(i=new Uint8Array(i)),Array.isArray(i)||ArrayBuffer.isView(i)||i.constructor===s?r.createHash(e).update(new s(i)).digest("hex"):t(i)};return n},v=function(t,h){return function(r,s){return new i(r,h,!0).update(s)[t]()}},_=function(t){var h=v("hex",t);h.create=function(h){return new i(h,t)},h.update=function(t,i){return h.create(t).update(i)};for(var r=0;r<l.length;++r){var s=l[r];h[s]=v(s,t)}return h};t.prototype.update=function(t){if(!this.finalized){var i,r=typeof t;if("string"!==r){if("object"!==r)throw new Error(h);if(null===t)throw new Error(h);if(f&&t.constructor===ArrayBuffer)t=new Uint8Array(t);else if(!(Array.isArray(t)||f&&ArrayBuffer.isView(t)))throw new Error(h);i=!0}for(var s,e,n=0,o=t.length,a=this.blocks;n<o;){if(this.hashed&&(this.hashed=!1,a[0]=this.block,a[16]=a[1]=a[2]=a[3]=a[4]=a[5]=a[6]=a[7]=a[8]=a[9]=a[10]=a[11]=a[12]=a[13]=a[14]=a[15]=0),i)for(e=this.start;n<o&&e<64;++n)a[e>>2]|=t[n]<<y[3&e++];else for(e=this.start;n<o&&e<64;++n)(s=t.charCodeAt(n))<128?a[e>>2]|=s<<y[3&e++]:s<2048?(a[e>>2]|=(192|s>>6)<<y[3&e++],a[e>>2]|=(128|63&s)<<y[3&e++]):s<55296||s>=57344?(a[e>>2]|=(224|s>>12)<<y[3&e++],a[e>>2]|=(128|s>>6&63)<<y[3&e++],a[e>>2]|=(128|63&s)<<y[3&e++]):(s=65536+((1023&s)<<10|1023&t.charCodeAt(++n)),a[e>>2]|=(240|s>>18)<<y[3&e++],a[e>>2]|=(128|s>>12&63)<<y[3&e++],a[e>>2]|=(128|s>>6&63)<<y[3&e++],a[e>>2]|=(128|63&s)<<y[3&e++]);this.lastByteIndex=e,this.bytes+=e-this.start,e>=64?(this.block=a[16],this.start=e-64,this.hash(),this.hashed=!0):this.start=e}return this.bytes>4294967295&&(this.hBytes+=this.bytes/4294967296<<0,this.bytes=this.bytes%4294967296),this}},t.prototype.finalize=function(){if(!this.finalized){this.finalized=!0;var t=this.blocks,i=this.lastByteIndex;t[16]=this.block,t[i>>2]|=c[3&i],this.block=t[16],i>=56&&(this.hashed||this.hash(),t[0]=this.block,t[16]=t[1]=t[2]=t[3]=t[4]=t[5]=t[6]=t[7]=t[8]=t[9]=t[10]=t[11]=t[12]=t[13]=t[14]=t[15]=0),t[14]=this.hBytes<<3|this.bytes>>>29,t[15]=this.bytes<<3,this.hash()}},t.prototype.hash=function(){var t,i,h,r,s,e,n,o,a,f=this.h0,u=this.h1,c=this.h2,y=this.h3,l=this.h4,d=this.h5,A=this.h6,w=this.h7,b=this.blocks;for(t=16;t<64;++t)i=((s=b[t-15])>>>7|s<<25)^(s>>>18|s<<14)^s>>>3,h=((s=b[t-2])>>>17|s<<15)^(s>>>19|s<<13)^s>>>10,b[t]=b[t-16]+i+b[t-7]+h<<0;for(a=u&c,t=0;t<64;t+=4)this.first?(this.is224?(e=300032,w=(s=b[0]-1413257819)-150054599<<0,y=s+24177077<<0):(e=704751109,w=(s=b[0]-210244248)-1521486534<<0,y=s+143694565<<0),this.first=!1):(i=(f>>>2|f<<30)^(f>>>13|f<<19)^(f>>>22|f<<10),r=(e=f&u)^f&c^a,w=y+(s=w+(h=(l>>>6|l<<26)^(l>>>11|l<<21)^(l>>>25|l<<7))+(l&d^~l&A)+p[t]+b[t])<<0,y=s+(i+r)<<0),i=(y>>>2|y<<30)^(y>>>13|y<<19)^(y>>>22|y<<10),r=(n=y&f)^y&u^e,A=c+(s=A+(h=(w>>>6|w<<26)^(w>>>11|w<<21)^(w>>>25|w<<7))+(w&l^~w&d)+p[t+1]+b[t+1])<<0,i=((c=s+(i+r)<<0)>>>2|c<<30)^(c>>>13|c<<19)^(c>>>22|c<<10),r=(o=c&y)^c&f^n,d=u+(s=d+(h=(A>>>6|A<<26)^(A>>>11|A<<21)^(A>>>25|A<<7))+(A&w^~A&l)+p[t+2]+b[t+2])<<0,i=((u=s+(i+r)<<0)>>>2|u<<30)^(u>>>13|u<<19)^(u>>>22|u<<10),r=(a=u&c)^u&y^o,l=f+(s=l+(h=(d>>>6|d<<26)^(d>>>11|d<<21)^(d>>>25|d<<7))+(d&A^~d&w)+p[t+3]+b[t+3])<<0,f=s+(i+r)<<0;this.h0=this.h0+f<<0,this.h1=this.h1+u<<0,this.h2=this.h2+c<<0,this.h3=this.h3+y<<0,this.h4=this.h4+l<<0,this.h5=this.h5+d<<0,this.h6=this.h6+A<<0,this.h7=this.h7+w<<0},t.prototype.hex=function(){this.finalize();var t=this.h0,i=this.h1,h=this.h2,r=this.h3,s=this.h4,e=this.h5,n=this.h6,o=this.h7,a=u[t>>28&15]+u[t>>24&15]+u[t>>20&15]+u[t>>16&15]+u[t>>12&15]+u[t>>8&15]+u[t>>4&15]+u[15&t]+u[i>>28&15]+u[i>>24&15]+u[i>>20&15]+u[i>>16&15]+u[i>>12&15]+u[i>>8&15]+u[i>>4&15]+u[15&i]+u[h>>28&15]+u[h>>24&15]+u[h>>20&15]+u[h>>16&15]+u[h>>12&15]+u[h>>8&15]+u[h>>4&15]+u[15&h]+u[r>>28&15]+u[r>>24&15]+u[r>>20&15]+u[r>>16&15]+u[r>>12&15]+u[r>>8&15]+u[r>>4&15]+u[15&r]+u[s>>28&15]+u[s>>24&15]+u[s>>20&15]+u[s>>16&15]+u[s>>12&15]+u[s>>8&15]+u[s>>4&15]+u[15&s]+u[e>>28&15]+u[e>>24&15]+u[e>>20&15]+u[e>>16&15]+u[e>>12&15]+u[e>>8&15]+u[e>>4&15]+u[15&e]+u[n>>28&15]+u[n>>24&15]+u[n>>20&15]+u[n>>16&15]+u[n>>12&15]+u[n>>8&15]+u[n>>4&15]+u[15&n];return this.is224||(a+=u[o>>28&15]+u[o>>24&15]+u[o>>20&15]+u[o>>16&15]+u[o>>12&15]+u[o>>8&15]+u[o>>4&15]+u[15&o]),a},t.prototype.toString=t.prototype.hex,t.prototype.digest=function(){this.finalize();var t=this.h0,i=this.h1,h=this.h2,r=this.h3,s=this.h4,e=this.h5,n=this.h6,o=this.h7,a=[t>>24&255,t>>16&255,t>>8&255,255&t,i>>24&255,i>>16&255,i>>8&255,255&i,h>>24&255,h>>16&255,h>>8&255,255&h,r>>24&255,r>>16&255,r>>8&255,255&r,s>>24&255,s>>16&255,s>>8&255,255&s,e>>24&255,e>>16&255,e>>8&255,255&e,n>>24&255,n>>16&255,n>>8&255,255&n];return this.is224||a.push(o>>24&255,o>>16&255,o>>8&255,255&o),a},t.prototype.array=t.prototype.digest,t.prototype.arrayBuffer=function(){this.finalize();var t=new ArrayBuffer(this.is224?28:32),i=new DataView(t);return i.setUint32(0,this.h0),i.setUint32(4,this.h1),i.setUint32(8,this.h2),i.setUint32(12,this.h3),i.setUint32(16,this.h4),i.setUint32(20,this.h5),i.setUint32(24,this.h6),this.is224||i.setUint32(28,this.h7),t},i.prototype=new t,i.prototype.finalize=function(){if(t.prototype.finalize.call(this),this.inner){this.inner=!1;var i=this.array();t.call(this,this.is224,this.sharedMemory),this.update(this.oKeyPad),this.update(i),t.prototype.finalize.call(this)}};var B=w();B.sha256=B,B.sha224=w(!0),B.sha256.hmac=_(),B.sha224.hmac=_(!0),o?module.exports=B:(s.sha256=B.sha256,s.sha224=B.sha224,a&&define(function(){return B}))}();
!function(t,e){"use strict";"object"==typeof module&&module.exports?module.exports=e(require("moment")):"function"==typeof define&&define.amd?define(["moment"],e):e(t.moment)}(this,function(r){"use strict";void 0===r.version&&r.default&&(r=r.default);var e,a={},i={},s={},c={},l={},t=(r&&"string"==typeof r.version||D("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/"),r.version.split(".")),n=+t[0],o=+t[1];function f(t){return 96<t?t-87:64<t?t-29:t-48}function u(t){var e=0,n=t.split("."),o=n[0],r=n[1]||"",i=1,s=0,n=1;for(45===t.charCodeAt(0)&&(n=-(e=1));e<o.length;e++)s=60*s+f(o.charCodeAt(e));for(e=0;e<r.length;e++)i/=60,s+=f(r.charCodeAt(e))*i;return s*n}function h(t){for(var e=0;e<t.length;e++)t[e]=u(t[e])}function p(t,e){for(var n=[],o=0;o<e.length;o++)n[o]=t[e[o]];return n}function m(t){for(var t=t.split("|"),e=t[2].split(" "),n=t[3].split(""),o=t[4].split(" "),r=(h(e),h(n),h(o),o),i=n.length,s=0;s<i;s++)r[s]=Math.round((r[s-1]||0)+6e4*r[s]);return r[i-1]=1/0,{name:t[0],abbrs:p(t[1].split(" "),n),offsets:p(e,n),untils:o,population:0|t[5]}}function d(t){t&&this._set(m(t))}function z(t,e){this.name=t,this.zones=e}function v(t){var e=t.toTimeString(),n=e.match(/\([a-z ]+\)/i);"GMT"===(n=n&&n[0]?(n=n[0].match(/[A-Z]/g))?n.join(""):void 0:(n=e.match(/[A-Z]{3,5}/g))?n[0]:void 0)&&(n=void 0),this.at=+t,this.abbr=n,this.offset=t.getTimezoneOffset()}function b(t){this.zone=t,this.offsetScore=0,this.abbrScore=0}function g(){for(var t,e,n,o=(new Date).getFullYear()-2,r=new v(new Date(o,0,1)),i=r.offset,s=[r],f=1;f<48;f++)(n=new Date(o,f,1).getTimezoneOffset())!==i&&(t=function(t,e){for(var n;n=6e4*((e.at-t.at)/12e4|0);)(n=new v(new Date(t.at+n))).offset===t.offset?t=n:e=n;return t}(r,e=new v(new Date(o,f,1))),s.push(t),s.push(new v(new Date(t.at+6e4))),r=e,i=n);for(f=0;f<4;f++)s.push(new v(new Date(o+f,0,1))),s.push(new v(new Date(o+f,6,1)));return s}function _(t,e){return t.offsetScore!==e.offsetScore?t.offsetScore-e.offsetScore:t.abbrScore!==e.abbrScore?t.abbrScore-e.abbrScore:t.zone.population!==e.zone.population?e.zone.population-t.zone.population:e.zone.name.localeCompare(t.zone.name)}function w(){try{var t=Intl.DateTimeFormat().resolvedOptions().timeZone;if(t&&3<t.length){var e=c[y(t)];if(e)return e;D("Moment Timezone found "+t+" from the Intl api, but did not have that data loaded.")}}catch(t){}for(var n,o,r=g(),i=r.length,s=function(t){for(var e,n,o,r=t.length,i={},s=[],f={},u=0;u<r;u++)if(n=t[u].offset,!f.hasOwnProperty(n)){for(e in o=l[n]||{})o.hasOwnProperty(e)&&(i[e]=!0);f[n]=!0}for(u in i)i.hasOwnProperty(u)&&s.push(c[u]);return s}(r),f=[],u=0;u<s.length;u++){for(n=new b(S(s[u])),o=0;o<i;o++)n.scoreOffsetAt(r[o]);f.push(n)}return f.sort(_),0<f.length?f[0].zone.name:void 0}function y(t){return(t||"").toLowerCase().replace(/\//g,"_")}function O(t){var e,n,o,r;for("string"==typeof t&&(t=[t]),e=0;e<t.length;e++){r=y(n=(o=t[e].split("|"))[0]),a[r]=t[e],c[r]=n,s=i=u=f=void 0;var i,s,f=r,u=o[2].split(" ");for(h(u),i=0;i<u.length;i++)s=u[i],l[s]=l[s]||{},l[s][f]=!0}}function S(t,e){t=y(t);var n=a[t];return n instanceof d?n:"string"==typeof n?(n=new d(n),a[t]=n):i[t]&&e!==S&&(e=S(i[t],S))?((n=a[t]=new d)._set(e),n.name=c[t],n):null}function M(t){var e,n,o,r;for("string"==typeof t&&(t=[t]),e=0;e<t.length;e++)o=y((n=t[e].split("|"))[0]),r=y(n[1]),i[o]=r,c[o]=n[0],i[r]=o,c[r]=n[1]}function j(t){return j.didShowError||(j.didShowError=!0,D("moment.tz.zoneExists('"+t+"') has been deprecated in favor of !moment.tz.zone('"+t+"')")),!!S(t)}function A(t){var e="X"===t._f||"x"===t._f;return!(!t._a||void 0!==t._tzm||e)}function D(t){"undefined"!=typeof console&&"function"==typeof console.error&&void 0}function T(t){var e=Array.prototype.slice.call(arguments,0,-1),n=arguments[arguments.length-1],e=r.utc.apply(null,e);return!r.isMoment(t)&&A(e)&&(t=S(n))&&e.add(t.parse(e),"minutes"),e.tz(n),e}(n<2||2==n&&o<6)&&D("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js "+r.version+". See momentjs.com"),d.prototype={_set:function(t){this.name=t.name,this.abbrs=t.abbrs,this.untils=t.untils,this.offsets=t.offsets,this.population=t.population},_index:function(t){t=function(t,e){var n,o=e.length;if(t<e[0])return 0;if(1<o&&e[o-1]===1/0&&t>=e[o-2])return o-1;if(t>=e[o-1])return-1;for(var r=0,i=o-1;1<i-r;)e[n=Math.floor((r+i)/2)]<=t?r=n:i=n;return i}(+t,this.untils);if(0<=t)return t},countries:function(){var e=this.name;return Object.keys(s).filter(function(t){return-1!==s[t].zones.indexOf(e)})},parse:function(t){for(var e,n,o,r=+t,i=this.offsets,s=this.untils,f=s.length-1,u=0;u<f;u++)if(e=i[u],n=i[u+1],o=i[u&&u-1],e<n&&T.moveAmbiguousForward?e=n:o<e&&T.moveInvalidForward&&(e=o),r<s[u]-6e4*e)return i[u];return i[f]},abbr:function(t){return this.abbrs[this._index(t)]},offset:function(t){return D("zone.offset has been deprecated in favor of zone.utcOffset"),this.offsets[this._index(t)]},utcOffset:function(t){return this.offsets[this._index(t)]}},b.prototype.scoreOffsetAt=function(t){this.offsetScore+=Math.abs(this.zone.utcOffset(t.at)-t.offset),this.zone.abbr(t.at).replace(/[^A-Z]/g,"")!==t.abbr&&this.abbrScore++},T.version="0.5.45",T.dataVersion="",T._zones=a,T._links=i,T._names=c,T._countries=s,T.add=O,T.link=M,T.load=function(t){O(t.zones),M(t.links);var e,n,o,r=t.countries;if(r&&r.length)for(e=0;e<r.length;e++)n=(o=r[e].split("|"))[0].toUpperCase(),o=o[1].split(" "),s[n]=new z(n,o);T.dataVersion=t.version},T.zone=S,T.zoneExists=j,T.guess=function(t){return e=e&&!t?e:w()},T.names=function(){var t,e=[];for(t in c)c.hasOwnProperty(t)&&(a[t]||a[i[t]])&&c[t]&&e.push(c[t]);return e.sort()},T.Zone=d,T.unpack=m,T.unpackBase60=u,T.needsOffset=A,T.moveInvalidForward=!0,T.moveAmbiguousForward=!1,T.countries=function(){return Object.keys(s)},T.zonesForCountry=function(t,e){var n;return n=(n=t).toUpperCase(),(t=s[n]||null)?(n=t.zones.sort(),e?n.map(function(t){return{name:t,offset:S(t).utcOffset(new Date)}}):n):null};var x,t=r.fn;function C(t){return function(){return this._z?this._z.abbr(this):t.call(this)}}function Z(t){return function(){return this._z=null,t.apply(this,arguments)}}r.tz=T,r.defaultZone=null,r.updateOffset=function(t,e){var n,o=r.defaultZone;void 0===t._z&&(o&&A(t)&&!t._isUTC&&t.isValid()&&(t._d=r.utc(t._a)._d,t.utc().add(o.parse(t),"minutes")),t._z=o),t._z&&(o=t._z.utcOffset(t),Math.abs(o)<16&&(o/=60),void 0!==t.utcOffset?(n=t._z,t.utcOffset(-o,e),t._z=n):t.zone(o,e))},t.tz=function(t,e){if(t){if("string"!=typeof t)throw new Error("Time zone name must be a string, got "+t+" ["+typeof t+"]");return this._z=S(t),this._z?r.updateOffset(this,e):D("Moment Timezone has no data for "+t+". See http://momentjs.com/timezone/docs/#/data-loading/."),this}if(this._z)return this._z.name},t.zoneName=C(t.zoneName),t.zoneAbbr=C(t.zoneAbbr),t.utc=Z(t.utc),t.local=Z(t.local),t.utcOffset=(x=t.utcOffset,function(){return 0<arguments.length&&(this._z=null),x.apply(this,arguments)}),r.tz.setDefault=function(t){return(n<2||2==n&&o<9)&&D("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js "+r.version+"."),r.defaultZone=t?S(t):null,r};t=r.momentProperties;return"[object Array]"===Object.prototype.toString.call(t)?(t.push("_z"),t.push("_a")):t&&(t._z=null),r});
!function(a,i){"use strict";"object"==typeof module&&module.exports?module.exports=i(require("moment")):"function"==typeof define&&define.amd?define(["moment"],i):i(a.moment)}(this,function(o){"use strict";void 0===o.version&&o.default&&(o=o.default);var i,s={},c={},A={},u={},m={},a=(o&&"string"==typeof o.version||N("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/"),o.version.split(".")),e=+a[0],r=+a[1];function n(a){return 96<a?a-87:64<a?a-29:a-48}function t(a){var i=0,e=a.split("."),r=e[0],o=e[1]||"",c=1,A=0,e=1;for(45===a.charCodeAt(0)&&(e=-(i=1));i<r.length;i++)A=60*A+n(r.charCodeAt(i));for(i=0;i<o.length;i++)c/=60,A+=n(o.charCodeAt(i))*c;return A*e}function l(a){for(var i=0;i<a.length;i++)a[i]=t(a[i])}function f(a,i){for(var e=[],r=0;r<i.length;r++)e[r]=a[i[r]];return e}function p(a){for(var a=a.split("|"),i=a[2].split(" "),e=a[3].split(""),r=a[4].split(" "),o=(l(i),l(e),l(r),r),c=e.length,A=0;A<c;A++)o[A]=Math.round((o[A-1]||0)+6e4*o[A]);return o[c-1]=1/0,{name:a[0],abbrs:f(a[1].split(" "),e),offsets:f(i,e),untils:r,population:0|a[5]}}function b(a){a&&this._set(p(a))}function M(a,i){this.name=a,this.zones=i}function d(a){var i=a.toTimeString(),e=i.match(/\([a-z ]+\)/i);"GMT"===(e=e&&e[0]?(e=e[0].match(/[A-Z]/g))?e.join(""):void 0:(e=i.match(/[A-Z]{3,5}/g))?e[0]:void 0)&&(e=void 0),this.at=+a,this.abbr=e,this.offset=a.getTimezoneOffset()}function h(a){this.zone=a,this.offsetScore=0,this.abbrScore=0}function E(){for(var a,i,e,r=(new Date).getFullYear()-2,o=new d(new Date(r,0,1)),c=o.offset,A=[o],n=1;n<48;n++)(e=new Date(r,n,1).getTimezoneOffset())!==c&&(a=function(a,i){for(var e;e=6e4*((i.at-a.at)/12e4|0);)(e=new d(new Date(a.at+e))).offset===a.offset?a=e:i=e;return a}(o,i=new d(new Date(r,n,1))),A.push(a),A.push(new d(new Date(a.at+6e4))),o=i,c=e);for(n=0;n<4;n++)A.push(new d(new Date(r+n,0,1))),A.push(new d(new Date(r+n,6,1)));return A}function g(a,i){return a.offsetScore!==i.offsetScore?a.offsetScore-i.offsetScore:a.abbrScore!==i.abbrScore?a.abbrScore-i.abbrScore:a.zone.population!==i.zone.population?i.zone.population-a.zone.population:i.zone.name.localeCompare(a.zone.name)}function z(){try{var a=Intl.DateTimeFormat().resolvedOptions().timeZone;if(a&&3<a.length){var i=u[P(a)];if(i)return i;N("Moment Timezone found "+a+" from the Intl api, but did not have that data loaded.")}}catch(a){}for(var e,r,o=E(),c=o.length,A=function(a){for(var i,e,r,o=a.length,c={},A=[],n={},t=0;t<o;t++)if(e=a[t].offset,!n.hasOwnProperty(e)){for(i in r=m[e]||{})r.hasOwnProperty(i)&&(c[i]=!0);n[e]=!0}for(t in c)c.hasOwnProperty(t)&&A.push(u[t]);return A}(o),n=[],t=0;t<A.length;t++){for(e=new h(S(A[t])),r=0;r<c;r++)e.scoreOffsetAt(o[r]);n.push(e)}return n.sort(g),0<n.length?n[0].zone.name:void 0}function P(a){return(a||"").toLowerCase().replace(/\//g,"_")}function T(a){var i,e,r,o;for("string"==typeof a&&(a=[a]),i=0;i<a.length;i++){o=P(e=(r=a[i].split("|"))[0]),s[o]=a[i],u[o]=e,A=c=t=n=void 0;var c,A,n=o,t=r[2].split(" ");for(l(t),c=0;c<t.length;c++)A=t[c],m[A]=m[A]||{},m[A][n]=!0}}function S(a,i){a=P(a);var e=s[a];return e instanceof b?e:"string"==typeof e?(e=new b(e),s[a]=e):c[a]&&i!==S&&(i=S(c[a],S))?((e=s[a]=new b)._set(i),e.name=u[a],e):null}function _(a){var i,e,r,o;for("string"==typeof a&&(a=[a]),i=0;i<a.length;i++)r=P((e=a[i].split("|"))[0]),o=P(e[1]),c[r]=o,u[r]=e[0],c[o]=r,u[o]=e[1]}function k(a){T(a.zones),_(a.links);var i,e,r,o=a.countries;if(o&&o.length)for(i=0;i<o.length;i++)e=(r=o[i].split("|"))[0].toUpperCase(),r=r[1].split(" "),A[e]=new M(e,r);O.dataVersion=a.version}function C(a){return C.didShowError||(C.didShowError=!0,N("moment.tz.zoneExists('"+a+"') has been deprecated in favor of !moment.tz.zone('"+a+"')")),!!S(a)}function B(a){var i="X"===a._f||"x"===a._f;return!(!a._a||void 0!==a._tzm||i)}function N(a){"undefined"!=typeof console&&"function"==typeof console.error&&void 0}function O(a){var i=Array.prototype.slice.call(arguments,0,-1),e=arguments[arguments.length-1],i=o.utc.apply(null,i);return!o.isMoment(a)&&B(i)&&(a=S(e))&&i.add(a.parse(i),"minutes"),i.tz(e),i}(e<2||2==e&&r<6)&&N("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js "+o.version+". See momentjs.com"),b.prototype={_set:function(a){this.name=a.name,this.abbrs=a.abbrs,this.untils=a.untils,this.offsets=a.offsets,this.population=a.population},_index:function(a){a=function(a,i){var e,r=i.length;if(a<i[0])return 0;if(1<r&&i[r-1]===1/0&&a>=i[r-2])return r-1;if(a>=i[r-1])return-1;for(var o=0,c=r-1;1<c-o;)i[e=Math.floor((o+c)/2)]<=a?o=e:c=e;return c}(+a,this.untils);if(0<=a)return a},countries:function(){var i=this.name;return Object.keys(A).filter(function(a){return-1!==A[a].zones.indexOf(i)})},parse:function(a){for(var i,e,r,o=+a,c=this.offsets,A=this.untils,n=A.length-1,t=0;t<n;t++)if(i=c[t],e=c[t+1],r=c[t&&t-1],i<e&&O.moveAmbiguousForward?i=e:r<i&&O.moveInvalidForward&&(i=r),o<A[t]-6e4*i)return c[t];return c[n]},abbr:function(a){return this.abbrs[this._index(a)]},offset:function(a){return N("zone.offset has been deprecated in favor of zone.utcOffset"),this.offsets[this._index(a)]},utcOffset:function(a){return this.offsets[this._index(a)]}},h.prototype.scoreOffsetAt=function(a){this.offsetScore+=Math.abs(this.zone.utcOffset(a.at)-a.offset),this.zone.abbr(a.at).replace(/[^A-Z]/g,"")!==a.abbr&&this.abbrScore++},O.version="0.5.45",O.dataVersion="",O._zones=s,O._links=c,O._names=u,O._countries=A,O.add=T,O.link=_,O.load=k,O.zone=S,O.zoneExists=C,O.guess=function(a){return i=i&&!a?i:z()},O.names=function(){var a,i=[];for(a in u)u.hasOwnProperty(a)&&(s[a]||s[c[a]])&&u[a]&&i.push(u[a]);return i.sort()},O.Zone=b,O.unpack=p,O.unpackBase60=t,O.needsOffset=B,O.moveInvalidForward=!0,O.moveAmbiguousForward=!1,O.countries=function(){return Object.keys(A)},O.zonesForCountry=function(a,i){var e;return e=(e=a).toUpperCase(),(a=A[e]||null)?(e=a.zones.sort(),i?e.map(function(a){return{name:a,offset:S(a).utcOffset(new Date)}}):e):null};var G,a=o.fn;function y(a){return function(){return this._z?this._z.abbr(this):a.call(this)}}function D(a){return function(){return this._z=null,a.apply(this,arguments)}}o.tz=O,o.defaultZone=null,o.updateOffset=function(a,i){var e,r=o.defaultZone;void 0===a._z&&(r&&B(a)&&!a._isUTC&&a.isValid()&&(a._d=o.utc(a._a)._d,a.utc().add(r.parse(a),"minutes")),a._z=r),a._z&&(r=a._z.utcOffset(a),Math.abs(r)<16&&(r/=60),void 0!==a.utcOffset?(e=a._z,a.utcOffset(-r,i),a._z=e):a.zone(r,i))},a.tz=function(a,i){if(a){if("string"!=typeof a)throw new Error("Time zone name must be a string, got "+a+" ["+typeof a+"]");return this._z=S(a),this._z?o.updateOffset(this,i):N("Moment Timezone has no data for "+a+". See http://momentjs.com/timezone/docs/#/data-loading/."),this}if(this._z)return this._z.name},a.zoneName=y(a.zoneName),a.zoneAbbr=y(a.zoneAbbr),a.utc=D(a.utc),a.local=D(a.local),a.utcOffset=(G=a.utcOffset,function(){return 0<arguments.length&&(this._z=null),G.apply(this,arguments)}),o.tz.setDefault=function(a){return(e<2||2==e&&r<9)&&N("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js "+o.version+"."),o.defaultZone=a?S(a):null,o};a=o.momentProperties;return"[object Array]"===Object.prototype.toString.call(a)?(a.push("_z"),a.push("_a")):a&&(a._z=null),k({version:"2024a",zones:["Africa/Abidjan|GMT|0|0||48e5","Africa/Nairobi|EAT|-30|0||47e5","Africa/Algiers|CET|-10|0||26e5","Africa/Lagos|WAT|-10|0||17e6","Africa/Maputo|CAT|-20|0||26e5","Africa/Cairo|EET EEST|-20 -30|01010|1M2m0 gL0 e10 mn0|15e6","Africa/Casablanca|+00 +01|0 -10|010101010101010101010101010101010101|1H3C0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0|32e5","Europe/Paris|CET CEST|-10 -20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|11e6","Africa/Johannesburg|SAST|-20|0||84e5","Africa/Juba|EAT CAT|-30 -20|01|24nx0|","Africa/Khartoum|EAT CAT|-30 -20|01|1Usl0|51e5","Africa/Sao_Tome|GMT WAT|0 -10|010|1UQN0 2q00|","Africa/Tripoli|EET CET CEST|-20 -10 -20|0120|1IlA0 TA0 1o00|11e5","Africa/Windhoek|CAT WAT|-20 -10|0101010101010|1GQo0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|HST HDT|a0 90|01010101010101010101010|1GIc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|326","America/Anchorage|AKST AKDT|90 80|01010101010101010101010|1GIb0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|30e4","America/Santo_Domingo|AST|40|0||29e5","America/Araguaina|-03 -02|30 20|010|1IdD0 Lz0|14e4","America/Fortaleza|-03|30|0||34e5","America/Asuncion|-03 -04|30 40|01010101010101010101010|1GTf0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0|28e5","America/Panama|EST|50|0||15e5","America/Mexico_City|CST CDT|60 50|01010101010101010101010|1GQw0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6","America/Bahia|-02 -03|20 30|01|1GCq0|27e5","America/Managua|CST|60|0||22e5","America/La_Paz|-04|40|0||19e5","America/Lima|-05|50|0||11e6","America/Denver|MST MDT|70 60|01010101010101010101010|1GI90 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|26e5","America/Campo_Grande|-03 -04|30 40|0101010101010101|1GCr0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|CST CDT EST|60 50 50|01010102|1GQw0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|-0430 -04|4u 40|01|1QMT0|29e5","America/Chicago|CST CDT|60 50|01010101010101010101010|1GI80 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|92e5","America/Chihuahua|MST MDT CST|70 60 60|01010101010101010101012|1GQx0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4","America/Ciudad_Juarez|MST MDT CST|70 60 60|010101010101010101010120|1GI90 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0|","America/Phoenix|MST|70|0||42e5","America/Whitehorse|PST PDT MST|80 70 70|0101010101010101012|1GIa0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/New_York|EST EDT|50 40|01010101010101010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|21e6","America/Rio_Branco|-04 -05|40 50|01|1KLE0|31e4","America/Los_Angeles|PST PDT|80 70|01010101010101010101010|1GIa0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|15e6","America/Fort_Nelson|PST PDT MST|80 70 70|01010102|1GIa0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Halifax|AST ADT|40 30|01010101010101010101010|1GI60 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|39e4","America/Godthab|-03 -02|30 20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|17e3","America/Grand_Turk|EST EDT AST|50 40 40|010101021010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|37e2","America/Havana|CST CDT|50 40|01010101010101010101010|1GQt0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0|21e5","America/Mazatlan|MST MDT|70 60|01010101010101010101010|1GQx0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4","America/Metlakatla|PST AKST AKDT|80 90 80|01212120121212121|1PAa0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|14e2","America/Miquelon|-03 -02|30 20|01010101010101010101010|1GI50 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|61e2","America/Montevideo|-02 -03|20 30|01010101|1GI40 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Noronha|-02|20|0||30e2","America/Ojinaga|MST MDT CST|70 60 60|01010101010101010101012|1GI90 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0|23e3","America/Port-au-Prince|EST EDT|50 40|010101010101010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|23e5","Antarctica/Palmer|-03 -04|30 40|010101010|1H3D0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","America/Santiago|-03 -04|30 40|010101010101010101010|1H3D0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0|62e5","America/Sao_Paulo|-02 -03|20 30|0101010101010101|1GCq0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","Atlantic/Azores|-01 +00|10 0|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e4","America/St_Johns|NST NDT|3u 2u|01010101010101010101010|1GI5u 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|11e4","Antarctica/Casey|+11 +08|-b0 -80|0101010101010|1GAF0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1|10","Antarctica/Davis|+05 +07|-50 -70|01|1GAI0|70","Pacific/Port_Moresby|+10|-a0|0||25e4","Australia/Sydney|AEDT AEST|-b0 -a0|01010101010101010101010|1GQg0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5","Asia/Tashkent|+05|-50|0||23e5","Pacific/Auckland|NZDT NZST|-d0 -c0|01010101010101010101010|1GQe0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5","Asia/Baghdad|+03|-30|0||66e5","Antarctica/Troll|+00 +02|0 -20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|40","Asia/Bangkok|+07|-70|0||15e6","Asia/Dhaka|+06|-60|0||16e6","Asia/Amman|EET EEST +03|-20 -30 -30|010101010101010101012|1GPy0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5","Asia/Kamchatka|+12|-c0|0||18e4","Asia/Baku|+04 +05|-40 -50|010101010|1GNA0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Barnaul|+07 +06|-70 -60|010|1N7v0 3rd0|","Asia/Beirut|EET EEST|-20 -30|01010101010101010101010|1GNy0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|22e5","Asia/Kuala_Lumpur|+08|-80|0||71e5","Asia/Kolkata|IST|-5u|0||15e6","Asia/Chita|+10 +08 +09|-a0 -80 -90|012|1N7s0 3re0|33e4","Asia/Ulaanbaatar|+08 +09|-80 -90|01010|1O8G0 1cJ0 1cP0 1cJ0|12e5","Asia/Shanghai|CST|-80|0||23e6","Asia/Colombo|+0530|-5u|0||22e5","Asia/Damascus|EET EEST +03|-20 -30 -30|01010101010101010101012|1GPy0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5","Asia/Dili|+09|-90|0||19e4","Asia/Dubai|+04|-40|0||39e5","Asia/Famagusta|EET EEST +03|-20 -30 -30|0101010101201010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|","Asia/Gaza|EET EEST|-20 -30|01010101010101010101010|1GPy0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0|18e5","Asia/Hong_Kong|HKT|-80|0||73e5","Asia/Hovd|+07 +08|-70 -80|01010|1O8H0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|+09 +08|-90 -80|01|1N7t0|60e4","Europe/Istanbul|EET EEST +03|-20 -30 -30|01010101012|1GNB0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|WIB|-70|0||31e6","Asia/Jayapura|WIT|-90|0||26e4","Asia/Jerusalem|IST IDT|-20 -30|01010101010101010101010|1GPA0 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0|81e4","Asia/Kabul|+0430|-4u|0||46e5","Asia/Karachi|PKT|-50|0||24e6","Asia/Kathmandu|+0545|-5J|0||12e5","Asia/Yakutsk|+10 +09|-a0 -90|01|1N7s0|28e4","Asia/Krasnoyarsk|+08 +07|-80 -70|01|1N7u0|10e5","Asia/Magadan|+12 +10 +11|-c0 -a0 -b0|012|1N7q0 3Cq0|95e3","Asia/Makassar|WITA|-80|0||15e5","Asia/Manila|PST|-80|0||24e6","Europe/Athens|EET EEST|-20 -30|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|35e5","Asia/Novosibirsk|+07 +06|-70 -60|010|1N7v0 4eN0|15e5","Asia/Omsk|+07 +06|-70 -60|01|1N7v0|12e5","Asia/Pyongyang|KST KST|-90 -8u|010|1P4D0 6BA0|29e5","Asia/Qyzylorda|+06 +05|-60 -50|01|1Xei0|73e4","Asia/Rangoon|+0630|-6u|0||48e5","Asia/Sakhalin|+11 +10|-b0 -a0|010|1N7r0 3rd0|58e4","Asia/Seoul|KST|-90|0||23e6","Asia/Srednekolymsk|+12 +11|-c0 -b0|01|1N7q0|35e2","Asia/Tehran|+0330 +0430|-3u -4u|01010101010101010101010|1GLUu 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6","Asia/Tokyo|JST|-90|0||38e6","Asia/Tomsk|+07 +06|-70 -60|010|1N7v0 3Qp0|10e5","Asia/Vladivostok|+11 +10|-b0 -a0|01|1N7r0|60e4","Asia/Yekaterinburg|+06 +05|-60 -50|01|1N7w0|14e5","Europe/Lisbon|WET WEST|0 -10|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|27e5","Atlantic/Cape_Verde|-01|10|0||50e4","Australia/Adelaide|ACDT ACST|-au -9u|01010101010101010101010|1GQgu 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST|-a0|0||20e5","Australia/Darwin|ACST|-9u|0||12e4","Australia/Eucla|+0845|-8J|0||368","Australia/Lord_Howe|+11 +1030|-b0 -au|01010101010101010101010|1GQf0 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347","Australia/Perth|AWST|-80|0||18e5","Pacific/Easter|-05 -06|50 60|010101010101010101010|1H3D0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0|30e2","Europe/Dublin|GMT IST|0 -10|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|12e5","Etc/GMT-1|+01|-10|0||","Pacific/Guadalcanal|+11|-b0|0||11e4","Pacific/Fakaofo|+13|-d0|0||483","Pacific/Kiritimati|+14|-e0|0||51e2","Etc/GMT-2|+02|-20|0||","Pacific/Tahiti|-10|a0|0||18e4","Pacific/Niue|-11|b0|0||12e2","Etc/GMT+12|-12|c0|0||","Pacific/Galapagos|-06|60|0||25e3","Etc/GMT+7|-07|70|0||","Pacific/Pitcairn|-08|80|0||56","Pacific/Gambier|-09|90|0||125","Etc/UTC|UTC|0|0||","Europe/Ulyanovsk|+04 +03|-40 -30|010|1N7y0 3rd0|13e5","Europe/London|GMT BST|0 -10|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|10e6","Europe/Chisinau|EET EEST|-20 -30|01010101010101010101010|1GNA0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|67e4","Europe/Kaliningrad|+03 EET|-30 -20|01|1N7z0|44e4","Europe/Moscow|MSK MSK|-40 -30|01|1N7y0|16e6","Europe/Saratov|+04 +03|-40 -30|010|1N7y0 5810|","Europe/Simferopol|EET EEST MSK MSK|-20 -30 -40 -30|0101023|1GNB0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Volgograd|MSK MSK +04|-40 -30 -40|0121|1N7y0 9Jd0 5gn0|10e5","Pacific/Honolulu|HST|a0|0||37e4","MET|MET MEST|-10 -20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|","Pacific/Chatham|+1345 +1245|-dJ -cJ|01010101010101010101010|1GQe0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|+14 +13|-e0 -d0|01010101010101010101|1GQe0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|+10 +11|-a0 -b0|01|1NwE0|18e4","Pacific/Fiji|+13 +12|-d0 -c0|01010101010101010101|1Goe0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4","Pacific/Guam|ChST|-a0|0||17e4","Pacific/Marquesas|-0930|9u|0||86e2","Pacific/Pago_Pago|SST|b0|0||37e2","Pacific/Norfolk|+1130 +11 +12|-bu -b0 -c0|012121212|1PoCu 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Tongatapu|+13 +14|-d0 -e0|010|1S4d0 s00|75e3"],links:["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Bissau","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Monrovia","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|America/Danmarkshavn","Africa/Abidjan|Atlantic/Reykjavik","Africa/Abidjan|Atlantic/St_Helena","Africa/Abidjan|Etc/GMT","Africa/Abidjan|Etc/GMT+0","Africa/Abidjan|Etc/GMT-0","Africa/Abidjan|Etc/GMT0","Africa/Abidjan|Etc/Greenwich","Africa/Abidjan|GMT","Africa/Abidjan|GMT+0","Africa/Abidjan|GMT-0","Africa/Abidjan|GMT0","Africa/Abidjan|Greenwich","Africa/Abidjan|Iceland","Africa/Algiers|Africa/Tunis","Africa/Cairo|Egypt","Africa/Casablanca|Africa/El_Aaiun","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Ndjamena","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|America/Juneau","America/Anchorage|America/Nome","America/Anchorage|America/Sitka","America/Anchorage|America/Yakutat","America/Anchorage|US/Alaska","America/Campo_Grande|America/Cuiaba","America/Chicago|America/Indiana/Knox","America/Chicago|America/Indiana/Tell_City","America/Chicago|America/Knox_IN","America/Chicago|America/Matamoros","America/Chicago|America/Menominee","America/Chicago|America/North_Dakota/Beulah","America/Chicago|America/North_Dakota/Center","America/Chicago|America/North_Dakota/New_Salem","America/Chicago|America/Rainy_River","America/Chicago|America/Rankin_Inlet","America/Chicago|America/Resolute","America/Chicago|America/Winnipeg","America/Chicago|CST6CDT","America/Chicago|Canada/Central","America/Chicago|US/Central","America/Chicago|US/Indiana-Starke","America/Denver|America/Boise","America/Denver|America/Cambridge_Bay","America/Denver|America/Edmonton","America/Denver|America/Inuvik","America/Denver|America/Shiprock","America/Denver|America/Yellowknife","America/Denver|Canada/Mountain","America/Denver|MST7MDT","America/Denver|Navajo","America/Denver|US/Mountain","America/Fortaleza|America/Argentina/Buenos_Aires","America/Fortaleza|America/Argentina/Catamarca","America/Fortaleza|America/Argentina/ComodRivadavia","America/Fortaleza|America/Argentina/Cordoba","America/Fortaleza|America/Argentina/Jujuy","America/Fortaleza|America/Argentina/La_Rioja","America/Fortaleza|America/Argentina/Mendoza","America/Fortaleza|America/Argentina/Rio_Gallegos","America/Fortaleza|America/Argentina/Salta","America/Fortaleza|America/Argentina/San_Juan","America/Fortaleza|America/Argentina/San_Luis","America/Fortaleza|America/Argentina/Tucuman","America/Fortaleza|America/Argentina/Ushuaia","America/Fortaleza|America/Belem","America/Fortaleza|America/Buenos_Aires","America/Fortaleza|America/Catamarca","America/Fortaleza|America/Cayenne","America/Fortaleza|America/Cordoba","America/Fortaleza|America/Jujuy","America/Fortaleza|America/Maceio","America/Fortaleza|America/Mendoza","America/Fortaleza|America/Paramaribo","America/Fortaleza|America/Recife","America/Fortaleza|America/Rosario","America/Fortaleza|America/Santarem","America/Fortaleza|Antarctica/Rothera","America/Fortaleza|Atlantic/Stanley","America/Fortaleza|Etc/GMT+3","America/Godthab|America/Nuuk","America/Halifax|America/Glace_Bay","America/Halifax|America/Goose_Bay","America/Halifax|America/Moncton","America/Halifax|America/Thule","America/Halifax|Atlantic/Bermuda","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/La_Paz|America/Boa_Vista","America/La_Paz|America/Guyana","America/La_Paz|America/Manaus","America/La_Paz|America/Porto_Velho","America/La_Paz|Brazil/West","America/La_Paz|Etc/GMT+4","America/Lima|America/Bogota","America/Lima|America/Guayaquil","America/Lima|Etc/GMT+5","America/Los_Angeles|America/Ensenada","America/Los_Angeles|America/Santa_Isabel","America/Los_Angeles|America/Tijuana","America/Los_Angeles|America/Vancouver","America/Los_Angeles|Canada/Pacific","America/Los_Angeles|Mexico/BajaNorte","America/Los_Angeles|PST8PDT","America/Los_Angeles|US/Pacific","America/Managua|America/Belize","America/Managua|America/Costa_Rica","America/Managua|America/El_Salvador","America/Managua|America/Guatemala","America/Managua|America/Regina","America/Managua|America/Swift_Current","America/Managua|America/Tegucigalpa","America/Managua|Canada/Saskatchewan","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|America/Bahia_Banderas","America/Mexico_City|America/Merida","America/Mexico_City|America/Monterrey","America/Mexico_City|Mexico/General","America/New_York|America/Detroit","America/New_York|America/Fort_Wayne","America/New_York|America/Indiana/Indianapolis","America/New_York|America/Indiana/Marengo","America/New_York|America/Indiana/Petersburg","America/New_York|America/Indiana/Vevay","America/New_York|America/Indiana/Vincennes","America/New_York|America/Indiana/Winamac","America/New_York|America/Indianapolis","America/New_York|America/Iqaluit","America/New_York|America/Kentucky/Louisville","America/New_York|America/Kentucky/Monticello","America/New_York|America/Louisville","America/New_York|America/Montreal","America/New_York|America/Nassau","America/New_York|America/Nipigon","America/New_York|America/Pangnirtung","America/New_York|America/Thunder_Bay","America/New_York|America/Toronto","America/New_York|Canada/Eastern","America/New_York|EST5EDT","America/New_York|US/East-Indiana","America/New_York|US/Eastern","America/New_York|US/Michigan","America/Noronha|Atlantic/South_Georgia","America/Noronha|Brazil/DeNoronha","America/Noronha|Etc/GMT+2","America/Panama|America/Atikokan","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Panama|America/Jamaica","America/Panama|EST","America/Panama|Jamaica","America/Phoenix|America/Creston","America/Phoenix|America/Dawson_Creek","America/Phoenix|America/Hermosillo","America/Phoenix|MST","America/Phoenix|US/Arizona","America/Rio_Branco|America/Eirunepe","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Santo_Domingo|America/Anguilla","America/Santo_Domingo|America/Antigua","America/Santo_Domingo|America/Aruba","America/Santo_Domingo|America/Barbados","America/Santo_Domingo|America/Blanc-Sablon","America/Santo_Domingo|America/Curacao","America/Santo_Domingo|America/Dominica","America/Santo_Domingo|America/Grenada","America/Santo_Domingo|America/Guadeloupe","America/Santo_Domingo|America/Kralendijk","America/Santo_Domingo|America/Lower_Princes","America/Santo_Domingo|America/Marigot","America/Santo_Domingo|America/Martinique","America/Santo_Domingo|America/Montserrat","America/Santo_Domingo|America/Port_of_Spain","America/Santo_Domingo|America/Puerto_Rico","America/Santo_Domingo|America/St_Barthelemy","America/Santo_Domingo|America/St_Kitts","America/Santo_Domingo|America/St_Lucia","America/Santo_Domingo|America/St_Thomas","America/Santo_Domingo|America/St_Vincent","America/Santo_Domingo|America/Tortola","America/Santo_Domingo|America/Virgin","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Whitehorse|America/Dawson","America/Whitehorse|Canada/Yukon","Antarctica/Palmer|America/Punta_Arenas","Asia/Baghdad|Antarctica/Syowa","Asia/Baghdad|Asia/Aden","Asia/Baghdad|Asia/Bahrain","Asia/Baghdad|Asia/Kuwait","Asia/Baghdad|Asia/Qatar","Asia/Baghdad|Asia/Riyadh","Asia/Baghdad|Etc/GMT-3","Asia/Baghdad|Europe/Minsk","Asia/Bangkok|Antarctica/Vostok","Asia/Bangkok|Asia/Ho_Chi_Minh","Asia/Bangkok|Asia/Novokuznetsk","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Saigon","Asia/Bangkok|Asia/Vientiane","Asia/Bangkok|Etc/GMT-7","Asia/Bangkok|Indian/Christmas","Asia/Dhaka|Asia/Almaty","Asia/Dhaka|Asia/Bishkek","Asia/Dhaka|Asia/Dacca","Asia/Dhaka|Asia/Kashgar","Asia/Dhaka|Asia/Qostanay","Asia/Dhaka|Asia/Thimbu","Asia/Dhaka|Asia/Thimphu","Asia/Dhaka|Asia/Urumqi","Asia/Dhaka|Etc/GMT-6","Asia/Dhaka|Indian/Chagos","Asia/Dili|Etc/GMT-9","Asia/Dili|Pacific/Palau","Asia/Dubai|Asia/Muscat","Asia/Dubai|Asia/Tbilisi","Asia/Dubai|Asia/Yerevan","Asia/Dubai|Etc/GMT-4","Asia/Dubai|Europe/Samara","Asia/Dubai|Indian/Mahe","Asia/Dubai|Indian/Mauritius","Asia/Dubai|Indian/Reunion","Asia/Gaza|Asia/Hebron","Asia/Hong_Kong|Hongkong","Asia/Jakarta|Asia/Pontianak","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kamchatka|Asia/Anadyr","Asia/Kamchatka|Etc/GMT-12","Asia/Kamchatka|Kwajalein","Asia/Kamchatka|Pacific/Funafuti","Asia/Kamchatka|Pacific/Kwajalein","Asia/Kamchatka|Pacific/Majuro","Asia/Kamchatka|Pacific/Nauru","Asia/Kamchatka|Pacific/Tarawa","Asia/Kamchatka|Pacific/Wake","Asia/Kamchatka|Pacific/Wallis","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Brunei","Asia/Kuala_Lumpur|Asia/Kuching","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Etc/GMT-8","Asia/Kuala_Lumpur|Singapore","Asia/Makassar|Asia/Ujung_Pandang","Asia/Rangoon|Asia/Yangon","Asia/Rangoon|Indian/Cocos","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|Asia/Macao","Asia/Shanghai|Asia/Macau","Asia/Shanghai|Asia/Taipei","Asia/Shanghai|PRC","Asia/Shanghai|ROC","Asia/Tashkent|Antarctica/Mawson","Asia/Tashkent|Asia/Aqtau","Asia/Tashkent|Asia/Aqtobe","Asia/Tashkent|Asia/Ashgabat","Asia/Tashkent|Asia/Ashkhabad","Asia/Tashkent|Asia/Atyrau","Asia/Tashkent|Asia/Dushanbe","Asia/Tashkent|Asia/Oral","Asia/Tashkent|Asia/Samarkand","Asia/Tashkent|Etc/GMT-5","Asia/Tashkent|Indian/Kerguelen","Asia/Tashkent|Indian/Maldives","Asia/Tehran|Iran","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Choibalsan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Vladivostok|Asia/Ust-Nera","Asia/Yakutsk|Asia/Khandyga","Atlantic/Azores|America/Scoresbysund","Atlantic/Cape_Verde|Etc/GMT+1","Australia/Adelaide|Australia/Broken_Hill","Australia/Adelaide|Australia/South","Australia/Adelaide|Australia/Yancowinna","Australia/Brisbane|Australia/Lindeman","Australia/Brisbane|Australia/Queensland","Australia/Darwin|Australia/North","Australia/Lord_Howe|Australia/LHI","Australia/Perth|Australia/West","Australia/Sydney|Antarctica/Macquarie","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/Currie","Australia/Sydney|Australia/Hobart","Australia/Sydney|Australia/Melbourne","Australia/Sydney|Australia/NSW","Australia/Sydney|Australia/Tasmania","Australia/Sydney|Australia/Victoria","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Athens|Asia/Nicosia","Europe/Athens|EET","Europe/Athens|Europe/Bucharest","Europe/Athens|Europe/Helsinki","Europe/Athens|Europe/Kiev","Europe/Athens|Europe/Kyiv","Europe/Athens|Europe/Mariehamn","Europe/Athens|Europe/Nicosia","Europe/Athens|Europe/Riga","Europe/Athens|Europe/Sofia","Europe/Athens|Europe/Tallinn","Europe/Athens|Europe/Uzhgorod","Europe/Athens|Europe/Vilnius","Europe/Athens|Europe/Zaporozhye","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Atlantic/Canary","Europe/Lisbon|Atlantic/Faeroe","Europe/Lisbon|Atlantic/Faroe","Europe/Lisbon|Atlantic/Madeira","Europe/Lisbon|Portugal","Europe/Lisbon|WET","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|Europe/Kirov","Europe/Moscow|W-SU","Europe/Paris|Africa/Ceuta","Europe/Paris|Arctic/Longyearbyen","Europe/Paris|Atlantic/Jan_Mayen","Europe/Paris|CET","Europe/Paris|Europe/Amsterdam","Europe/Paris|Europe/Andorra","Europe/Paris|Europe/Belgrade","Europe/Paris|Europe/Berlin","Europe/Paris|Europe/Bratislava","Europe/Paris|Europe/Brussels","Europe/Paris|Europe/Budapest","Europe/Paris|Europe/Busingen","Europe/Paris|Europe/Copenhagen","Europe/Paris|Europe/Gibraltar","Europe/Paris|Europe/Ljubljana","Europe/Paris|Europe/Luxembourg","Europe/Paris|Europe/Madrid","Europe/Paris|Europe/Malta","Europe/Paris|Europe/Monaco","Europe/Paris|Europe/Oslo","Europe/Paris|Europe/Podgorica","Europe/Paris|Europe/Prague","Europe/Paris|Europe/Rome","Europe/Paris|Europe/San_Marino","Europe/Paris|Europe/Sarajevo","Europe/Paris|Europe/Skopje","Europe/Paris|Europe/Stockholm","Europe/Paris|Europe/Tirane","Europe/Paris|Europe/Vaduz","Europe/Paris|Europe/Vatican","Europe/Paris|Europe/Vienna","Europe/Paris|Europe/Warsaw","Europe/Paris|Europe/Zagreb","Europe/Paris|Europe/Zurich","Europe/Paris|Poland","Europe/Ulyanovsk|Europe/Astrakhan","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Fakaofo|Etc/GMT-13","Pacific/Fakaofo|Pacific/Enderbury","Pacific/Fakaofo|Pacific/Kanton","Pacific/Galapagos|Etc/GMT+6","Pacific/Gambier|Etc/GMT+9","Pacific/Guadalcanal|Etc/GMT-11","Pacific/Guadalcanal|Pacific/Efate","Pacific/Guadalcanal|Pacific/Kosrae","Pacific/Guadalcanal|Pacific/Noumea","Pacific/Guadalcanal|Pacific/Pohnpei","Pacific/Guadalcanal|Pacific/Ponape","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|HST","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kiritimati|Etc/GMT-14","Pacific/Niue|Etc/GMT+11","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Pitcairn|Etc/GMT+8","Pacific/Port_Moresby|Antarctica/DumontDUrville","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tahiti|Etc/GMT+10","Pacific/Tahiti|Pacific/Rarotonga"],countries:["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Puerto_Rico America/Antigua","AI|America/Puerto_Rico America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Puerto_Rico America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Puerto_Rico America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Kuching Asia/Brunei","BO|America/La_Paz","BQ|America/Puerto_Rico America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Toronto America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston","CC|Asia/Yangon Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Puerto_Rico America/Curacao","CX|Asia/Bangkok Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Berlin Europe/Copenhagen","DM|America/Puerto_Rico America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Puerto_Rico America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Abidjan Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Puerto_Rico America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Africa/Abidjan Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Puerto_Rico America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Puerto_Rico America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Brussels Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Paris Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Puerto_Rico America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Puerto_Rico America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana","MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Brussels Europe/Amsterdam","NO|Europe/Berlin Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Asia/Dubai Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Asia/Dubai Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Berlin Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Berlin Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Puerto_Rico America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Asia/Dubai Indian/Maldives Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Puerto_Rico America/Port_of_Spain","TV|Pacific/Tarawa Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kyiv","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Puerto_Rico America/St_Vincent","VE|America/Caracas","VG|America/Puerto_Rico America/Tortola","VI|America/Puerto_Rico America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Tarawa Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}),!1===o.suppressDeprecationWarnings&&"undefined"!=typeof console&&console.warn&&void 0,o});
(function (app) {
	app.module('qbePortal', ['ui.date', 'ui.bootstrap', 'credit-cards', 'ui.select', 'ngSanitize', 'ipCookie', 'ui.mask', 'ngDialog', 'ActivityMonitor', 'vcRecaptcha']);
	app.module('qbePortal.services', []);

	/** These need to be replaced with existing routes
	 *  when the right ng-app value is updated on the backend templates for qbePortal.routes.vehicle
	 */

	app.module('qbePortal.services.vehicle', ['qbePortal.services']);
	app.module('qbePortal.services.bike', ['qbePortal.services']);
	app.module('qbePortal.services.caravan', ['qbePortal.services']);
	app.module('qbePortal.services.home', ['qbePortal.services']);
	app.module('qbePortal.services.ctp', ['qbePortal.services']);
	app.module('qbePortal.services.payments', ['qbePortal.services']);

	app.module('qbePortal.routes', ['ui.router', 'qbePortal', 'angular-jwt', 'angulartics', 'angulartics.google.analytics']);
	app.module('qbePortal.routes.vehicle', ['qbePortal.routes', 'qbePortal.services.vehicle']);
	app.module('qbePortal.routes.bike', ['qbePortal.routes', 'qbePortal.services.bike']);
	app.module('qbePortal.routes.caravan', ['qbePortal.routes', 'qbePortal.services.caravan', 'rzModule']);
	app.module('qbePortal.routes.home', ['qbePortal.routes', 'qbePortal.services.home', 'rzModule']);
	app.module('qbePortal.routes.ctp', ['qbePortal.routes', 'qbePortal.services.ctp']);
	app.module('qbePortal.routes.payments', ['qbePortal.routes', 'qbePortal.services.payments']);

	app.module('qbePortal.rapidEstimate.vehicle', ['ui.router', 'qbePortal', 'qbePortal.services.vehicle', 'rzModule']);
	app.module('qbePortal.rapidEstimate.bike', ['ui.router', 'qbePortal', 'qbePortal.services.bike', 'rzModule']);
	app.module('qbePortal.rapidEstimate.caravan', ['ui.router', 'qbePortal', 'qbePortal.services.caravan', 'rzModule']);

})(angular);

"use strict";

/**
 * Stores quote data that can be used to:
 *    - Display summary of quote
 *    - Transform data for posting requests
 *    - Transform data for responses
 *
 * @param {UserInputRepository} userInputRepository                        Passed in from services/config.js
 * @param {ServiceResponseRepository} serviceResponseRepository            Passed in from services/config.js
 * @param {Util} Util                                                    Passed in from services/config.js
 * @constructor
 */
function BikeQuoteModel(MODULE_INFO, userInputRepository, serviceResponseRepository, quoteOptions, quoteRequestRepository, Util) {
	var self = this;

	var selectedQuote= quoteOptions.getSelectedQuoteResult() ;
	var selectedQuoteForPayment = quoteOptions.getSelectedQuoteResultForPayment() ;
	/**
	 * Retrieves values from UserInputRepository
	 * @param {String} dotSeperatedFieldPath                    Path to value to retrieve
	 * @return {*}                                                Value from UserInputRepository to return
	 * @private
	 */
	this._getUserInputValueFor = function (dotSeperatedFieldPath) {
		var userInput = userInputRepository.get();
		return Util.findHierarchyStringInObject(userInput, dotSeperatedFieldPath, '.');
	}

	/**
	 * Retrieves values from ServiceResponseRepository
	 * @param {String} dotSeperatedFieldPath                    Path to value to retrieve
	 * @return {*}                                                Value from ServiceResponseRepository to return
	 * @private
	 */
	this._getServiceResponseValueFor = function (serviceName, dotSeperatedFieldPath) {
		return serviceResponseRepository.getLastResponseFrom(serviceName);
	}

	/**
	 *
	 * @returns {boolean}
	 * @private
	 */
	this._ridersHave_threeYears_restrictedSuspendedDisqualifiedCancelled = function () {
		if (this.riders) {
			var ridersLength = this.riders.length,
				atLeastOneRiderHas = false,
				rider;

			for (var i = 0; i < ridersLength; i++) {
				rider = this.riders[i];

				if (rider.threeYears_restrictedSuspendedDisqualifiedCancelled) {
					atLeastOneRiderHas = true;
					break;
				}
			}

			return atLeastOneRiderHas;
		}
	}
	/**
	 *
	 * @returns {boolean}
	 * @private
	 */
	this._ridersHave_threeYears_accidentsClaims = function () {
		if (this.riders) {
			var ridersLength = this.riders.length,
				atLeastOneRiderHas = false,
				rider;

			for (var i = 0; i < ridersLength; i++) {
				rider = this.riders[i];

				if (rider.threeYears_accidentsClaims) {
					atLeastOneRiderHas = true;
					break;
				}
			}

			return atLeastOneRiderHas;
		}
	}
	/**
	 *
	 * @returns {boolean}
	 * @private
	 */
	this._ridersHave_fiveYears_chargedOrConvicted = function () {
		if (this.riders) {

			var ridersLength = this.riders.length,
				atLeastOneRiderHas = false,
				rider;

			for (var i = 0; i < ridersLength; i++) {
				rider = this.riders[i];

				if (rider.fiveYears_chargedOrConvicted) {
					atLeastOneRiderHas = true;
					break;
				}
			}

			return atLeastOneRiderHas;
		}
	}

	this.email = this._getUserInputValueFor('bikeForm.tellUsABitMore.yourEmailAddress')?this._getUserInputValueFor('bikeForm.tellUsABitMore.yourEmailAddress'):this._getUserInputValueFor('email');

	this.bikeForm = this._getUserInputValueFor('bikeForm');

	// rego details
	this.regoDetails = this._getServiceResponseValueFor('regoSearch');

	if ( !!this.regoDetails && !!this.bikeForm && !!this.bikeForm.tellUsYourRegoNumber && !!this.bikeForm.tellUsYourRegoNumber.regoNumber) {
		this.regoDetails.regoNumber = this.bikeForm.tellUsYourRegoNumber.regoNumber;
	}

	if ( !! this.regoDetails &&  this.regoDetails.goodRetailPrice ) {
		this.bikeRetailValue = parseInt( this.regoDetails.goodRetailPrice ) ;
	}

	// cover type
	this.selectedQuote = selectedQuote ;
	this.selectedQuoteForPayment = selectedQuoteForPayment;
	//  this._getServiceResponseValueFor('quickQuote');
	if (selectedQuote ) {
		this.annualCoverType = selectedQuote.getAnnual();
		this.monthlyCoverType = selectedQuote.getMonthly();

		this.quoteResult = this.selectedQuoteForPayment ; // selectedQuote.getQuoteResult();
		if ( this.quoteResult ) {
			this.coverageOptions = this.quoteResult.coverageOptions ;
			if ( this.coverageOptions ) {
				this.coverageOptionsToShow = this.coverageOptions.filter(function(op) {
					return op.required === false ;
				});
				this.hasCoverageOptions = this.coverageOptionsToShow.length > 0 ;
			}
			this.excess = this.quoteResult.excess ;
			this.namedRiderExcess = findNamedRiderExcess() ;
		}

		this.motorcycleValue = this.quoteResult.motorcycleValue;
		this.sumInsuredAmount = this.quoteResult.sumInsuredAmount;
		// console.log( ' sum insured ammount is ' , this.sumInsuredAmount ) ;
	}

	/** excess list to be displayed in the quote panel */
	this.displayableExcessList = null;

	this.getDisplayableExcess=function(isCoverSummary) {
		if ( ! this.excess )
			return [] ;

		if ( ! this.displayableExcessList) {
			var filterOut =  ['voluntaryVehicleExcessOptions', 'voluntaryVehicleExcess', 'standardVehicleExcess'] ;
			this.displayableExcessList = [] ;

			for ( var key in this.excess) {
				if ( filterOut.indexOf(key) === -1){
					//dd-6058 - do not display Flexi excess if value is not greater than zero					
					if((key == "flexiExcessExcess" || key == "flexiExcessOptions") && this.excess.flexiExcessExcess <= 0) continue;
					if (key == "flexiExcessExcess") { continue; }
					if (key == "standardExcess") {
						if (isCoverSummary) {
						    var feItemValue = this.excess["flexiExcessExcess"];
							var standardValue = this.excess[key];
							if (!isNaN(feItemValue)) {
								standardValue += feItemValue;
							}
							this.displayableExcessList.push({ key : key, excessValue : standardValue }) ;
						}
						else {
							continue;
						}
					}
					else {
						this.displayableExcessList.push({ key : key, excessValue : this.excess[key] }) ;
					}
										
				}
			}
		}

		return this.displayableExcessList ;
	}

	this.getSelectionExcess=function() {
		if (!this.excess)
			return [] ;
		var options = [-200, -100, 0, 100, 200, 300, 500, 1000, 1500];
		var flexiExcessRange = this.excess.flexiExcessOptions.filter(function(x) {
			return options.indexOf(x) != -1;
		});

		for (var idx = 0; idx < flexiExcessRange.length; idx++) {
			flexiExcessRange[idx] += this.excess.standardExcess;
		}

		return flexiExcessRange;
	}

	function findNamedRiderExcess() {
		var namedRiderExcess = [],
			qr = selectedQuoteForPayment ? selectedQuoteForPayment.response : null ;

		if ( qr && qr.motorcycles) {
			var riders = qr.motorcycles[0].riders ;
			riders.forEach( function(rider) {
				if ( rider.rider
					&& rider.rider.calculatedExcess
					&& rider.rider.calculatedExcess > 0 ) {
					namedRiderExcess.push({
						firstName : rider.rider.person.firstName,
						lastName: rider.rider.person.lastName,
						excessValue : rider.rider.calculatedExcess,
						dob: rider.rider.person.dateOfBirth
					});
				}
			});
		}

		return namedRiderExcess ;
	}

	/**
	* Excluded riders
	*/
	var savedQuoteResult = !!this.quoteResult ? this.quoteResult.response : null;
	if ( savedQuoteResult ) {
		/** excluded rider condition to be correctly diagnosed here */
		// this.excludedRiders = this.quoteResult.excludedRiders ;
		var excludedRiders = [] ;
		savedQuoteResult.motorcycles[0].riders.forEach(function(rider) {
			if ( rider.riderUsage == 'excluded')
				excludedRiders.push(rider.rider.person) ;
		});
		this.excludedRiders = excludedRiders;
	}

	this.hasExcludedRiders = function() {
		return this.excludedRiders && this.excludedRiders.length > 0 ;
	}

	this.riders = [];
	this.postCode = null;
	this.campaignCode = null ;
	if (this.bikeForm) {
		//TODO: set regoNumber based on step 1 or step 4

		// bikeDetails
		if (this.bikeForm.bikeDetails) {
			this.bikeDetails = this.bikeForm.bikeDetails;

			this.bikeDetailsUsage = this.bikeForm.bikeDetails.primaryBikeUse;
			switch (this.bikeDetailsUsage) {
				case 'commercial':
					this.bikeDetailsUsage += ' - ' + this.bikeForm.bikeDetails.commercialActivityType.label;
					break;
				case 'business':
					this.bikeDetailsUsage += ' - ' + this.bikeForm.bikeDetails.businessActivityType.label;
					break;
			}
		}

		if ( this.bikeForm.getStarted ) {
			this.personOrCompany = this.bikeForm.getStarted.personOrCompany;
			this.policyStartDate = this.bikeForm.getStarted.policyStartDate;
		}

		// Main riders & additional riders
		this.additionalRiders = [];

		if (!!this.bikeForm.rider) {
     		var riders=this.bikeForm.rider.riders;
     		if(riders){

				this.mainRider = riders[0];

				if (!!this.bikeForm.mainPolicyHolderContact) {
					this.mainRider.person.phoneNumber = this.bikeForm.mainPolicyHolderContact.primaryPhoneNumber;
				}

      			if(riders.length>1){
         			this.additionalRiders=riders.splice(1,riders.length);
      			}
     		}
		};

		// riders
		if (this.mainRider) {
			this.riders = [this.mainRider];
			this.noClaimBonus = this.mainRider.noClaimBonus ; 
		}
		if (this.additionalRiders) {
			this.riders = this.riders.concat(this.additionalRiders);
		}

		// address
		var aboutYourBike = this.bikeForm.aboutYourBike ;
		if ( aboutYourBike && aboutYourBike.address ) {
			this.address = aboutYourBike.address	;
			this.postCode = this.address.postalCode;
			this.state = this.address.state ;
		}

		if ( this.bikeForm.promotionalCode ) {
			this.campaignCode = this.bikeForm.promotionalCode.promotionalCode ;
		}

	}

	// this.quoteId = this._getServiceResponseValueFor('service-name', 'quote.quoteId');
	this.quoteId = null ;
	if ( quoteRequestRepository.getSelectedQuoteCredentials() )
		this.quoteId = quoteRequestRepository.getSelectedQuoteCredentials().quoteID ;


	/** Google Tag Manager data **/
	this.gtmPolicyHolder = this.mainRider ? this.mainRider.person : null;
	this.gtmTransactionAffiliation = 'QBE Direct' ;
	this.insuranceType =  MODULE_INFO.insuranceType ;
	this.productCode = MODULE_INFO.productCode ;


}

"use strict";

/**
 * Stores quote data that can be used to:
 *    - Display summary of quote
 *    - Transform data for posting requests
 *    - Transform data for responses
 *
 * @param {UserInputRepository} userInputRepository                        Passed in from services/config.js
 * @param {ServiceResponseRepository} serviceResponseRepository            Passed in from services/config.js
 * @param {Util} Util                                                    Passed in from services/config.js
 * @constructor
 */
function CaravanQuoteModel(MODULE_INFO, userInputRepository, serviceResponseRepository, quoteOptions, quoteRequestRepository, Util) {
	var self = this;

	var selectedQuote= quoteOptions.getSelectedQuoteResult() ;
	var selectedQuoteForPayment = quoteOptions.getSelectedQuoteResultForPayment() ;
	// cover type
	this.selectedQuote = selectedQuote;
	this.selectedQuoteForPayment = selectedQuoteForPayment;
	/**
	 * Retrieves values from UserInputRepository
	 * @param {String} dotSeperatedFieldPath                    Path to value to retrieve
	 * @return {*}                                                Value from UserInputRepository to return
	 * @private
	 */
	this._getUserInputValueFor = function (dotSeperatedFieldPath) {
		var userInput = userInputRepository.get();
		return Util.findHierarchyStringInObject(userInput, dotSeperatedFieldPath, '.');
	}

	/**
	 * Retrieves values from ServiceResponseRepository
	 * @param {String} dotSeperatedFieldPath                    Path to value to retrieve
	 * @return {*}                                                Value from ServiceResponseRepository to return
	 * @private
	 */
	this._getServiceResponseValueFor = function (serviceName, dotSeperatedFieldPath) {
		return serviceResponseRepository.getLastResponseFrom(serviceName);
	}

	/**
	 * Calculates whether at least one driver in the last 4 years, has been charged or convicted of any driving offences
	 * @returns {boolean}
	 * @private
	 */
	this._driversHave_fourYears_licenceRSDC = function () {
		if (this.drivers) {
			var driversLength = this.drivers.length,
				atLeastOneDriverHas = false,
				driver;

			for (var i = 0; i < driversLength; i++) {
				driver = this.drivers[i];

				if (driver.fourYears_licenceRSDC) {
					atLeastOneDriverHas = true;
					break;
				}
			}

			return atLeastOneDriverHas;
		}
	}
	/**
	 *
	 * @returns {boolean}
	 * @private
	 */
	this._driversHave_fourYears_chargedOrConvictedOffences = function () {
		if (this.drivers) {
			var driversLength = this.drivers.length,
				atLeastOneDriverHas = false,
				driver;

			for (var i = 0; i < driversLength; i++) {
				driver = this.drivers[i];

				if (driver.fourYears_chargedOrConvictedOffences) {
					atLeastOneDriverHas = true;
					break;
				}
			}

			return atLeastOneDriverHas;
		}
	}
	/**
	 *
	 * @returns {boolean}
	 * @private
	 */
	this._driversHave_fourYears_vehicleAccidentsClaims = function () {
		if (this.drivers) {

			var driversLength = this.drivers.length,
				atLeastOneDriverHas = false,
				driver;

			for (var i = 0; i < driversLength; i++) {
				driver = this.drivers[i];

				if (driver.fourYears_vehicleAccidentsClaims) {
					atLeastOneDriverHas = true;
					break;
				}
			}

			return atLeastOneDriverHas;
		}
	}
	/**
	 *
	 * @returns {boolean}
	 * @private
	 */
	this._driversHave_tenYears_chargedOrConvictedOffences = function () {
		if (this.drivers) {

			var driversLength = this.drivers.length,
				atLeastOneDriverHas = false,
				driver;

			for (var i = 0; i < driversLength; i++) {
				driver = this.drivers[i];

				if (driver.tenYears_chargedOrConvictedOffences) {
					atLeastOneDriverHas = true;
					break;
				}
			}

			return atLeastOneDriverHas;
		}
	}

	this.email = this._getUserInputValueFor('caravanForm.tellUsABitMore.yourEmailAddress')?this._getUserInputValueFor('caravanForm.tellUsABitMore.yourEmailAddress'):this._getUserInputValueFor('email');

	// vehicle form data
	this.caravanForm = this._getUserInputValueFor('caravanForm');

	// rego details
	this.regoDetails = this._getServiceResponseValueFor('regoSearch');

	if ( selectedQuoteForPayment ) {
		this.vehicleInfo = selectedQuoteForPayment.response.caravans[0].caravanInfo;
	}

	// vehicle type
	this.vehicleType = this._getUserInputValueFor('caravanForm.aboutYourCaravan.vehicleType');

	// vehicle agreed value
	this.agreedValue = this._getUserInputValueFor('caravanForm.sumInsured.agreedValue');
	this.generalContentsValue = this._getUserInputValueFor('caravanForm.aboutYourContents.generalContentsValue') ;
	this.specifiedContentItems = this._getUserInputValueFor('caravanForm.aboutYourContents.contentsItems') || [] ;
	this.totalSpecifiedContentValue = function(items) {
		var total = 0 ;
		angular.forEach(items, function(item) { total += item.value ; });
		return total ;
	}(this.specifiedContentItems);

	this.totalContentsValue = this.totalSpecifiedContentValue + this.generalContentsValue ;

	this.annexeCost = this._getUserInputValueFor('caravanForm.sumInsured.annexeReplacementCost');
	this.sumInsured = this.agreedValue + this.annexeCost;

	this.contentsSumInsured = 1000; // TODO: Aggregate the contents items + general contents value

	this.purchaseMonth = this._getUserInputValueFor('caravanForm.caravanDetails.whenDidYouBuyMonth');
	this.purchaseYear = this._getUserInputValueFor('caravanForm.caravanDetails.whenDidYouBuyYear');
	this.purchaseDate = this.purchaseMonth + '/' + this.purchaseYear;

	this.isCaravanRegistered = this._getUserInputValueFor('caravanForm.caravanDetails.isCaravanRegistered');

	if ( this.isCaravanRegistered ) {
		this.regoNumber = this._getUserInputValueFor('caravanForm.caravanDetails.regoNumber');
	}

	if ( this.regoDetails ) {
		this.vehicleOptionalEquipments = this.regoDetails.optionalEquipments ;
	}else if(this.caravanForm && this.caravanForm.caravanInfo){
		this.regoDetails = this.caravanForm.caravanInfo;
	}

	this.showLayupDiscount = (this.vehicleType == 'caravan' || this.vehicleType == 'campertrailer' || this.vehicleType == 'slideoncamper' || this.vehicleType == 'motorhome' || this.vehicleType == 'campervan') && this.isCaravanRegistered;

	this.showOnsiteDiscount = (this.vehicleType == 'caravan' || this.vehicleType == 'campertrailer' || this.vehicleType == 'slideoncamper' || this.vehicleType == 'motorhome' || this.vehicleType == 'campervan') && !this.isCaravanRegistered;


	//  this._getServiceResponseValueFor('quickQuote');
	if (selectedQuote ) {
		this.annualCoverType = selectedQuote.getAnnual();
		this.monthlyCoverType = selectedQuote.getMonthly();
		this.quoteResult = selectedQuoteForPayment ;
		if ( this.quoteResult ) {
			this.coverageOptions = this.quoteResult.coverageOptions ;
			if ( this.coverageOptions ) {
				this.coverageOptionsToShow = this.coverageOptions.filter(function(op) {
					return op.required === false && op.name !== 'QPCLayupCover' ;
				});
				this.hasCoverageOptions = this.coverageOptionsToShow.length > 0 ;
			}
			this.excess = this.quoteResult.excess ;
			this.namedDriverExcess = findNamedDriverExcess() ;
			this.excludedDrivers = findExcludedDrivers();
		}
	}

	function findNamedDriverExcess() {
		var namedDriverExcess = [],
			qr = selectedQuoteForPayment ? selectedQuoteForPayment.response : null ;

		if ( qr && qr.caravans ) {
			var drivers = qr.caravans[0].drivers ;
		 	drivers.forEach( function(driver) {
		 		if ( driver.driver
		 			&& driver.driver.calculatedExcess
		 			&& driver.driver.calculatedExcess > 0 ) {
		 				namedDriverExcess.push({
		 					firstName : driver.driver.person.firstName,
		 					lastName: driver.driver.person.lastName,
		 					excessValue : driver.driver.calculatedExcess,
							dob: driver.driver.dateOfBirth
		 				});
		 		}
		 	});
		}

	 	return namedDriverExcess ;
	}

	/**
	* Excluded drivers
	*/
	function findExcludedDrivers() {
		var excludedDrivers = [] ;
		if (selectedQuoteForPayment ) {
			var quote = selectedQuoteForPayment.response ;
			quote.caravans[0].drivers.forEach(function(driver) {
				if ( driver.driverUsage == 'excluded')
					excludedDrivers.push(driver.driver.person) ;
			})	;
		}

		return excludedDrivers
	}

	this.hasExcludedDrivers = function() {
		return this.excludedDrivers && this.excludedDrivers.length > 0 ;
	}

	/** excess list to be displayed in the quote panel */
	this.displayableExcessList = null;

	this.getDisplayableExcess=function() {
		if ( ! this.excess )
			return [] ;

		if ( ! this.displayableExcessList) {
			var filterOut =  ['voluntaryVehicleExcessOptions', 'voluntaryVehicleExcess', 'standardVehicleExcess'] ;
			this.displayableExcessList = [] ;

			for ( var key in this.excess) {
				if ( filterOut.indexOf(key) === -1)
					this.displayableExcessList.push({ key : key, excessValue : this.excess[key] }) ;
			}
		}

		return this.displayableExcessList ;
	}



	this.drivers = [];
	this.postCode = null;
	this.campaignCode = null ;
	if (this.caravanForm) {
		//TODO: set regoNumber based on step 1 or step 4

		// vehicleDetails
		if (this.caravanForm.caravanDetails) {
			this.primaryUse = this.caravanForm.caravanDetails.primaryUse;
			switch (this.primaryUse) {
				case 'commercial':
					this.primaryUse += ' - ' + this.caravanForm.caravanDetails.commercialActivityType.label;
					break;
				case 'business':
					this.primaryUse += ' - ' + this.caravanForm.caravanDetails.businessActivityType.label;
					break;
			}
		}

		if ( this.caravanForm.getStarted) {
			this.personOrCompany = this.caravanForm.getStarted.personOrCompany;
			this.policyStartDate = this.caravanForm.getStarted.policyStartDate;
		}

		// Main drivers & additional drivers
		this.additionalDrivers = [];

		if (this.caravanForm.driver) {
     		var drivers=this.caravanForm.driver.drivers;
     		if(drivers){

				this.mainDriver = drivers[0];

      			if(drivers.length>1){
         			this.additionalDrivers=drivers.splice(1,drivers.length);
      			}
     		}
		}

		// drivers
		if (this.mainDriver) {
			this.drivers = [this.mainDriver];
		}
		if (this.additionalDrivers) {
			this.drivers = this.drivers.concat(this.additionalDrivers);
		}

		// address
		var aboutYourCaravan = this.caravanForm.aboutYourCaravan ;
		if ( aboutYourCaravan) {
			if (aboutYourCaravan.address ) {
				this.address = aboutYourCaravan.address	;
				this.postCode = this.address.postalCode;
				this.state = this.address.state.replace('AU_', '') ;
			}
			this.searchType = aboutYourCaravan.searchType;

			if ( this.searchType == 'manually') {
				var year = aboutYourCaravan.year,
					make = aboutYourCaravan.make,
					model = aboutYourCaravan.model,
					bodyType = aboutYourCaravan.bodyType,
					berths = aboutYourCaravan.berths,
					weight = aboutYourCaravan.weight,
					caravanLength = aboutYourCaravan.manualLength,
					lengthUnits = aboutYourCaravan.manualLengthUnits,
					customBuilt = aboutYourCaravan.customBuilt;

				this.yearMakeModel = year + ', ' + make + ', ' + model+ ', ' + bodyType + ', ' + berths + ', ' + weight + ', ' + caravanLength + lengthUnits;
			} else if (this.regoDetails) {
				var year = this.regoDetails.modelYear,
					make = this.regoDetails.make,
					model = this.regoDetails.model;

				this.yearMakeModel = year + ' ' + make + ' ' + model;
			}
		}

		if ( this.caravanForm.promotionalCode ) {
			this.campaignCode = this.caravanForm.promotionalCode.promotionalCode ;
		}

		if (this.caravanForm.mainPolicyHolderContact) {
			this.mainPolicyHolder = this.caravanForm.mainPolicyHolderContact;
		}

	}


	// this.quoteId = this._getServiceResponseValueFor('service-name', 'quote.quoteId');
	this.quoteId = null ;
	if ( quoteRequestRepository.getSelectedQuoteCredentials() )
		this.quoteId = quoteRequestRepository.getSelectedQuoteCredentials().quoteID ;


	/** Google Tag Manager data **/
	this.gtmPolicyHolder = this.mainDriver ? this.mainDriver.person : null;
	this.gtmTransactionAffiliation = 'QBE Direct' ;
	this.insuranceType =  MODULE_INFO.insuranceType ;
	this.productCode = MODULE_INFO.productCode ;

}

"use strict";

/**
 * Stores quote data that can be used to:
 *    - Display summary of quote
 *    - Transform data for posting requests
 *    - Transform data for responses
 *
 * @param {UserInputRepository} userInputRepository                        Passed in from services/config.js
 * @param {ServiceResponseRepository} serviceResponseRepository            Passed in from services/config.js
 * @param {Util} Util                                                    Passed in from services/config.js
 * @constructor
 */
function CTPModel(MODULE_INFO, userInputRepository, serviceResponseRepository, Util) {
	var self = this;

	/** Google Tag Manager data **/
	this.gtmTransactionAffiliation = 'payments';
}

"use strict";

/**
 * Stores quote data that can be used to:
 *    - Display summary of quote
 *    - Transform data for posting requests
 *    - Transform data for responses
 *
 * @param {UserInputRepository} userInputRepository                        Passed in from services/config.js
 * @param {ServiceResponseRepository} serviceResponseRepository            Passed in from services/config.js
 * @param {Util} Util                                                    Passed in from services/config.js
 * @constructor
 */
function HomeQuoteModel(
	MODULE_INFO,
	userInputRepository,
	serviceResponseRepository,
	quoteOptions,
	quoteRequestRepository,
	Util,
	$rootScope
) {
	var self = this;

	var selectedQuote = quoteOptions.getSelectedQuoteResult();
	var selectedQuoteForPayment = quoteOptions.getSelectedQuoteResultForPayment();
	var selectedOffering = quoteOptions.getSelectedOffering();

	self.rootScope = $rootScope;

	self.maxSumInsured = 2000000;
	//value will come from quickQuote
	self.minSumInsured = 0;

	/**
	 * Retrieves values from UserInputRepository
	 * @param {String} dotSeperatedFieldPath                    Path to value to retrieve
	 * @return {*}                                                Value from UserInputRepository to return
	 * @private
	 */
	this._getUserInputValueFor = function(dotSeperatedFieldPath) {
		var userInput = userInputRepository.get();
		return Util.findHierarchyStringInObject(
			userInput,
			dotSeperatedFieldPath,
			"."
		);
	};

	/**
	 * Retrieves values from ServiceResponseRepository
	 * @param {String} dotSeperatedFieldPath                    Path to value to retrieve
	 * @return {*}                                                Value from ServiceResponseRepository to return
	 * @private
	 */
	this._getServiceResponseValueFor = function(
		serviceName,
		dotSeperatedFieldPath
	) {
		return serviceResponseRepository.getLastResponseFrom(serviceName);
	};

	//retunr the home insurance need type : 'building_only'/'contents_only'/'building_and_contents'
	this.getHomeNeedType = function() {
		if (
			this.homeForm &&
			this.homeForm.tellUsHowWeCanInsureYou &&
			this.homeForm.tellUsHowWeCanInsureYou.coverNeeds
		) {
			var building =
				this.homeForm.tellUsHowWeCanInsureYou.coverNeeds.building ==
				true;
			var content =
				this.homeForm.tellUsHowWeCanInsureYou.coverNeeds.contents ==
				true;
		} else {
			return null;
		}

		if (building && content) {
			return "building_and_contents";
		} else if (building && !content) {
			return "building_only";
		} else if (!building && content) {
			return "contents_only";
		} else {
			return null;
		}
	};

	this.getAge = function(dateString) {
		if (dateString) {
			return moment().diff(moment(dateString, "DD/MM/YYYY"), "years");
		} else {
			return 0;
		}
	};

	this.homeHowIsHomeOccupied = function() {
		if (
			this.homeForm &&
			this.homeForm.tellUsAboutTheProperty &&
			this.homeForm.tellUsAboutTheProperty.howIsHomeOccupied
		) {
			return this.homeForm.tellUsAboutTheProperty.howIsHomeOccupied;
		} else {
			return null;
		}
	};

	this.showIsBuiltToCycloneStandards = function(cycloneParams) {
		if (cycloneParams[0] == "19801989") {
			var cycloneRating = isNaN(cycloneParams[1]) ? 0 : cycloneParams[1];
			var address = this._getServiceResponseValueFor("addressSearch");
			if (address && address.enrichment && address.addressLine1) {
				if (address.enrichment.floodRisk.building) {
					var cycloneRiskSeverity = parseInt(
						address.enrichment.cycloneRisk.building
					);
					if (cycloneRiskSeverity >= cycloneRating) {
						return true;
					} else {
						return false;
					}
				} else {
					return true;
				}
			}
		} else {
			return false;
		}
	};

	/*
	 * Returns the list of avialble offerings based on the user selections
	 */
	this.getOfferings = function() {
		// this._getUserInputValueFor('formData.homeForm.tellUsAboutTheProperty.howIsHomeOccupied');
		var homeOccupancy;
		var buildingType;
		var needs;

		if (this.homeForm && this.homeForm.tellUsAboutTheProperty) {
			homeOccupancy = this.homeForm.tellUsAboutTheProperty
				.howIsHomeOccupied;
			buildingType = this.homeForm.tellUsAboutTheProperty.typeOfBuilding;
			needs = this.homeForm.tellUsHowWeCanInsureYou.coverNeeds;
		} else {
			void 0;
		}

		var offerings = _getOfferings(homeOccupancy, buildingType, needs, true);

		return offerings;
	};

	//getOfferings is based on the exisitng portal
	function _getOfferings(
		homeOccupancy,
		buildingType,
		needs,
		needRapidEstimate
	) {
		//logic from exsting portal
		var offerings = [];
		if (
			(homeOccupancy === "own_live" ||
				homeOccupancy === "rent_live" ||
				homeOccupancy === "own_holidayhome") &&
			!(
				buildingType === "unit" ||
				buildingType === "flat" ||
				buildingType === "villa" ||
				buildingType === "townhouse"
			)
		) {
			offerings.push("QPHStandardOffering");
			if (needRapidEstimate) {
				offerings.push("QPHPrestigeOffering");
			}
		} else if (
			(homeOccupancy === "own_live" ||
				homeOccupancy === "rent_live" ||
				homeOccupancy === "own_holidayhome") &&
			(buildingType === "unit" ||
				buildingType === "flat" ||
				buildingType === "villa" ||
				buildingType === "townhouse") &&
			needs.building
		) {
			offerings.push("QPHStandardOffering");
			if (needRapidEstimate) {
				offerings.push("QPHPrestigeOffering");
			}
		} else if (
			(homeOccupancy === "own_live" ||
				homeOccupancy === "rent_live" ||
				homeOccupancy === "own_holidayhome") &&
			(buildingType === "unit" ||
				buildingType === "flat" ||
				buildingType === "villa" ||
				buildingType === "townhouse") &&
			needs.contents
		) {
			offerings.push("QPHStrataContentsOffering");
			if (needRapidEstimate) {
				offerings.push("QPHPrestigeOffering");
			}
		} else if (
			homeOccupancy === "own_rent_tenants" ||
			homeOccupancy === "own_rent_tenants_causalbasis" ||
			homeOccupancy === "property_used_hostel_or_guest"
		) {
			offerings.push("QPHLandlordOffering");
		}
		return offerings;
	}

	this.getSelectedOffering = function() {
		return selectedOffering;
	};

	this.address = {};

	this.getCycleData = function() {
		if (this.homeForm && this.homeForm.cycleCover) {
			return this.homeForm.cycleCover;
		}
		return null;
	};

	this.isByCompany = function() {
		if (this.homeForm && this.homeForm.letsGetStarted) {
			return this.homeForm.letsGetStarted.personOrCompany == "company";
		}

		return false;
	};

	this.getinsuranceHistoryYear = function(insuranceHeldFor) {
		var insuranceHeldForMapping = {
			noPreviousInsurance: "0",
			lessThan1year: "1",
			oneYear: "1",
			twoYears: "2",
			threeYears: "3",
			fourOrMoreYears: "4"
		};
		if (insuranceHeldForMapping[insuranceHeldFor]) {
			return insuranceHeldForMapping[insuranceHeldFor];
		} else {
			return "1";
		}
	};

	this.isRapidEstimatePanelVisible = function() {
		var address = this._getServiceResponseValueFor("addressSearch");
		var display = false;
		if (address && address.enrichment && address.addressLine1) {
			//address is available
			if (isLowRisk(address.enrichment)) {
				display = true;
			} else {
				// console.log('--------------------------- no rapid estimate based on enrichment');
				display = false;
			}
		}
		return display;
	};

	this.isBuildingFloodSafe = function() {
		var address = this._getServiceResponseValueFor("addressSearch");
		if (address && address.enrichment && address.addressLine1) {
			if (address.enrichment.floodRisk.building) {
				var floodRiskSeverity = parseInt(
					address.enrichment.floodRisk.building
				);
				if (floodRiskSeverity > 1) {
					return false;
				} else {
					//safe for 0 and 1
					return true;
				}
			} else {
				return false;
			}
		}
	};

	this.isInFloodZone = function() {
		var address = this._getServiceResponseValueFor("addressSearch");
		if (address && address.enrichment && address.addressLine1) {
			var risk = address.enrichment;
			//check flood risk
			var floodRiskSeverity = Math.max(
				parseInt(risk.floodRisk.building),
				parseInt(risk.floodRisk.content)
			);
			// var floodZoneAccuracy = risk.floodRisk.building.substr(2);
			if (floodRiskSeverity > 1) {
				return true;
			}
		}
		return false;
	};

	this.isSumInsuredInLowerRange = function(sumInsured) {
		return (
			sumInsured <= self.minSumInsured * 1.75 &&
			sumInsured >= self.minSumInsured
		);
	};

	this.isSumInsuredInUpperRange = function(sumInsured) {
		return sumInsured > this.cordelInfo.upperBand;
	};

	function isLowRisk(risk) {
		//check cyclone risk
		var cycloneRiskSeverity = Math.max(
			parseInt(risk.cycloneRisk.building),
			parseInt(risk.cycloneRisk.content)
		);
		if (cycloneRiskSeverity > 1) {
			return false;
		}

		//check flood risk
		var floodRiskSeverity = Math.max(
			parseInt(risk.floodRisk.building),
			parseInt(risk.floodRisk.content)
		);
		if (floodRiskSeverity > 59) {
			return false;
		}

		var floodZoneAccuracy = risk.floodRisk.building.substr(2);
		if (floodZoneAccuracy == "A" || floodZoneAccuracy == "B") {
			//is in zone
		} else {
			return false;
		}

		//check fire risk
		var fireRiskSeverity = Math.max(
			parseInt(risk.fireRisk.building),
			parseInt(risk.fireRisk.content)
		);
		if (fireRiskSeverity > 59) {
			return false;
		}

		var fireZoneAccuracy = risk.fireRisk.building.substr(2);
		if (fireZoneAccuracy == "A" || fireZoneAccuracy == "B") {
			//is in zone
		} else {
			return false;
		}

		return true;
	}

	this.email = this._getUserInputValueFor(
		"homeForm.tellUsABitMore.yourEmailAddress"
	)
		? this._getUserInputValueFor("homeForm.tellUsABitMore.yourEmailAddress")
		: this._getUserInputValueFor("email");

	// home form data
	this.homeForm = this._getUserInputValueFor("homeForm");

	// cover type
	this.selectedQuote = selectedQuote;
	this.selectedQuoteForPayment = selectedQuoteForPayment;
	this.dwelling = null;
	//  this._getServiceResponseValueFor('quickQuote');
	if (selectedQuote) {
		this.annualCoverType = selectedQuote.getAnnual();
		this.monthlyCoverType = selectedQuote.getMonthly();
		// this.fortnightlyCoverType = selectedQuote.getMonthly();

		this.quoteResult = this.selectedQuoteForPayment; // selectedQuote.getQuoteResult();
		if (this.quoteResult) {
			this.cordelInfo = this.quoteResult.cordelInfo;
			self.minSumInsured = Math.round(this.cordelInfo.lowerBand * 0.75);

			this.excess = this.quoteResult.excess;
			this.dwelling = this.quoteResult;
			this.offering = this.quoteResult.offering;
		}
	}

	this.postCode = null;
	this.campaignCode = null;

	if (this.homeForm) {
		// address
		var aboutYourHome = this.homeForm.tellUsAboutTheProperty;
		if (aboutYourHome && aboutYourHome.address) {
			this.address = aboutYourHome.address;
			this.postCode = this.address.postalCode;
			this.state = this.address.state;
		}

		if (this.homeForm.promotionalCode) {
			this.campaignCode = this.homeForm.promotionalCode.promotionalCode;
		}

		if (this.homeForm.letsGetStarted) {
			this.policyContactType = this.homeForm.letsGetStarted.personOrCompany;
			this.policyStartDate = this.homeForm.letsGetStarted.startCoverDate;

			if (
				this.policyContactType == "person" &&
				this.homeForm.mainPolicyHolder
			)
				this.policyContact = this.homeForm.mainPolicyHolder;
			else if (
				this.policyContactType == "contact" &&
				this.homeForm.aboutCompanyContact
			)
				this.policyContact = this.this.homeForm.aboutCompanyContact;
		}
	}

	// this.quoteId = this._getServiceResponseValueFor('service-name', 'quote.quoteId');
	this.quoteId = null;
	if (quoteRequestRepository.getSelectedQuoteCredentials())
		this.quoteId = quoteRequestRepository.getSelectedQuoteCredentials().quoteID;

	/** Google Tag Manager data **/
	this.gtmPolicyHolder = this.policyContact;
	this.gtmTransactionAffiliation = "QBE Direct";
	this.insuranceType = MODULE_INFO.insuranceType;
	this.productCode = MODULE_INFO.productCode;
}

"use strict";

/**
 * Stores quote data that can be used to:
 *    - Display summary of quote
 *    - Transform data for posting requests
 *    - Transform data for responses
 *
 * @param {UserInputRepository} userInputRepository                        Passed in from services/config.js
 * @param {ServiceResponseRepository} serviceResponseRepository            Passed in from services/config.js
 * @param {Util} Util                                                    Passed in from services/config.js
 * @constructor
 */
function PaymentsQuoteModel(MODULE_INFO, userInputRepository, serviceResponseRepository, Util) {
	var self = this;
	
	/** Google Tag Manager data **/	
	this.gtmTransactionAffiliation = 'payments' ;
}

"use strict";

/**
 * Stores quote data that can be used to:
 *    - Display summary of quote
 *    - Transform data for posting requests
 *    - Transform data for responses
 *
 * @param {UserInputRepository} userInputRepository                        Passed in from services/config.js
 * @param {ServiceResponseRepository} serviceResponseRepository            Passed in from services/config.js
 * @param {Util} Util                                                    Passed in from services/config.js
 * @constructor
 */
function QuoteModel(MODULE_INFO, userInputRepository, serviceResponseRepository, quoteOptions, quoteRequestRepository, Util) {
	var self = this;

	var selectedQuote = quoteOptions.getSelectedQuoteResult();
	var selectedQuoteForPayment = quoteOptions.getSelectedQuoteResultForPayment();
	/**
	 * Retrieves values from UserInputRepository
	 * @param {String} dotSeperatedFieldPath                    Path to value to retrieve
	 * @return {*}                                                Value from UserInputRepository to return
	 * @private
	 */
	this._getUserInputValueFor = function (dotSeperatedFieldPath) {
		var userInput = userInputRepository.get();
		return Util.findHierarchyStringInObject(userInput, dotSeperatedFieldPath, '.');
	}

	/**
	 * Retrieves values from ServiceResponseRepository
	 * @param {String} dotSeperatedFieldPath                    Path to value to retrieve
	 * @return {*}                                                Value from ServiceResponseRepository to return
	 * @private
	 */
	this._getServiceResponseValueFor = function (serviceName, dotSeperatedFieldPath) {
		return serviceResponseRepository.getLastResponseFrom(serviceName);
	}

	/**
	 * Calculates whether at least one driver in the last 4 years, has been charged or convicted of any driving offences
	 * @returns {boolean}
	 * @private
	 */
	this._driversHave_fourYears_licenceRSDC = function () {
		if (this.drivers) {
			var driversLength = this.drivers.length,
				atLeastOneDriverHas = false,
				driver;

			for (var i = 0; i < driversLength; i++) {
				driver = this.drivers[i];

				if (driver.fourYears_licenceRSDC &&
					driver._aggregator.markedForDelete !== true) {
					atLeastOneDriverHas = true;
					break;
				}
			}

			return atLeastOneDriverHas;
		}
	}
	/**
	 *
	 * @returns {boolean}
	 * @private
	 */
	this._driversHave_fourYears_chargedOrConvictedOffences = function () {
		if (this.drivers) {
			var driversLength = this.drivers.length,
				atLeastOneDriverHas = false,
				driver;

			for (var i = 0; i < driversLength; i++) {
				driver = this.drivers[i];

				if (driver.fourYears_chargedOrConvictedOffences &&
					driver._aggregator.markedForDelete !== true
				) {
					atLeastOneDriverHas = true;
					break;
				}
			}

			return atLeastOneDriverHas;
		}
	}
	/**
	 *
	 * @returns {boolean}
	 * @private
	 */
	this._driversHave_fourYears_vehicleAccidentsClaims = function () {
		if (this.drivers) {

			var driversLength = this.drivers.length,
				atLeastOneDriverHas = false,
				driver;

			for (var i = 0; i < driversLength; i++) {
				driver = this.drivers[i];

				if (driver.fourYears_vehicleAccidentsClaims &&
					driver._aggregator.markedForDelete !== true) {
					atLeastOneDriverHas = true;
					break;
				}
			}

			return atLeastOneDriverHas;
		}
	}
	/**
	 *
	 * @returns {boolean}
	 * @private
	 */
	this._driversHave_tenYears_chargedOrConvictedOffences = function () {
		if (this.drivers) {

			var driversLength = this.drivers.length,
				atLeastOneDriverHas = false,
				driver;

			for (var i = 0; i < driversLength; i++) {
				driver = this.drivers[i];

				if (driver.tenYears_chargedOrConvictedOffences &&
					driver._aggregator.markedForDelete !== true) {
					atLeastOneDriverHas = true;
					break;
				}
			}

			return atLeastOneDriverHas;
		}
	}

	this.isReplacementAvailable = function () {

		var selectedCar = serviceResponseRepository.getLastResponseFrom('regoSearch')
		if (selectedCar && selectedCar.modelYear) {
			var modelAge = new Date().getFullYear() - selectedCar.modelYear;
			return (modelAge <= 2);
		}
		return false;
	}

	this.getValidReplacementMonths = function (whenDidYouBuyYear) {
		if (!this.replacementMonths)
			this.replacementMonths = {};

		if (!this.replacementMonths[whenDidYouBuyYear]) {
			if (!whenDidYouBuyYear) {
				return [];
			}

			var monthOptions = moment.months().map(
				function (month, index) {
					var monthIndex = index + 1;
					//add leading zero
					monthIndex = (monthIndex > 9) ? ('' + monthIndex) : ('0' + monthIndex);
					return {
						'label': month,
						'value': monthIndex
					};
				});

			//split month based on year
			var yearsOld = moment().year() - whenDidYouBuyYear;
			if (yearsOld == 0) {
				monthOptions = monthOptions.splice(0, moment().month() + 1);
			} else if (yearsOld > 1) {
				monthOptions = monthOptions.splice(moment().month());
			}
			this.replacementMonths[whenDidYouBuyYear] = monthOptions;
		}

		return this.replacementMonths[whenDidYouBuyYear];
	}

	this.getValidReplacementYears = function () {
		if (!this.replacementYears) {
			var yearOptions = [];
			//get start year by subtracting 2 years
			var startYear = moment().subtract(2, 'years').year();
			var currentYear = moment().year();
			for (var i = startYear; i <= currentYear; i++) {
				yearOptions.push({
					'label': i,
					'value': i
				});
			}
			this.replacementYears = yearOptions;
		}

		return this.replacementYears;
	}

	this.email = this._getUserInputValueFor('vehicleForm.tellUsABitMore.yourEmailAddress') ? this._getUserInputValueFor('vehicleForm.tellUsABitMore.yourEmailAddress') : this._getUserInputValueFor('email');

	// vehicle form data
	this.vehicleForm = this._getUserInputValueFor('vehicleForm');

	// cover type
	this.selectedQuote = selectedQuote;
	this.selectedQuoteForPayment = selectedQuoteForPayment;
	//  this._getServiceResponseValueFor('quickQuote');
	if (selectedQuote) {
		this.annualCoverType = selectedQuote.getAnnual();
		this.monthlyCoverType = selectedQuote.getMonthly();
		// this.fortnightlyCoverType = selectedQuote.getMonthly();

		this.quoteResult = this.selectedQuoteForPayment; // selectedQuote.getQuoteResult();
		if (this.quoteResult) {
			this.coverageOptions = this.quoteResult.coverageOptions;
			if (this.coverageOptions) {
				this.coverageOptionsToShow = this.coverageOptions.filter(function (op) {
					return op.required === false;
				});
				this.hasCoverageOptions = this.coverageOptionsToShow.length > 0;
			}
			this.excess = this.quoteResult.excess;
			this.namedDriverExcess = findNamedDriverExcess();
		}
	}

	/** excess list to be displayed in the quote panel */
	this.displayableExcessList = null;

	this.getDisplayableExcess = function () {
		if (!this.excess)
			return [];

		if (!this.displayableExcessList) {
			var filterOut = ['voluntaryVehicleExcessOptions', 'voluntaryVehicleExcess', 'standardVehicleExcess'];
			this.displayableExcessList = [];

			for (var key in this.excess) {
				if (filterOut.indexOf(key) === -1)
					this.displayableExcessList.push({
						key: key,
						excessValue: this.excess[key]
					});
			}
		}

		return this.displayableExcessList;
	}

	function findNamedDriverExcess() {
		var namedDriverExcess = [],
			qr = selectedQuoteForPayment ? selectedQuoteForPayment.response : null;

		if (qr && qr.vehicles) {
			var drivers = qr.vehicles[0].drivers;
			drivers.forEach(function (driver) {
				if (driver.driver &&
					driver.driver.calculatedExcess &&
					driver.driver.calculatedExcess > 0) {
					namedDriverExcess.push({
						firstName: driver.driver.person.firstName,
						lastName: driver.driver.person.lastName,
						excessValue: driver.driver.calculatedExcess,
						dob: driver.driver.person.dateOfBirth
					});
				}
			});
		}

		return namedDriverExcess;
	}


	/**
	 * Excluded drivers
	 */
	var savedQuoteResult = this._getServiceResponseValueFor('quote');
	if (savedQuoteResult && savedQuoteResult.vehicles && savedQuoteResult.vehicles[0]) {
		/** excluded driver condition to be correctly diagnosed here */
		// this.excludedDrivers = this.quoteResult.excludedDrivers ;
		var excludedDrivers = [];

		savedQuoteResult.vehicles[0].drivers.forEach(function (driver) {
			if (driver.driverUsage == 'excluded')
				excludedDrivers.push(driver.driver.person);
		})
		this.excludedDrivers = excludedDrivers;
	}


	this.hasExcludedDrivers = function () {
		return this.excludedDrivers && this.excludedDrivers.length > 0;
	}

	this.drivers = [];
	this.postCode = null;
	this.campaignCode = null;
	if (this.vehicleForm) {
		//TODO: set regoNumber based on step 1 or step 4

		// vehicleDetails
		if (this.vehicleForm.carDetails) {
			this.carDetailsUsage = this.vehicleForm.carDetails.primaryCarUse;
			switch (this.carDetailsUsage) {
				case 'commercial':
					this.carDetailsUsage += ' - ' + this.vehicleForm.carDetails.commercialActivityType.label;
					break;
				case 'business':
					this.carDetailsUsage += ' - ' + this.vehicleForm.carDetails.businessActivityType.label;
					break;
			}
		}

		if (this.vehicleForm.getStarted && this.vehicleForm.getStarted.personOrCompany) {
			this.policyStartDate = this.vehicleForm.getStarted.policyStartDate,
				this.personOrCompany = this.vehicleForm.getStarted.personOrCompany;
		}

		// Main drivers & additional drivers
		this.additionalDrivers = [];

		if (this.vehicleForm.driver) {
			var drivers = this.vehicleForm.driver.drivers;
			if (drivers) {

				this.mainDriver = drivers[0];

				if (drivers.length > 1) {
					this.additionalDrivers = drivers.splice(1, drivers.length);
				}
			}
		}

		// drivers
		if (this.mainDriver) {
			this.drivers = [this.mainDriver];
			this.noClaimBonus = this.mainDriver.noClaimBonus;
		}
		if (this.additionalDrivers) {
			this.drivers = this.drivers.concat(this.additionalDrivers);
		}

		// address
		var aboutYourCar = this.vehicleForm.aboutYourCar;
		if (aboutYourCar && aboutYourCar.address) {
			this.address = aboutYourCar.address;
			this.postCode = this.address.postalCode;
			this.state = this.address.state;
		}

		if (this.vehicleForm.promotionalCode) {
			this.campaignCode = this.vehicleForm.promotionalCode.promotionalCode;
		}

		// rego details
		this.regoDetails = this._getServiceResponseValueFor('regoSearch');

		if (aboutYourCar && aboutYourCar.regoDetails) {
			this.regoNumber = aboutYourCar.regoDetails.regoNumber;
		} else if (this.vehicleForm.tellUsYourRegoNumber &&
			this.vehicleForm.tellUsYourRegoNumber.regoNumber && !this.vehicleForm.aboutYourCar.retrievedQuoteRego) {
			this.regoNumber = this.vehicleForm.tellUsYourRegoNumber.regoNumber;
		}

		if (this.regoDetails) {
			this.vehicleOptionalEquipments = this.regoDetails.optionalEquipments;
		}


	}

	// this.quoteId = this._getServiceResponseValueFor('service-name', 'quote.quoteId');
	this.quoteId = null;
	if (quoteRequestRepository.getSelectedQuoteCredentials())
		this.quoteId = quoteRequestRepository.getSelectedQuoteCredentials().quoteID;


	/** Google Tag Manager data **/
	this.gtmPolicyHolder = this.mainDriver ? this.mainDriver.person : null;
	this.gtmTransactionAffiliation = 'QBE Direct';
	this.insuranceType = MODULE_INFO.insuranceType;
	this.productCode = MODULE_INFO.productCode;
}

function JsonMapper(responseRepository) {

	/**
	 * places @value on a @source, in the spot indicated by @valueStringArray.
	 * @mappedValueStarIndices is used for conversion callbacks and @isDefault determines if the value
	 * is to be placed only if no current value exists.
	 */
	function mapValues(source, valueStringArray, value, mappedValueStarIndices, isDefault) {
		var lastKey = valueStringArray.pop();
		for (var i = 0 ; i < valueStringArray.length; i++) {
			if ( ! source ) return null ;

			var key = valueStringArray[i], nextKey = valueStringArray[i+1] ;

			if ( key === '*') {
				for (var j = 0 ; j < source.length ; j++ ) {
					var vsa = valueStringArray.slice(i+1, valueStringArray.length) ;
					vsa.push(lastKey);
					var startIndices = mappedValueStarIndices ? mappedValueStarIndices: [];
					mapValues(source[j], vsa , value, startIndices.concat([j]),  isDefault) ;
				}
			} else if (key.indexOf('*[') == 0 && key.indexOf(']') == (key.length - 1)) {
				var propetyName = key.substring(2,key.length - 1);
				for (var j = 0 ; j < source.length ; j++ ) {
					var vsa = valueStringArray.slice(i+1, valueStringArray.length) ;
					vsa.push(lastKey);
					var startIndices = mappedValueStarIndices ? mappedValueStarIndices: [];
					//get propety value and append to startIndices like this [name=value]
					var propetyVal = source[j][propetyName];
					var indiceValue = '['+propetyName+'='+propetyVal+']';
					mapValues(source[j], vsa , value, startIndices.concat([j + indiceValue]),  isDefault) ;
				}
			} else if ( source[key] === undefined ) {
				createChildProperty(source, key, nextKey);
			}

			source = source[key] ;
		}

		if ( ! source ) {
			return ;
		}

		if ( ! (isDefault && ( source[lastKey] !== null && source[lastKey] !== undefined))) {
			var val = isFunction(value) ? value(source[lastKey], mappedValueStarIndices) : value;
			source[lastKey] = val;
		}
	}

	function createChildProperty(target, key, nextKey) {
		if ( nextKey === '*' ) {
			target[key] = [];
		}
		else if ( Number.isNumeric(nextKey)){
			target[key] = [];
		}
		else {
			target[key] = {} ;
		}
	}


	function fetchValue(value, requestData) {
		if ( isFunction(value) )
			return value() ;

		if ( typeof(value) !== 'string')
			return value;

		if ( value.indexOf('=') === -1 )
			return value ;

		var valueStringArray = value.substring(1, value.length).split('.');
		var sourceIdentifier = valueStringArray[0];
		var source = getSource(sourceIdentifier, requestData);

		valueStringArray.shift() ; /** first element in the array is the source identifier */
		for (var i = 0 ; i < valueStringArray.length; i++) {
			if ( ! source ) return null ;
			source = source[valueStringArray[i]] ;
		}

		return source;
	}

	function getSource(source, requestData) {
		if ( source == '_input' )
			return requestData;

		source = source.substring(1, source.length); // remove _
		return responseRepository.getLastResponseFrom(source);
	}


	function transform(requestData, mapping) {
		var inflated = requestData ;
		for (var key in mapping) {
			value = mapping[key];
			mapValues(requestData, key.split('.'), function() {
				return fetchValue(value, requestData)
			} ) ;
		}

		return inflated;
	}

	function convert(requestData, mapping) {
		for (var key in mapping) {
			converterFn = mapping[key];
			mapValues(requestData, key.split('.'), converterFn) ;
		}

		return requestData;
	}

	function setDefaultValues(requestData, mapping) {
		for (var key in mapping) {
			value = mapping[key];
			mapValues(requestData, key.split('.'), value, null, true) ;
		}

		return requestData;
	}

	return {
		transform: transform,
		convert: convert,
		setDefault: setDefaultValues
	}
}

function MergedQuoteResultModel(Util, coverType) {
	var quoteResults = {} ;

	function addQuoteResult(quote) {
		var freq = paymentFrequencyMapping[quote.paymentFrequency] ;
		quoteResults[freq] = quote ;
	}

	function getQuoteResult(paymentFrequency) {
		paymentFrequency = paymentFrequencyMapping[paymentFrequency] || paymentFrequency ; 
		if ( ! quoteResults[paymentFrequency] )
			quoteResults[paymentFrequency] = forgeQuoteResult(paymentFrequency) ;

		return quoteResults[paymentFrequency] ;
	}

	var paymentFrequencyMapping = {
		everyyear : 'annual',
		monthly: 'monthly',
		everyotherweek: 'fortnightly'
	}

	var premiumConstant = {
		monthly : 1.07 / 12 ,
		fortnightly : 1.07 / 27.5 ,
	}

	function forgeQuoteResult(paymentFrequency) {
		var qr = Util.deepClone(quoteResults.annual) ;
		qr.paymentFrequency = paymentFrequency ;
		qr.isForgedPremium = true ;
		if ( qr.quoteResult && qr.quoteResult.totalPremium) {
			qr.quoteResult.totalPremium = qr.quoteResult.totalPremium * premiumConstant[paymentFrequency] * 12 ;
			qr.paymentPlan = qr.paymentPlan || {} ; 
			qr.paymentPlan.installment= qr.quoteResult.totalPremium * premiumConstant[paymentFrequency]; 
		}

		return qr;
	}

	return {
		addQuoteResult: addQuoteResult,
		getQuoteResult: getQuoteResult,
		getAnnual: function() {return getQuoteResult('annual')},
		getMonthly: function() {return getQuoteResult('monthly')},
		getFortnightly: function() {return getQuoteResult('fortnightly')},
	}
}

function PortalServiceWrapper(
	guideWireService,
	quoteRequestRepository,
	serviceResponseRepository,
	retrieveSavedQuoteResponseTransformer,
	quoteServiceResponseTransformer,
	quoteOptions) {

	function updateQuote(userInput) {
		return quoteRequestRepository.update(userInput);
	}

	function getLastRequest() {
		return quoteRequestRepository.getLastRequest();
	}

	function getLastResponse(serviceName) {
		return serviceResponseRepository.getLastResponseFrom(serviceName);
	}


	function handleSaveQuoteResponse(resp) {
		var data = resp.data;
		if (data.error) {
			void 0;
			throw data.error;
		}
		serviceResponseRepository.update('quote', data);
		quoteRequestRepository.updateQuoteCredentials(resp);
		return resp;
	}

	function saveQuote(paymentOption, params) {
		var qr = quoteRequestRepository.getSaveQuoteRequest(paymentOption);
		var credentials = quoteRequestRepository.getSelectedQuoteCredentials();
		var qq = guideWireService.saveQuote(qr, credentials, params);
		qq.then(function (resp) {
			return handleSaveQuoteResponse(resp);
		});

		return qq;
	}

	var quickQuoteParams = {
		rating: 'boolean',
		checkUWQuote: 'boolean',
		checkUWBind: 'boolean',
		ruleSet: 'string'
	};

	function getQuoteParams(rules) {
		return {
			rating: rules.price,
			checkUWQuote: rules.quote,
			checkUWBind: rules.purchase,
			ruleSet: rules.ruleSet
		}
	}

	function handleQuickQuoteResponse(resp) {
		var data = resp.data;
		if (data.error) {
			void 0;
			throw data.error;
		}

		quoteResults = quoteServiceResponseTransformer.transform(data);
		serviceResponseRepository.update('quickQuote', quoteResults);
		quoteOptions.setAvailableQuoteResults(quoteResults);
		updateSelectedCoverTypeIfNoLongerAvailableIn(quoteResults);
		return resp;
	}

	function updateSelectedCoverTypeIfNoLongerAvailableIn(quoteResults) {
		if (!quoteOptions.getSelectedQuoteResult()) {
			void 0;
			quoteOptions.setDefaultCoverType();
			if (!quoteOptions.getSelectedQuoteResult()) {
				throw 'No cover is available';
			}
		}
	}

	//type is 'bike' or 'caravan'
	function checkEmbargo(postcode, type) {
		return guideWireService.checkEmbargo(postcode, type).then(function(resp) {
			return (resp 
				&& resp.data 
				&& resp.data.embargoes 
				&& resp.data.embargoes.length > 0);
		}).catch(function (err) {
			return true;
		});
	}

	function getQuickQuote(permutations, rules, updateSelectedCoverType) {
		var params = getQuoteParams(rules);
		if (updateSelectedCoverType || !permutations.coverTypes) {
			permutations.coverTypes = [quoteOptions.getSelectedCoverType()];
		}
		var multiQuoteRequest = quoteRequestRepository.splitQuotes(permutations);
		var credentials = quoteRequestRepository.getSelectedQuoteCredentials();
		var qq = guideWireService.getQuickQuote(multiQuoteRequest, params, credentials);
		qq.then(function (resp) {
			return handleQuickQuoteResponse(resp);
		}).catch(function (err) {
			return err;
		});

		return qq;
	}

	function triggerGoalSaveQuote() {		
		var credentials = quoteRequestRepository.getSelectedQuoteCredentials();
		if (credentials && credentials.quoteID) {
			var marketingAuto = window.marketingAutomations;
			var maCreateQuote = (marketingAuto && marketingAuto.createQuote) ? marketingAuto.createQuote : undefined;
			var request = quoteRequestRepository.getQuoteTriggerRequest();
			request.QuoteId = credentials.quoteID;
			request.QuoteStatus = "Created";
			request.GoalId = (maCreateQuote) ? maCreateQuote.GoalId : '';
			request.Source = (maCreateQuote) ? maCreateQuote.Source : '';
			request.ChannelId = (maCreateQuote) ? maCreateQuote.ChannelId : '';
			request.EventId = (maCreateQuote) ? maCreateQuote.EventId : '';
			if (request.GoalId && request.EventId) {				
				guideWireService.triggerGoal(request);
			}
		}
	}

	function triggerGoalCompleteQuote() {
		var credentials = quoteRequestRepository.getSelectedQuoteCredentials();
		if (credentials && credentials.quoteID) {
			var marketingAuto = window.marketingAutomations;
			var maCompleteQuote = (marketingAuto && marketingAuto.completeQuote) ? marketingAuto.completeQuote : undefined;
			var request = quoteRequestRepository.getQuoteTriggerRequest();
			request.QuoteId = credentials.quoteID;
			request.QuoteStatus = "Completed";
			request.GoalId = (maCompleteQuote) ? maCompleteQuote.GoalId : '';
			request.Source = (maCompleteQuote) ? maCompleteQuote.Source : '';
			request.ChannelId = (maCompleteQuote) ? maCompleteQuote.ChannelId : '';
			request.EventId = (maCompleteQuote) ? maCompleteQuote.EventId : '';

			if (request.GoalId && request.EventId) {				
				guideWireService.triggerGoal(request);
			}
		}		
	}

	function testQuoteDecline(declineQuoteOptions) {
		if (declineQuoteOptions) {
			var params = getQuoteParams(declineQuoteOptions.rules);
			declineQuoteOptions.permutations.coverTypes = [quoteOptions.getSelectedCoverType()];
			var multiQuoteRequest = quoteRequestRepository.splitQuotes(declineQuoteOptions.permutations);
			var credentials = quoteRequestRepository.getSelectedQuoteCredentials();
			var qq = guideWireService.getQuickQuote(multiQuoteRequest, params, credentials);
			return qq.then(function (resp) {
				return handleDeclineAndReferralResponse(resp);
			});
		}		
	}

	function handleDeclineAndReferralResponse(resp) {
		var data = resp.data;
		if (data.error)
			throw data.error;

		var quote = data[0];
		if (quote.error)
			throw quote.error;

		var declineType = detectDeclineType(quote);
		if (declineType) {
			var declineParams = {
				declineType: declineType,
				declineCodes: []
			};

			quote.quoteResult.uwIssues.forEach(function (element) {
				declineParams.declineCodes.push(element.typeCode);
			}, this);

			throw declineParams;
		}
		return resp;
	}

	function sendDeclineMessagesTOGTM(result) {
		var dataLayer = window.dataLayer = window.dataLayer || [];
		var trackingData = {
			event: 'decline',
			declineCode: []
		}

		result.uwIssues.forEach(function (element) {
			trackingData.declineCode.push(element.typeCode);
		}, this);

		dataLayer.push(trackingData);
	}

	function detectDeclineType(quote) {
		if (quote.quoteResult) {
			if (quote.quoteResult.errors && quote.quoteResult.errors.messages) {
				var message = quote.quoteResult.errors.messages.join('\n') + '\n';
				return 'error';
			} else if (quote.quoteResult.decline && !quote.quoteResult.embargo) {
				sendDeclineMessagesTOGTM(quote.quoteResult);
				return 'decline';
			} else if (quote.quoteResult.referral && !quote.quoteResult.embargo) {
				return 'referral';
			} else if (quote.quoteResult.embargo) {
				return 'embargo';
			}
		}
		return null;
	}

	function retrieveSavedQuote(quoteId, email) {
		var qq = guideWireService.retrieveSavedQuote(quoteId, email)
			.then(function (response) {
				var data = response.data;
				serviceResponseRepository.update('quote', data);
				quoteRequestRepository.updateQuoteCredentials(response);
				return retrieveSavedQuoteResponseTransformer.transform(data);
			});

		return qq;
	}

	function refreshAddress(address) {
		var qq = guideWireService.refreshAddress(address);
		qq.then(function (resp) {
			serviceResponseRepository.update('addressSearch', resp.data);
			return resp.data;
		})
		return qq;
	}

	function refreshVehicleDetails(vgiId, effectiveDate) {
		var qq = guideWireService.refreshVehicleDetails(vgiId, effectiveDate);
		qq.then(function (resp) {
			if (resp.data && resp.data.length > 0) {
				var searchedData = resp.data[0];
				if (!searchedData.goodRetailPrice && searchedData.make) {
					searchedData.goodRetailPrice = "0";
				}
				serviceResponseRepository.update('regoSearch', searchedData);
				return searchedData;
			}
			return null;
		});
		return qq;
	}

	function refreshCaravanDetails(vgiId, effectiveDate) {
		var qq = guideWireService.refreshCaravanDetails(vgiId, effectiveDate);
		qq.then(function (resp) {
			if (resp.data && resp.data.length > 0) {
				serviceResponseRepository.update('regoSearch', resp.data[0]);
				return resp.data;
			}
			return null;
		});
		return qq;
	}

	function doesUserExist(email) {
		return guideWireService.doesUserExist(email);
	}

	return {
		updateQuote: updateQuote,
		getQuickQuote: getQuickQuote,
		saveQuote: saveQuote,
		triggerGoalSaveQuote: triggerGoalSaveQuote,
		triggerGoalCompleteQuote: triggerGoalCompleteQuote,
		testQuoteDecline: testQuoteDecline,
		getLastRequest: getLastRequest,
		getLastResponse: getLastResponse,
		retrieveSavedQuote: retrieveSavedQuote,
		refreshAddress: refreshAddress,
		refreshVehicleDetails: refreshVehicleDetails,
		refreshCaravanDetails: refreshCaravanDetails,
		doesUserExist: doesUserExist,
		checkEmbargo: checkEmbargo
	};
}

"use strict";

function QuoteRequestRepository(Util,
	storage,
	quoteOptions,
	quoteConfiguration,
	userInputRepository,
	serviceResponseRepository,
	structuredRequestTransformer,
	defaultValueRequestTransformer,
	formatConverterTransformer,
	cleanRequestTransformer,
	splitterRequestTransformer,
	publicIDTransformer,
	policyHolderHandler,
	coverTypeTransformer,
	coverTypeResolver,
	coverOfferingResolver,
	triggerGoalTransformer
) {

	var userInput = null;

	var lastQuoteResponse = null;

	function getUserInput() {
		return userInput;
	}

	function updateQuoteRequest(input) {
		userInput = Util.deepClone(input);
	}

	function getLastRequest() {
		return quoteRequest;
	}

	function forgePublicId(moduleName) {
		return Util.stringFormat('portal:{0}-{1}', moduleName, Util.generateRandomString(15));
	}

	var moduleNameMapping = {
		"vehiclesDriver": 'QPMVehicleDriver',
		"vehiclesPolicyDriver": 'QPMPolicyDriver',
		"vehiclesPerson": 'person',
		"vehiclesDriverHistory": "QPMDriverHistory",
		"caravansDriver": "QPCVehicleDriver",
		"caravansPolicyDriver": "QPCPolicyDriver",
		"caravansPerson": "Person",
		"caravansDriverHistory": "QPCDriverHistory",
		"motorcyclesDriver": 'QPYMotorcycleRider',
		"motorcyclesPolicyDriver": 'QPYPolicyRider',
		"motorcyclesPerson": 'Person',
		"motorcyclesDriverHistory": "QPYRiderHistory",
	};

	/**
	 * Generates the json for the body of the QuickQuote request, by applying
	 * quote specific transformations (based on the corresponding response received from the service).
	 * @quotePermutations: a list of coverType, paymentFrequency and quoteType permutations to generate the final request for.
	 */
	function splitQuotes(quotePermutations) {
		var quoteRequest = transformQuickQuoteRequest();
		if (!quotePermutations.offerings)
			quotePermutations.offerings = [quoteOptions.getSelectedOffering()];

		var quotes = splitterRequestTransformer.transform(quotePermutations, quoteRequest);
		return quotes;
	}

	function getQuoteTriggerRequest() {
		var quoteRequest = transformQuickQuoteRequest();
		var request = triggerGoalTransformer.transform(quoteRequest);
		return request;
	}

	function transformQuickQuoteRequest() {
		var input = Util.deepClone(userInput);
		var structuredRequest = structuredRequestTransformer.transform(input);
		var valueSubbedRequest = defaultValueRequestTransformer.transform(structuredRequest, input);
		var valueReformattedRequest = formatConverterTransformer.transform(valueSubbedRequest);
		var cleanedRequest = cleanRequestTransformer.transform(valueReformattedRequest);
		return cleanedRequest;
	}

	/**
	 * Generate the json body of a Full Quote Request.  This body is used for both PUT and POST requests
	 * and sent to the guideWire service.
	 */
	function getSaveQuoteRequest(paymentFrequency) {
		var quoteRequest = transformSaveQuoteRequest();
		var q = Util.deepClone(quoteRequest);
		q = Object.extend(q, {
			quoteType: 'Full',
			paymentFrequency: paymentFrequency
		});

		//added firstAnchorDate and firstDayOfMonth for monthly and fortnightly payments
		if (quoteRequest.paymentForm && quoteRequest.paymentForm.paymentDetails && quoteRequest.paymentForm.paymentDetails.paymentStartDate) {
			var dateString = quoteRequest.paymentForm.paymentDetails.paymentStartDate;
			q.firstAnchorDate = moment(dateString, 'DD/MM/YYYY').toISOString();
			q.firstDayOfMonth = moment(dateString, 'DD/MM/YYYY').format('D');
		}
		var coverType = quoteOptions.getSelectedCoverType();
		var offering = quoteOptions.getSelectedOffering(),
			offeringDescriptor = offering ? offering.descriptor : null;;

		q = coverTypeTransformer.transform(q, coverType.descriptor, offeringDescriptor);

		var cred = getSelectedQuoteCredentials();
		if (cred) {
			q.quoteID = cred.quoteID;
			q.secret = cred.secret;
		}

		var lastResponse = findMatchingQuoteResponse(coverType, offering);

		//check from last response if added driver has excluded usage
		if (lastResponse !== null) {
			var productType = null;

			if (angular.isObject(lastResponse.vehicles)) productType = 'vehicles';

			if (angular.isObject(lastResponse.caravans)) productType = 'caravans';

			//applicable for motor products
			if (productType != null) {
				angular.forEach(lastResponse[productType][0].drivers, function (driver, index) {
					if (driver.driverUsage === 'excluded') {
						q[productType][0].drivers[index].driverUsage = 'excluded';
					}
				})
			}
		}

		q = publicIDTransformer.transform(q, lastResponse);

		var policyHolderhandledRequest = policyHolderHandler.handle(q, userInput);

		return policyHolderhandledRequest;
	}

	function findMatchingQuoteResponse(coverType, offering) {
		var lastQuote = serviceResponseRepository.getLastResponseFrom('quote');
		var lastQuickQuote = serviceResponseRepository.getLastResponseFrom('quickQuote');
		if (lastQuote &&
			coverTypeResolver.resolve(lastQuote) == coverType.descriptor &&
			(!coverOfferingResolver.resolve(lastQuote) || coverOfferingResolver.resolve(lastQuote) == offering.descriptor)
		) {

			if (angular.isObject(lastQuote.vehicles) && lastQuickQuote.length > 0) {
				lastQuote = addDriverFromQuickQuote(lastQuote, 'vehicles');
			}

			if (angular.isObject(lastQuote.caravans) && lastQuickQuote.length > 0) {
				lastQuote = addDriverFromQuickQuote(lastQuote, 'caravans');
			}

			if (angular.isObject(lastQuote.motorcycles) && lastQuickQuote.length > 0) {
				lastQuote = addDriverFromQuickQuote(lastQuote, 'motorcycles');
			}

			return lastQuote;
		}

		return null;
	}

	function transformSaveQuoteRequest() {
		var input = Util.deepClone(userInput);
		structuredRequestTransformer.transform(input);
		var valueSubbedRequest = defaultValueRequestTransformer.transform(null, input);
		var valueReformattedRequest = formatConverterTransformer.transform(valueSubbedRequest);
		var cleanedRequest = cleanRequestTransformer.transform(valueReformattedRequest);
		return cleanedRequest;
	}

	function getCoverTypeSelector(quoteResponse) {
		if (!quoteResponse)
			return null;

		var coverTypeSelector = coverTypeResolver.resolve(quoteResponse);
		var offering = coverOfferingResolver.resolve(quoteResponse);
		if (offering)
			coverTypeSelector += '_' + offering;

		return coverTypeSelector;
	}

	/**
	 * @fullQuoteResponse : full HTTP response including body and headers
	 */
	function updateQuoteCredentials(fullQuoteResponse) {
		var respBody = fullQuoteResponse.data;
		var headers = fullQuoteResponse.headers;
		var quoteRequestCredentials = {};
		/** remove all quote credentials after quote type has changed
												 to not confuse guidewire :) */

		var coverTypeSelector = getCoverTypeSelector(respBody);
		if (coverTypeSelector) {
			quoteRequestCredentials[coverTypeSelector] = {
				quoteID: respBody.quoteID,
				secret: respBody.secret
			}
		}

		var eyUserToken = headers('ey-user-token');
		storage.setItem('eyUserToken', eyUserToken);
		storage.setItem('quoteRequestCredentials', quoteRequestCredentials);
		if (respBody.productCode == "QPMMotorVehicle")
			storage.setItem('selectedCoverType', quoteConfiguration.allCoverTypesByKey[coverTypeSelector]);
	}

	function getSelectedQuoteCredentials() {
		var selectedCoverType = quoteOptions.getSelectedCoverType();
		var quoteRequestCredentials = storage.getItem('quoteRequestCredentials');
		var creds;
		if (selectedCoverType) {
			var coverTypeSelector = quoteOptions.getCoverTypeSelector();
			creds = quoteRequestCredentials[coverTypeSelector];
			var eyUserToken = storage.getItem('eyUserToken');
			if (creds && eyUserToken)
				creds.eyUserToken = eyUserToken;
		}

		return creds;
	}

	function clearQuoteCredentials() {
		storage.setItem('eyUserToken', null);
		storage.setItem('quoteRequestCredentials', {});
	}

	/*
	 * Function - adds new driver from quick quote before submitting to public id transformer
	 * Params - quote, product type
	 * Return - quote
	 */
	function addDriverFromQuickQuote(lastQuote, productType) {
		var driverType = productType == 'motorcycles' ? 'riders' : 'drivers';
		var lastQuick = serviceResponseRepository.getLastResponseFrom('quickQuote');
		var quickQuoteLength = lastQuick[0].response[productType][0][driverType].length;
		var quoteLength = lastQuote[productType][0][driverType].length;
		var lengthDiff = quickQuoteLength - quoteLength;
		var quickQuoteItems = lastQuick[0].response[productType][0][driverType];
		var quoteItems = lastQuote[productType][0][driverType];

		if (lengthDiff > 0) {
			var startIndex = quickQuoteLength - lengthDiff;
			var driver = productType + 'Driver';
			var policyDriver = productType + 'PolicyDriver';
			var person = productType + 'Person';
			var driverHistory = productType + 'DriverHistory';
			var driverType = productType == 'motorcycles' ? 'rider' : 'driver';
			var historyType = productType == 'motorcycles' ? 'riderHistory' : 'driverHistory';

			for (var i = startIndex; i < quickQuoteLength; i++) {
				quickQuoteItems[i].publicID = forgePublicId(moduleNameMapping[driver]);
				quickQuoteItems[i][driverType].publicID = forgePublicId(moduleNameMapping[policyDriver]);
				quickQuoteItems[i][driverType].person.publicID = forgePublicId(moduleNameMapping[person]);

				if (angular.isDefined(quickQuoteItems[i][driverType][historyType])) {
					var driverHistory = quickQuoteItems[i][driverType][historyType];

					angular.forEach(driverHistory, function (history, index) {
						history.publicID = forgePublicId(moduleNameMapping[driverHistory]);
					});
				}

				quoteItems.push(quickQuoteItems[i]);
			}
		}

		return lastQuote;
	}

	return {
		update: updateQuoteRequest,
		getLastRequest: getLastRequest,
		splitQuotes: splitQuotes,
		getQuoteTriggerRequest: getQuoteTriggerRequest,
		getSaveQuoteRequest: getSaveQuoteRequest,
		updateQuoteCredentials: updateQuoteCredentials,
		getSelectedQuoteCredentials: getSelectedQuoteCredentials,
		clearQuoteCredentials: clearQuoteCredentials,
		getUserInput: getUserInput,
	};
}

function QuoteResultModelBuilder(Util) {
	var quoteResultsByType= {} ;

	function addQuoteResult(quoteResult) {
		var quoteCoverIndicator = quoteResult.coverType;
		if ( quoteResult.offering )
			quoteCoverIndicator += '_' + quoteResult.offering ; 

		if ( ! quoteResultsByType[quoteCoverIndicator] ) 
			quoteResultsByType[quoteCoverIndicator] = new MergedQuoteResultModel(Util, quoteCoverIndicator);

		quoteResultsByType[quoteCoverIndicator].addQuoteResult(quoteResult) ; 
	}

	function getMergedQuoteResults(quoteResults) {
		return quoteResultsByType;
	}

	function clear() {
		quoteResultsByType = {}; 
	}

	return {
		clear: clear,
		addQuoteResult: addQuoteResult,
		getMergedQuoteResults: getMergedQuoteResults,
	}
}

function QuoteServiceResponseTransformer(quoteResultModelBuilder, serviceResponseRepository, quoteResultModelFactory) {

	function transform(quoteResponses) {
		var quoteResults = [] ;
		quoteResponses.forEach(function(response) {
			// if ( response.quoteResult && ! response.quoteResult.errors )
			// response.productCode
			// quoteResults.push(new QuoteResultModel(response));
			quoteResults.push(quoteResultModelFactory.newQuoteResultModel(response));
		});

		var oldResults = serviceResponseRepository.getLastResponseFrom('quickQuote') ;
		var updatedQuoteResults = updateQuoteResults(quoteResults , oldResults) ;
		var filteredQuoteResults = filterQuoteResults(updatedQuoteResults);
		return filteredQuoteResults;
	}

	function updateQuoteResults(currentResults, oldResults) {
		if ( ! oldResults || oldResults.length == 0 )
			return currentResults ;

		currentResults.forEach(function(cqr) {
			if ( cqr.isCoverAvailable ) {
				addOrUpdateQuoteResult(oldResults, cqr)
			} else {
				oldResults = removeAllCoverTypeMatches(oldResults, cqr) ;
			}
		});

		return oldResults ;
	}

	function addOrUpdateQuoteResult(oldResults, quoteResult) {
		var matchingOldResult = findCompleteMatch(oldResults, quoteResult) ;
		if ( matchingOldResult ) {
			var oldResultIndex = oldResults.indexOf(matchingOldResult) ;
			oldResults[oldResultIndex] = quoteResult ;
		} else {
			oldResults.push(quoteResult);
		}
	}

	function removeAllCoverTypeMatches(oldResults, quoteResult) {
		var partialMatches = findCoverTypeMatches(oldResults, quoteResult) ;
		if ( partialMatches ) {
			oldResults = oldResults.filter(function(qr) {
				return partialMatches.indexOf(qr) === -1 ;
			}) ;
		}
		return oldResults;
	}

	function findCoverTypeMatches(oldResults, quoteResult) {
		var matchingQuoteResponses = [] ;
		oldResults.forEach(function(qr) {
			if ( qr.coverType == quoteResult.coverType
			&& (!qr.offering || qr.offering == quoteResult.offering) ){
				matchingQuoteResponses.push(qr);
			}
		});
		return matchingQuoteResponses;
	}

	function findCompleteMatch(oldResults, quoteResult) {
		var matchingQuoteResponse = null ;
		oldResults.some(function(qr) {
			if ( qr.coverType == quoteResult.coverType
				&& qr.paymentFrequency == quoteResult.paymentFrequency 
				&& (!qr.offering || qr.offering == quoteResult.offering)
				){
				matchingQuoteResponse = qr;
				return true;
			}
		});
		return matchingQuoteResponse;
	}

	function filterQuoteResults(quoteResults) {
		quoteResults = quoteResults.filter(function(qr) {
			return qr.isCoverAvailable;
		})

		return quoteResults ;
	}

	return {
		transform: transform,
	}
}

"use strict";

function ServiceResponseRepository(storage) {
	function update(serviceName, response) {
		// var lastResponse = serviceResponses[serviceName] || {} ;
		var serviceResponses = storage.getItem('service-response') || {} ; 
		serviceResponses[serviceName] = response;
		storage.setItem('service-response', serviceResponses) ;
	}

	function getLastResponseFrom(serviceName) {
		var serviceResponses = storage.getItem('service-response') ;
		return serviceResponses[serviceName] || null;
	}

	return {
		update: update,
		getLastResponseFrom: getLastResponseFrom
	};
}

'use strict' ;

function SplitterRequestTransformer(Util,  serviceResponseRepository, jsonMapper, publicIDTransformer, coverTypeTransformer) {

	function getQuoteResponseValue(qouteResponse, pathString) {
		return Util.findHierarchyStringInObject(qouteResponse, pathString, '.') ;
	}

	function transform(quotePermutations, quoteRequest) {
		var quoteResponses = serviceResponseRepository.getLastResponseFrom('quickQuote') ;
		var transformedRequest = null ;
		if ( quoteResponses )
			transformedRequest = transformExistingQuote(quotePermutations, quoteResponses, quoteRequest) ;
		else
			transformedRequest = transformNewQuote(quotePermutations, quoteRequest) ;

		return transformedRequest ;
	}

	function transformExistingQuote(quotePermutations, quoteResponses, quoteRequest) {
		var quotes = Util.generatePermutationsArray(quotePermutations.coverTypes, quotePermutations.paymentFrequencies).map(function(permutation, index) {
			var quote = Object.extend(permutation, quoteRequest);

			var coverType = permutation.option1;
			var paymentFrequency = permutation.option2 ; 
			delete quote.option1; delete quote.option2 ; 
			
			var quoteType = quotePermutations.quoteType ;
			var q = Util.deepClone(quote) ;
			q = Object.extend(q,{
				quoteType: quoteType,
				paymentFrequency: paymentFrequency,
			}) ;

			var quoteResponseBody = null ;
			// var matchingQuoteResponse = findMatchingQuoteResponse(quoteResponses, coverType) ;
			// if ( matchingQuoteResponse )
			// 	quoteResponseBody = matchingQuoteResponse.response;
			q = publicIDTransformer.transform(q, null) ;
			q = coverTypeTransformer.transform(q, coverType.descriptor);
			return q ;
		}) ;

		return quotes.filter(function(quote) { return quote !== null }) ;
	}

	function findMatchingQuoteResponse(quoteResponses, coverType){
		if ( ! quoteResponses )
			return;

		var matchingResponse = null ;
		quoteResponses.some(function(qr) {
			if (qr.coverType ==  coverType.descriptor) {
				matchingResponse = qr ;
				return true;
			}
		});

		return matchingResponse;
	}

	function transformNewQuote(quotePermutations, quoteRequest) {
		var nr = quotePermutations.coverTypes.length * quotePermutations.paymentFrequencies.length;
		var quotes = Util.arrayFill(nr, quoteRequest).map(function(quote, index) {
			var coverType = quotePermutations.coverTypes[index % quotePermutations.coverTypes.length];
			var paymentFrequency = quotePermutations.paymentFrequencies[index % quotePermutations.paymentFrequencies.length];
			var quoteType = quotePermutations.quoteType ;
			var q = Util.deepClone(quote) ;
			q = Object.extend(q,{
				quoteType: quoteType,
				paymentFrequency: paymentFrequency,
			}) ;

			q = coverTypeTransformer.transform(q, coverType.descriptor);
			q = publicIDTransformer.transform(q) ;
			return q ;
		}) ;

		return quotes ;
	}

	return {
		transform: transform
	}
}

function BikeCleanRequestTransformer(Util, jsonMapper) {

	function transform(intermediateRequest, userInput) {
		try {
			delete intermediateRequest.bikeForm;

			var bike = intermediateRequest.motorcycles[0];
			var policyHolders = intermediateRequest.policyHolders;

			delete bike.motorcycleInfo.description;
			delete bike.motorcycleInfo.goodRetailPrice;
			delete bike.motorcycleInfo.bikeType;
			delete bike.motorcycleInfo.ratingGrade;
			delete bike.motorcycleInfo.vehicleKey;
			delete bike.motorcycleInfo.enrichment;
			delete bike.accountLocation.enrichment;
			delete bike.totalAccessoriesPrice;
			delete bike.totalModificationsPrice;
			delete bike.youngestRiderDateOfBirth;

			if ( bike.riders ) {
				bike.riders.forEach(function(policyRider, index) {
					delete policyRider.rider._HTMLID;
					delete policyRider.rider._aggregator;
					delete policyRider.rider.threeYears_accidentsClaims;
					delete policyRider.rider.threeYears_accidentsClaimsDetails;
					delete policyRider.rider.threeYears_restrictedSuspendedDisqualifiedCancelled;
					delete policyRider.rider.threeYears_restrictedSuspendedDisqualifiedCancelledDetails;
					delete policyRider.rider.fiveYears_chargedOrConvicted;
					delete policyRider.rider.fiveYears_chargedOrConvictedDetails;
					delete policyRider.rider.person.noClaimBonus;
					delete policyRider.rider.person.title;
					delete policyRider.riders;
					delete policyRider.rider.isMemberOfClub;
					delete policyRider.rider.isTheMainRider;
					delete policyRider.rider.licensedToRide;
					delete policyRider.rider.motorcycleClub;
					delete policyRider.rider.yearsHeld;
					delete policyRider.rider.previousInsurer;
					delete policyRider.rider.primaryPhoneNumber;
					delete policyRider.rider.person.riders;
					delete policyRider.rider.person.address;
					delete policyRider.rider.person.fiveYears_chargedOrConvicted;
					delete policyRider.rider.person.isMainRiderMainPolicyHolder;
					delete policyRider.rider.person.postalOption;
					delete policyRider.rider.person.threeYears_accidentsClaims;
					delete policyRider.rider.person.threeYears_restrictedSuspendedDisqualifiedCancelled;

					if (index > 0) {
						delete policyRider.rider.person.hasClaim;
						delete policyRider.rider.person.hasConviction;
						delete policyRider.rider.currentInsurer;
						delete policyRider.rider.noClaimBonus;
						// delete policyRider.rider.person.primaryAddress.addressType;

						// test
						delete policyRider.rider.relationWithMainRider;
					}

				})
			}
			//

			policyHolders.forEach(function(policyHolder) {
				if ( policyHolder.contact ) {
					delete policyHolder.contact._HTMLID;
					delete policyHolder.contact.$$hashKey;
					delete policyHolder.contact._aggregator;

					delete policyHolder.contact.anyInfringements;
					delete policyHolder.contact.anyLostLicences;
					delete policyHolder.contact.riders;
					delete policyHolder.contact.MaxNoClaimBonus;
					delete policyHolder.contact.noClaimBonus;
					delete policyHolder.contact.numberOfOtherRiders;
					delete policyHolder.contact.provisionalLicence;
					delete policyHolder.contact.title;
					delete policyHolder.contact.youngestRider;
					delete policyHolder.contact.youngestRiderDob;
					delete policyHolder.contact.youngestRiderGender;
					delete policyHolder.contact.address;
					delete policyHolder.contact.postalOption;
					delete policyHolder.contact.primaryPhoneNumber;
					delete policyHolder.contact.fiveYears_chargedOrConvicted;
					delete policyHolder.contact.fiveYears_chargedOrConvictedDetails;
					delete policyHolder.contact.isMainRiderMainPolicyHolder;
					delete policyHolder.contact.threeYears_accidentsClaims;
					delete policyHolder.contact.threeYears_accidentsClaimsDetails;
					delete policyHolder.contact.threeYears_restrictedSuspendedDisqualifiedCancelled;
					delete policyHolder.contact.threeYears_restrictedSuspendedDisqualifiedCancelledDetails;
					delete policyHolder.contact.primaryAddress.enrichment;
				}

				if (!!policyHolder.contact.contactType && policyHolder.contact.contactType === 'person') {
					delete policyHolder.contact.authorisedPersons;
				}
				if (!!policyHolder.contact.authorisedPersons) {
					delete policyHolder.contact.dateOfBirth;
					delete policyHolder.contact.firstName;
					delete policyHolder.contact.lastName;
				}
			});


			if ( intermediateRequest.motorcycles[0].sumInsuredType !== 'agreed' ) {
				delete intermediateRequest.motorcycles[0].sumInsuredAmount;
			}

			if ( ! intermediateRequest.email )
				delete intermediateRequest.email ;

			}
		catch (ex) {
			void 0;
		}	
		return intermediateRequest;
	}

	return {
		transform: transform
	}
}

function BikeCoverTypeTransformer(jsonMapper, util, quoteOptions) {
	function transform(intermediateRequest, coverTypeDescriptor) {

		intermediateRequest.motorcycles[0].coverType =  coverTypeDescriptor;

		return intermediateRequest;
	}

	return {
		transform: transform
	}
}

function BikeDefaultValueRequestTransformer(Util, jsonMapper, userInputRepository) {

	function formatDateAndTimeTheGuidewireWay(date, time) {
		var format = "{0} at {1} AEST" ;
		var timeFormatted = '4:00PM' ;
		if ( time )
			timeFormatted = moment().tz("Australia/Sydney").format('h:mma');
		return Util.stringFormat(format, moment().tz("Australia/Sydney").format('Do MMM YYYY') , timeFormatted) ;
	}

	var staticValuesMapping = {
		quoteType:'Full',
		productCode : 'QPYPersonalMotorcycle',
		paymentFrequency: 'everyyear',
		// "anyClaimsQuestion": "unknown",
		// "anyLostLicencesQuestion": "unknown",
		// "anyConvictionsQuestion": "unknown",
		// "anyInfringementsQuestion": "no",

		"motorcycles.0.bikeUsage" : "bike",
		"motorcycles.0.damage": "no_damage",
		"motorcycles.0.isMemberOfClub": false,
		// is the main rider the registered owner of the bike
		"motorcycles.0.isTheMainRider": true,
		"motorcycles.0.motorCycleUsage": "private",
		"motorcycles.0.isFinanced": false,
		"motorcycles.0.isBikeModified": false,
		"motorcycles.0.businessUsage": "courier",
		"motorcycles.0.garageType": "communal_garage",
		"motorcycles.0.motorcycleClub": "other",
		"motorcycles.0.sumInsuredType": "market",
		"motorcycles.0.motorCycleKilometers": "4001_8000km",
		"motorcycles.0.isAccessoriesAdded": false,
		"motorcycles.0.coverType": "comprehensive",
		"motorcycles.0.accessoriesPrice": 0,
		"motorcycles.0.totalModificationsPrice": 0,
		"motorcycles.0.totalAccessoriesPrice": 0,
		"motorcycles.0.accountLocation.addressType": "postal",


		// "motorcycles.0.financeType": "none",
		"motorcycles.0.sumInsuredAmount": "1000",
		// "motorcycles.0.riders.*.person.primaryAddress.addressType": "residential",

		"motorcycles.0.riders.*.licensedToRide": "yes",
		"motorcycles.0.riders.*.rider.currentInsurer": "nocurrentinsurance",
		"motorcycles.0.riders.*.rider.yearsLicenced": "1",
		"motorcycles.0.riders.*.rider.licenceType": "full",
		"motorcycles.0.riders.*.rider.relationWithMainRider": "other",
		"motorcycles.0.riders.*.rider.noClaimBonus": "nil",
		// "motorcycles.0.riders.*.rider.visaType": "distinguishedtalentvisa124",
		"motorcycles.0.riders.*.rider.person.gender": "male",
		"motorcycles.0.riders.*.rider.person.firstName": "An@n",
		"motorcycles.0.riders.*.rider.person.lastName": "An@nym@us",
		"motorcycles.0.riders.*.rider.person.contactType": "person",
		"motorcycles.0.riders.*.rider.person.dateOfBirth": "01/06/2000",
		"policyHolders.*.contact.primaryAddress.addressType": "residential",


		// "email": "a@a.com",
		"motorcycles.0.availableCoverTypes" : [
			"comprehensive",
			"fireandtheft",
			"thirdpartyonly",
			"thirdpartyfiretheft"
        ],
		"motorcycles.0.availableSumInsuredTypes": [
          "market",
          "agreed"
        ],


		"motorcycles.0.excess.ageExcess" : 0,
		"motorcycles.0.excess.flexiExcessExcess" : 0,
		// "motorcycles.0.excess.flexiExcessOptions": [],
		"motorcycles.0.excess.inexperiencedRiderExcess" : 0,
		"motorcycles.0.excess.riderTrainingExcess" : 0,
		"motorcycles.0.excess.standardExcess" : 0,
		"motorcycles.0.excess.theftClaimsExcess" : 0,
		"motorcycles.0.excess.unListedRiderExcess" : 0,

		"policyHolders.0.mainHolder": true,
		"policyHolders.0.contact.contactType": "person",
		"policyHolders.0.contact.firstName": "An@n",
		"policyHolders.0.contact.lastName": "An@nym@us",
		"policyHolders.0.contact.dateOfBirth": "01/06/2000",
		"policyHolders.0.contact.primaryPhone": "mobile",
		// full quote transformation :
        "status" : "Draft",
        "documentDeliveryMethod": 'email',
		"displayStatus": 'Draft',
		"periodStartDateTimeAEDT": formatDateAndTimeTheGuidewireWay(moment(), moment()),
		"periodEndDateTimeAEDT" : formatDateAndTimeTheGuidewireWay(moment().add(1,'years')),
		"channel": 'portal',
		"motorcycles.0.riders.*.riderUsage" : "other"
	}

	function transform(intermediateRequest, userInput) {
		var transformedRequest = jsonMapper.setDefault(userInput, staticValuesMapping) ;
		return transformedRequest;
	}

	return {
		transform: transform
	}
}

function BikeFormatConverterTransformer(Util, jsonMapper) {

	function convertDateAndTimeTheGuidewireWay(dateTime) {
		var format = "{0} at {1} AEST" ;
		return Util.stringFormat(format, dateTime.format('Do MMM YYYY') , dateTime.format('h:mma')) ;
	}

	function convertDate(dateString) {
		var date = moment(dateString, 'DD/MM/YYYY') ;
		var formattedDate = date.format('YYYY-MM-DD') ;
		if ( formattedDate != "Invalid date")
			return formattedDate;


		// throw 'date format exception formatting ' + dateString ;
		return null;
	}
	
	function convertDateToGWTimeZone(dateString) {
		var formattedDate = moment(dateString,'DDMMYYYY').tz("Australia/Sydney").format('YYYY-MM-DD') ;
		if ( formattedDate != "Invalid date")
			return formattedDate;

		return null;
	}

	function convertGender(gender) {
		var gc = {
			male : 'M',
			female : 'F',
			intersex : 'I',
		};

		return gc[gender] ;
	}

	function convertFalsyToUnknown(value) {
		if ( value === null || value === undefined )
			return 'unknown';

		return convertBooleanToYesNo(value) ;
	}

	function convertBooleanToYesNo(value) {
		return value ? 'yes' : 'no' ;
	}

	function convertStringToInt(value) {
		return !!value ? parseInt(value) : value;
	}

	function convertIntToString(value) {
		return !!value ? value.toString() : value;
	}


	var convertValueMapping = {
		'periodStartDate': convertDateToGWTimeZone,

		'policyHolders.*.contact.gender' : convertGender,
		'policyHolders.*.contact.hasClaim' : convertFalsyToUnknown,
		'policyHolders.*.contact.hasConviction' : convertFalsyToUnknown,
		'policyHolders.*.contact.anyLostLicence' : convertFalsyToUnknown,
		'policyHolders.*.contact.anyInfringements' : convertFalsyToUnknown,
		'policyHolders.*.contact.dateOfBirth' : convertDate,
		'policyHolders.*.contact.authorisedPersons.0.person.dateOfBirth' : convertDate,
		'policyHolders.*.contact.authorisedPersons.0.person.gender' : convertGender,


		'motorcycles.0.purchaseDate' : convertDate,

		'motorcycles.0.youngestRiderDOB' : convertDate,
		'motorcycles.0.youngestRiderGender' : convertGender,
		
		'motorcycles.0.motorcycleInfo.modelYear' : convertStringToInt,
		"motorcycles.0.sumInsuredAmount": convertStringToInt,

		// 'motorcycles.0.purchasePrice' : convertIntToString,
		// 'motorcycles.0.sumInsuredAmount' : convertIntToString,
		'motorcycles.0.isFinanced' : convertBooleanToYesNo,

		'motorcycles.0.riders.*.rider.person.dateOfBirth' : convertDate,
		'motorcycles.0.riders.*.rider.person.gender' : convertGender,
		"motorcycles.0.riders.*.rider.hasConviction": convertFalsyToUnknown,
		"motorcycles.0.riders.*.rider.person.hasConviction": convertBooleanToYesNo,
		"motorcycles.0.riders.*.rider.hasClaim": convertFalsyToUnknown,
		"motorcycles.0.riders.*.rider.person.hasClaim": convertBooleanToYesNo,
		"motorcycles.0.riders.*.rider.hasLostLicence": convertFalsyToUnknown,
		"motorcycles.0.riders.*.licensedToRide": convertBooleanToYesNo,
		'motorcycles.0.riders.*.rider.riderHistory.*.year' : convertStringToInt,
		'motorcycles.0.sumInsuredAmount' : convertStringToInt
	};

	function transform(intermediateRequest, userInput) {
		var transformedRequest = jsonMapper.convert(intermediateRequest, convertValueMapping) ;
		return transformedRequest;
	}

	return {
		transform: transform
	}
}

function BikePolicyHolderHandler(Util, publicIDTransformer) {
	function handle(quoteRequest, userInput) {
		var mainPolicyholder = quoteRequest.policyHolders.filter(function (item) {
            return item['mainHolder'];
        })[0];

        var mainRider = quoteRequest.motorcycles[0].riders.filter(function (item) {
            return item['riderUsage'] == 'main';
		})[0];		
		
		if (mainPolicyholder.contact.publicID == mainRider.rider.person.publicID) {
            mainRider.rider.person.passwordQuestion = mainPolicyholder.contact.passwordQuestion;
            mainRider.rider.person.passwordAnswer = mainPolicyholder.contact.passwordAnswer;
            mainRider.rider.person.primaryPhone = mainPolicyholder.contact.primaryPhone;
            
			switch (mainPolicyholder.contact.primaryPhone) {
				case 'mobile':
					mainRider.rider.person.cellPhone = mainPolicyholder.contact.cellPhone;
					break;
				case 'home':
					mainRider.rider.person.homePhone = mainPolicyholder.contact.homePhone;
					break;
				case 'work':
					mainRider.rider.person.workPhone = mainPolicyholder.contact.workPhone;
					break;
            }
		}	

		return quoteRequest;
	}

	return {
		handle: handle
	}
};

'use strict';

function BikePublicIDTransformer(
	Util,
	jsonMapper,
	serviceResponseRepository,
	aggregatedRemoveService
) {
	var currentResponse = null;
	var driverUniqueIdCtr = 1;
	var historyUniqueIdCtr = 1;

	function forgePublicId(moduleName) {
		return Util.stringFormat(
			'portal:{0}-{1}',
			moduleName,
			Util.generateRandomString(15)
		);
	}

	function hasValidGWPublicID(publicID) {
		if (publicID && publicID.indexOf('portal:') === -1) return true;

		return false;
	}

	function hash(value) {
		return md5(value);
	}

	function fetchFromPreviousResponse(path) {
		if (currentResponse)
			return Util.findHierarchyStringInObject(currentResponse, path, '.');

		return null;
	}

	function convertPublicID(path, moduleName) {
		if (currentResponse) {
			var lastPublicID = fetchFromPreviousResponse(path);
			if (lastPublicID) return lastPublicID;
		}

		return forgePublicId(moduleName);
	}

	var moduleNameMapping = {
		policyHolders: 'PolicyHolder[]',
		policyAddress: 'Address',
		motorcycle: 'QPYMotorcycle',
		rider: 'QPYMotorcycleRider',
		policyRider: 'QPYPolicyRider',
		person: 'Person',
		modification: 'QPYCycleModification',
		accessories: 'QPYCycleAccessories',
		riderHistory: 'QPYRiderHistory',
		drivingHistory: 'DrivingHistory',
		pattern: 'qbePattern'
	};

	var publicIDTransformationMapping = {
		'policyAddress.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		},
		'motorcycles.0.publicID': function() {
			return forgePublicId(moduleNameMapping.motorcycle);
		},
		'motorcycles.0.accountLocation.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		},
		'motorcycles.0.qpyCycleModifications.*.publicID': function() {
			return forgePublicId(moduleNameMapping.modification);
		},
		'motorcycles.0.qpyMotorcycleAccessories.*.publicID': function() {
			return forgePublicId(moduleNameMapping.accessories);
		},
		'motorcycles.0.riders.*.publicID': function() {
			return forgePublicId(moduleNameMapping.rider);
		},
		'motorcycles.0.riders.*.uniqueID': function() {
			return driverUniqueIdCtr++;
		},
		'motorcycles.0.riders.*.rider.publicID': function() {
			return forgePublicId(moduleNameMapping.policyRider);
		},
		'motorcycles.0.riders.*.rider.person.publicID': function() {
			return forgePublicId(moduleNameMapping.person);
		},
		'motorcycles.0.riders.*.rider.person.primaryAddress.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		},
		'motorcycles.0.riders.*.rider.riderHistory.*.publicID': function() {
			return forgePublicId(moduleNameMapping.riderHistory);
		},
		'motorcycles.0.riders.*.rider.riderHistory.*.uniqueID': function() {
			return historyUniqueIdCtr++;
		},
		'policyHolders.*.contact.publicID': function() {
			return forgePublicId(moduleNameMapping.person);
		},
		'policyHolders.*.contact.primaryAddress.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		},
		'policyHolders.*.contact.drivingHistory.*.publicID': function() {
			return forgePublicId(moduleNameMapping.drivingHistory);
		}
	};

	var authorisedPersonsPublicIDTransformationMapping = {
		'policyHolders.*.contact.authorisedPersons.0.person.publicID': function() {
			return forgePublicId(moduleNameMapping.person);
		},
		'policyHolders.*.contact.authorisedPersons.0.person.primaryAddress.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		}
	};

	var publicIDConversionMapping = {
		'policyAddress.publicID': function(val) {
			return convertPublicID(
				'policyAddress.publicID',
				moduleNameMapping.policyAddress
			);
		},
		'motorcycles.0.publicID': function(val) {
			return convertPublicID(
				'motorcycles.0.publicID',
				moduleNameMapping.motorcycle
			);
		},
		'motorcycles.0.riders.*.uniqueID': function() {
			return driverUniqueIdCtr++;
		},
		'motorcycles.0.riders.*.rider.riderHistory.*.uniqueID': function() {
			return historyUniqueIdCtr++;
		},
		'motorcycles.0.accountLocation.publicID': function(val) {
			return convertPublicID(
				'motorcycles.0.accountLocation.publicID',
				moduleNameMapping.policyAddress
			);
		},
		'motorcycles.0.qpyCycleModifications.*.publicID': function(
			val,
			mappedValueStarIndex
		) {
			return convertPublicID(
				'motorcycles.0.qpyCycleModifications.' +
					mappedValueStarIndex +
					'.publicID',
				moduleNameMapping.modifications
			);
		},
		'motorcycles.0.qpyMotorcycleAccessories.*.publicID': function(
			val,
			mappedValueStarIndex
		) {
			return convertPublicID(
				'motorcycles.0.qpyMotorcycleAccessories.' +
					mappedValueStarIndex +
					'.publicID',
				moduleNameMapping.accessories
			);
		},
		'policyHolders.*.contact.publicID': function(
			val,
			mappedValueStarIndex
		) {
			return convertPublicID(
				'policyHolders.' + mappedValueStarIndex + '.contact.publicID',
				moduleNameMapping.policyHolders
			);
		},
		'motorcycles.0.riders.*.publicID': function(val, mappedValueStarIndex) {
			return convertPublicID(
				'motorcycles.0.riders.' + mappedValueStarIndex + '.publicID',
				moduleNameMapping.rider
			);
		},
		'motorcycles.0.riders.*.rider.publicID': function(
			val,
			mappedValueStarIndex
		) {
			return convertPublicID(
				'motorcycles.0.riders.' +
					mappedValueStarIndex +
					'.rider.publicID',
				moduleNameMapping.policyRider
			);
		},
		'motorcycles.0.riders.*.rider.person.publicID': function(
			val,
			mappedValueStarIndex
		) {
			return convertPublicID(
				'motorcycles.0.riders.' +
					mappedValueStarIndex +
					'.rider.person.publicID',
				moduleNameMapping.person
			);
		},
		'motorcycles.0.riders.*.rider.person.primaryAddress.publicID': function(
			val,
			mappedValueStarIndex
		) {
			return convertPublicID(
				'motorcycles.0.riders.' +
					mappedValueStarIndex +
					'.rider.person.primaryAddress.publicID',
				moduleNameMapping.policyAddress
			);
		},
		'motorcycles.0.riders.*.rider.riderHistory.*.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'motorcycles.0.riders.' +
					mappedValueStarIndices[0] +
					'.rider.riderHistory.' +
					mappedValueStarIndices[1] +
					'.publicID',
				moduleNameMapping.riderHistory
			);
		},
		'policyHolders.*.contact.primaryAddress.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'policyHolder.' +
					mappedValueStarIndices[0] +
					'.contact.primaryAddress.publicID',
				moduleNameMapping.policyAddress
			);
		},
		'policyHolders.*.contact.drivingHistory.*.publicID': function(
			val,
			mappedValueStarIndex
		) {
			return convertPublicID(
				'policyHolders.' +
					mappedValueStarIndex[0] +
					'.contact.drivingHistory.' +
					mappedValueStarIndex[1] +
					'.publicID',
				moduleNameMapping.drivingHistory
			);
		}
	};

	var authorisedPersonsPublicIDConversionMapping = {
		'policyHolders.*.contact.authorisedPersons.0.person.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'policyHolders.' +
					mappedValueStarIndices[0] +
					'.contact.authorisedPersons.0.person.publicID',
				moduleNameMapping.person
			);
		},
		'policyHolders.*.contact.authorisedPersons.0.person.primaryAddress.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'policyHolders.' +
					mappedValueStarIndices[0] +
					'.contact.authorisedPersons.0.person.primaryAddress.publicID',
				moduleNameMapping.policyAddress
			);
		}
	};

	function removeDeletedAdditionalRiders(transformedRequest) {
		var removedRiders = aggregatedRemoveService.getList()
			? aggregatedRemoveService.getList()['rider']
			: null;
		var savedRiders = fetchFromPreviousResponse('motorcycles.0.riders');
		if (savedRiders && removedRiders) {
			angular.forEach(removedRiders, function(removedRider) {
				var matchingRider = savedRiders.filter(function(rider) {
					return (
						rider.rider.person.firstName ==
							removedRider.person.firstName &&
						rider.rider.person.lastName ==
							removedRider.person.lastName
					);
				});
				matchingRider = matchingRider[0] || null;
				if (matchingRider) {
					matchingRider.markedForDelete = true;
					transformedRequest.motorcycles[0].riders.push(
						matchingRider
					);
				}
			});
			aggregatedRemoveService.clear('rider');
		}

		return transformedRequest;
	}

	function removeDeletedRiderHistoryArrays(transformedRequest) {
		var riders = transformedRequest.motorcycles[0].riders;
		angular.forEach(riders, function(rider, index) {
			var savedHistories = fetchFromPreviousResponse(
				'motorcycles.0.riders.' + index + '.rider.riderHistory'
			);
			if (savedHistories && savedHistories.length > 0) {
				var riderHistories = rider.rider.riderHistory;
				angular.forEach(savedHistories, function(savedHistory) {
					var matchingInput = riderHistories.filter(function(
						history
					) {
						return history.publicID == savedHistory.publicID;
					});
					if (!matchingInput || matchingInput.length == 0) {
						savedHistory.markedForDelete = true;
						riderHistories.push(savedHistory);
					}
				});
			}
		});
		return transformedRequest;
	}

	function removeEmptyRiderHistoryArrays(transformedRequest) {
		var motorcycle = transformedRequest.motorcycles[0];
		if (motorcycle && motorcycle.riders) {
			motorcycle.riders.forEach(function(policyRider) {
				if (
					policyRider.rider &&
					policyRider.rider.riderHistory &&
					Array.isArray(policyRider.rider.riderHistory) &&
					policyRider.rider.riderHistory.length == 0
				)
					delete policyRider.rider.riderHistory;
			});
		}

		return transformedRequest;
	}

	//dd-973 - requiring a sequence number for driver infringement
	function addUniqueHistoryID(transformedRequest) {
		var drivers = transformedRequest.motorcycles[0].riders;

		angular.forEach(drivers, function(driver, index) {
			historyUniqueIdCtr = 1;
			var driverHistory = driver.rider.riderHistory;
			if (driverHistory) {
				angular.forEach(driverHistory, function(driverHistory, index) {
					driverHistory.uniqueID = historyUniqueIdCtr;
					historyUniqueIdCtr++;
				});
			}
		});
		return transformedRequest;
	}

	function transform(intermediateRequest, response) {
		currentResponse = response;
		driverUniqueIdCtr = 1;
		var transformedRequest = intermediateRequest;

		if (
			transformedRequest.policyHolders[0] &&
			transformedRequest.policyHolders[0].contact &&
			transformedRequest.policyHolders[0].contact.authorisedPersons
		) {
			publicIDConversionMapping = Object.extend(
				publicIDConversionMapping,
				authorisedPersonsPublicIDConversionMapping
			);
			publicIDTransformationMapping = Object.extend(
				publicIDTransformationMapping,
				authorisedPersonsPublicIDTransformationMapping
			);
		}

		if (!currentResponse)
			transformedRequest = jsonMapper.transform(
				intermediateRequest,
				publicIDTransformationMapping
			);
		else {
			transformedRequest = jsonMapper.convert(
				intermediateRequest,
				publicIDConversionMapping
			);
		}

		transformedRequest = addUniqueHistoryID(transformedRequest);
		transformedRequest = removeDeletedAdditionalRiders(transformedRequest);
		transformedRequest = removeDeletedRiderHistoryArrays(
			transformedRequest
		);
		transformedRequest = removeEmptyRiderHistoryArrays(transformedRequest);

		return transformedRequest;
	}

	return {
		transform: transform
	};
}

function BikeQuoteResultModel(quoteResultResponse) {
	this.isCoverAvailable = quoteResultResponse.quoteResult.totalPremium !== undefined ;
	this.coverType = quoteResultResponse.motorcycles[0].coverType;
	this.sumInsuredAmount = quoteResultResponse.motorcycles[0].sumInsuredAmount;
	this.quoteResult = quoteResultResponse.quoteResult;
	this.paymentPlan = quoteResultResponse.paymentPlan;
	this.totalPremium = quoteResultResponse.quoteResult.totalPremium ;
	this.totalFSL = quoteResultResponse.quoteResult.totalFSL ;
	this.totalGST = quoteResultResponse.quoteResult.totalGST ;
	this.totalStampDuty = quoteResultResponse.quoteResult.totalStampDuty ;
	this.premiumAfterDiscount = quoteResultResponse.quoteResult.premiumAfterDiscount ;
	this.totalPremium = quoteResultResponse.quoteResult.totalPremium ;
	this.paymentFrequency = quoteResultResponse.paymentPlan ? quoteResultResponse.paymentPlan.paymentFrequency : null ;
	this.excess = quoteResultResponse.motorcycles[0].excess ;
	this.availableSumInsuredTypes = quoteResultResponse.motorcycles[0].availableSumInsuredTypes;
	this.motorcycleValue = {
		upper: quoteResultResponse.motorcycles[0].agreedValueUpper,
		lower: quoteResultResponse.motorcycles[0].agreedValueLower
	};
	this.coverageOptions = quoteResultResponse.motorcycles[0].coverageOptions;
	this.response = quoteResultResponse ;

}

function BikeRetrieveSavedQuoteResponseTransformer($filter, jsonMapper, Util) {
    // transform functions
    var transformers = {
        camelcase: function(value) {
            if(value) {
                return value.charAt(0).toUpperCase() + value.slice(1);
            }
        },
        date: function(dateString) {
            var date = moment(dateString, 'YYYY-MM-DD') ;
            return date.format('DD/MM/YYYY') ;
        },
		today : function() {
			return moment().tz("Australia/Sydney").format('DD/MM/YYYY') ;
		},
        financeType: function(financeType) {
            switch(financeType) {
                case 'none':
                    return '';
                    break;
            }
        },
        convertGender: function(gender) {
            var gc = {
                M : 'male',
                F : 'female',
                I : 'intersex',
            };
            return gc[gender] ;
        },
        yesNo: function(value) {
            return value == 'yes' ? true : false;
        },
        checkbox: function(value) {
        },
        state: function(state) {
            if ( state )
                return state.replace('AU_', '');
        },
        coverType: function(coverType) {
            if(coverType === 'third_party' || coverType === 'third_party_fire_theft') {
                return 'third_party';
            }
            return coverType;
        },
        purchaseMonthFromMonthYear: function(monthYear) {
            if(monthYear){
                return monthYear.split('-')[1];
            }else{
                return '';
            }

        },
        purchaseYearFromMonthYear: function(monthYear) {
            if(monthYear){
                return monthYear.split('-')[0];
            }else{
                return '';
            }
        },
        thirdPartyPref: function(coverType) {
            if(coverType === 'comprehensive') {
                return null;
            }
            return coverType;
        },
		modifications: function(mod) {
			if (!!mod) {
				var values = [{"label":"Big bore kit","value":"big_bore_kit"},{"label":"Cam modified","value":"cam_modified"},{"label":"Custom paint","value":"custom_paint"},{"label":"Frame – non standard","value":"frame_non_standard"},{"label":"Modified exhaust","value":"modified_exhaust"},{"label":"Modified or non-standard engine","value":"modified_or_non-standard_engine"},{"label":"Modified or non-standard fuel system","value":"modified_or_non-standard_fuel_system"},{"label":"Modified suspension","value":"modified_suspension"},{"label":"Nitrous oxide","value":"nitrous_oxide"},{"label":"Other modifications and customisations","value":"other_modifications_and_customisations"},{"label":"Side car","value":"side_car"},{"label":"Supercharged","value":"supercharged"},{"label":"Turbo charged","value":"turbo_charged"},{"label":"Wheels – non standard","value":"wheels_non_standard"}];
				return values.find(function(o) {
					return o.value === mod;
				}).label;
			}
		},
		accessories: function(accessory) {
			if (!!accessory) {
				var values = [{"label":"Aftermarket levers (brake and clutch)","value":"Aftermarketleversbrakeandclutch"},{"label":"Air filter","value":"Airfilter"},{"label":"Bash plate","value":"Bashplate"},{"label":"Braided brake lines","value":"Braidedbrakelines"},{"label":"Brake discs","value":"Brakediscs"},{"label":"Burglar alarm","value":"Burglaralarm"},{"label":"Carbon fibre guards","value":"Carbonfibreguards"},{"label":"Centre stand","value":"Centrestand"},{"label":"Crash bars","value":"Crashbars"},{"label":"Fender eliminator","value":"Fendereliminator"},{"label":"Foot pegs","value":"Footpegs"},{"label":"Forward controls","value":"Forwardcontrols"},{"label":"GPS","value":"GPS"},{"label":"Gear shift lever","value":"Gearshiftlever"},{"label":"Hand guards","value":"Handguards"},{"label":"Hand Grips","value":"HandGrips"},{"label":"Handlebars","value":"Handlebars"},{"label":"Headlight Protectors","value":"HeadlightProtectors"},{"label":"Immobiliser","value":"Immobiliser"},{"label":"Indicators","value":"Indicators"},{"label":"Instrument clusters","value":"Instrumentclusters"},{"label":"Intercom system","value":"Intercomsystem"},{"label":"Kill switch","value":"Killswitch"},{"label":"Lights","value":"Lights"},{"label":"Mirrors","value":"Mirrors"},{"label":"Motorcycle rack","value":"Motorcyclerack"},{"label":"Oggy knobs","value":"Oggyknobs"},{"label":"On road costs","value":"Onroadcosts"},{"label":"Panniers","value":"Panniers"},{"label":"Power commander","value":"Powercommander"},{"label":"Radiator guard","value":"Radiatorguard"},{"label":"Rear hugger","value":"Rearhugger"},{"label":"Saddle bags","value":"Saddlebags"},{"label":"Seat sissy bar","value":"Seatsissybar"},{"label":"Steering damper","value":"Steeringdamper"},{"label":"Stereo","value":"Stereo"},{"label":"Tank bag","value":"Tankbag"},{"label":"Tank pad","value":"Tankpad"},{"label":"Tank protector","value":"Tankprotector"},{"label":"Top Box","value":"TopBox"},{"label":"Windshield","value":"Windshield"},{"label":"Other non-standard accessories","value":"Othernon-standardaccessories"}];
				return values.find(function(o) {
					return o.value === accessory;
				}).label;
			}
		},
		yearsHeld: function(years) {
			var yearsHeld;

			switch (years) {
				case '0':
					yearsHeld = 'lessThan_1';
					break;
				case '6':
					yearsHeld = 'greaterThan_5';
					break;
				default:
					yearsHeld = years;
			}

			return yearsHeld;
		},
    };
    function transformPerson(person) {
        var transformMapping = {
                'returnObject.title':                                   '=_input.prefix',
                'returnObject.firstName':                               '=_input.firstName',
                'returnObject.lastName':                                '=_input.lastName',
                'returnObject.gender':                                  '=_input.gender',
                'returnObject.dateOfBirth':                             '=_input.dateOfBirth'
            },
            convertMapping = {
                'returnObject.title':                                   transformers.camelcase,
                'returnObject.gender':                                  transformers.convertGender,
                'returnObject.dateOfBirth':                             transformers.date
            };
        var transformedPerson = jsonMapper.convert(jsonMapper.transform(person, transformMapping), convertMapping);
        return transformedPerson.returnObject;
    }

    function transformRider(rider) {
        var transformMapping = {
        	'returnObject.yearsHeld':                                       		'=_input.rider.yearsLicenced',
            'returnObject.licenceType':                                     		'=_input.rider.licenceType',
            'returnObject.noClaimBonus':                                    		'=_input.rider.noClaimBonus',
            'returnObject.previousInsurer':                                 		'=_input.rider.currentInsurer',
            'returnObject.licensedToRide':                                  		'=_input.licensedToRide',
			'returnObject.threeYears_accidentsClaims': 								'=_input.rider.hasClaim',
			'returnObject.fiveYears_chargedOrConvicted': 							'=_input.rider.hasConviction',
			'returnObject.threeYears_restrictedSuspendedDisqualifiedCancelled': 	'=_input.rider.hasLostLicence',
			'returnObject.visaType':											 	'=_input.rider.visaType',
            },
            convertMapping = {
				'returnObject.yearsHeld':                                   		transformers.yearsHeld,
                'returnObject.licensedToRide':                              		transformers.yesNo,
				'returnObject.threeYears_accidentsClaims': 							transformers.yesNo,
				'returnObject.fiveYears_chargedOrConvicted': 						transformers.yesNo,
				'returnObject.threeYears_restrictedSuspendedDisqualifiedCancelled':	transformers.yesNo
            };

		var mappedRider = jsonMapper.transform(rider, transformMapping);
        var transformedRider = jsonMapper.convert(mappedRider, convertMapping);
        if(rider.rider.person) {
            transformedRider.returnObject.person = transformPerson(rider.rider.person);
        }

        // extract rider history
		transformedRider.returnObject.threeYears_accidentsClaimsDetails = [];
		transformedRider.returnObject.fiveYears_chargedOrConvictedDetails = [];
		transformedRider.returnObject.threeYears_restrictedSuspendedDisqualifiedCancelledDetails = [];

		if (!!rider.rider.riderHistory) {
			rider.rider.riderHistory.forEach(function(record) {
				switch (record.pattern.filter1) {
					case 'claim' :
						transformedRider.returnObject.threeYears_accidentsClaimsDetails.push(
							extractHistory(globals.threeYears_accidentsClaimsDetails.options, record));
						break;
					case 'conviction' :
						transformedRider.returnObject.fiveYears_chargedOrConvictedDetails.push(
							extractHistory(globals.fiveYears_chargedOrConvictedDetails.options, record)
						);
						break;
					default: {
						transformedRider.returnObject.threeYears_restrictedSuspendedDisqualifiedCancelledDetails.push(
							extractHistory(globals.threeYears_restrictedSuspendedDisqualifiedCancelledDetails.options, record)
						);
						break;
					}
				}
			});
		}
        return transformedRider.returnObject;
    }

    function extractHistory(collection, record) {
		var matchedPattern = {};
		var month = {};
		var year = {};

		matchedPattern = collection.find(function(opt) {
			return opt.publicID == record.pattern.publicID;
		});
		month.label = month.value = Util.capitalize(record.month.toString());
		year.label = year.value = Util.capitalize(record.year.toString());

		record.description = matchedPattern;
		record.month = month;
		record.year = year;

		delete record.pattern;

    	return record;
	}

	function extractPolicyHolderHistory(collection, record) {
		var matchedPattern = {};
		var month = {};
		var year = {};

		matchedPattern = collection.find(function(opt) {
			return opt.publicID = record.riderPattern.publicID;
		});
		month.label = month.value = Util.capitalize(record.riderMonth.toString());
		year.label = year.value = Util.capitalize(record.year.toString());

		record.description = matchedPattern;
		record.month = month;
		record.year = year;

		delete record.pattern;

    	return record;
	}

    function transformPolicyHolder(holder) {
        var transformMapping = {
			'returnObject.title':                                           		'=_input.prefix',
			'returnObject.firstName':                                       		'=_input.firstName',
			'returnObject.lastName':                                        		'=_input.lastName',
			'returnObject.gender':                                          		'=_input.gender',
			'returnObject.dateOfBirth':                                     		'=_input.dateOfBirth',
			// 'returnObject.threeYears_accidentsClaims': 								'=_input.rider.hasClaim',
			// 'returnObject.fiveYears_chargedOrConvicted': 							'=_input.rider.hasConviction',
			// 'returnObject.threeYears_restrictedSuspendedDisqualifiedCancelled': 	'=_input.rider.hasLostLicence',
		},
		convertMapping = {
			'returnObject.title':                                       		transformers.camelcase,
			'returnObject.gender':                                      		transformers.convertGender,
			'returnObject.dateOfBirth':                                 		transformers.date,
			// 'returnObject.threeYears_accidentsClaims': 							transformers.yesNo,
			// 'returnObject.fiveYears_chargedOrConvicted': 						transformers.yesNo,
			// 'returnObject.threeYears_restrictedSuspendedDisqualifiedCancelled':	transformers.yesNo
		};

        var transformedPolicyHolder = jsonMapper.convert(jsonMapper.transform(holder, transformMapping), convertMapping);

		//region Policy Holder driving history
		transformedPolicyHolder.returnObject.threeYears_accidentsClaims = false;
		transformedPolicyHolder.returnObject.threeYears_accidentsClaimsDetails = [];
		transformedPolicyHolder.returnObject.threeYears_restrictedSuspendedDisqualifiedCancelled = false;
		transformedPolicyHolder.returnObject.threeYears_restrictedSuspendedDisqualifiedCancelledDetails = [];
		transformedPolicyHolder.returnObject.fiveYears_chargedOrConvicted = false;
		transformedPolicyHolder.returnObject.fiveYears_chargedOrConvictedDetails = [];

		if (!!holder.drivingHistory) {
			holder.drivingHistory.forEach(function(record) {
				switch(record.riderPattern.filter1) {
					case 'claim' :
						transformedPolicyHolder.returnObject.threeYears_accidentsClaims = true;
						transformedPolicyHolder.returnObject.threeYears_accidentsClaimsDetails.push(
							extractPolicyHolderHistory(globals.threeYears_accidentsClaimsDetails.options, record));
						break;
					case 'conviction' :
						transformedPolicyHolder.returnObject.fiveYears_chargedOrConvicted = true;
						transformedPolicyHolder.returnObject.fiveYears_chargedOrConvictedDetails.push(
							extractPolicyHolderHistory(globals.fiveYears_chargedOrConvictedDetails.options, record)
						);
						break;
					default: {
						transformedPolicyHolder.returnObject.threeYears_restrictedSuspendedDisqualifiedCancelled = true;
						transformedPolicyHolder.returnObject.threeYears_restrictedSuspendedDisqualifiedCancelledDetails.push(
							extractPolicyHolderHistory(globals.threeYears_restrictedSuspendedDisqualifiedCancelledDetails.options, record)
						);
						break;
					}
				}
			});
		}
		// endregion

        return transformedPolicyHolder.returnObject;
    }

    /**
     * Transforms the retrievedQuoteResponse into a format that can be injected into the userInputRepository
     * The returned value will populate all the forms in the quote process
     * @param {Object} retrievedQuoteResponse                   Response object from the retrieveSavedQuote service
     * @returns {Object}                                        Transformed object ready to inject into the userInputRepository
     */
    function transform(retrievedQuoteResponse) {
    	void 0;
    	void 0;
        var transformMapping = {
				// getStarted
				// 'vehicleForm.getStarted.paymentOptions':         '=_input.?',
				'returnObject.getStarted.policyStartDate':
					'=_input.periodStartDate', // find where this comes from
				'returnObject.getStarted.personOrCompany':
					'=_input.policyHolders.0.contact.contactType',

				//tell us a bit more -------------------------------------
				'returnObject.tellUsABitMore.yourEmailAddress': '=_input.email',
				'returnObject.tellUsABitMore.promotionalCode':
					'=_input.campaignCode',

				// aboutYourBike
				'returnObject.address': '=_input.motorcycles.0.accountLocation',
				'returnObject.motorcycleInfo':
					'=_input.motorcycles.0.motorcycleInfo',
				'returnObject.aboutYourBike.purchaseDate':
					'=_input.motorcycles.0.purchaseDate',
				'returnObject.aboutYourBike.bikeCost':
					'=_input.motorcycles.0.purchasePrice',

				// Modifications and Accessories
				'returnObject.modificationsAccessories.modifications':
					'=_input.motorcycles.0.isBikeModified',
				'returnObject.modificationsAccessories.accessories':
					'=_input.motorcycles.0.isAccessoriesAdded',

				// Bike Details
				'returnObject.bikeDetails.locationParked':
					'=_input.motorcycles.0.garageType',
				'returnObject.bikeDetails.isItFinanced':
					'=_input.motorcycles.0.isFinanced',
				'returnObject.bikeDetails.financeWith':
					'=_input.motorcycles.0.financier',
				'returnObject.bikeDetails.kilometres':
					'=_input.motorcycles.0.motorCycleKilometers',
				'returnObject.bikeDetails.primaryBikeUse':
					'=_input.motorcycles.0.motorCycleUsage',
				'returnObject.bikeDetails.businessActivityType':
					'=_input.motorcycles.0.businessUsage',
				'returnObject.bikeDetails.commercialActivityType':
					'=_input.motorcycles.0.businessUsage',
				'returnObject.bikeDetails.existingDamage':
					'=_input.motorcycles.0.damage',

				//driver
				// 'vehicleForm.driver.paymentOptions':             '=_input.?',

				//quote
				// 'returnObject.insuredExcessValue.coverType':                            '=_input.vehicles.0.coverType',
				// 'returnObject.insuredExcessValue.comprehensivePref':                    '=_input.vehicles.0.sumInsuredType',
				// 'returnObject.insuredExcessValue.thirdPartyOrThirdPartyFireAndTheft':   '=_input.vehicles.0.coverType',
				// 'returnObject.insuredExcessValue.vehicleExcess':                        '=_input.vehicles.0.excess.voluntaryVehicleExcessOptions',
				// 'returnObject.insuredExcessValue.standardVehicleExcess':                '=_input.vehicles.0.excess.standardVehicleExcess',
				// 'returnObject.insuredExcessValue.voluntaryVehicleExcess':               '=_input.vehicles.0.excess.voluntaryVehicleExcess',
				// 'returnObject.insuredExcessValue.ageExcessTier1':                       '=_input.vehicles.0.excess.ageExcessTier1',
				// 'returnObject.insuredExcessValue.ageExcessTier2':                       '=_input.vehicles.0.excess.ageExcessTier2',
				// 'returnObject.insuredExcessValue.undeclaredDriverTier2':                '=_input.vehicles.0.excess.undeclaredDriverTier2',
				// 'returnObject.insuredExcessValue.inexperiencedDriver':                  '=_input.vehicles.0.excess.inexperiencedDriver',
				// 'returnObject.insuredExcessValue.agreedValue':                          '=_input.vehicles.0.sumInsuredAmount',

				// optional benefits
				// 'returnObject.optionalBenefits.QPMMotVehHireCar':                   '=_input.vehicles.0.coverageOptions.0.selected',
				// 'returnObject.optionalBenefits.QPMMotVehWindscreen':                '=_input.vehicles.0.coverageOptions.1.selected',
				// 'returnObject.optionalBenefits.QPMMotVehNCB':                       '=_input.vehicles.0.coverageOptions.2.selected',

				// registration details
				'returnObject.tellUsYourRegoNumber.regoNumber':
					'=_input.motorcycles.0.registrationNumber',
				// 'returnObject.vehicleInfo':     			        '=_input.vehicles.0.vehicleInfo',
				// 'returnObject.retrievedQuoteRego.rego':             '=_input.vehicles.0.registrationNumber',
				// 'returnObject.retrievedQuoteRego.state':            '=_input.vehicles.0.garageAddress.state'
				// Contact
				'returnObject.mainPolicyHolderContact.passwordQuestion':
					'=_input.policyHolders.0.contact.passwordQuestion',
				'returnObject.mainPolicyHolderContact.passwordAnswer':
					'=_input.policyHolders.0.contact.passwordAnswer',
				'returnObject.mainPolicyHolderContact.primaryPhone':
					'=_input.policyHolders.0.contact.primaryPhone'
			},
			convertMapping = {
				'returnObject.aboutYourBike.purchaseDate': transformers.date,
				'returnObject.bikeDetails.isItFinanced': transformers.yesNo,
				'returnObject.getStarted.policyStartDate': transformers.date
				// 'returnObject.rider.isTheMainRider':									transformers.yesNo,
				// 'returnObject.rider.isMemberOfClub':									transformers.yesNo

				// 'returnObject.carDetails.colour':                                       transformers.camelcase,
				// 'returnObject.carDetails.carFinance':                        			transformers.financeType,
				// 'returnObject.retrievedQuoteRego.state':                                transformers.state,
				// 'returnObject.insuredExcessValue.coverType':                            transformers.coverType,
				// 'returnObject.insuredExcessValue.thirdPartyOrThirdPartyFireAndTheft':   transformers.thirdPartyPref,
				// 'returnObject.carDetails.whenDidYouBuyYear':                            transformers.purchaseMonthFromMonthYear,
				// 'returnObject.carDetails.whenDidYouBuyMonth':                           transformers.purchaseYearFromMonthYear
			};
        var transformedQuote = jsonMapper.convert(jsonMapper.transform(retrievedQuoteResponse, transformMapping), convertMapping);

        // region set comprehensive preference to null if the coverType is third party
        /*if(retrievedQuoteResponse.motorcycles[0].coverType.length && retrievedQuoteResponse.motorcycles[0].sumInsuredType.length) {
            var coverType = retrievedQuoteResponse.motorcycles[0].coverType;
            if(coverType === 'third_party' || coverType === 'third_party_fire_theft') {
                transformedQuote.returnObject.insuredExcessValue.comprehensivePref = null;
            }
        }*/
		// endregion

        // region Mods and Accessories
		if (retrievedQuoteResponse.motorcycles[0].qpyCycleModifications) {
			var mods = retrievedQuoteResponse.motorcycles[0].qpyCycleModifications;

			transformedQuote.returnObject.modificationsAccessories.modificationsTable = mods.map(function(mod) {
				return {
					'modification' : {
							'label' : transformers.modifications(mod.modification),
							'value' : mod.modification
					},
					'modificationValue' : mod.purchasePrice
				}
			});
		}
		if (retrievedQuoteResponse.motorcycles[0].qpyMotorcycleAccessories) {
			var acc = retrievedQuoteResponse.motorcycles[0].qpyMotorcycleAccessories;

			transformedQuote.returnObject.modificationsAccessories.accessoriesTable = acc.map(function(accessory) {
				return {
					'accessories' : {
						'label' : transformers.accessories(accessory.accessory),
						'value' : accessory.accessory
					},
					'accessoryValue' : accessory.purchasePrice
				}
			});
		}
		// endregion

        // region Sort drivers to put mainRider first in the list
        if(retrievedQuoteResponse.motorcycles && retrievedQuoteResponse.motorcycles.length && retrievedQuoteResponse.motorcycles[0].riders) {
            var riders = $filter('orderBy')(retrievedQuoteResponse.motorcycles[0].riders, function(rider) {
                return rider.riderUsage == 'main' ? 0 : 1;
            });
            transformedQuote.returnObject.rider = {};
            transformedQuote.returnObject.rider.riders = [];
            riders.forEach(function(rider, index) {
                transformedQuote.returnObject.rider.riders.push(transformRider(rider));

				if (index === 0) {
					// License and insurance details
					transformedQuote.returnObject.rider.riders[0].isTheMainRider = retrievedQuoteResponse.motorcycles[0].isTheMainRider;
					transformedQuote.returnObject.rider.riders[0].isMemberOfClub = retrievedQuoteResponse.motorcycles[0].isMemberOfClub;
					transformedQuote.returnObject.rider.riders[0].motorcycleClub = retrievedQuoteResponse.motorcycles[0].motorcycleClub;
				}
            });
        }
        // endregion

        // region set contact policy holders
        if(!!retrievedQuoteResponse.policyHolders && !!retrievedQuoteResponse.policyHolders.length) {
            var policyHolders = retrievedQuoteResponse.policyHolders;
			var response = retrievedQuoteResponse;

            transformedQuote.returnObject.mainPolicyHolder = {};

            policyHolders.forEach(function(holder, index) {
                if(holder.mainHolder) {
                    transformedQuote.returnObject.mainPolicyHolder = transformPolicyHolder(holder.contact);
                    transformedQuote.returnObject.mainPolicyHolder.isMainRiderMainPolicyHolder = true;

					transformedQuote.returnObject.mainPolicyHolderContact = holder.contact;
					transformedQuote.returnObject.mainPolicyHolderContact
						.personalContactDetailsMailingPreference = response.documentDeliveryMethod;
					
					// if (transformedQuote.returnObject.mainPolicyHolderContact.returnObject !== undefined
					// 	&& transformedQuote.returnObject.mainPolicyHolderContact.returnObject.dateOfBirth) {
					// 		transformedQuote.returnObject.mainPolicyHolderContact.returnObject.dateOfBirth =
					// 			transformers.date(transformedQuote.returnObject.mainPolicyHolderContact.returnObject.dateOfBirth);
					// }

						// set primary phone number to mobile phone
					if(response.policyHolders[0].contact.cellPhone) {
						transformedQuote.returnObject.mainPolicyHolderContact.primaryPhoneNumber = response.policyHolders[0].contact.cellPhone;
					}

					// set primary phone number to home phone
					if(response.policyHolders[0].contact.homePhone) {
						transformedQuote.returnObject.mainPolicyHolderContact.primaryPhoneNumber = response.policyHolders[0].contact.homePhone;
					}

					// set primary phone number to work phone
					if(response.policyHolders[0].contact.workPhone) {
						transformedQuote.returnObject.mainPolicyHolderContact.primaryPhoneNumber = response.policyHolders[0].contact.workPhone;
					}	
					
					if (holder.contact.contactType === 'company') {
						transformedQuote.returnObject.aboutCompany = {};
						transformedQuote.returnObject.aboutCompany.name = holder.contact.name;
						transformedQuote.returnObject.aboutCompany.abn = holder.contact.abn;
						transformedQuote.returnObject.aboutCompany.email = holder.contact.emailAddress1;
						transformedQuote.returnObject.aboutCompany.officePhone = holder.contact.workPhone;
						transformedQuote.returnObject.aboutCompany.companyAddress = holder.contact.primaryAddress;

						transformedQuote.returnObject.companyContact = {};
						var authorisedPerson = holder.contact.authorisedPersons[0].person;

						if (response.policyAddress.addressLine1 === authorisedPerson.primaryAddress.addressLine1 &&
							response.policyAddress.postalCode === authorisedPerson.primaryAddress.postalCode) {
							transformedQuote.returnObject.companyContact.companyContactDetailsPostalOption = true;
						}
						else {
							transformedQuote.returnObject.companyContact.companyContactDetailsPostalOption = false;
						}
						transformedQuote.returnObject.companyContact.companyContactTitle = authorisedPerson.prefix;
						transformedQuote.returnObject.companyContact.companyContactFirstName = authorisedPerson.firstName;
						transformedQuote.returnObject.companyContact.companyContactLastName = authorisedPerson.lastName;
						transformedQuote.returnObject.companyContact.companyContactGender = authorisedPerson.gender;
						transformedQuote.returnObject.companyContact.companyContactDateOfBirth = transformers.date(authorisedPerson.dateOfBirth);
						transformedQuote.returnObject.companyContact.companyContactDetailsAddress = authorisedPerson.primaryAddress;
						transformedQuote.returnObject.companyContact.companyContactDetailsEmail = authorisedPerson.emailAddress1;
						transformedQuote.returnObject.companyContact.companyContactDetailsPostalAddress = response.policyAddress;
						transformedQuote.returnObject.companyContact.companyContactDetailsMailingPreference =
							response.documentDeliveryMethod;
						transformedQuote.returnObject.companyContact.primaryPhone = authorisedPerson.primaryPhone;
						transformedQuote.returnObject.companyContact.preferredNumber = authorisedPerson.homePhone || authorisedPerson.workPhone || authorisedPerson.cellPhone;
						transformedQuote.returnObject.companyContact.passwordQuestion = holder.contact.passwordQuestion;
						transformedQuote.returnObject.companyContact.enterAQuestion = holder.contact.passwordQuestionStr || '';
						transformedQuote.returnObject.companyContact.passwordAnswer = holder.contact.passwordAnswer;
					}
                } else {
					if (index === 1) {
						transformedQuote.returnObject.additionalPolicyHolders = {};
						transformedQuote.returnObject.additionalPolicyHolders.policyHolders = [];
					}
					transformedQuote.returnObject.additionalPolicyHolders.policyHolders.push(transformPolicyHolder(holder.contact));
                }
            });

        }
        // endregion

        void 0;
        void 0;

        return transformedQuote.returnObject;
    }
    return {
        transform: transform
    }
}

function BikeStructureRequestTransformer(
	jsonMapper,
	util,
	quoteOptions,
	storage
) {
	var structureQuoteMapping = {
		periodStartDate: '=_input.bikeForm.getStarted.policyStartDate',
		motorcycles: [],
		'motorcycles.0': {},
		'motorcycles.0.sumInsuredType':
			'=_input.bikeForm.insuredExcessValue.comprehensivePref',
		'motorcycles.0.sumInsuredAmount': '=_regoSearch.goodRetailPrice',
		'motorcycles.0.otherRidersCount':
			'=_input.bikeForm.rider.numberOfOtherRiders',
		'motorcycles.0.motorcycleInfo':
			'=_input.bikeForm.aboutYourBike.yearMakeModelResponse',
		'motorcycles.0.accountLocation': '=_addressSearch',
		'motorcycles.0.purchasePrice':
			'=_input.bikeForm.aboutYourBike.bikeCost',
		'motorcycles.0.purchaseDate':
			'=_input.bikeForm.aboutYourBike.purchaseDate',
		'motorcycles.0.youngestRiderDateOfBirth':
			'=_input.bikeForm.rider.youngestRiderDob',
		'motorcycles.0.isBikeModified':
			'=_input.bikeForm.modificationsAccessories.modifications',
		'motorcycles.0.isAccessoriesAdded':
			'=_input.bikeForm.modificationsAccessories.accessories',

		'motorcycles.0.riders': [],
		'motorcycles.0.riders.0.licensedToRide':
			'_input.bikeForm.riders[0].licensedToRide',

		policyHolders: [],
		'policyHolders.*.contact.prefix':
			'=_input.bikeForm.rider.riders[0].person.title',
		'policyHolders.0': {},
		'policyHolders.0.contact.gender': '=_input.bikeForm.rider.gender',
		'policyHolders.0.contact.dateOfBirth':
			'=_input.bikeForm.rider.dateOfBirth',
		'policyHolders.0.contact.emailAddress1':
			'=_input.bikeForm.yourEmail.email',
		'policyHolders.0.contact.primaryAddress': '=_addressSearch',
		'policyHolders.0.contact.contactType':
			'=_input.bikeForm.getStarted.personOrCompany',

		policyAddress: '=_addressSearch',
		'policyAddress.addressType': 'postal',

		email: '=_input.email',
		campaignCode: '=_input.bikeForm.promotionalCode.promotionalCode',
		mainContactAddress: '=_addressSearch-main-contact',
		postalAddress: '=_addressSearch-postal-address'
	};

	// region Step 1
	function updateIsMotorRegistered(transformedRequest) {
		try {
			var bike = transformedRequest.motorcycles[0];

			if (bike.coverType === 'fireandtheft') {
				bike.isMotorRegistered = false;
			}
			if (bike.isMotorRegistered === undefined) {
				bike.isMotorRegistered = true;
			}
		} catch (ex) {
			void 0;
		}

		return transformedRequest;
	}

	function updatePolicyHolderPrimaryAddress(transformedRequest) {
		try {
			var policyHolder = transformedRequest.policyHolders[0];

			if (!!policyHolder.contact.primaryAddress) {
				policyHolder.contact.primaryAddress.addressType = 'residential';
			}

			transformedRequest.policyHolders[0] = policyHolder;
		}
		catch (ex) {
			void 0;
		}
		return transformedRequest;
	}

	function findYoungestRider(riders) {
		var youngest = null;
		riders.forEach(function(rider) {
			if (!youngest) {
				youngest = rider;
			} else if (isYounger(rider, youngest)) {
				youngest = rider;
			}
		});

		function isYounger(rider, otherRider) {
			return (
				moment(rider.person.dateOfBirth, 'DD/MM/YYYY') >
				moment(otherRider.person.dateOfBirth, 'DD/MM/YYYY')
			);
		}

		return youngest;
	}

	function updateModifications(transformedRequest, userInput) {
		var bike = transformedRequest.motorcycles[0];

		if (!!userInput.bikeForm && !!userInput.bikeForm.modificationsAccessories) {
			if (!!userInput.bikeForm.modificationsAccessories.modifications) {
				var modifications =
					userInput.bikeForm.modificationsAccessories
						.modificationsTable;

				bike.qpyCycleModifications = modifications.map(function(
					mod,
					i
				) {
					return {
						modification: mod.modification.value,
						purchasePrice: mod.modificationValue
					};
				});
			}

			if (!!userInput.bikeForm.modificationsAccessories.accessories) {
				var accessories =
					userInput.bikeForm.modificationsAccessories
						.accessoriesTable;

				bike.qpyMotorcycleAccessories = accessories.map(function(
					acc,
					i
				) {
					return {
						accessory: acc.accessories.value,
						purchasePrice: acc.accessoryValue
					};
				});
			}
		}

		transformedRequest.motorcycles[0] = bike;

		return transformedRequest;
	}

	function updateKilometres(transformedRequest, userInput) {
		var bike = transformedRequest.motorcycles[0];

		if (
			!!userInput.bikeForm &&
			!!userInput.bikeForm.bikeDetails &&
			!!userInput.bikeForm.bikeDetails.kilometres
		) {
			bike.motorCycleKilometers =
				userInput.bikeForm.bikeDetails.kilometres;
			transformedRequest.motorcycles[0] = bike;
		}

		return transformedRequest;
	}

	function updateGarageType(transformedRequest, userInput) {
		var bike = transformedRequest.motorcycles[0];

		if (
			!!userInput.bikeForm &&
			!!userInput.bikeForm.bikeDetails &&
			!!userInput.bikeForm.bikeDetails.locationParked
		) {
			bike.garageType = userInput.bikeForm.bikeDetails.locationParked;
		}

		transformedRequest.motorcycles[0] = bike;

		return transformedRequest;
	}

	function updateFinancier(transformedRequest, userInput) {
		var bike = transformedRequest.motorcycles[0];

		if (
			!!userInput.bikeForm &&
			!!userInput.bikeForm.bikeDetails &&
			!!userInput.bikeForm.bikeDetails.isItFinanced
		) {
			bike.isFinanced = userInput.bikeForm.bikeDetails.isItFinanced;
			bike.financier =
				userInput.bikeForm.bikeDetails.financeWith.value ||
				userInput.bikeForm.bikeDetails.financeWith;
		} else {
			bike.isFinanced = false;
		}

		return transformedRequest;
	}

	function updateDamage(transformedRequest, userInput) {
		var bike = transformedRequest.motorcycles[0];

		if (
			!!userInput.bikeForm &&
			!!userInput.bikeForm.bikeDetails &&
			!!userInput.bikeForm.bikeDetails.existingDamage
		) {
			bike.damage = userInput.bikeForm.bikeDetails.existingDamage;
		}

		transformedRequest.motorcycles[0] = bike;

		return transformedRequest;
	}

	function updateUsage(transformedRequest, userInput) {
		var bike = transformedRequest.motorcycles[0];

		if (
			!!userInput.bikeForm &&
			!!userInput.bikeForm.bikeDetails &&
			!!userInput.bikeForm.bikeDetails.primaryBikeUse
		) {
			bike.motorCycleUsage =
				userInput.bikeForm.bikeDetails.primaryBikeUse;
		}

		transformedRequest.motorcycles[0] = bike;

		return transformedRequest;
	}

	function updateMotorcycleInfo(transformedRequest, userInput) {
		try{
			if (
				!!userInput.bikeForm &&
				!!userInput.bikeForm.aboutYourBike &&
				!!userInput.bikeForm.aboutYourBike.regoDetails
			) {
				transformedRequest.motorcycles[0].motorcycleInfo =
					userInput.bikeForm.aboutYourBike.regoDetails;
			} else if (!!userInput.bikeForm.motorcycleInfo) {
				transformedRequest.motorcycles[0].motorcycleInfo =
					userInput.bikeForm.motorcycleInfo;
			}
	
			if (!!userInput.bikeForm && 
				!!userInput.bikeForm.bikeDetails &&
				!!userInput.bikeForm.bikeDetails.businessActivityType) {
				transformedRequest.motorcycles[0].businessUsage =
					userInput.bikeForm.bikeDetails.businessActivityType;
			} else if (!!userInput.bikeForm.bikeDetails.commercialActivityType) {
				transformedRequest.motorcycles[0].commercialUsage =
					userInput.bikeForm.bikeDetails.commercialActivityType;
			}
		} catch(ex) {
			void 0;
		}		

		return transformedRequest;
	}

	// endregion

	// region Step 2
	function updateRiders(transformedRequest, userInput) {
		transformedRequest.motorcycles[0].riders = [];
		if (!!userInput.bikeForm && !!userInput.bikeForm.rider) {
			if (!!userInput.bikeForm.rider.riders) {
				userInput.bikeForm.rider.riders.forEach(function(rider) {
					rider.person.contactType = 'person';
					rider.person.prefix = rider.person.title;
					rider.person.primaryAddress =
						transformedRequest.mainContactAddress !== null
							? transformedRequest.mainContactAddress
							: transformedRequest.policyAddress;

					//region yearsLicenced
					rider.yearsLicenced = rider.yearsHeld;
					switch (rider.yearsHeld) {
						case 'lessThan_1':
							rider.yearsLicenced = '0';
							break;
						case 'greaterThan_5':
							rider.yearsLicenced = '6';
							break;
						default:
							rider.yearsLicenced = rider.yearsHeld;
					}
					//endregion

					// region riderHistory
					if (
						rider.threeYears_accidentsClaims &&
						rider.threeYears_accidentsClaimsDetails.length < 1
					) {
						rider.threeYears_accidentsClaims = false;
					}

					if (
						rider.threeYears_restrictedSuspendedDisqualifiedCancelled &&
						rider
							.threeYears_restrictedSuspendedDisqualifiedCancelledDetails
							.length < 1
					) {
						rider.threeYears_restrictedSuspendedDisqualifiedCancelled = false;
					}

					if (
						rider.fiveYears_chargedOrConvicted &&
						rider.fiveYears_chargedOrConvictedDetails.length < 1
					) {
						rider.fiveYears_chargedOrConvicted = false;
					}
					rider.hasClaim = rider.threeYears_accidentsClaims;
					rider.hasConviction = rider.fiveYears_chargedOrConvicted;
					rider.hasLostLicence =
						rider.threeYears_restrictedSuspendedDisqualifiedCancelled;
					rider.riderHistory = [];

					if (rider.threeYears_accidentsClaims) {
						rider.riderHistory = rider.riderHistory.concat(
							rider.threeYears_accidentsClaimsDetails.slice()
						);
					}

					if (
						rider.threeYears_restrictedSuspendedDisqualifiedCancelled
					) {
						rider.riderHistory = rider.riderHistory.concat(
							rider.threeYears_restrictedSuspendedDisqualifiedCancelledDetails.slice()
						);
					}

					if (rider.fiveYears_chargedOrConvicted) {
						rider.riderHistory = rider.riderHistory.concat(
							rider.fiveYears_chargedOrConvictedDetails.slice()
						);
					}

					rider.riderHistory.forEach(function(rh) {
						rh.pattern = {
							publicID: '',
							description: '',
							code: '',
							filter1: ''
						};
						rh.pattern.publicID = rh.description.publicID;
						rh.pattern.description = rh.description.label;
						rh.pattern.code = rh.description.code;
						rh.pattern.filter1 = rh.description.filter1;

						rh.month = rh.month.value.toLowerCase();
						rh.year = rh.year.value;

						delete rh.description;
					});

					//endregion

					// region current insurer
					if (!!rider.previousInsurer) {
						rider.currentInsurer = rider.previousInsurer;

						delete rider.previousInsurer;
					}
					// endregion

					transformedRequest.motorcycles[0].riders.push({
						rider: rider
					});
					// endregion

					// region motorcycle club
					if (!!rider.isMemberOfClub && rider.motorcycleClub) {
						transformedRequest.motorcycles[0].isMemberOfClub =
							rider.isMemberOfClub;
						transformedRequest.motorcycles[0].motorcycleClub =
							rider.motorcycleClub;
					}
					//endregion
				});

				transformedRequest.motorcycles[0].riders[0].riderUsage = 'main';
			}

			// licensed to ride
			transformedRequest.motorcycles[0].riders[0].licensedToRide =
				userInput.bikeForm.rider.riders[0].licensedToRide;

			// is main rider
			transformedRequest.motorcycles[0].isTheMainRider =
				userInput.bikeForm.rider.riders[0].isTheMainRider;
		} else {
			transformedRequest.motorcycles[0].riders = [
				{
					riderUsage: 'main'
				}
			];
		}

		return transformedRequest;
	}

	function updatePolicyHolders(transformedRequest, userInput) {
		try {
			var bikeForm = userInput.bikeForm,
				mainPolicyHolder = bikeForm.mainPolicyHolder,
				companyDetails = bikeForm.aboutCompany,
				mainPolicyHolderContact = bikeForm.mainPolicyHolderContact,
				riders = transformedRequest.motorcycles[0].riders;

			// region mainPolicyHolder
			if (!!mainPolicyHolder) {
				var policyHolders = [];
				if (!!mainPolicyHolderContact) {
					// set primary address
					if (!!mainPolicyHolderContact.address) {
						mainPolicyHolderContact.primaryAddress =
							transformedRequest.mainContactAddress !== null
								? transformedRequest.mainContactAddress
								: transformedRequest.motorcycles[0].accountLocation;
						delete mainPolicyHolderContact.address;
					}
				}
				mainPolicyHolder.policyContact = mainPolicyHolderContact;

				if (mainPolicyHolder.isMainRiderMainPolicyHolder) {
					var rider = util.deepClone(
						transformedRequest.motorcycles[0].riders[0].rider
					);
					Object.extend(mainPolicyHolder, rider.person);
				}

				policyHolders.push(mainPolicyHolder);
				if (
					bikeForm.additionalPolicyHolders &&
					bikeForm.additionalPolicyHolders.policyHolders
				) {
					policyHolders = policyHolders.concat(
						bikeForm.additionalPolicyHolders.policyHolders
					);
				}

				policyHolders.forEach(function(policyHolder, index) {
					var contact = util.deepClone(policyHolder);
					if (!transformedRequest.policyHolders[index])
						transformedRequest.policyHolders[index] = {};

					var transformedContact =
						transformedRequest.policyHolders[index];
					if (!contact.contactType) contact.contactType = 'person';

					contact.prefix = contact.title;
					if (contact.policyContact) {
						Object.extend(contact, contact.policyContact);
						if (contact.primaryPhone == 'mobile')
							contact.cellPhone = contact.primaryPhoneNumber;
						else if (contact.primaryPhone == 'home')
							contact.homePhone = contact.primaryPhoneNumber;
						else if (contact.primaryPhone == 'work')
							contact.workPhone = contact.primaryPhoneNumber;

						delete contact.policyContact;
					}

					if (!contact.primaryAddress)
						contact.primaryAddress = util.clone(
							transformedRequest.policyHolders[0].contact
								.primaryAddress
						);

					// region driving history
					contact.hasClaim = contact.threeYears_accidentsClaims;
					contact.hasConviction = contact.fiveYears_chargedOrConvicted;
					contact.hasLostLicence =
						contact.threeYears_restrictedSuspendedDisqualifiedCancelled;

					if (
						contact.threeYears_accidentsClaims &&
						contact.threeYears_accidentsClaimsDetails.length < 1
					) {
						contact.threeYears_accidentsClaims = false;
					}

					if (
						contact.threeYears_restrictedSuspendedDisqualifiedCancelled &&
						contact
							.threeYears_restrictedSuspendedDisqualifiedCancelledDetails
							.length < 1
					) {
						contact.threeYears_restrictedSuspendedDisqualifiedCancelled = false;
					}

					if (
						contact.fiveYears_chargedOrConvicted &&
						contact.fiveYears_chargedOrConvictedDetails.length < 1
					) {
						contact.fiveYears_chargedOrConvicted = false;
					}

					contact.drivingHistory = [];

					if (contact.threeYears_accidentsClaims) {
						contact.drivingHistory = contact.drivingHistory.concat(
							contact.threeYears_accidentsClaimsDetails.slice()
						);
					}

					if (
						contact.threeYears_restrictedSuspendedDisqualifiedCancelled
					) {
						contact.drivingHistory = contact.drivingHistory.concat(
							contact.threeYears_restrictedSuspendedDisqualifiedCancelledDetails.slice()
						);
					}

					if (contact.fiveYears_chargedOrConvicted) {
						contact.drivingHistory = contact.drivingHistory.concat(
							contact.fiveYears_chargedOrConvictedDetails.slice()
						);
					}

					contact.drivingHistory.forEach(function(rh) {
						rh.riderPattern = {
							publicID: '',
							description: '',
							code: '',
							filter1: ''
						};
						rh.riderPattern.publicID = rh.description.publicID;
						rh.riderPattern.description = rh.description.label;
						rh.riderPattern.code = rh.description.code;
						rh.riderPattern.filter1 = rh.description.filter1;

						rh.riderMonth = rh.month.value.toLowerCase();
						rh.year = parseInt(rh.year.value);

						delete rh.description;
						delete rh.month;
						delete rh.pattern;
					});

					//endregion

					if (!transformedContact.contact)
						transformedContact.contact = {};
					transformedContact.contact.drivingHistory = [];
					Object.extend(transformedContact.contact, contact);
				});

				// region rider person
				if (!!riders[0] && !!riders[0].rider && !!riders[0].rider.person) {
					var riders = transformedRequest.motorcycles[0].riders;

					riders.forEach(function(rider, index) {
						//rider.rider.person.primaryAddress = transformedRequest.policyAddress;

						// first rider
						if (index === 0) {
							rider.rider.person.primaryPhone =
								mainPolicyHolder.policyContact.primaryPhone;

							switch (mainPolicyHolder.policyContact.primaryPhone) {
								case 'mobile':
									rider.rider.person.cellPhone =
										mainPolicyHolder.policyContact.primaryPhoneNumber;
									break;
								case 'home':
									rider.rider.person.homePhone =
										mainPolicyHolder.policyContact.primaryPhoneNumber;
									break;
								case 'work':
									rider.rider.person.workPhone =
										mainPolicyHolder.policyContact.primaryPhoneNumber;
									break;
								default:
									throw new Error(
										'unknown primaryPhone ' + primaryPhone
									);
							}

							rider.rider.person.passwordAnswer =
								mainPolicyHolder.policyContact.passwordAnswer;
							rider.rider.person.passwordQuestion =
								mainPolicyHolder.policyContact.passwordQuestion;
							if (
								rider.rider.person.passwordQuestion ===
								'customer_created_question'
							) {
								rider.rider.person.passwordQuestionStr =
									mainPolicyHolder.policyContact.passwordQuestionStr;
							}
						}
					});
				}
				// endregion
			} else if (!!companyDetails) {
				if (!!riders[0] && !!riders[0].rider && !!riders[0].rider.person) {
					var riders = transformedRequest.motorcycles[0].riders;

					riders.forEach(function(rider) {
						rider.rider.person.primaryAddress =
							transformedRequest.policyAddress;
					});
				}
			} else if (
				transformedRequest.motorcycles[0].riders[0] &&
				transformedRequest.motorcycles[0].riders[0].rider &&
				transformedRequest.motorcycles[0].riders[0].rider.person
			) {
				var rider = transformedRequest.motorcycles[0].riders[0].rider;
				var contact = transformedRequest.policyHolders[0].contact;
				Object.extend(contact, rider.person);
				contact.contactType = 'person';
				contact.hasClaim = rider.hasClaim;
				contact.hasConviction = rider.hasConviction;
			}
			// endregion

			transformedRequest.policyHolders.forEach(function(holder, index) {
				holder.mainHolder = index === 0;
			});

			// var rider = transformedRequest.motorcycles[0].riders[0].rider;
			// Object.extend(rider.person, transformedRequest.policyHolders[0]);
			// rider.person.emailAddress1 = userInput.mainPolicyHolderContact.emailAddress1;

			if (userInput.email) {
				if (
					userInput.bikeForm &&
					userInput.bikeForm.tellUsABitMore &&
					userInput.bikeForm.tellUsABitMore.yourEmailAddress
				) {
					transformedRequest.policyHolders[0].contact.emailAddress1 =
						userInput.bikeForm.tellUsABitMore.yourEmailAddress;
				} else if (
					userInput.bikeForm &&
					userInput.bikeForm.mainPolicyHolderContact &&
					userInput.bikeForm.mainPolicyHolderContact.emailAddress1
				) {
					transformedRequest.policyHolders[0].contact.emailAddress1 =
						userInput.bikeForm.mainPolicyHolderContact.emailAddress1;
				} else {
					transformedRequest.policyHolders[0].contact.emailAddress1 =
						userInput.email;
				}

				if (
					angular.isDefined(
						transformedRequest.motorcycles[0].riders[0].rider
					)
				) {
					if (
						userInput.bikeForm.tellUsABitMore &&
						userInput.bikeForm.tellUsABitMore.yourEmailAddress
					) {
						transformedRequest.motorcycles[0].riders[0].rider.person.emailAddress1 =
							userInput.bikeForm.tellUsABitMore.yourEmailAddress;
					} else if (
						userInput.bikeForm.mainPolicyHolderContact &&
						userInput.bikeForm.mainPolicyHolderContact.emailAddress1
					) {
						transformedRequest.motorcycles[0].riders[0].rider.person.emailAddress1 =
							userInput.bikeForm.mainPolicyHolderContact.emailAddress1;
					} else {
						transformedRequest.motorcycles[0].riders[0].rider.person.emailAddress1 =
							userInput.email;
					}
				}
			} else {
				if (
					userInput.bikeForm &&
					userInput.bikeForm.tellUsABitMore &&
					userInput.bikeForm.tellUsABitMore.yourEmailAddress
				) {
					if (transformedRequest.policyHolders[0].contact.emailAddress1) {
						//use the existing if available
					} else {
						transformedRequest.policyHolders[0].contact.emailAddress1 =
							userInput.bikeForm.tellUsABitMore.yourEmailAddress;
					}

					if (
						transformedRequest.motorcycles[0].riders[0].rider.person
							.emailAddress1
					) {
						//use the existing if available
					} else {
						transformedRequest.motorcycles[0].riders[0].rider.person.emailAddress1 =
							userInput.bikeForm.tellUsABitMore.yourEmailAddress;
					}
				}
			}

			if (
				userInput.bikeForm &&
				userInput.bikeForm.mainPolicyHolderContact &&
				userInput.bikeForm.mainPolicyHolderContact
					.personalContactDetailsMailingPreference
			) {
				transformedRequest.documentDeliveryMethod =
					userInput.bikeForm.mainPolicyHolderContact.personalContactDetailsMailingPreference;
				delete transformedRequest.policyHolders[0].contact
					.personalContactDetailsMailingPreference;
			}
		}
		catch (ex) {
			void 0;
		}

		return transformedRequest;
	}

	function updateAccountLocation(transformedRequest, userInput) {
		try {
			var accountLocation = transformedRequest.motorcycles[0].accountLocation,
				bikeForm = userInput.bikeForm;

			accountLocation.addressType = 'residential';

			if (!!accountLocation) {
				if (
					!!bikeForm.getStarted &&
					!!bikeForm.getStarted.personOrCompany &&
					bikeForm.getStarted.personOrCompany === 'company'
				) {
					accountLocation.addressType = 'business';
				}
			}

			transformedRequest.motorcycles[0].accountLocation = accountLocation;
		}
		catch (ex) {
			void 0;
		}

		return transformedRequest;
	}

	function updateAdditionalRiders(transformedRequest, userInput) {
		try{
			var fromRapidEstimate = !userInput.fromFullQuote,
				rider = userInput.bikeForm.rider,
				riders = rider ? rider.riders : null,
				/** required for when checking decline on step 1 */
				youngRider = null;

			if (!rider) return transformedRequest;

			if (!fromRapidEstimate) youngRider = findYoungestRider(rider.riders);

			transformedRequest.motorcycles[0].youngestRiderGender = fromRapidEstimate
				? rider.youngestRiderGender /** value from rapid estimate */
				: youngRider
				? youngRider.person.gender
				: null; /** value from full quote */

			transformedRequest.motorcycles[0].otherRiderHasProLicense = fromRapidEstimate
				? rider.provisionalLicence /** value from rapid estimate */
				: youngRider
				? youngRider.licenceType == 'provisional'
				: null; /** value from full path */

			transformedRequest.motorcycles[0].youngestRiderDOB = fromRapidEstimate
				? rider.youngestRiderDob
				: youngRider
				? youngRider.person.dateOfBirth
				: null;

			transformedRequest.motorcycles[0].otherRiderUsageTimes = fromRapidEstimate
				? rider.numberOfOtherRiders /* value from rapid estimate */
				: riders.length; /* value from full quote */
		}
		catch (ex) {
			void 0;
		}
		return transformedRequest;
	}

	// endregion

	// region Step 3

	// endregion

	// region Step 4
	function updateRegoDetails(transformedRequest, userInput) {
		try {
			var tellUsYourRegoNumber = userInput.bikeForm.tellUsYourRegoNumber,
				regoNumber = null;

			if (tellUsYourRegoNumber && tellUsYourRegoNumber.regoNumber) {
				regoNumber = tellUsYourRegoNumber.regoNumber;
			}

			transformedRequest.motorcycles[0].registrationNumber = regoNumber;
		} catch (ex) {
			void 0;
		}
		return transformedRequest;
	}

	// endregion

	function updateCompanyContactDetails(transformedRequest, userInput) {
		try {
			var policyHolder = util.deepClone(transformedRequest.policyHolders[0]);

			if (
				userInput.bikeForm &&
				userInput.bikeForm.getStarted &&
				userInput.bikeForm.getStarted.personOrCompany === 'company' &&
				!!userInput.bikeForm.companyContact &&
				!!userInput.bikeForm.aboutCompany
			) {
				transformedRequest.email = userInput.bikeForm.aboutCompany.email;

				policyHolder = {};
				policyHolder.contact = policyHolder.contact || {};
				policyHolder.contact.abn = userInput.bikeForm.aboutCompany.abn;
				policyHolder.contact.contactType = 'company';
				policyHolder.contact.emailAddress1 =
					userInput.bikeForm.aboutCompany.email;
				policyHolder.contact.passwordQuestion =
					userInput.bikeForm.companyContact.passwordQuestion;
				if (
					policyHolder.contact.passwordQuestion ===
					'customerCreatedQuestion'
				) {
					policyHolder.contact.passwordQuestionStr =
						userInput.bikeForm.companyContact.enterAQuestion;
				}
				policyHolder.contact.passwordAnswer =
					userInput.bikeForm.companyContact.passwordAnswer;
				policyHolder.contact.hasClaim = false;
				policyHolder.contact.hasConviction = false;
				policyHolder.contact.isJustInsured = false;
				policyHolder.contact.name = userInput.bikeForm.aboutCompany.name;
				policyHolder.contact.primaryAddress =
					userInput.bikeForm.aboutCompany.companyAddress;
				policyHolder.contact.primaryPhone = 'work';
				policyHolder.contact.workPhone =
					userInput.bikeForm.aboutCompany.officePhone;

				// region Authorised Person
				var authorisedPerson = {};
				authorisedPerson.contactType = 'person';
				var contact = userInput.bikeForm.companyContact;

				authorisedPerson.primaryAddress = contact.address;
				authorisedPerson.primaryPhone = contact.primaryPhone;
				switch (authorisedPerson.primaryPhone) {
					case 'mobile':
						authorisedPerson.cellPhone = contact.preferredNumber;
						break;
					case 'home':
						authorisedPerson.homePhone = contact.preferredNumber;
						break;
					case 'work':
						authorisedPerson.workPhone = contact.preferredNumber;
						break;
					default:
						throw new Error('unknown primaryPhone ' + primaryPhone);
				}
				authorisedPerson.dateOfBirth = contact.companyContactDateOfBirth;
				authorisedPerson.firstName = contact.companyContactFirstName;
				authorisedPerson.lastName = contact.companyContactLastName;
				authorisedPerson.gender = contact.companyContactGender;
				authorisedPerson.prefix = contact.companyContactTitle;
				authorisedPerson.emailAddress1 = contact.companyContactDetailsEmail;
				authorisedPerson.primaryAddress =
					contact.companyContactDetailsAddress;

				policyHolder.contact.authorisedPersons = [
					{
						person: authorisedPerson
					}
				];

				if (contact.postalOption === false) {
					transformedRequest.policyAddress =
						contact.companyContactDetailsPostalAddress;
				}
				// endregion
			} else {
				policyHolder.contact.contactType =
					userInput.bikeForm.getStarted.personOrCompany;
				policyHolder.contact.authorisedPersons = [
					{
						person: {
							contactType: 'person',
							primaryAddress: transformedRequest.policyAddress
						}
					}
				];
			}

			transformedRequest.policyHolders[0] = policyHolder;
			transformedRequest.policyHolders[0].mainHolder = true;

			if (
				userInput.bikeForm &&
				userInput.bikeForm.companyContact &&
				userInput.bikeForm.companyContact
					.companyContactDetailsMailingPreference
			) {
				transformedRequest.documentDeliveryMethod =
					userInput.bikeForm.companyContact.companyContactDetailsMailingPreference;
				delete transformedRequest.policyHolders[0].contact
					.companyContactDetailsMailingPreference;
			}
		}
		catch (ex) {
			void 0;
		}
		return transformedRequest;
	}

	function updateMotorcycleInsuranceTypeAndAmount(
		transformedRequest,
		userInput
	) {
		try {
			var insuredExcessValue = userInput.bikeForm.insuredExcessValue;
			if (insuredExcessValue) {
				transformedRequest.motorcycles[0].sumInsuredType =
					insuredExcessValue.comprehensivePref;
				if (insuredExcessValue.comprehensivePref == 'agreed') {
					if (!!insuredExcessValue.agreedValue) {
						transformedRequest.motorcycles[0].sumInsuredAmount =
							insuredExcessValue.agreedValue;
					}
				}
				transformedRequest.motorcycles[0].excess.flexiExcessExcess = userInput.bikeForm.insuredExcessValue.flexiExcess;
			}
		} catch (ex) { 
			void 0;
		}
		return transformedRequest;
	}

	//updates the email
	function updateEmail(transformedRequest, userInput) {
		try {
			if (
				userInput.bikeForm &&
				userInput.bikeForm.tellUsABitMore &&
				userInput.bikeForm.tellUsABitMore.yourEmailAddress
			) {
				transformedRequest.email =
					userInput.bikeForm.tellUsABitMore.yourEmailAddress;
			} else {
				//set email from maincontact if not available in tellUsABitMore
				if (
					userInput.bikeForm &&
					userInput.bikeForm.mainPolicyHolderContact &&
					userInput.bikeForm.mainPolicyHolderContact.emailAddress1
				) {
					transformedRequest.email =
						userInput.bikeForm.mainPolicyHolderContact.emailAddress1;
				}
			}

			// send the campaign code to GW
			if (
				userInput.bikeForm &&
				userInput.bikeForm.tellUsABitMore &&
				userInput.bikeForm.tellUsABitMore.promotionalCode
			) {
				transformedRequest.campaignCode =
					userInput.bikeForm.tellUsABitMore.promotionalCode;
			}
	    }
		catch (ex) {
			void 0;
		}

		return transformedRequest;
	}

	function updatePolicyAddress(transformedRequest, userInput) {
		try {
			var postalAddress = storage.getItem('policy-address');

			if (
				angular.isDefined(userInput.bikeForm.mainPolicyHolderContact) ||
				angular.isDefined(userInput.bikeForm.companyContact)
			) {
				if (transformedRequest.postalAddress !== null) {
					transformedRequest.policyAddress =
						transformedRequest.postalAddress;
				} else {
					var isPostalOption = true;
					if(userInput.bikeForm.getStarted.personOrCompany == 'person'){
						isPostalOption = userInput.bikeForm.mainPolicyHolderContact.postalOption;
					} else {
						isPostalOption =
							userInput.bikeForm.companyContact.postalOption;
					}

					if (Object.keys(postalAddress).length > 0 && !isPostalOption) {
						transformedRequest.policyAddress = postalAddress;
					}
				}
			} else {
				if (Object.keys(postalAddress).length > 0) {
					transformedRequest.policyAddress = postalAddress;
				}
			}

			delete transformedRequest.postalAddress;
			delete transformedRequest.mainContactAddress;
		} catch (ex) {
			void 0;
		}
		return transformedRequest;
	}

	function transform(userInput) {
		var transformedRequest = jsonMapper.transform(
			userInput,
			structureQuoteMapping
		);
		transformedRequest = updateIsMotorRegistered(transformedRequest);
		transformedRequest = updatePolicyHolderPrimaryAddress(
			transformedRequest
		);
		transformedRequest = updateModifications(transformedRequest, userInput);
		transformedRequest = updateKilometres(transformedRequest, userInput);
		transformedRequest = updateGarageType(transformedRequest, userInput);
		transformedRequest = updateFinancier(transformedRequest, userInput);
		transformedRequest = updateDamage(transformedRequest, userInput);
		transformedRequest = updateUsage(transformedRequest, userInput);
		transformedRequest = updateMotorcycleInfo(
			transformedRequest,
			userInput
		);
		transformedRequest = updateRiders(transformedRequest, userInput);
		transformedRequest = updatePolicyHolders(transformedRequest, userInput);
		transformedRequest = updateAccountLocation(
			transformedRequest,
			userInput
		);
		transformedRequest = updateAdditionalRiders(
			transformedRequest,
			userInput
		);
		transformedRequest = updateRegoDetails(transformedRequest, userInput);
		transformedRequest = updateCompanyContactDetails(
			transformedRequest,
			userInput
		);
		transformedRequest = updateMotorcycleInsuranceTypeAndAmount(
			transformedRequest,
			userInput
		);
		transformedRequest = updateEmail(transformedRequest, userInput);
		transformedRequest = updatePolicyAddress(transformedRequest, userInput);

		return transformedRequest;
	}

	function transposeMonth(monthName) {
		var months = {
			January: '01',
			February: '02',
			March: '03',
			April: '04',
			May: '05',
			June: '06',
			July: '07',
			August: '08',
			September: '09',
			October: '10',
			November: '11',
			December: '12'
		};

		return months[monthName];
	}

	return {
		transform: transform
	};
}

function BikeTriggerGoalTransformer(jsonMapper, util, quoteOptions) {
	function transform(userInput) {
		var policyHolder = userInput.policyHolders[0];
		var address = userInput.policyAddress;
		
		var request = {
			Email:  policyHolder.contact.emailAddress1,
			FirstName: policyHolder.contact.firstName,
			LastName: policyHolder.contact.lastName,
			AddressLine: address.addressLine1,
			City: address.city,
			State: address.state,
			PostCode: address.postalCode,
			CountryCode: "Australia",
			Product: "Bike",
			UserAgent: "SPA-Bike"
		};
		return request;
	}

	return {
		transform: transform
	}
}

function HomeCleanRequestTransformer(Util, jsonMapper) {

	function transform(intermediateRequest, userInput) {

		delete intermediateRequest.homeForm;

		// var bike = intermediateRequest.motorcycles[0];
		 var policyHolders = intermediateRequest.policyHolders;
		 if(policyHolders){
		 	policyHolders.forEach(function(holder,idx){
		 		if(holder.contact)
		 		{
						//Address
						if(holder.contact.address) delete holder.contact.address;

						//Contact Number
						if(holder.contact.contactNumber) delete holder.contact.contactNumber;

						//Phone number items
						cleanPolicyHoldersPhoneNumber(holder.contact.primaryPhone,holder.contact);

						//same as postal address object
						if(holder.contact.personContactSamePostalAddress!==undefined) delete holder.contact.personContactSamePostalAddress;
						if(holder.contact.additionalContactSamePostalAddress!==undefined) delete holder.contact.additionalContactSamePostalAddress;

						//10 years offences objects
						if(holder.contact.tenYears_chargedOrConvictedOffences!== undefined) delete holder.contact.tenYears_chargedOrConvictedOffences;
						if(holder.contact.tenYears_chargedOrConvictedOffencesDetails!== undefined) delete holder.contact.tenYears_chargedOrConvictedOffencesDetails;

						if(holder.contact.dwellingHistory && holder.contact.dwellingHistory.length>0){
							holder.contact.dwellingHistory.forEach(function(history,idx){

							// 	if(history.pattern.label) delete history.pattern.label;
							// 	if(history.pattern.value) delete history.pattern.value;
							// 	if(history.pattern.$$hashKey) delete history.pattern.$$hashKey;
							});
						}else{
							if(holder.contact.dwellingHistory) delete holder.contact.dwellingHistory;
						}

						//Contents from Additional
						if(holder.contact._aggregator) delete holder.contact._aggregator;
						if(holder.contact._HTMLID) delete holder.contact._HTMLID;
						if(holder.contact.$$hashKey) delete holder.contact.$$hashKey;

						if(holder.contact.authorisedPersons
							&& holder.contact.authorisedPersons!=null
							&& holder.contact.authorisedPersons.length>0
							&& holder.contact.authorisedPersons[0].person){
							if(holder.contact.authorisedPersons[0].person.companyContactSamePostalAddress!==undefined)
								delete holder.contact.authorisedPersons[0].person.companyContactSamePostalAddress

						}

						// if(holder.contact.dateOfBirth!==undefined)
						// 	delete holder.contact.dateOfBirth;
						// if(holder.contact.hasConviction!==undefined)
						// 	delete holder.contact.hasConviction;

						// if(holder.contact.dwellingHistory!==undefined)
						// 	delete holder.contact.dwellingHistory;
		 		}

		 	});
		 }

		 delete intermediateRequest.dwellings[0].location.enrichment ;
		 delete intermediateRequest.policyAddress.enrichment ;
		 delete intermediateRequest.policyHolders[0].contact.primaryAddress.enrichment ;

		return intermediateRequest;
	}

	function cleanPolicyHoldersPhoneNumber(phoneType,contactInfo){
		if(['home','mobile'].indexOf(phoneType)>-1){
			if(contactInfo.workPhone) { delete contactInfo.workPhone; }
		}

		if(['work','mobile'].indexOf(phoneType)>-1){
			if(contactInfo.homePhone) { delete contactInfo.homePhone; }
		}

		if(['work','home'].indexOf(phoneType)>-1){
			if(contactInfo.cellPhone) { delete contactInfo.cellPhone; }
		}
	}

	return {
		transform: transform
	}
}

function HomeCoverTypeTransformer(jsonMapper, util, quoteOptions) {
	function transform(intermediateRequest, coverType, offering) {

		// intermediateRequest.dwellings[0].coverType =  coverType.descriptor;
		intermediateRequest.dwellings[0].offering =  (offering.descriptor)?offering.descriptor:offering;
		intermediateRequest.dwellings[0].coverType =  coverType;

		return intermediateRequest;
	}

	return {
		transform: transform
	}
}

function HomeDefaultValueRequestTransformer(Util, jsonMapper, userInputRepository, quoteOptions) {

	function formatDateAndTimeTheGuidewireWay(date, time) {
		var format = "{0} at {1} AEST" ;
		var timeFormatted = '4:00PM' ;
		if ( time )
			timeFormatted = moment().tz("Australia/Sydney").format('h:mma');
		return Util.stringFormat(format, moment().tz("Australia/Sydney").format('Do MMM YYYY') , timeFormatted) ;
	}

	var staticValuesMapping = {
		quoteType:'Full',
		periodStartDate: function() { return moment().tz("Australia/Sydney").format('DD/MM/YYYY')},
		productCode : 'QPHHome',
		isInsuredsOverTheAge : false,
		isInsuredsRetired: false,
		anyConvictionsQuestion: 'no',
		hasPortableContentsClaims: 'no',
		paymentFrequency: 'everyyear',
		email : "test@test.com",
		"includeFloodCover" : true,  // testing for cordelInfo


		"policyHolders.0.mainHolder": true,
		"policyHolders.0.contact.contactType": "person",
		"policyHolders.0.contact.authorisedPersons.*.person.firstName": "An@n",
		"policyHolders.0.contact.authorisedPersons.*.person.lastName": "An@nym@us",
		"policyHolders.0.contact.authorisedPersons.*.person.dateOfBirth": "07/07/2000",
		"policyHolders.*.contact.passwordQuestionStr" : '',
		"policyHolders.*.contact.passwordQuestion" : '',
		"policyHolders.*.contact.passwordAnswer" : '',
		"policyHolders.0.contact.dateOfBirth" : '07/07/2000',
		"policyHolders.0.contact.firstName" : 'An@n',
		"policyHolders.0.contact.lastName" : 'An@nym@us',



		"dwellings.0.buildingType" : "house",
		"dwellings.0.externalWallMaterial" : "aluminium",
		"dwellings.0.homeOccupancy" : "own_live",
		"dwellings.0.coverType" : "building_and_contents",
		"dwellings.0.buildingSumInsured" : "200000",
		"dwellings.0.contentSumInsured" : "20000",
		"dwellings.0.offering" : "QPHStandardOffering",
		"dwellings.0.hasGeneralPortableContents" : false,
		"dwellings.0.portableCoverCountry" : "australia_nz",
		"dwellings.0.hasPortableContentsHomeAway" : false,


		"dwellings.0.policyOption" : {},
		"dwellings.0.policyOption.isBuildingAccidentalDamage" : true,
		"dwellings.0.policyOption.isContentsAccidentalDamage" : true,
		"dwellings.0.policyOption.isContentsDomesticWorkerComp" : false,
		"dwellings.0.policyOption.isContentsStoredAway" : false,
		"dwellings.0.policyOption.specifyCycleEquipment" : false,
		"dwellings.0.policyOption.isContentsCycleCover" : false,
		// "dwellings.0.isOwnersInsureUnits":"no",
		"dwellings.0.isSubUrbanLocated" : true,
		"dwellings.0.isRenovated" : false,
		"dwellings.0.isIncomeGenerated" : false,
		"dwellings.0.isMortgagePresent" : false,
		"dwellings.0.isUnrelatedPeople" : false,
		"dwellings.0.isUnitAboveGround" : "no",
		"dwellings.0.isPortionAboveGround" : "no",
		"dwellings.0.isCommunitySurrounded" : true,
		"dwellings.0.hasSpecifiedPortableContList" : false,
		"dwellings.0.hasIndividualContents" : false,
		"dwellings.0.homeLevels" : '1',
		"dwellings.0.isGroundLevelElevated" : "no",
		"dwellings.0.roofMaterial" : "concretetiles",
		"dwellings.0.yearsContInsurance" : "noPreviousInsurance",
		"dwellings.0.hasEntertainmentEquipment" : false,
		"dwellings.0.hasWorksArt" : false,
		"dwellings.0.homeBuiltYear" : "2000",
		"dwellings.0.isWaterTight" : true, // no data
		"dwellings.0.renovationCost" : 0,

		"dwellings.0.locationProperty" : {},
		"dwellings.0.locationProperty.knowHomeSize" : false,
		"dwellings.0.locationProperty.hasDuctedAirConditioning" : false,
		"dwellings.0.locationProperty.hasInGroundPool" : false,
		"dwellings.0.locationProperty.hasTennisCourt" : false,
		"dwellings.0.locationProperty.hasGrannyFlat" : false,
		"dwellings.0.locationSecurity" : {},
		"dwellings.0.locationSecurity.hasWindowScreenBars" : false,
		"dwellings.0.locationSecurity.isGatedCommunity" : false,
		"dwellings.0.locationSecurity.hasFixedHomeSafe" : false,
		"dwellings.0.locationSecurity.haveSecurityAlarm" : false,
		"dwellings.0.locationSecurity.hasWindowKeylocks" : false,
		"dwellings.0.locationSecurity.hasDoorSecurityScreen" : false,
		"dwellings.0.locationSecurity.hasDoorDeadlocks" : false,
		"dwellings.0.locationSecurity.has24HourConcierge" : false,
		"dwellings.0.locationSecurity.isSecurityRatedBuilding" : false,

		"dwellings.0.locationProperty.hasSheds" : false,

		"dwellings.0.isCycloneStandardlyBuilt": 'yes',
		"status" : "Draft",
		"documentDeliveryMethod": 'email',
		"displayStatus": 'Draft',
		"periodStartDateTimeAEDT": formatDateAndTimeTheGuidewireWay(moment(), moment()),
		"periodEndDateTimeAEDT" : formatDateAndTimeTheGuidewireWay(moment().add(1,'years')),
		"channel": 'portal',
	}

	function transform(intermediateRequest, userInput) {
		var staticValuesMappingNew = ApplyDefaultExcess(userInput);
		var transformedRequest = jsonMapper.setDefault(userInput, staticValuesMappingNew) ;
		void 0;
		return transformedRequest;
	}

	
	function ApplyDefaultExcess(userInput) {
		var staticValuesMappingNew  = staticValuesMapping;

		var excessValue = quoteOptions.getStateDefaultVoluntaryExcess(userInput.policyAddress.state);
		if(excessValue != null){
			var tempObj = {"dwellings.0.excess.voluntaryExcess": excessValue};
			staticValuesMappingNew = Object.extend(staticValuesMapping, tempObj);
		}

		var portableExcessValue = quoteOptions.getStateDefaultVoluntaryExcess(userInput.policyAddress.state, 1);
		if(portableExcessValue != null){
			var tempObj2 = {"dwellings.0.excess.portableContentVoluntaryExcess": portableExcessValue};
			staticValuesMappingNew = Object.extend(staticValuesMappingNew, tempObj2);
		}
		
		return staticValuesMappingNew;
	}

	return {
		transform: transform
	}
}

function HomeFormatConverterTransformer(Util, jsonMapper) {

	function convertDateAndTimeTheGuidewireWay(dateTime) {
		var format = "{0} at {1} AEST" ;
		return Util.stringFormat(format, dateTime.format('Do MMM YYYY') , dateTime.format('h:mma')) ;
	}

	function convertDate(dateString) {
		var date = moment(dateString, 'DD/MM/YYYY') ;
		var formattedDate = date.format('YYYY-MM-DD') ;
		if ( formattedDate != "Invalid date")
			return formattedDate;

		// throw 'date format exception formatting ' + dateString ;
		return null;
	}

	function convertDateToGWTimeZone(dateString) {
		var formattedDate = moment(dateString,'DDMMYYYY').tz("Australia/Sydney").format('YYYY-MM-DD') ;
		if ( formattedDate != "Invalid date")
			return formattedDate;

		return null;
	}
	 
	function getMonthString(monthInFigure){
		if(monthInFigure){
			var objDate = new Date("2000-"+String(monthInFigure)+"-01");
	    	return objDate.toLocaleString("en-au", { month: "long" });
		}
		return null;
	}


	function getMonthNumber(monthInString){
		if(monthInString){
			var monthObj = {
				'January': '01',
				'February': '02',
				'March': '03',
				'April': '04',
				'May': '05',
				'June': '06',
				'July': '07',
				'August': '08',
				'September': '09',
				'October': '10',
				'November': '11',
				'December': '12',
			}

			return monthObj[monthInString];
		}
		return null;
	}

	function convertGender(gender) {
		var gc = {
			male : 'M',
			female : 'F',
			intersex : 'I',
		};

		return gc[gender] ;
	}

	function convertFalsyToUnknown(value) {

		if ( value === null || value === undefined)
			return 'unknown';

		if(value === 'unknown')
			return 'unknown';

		return convertBooleanToYesNo(value) ;
	}

	function convertBooleanToYesNo(value) {
		return !!value ? 'yes' : 'no' ;
	}

	function convertStringToInt(value) {
		return parseInt(value);
	}

	function convertIntToString(value) {
		return value.toString();
	}

	function convertHomelevels(value){
		if(value=='3+'){
			value = '3Plus';
		}
		return value;
	}

	function convertNumberToStringPattern(value, pattern, zeroValue) {
		var stringValue = value > 0 ? Util.stringFormat(pattern, value) : zeroValue ;
		return ( value == 0 || value > 1) ? stringValue + 's' : stringValue ;
	}

	function convertNumberToStringPatternZeroSingular(value, pattern, zeroValue) {
		var stringValue = value > 0 ? Util.stringFormat(pattern, value) : zeroValue ;
		return (value > 1) ? stringValue + 's' : stringValue ;
	}

	var convertValueMapping = {
		'dwellings.*.isUnitAboveGround' : convertBooleanToYesNo,
		'dwellings.*.isPortionAboveGround' : convertBooleanToYesNo,
		'dwellings.*.isCycloneStandardlyBuilt' : convertBooleanToYesNo,
		'isInsuredsRetired': convertBooleanToYesNo,

		"dwellings.*.homeLevels": convertHomelevels,
		"dwellings.*.locationSecurity.hasDoorDeadlocks" : convertBooleanToYesNo,
		"dwellings.*.locationSecurity.hasDoorSecurityScreen" : convertBooleanToYesNo,
		"dwellings.*.locationSecurity.hasWindowKeylocks" : convertBooleanToYesNo,
		"dwellings.*.locationSecurity.hasWindowRollerShutter" : convertBooleanToYesNo,
		"dwellings.*.locationSecurity.hasWindowScreenBars" : convertBooleanToYesNo,
		"dwellings.*.locationSecurity.isGatedCommunity" : convertBooleanToYesNo,
		"dwellings.*.locationSecurity.hasFixedHomeSafe" : convertBooleanToYesNo,
		"dwellings.*.locationSecurity.isSecurityRatedBuilding" : convertBooleanToYesNo,
		"dwellings.*.locationSecurity.haveSecurityAlarm" : convertBooleanToYesNo,
		"dwellings.*.locationSecurity.has24HourConcierge" : convertBooleanToYesNo,


		"policyHolders.*.contact.dateOfBirth" : convertDate,
		"policyHolders.*.contact.dwellingHistory.*.eventMonth":getMonthNumber,
		"policyHolders.*.contact.gender":convertGender,

		"policyHolders.*.contact.authorisedPersons.*.person.gender":convertGender,
		"policyHolders.*.contact.authorisedPersons.*.person.dateOfBirth":convertDate,



		/**
		* Guide Wire formatting for bedrooms, balconies and etc ...
		* bring popcorn

		for none of each :

		numberOfBalconies:"no_balconies_or_decks"
		numberOfBedrooms:"1_item"
		numberOfCarports:"no_carports"
		numberOfGarages:"no_garages"
		numberOfVerandahs:"no_verandahs"

		For 1 of each :

		numberOfBalconies:"1_item"
		numberOfBedrooms:"1_item"
		numberOfCarports:"carport_for_1_car"
		numberOfGarages:"garage_for_1_car"
		numberOfVerandahs:"1_item"

		For 2 of each :

		numberOfBalconies:"2_items"
		numberOfBedrooms:"2_items"
		numberOfCarports:"carport_for_2_cars"
		numberOfGarages:"garage_for_2_cars"
		numberOfVerandahs:"2_items"

		for max of each :

		numberOfBalconies:"6_items"
		numberOfBedrooms:"9_items"
		numberOfCarports:"carport_for_6_cars"
		numberOfGarages:"garage_for_6_cars"
		numberOfVerandahs:"6_items"
		*/
		"dwellings.0.locationProperty.numberOfBedrooms" : function(value) {return convertNumberToStringPattern(value, '{0}_item', '1_item')},
		"dwellings.0.locationProperty.numberOfBalconies" : function(value) {return convertNumberToStringPattern(value, '{0}_item', 'no_balconies_or_deck')},
		"dwellings.0.locationProperty.numberOfVerandahs" : function(value) {return convertNumberToStringPattern(value, '{0}_item', 'no_verandah')},
		"dwellings.0.locationProperty.numberOfCarports" :  function(value) {return convertNumberToStringPattern(value, 'carport_for_{0}_car', 'no_carport')},
		"dwellings.0.locationProperty.numberOfGarages" : function(value) {return convertNumberToStringPattern(value, 'garage_for_{0}_car', 'no_garage')},
		"dwellings.0.locationProperty.numberOfLargeSheds" : function(value) {return convertNumberToStringPatternZeroSingular(value, '{0}_item', '0_item')},
		"dwellings.0.locationProperty.numberOfSmallSheds" : function(value) {return convertNumberToStringPatternZeroSingular(value,  '{0}_item', '0_item')},
		"periodStartDate": convertDateToGWTimeZone,

	};

	function transform(intermediateRequest, userInput) {
		var transformedRequest = jsonMapper.convert(intermediateRequest, convertValueMapping) ;
		return transformedRequest;
	}

	return {
		transform: transform
	}
}

function HomePolicyHolderHandler(Util, publicIDTransformer) {

	
	function handle(quoteRequest, userInput) {
		
		
		return quoteRequest;
	}

    return {
		handle: handle
	}
};
"use strict";

function HomePublicIDTransformer(Util, jsonMapper, serviceResponseRepository) {
	var currentResponse = null ;

	function forgePublicId(moduleName) {
		return Util.stringFormat('portal:{0}-{1}', moduleName, Util.generateRandomString(15) );
	}

	function hash(value) {
		return md5(value);
	}

	function fetchFromPreviousResponse(path) {
		if ( currentResponse )
			return Util.findHierarchyStringInObject(currentResponse, path , '.') ;

		return null;
	}


	function convertPublicID(path, moduleName) {
		if ( currentResponse ) {
			var lastPublicID =  fetchFromPreviousResponse(path) ;
			if ( lastPublicID )
				return lastPublicID;
		}

		return forgePublicId(moduleName) ;
	}


	var moduleNameMapping = {
		'policyHolders' : 'PolicyHolder',
		'policyHoldersContact' : 'PolicyHolder',
		'policyAddress' : 'Address',
		"dwellings":"QPHDwelling", // AbstractQPHDwelling
		"mortgagees":"QPHMortgagee",
		"cycles":"QPHCycle",
		"cycleEquipments":"QPHCycleEquipment",
		"pattern": "qbePattern",
		"dwellingHistory": "QPHDwellingHistory",
		"dwellingHistories": "QPHDwellingHistoryDTO"
	};

	var publicIDTransformationMapping = {
		'policyAddress.publicID' :  function() { return forgePublicId(moduleNameMapping.policyAddress)  },
		'policyHolders.*.publicID' : function() { return forgePublicId(moduleNameMapping.policyHolders)  },
		'policyHolders.*.contact.dwellingHistory.*.publicID' : function() { return forgePublicId(moduleNameMapping.dwellingHistory)  },
		"dwellings.0.publicID": function() { return forgePublicId(moduleNameMapping.dwellings)},
		"dwellings.0.location.publicID": function() { return forgePublicId(moduleNameMapping.policyAddress)},
		"policyHolders.*.contact.publicID": function() { return forgePublicId(moduleNameMapping.policyHoldersContact)},
		"policyHolders.*.contact.authorisedPersons.*.person.publicID": function() { return forgePublicId(moduleNameMapping.policyHoldersContact)},
		"policyHolders.*.contact.authorisedPersons.*.person.primaryAddress.publicID": function() { return forgePublicId(moduleNameMapping.policyAddress)},
		"policyHolders.*.contact.primaryAddress.publicID": function() { return forgePublicId(moduleNameMapping.policyAddress)},
		"dwellings.*.mortgagees.*.publicID":function() { return forgePublicId(moduleNameMapping.mortgagees)},
		"dwellings.*.policyOption.cycles.*.publicID":function() { return forgePublicId(moduleNameMapping.cycles)},
		"dwellings.*.policyOption.cycleEquipments.*.publicID":function() { return forgePublicId(moduleNameMapping.cycleEquipments)},
		"dwellings.*.dwellingHistories.*.publicID":function() { return forgePublicId(moduleNameMapping.dwellingHistories)},
	};

	var publicIDConversionMapping = {
		'policyAddress.publicID' :  function(val) { return convertPublicID('policyAddress.publicID', moduleNameMapping.policyAddress);} ,
		'policyHolders.*.publicID' : function(val, mappedValueStarIndices) {
			return convertPublicID('policyHolders.' + mappedValueStarIndices[0] + '.publicID', moduleNameMapping.policyHolders);
		},
		'policyHolders.*.contact.dwellingHistory.*.publicID' : function(val, mappedValueStarIndices) {
			return convertPublicID('policyHolders.' + mappedValueStarIndices[0] + '.contact.dwellingHistory.'  + mappedValueStarIndices[1] + '.publicID' , moduleNameMapping.dwellingHistory);
		},
		"policyHolders.*.contact.authorisedPersons.*.person.publicID": function(val, mappedValueStarIndices) {
			return convertPublicID('policyHolders.' + mappedValueStarIndices[0] + '.contact.authorisedPersons.'+ mappedValueStarIndices[1] + '.person.publicID' , moduleNameMapping.policyHoldersContact);
		},
		"policyHolders.*.contact.authorisedPersons.*.person.primaryAddress.publicID": function(val, mappedValueStarIndices) {
			return convertPublicID('policyHolders.' + mappedValueStarIndices[0] + '.contact.authorisedPersons.'+ mappedValueStarIndices[1] + '.person.primaryAddress.publicID', moduleNameMapping.policyAddress);
		},
		"dwellings.0.publicID": function(val) { return convertPublicID('dwellings.0.publicID', moduleNameMapping.dwellings);} ,
		"dwellings.0.location.publicID": function(val) { return convertPublicID('dwellings.0.location.publicID', moduleNameMapping.policyAddress);},
		'policyHolders.*.contact.publicID' : function(val, mappedValueStarIndices) {
			return convertPublicID('policyHolders.' + mappedValueStarIndices[0] + '.contact.publicID', moduleNameMapping.policyHoldersContact);
		},
		'policyHolders.*.contact.primaryAddress.publicID' : function(val, mappedValueStarIndices) {
			return convertPublicID('policyHolders.' + mappedValueStarIndices[0] + '.contact.primaryAddress.publicID', moduleNameMapping.policyAddress);
		},
		'dwellings.*.mortgagees.*.publicID':function(val, mappedValueStarIndices) {
			return convertPublicID('dwellings.' + mappedValueStarIndices[0] +  '.mortgagees.' + mappedValueStarIndices[1] + '.publicID', moduleNameMapping.mortgagees);
		},
		'dwellings.*.policyOption.cycles.*.publicID':function(val, mappedValueStarIndices) {
			return convertPublicID('dwellings.' + mappedValueStarIndices[0] +  '.policyOption.cycles.' + mappedValueStarIndices[1] + '.publicID', moduleNameMapping.cycles);
		},
		'dwellings.*.policyOption.cycleEquipments.*.publicID':function(val, mappedValueStarIndices) {
			return convertPublicID('dwellings.' + mappedValueStarIndices[0] +  '.policyOption.cycleEquipments.' + mappedValueStarIndices[1] + '.publicID', moduleNameMapping.cycleEquipments);
		},
		'dwellings.*.dwellingHistories.*.publicID':function(val, mappedValueStarIndices) {
			return convertPublicID('dwellings.' + mappedValueStarIndices[0] +  '.dwellingHistories.' + mappedValueStarIndices[1] + '.publicID', moduleNameMapping.dwellingHistories);
		},
	};

	function transform(intermediateRequest, response, quickQuote) {

		currentResponse = response ;

		var transformedRequest = intermediateRequest;
		if ( !currentResponse || quickQuote )
		 	transformedRequest = jsonMapper.transform(intermediateRequest, publicIDTransformationMapping) ;
		else
		 	transformedRequest = jsonMapper.convert(intermediateRequest, publicIDConversionMapping) ;

		return transformedRequest;
	}

	return {
		transform: transform
	}
}

function HomeQuoteResultModel(quoteResultResponse) {
	this.isCoverAvailable = quoteResultResponse.quoteResult.totalPremium !== undefined ;
	this.coverType = quoteResultResponse.dwellings[0].coverType;
	this.quoteResult = quoteResultResponse.quoteResult;
	this.paymentPlan = quoteResultResponse.paymentPlan;
	this.totalPremium = quoteResultResponse.quoteResult.totalPremium ;
	this.totalFSL = quoteResultResponse.quoteResult.totalFSL ;
	this.totalGST = quoteResultResponse.quoteResult.totalGST ;
	this.totalStampDuty = quoteResultResponse.quoteResult.totalStampDuty ;
	this.premiumAfterDiscount = quoteResultResponse.quoteResult.premiumAfterDiscount ;
	this.paymentFrequency = quoteResultResponse.paymentPlan ? quoteResultResponse.paymentPlan.paymentFrequency : null ;
	this.excess = quoteResultResponse.dwellings[0].excess ;
	this.cordelInfo = quoteResultResponse.dwellings[0].cordelInfo ;
	this.availableSumInsuredTypes = quoteResultResponse.dwellings[0].availableSumInsuredTypes;
	this.offering = quoteResultResponse.dwellings[0].offering;
	this.isStandardOffering = this.offering === 'QPHStandardOffering' ; 
	this.isPrestigeOffering = this.offering === 'QPHPrestigeOffering' ; 
	this.coverageOptions = quoteResultResponse.dwellings[0].coverageOptions ;
	this.response = quoteResultResponse ;

}

function HomeRetrieveSavedQuoteResponseTransformer($filter, jsonMapper, Util) {
	// transform functions
	var transformers = {
		camelcase: function(value) {
			if (value) {
				return value.charAt(0).toUpperCase() + value.slice(1);
			}
		},
		date: function(dateString) {
			var date = moment(dateString, 'YYYY-MM-DD');
			return date.format('DD/MM/YYYY');
		},
		today: function(dateString) {
			var returnDate = '';
			if (moment().diff(dateString, 'days') > 0) {
				var date = moment();
				returnDate = date.format('DD/MM/YYYY');
			} else {
				var date = moment(dateString, 'YYYY-MM-DD');
				returnDate = date.format('DD/MM/YYYY');
			}
			return returnDate;
		},
		hasValue: function(value) {
			if (value) {
				return true;
			} else {
				return false;
			}
		},
		financeType: function(financeType) {
			switch (financeType) {
				case 'none':
					return '';
					break;
			}
		},
		convertGender: function(gender) {
			var gc = {
				M: 'male',
				F: 'female',
				I: 'intersex'
			};
			return gc[gender];
		},
		yesNo: function(value) {
			return value == 'yes' ? true : false;
		},
		checkbox: function(value) {},
		state: function(state) {
			if (state) return state.replace('AU_', '');
		},
		coverType: function(coverType) {
			if (
				coverType === 'third_party' ||
				coverType === 'third_party_fire_theft'
			) {
				return 'third_party';
			}
			return coverType;
		},
		purchaseMonthFromMonthYear: function(monthYear) {
			if (monthYear) {
				return monthYear.split('-')[1];
			} else {
				return '';
			}
		},
		purchaseYearFromMonthYear: function(monthYear) {
			if (monthYear) {
				return monthYear.split('-')[0];
			} else {
				return '';
			}
		},
		thirdPartyPref: function(coverType) {
			if (coverType === 'comprehensive') {
				return null;
			}
			return coverType;
		},
		itemCount: function(itemString) {
			var itemObj = {
				no_balconies_or_decks: '0',
				no_verandahs: '0',
				'0_item': '0',
				'1_item': '1',
				'2_items': '2',
				'3_items': '3',
				'4_items': '4',
				'5_items': '5',
				'6_items': '6',
				'7_items': '7',
				'8_items': '8',
				'9_items': '9',
				'10_items': '10',
				'11_items': '11'
			};

			return itemObj[itemString];
		},
		itemCountGarages: function(itemString) {
			var itemObj = {
				no_garages: '0',
				garage_for_1_car: '1',
				garage_for_2_cars: '2',
				garage_for_3_cars: '3',
				garage_for_4_cars: '4',
				garage_for_5_cars: '5',
				garage_for_6_cars: '6'
			};

			return itemObj[itemString];
		},
		itemCountCarPort: function(itemString) {
			var itemObj = {
				no_carports: '0',
				carport_for_1_car: '1',
				carport_for_2_cars: '2',
				carport_for_3_cars: '3',
				carport_for_4_cars: '4',
				carport_for_5_cars: '5',
				carport_for_6_cars: '6'
			};

			return itemObj[itemString];
		},
		cycleNameMapping: function(itemString) {
			var itemObj = {
				mountain_bike: 'Mountain Bike',
				road_bike: 'Road Bike',
				bmx: 'BMX',
				track_bike: 'Track Bike',
				motorised_bike: 'Motorised Bike',
				accessories: 'Accessories',
				custom_parts: 'Custom parts',
				travel_case: 'Travel case',
				cycling_apparel: 'Cycling Apparel',
				cycling_computer: 'Cycling Computer'
			};

			return itemObj[itemString];
		},
		coverMapping: function(itemString) {
			var itemObj = {
				building_only: 'Building only',
				contents_only: 'Contents only',
				building_and_contents: 'Building and Contents',
				multi_item_loss: 'Multi Item Loss',
				bicycle: 'Bicycle',
				camping_equipment: 'Camping Equipment',
				clothing: 'Clothing',
				collection: 'Collection',
				computer_equipment: 'Computer Equipment',
				eye_ware: 'Eye ware',
				firearm: 'Firearm',
				gps_device: 'GPS Device',
				hearing_aid: 'Hearing Aid',
				in_vault_item: 'In Vault Item',
				jewellery: 'Jewellery',
				mobile_phone: 'Mobile Phone',
				music_games_media: 'Music, Games and Media',
				personal_medical_item: 'Personal Medical Item',
				personal_valuable_item: 'Personal Valuable Item',
				photographic_equipment: 'Photographic and Video Equipment',
				portable_music_instrument: 'Portable musical instrument',
				prosthetics: 'Prosthetics',
				other_portable_item: 'Other Portable Item',
				sporting_equipment: 'Sporting Equipment',
				tablet: 'Portable Computer Equipment',
				watch: 'Watch'
			};

			return itemObj[itemString];
		},
		monthFromNumber: function(monthNumber) {
			var monthObj = {
				'01': 'January',
				'02': 'February',
				'03': 'March',
				'04': 'April',
				'05': 'May',
				'06': 'June',
				'07': 'July',
				'08': 'August',
				'09': 'September',
				'10': 'October',
				'11': 'November',
				'12': 'December'
			};

			return monthObj[monthNumber];
		}
	};

	function transformBuilding(buildingDetails) {
		var slope = buildingDetails.landSlope;
		if (slope === 'flat') {
			buildingDetails.landSlope = 'flat';
		} else {
			buildingDetails.landSlope = buildingDetails.slopeType;
		}
		return buildingDetails;
	}

	function transformTellUsAboutBuilding(buildingDetails) {
		if (buildingDetails.isHomeElevated) {
		} else {
			buildingDetails.isHomeElevated = 'notasked';
		}
		return buildingDetails;
	}

	function transformInsuranceHistory(insuranceHistory) {
		var _portableClaimHistory = [];
		var _claimHistory = [];

		if (insuranceHistory.history) {
			insuranceHistory.history.forEach(function(item) {
				if (item.isPortableContents) {
					_portableClaimHistory.push({
						coverAffected: {
							value: item.contentCategory,
							label: transformers.coverMapping(
								item.contentCategory
							)
						},
						year: {
							value: item.year,
							label: item.year
						},
						month: {
							value: transformers.monthFromNumber(
								item.eventMonth
							),
							label: transformers.monthFromNumber(item.eventMonth)
						},
						description: {
							value: item.pattern.description,
							label: item.pattern.description,
							description: item.pattern.description,
							publicID: item.pattern.publicID,
							code: item.pattern.code,
							filter1: item.pattern.filter1
						}
					});
				} else {
					_claimHistory.push({
						coverAffected: {
							value: item.claimType,
							label: transformers.coverMapping(item.claimType)
						},
						year: {
							value: item.year,
							label: item.year
						},
						month: {
							value: transformers.monthFromNumber(
								item.eventMonth
							),
							label: transformers.monthFromNumber(item.eventMonth)
						},
						description: {
							value: item.pattern.description,
							label: item.pattern.description,
							description: item.pattern.description,
							publicID: item.pattern.publicID,
							code: item.pattern.code,
							filter1: item.pattern.filter1
						}
					});
				}
			});

			insuranceHistory.claimDetails = _claimHistory;
			insuranceHistory.portableClaimDetails = _portableClaimHistory;
		}

		return insuranceHistory;
	}

	function transformCycleCover(cycleCover) {
		var _cycleList = [];
		var _coverItemsList = [];
		if (cycleCover.cycleList) {
			cycleCover.cycleList.forEach(function(item) {
				_cycleList.push({
					bikeType: {
						value: item.typeOfBicycle,
						label: transformers.cycleNameMapping(item.typeOfBicycle)
					},
					description: item.description,
					value: item.value
				});
			});
		}

		if (cycleCover.coverItemsList) {
			cycleCover.coverItemsList.forEach(function(item) {
				_coverItemsList.push({
					category: {
						value: item.category,
						label: transformers.cycleNameMapping(item.category)
					},
					description: item.description,
					value: item.value
				});
			});
		}

		if (_coverItemsList.length > 0) {
			cycleCover.coverItems = true;
		} else {
			cycleCover.coverItems = false;
		}

		cycleCover.cycleList = _cycleList;
		cycleCover.coverItemsList = _coverItemsList;
		// {"bikeType":{"value":"mountain_bike","label":"Mountain Bike"},"description":"mb","value":"1000"}
		return cycleCover;
	}

	function transformMortgageOnProperty(mortgageOnProperty) {
		if (
			mortgageOnProperty.propertyMortgagedWith &&
			mortgageOnProperty.propertyMortgagedWith.length > 0
		) {
			mortgageOnProperty.isPropertyUnderMortgage = true;
			var _mortgageWith = [];
			mortgageOnProperty.propertyMortgagedWith.forEach(function(item) {
				_mortgageWith.push(item.mortgagee);
			});

			mortgageOnProperty.propertyMortgagedWith = _mortgageWith;
		} else {
			mortgageOnProperty.isPropertyUnderMortgage = false;
			mortgageOnProperty.propertyMortgagedWith = [];
		}
		return mortgageOnProperty;
	}

	function transformSecurity(securityTransform) {
		var _securityExternalDoors = {
			deadlocks: securityTransform.security.hasDoorDeadlocks == 'yes',
			door_security_screen:
				securityTransform.security.hasDoorSecurityScreen == 'yes'
		};

		var _securityExternalWindows = {
			keylocks: securityTransform.security.hasWindowKeylocks == 'yes',
			roller_shutter:
				securityTransform.security.hasWindowRollerShutter == 'yes',
			security_screens_or_bars:
				securityTransform.security.hasWindowScreenBars == 'yes'
		};

		var _otherSecurity = {
			gated_community:
				securityTransform.security.isGatedCommunity == 'yes',
			'24_hour_concierge':
				securityTransform.security.has24HourConcierge == 'yes',
			fixed_home_sage:
				securityTransform.security.hasFixedHomeSafe == 'yes',
			security_rated_building:
				securityTransform.security.isSecurityRatedBuilding == 'yes',
			'24_hour_monitored_alarm':
				securityTransform.security.haveSecurityAlarm == 'yes'
		};

		return {
			securityExternalDoors: _securityExternalDoors,
			securityExternalWindows: _securityExternalWindows,
			otherSecurity: _otherSecurity
		};
	}

	function transformNeeds(needTransform, fullData) {
		var coverType = needTransform.coverType;
		needTransform.coverNeeds = {
			building: false,
			contents: false,
			rent_default: false,
			malicious_damage: false
		};

		//basic need
		if (coverType == 'building_and_contents') {
			needTransform.coverNeeds.building = true;
			needTransform.coverNeeds.contents = true;
		} else if (coverType == 'building_only') {
			needTransform.coverNeeds.building = true;
		} else if (coverType == 'contents_only') {
			needTransform.coverNeeds.contents = true;
		}

		//landlord needs
		var policyOption = needTransform.policyOption;
		if (policyOption.isRentDefaultCover) {
			needTransform.coverNeeds.rent_default = true;
		}

		if (fullData.theftAndVandalismByTenants) {
			if (
				fullData.theftAndVandalismByTenants.theftCoverContents ||
				fullData.theftAndVandalismByTenants.theftCoverBuilding
			) {
				needTransform.coverNeeds.malicious_damage = true;
			}
		}

		delete needTransform.policyOption;
		delete needTransform.coverType;

		return needTransform;
	}

	function transformMainPolicyHolder(returnObject, policyHolder, response) {
		//tell us about the main policy holder -------------------------------------
		returnObject.mainPolicyHolder = {
			prefix: policyHolder.contact.prefix,
			firstName: policyHolder.contact.firstName,
			lastName: policyHolder.contact.lastName,
			gender: policyHolder.contact.gender,
			dateOfBirth: policyHolder.contact.dateOfBirth,
			tenYears_chargedOrConvictedOffences:
				policyHolder.contact.hasConviction
		};
		convertMapping = {
			'mainPolicyHolder.gender': transformers.convertGender,
			'mainPolicyHolder.dateOfBirth': transformers.date
		};

		var mappedValue = jsonMapper.convert(returnObject, convertMapping);
		if (policyHolder.contact.hasConviction == 'yes') {
			//parse dwelling history only if the hasConviction is yes
			var _convictionHistory = [];
			policyHolder.contact.dwellingHistory.forEach(function(conviction) {
				// tenYears_chargedOrConvictedOffences

				var _conviction = {
					description: {
						publicID: conviction.pattern.publicID,
						code: conviction.pattern.code,
						description: conviction.pattern.description,
						value: conviction.pattern.description,
						label: conviction.pattern.description,
						filter1: conviction.pattern.filter1
					},
					year: {
						label: conviction.year,
						value: conviction.year
					},
					month: {
						label: transformers.monthFromNumber(
							conviction.eventMonth
						),
						value: transformers.monthFromNumber(
							conviction.eventMonth
						)
					}
				};
				_convictionHistory.push(_conviction);
			});

			returnObject.mainPolicyHolder.tenYears_chargedOrConvictedOffencesDetails = _convictionHistory;
		}

		//main policy holder contact -------------------------------------
		returnObject.mainPolicyHolderContact = {
			personContactResidentialAddress:
				policyHolder.contact.primaryAddress,
			address: policyHolder.contact.primaryAddress,
			//::'personContactSamePostalAddress' : policyHolder.contact,
			// 'personContactPostalAddress' : policyHolder.contact,
			emailAddress1: policyHolder.contact.emailAddress1,
			primaryPhone: policyHolder.contact.primaryPhone,
			passwordQuestion: policyHolder.contact.passwordQuestion,
			// 'personContactEnterAQuestion' : policyHolder.contact,
			passwordAnswer: policyHolder.contact.passwordAnswer,
			personContactMailingPreference: response.documentDeliveryMethod
		};

		//add number based on phone type
		if (policyHolder.contact.primaryPhone === 'work') {
			returnObject.mainPolicyHolderContact.contactNumber =
				policyHolder.contact.workPhone;
		} else if (policyHolder.contact.primaryPhone === 'home') {
			returnObject.mainPolicyHolderContact.contactNumber =
				policyHolder.contact.homePhone;
		} else if (policyHolder.contact.primaryPhone === 'mobile') {
			returnObject.mainPolicyHolderContact.contactNumber =
				policyHolder.contact.cellPhone;
		}

		//if custom question
		if (
			policyHolder.contact.passwordQuestion ===
			'customer_created_question'
		) {
			returnObject.mainPolicyHolderContact.personContactEnterAQuestion =
				policyHolder.contact.passwordQuestionStr;
		}

		// if contact type is company
		if (policyHolder.contact.contactType === 'company') {
			var authorisedPerson =
				policyHolder.contact.authorisedPersons[0].person;
			returnObject.aboutTheCompany = {};
			returnObject.aboutTheCompany.name = policyHolder.contact.name;
			returnObject.aboutTheCompany.abn = policyHolder.contact.abn;
			returnObject.aboutTheCompany.emailAddress1 =
				policyHolder.contact.emailAddress1;
			returnObject.aboutTheCompany.workPhone =
				policyHolder.contact.workPhone;
			returnObject.aboutTheCompany.companyAddress =
				policyHolder.contact.primaryAddress;

			returnObject.aboutCompanyContact = {};
			returnObject.aboutCompanyContact.prefix = authorisedPerson.prefix;
			returnObject.aboutCompanyContact.firstName =
				authorisedPerson.firstName;
			returnObject.aboutCompanyContact.lastName =
				authorisedPerson.lastName;
			returnObject.aboutCompanyContact.gender = transformers.convertGender(
				authorisedPerson.gender
			);
			returnObject.aboutCompanyContact.dateOfBirth = transformers.date(
				authorisedPerson.dateOfBirth
			);

			// postal address and custom question is not saved in GW
			returnObject.companyContactContact = {};
			returnObject.companyContactContact.companyContactResidentialAddress =
				authorisedPerson.primaryAddress;
			returnObject.companyContactContact.emailAddress1 =
				authorisedPerson.emailAddress1;
			// returnObject.companyContactContact.companyContactDetailsPostalAddress = response.policyAddress;
			returnObject.companyContactContact.primaryPhone =
				authorisedPerson.primaryPhone;
			returnObject.companyContactContact.contactNumber =
				authorisedPerson.homePhone ||
				authorisedPerson.workPhone ||
				authorisedPerson.cellPhone;
			returnObject.companyContactContact.passwordQuestion =
				policyHolder.contact.passwordQuestion;
			// returnObject.companyContactContact.passwordQuestionStr = policyHolder.contact.passwordQuestionStr || '';
			returnObject.companyContactContact.passwordAnswer =
				policyHolder.contact.passwordAnswer;
			returnObject.companyContactContact.companyContactMailingPreference =
				response.documentDeliveryMethod;
		}

		return returnObject;
	}

	//transform for the other policy holder
	function transformOtherPolicyHolder(returnObject, policyHolder) {
		if (!returnObject.additionalPolicyHolders) {
			returnObject.additionalPolicyHolders = {};
		}

		if (!returnObject.additionalPolicyHolders.policyHolders) {
			returnObject.additionalPolicyHolders.policyHolders = [];
		}

		var _contact = {
			additionalContactSamePostalAddress: 'yes',
			address: policyHolder.contact.primaryAddress,
			contactNumber: '',
			dateOfBirth: policyHolder.contact.dateOfBirth,
			emailAddress1: policyHolder.contact.emailAddress1,
			firstName: policyHolder.contact.firstName,
			gender: policyHolder.contact.gender,
			lastName: policyHolder.contact.lastName,
			passwordAnswer: policyHolder.contact.passwordAnswer,
			passwordQuestion: policyHolder.contact.passwordQuestion,
			prefix: policyHolder.contact.prefix,
			primaryPhone: policyHolder.contact.primaryPhone
			// 'tenYears_chargedOrConvictedOffences':policyHolder.,
			// 'tenYears_chargedOrConvictedOffencesDetails':policyHolder.,
		};

		//add number based on phone type
		if (policyHolder.contact.primaryPhone === 'work') {
			_contact.contactNumber = policyHolder.contact.workPhone;
		} else if (policyHolder.contact.primaryPhone === 'home') {
			_contact.contactNumber = policyHolder.contact.homePhone;
		} else if (policyHolder.contact.primaryPhone === 'mobile') {
			_contact.contactNumber = policyHolder.contact.cellPhone;
		}

		//if custom question
		if (
			policyHolder.contact.passwordQuestion ===
			'customer_created_question'
		) {
			_contact.personContactEnterAQuestion =
				policyHolder.contact.passwordQuestionStr;
		}

		if (policyHolder.contact.hasConviction === 'yes') {
			_contact.tenYears_chargedOrConvictedOffences = 'yes';
			_contact.tenYears_chargedOrConvictedOffencesDetails = [];
			policyHolder.contact.dwellingHistory.forEach(function(history) {
				_contact.tenYears_chargedOrConvictedOffencesDetails.push({
					description: {
						publicID: history.pattern.publicID,
						code: history.pattern.code,
						description: history.pattern.description,
						value: history.pattern.description,
						label: history.pattern.description,
						filter1: history.pattern.filter1
					},
					year: {
						label: history.year,
						value: history.year
					},
					month: {
						label: transformers.monthFromNumber(history.eventMonth),
						value: transformers.monthFromNumber(history.eventMonth)
					}
				});
			});
		} else {
			_contact.tenYears_chargedOrConvictedOffences = 'no';
		}

		convertMapping = {
			gender: transformers.convertGender,
			dateOfBirth: transformers.date
		};

		var mappedValue = jsonMapper.convert(_contact, convertMapping);
		returnObject.additionalPolicyHolders.policyHolders.push(_contact);

		return returnObject;
	}

	//transform policy holders
	function transformPolicyHolders(returnObject, response) {
		var _policyHolders = returnObject.policyHolders;
		var _policyHolderOldestDOB = moment();
		_policyHolders.forEach(function(policyHolder) {
			if (policyHolder.mainHolder == true) {
				returnObject = transformMainPolicyHolder(
					returnObject,
					policyHolder,
					response
				);
			} else {
				returnObject = transformOtherPolicyHolder(
					returnObject,
					policyHolder
				);
			}
			//sets as oldest date of birth if higher
			if (
				_policyHolderOldestDOB.diff(
					policyHolder.contact.dateOfBirth,
					'days'
				) > 0
			) {
				_policyHolderOldestDOB = moment(
					policyHolder.contact.dateOfBirth
				);
			}
		});

		// sets the oldest persons date of birth
		returnObject.tellUsAboutInsured.dobOldestInsured = _policyHolderOldestDOB.format(
			'DD/MM/YYYY'
		);

		return returnObject;
	}

	/**
	 * Transforms the retrievedQuoteRepsonse into a format that can be injected into the userInputRepository
	 * The returned value will populate all the forms in the quote process
	 * @param {Object} retrievedQuoteResponse				   Response object from the retrieveSavedQuote service
	 * @returns {Object}										Transformed object ready to inject into the userInputRepository
	 */
	function transform(retrievedQuoteResponse) {
		void 0;

		var transformMapping = {
				//estimate =================================================
				//tell us about property -------------------------------------
				'returnObject.tellUsAboutTheProperty.address':
					'=_input.dwellings.0.location',
				'returnObject.tellUsAboutTheProperty.typeOfBuilding':
					'=_input.dwellings.0.buildingType',
				'returnObject.tellUsAboutTheProperty.wallsMadeOf':
					'=_input.dwellings.0.externalWallMaterial',
				'returnObject.tellUsAboutTheProperty.howIsHomeOccupied':
					'=_input.dwellings.0.homeOccupancy',
				'returnObject.tellUsAboutTheProperty.propertyProfessionalAgent':
					'=_input.dwellings.0.policyOption.isPropertyAgentManaged',

				//tell us how we can insure you -------------------------------------
				'returnObject.tellUsHowWeCanInsureYou.coverType':
					'=_input.dwellings.0.coverType',
				'returnObject.tellUsHowWeCanInsureYou.policyOption':
					'=_input.dwellings.0.policyOption',
				'returnObject.tellUsHowWeCanInsureYou.needCoverOutsideHome':
					'=_input.dwellings.0.hasPortableContentsHomeAway',

				//rapid estimate -------------------------------------

				//tell us a bit more -------------------------------------
				'returnObject.tellUsABitMore.yourEmailAddress': '=_input.email',
				'returnObject.tellUsABitMore.promotionalCode':
					'=_input.campaignCode',

				//property =================================================
				//lets get started -------------------------------------
				'returnObject.letsGetStarted.personOrCompany':
					'=_input.policyHolders.0.contact.contactType',
				'returnObject.letsGetStarted.startCoverDate':
					'=_input.periodStartDate',

				//tell us about the building -------------------------------------
				'returnObject.tellUsAboutTheBuilding.yearHomeBuilt':
					'=_input.dwellings.0.homeBuiltYear',
				'returnObject.tellUsAboutTheBuilding.isStrataRegdCorp':
					'=_input.dwellings.0.isStrataRegisteredBody',
				'returnObject.tellUsAboutTheBuilding.areUnitAboveBelow':
					'=_input.dwellings.0.isUnitsAvailable',
				'returnObject.tellUsAboutTheBuilding.corpInsureUnit':
					'=_input.dwellings.0.isOwnersInsureUnits',

				'returnObject.tellUsAboutTheBuilding.isSuburbanBlock':
					'=_input.dwellings.0.isSubUrbanLocated',
				'returnObject.tellUsAboutTheBuilding.isBlockLarger':
					'=_input.dwellings.0.isPropertySize',
				'returnObject.tellUsAboutTheBuilding.waterSource':
					'=_input.dwellings.0.waterSourced',
				'returnObject.tellUsAboutTheBuilding.waterTankCapacity':
					'=_input.dwellings.0.waterTankCapacity',
				'returnObject.tellUsAboutTheBuilding.isEmergencyFuelWaterTank':
					'=_input.dwellings.0.isSecondaryFitted',
				'returnObject.tellUsAboutTheBuilding.isBuildingRelocatable':
					'=_input.dwellings.0.isCaravanHomeLocated',
				'returnObject.tellUsAboutTheBuilding.areFoundationsSecured':
					'=_input.dwellings.0.isSecuredFoundation',
				'returnObject.tellUsAboutTheBuilding.isFixedPlumbingElectricityConnect':
					'=_input.dwellings.0.isPlumbingConnect',
				'returnObject.tellUsAboutTheBuilding.roofMake':
					'=_input.dwellings.0.roofMaterial',
				'returnObject.tellUsAboutTheBuilding.isHomeElevated':
					'=_input.dwellings.0.groundElevated',
				'returnObject.tellUsAboutTheBuilding.isPortionBelowGround':
					'=_input.dwellings.0.isPortionAboveGround',

				// 'returnObject.tellUsAboutTheBuilding.areContentsBelowGround':	'=_input.dwellings.0.',
				'returnObject.tellUsAboutTheBuilding.homeLevels':
					'=_input.dwellings.0.homeLevels',
				'returnObject.tellUsAboutTheBuilding.isNationalTrustListed':
					'=_input.dwellings.0.isNationalTrustListed',
				'returnObject.tellUsAboutTheBuilding.isHomeWired':
					'=_input.dwellings.0.isFullyRewired',

				//tell us about the security -------------------------------------
				'returnObject.tellUsAboutTheSecurity.security':
					'=_input.dwellings.0.locationSecurity',

				//rennovation and residents -------------------------------------
				'returnObject.renovationsAndResidents.isHomeUnderRepairs':
					'=_input.dwellings.0.isRenovated',

				//property usage -------------------------------------
				'returnObject.propertyUsage.isPropertyForBusiness':
					'=_input.dwellings.0.isIncomeGenerated',
				'returnObject.propertyUsage.propertyActivityDegree':
					'=_input.dwellings.0.incomeGeneratingDegree',

				'returnObject.propertyUsage.propertyActivities':
					'=_input.dwellings.0.incomeGeneratingActivities',
				'returnObject.propertyUsage.propertyAgricultureActivities':
					'=_input.dwellings.0.agriculturalActivities',

				//mortgage on property -------------------------------------
				'returnObject.mortgageOnProperty.propertyMortgagedWith':
					'=_input.dwellings.0.mortgagees',

				//building =================================================
				//building details -------------------------------
				'returnObject.buildingDetails.homeBuiltStandard':
					'=_input.dwellings.0.locationProperty.homeStandard',
				'returnObject.buildingDetails.landSlope':
					'=_input.dwellings.0.locationProperty.isLandSloped',
				'returnObject.buildingDetails.slopeType':
					'=_input.dwellings.0.locationProperty.slopeType',
				'returnObject.buildingDetails.homeTotalArea':
					'=_input.dwellings.0.locationProperty.knowHomeSize',
				'returnObject.buildingDetails.homeArea':
					'=_input.dwellings.0.locationProperty.sizeOfHome',
				'returnObject.buildingDetails.homeAreaUnit':
					'=_input.dwellings.0.locationProperty.areaUnit',
				'returnObject.buildingDetails.homeBedrooms':
					'=_input.dwellings.0.locationProperty.numberOfBedrooms',
				'returnObject.buildingDetails.homeBedroomSize':
					'=_input.dwellings.0.locationProperty.sizeOfBedroom',

				'returnObject.buildingDetails.homeDecks':
					'=_input.dwellings.0.locationProperty.numberOfBalconies',
				'returnObject.buildingDetails.homeVerandahs':
					'=_input.dwellings.0.locationProperty.numberOfVerandahs',
				'returnObject.buildingDetails.homeCarports':
					'=_input.dwellings.0.locationProperty.numberOfCarports',
				'returnObject.buildingDetails.homeGarages':
					'=_input.dwellings.0.locationProperty.numberOfGarages',

				'returnObject.buildingDetails.homeSheds':
					'=_input.dwellings.0.locationProperty.hasSheds',

				'returnObject.buildingDetails.largeSheds':
					'=_input.dwellings.0.locationProperty.numberOfLargeSheds',
				'returnObject.buildingDetails.smallSheds':
					'=_input.dwellings.0.locationProperty.numberOfSmallSheds',

				'returnObject.buildingDetails.homeFeatures.ducted_airconditioning':
					'=_input.dwellings.0.locationProperty.hasDuctedAirConditioning',
				'returnObject.buildingDetails.homeFeatures.in_ground_swimming_pool':
					'=_input.dwellings.0.locationProperty.hasInGroundPool',
				'returnObject.buildingDetails.homeFeatures.tennis_court':
					'=_input.dwellings.0.locationProperty.hasTennisCourt',
				'returnObject.buildingDetails.homeFeatures.granny_flat':
					'=_input.dwellings.0.locationProperty.hasGrannyFlat',

				'returnObject.buildingDetails.grannyFlatSize':
					'=_input.dwellings.0.locationProperty.grannyFlatSize',
				'returnObject.buildingDetails.isBuiltToCycloneStandards':
					'=_input.dwellings.0.isCycloneStandardlyBuilt',

				//covers =================================================
				//your buildings -------------------------------------
				'returnObject.yourBuilding.buildingSumInsured':
					'=_input.dwellings.0.buildingSumInsured',
				//your contents -------------------------------------
				'returnObject.yourContents.contentsSumInsured':
					'=_input.dwellings.0.contentSumInsured',
				//portable contents -------------------------------------
				'returnObject.portableContents.coverPortableContents':
					'=_input.dwellings.0.hasPortableContentsHomeAway',
				'returnObject.portableContents.coverPortableContentsRegion':
					'=_input.dwellings.0.portableCoverCountry',
				'returnObject.portableContents.coverPortableContentLimit':
					'=_input.dwellings.0.generalPortableContents',
				'returnObject.portableContents.portableContentsSpecifiedCover':
					'=_input.dwellings.0.hasSpecifiedPortableContList',

				//accidental loss or damage -------------------------------------
				'returnObject.accidentalLossOrDamage.coverAccDmgBuilding':
					'=_input.dwellings.0.policyOption.isBuildingAccidentalDamage',
				'returnObject.accidentalLossOrDamage.coverAccDmgContents':
					'=_input.dwellings.0.policyOption.isContentsAccidentalDamage',

				//cycle cover -------------------------------------
				'returnObject.cycleCover.coverCycle':
					'=_input.dwellings.0.policyOption.isContentsCycleCover',
				'returnObject.cycleCover.coverCycleExtendOption':
					'=_input.dwellings.0.policyOption.isContentsCycleRacingCover',
				'returnObject.cycleCover.cycleList':
					'=_input.dwellings.0.policyOption.cycles',
				'returnObject.cycleCover.coverItemsList':
					'=_input.dwellings.0.policyOption.cycleEquipments',

				//rent default
				'returnObject.rentDefault.rentDefault':
					'=_input.dwellings.0.policyOption.rentDefaultAmount',

				'returnObject.rentDefault.rentCurrentWeekly':
					'=_input.dwellings.0.policyOption.rentDefaultAmount',
				'returnObject.rentDefault.rentXWeeks':
					'=_input.dwellings.0.policyOption.rentDefaultWeeks',

				//vandalism by tenanats
				'returnObject.theftAndVandalismByTenants.theftCoverContents':
					'=_input.dwellings.0.policyOption.isContentVandalismCover',
				'returnObject.theftAndVandalismByTenants.theftCoverBuilding':
					'=_input.dwellings.0.policyOption.isBuildingVandalismCover',
				// 'returnObject.tellUsHowWeCanInsureYou.coverNeeds.malicious_damage':	'=_input.dwellings.0.isBuildingVandalismCover',

				//high risk items
				'returnObject.specifiedHighRiskItems.riskCoverIndividualWorks':
					'=_input.dwellings.0.hasWorksArt',
				'returnObject.specifiedHighRiskItems.riskEntertainmentEquipment':
					'=_input.dwellings.0.hasEntertainmentEquipment',

				//domestic worker compansation
				'returnObject.domesticWorkerCompensation.domesticWorkerCompCover':
					'=_input.dwellings.0.policyOption.isContentsDomesticWorkerComp',

				//details =================================================
				//tell us about insured -------------------------------------
				'returnObject.tellUsAboutInsured.dobOldestInsured':
					'=_input.policyHolders.0.contact.dateOfBirth',
				'returnObject.tellUsAboutInsured.isRetired':
					'=_input.isInsuredsRetired',

				// insurance history -------------------------------------
				'returnObject.insuranceHistory.history':
					'=_input.dwellings.0.dwellingHistories',
				'returnObject.insuranceHistory.insuranceHeldFor':
					'=_input.dwellings.0.yearsContInsurance',
				'returnObject.insuranceHistory.previousInsurer':
					'=_input.dwellings.0.previousInsurer',
				'returnObject.insuranceHistory.claimInLastYear':
					'=_input.dwellings.0.hasInsuredClaims',
				'returnObject.insuranceHistory.portableClaim':
					'=_input.hasPortableContentsClaims',

				//quote =================================================
				//insured excess value -------------------------------------
				//save on premium -------------------------------------
				// optional benifits -------------------------------------
				// promotonal code -------------------------------------

				//contact =================================================
				//tell us about the main policy holder -------------------------------------
				//main policy holder contact -------------------------------------
				//additional policy holder -------------------------------------
				//tell us about the company -------------------------------------
				//tell us about the authurised contact for the company -------------------------------------
				//compant contact -------------------------------------
				'returnObject.policyHolders': '=_input.policyHolders',

				//payment =================================================
				//payment details -------------------------------------
				//promotional code -------------------------------------

				//additional info
				'returnObject.info': {},
				'returnObject.info.offering': '=_input.dwellings.0.offering'
			},
			convertMapping = {
				'returnObject.letsGetStarted.startCoverDate': transformers.date,
				'returnObject.buildingDetails.homeBedrooms':
					transformers.itemCount,
				'returnObject.buildingDetails.homeDecks':
					transformers.itemCount,
				'returnObject.buildingDetails.homeVerandahs':
					transformers.itemCount,
				'returnObject.buildingDetails.homeCarports':
					transformers.itemCountCarPort,
				'returnObject.buildingDetails.homeGarages':
					transformers.itemCountGarages,
				'returnObject.buildingDetails.largeSheds':
					transformers.itemCount,
				'returnObject.buildingDetails.smallSheds':
					transformers.itemCount,
				'returnObject.rentDefault.rentDefault': transformers.hasValue,
				'returnObject.tellUsAboutTheBuilding.isPortionBelowGround':
					transformers.yesNo,
				'returnObject.tellUsAboutInsured.isRetired': transformers.yesNo,
				'returnObject.tellUsAboutTheBuilding.isBuiltToCycloneStandards':
					transformers.yesNo

				// 'returnObject.carDetails.colour':									   transformers.camelcase,
				// 'returnObject.getStarted.policyStartDate':							  transformers.date,
				// 'returnObject.carDetails.carFinance':									transformers.financeType,
				// 'returnObject.retrievedQuoteRego.state':								transformers.state,
				// 'returnObject.insuredExcessValue.coverType':							transformers.coverType,
				// 'returnObject.insuredExcessValue.thirdPartyOrThirdPartyFireAndTheft':   transformers.thirdPartyPref,
				// 'returnObject.carDetails.whenDidYouBuyYear':							transformers.purchaseMonthFromMonthYear,
				// 'returnObject.carDetails.whenDidYouBuyMonth':						   transformers.purchaseYearFromMonthYear
			};
		var transformedQuote = jsonMapper.convert(
			jsonMapper.transform(retrievedQuoteResponse, transformMapping),
			convertMapping
		);
		transformedQuote.returnObject.tellUsAboutTheSecurity = transformSecurity(
			transformedQuote.returnObject.tellUsAboutTheSecurity
		);
		transformedQuote.returnObject.tellUsHowWeCanInsureYou = transformNeeds(
			transformedQuote.returnObject.tellUsHowWeCanInsureYou,
			transformedQuote.returnObject
		);
		transformedQuote.returnObject.buildingDetails = transformBuilding(
			transformedQuote.returnObject.buildingDetails
		);
		transformedQuote.returnObject.tellUsAboutTheBuilding = transformTellUsAboutBuilding(
			transformedQuote.returnObject.tellUsAboutTheBuilding
		);
		transformedQuote.returnObject.mortgageOnProperty = transformMortgageOnProperty(
			transformedQuote.returnObject.mortgageOnProperty
		);
		transformedQuote.returnObject.cycleCover = transformCycleCover(
			transformedQuote.returnObject.cycleCover
		);
		transformedQuote.returnObject.insuranceHistory = transformInsuranceHistory(
			transformedQuote.returnObject.insuranceHistory
		);
		transformedQuote.returnObject = transformPolicyHolders(
			transformedQuote.returnObject,
			retrievedQuoteResponse
		);

		return transformedQuote.returnObject;
	}
	return {
		transform: transform
	};
}

	'use strict' ;

function HomeSplitterRequestTransformer(Util,  serviceResponseRepository, jsonMapper, publicIDTransformer, coverTypeTransformer) {

	function getQuoteResponseValue(qouteResponse, pathString) {
		return Util.findHierarchyStringInObject(qouteResponse, pathString, '.') ;
	}

	function transform(quotePermutations, quoteRequest) {
		var quoteResponses = serviceResponseRepository.getLastResponseFrom('quickQuote') ;
		var transformedRequest = null ;
		if ( quoteResponses )
			transformedRequest = transformExistingQuote(quotePermutations, quoteResponses, quoteRequest) ;
		else
			transformedRequest = transformNewQuote(quotePermutations, quoteRequest) ;

		return transformedRequest ;
	}

	function transformExistingQuote(quotePermutations, quoteResponses, quoteRequest) {
		var quotes = Util.generatePermutationsArray(quotePermutations.offerings, quotePermutations.paymentFrequencies).map(function(permutation, index) {
			var quote = Object.extend(permutation, quoteRequest);
			var offering = permutation.option1;
			var paymentFrequency = permutation.option2;
			delete quote.option1; delete quote.option2 ; 
			var quoteType = quotePermutations.quoteType ;
			var coverType = quotePermutations.coverTypes[0] ;
			var q = Util.deepClone(quote) ;
			q = Object.extend(q,{
				quoteType: quoteType,
				paymentFrequency: paymentFrequency,
			}) ;

			var quoteResponseBody = null ;
			var matchingQuoteResponse = findMatchingQuoteResponse(quoteResponses, coverType, offering) ;
			if ( matchingQuoteResponse )
				quoteResponseBody = matchingQuoteResponse.response;

			q = publicIDTransformer.transform(q, quoteResponseBody, true) ;
			q = coverTypeTransformer.transform(q, coverType.descriptor, offering.descriptor);
			return q ;
		}) ;

		return quotes.filter(function(quote) { return quote !== null }) ;
	}

	function findMatchingQuoteResponse(quoteResponses, coverType, offering){
		if ( ! quoteResponses )
			return;

		var matchingResponse = null ;
		quoteResponses.some(function(qr) {
			if (qr.coverType ==  coverType.descriptor && qr.offering == offering.descriptor ) {
				matchingResponse = qr ;
				return true;
			}
		});

		return matchingResponse;
	}

	function transformNewQuote(quotePermutations, quoteRequest) {
		var nr = quotePermutations.offerings.length * quotePermutations.paymentFrequencies.length;
		var counter = 0 ; 
		var quotes = Util.arrayFill(nr, quoteRequest).map(function(quote, index) {
			var offering = quotePermutations.offerings[index % quotePermutations.offerings.length];			
			var paymentFrequency = quotePermutations.paymentFrequencies[counter % quotePermutations.paymentFrequencies.length];
			var quoteType = quotePermutations.quoteType ;
			var coverType = quotePermutations.coverTypes[0];
			var q = Util.deepClone(quote) ;
			q = Object.extend(q,{
				quoteType: quoteType,
				paymentFrequency: paymentFrequency,
			}) ;

			q = coverTypeTransformer.transform(q, coverType.descriptor, offering.descriptor);
			q = publicIDTransformer.transform(q) ;
			if ( index == quotePermutations.offerings.length - 1 )
				counter = ++counter % quotePermutations.paymentFrequencies.length ; 
			
			return q ;
		}) ;

		return quotes ;
	}

	return {
		transform: transform
	}
}

function HomeStructureRequestTransformer(
	jsonMapper,
	util,
	quoteOptions,
	storage
) {
	var structureQuoteMapping = {
		periodStartDate: "=_input.homeForm.letsGetStarted.startCoverDate",
		dwellings: [],
		"dwellings.0": {},
		"dwellings.0.location": "=_addressSearch",
		"dwellings.0.buildingType":
			"=_input.homeForm.tellUsAboutTheProperty.typeOfBuilding",
		"dwellings.0.externalWallMaterial":
			"=_input.homeForm.tellUsAboutTheProperty.wallsMadeOf",
		"dwellings.0.homeOccupancy":
			"=_input.homeForm.tellUsAboutTheProperty.howIsHomeOccupied",
		"dwellings.0.buildingSumInsured":
			"=_input.homeForm.rapidEstimate.buildingInsureAmount",
		"dwellings.0.contentSumInsured":
			"=_input.homeForm.rapidEstimate.contentInsureAmount",

		"dwellings.0.policyOption": {},
		"dwellings.0.policyOption.rentDefaultAmount":
			"=_input.homeForm.rapidEstimate.rentDefaultCoverAmount",
		"dwellings.0.policyOption.rentDefaultWeeks":
			"=_input.homeForm.rapidEstimate.uptoWeeks",
		"dwellings.0.policyOption.isPropertyAgentManaged":
			"=_input.homeForm.tellUsAboutTheProperty.propertyProfessionalAgent",

		"dwellings.0.yearsContInsurance":
			"=_input.homeForm.insuranceHistory.insuranceHeldFor",
		"dwellings.0.previousInsurer":
			"=_input.homeForm.insuranceHistory.previousInsurer",
		"dwellings.0.hasInsuredClaims":
			"=_input.homeForm.insuranceHistory.claimInLastYear",

		"dwellings.0.dwellingHistories": [],

		//multiple data for portable and other contents
		"dwellings.0.dwellingClaimHistories":
			"=_input.homeForm.insuranceHistory.claimDetails",

		"dwellings.0.dwellingPortableClaimHistories":
			"=_input.homeForm.insuranceHistory.portableClaimDetails",

		"dwellings.0.homeBuiltYear":
			"=_input.homeForm.tellUsAboutTheBuilding.yearHomeBuilt",
		"dwellings.0.isStrataRegisteredBody":
			"=_input.homeForm.tellUsAboutTheBuilding.isStrataRegdCorp",
		"dwellings.0.isUnitsAvailable":
			"=_input.homeForm.tellUsAboutTheBuilding.areUnitAboveBelow",
		"dwellings.0.isOwnersInsureUnits":
			"=_input.homeForm.tellUsAboutTheBuilding.corpInsureUnit",
		"dwellings.0.isSubUrbanLocated":
			"=_input.homeForm.tellUsAboutTheBuilding.isSuburbanBlock",
		"dwellings.0.isPropertySize":
			"=_input.homeForm.tellUsAboutTheBuilding.isBlockLarger",
		"dwellings.0.waterSourced":
			"=_input.homeForm.tellUsAboutTheBuilding.waterSource",
		"dwellings.0.waterTankCapacity":
			"=_input.homeForm.tellUsAboutTheBuilding.waterTankCapacity",
		"dwellings.0.isSecondaryFitted":
			"=_input.homeForm.tellUsAboutTheBuilding.isEmergencyFuelWaterTank",
		"dwellings.0.isCaravanHomeLocated":
			"=_input.homeForm.tellUsAboutTheBuilding.isBuildingRelocatable",
		"dwellings.0.isSecuredFoundation":
			"=_input.homeForm.tellUsAboutTheBuilding.areFoundationsSecured",
		"dwellings.0.isPlumbingConnect":
			"=_input.homeForm.tellUsAboutTheBuilding.isFixedPlumbingElectricityConnect",
		"dwellings.0.roofMaterial":
			"=_input.homeForm.tellUsAboutTheBuilding.roofMake",
		"dwellings.0.groundElevated":
			"=_input.homeForm.tellUsAboutTheBuilding.isHomeElevated",
		"dwellings.0.homeLevels":
			"=_input.homeForm.tellUsAboutTheBuilding.homeLevels",
		"dwellings.0.isUnitAboveGround":
			"=_input.homeForm.tellUsAboutTheBuilding.isUnitAboveGround",
		//IMPORTANT: Setting isPortionBelowGround to isPortionAboveGround is intentional as this is how it is mapped in guide-wire
		"dwellings.0.isPortionAboveGround":
			"=_input.homeForm.tellUsAboutTheBuilding.isPortionBelowGround",
		// "dwellings.0.isPortionAboveGround" : "=_input.homeForm.tellUsAboutTheBuilding.areContentsBelowGround",
		"dwellings.0.isNationalTrustListed":
			"=_input.homeForm.tellUsAboutTheBuilding.isNationalTrustListed",
		"dwellings.0.isFullyRewired":
			"=_input.homeForm.tellUsAboutTheBuilding.isHomeWired",

		//Theft and vandalism by tenants
		"dwellings.0.policyOption.isBuildingVandalismCover":
			"=_input.homeForm.theftAndVandalismByTenants.theftCoverBuilding",
		"dwellings.0.policyOption.isContentVandalismCover":
			"=_input.homeForm.theftAndVandalismByTenants.theftCoverContents",

		// Tell us About the Security Section
		"dwellings.0.locationSecurity": {},
		"dwellings.0.locationSecurity.hasDoorDeadlocks":
			"=_input.homeForm.tellUsAboutTheSecurity.securityExternalDoors.deadlocks",
		"dwellings.0.locationSecurity.hasDoorSecurityScreen":
			"=_input.homeForm.tellUsAboutTheSecurity.securityExternalDoors.door_security_screen",

		"dwellings.0.locationSecurity.hasWindowKeylocks":
			"=_input.homeForm.tellUsAboutTheSecurity.securityExternalWindows.keylocks",
		"dwellings.0.locationSecurity.hasWindowRollerShutter":
			"=_input.homeForm.tellUsAboutTheSecurity.securityExternalWindows.roller_shutter",
		"dwellings.0.locationSecurity.hasWindowScreenBars":
			"=_input.homeForm.tellUsAboutTheSecurity.securityExternalWindows.security_screens_or_bars",

		"dwellings.0.locationSecurity.isGatedCommunity":
			"=_input.homeForm.tellUsAboutTheSecurity.otherSecurity.gated_community",
		"dwellings.0.locationSecurity.has24HourConcierge":
			"=_input.homeForm.tellUsAboutTheSecurity.otherSecurity.24_hour_concierge",
		"dwellings.0.locationSecurity.hasFixedHomeSafe":
			"=_input.homeForm.tellUsAboutTheSecurity.otherSecurity.fixed_home_sage",
		"dwellings.0.locationSecurity.isSecurityRatedBuilding":
			"=_input.homeForm.tellUsAboutTheSecurity.otherSecurity.security_rated_building",

		//Renovations and Residents
		"dwellings.0.isRenovated":
			"=_input.homeForm.renovationsAndResidents.isHomeUnderRepairs",
		"dwellings.0.isCommunitySurrounded":
			"=_input.homeForm.renovationsAndResidents.isHomeInCommunity",
		"dwellings.0.isUnrelatedPeople":
			"=_input.homeForm.renovationsAndResidents.areUnrelatedPeopleInHome",

		//Property Usage
		"dwellings.0.isIncomeGenerated":
			"=_input.homeForm.propertyUsage.isPropertyForBusiness",
		"dwellings.0.incomeGeneratingDegree":
			"=_input.homeForm.propertyUsage.propertyActivityDegree",
		"dwellings.0.incomeGeneratingActivities":
			"=_input.homeForm.propertyUsage.propertyActivities",
		"dwellings.0.agriculturalActivities":
			"=_input.homeForm.propertyUsage.propertyAgricultureActivities",

		//Mortgage on Property
		"dwellings.0.isMortgagePresent":
			"=_input.homeForm.mortgageOnProperty.isPropertyUnderMortgage",

		//Building step
		//Building Details
		"dwellings.0.locationProperty": {},
		"dwellings.0.locationProperty.homeStandard":
			"=_input.homeForm.buildingDetails.homeBuiltStandard",
		"dwellings.0.locationProperty.isLandSloped":
			"=_input.homeForm.buildingDetails.landSlope",
		"dwellings.0.locationProperty.knowHomeSize":
			"=_input.homeForm.buildingDetails.homeTotalArea",
		"dwellings.0.locationProperty.sizeOfHome":
			"=_input.homeForm.buildingDetails.homeArea",
		"dwellings.0.locationProperty.areaUnit":
			"=_input.homeForm.buildingDetails.homeAreaUnit",
		"dwellings.0.locationProperty.sizeOfBedroom":
			"=_input.homeForm.buildingDetails.homeBedroomSize",
		"dwellings.0.isCycloneStandardlyBuilt":
			"=_input.homeForm.buildingDetails.isBuiltToCycloneStandards",

		/** These need to be be commented back in and converted to guide-wire expected values */

		"dwellings.0.locationProperty.numberOfBedrooms":
			"=_input.homeForm.buildingDetails.homeBedrooms",
		"dwellings.0.locationProperty.numberOfBalconies":
			"=_input.homeForm.buildingDetails.homeDecks",
		"dwellings.0.locationProperty.numberOfVerandahs":
			"=_input.homeForm.buildingDetails.homeVerandahs",
		"dwellings.0.locationProperty.numberOfCarports":
			"=_input.homeForm.buildingDetails.homeCarports",
		"dwellings.0.locationProperty.numberOfGarages":
			"=_input.homeForm.buildingDetails.homeGarages",
		"dwellings.0.locationProperty.hasSheds":
			"=_input.homeForm.buildingDetails.homeSheds",

		"dwellings.0.locationProperty.numberOfLargeSheds":
			"=_input.homeForm.buildingDetails.largeSheds",
		"dwellings.0.locationProperty.numberOfSmallSheds":
			"=_input.homeForm.buildingDetails.smallSheds",

		"dwellings.0.locationProperty.hasDuctedAirConditioning":
			"=_input.homeForm.buildingDetails.homeFeatures.ducted_airconditioning",
		"dwellings.0.locationProperty.hasInGroundPool":
			"=_input.homeForm.buildingDetails.homeFeatures.in_ground_swimming_pool",
		"dwellings.0.locationProperty.hasTennisCourt":
			"=_input.homeForm.buildingDetails.homeFeatures.tennis_court",
		"dwellings.0.locationProperty.hasGrannyFlat":
			"=_input.homeForm.buildingDetails.homeFeatures.granny_flat",
		"dwellings.0.locationProperty.grannyFlatSize":
			"=_input.homeForm.buildingDetails.grannyFlatSize",

		//Covers Step
		//Your building
		"dwellings.0.buildingSumInsured":
			"=_input.homeForm.yourBuilding.buildingSumInsured",

		//Your contents
		"dwellings.0.contentSumInsured":
			"=_input.homeForm.yourContents.contentsSumInsured",

		//Portable Contents
		"dwellings.0.hasPortableContentsHomeAway":
			"=_input.homeForm.portableContents.coverPortableContents",
		"dwellings.0.portableCoverCountry":
			"=_input.homeForm.portableContents.coverPortableContentsRegion",
		"dwellings.0.generalPortableContents":
			"=_input.homeForm.portableContents.coverPortableContentLimit",
		"dwellings.0.hasSpecifiedPortableContList":
			"=_input.homeForm.portableContents.portableContentsSpecifiedCover",
		"dwellings.0.hasGeneralPortableContents":
			"=_input.homeForm.portableContents.coverPortableContents",
		//Accidental Loss or Damage
		"dwellings.0.policyOption.isBuildingAccidentalDamage":
			"=_input.homeForm.accidentalLossOrDamage.coverAccDmgBuilding",
		"dwellings.0.policyOption.isContentsAccidentalDamage":
			"=_input.homeForm.accidentalLossOrDamage.coverAccDmgContents",

		//Cycle Cover
		"dwellings.0.policyOption.isContentsCycleCover":
			"=_input.homeForm.cycleCover.coverCycle",
		"dwellings.0.policyOption.isContentsCycleRacingCover":
			"=_input.homeForm.cycleCover.coverCycleExtendOption",
		"dwellings.0.policyOption.specifyCycleEquipment":
			"=_input.homeForm.cycleCover.coverItems",

		//Rent Default
		"dwellings.0.policyOption.isRentDefaultCover":
			"=_input.homeForm.rentDefault.rentDefault",

		"dwellings.0.excess": {},
		"dwellings.0.excess.voluntaryExcess":
			"=_input.homeForm.chooseYourExcess.homeExcess",
		"dwellings.0.excess.portableContentVoluntaryExcess":
			"=_input.homeForm.chooseYourExcess.portableContentsExcess",

		//Specified High Risk Items
		"dwellings.0.hasWorksArt":
			"=_input.homeForm.specifiedHighRiskItems.riskCoverIndividualWorks",
		"dwellings.0.hasEntertainmentEquipment":
			"=_input.homeForm.specifiedHighRiskItems.riskEntertainmentEquipment",

		//Domestic Worker's compensation
		"dwellings.0.policyOption.isContentsDomesticWorkerComp":
			"=_input.homeForm.domesticWorkerCompensation.domesticWorkerCompCover",

		//quote steps
		"dwellings.0.offering":
			"=_input.homeForm.confirmYourLevelOfCover.yourChosenCover",

		//Contact Step
		policyHolders: [],
		"policyHolders.0": {},
		"policyHolders.0.contact": {},
		"policyHolders.0.contact.primaryAddress": "=_addressSearch",
		"policyHolders.0.contact.dateOfBirth":
			"=_input.homeForm.tellUsAboutInsured.dobOldestInsured",
		policyAddress: "=_addressSearch",
		"policyHolders.0.contact.primaryAddress.addressType": "residential",
		"policyAddress.addressType": "residential",
		isInsuredsRetired: "=_input.homeForm.tellUsAboutInsured.isRetired",
		hasPortableContentsClaims:
			"=_input.homeForm.insuranceHistory.portableClaim",
		email: "=_input.email",
		campaignCode: "=_input.homeForm.tellUsABitMore.promotionalCode",
		postalAddress: "=_addressSearch-postal-address",
	};

	function updatePolicyHolderPrimaryAddress(transformedRequest) {
		var policyHolder = util.deepClone(transformedRequest.policyHolders[0]);

		policyHolder.contact.primaryAddress.addressType = "residential";

		transformedRequest.policyHolders[0] = policyHolder;

		return transformedRequest;
	}

	function updateProductCode(transformedRequest, userInput) {
		//update productCode if rented
		if (
			userInput.homeForm &&
			userInput.homeForm.tellUsAboutTheProperty &&
			userInput.homeForm.tellUsAboutTheProperty.howIsHomeOccupied
		) {
			var landlordConditions = [
				"own_rent_tenants",
				"own_rent_tenants_causalbasis",
				"property_used_hostel_or_guest",
			];
			if (
				landlordConditions.indexOf(
					userInput.homeForm.tellUsAboutTheProperty.howIsHomeOccupied
				) > -1
			) {
				transformedRequest.productCode = "QPHLandlord";
			}
		}
		return transformedRequest;
	}

	function updateMortgagees(transformedRequest, userInput) {
		if (!userInput.homeForm && !userInput.homeForm.mortgageOnProperty) {
			return transformedRequest;
		}

		var mortgageOnProperty = userInput.homeForm.mortgageOnProperty;
		if (mortgageOnProperty.isPropertyUnderMortgage) {
			transformedRequest.dwellings[0].isMortgagePresent = true;
			var _mortgagees = [];
			mortgageOnProperty.propertyMortgagedWith.forEach(function (
				item,
				index
			) {
				var _mortgagee = {
					mortgagee: item,
					status: index + 1,
				};
				_mortgagees.push(_mortgagee);
			});
			if (_mortgagees.length > 0) {
				transformedRequest.dwellings[0].mortgagees = _mortgagees;
			} else {
				if (transformedRequest.dwellings[0].mortgagees) {
					delete transformedRequest.dwellings[0].mortgagees;
				}
			}
		} else {
			transformedRequest.dwellings[0].isMortgagePresent = false;
			if (transformedRequest.dwellings[0].mortgagees) {
				delete transformedRequest.dwellings[0].mortgagees;
			}
		}
		return transformedRequest;
	}

	function UpdateAlarmType(transformedRequest, userInput) {
		var localAlarm = false;
		var _24HourAlarm = false;

		if (
			userInput.homeForm.tellUsAboutTheSecurity &&
			userInput.homeForm.tellUsAboutTheSecurity.otherSecurity
		) {
			localAlarm =
				userInput.homeForm.tellUsAboutTheSecurity.otherSecurity[
					"local_alarm"
				];
			_24HourAlarm =
				userInput.homeForm.tellUsAboutTheSecurity.otherSecurity[
					"24_hour_monitored_alarm"
				];
		}

		transformedRequest.dwellings[0].locationSecurity.haveSecurityAlarm = false;

		var result = "";

		if (localAlarm && Boolean(localAlarm)) {
			result = "local_alarm";
			transformedRequest.dwellings[0].locationSecurity.haveSecurityAlarm = true;
		} else if (_24HourAlarm && Boolean(_24HourAlarm)) {
			result = "monitored_alarm";
			transformedRequest.dwellings[0].locationSecurity.haveSecurityAlarm = true;
		}

		transformedRequest.dwellings[0].locationSecurity.typeOfAlarm = result;
		return transformedRequest;
	}

	function UpdateRentDefault(transformedRequest, userInput) {
		// if (!userInput.homeForm.rentDefault) {
		// 	return transformedRequest;
		// }

		// var rentDefault = userInput.homeForm.rentDefault;

		// if (rentDefault.rentCurrentWeekly) {
		// 	transformedRequest.dwellings[0].policyOption.rentDefaultAmount =
		// 		rentDefault.rentCurrentWeekly;
		// }

		// if (rentDefault.rentXWeeks) {
		// 	transformedRequest.dwellings[0].policyOption.rentDefaultWeeks =
		// 		rentDefault.rentXWeeks;
		// }

		//dd-6486 - assign rent default cover to false when occupancy is rent casual basis
		if (
			transformedRequest.dwellings[0].homeOccupancy ==
			"own_rent_tenants_causalbasis"
		) {
			transformedRequest.dwellings[0].policyOption.isRentDefaultCover = false;
		}

		if (
			transformedRequest.dwellings[0].homeOccupancy ===
				"own_rent_tenants" &&
			transformedRequest.dwellings[0].policyOption
				.isPropertyAgentManaged == true
		) {
			transformedRequest.dwellings[0].policyOption.isRentDefaultCover = false;
		}

		return transformedRequest;
	}

	function updateCoverType(transformedRequest, userInput) {
		// debugger;
		if (userInput.homeForm && userInput.homeForm.tellUsHowWeCanInsureYou) {
			if (userInput.homeForm.tellUsHowWeCanInsureYou.coverNeeds) {
				var needs =
					userInput.homeForm.tellUsHowWeCanInsureYou.coverNeeds;
				if (needs.building && needs.contents) {
					transformedRequest.dwellings[0].coverType =
						"building_and_contents";
				} else if (needs.building) {
					transformedRequest.dwellings[0].coverType = "building_only";
				} else if (needs.contents) {
					transformedRequest.dwellings[0].coverType = "contents_only";
				}
			}
		}
		return transformedRequest;
	}

	function transposeMonth(monthName) {
		var months = {
			January: "01",
			February: "02",
			March: "03",
			April: "04",
			May: "05",
			June: "06",
			July: "07",
			August: "08",
			September: "09",
			October: "10",
			November: "11",
			December: "12",
		};

		return months[monthName];
	}

	function updateDwellingHistory(transformedRequest) {
		var transformedHistoryList = [];

		if (
			transformedRequest.dwellings &&
			transformedRequest.dwellings[0].hasInsuredClaims === "yes"
		) {
			var dwellingClaimHistory = transformedRequest.dwellings[0].dwellingClaimHistories.slice(
				0
			);
			dwellingClaimHistory.forEach(function (history) {
				void 0;
				var transformedHistory = {
					pattern: {},
					year: history.year.value,
					claimType: history.coverAffected.value,
					isPortableContents: false,
					eventMonth: transposeMonth(history.month.value),
				};
				transformedHistory.pattern = {
					publicID: history.description.publicID,
					code: history.description.code,
					description: history.description.description,
					filter1: history.description.filter1,
				};
				transformedHistoryList.push(transformedHistory);
			});
		}

		if (transformedRequest.hasPortableContentsClaims === "yes") {
			var dwellingPortableClaimHistory = transformedRequest.dwellings[0].dwellingPortableClaimHistories.slice(
				0
			);
			dwellingPortableClaimHistory.forEach(function (history) {
				void 0;
				var transformedHistory = {
					pattern: {},
					year: history.year.value,
					contentCategory: history.coverAffected.value,
					isPortableContents: true,

					eventMonth: transposeMonth(history.month.value),
				};
				transformedHistory.pattern = {
					publicID: history.description.publicID,
					code: history.description.code,
					description: history.description.description,
					filter1: history.description.filter1,
				};
				transformedHistoryList.push(transformedHistory);
			});
		}

		if (transformedRequest.dwellings) {
			if (
				transformedRequest.dwellings &&
				transformedHistoryList.length > 0
			) {
				transformedRequest.dwellings[0].dwellingHistories = transformedHistoryList;
			} else {
				delete transformedRequest.dwellings[0].dwellingHistories;
			}

			//removing as this is not requred by the service
			delete transformedRequest.dwellings[0].dwellingClaimHistories;
			delete transformedRequest.dwellings[0]
				.dwellingPortableClaimHistories;
		}

		return transformedRequest;
	}

	function UpdateCycles(transformedRequest, userInput) {
		if (!userInput.homeForm) {
			return transformedRequest;
		}

		if (
			userInput.homeForm.cycleCover &&
			userInput.homeForm.cycleCover.cycleList &&
			userInput.homeForm.cycleCover.cycleList.length > 0
		) {
			var cycles = [];

			userInput.homeForm.cycleCover.cycleList.forEach(function (
				cycle,
				idx
			) {
				cycles.push({
					typeOfBicycle: cycle.bikeType.value,
					description: cycle.description,
					value: cycle.value,
				});
			});

			transformedRequest.dwellings[0].policyOption.cycles = cycles;
		} else {
			delete transformedRequest.dwellings[0].policyOption.cycles;
		}

		if (
			userInput.homeForm.cycleCover &&
			userInput.homeForm.cycleCover.coverItemsList &&
			userInput.homeForm.cycleCover.coverItemsList.length > 0
		) {
			var cycleItems = [];

			userInput.homeForm.cycleCover.coverItemsList.forEach(function (
				item,
				idx
			) {
				cycleItems.push({
					category: item.category.value,
					description: item.description,
					value: item.value,
				});
			});

			transformedRequest.dwellings[0].policyOption.cycleEquipments = cycleItems;
		} else {
			delete transformedRequest.dwellings[0].policyOption.cycleEquipments;
		}

		return transformedRequest;
	}

	function updateSumInsured(transformedRequest, userInput) {
		var homeForm = userInput.homeForm,
			dwellingsInfo = transformedRequest.dwellings[0];
		if (!homeForm) {
			return transformedRequest;
		}

		//over write sum insured from quote page
		if (
			homeForm.confirmYourSumsInsured &&
			homeForm.confirmYourSumsInsured.yourBuildingSumInsured
		) {
			dwellingsInfo.buildingSumInsured =
				homeForm.confirmYourSumsInsured.yourBuildingSumInsured;
		} else {
			if (
				homeForm.yourBuilding &&
				homeForm.yourBuilding.buildingSumInsured
			) {
				dwellingsInfo.buildingSumInsured =
					homeForm.yourBuilding.buildingSumInsured;
			} else if (
				homeForm.rapidEstimate &&
				homeForm.rapidEstimate.buildingInsureAmount
			) {
				dwellingsInfo.buildingSumInsured =
					homeForm.rapidEstimate.buildingInsureAmount;
			} else {
				dwellingsInfo.buildingSumInsured = 0;
			}
		}
		//over write sum insured from quote page
		if (
			homeForm.confirmYourSumsInsured &&
			homeForm.confirmYourSumsInsured.yourContentsSumInsured
		) {
			dwellingsInfo.contentSumInsured =
				homeForm.confirmYourSumsInsured.yourContentsSumInsured;
		} else {
			if (
				homeForm.yourContents &&
				homeForm.yourContents.contentsSumInsured
			) {
				dwellingsInfo.contentSumInsured =
					homeForm.yourContents.contentsSumInsured;
			} else if (
				homeForm.rapidEstimate &&
				homeForm.rapidEstimate.contentInsureAmount
			) {
				dwellingsInfo.contentSumInsured =
					homeForm.rapidEstimate.contentInsureAmount;
			} else {
				dwellingsInfo.contentSumInsured = 0;
			}
		}

		return transformedRequest;
	}

	function updateBuildingDetails(transformedRequest, userInput) {
		if (!userInput.homeForm) {
			return transformedRequest;
		}

		if (userInput.homeForm.buildingDetails) {
			var slope =
				transformedRequest.dwellings[0].locationProperty.isLandSloped;
			if (slope === "flat") {
				transformedRequest.dwellings[0].locationProperty.isLandSloped =
					"flat";
			} else {
				transformedRequest.dwellings[0].locationProperty.isLandSloped =
					"sloped";

				transformedRequest.dwellings[0].locationProperty.slopeType = slope;
			}
		}

		return transformedRequest;
	}

	function updatePersonContactDetails(transformedRequest, userInput) {
		if (!userInput.homeForm) {
			return transformedRequest;
		}

		var homeForm = userInput.homeForm;

		if (
			homeForm.letsGetStarted &&
			homeForm.letsGetStarted.personOrCompany
		) {
			var isCompany = homeForm.letsGetStarted.personOrCompany != "person";
		} else {
			//dont do transofrmation if personOrCompany is not present
			return transformedRequest;
		}

		if (isCompany) {
			// aboutTheCompany
			var aboutTheCompany = homeForm.aboutTheCompany;
			var aboutCompanyContact = homeForm.aboutCompanyContact;
			var companyContactContact = homeForm.companyContactContact;

			if (
				aboutTheCompany &&
				aboutCompanyContact &&
				companyContactContact
			) {
				var policyHolders = [];

				var _authorisedPerson = util.deepClone(aboutCompanyContact);
				_authorisedPerson.contactType = "person";
				_authorisedPerson.primaryAddress = util.deepClone(
					companyContactContact.companyContactResidentialAddress
				);
				_authorisedPerson.emailAddress1 =
					companyContactContact.emailAddress1;
				_authorisedPerson.primaryPhone =
					companyContactContact.primaryPhone;
				_authorisedPerson.contactNumber =
					companyContactContact.contactNumber;
				_authorisedPerson = constructPhoneNumberObject(
					_authorisedPerson
				);
				delete _authorisedPerson.address;

				var _contact = util.deepClone(aboutTheCompany);
				_contact.contactType = "company";
				_contact.primaryPhone = "work";
				_contact.authorisedPersons = [
					{
						person: _authorisedPerson,
					},
				];
				_contact.primaryAddress = util.deepClone(
					_contact.companyAddress
				);
				_contact.passwordQuestion =
					companyContactContact.passwordQuestion;
				_contact.passwordAnswer = companyContactContact.passwordAnswer;
				delete _contact.address;

				policyHolders.push({
					contact: _contact,
					mainHolder: true,
				});

				if (
					homeForm &&
					homeForm.companyContactContact &&
					homeForm.companyContactContact
						.companyContactMailingPreference
				) {
					transformedRequest.documentDeliveryMethod =
						homeForm.companyContactContact.companyContactMailingPreference;
					delete transformedRequest.policyHolders[0].contact
						.companyContactMailingPreference;
				}

				transformedRequest.policyHolders = policyHolders;
			}
		} else {
			var mainPolicyHolder = homeForm.mainPolicyHolder;
			var mainPolicyHolderContact = homeForm.mainPolicyHolderContact;

			if (mainPolicyHolder && mainPolicyHolderContact) {
				var policyHolders = [];

				//create main policy holder
				var _contact = Object.extend(
					mainPolicyHolder,
					mainPolicyHolderContact
				);
				_contact.contactType = "person";
				//_contact.primaryAddress = util.deepClone(_contact.address);
				_contact.primaryAddress = util.deepClone(
					transformedRequest.policyHolders[0].contact.primaryAddress
				);
				delete _contact.address;

				var _mainPolicyHolder = {
					contact: _contact,
					mainHolder: true,
				};

				policyHolders.push(_mainPolicyHolder);

				//check for addition policy holders
				if (
					homeForm.additionalPolicyHolders &&
					homeForm.additionalPolicyHolders.policyHolders &&
					homeForm.additionalPolicyHolders.policyHolders.length > 0
				) {
					var _additionalPolicyHolders =
						homeForm.additionalPolicyHolders.policyHolders;

					_additionalPolicyHolders.forEach(function (
						policyHolderItem
					) {
						var _contact = util.deepClone(policyHolderItem);
						_contact.contactType = "person";
						_contact.primaryAddress = util.deepClone(
							_contact.address
						);
						delete _contact.address;
						var _additionalPolicyHolder = {
							contact: _contact,
							mainHolder: false,
						};
						policyHolders.push(_additionalPolicyHolder);
					});
				}

				//update convictions for all and mobile number
				policyHolders.map(function (policyHolderItem) {
					policyHolderItem.contact = constructPhoneNumberObject(
						policyHolderItem.contact
					);
					policyHolderItem.contact = constructConvictionHistoryObject(
						policyHolderItem.contact
					);

					return policyHolderItem;
				});

				if (
					homeForm &&
					homeForm.mainPolicyHolderContact &&
					homeForm.mainPolicyHolderContact
						.personContactMailingPreference
				) {
					transformedRequest.documentDeliveryMethod =
						homeForm.mainPolicyHolderContact.personContactMailingPreference;
					delete transformedRequest.policyHolders[0].contact
						.personContactMailingPreference;
				}

				transformedRequest.policyHolders = policyHolders;
			}
		}

		/** required for saving/retrieving the policy */
		if (userInput.email) {
			if (
				userInput.homeForm.tellUsABitMore &&
				userInput.homeForm.tellUsABitMore.yourEmailAddress
			) {
				transformedRequest.policyHolders[0].contact.emailAddress1 =
					userInput.homeForm.tellUsABitMore.yourEmailAddress;
				transformedRequest.email =
					userInput.homeForm.tellUsABitMore.yourEmailAddress;
			} else if (
				userInput.homeForm.mainPolicyHolderContact &&
				userInput.homeForm.mainPolicyHolderContact.emailAddress1
			) {
				transformedRequest.policyHolders[0].contact.emailAddress1 =
					userInput.homeForm.mainPolicyHolderContact.emailAddress1;
				transformedRequest.email =
					userInput.homeForm.mainPolicyHolderContact.emailAddress1;
			} else {
				transformedRequest.policyHolders[0].contact.emailAddress1 =
					userInput.email;
				transformedRequest.email = userInput.email;
			}
		} else {
			if (
				userInput.homeForm.tellUsABitMore &&
				userInput.homeForm.tellUsABitMore.yourEmailAddress
			) {
				if (transformedRequest.policyHolders[0].contact.emailAddress1) {
					//use the existing if available
				} else {
					transformedRequest.policyHolders[0].contact.emailAddress1 =
						userInput.homeForm.tellUsABitMore.yourEmailAddress;
					transformedRequest.email =
						userInput.homeForm.tellUsABitMore.yourEmailAddress;
				}
			}
		}

		return transformedRequest;
	}

	function constructPhoneNumberObject(contactInfo) {
		if (contactInfo) {
			if (!contactInfo.primaryPhone) {
				contactInfo.primaryPhone = "work";
			}

			switch (contactInfo.primaryPhone) {
				case "mobile":
					contactInfo.cellPhone = contactInfo.contactNumber;
					break;
				case "home":
					contactInfo.homePhone = contactInfo.contactNumber;
					break;
				case "work":
				default:
					contactInfo.workPhone = contactInfo.contactNumber;
					break;
			}
		}
		return contactInfo;
	}

	function constructConvictionHistoryObject(contactInfo) {
		if (contactInfo) {
			if (contactInfo.tenYears_chargedOrConvictedOffences == "yes") {
				contactInfo.hasConviction = "yes";
			} else if (
				contactInfo.tenYears_chargedOrConvictedOffences == "no"
			) {
				contactInfo.hasConviction = "no";
			} else {
				contactInfo.hasConviction = "unknown";
			}

			delete contactInfo.tenYears_chargedOrConvictedOffences;

			if (
				contactInfo &&
				contactInfo.tenYears_chargedOrConvictedOffencesDetails &&
				contactInfo.tenYears_chargedOrConvictedOffencesDetails.length >
					0
			) {
				contactInfo.dwellingHistory = [];

				contactInfo.tenYears_chargedOrConvictedOffencesDetails.forEach(
					function (incident) {
						contactInfo.dwellingHistory.push({
							pattern: incident.description,
							eventMonth: incident.month.value,
							year: parseInt(incident.year.value),
						});
					}
				);
				delete contactInfo.tenYears_chargedOrConvictedOffencesDetails;
			}
		}

		return contactInfo;
	}

	function updateCordelInfo(transformedRequest) {
		if (quoteOptions.getSelectedQuoteResultForPayment())
			transformedRequest.dwellings[0].cordelInfo = quoteOptions.getSelectedQuoteResultForPayment().cordelInfo;

		return transformedRequest;
	}

	function updateConfirmedValue(transformedRequest, userInput) {
		if (!userInput.homeForm) {
			return transformedRequest;
		}

		var confirmYourSumsInsured = userInput.homeForm.confirmYourSumsInsured;
		if (confirmYourSumsInsured) {
			if (confirmYourSumsInsured.generalPortableContentsLimit) {
				transformedRequest.dwellings[0].generalPortableContents =
					confirmYourSumsInsured.generalPortableContentsLimit;
			}
		}

		var confirmYourOptionalBenefits =
			userInput.homeForm.confirmYourOptionalBenefits;
		if (confirmYourOptionalBenefits) {
			if (confirmYourOptionalBenefits.accdLossDmgCoverBuilding) {
				transformedRequest.dwellings[0].policyOption.isBuildingAccidentalDamage = true;
			}
			if (confirmYourOptionalBenefits.accdLossDmgCoverContents) {
				transformedRequest.dwellings[0].policyOption.isContentsAccidentalDamage = true;
			}
			if (confirmYourOptionalBenefits.domesticWrkCompCover) {
				transformedRequest.dwellings[0].policyOption.isContentsDomesticWorkerComp = true;
			} else {
				transformedRequest.dwellings[0].policyOption.isContentsDomesticWorkerComp = false;
			}
		}

		return transformedRequest;
	}

	// !imp - transform the quote to use company contact and transforms only if company data is not available
	function updateRequoteCompanyContactForBlank(
		transformedRequest,
		userInput
	) {
		if (!userInput.homeForm) {
			return transformedRequest;
		}

		var homeForm = userInput.homeForm;

		//check if person or company data is available
		if (
			homeForm.letsGetStarted &&
			homeForm.letsGetStarted.personOrCompany
		) {
			var isCompany = homeForm.letsGetStarted.personOrCompany != "person";
		} else {
			//dont do transofrmation if personOrCompany is not present
			return transformedRequest;
		}

		if (isCompany) {
			//check if company contact details are available
			var aboutTheCompany = homeForm.aboutTheCompany;
			var aboutCompanyContact = homeForm.aboutCompanyContact;
			var companyContactContact = homeForm.companyContactContact;
			if (
				aboutTheCompany &&
				aboutCompanyContact &&
				companyContactContact
			) {
				//if data is available dont do anything
			} else {
				// create default data for company contact
				var _contact = transformedRequest.policyHolders[0].contact;
				_contact.contactType = "company";
				_contact.primaryPhone = "work";
				_contact.authorisedPersons = [
					{
						person: {
							contactType: "person",
							primaryAddress: _contact.primaryAddress,
						},
					},
				];

				transformedRequest.policyHolders[0] = {
					mainHolder: true,
					contact: _contact,
				};
			}
		}

		return transformedRequest;
	}

	function updatePropertyDetails(transformedRequest, userInput) {
		if (!userInput.homeForm && !userInput.homeForm.tellUsAboutTheBuilding) {
			return transformedRequest;
		}

		if (
			!userInput.homeForm.tellUsAboutTheBuilding.isHomeElevated ||
			userInput.homeForm.tellUsAboutTheBuilding.isHomeElevated ==
				"notasked"
		) {
			transformedRequest.dwellings[0].isGroundLevelElevated = "no";
		} else {
			transformedRequest.dwellings[0].isGroundLevelElevated = "yes";
		}

		//update cyclone standard based on the yearHomeBuilt
		var yearBuilt = userInput.homeForm.tellUsAboutTheBuilding.yearHomeBuilt;

		if (yearBuilt == 19801989) {
			//don't change user selection
		} else if (yearBuilt == 19901999) {
			transformedRequest.dwellings[0].isCycloneStandardlyBuilt = true;
		} else if (yearBuilt > 1999 && yearBuilt < 2100) {
			transformedRequest.dwellings[0].isCycloneStandardlyBuilt = true;
		} else {
			transformedRequest.dwellings[0].isCycloneStandardlyBuilt = false;
		}
		// transformedRequest.dwellings[0].isCycloneStandardlyBuilt

		return transformedRequest;
	}

	//updates the email
	function updateEmail(transformedRequest, userInput) {
		if (
			userInput.homeForm &&
			userInput.homeForm.tellUsABitMore &&
			userInput.homeForm.tellUsABitMore.yourEmailAddress
		) {
			transformedRequest.email =
				userInput.homeForm.tellUsABitMore.yourEmailAddress;
		} else {
			//set email from maincontact if not available in tellUsABitMore
			if (
				userInput.homeForm &&
				userInput.homeForm.mainPolicyHolderContact &&
				userInput.homeForm.mainPolicyHolderContact.emailAddress1
			) {
				transformedRequest.email =
					userInput.homeForm.mainPolicyHolderContact.emailAddress1;
			}
		}

		if (
			userInput.homeForm &&
			userInput.homeForm.tellUsABitMore &&
			userInput.homeForm.tellUsABitMore.promotionalCode
		) {
			transformedRequest.campaignCode =
				userInput.homeForm.tellUsABitMore.promotionalCode;
		}

		return transformedRequest;
	}

	//contains the logic for isInsuredsOverTheAge
	function determineIsInsuredsOverTheAge(transformedRequest, userInput) {
		if (
			userInput.homeForm &&
			userInput.homeForm.tellUsAboutInsured &&
			userInput.homeForm.tellUsAboutInsured.dobOldestInsured
		) {
			transformedRequest.isInsuredsOverTheAge =
				moment().diff(
					moment(
						userInput.homeForm.tellUsAboutInsured.dobOldestInsured,
						"DD/MM/YYYY"
					),
					"years"
				) >= 50;
		}
		return transformedRequest;
	}

	function updatePolicyAddress(transformedRequest, userInput) {
		var postalAddress = storage.getItem("policy-address");

		if (
			angular.isDefined(userInput.homeForm.mainPolicyHolderContact) ||
			angular.isDefined(userInput.homeForm.companyContact)
		) {
			if (transformedRequest.postalAddress !== null) {
				transformedRequest.policyAddress =
					transformedRequest.postalAddress;
			} else {
				var isPostalOption = true;
				if (
					userInput.homeForm.letsGetStarted.personOrCompany ==
					"person"
				) {
					isPostalOption =
						userInput.homeForm.mainPolicyHolderContact
							.personContactSamePostalAddress;
				} else {
					isPostalOption = angular.isDefined(
						userInput.homeForm.companyContact
					)
						? userInput.homeForm.companyContact
								.companyContactSamePostalAddress
						: true;
				}

				if (Object.keys(postalAddress).length > 0 && !isPostalOption) {
					transformedRequest.policyAddress = postalAddress;
				}
			}
		} else {
			if (Object.keys(postalAddress).length > 0) {
				transformedRequest.policyAddress = postalAddress;
			}
		}

		delete transformedRequest.postalAddress;
		return transformedRequest;
	}

	function updateWebBots(transformedRequest, userInput) {
		if (
			angular.isDefined(userInput.homeForm.isSyntheticTransaction_Ext) &&
			angular.isDefined(userInput.homeForm.syntheticSource_Ext)
		) {
			transformedRequest.IsSyntheticTransaction_Ext =
				userInput.homeForm.isSyntheticTransaction_Ext == "true"
					? true
					: false;
			transformedRequest.SyntheticSource_Ext =
				userInput.homeForm.syntheticSource_Ext;
		}

		return transformedRequest;
	}

	function transform(userInput) {
		var transformedRequest = jsonMapper.transform(
			userInput,
			structureQuoteMapping
		);
		transformedRequest = UpdateAlarmType(transformedRequest, userInput);
		transformedRequest = updateCoverType(transformedRequest, userInput);
		transformedRequest = updatePropertyDetails(
			transformedRequest,
			userInput
		);
		transformedRequest = updateMortgagees(transformedRequest, userInput);

		transformedRequest = UpdateRentDefault(transformedRequest, userInput);

		transformedRequest = UpdateCycles(transformedRequest, userInput);
		transformedRequest = updateDwellingHistory(transformedRequest);
		transformedRequest = updateSumInsured(transformedRequest, userInput);

		transformedRequest = updateProductCode(transformedRequest, userInput);
		transformedRequest = updateBuildingDetails(
			transformedRequest,
			userInput
		);
		transformedRequest = updatePersonContactDetails(
			transformedRequest,
			userInput
		);

		transformedRequest = updateCordelInfo(transformedRequest);
		transformedRequest = updateConfirmedValue(
			transformedRequest,
			userInput
		);

		transformedRequest = updateRequoteCompanyContactForBlank(
			transformedRequest,
			userInput
		);

		transformedRequest = updateEmail(transformedRequest, userInput);

		transformedRequest = determineIsInsuredsOverTheAge(
			transformedRequest,
			userInput
		);

		transformedRequest = updatePolicyAddress(transformedRequest, userInput);
		transformedRequest = updateWebBots(transformedRequest, userInput);
		return transformedRequest;
	}

	return {
		transform: transform,
	};
}

function VehicleCleanRequestTransformer(Util, jsonMapper) {

	function transform(intermediateRequest, userInput) {
		delete intermediateRequest.vehicleForm;

		var vehicle = intermediateRequest.vehicles[0];
		var policyHolders = intermediateRequest.policyHolders;
		delete vehicle.paymentOptions ;
		delete vehicle.locationParked ;
		delete vehicle.primaryCarUse ;
		delete vehicle.businessActivityType ;
		delete vehicle.commercialActivityType ;
		delete vehicle.modifications ;
		delete vehicle.modificationsOptions ;
		delete vehicle.modificationsBuilt ;
		delete vehicle.modificationsBuiltOptions ;
		delete vehicle.carFinance ;
		delete vehicle.last12Months ;

		delete vehicle.vehicleInfo.averageKM;
		delete vehicle.vehicleInfo.cylinders;
		delete vehicle.vehicleInfo.description;
		delete vehicle.vehicleInfo.engineDescription;
		delete vehicle.vehicleInfo.goodKM;
		delete vehicle.vehicleInfo.goodRetailPrice;
		delete vehicle.vehicleInfo.imageUrls;
		delete vehicle.vehicleInfo.inductionDescription;
		delete vehicle.vehicleInfo.kerbWeight;
		delete vehicle.vehicleInfo.optionalEquipments;
		delete vehicle.vehicleInfo.power;
		delete vehicle.vehicleInfo.ratingGrade;
		delete vehicle.vehicleInfo.standardEquipments;
		delete vehicle.vehicleInfo.vehicleKey;
		delete vehicle.vehicleInfo.vin;


		if ( vehicle.drivers ) {
			vehicle.drivers.forEach(function(policyDriver) {
				delete policyDriver.driver._HTMLID;
				delete policyDriver.driver.$$hashKey;
				delete policyDriver.driver._aggregator;

				delete policyDriver.driver.maxNoClaimBonus;
				delete policyDriver.driver.title;
				delete policyDriver.driver.yearsHeld;
				delete policyDriver.driver.fourYears_chargedOrConvictedOffences;
				delete policyDriver.driver.fourYears_chargedOrConvictedOffencesDetails;
				delete policyDriver.driver.fourYears_licenceRSDC;
				delete policyDriver.driver.fourYears_licenceRSDCDetails;
				delete policyDriver.driver.fourYears_vehicleAccidentsClaims;
				delete policyDriver.driver.fourYears_vehicleAccidentsClaimsDetails;
				delete policyDriver.driver.tenYears_chargedOrConvictedOffences;
				delete policyDriver.driver.tenYears_chargedOrConvictedOffencesDetails;

				/**
				* Guidewire creates duplicate records of other drivers criminal histories
				* if the driverHistory is sent as an empty array :)
				* For now this has been commented out and moved to PublicIDTransformer as that
				* is creating an array when going through and transforming public ID's for a list.  This behaviour should be changed for empty lists.
				* After changing that, this can be commented back in and removed from publicIDTransformer.
				if ( policyDriver.driver.driverHistory
					&& Array.isArray(policyDriver.driver.driverHistory)
					&& policyDriver.driver.driverHistory.length == 0 )
					delete policyDriver.driver.driverHistory;
				*/
			})
		}

		if ( policyHolders ) {
			policyHolders.forEach(function(ph){			
			delete ph.contact._HTMLID;
			delete ph.contact.$$hashKey;
			delete ph.contact._aggregator;

			delete ph.contact.anyInfringements;
			delete ph.contact.anyLostLicences;
			delete ph.contact.mainPolicyHolder;
			delete ph.contact.isMainDriverMainPolicyHolder;

			delete ph.contact.policyContact;
			delete ph.contact.phoneNumber;
			delete ph.contact.postalOption;
			delete ph.contact.primaryPhoneNumber;
			delete ph.contact.title;
			delete ph.contact.address;

			delete ph.contact.fourYears_chargedOrConvictedOffences;
			delete ph.contact.fourYears_chargedOrConvictedOffencesDetails;
			delete ph.contact.fourYears_licenceRSDC;
			delete ph.contact.fourYears_licenceRSDCDetails;
			delete ph.contact.fourYears_vehicleAccidentsClaims;
			delete ph.contact.fourYears_vehicleAccidentsClaimsDetails;
			delete ph.contact.tenYears_chargedOrConvictedOffences;
			delete ph.contact.tenYears_chargedOrConvictedOffencesDetails;

			delete ph.contact.additionalPolicyHolderFourYears_chargedOrConvictedOffences;
			delete ph.contact.additionalPolicyHolderFourYears_chargedOrConvictedOffencesDetails;
			delete ph.contact.additionalPolicyHolderFourYears_licenceRSDC;
			delete ph.contact.additionalPolicyHolderFourYears_licenceRSDCDetails;
			delete ph.contact.additionalPolicyHolderFourYears_vehicleAccidentsClaims;
			delete ph.contact.additionalPolicyHolderFourYears_vehicleAccidentsClaimsDetails;
			delete ph.contact.additionalPolicyHolderTenYears_chargedOrConvictedOffences;
			delete ph.contact.additionalPolicyHolderTenYears_chargedOrConvictedOffencesDetails;
			})
		}



		if ( ! intermediateRequest.email )
			delete intermediateRequest.email ;

		return intermediateRequest;
	}

	return {
		transform: transform
	}
}

function VehicleCoverTypeTransformer(jsonMapper, util, quoteOptions) {
	function transform(intermediateRequest, coverTypeDescriptor) {

		intermediateRequest.vehicles[0].coverType =  coverTypeDescriptor;

		return intermediateRequest;
	}

	return {
		transform: transform
	}
}

function VehicleDefaultValueRequestTransformer(
	Util,
	jsonMapper,
	userInputRepository,
	quoteOptions
) {
	function formatDateAndTimeTheGuidewireWay(date, time) {
		var format = '{0} at {1} AEST';
		var timeFormatted = '4:00PM';
		if (time)
			timeFormatted = moment()
				.tz('Australia/Sydney')
				.format('h:mma');
		return Util.stringFormat(
			format,
			moment()
				.tz('Australia/Sydney')
				.format('Do MMM YYYY'),
			timeFormatted
		);
	}

	var staticValuesMapping = {
		quoteType: 'Full',
		productCode: 'QPMMotorVehicle',
		// "anyInfringementsQuestion": "no",
		// "anyClaimsQuestion": "no",
		// "anyLostLicencesQuestion": "no",
		// "anyConvictionsQuestion": "no",
		'vehicles.0.primaryUsage': 'private',
		'vehicles.0.afterMarketModifications': false,
		'vehicles.0.isEligibleforSDExemption': false,
		'vehicles.0.financeType': 'none',
		'vehicles.0.sumInsuredType': 'market',
		'vehicles.0.garageType': 'garage',
		'vehicles.0.unrepairedDamage': 'none',
		'vehicles.0.colour': 'red',
		'vehicles.0.coverType': 'comprehensive',
		'vehicles.0.recentPurchase': false,
		'vehicles.0.otherDriverHasProLicense': false,
		'vehicles.0.youngestDriverGender': 'male',
		'vehicles.0.otherDriverUsageTimes': '0',
		'vehicles.0.sumInsuredAmount': '1000',
		'vehicles.0.garageAddress.addressType': 'postal',
		'vehicles.0.drivers.*.driver.licenceType': 'full',
		'vehicles.0.drivers.*.driver.yearsLicenced': '6',
		'vehicles.0.drivers.*.driver.hasConviction': false,
		'vehicles.0.drivers.*.driver.hasClaim': false,
		'vehicles.0.drivers.*.driver.hasInfringement': false,
		'vehicles.0.drivers.*.driver.hasLostLicence': false,
		'vehicles.0.drivers.*.driver.zeroDemerits': true,
		'vehicles.0.drivers.*.driver.previousInsurer': 'none',
		'vehicles.0.drivers.*.driver.noClaimBonus': 'rating_1',
		'vehicles.0.drivers.*.driver.maxNoClaimBonusLength': '2',
		// "vehicles.0.drivers.*.driver.calculatedExcess": 0,
		'vehicles.0.drivers.*.driver.person.contactType': 'person',
		'vehicles.0.drivers.*.driver.person.gender': 'male',
		'vehicles.0.drivers.*.driver.person.firstName': 'An@n',
		'vehicles.0.drivers.*.driver.person.lastName': 'An@nym@us',
		'vehicles.0.drivers.*.driver.person.isJustInsured': false,
		'vehicles.0.drivers.*.driver.person.dateOfBirth': '01/06/2000',
		email: 'a@a.com',
		'vehicles.0.availableCoverTypes': [
			'comprehensive',
			'comprehensive_nominated',
			'comprehensive_preferred',
			'third_party_fire_theft',
			'third_party'
		],
		availableSumInsuredTypes: ['market', 'agreed'],
		'vehicles.0.coverageOptions': [
			{
				name: 'QPMMotVehHireCar',
				selected: false,
				required: false
			},
			{
				name: 'QPMMotVehWindscreen',
				selected: false,
				required: false
			},
			{
				name: 'QPMMotVehNCB',
				selected: false,
				required: false
			}
		],
		'vehicles.0.excess.standardVehicleExcess': 650,
		'vehicles.0.excess.ageExcessTier1': 1000,
		'vehicles.0.excess.ageExcessTier2': 750,
		'vehicles.0.excess.undeclaredDriverTier2': 500,
		'vehicles.0.excess.inexperiencedDriver': 750,

		'policyHolders.0.mainHolder': true,
		'policyHolders.0.contact.isJustInsured': false,
		'policyHolders.0.contact.contactType': 'person',
		'policyHolders.0.contact.dateOfBirth': '01/06/2000',
		// full quote transformation :
		status: 'Draft',
		documentDeliveryMethod: 'email',
		displayStatus: 'Draft',
		periodStartDateTimeAEDT: formatDateAndTimeTheGuidewireWay(
			moment(),
			moment()
		),
		periodEndDateTimeAEDT: formatDateAndTimeTheGuidewireWay(
			moment().add(1, 'years')
		),
		channel: 'portal',
		'vehicles.0.drivers.*.driverUsage': 'other'
	};

	function transform(intermediateRequest, userInput) {
		var staticValuesMappingNew = ApplyDefaultExcess(userInput);
		var transformedRequest = jsonMapper.setDefault(
			userInput,
			staticValuesMappingNew
		);
		return transformedRequest;
	}

	function ApplyDefaultExcess(userInput) {
		var staticValuesMappingNew = staticValuesMapping;
		var excessValue = quoteOptions.getStateDefaultVoluntaryExcess(
			userInput.policyAddress.state
		);
		if (excessValue != null) {
			var tempObj = {
				'vehicles.0.excess.voluntaryVehicleExcess': excessValue
			};
			staticValuesMappingNew = Object.extend(
				staticValuesMapping,
				tempObj
			);
		}
		return staticValuesMappingNew;
	}

	return {
		transform: transform
	};
}


function VehicleFormatConverterTransformer(Util, jsonMapper) {

	
	function convertDateAndTimeTheGuidewireWay(dateTime) {
		var format = "{0} at {1} AEST" ;
		return Util.stringFormat(format, dateTime.format('Do MMM YYYY') , dateTime.format('h:mma')) ;
	}

	function convertDate(dateString) {
		var date = moment(dateString, 'DD/MM/YYYY') ;
		var formattedDate = date.format('YYYY-MM-DD') ;
		if ( formattedDate != "Invalid date")
			return formattedDate;


		// throw 'date format exception formatting ' + dateString ; 
		return null;
	}

	function convertDateToGWTimeZone(dateString) {
		var formattedDate = moment(dateString,'DDMMYYYY').tz("Australia/Sydney").format('YYYY-MM-DD') ;
		if ( formattedDate != "Invalid date")
			return formattedDate;

		return null;
	}

	function convertGender(gender) {
		var gc = {
			male : 'M',
			female : 'F',
			intersex : 'I',
		};

		return gc[gender] ;
	}

	function convertFalsyToUnknown(value) {
		if ( value === null || value === undefined )
			return 'unknown';

		return convertBooleanToYesNo(value) ;
	}

	function convertBooleanToYesNo(value) {
		return value ? 'yes' : 'no' ;
	}

	function addAUToStateValue(value) {
		if ( value )
			return 'AU_' + value ; 

		return null;
	}

	var convertValueMapping = {
		periodStartDate: convertDateToGWTimeZone,
		'policyHolders.*.contact.gender' : convertGender,
		'policyHolders.*.contact.hasClaim' : convertFalsyToUnknown,
		'policyHolders.*.contact.hasConviction' : convertFalsyToUnknown,
		'policyHolders.*.contact.anyLostLicences' : convertFalsyToUnknown,
		'policyHolders.*.contact.anyInfringements' : convertFalsyToUnknown,
		'policyHolders.*.contact.dateOfBirth' : convertDate,
		
		'vehicles.0.otherDriverHasProLicense' : convertBooleanToYesNo,
		'vehicles.0.youngestDriverGender' : convertGender,
		'vehicles.0.youngestDriverDOB' : convertDate,
		"vehicles.0.registrationState" : addAUToStateValue,
		'vehicles.0.drivers.*.driver.person.dateOfBirth' : convertDate,
		'vehicles.0.drivers.*.driver.person.gender' : convertGender,
		'vehicles.0.drivers.*.driver.person.hasClaim' : convertBooleanToYesNo,
		'vehicles.0.drivers.*.driver.person.hasConviction' : convertBooleanToYesNo,
		"vehicles.0.drivers.*.driver.zeroDemerits": convertBooleanToYesNo,

		"vehicles.0.drivers.*.driver.hasConviction": convertFalsyToUnknown,
		"vehicles.0.drivers.*.driver.hasClaim": convertFalsyToUnknown,
		"vehicles.0.drivers.*.driver.hasInfringement": convertFalsyToUnknown,
		"vehicles.0.drivers.*.driver.hasLostLicence": convertFalsyToUnknown,
	};

	var companyConvertValueMapping = {
		/** company contact details only */
		'policyHolders.*.contact.authorisedPersons.0.person.gender' : convertGender,
		'policyHolders.*.contact.authorisedPersons.0.person.hasClaim' : convertFalsyToUnknown,
		'policyHolders.*.contact.authorisedPersons.0.person.hasConviction' : convertFalsyToUnknown,
		'policyHolders.*.contact.authorisedPersons.0.person.anyLostLicences' : convertFalsyToUnknown,
		'policyHolders.*.contact.authorisedPersons.0.person.anyInfringements' : convertFalsyToUnknown,
		'policyHolders.*.contact.authorisedPersons.0.person.dateOfBirth' : convertDate,
	}

	function transform(intermediateRequest, userInput) {
		var transformedRequest = jsonMapper.convert(intermediateRequest, convertValueMapping) ;
		if ( transformedRequest.policyHolders[0]
			&& transformedRequest.policyHolders[0].contact
			&&  transformedRequest.policyHolders[0].contact.authorisedPersons
			)
			transformedRequest = jsonMapper.convert(intermediateRequest, companyConvertValueMapping) ;

		return transformedRequest;
	}

	return {
		transform: transform
	}
}

function VehiclePolicyHolderHandler(Util, publicIDTransformer) {

	function handle(quoteRequest, userInput) {

		var mainPolicyholder = quoteRequest.policyHolders.filter(function (item) {
			return item['mainHolder'];
		})[0];

		var mainDriver = quoteRequest.vehicles[0].drivers.filter(function (item) {
			return item['driverUsage'] == 'main';
		})[0];

		if ((!userInput.vehicleForm.mainPolicyHolder ||
				(userInput.vehicleForm.mainPolicyHolder && userInput.vehicleForm.mainPolicyHolder.isMainDriverMainPolicyHolder)) && userInput.vehicleForm.getStarted.personOrCompany != "company") {
			mainPolicyholder.contact.publicID = mainDriver.driver.person.publicID;
		} else if (userInput.vehicleForm.mainPolicyHolder != undefined && userInput.vehicleForm.mainPolicyHolder.isMainDriverMainPolicyHolder != undefined &&
			!userInput.vehicleForm.mainPolicyHolder.isMainDriverMainPolicyHolder &&
			mainPolicyholder.contact.publicID == mainDriver.driver.person.publicID) {
			quoteRequest = publicIDTransformer.transform(quoteRequest);
			delete quoteRequest.secret;
			delete quoteRequest.quoteID;
		}

		if (mainPolicyholder.contact.publicID == mainDriver.driver.person.publicID) {
			mainDriver.driver.person.passwordQuestion = mainPolicyholder.contact.passwordQuestion;
			mainDriver.driver.person.passwordAnswer = mainPolicyholder.contact.passwordAnswer;
			mainDriver.driver.person.primaryPhone = mainPolicyholder.contact.primaryPhone;

			switch (mainPolicyholder.contact.primaryPhone) {
				case 'mobile':
					mainDriver.driver.person.cellPhone = mainPolicyholder.contact.cellPhone;
					break;
				case 'home':
					mainDriver.driver.person.homePhone = mainPolicyholder.contact.homePhone;
					break;
				case 'work':
					mainDriver.driver.person.workPhone = mainPolicyholder.contact.workPhone;
					break;
			}

			delete mainPolicyholder.contact.drivingHistory;
		}

		return quoteRequest;
	}

	return {
		handle: handle
	}
};

'use strict';

function VehiclePublicIDTransformer(
	Util,
	jsonMapper,
	serviceResponseRepository,
	aggregatedRemoveService
) {
	var currentResponse = null;
	var driverUniqueIdCtr = 1;
	var historyUniqueIdCtr = 1;

	function forgePublicId(moduleName) {
		return Util.stringFormat(
			'portal:{0}-{1}',
			moduleName,
			Util.generateRandomString(15)
		);
	}

	function hasValidGWPublicID(publicID) {
		if (publicID && publicID.indexOf('portal:') === -1) return true;

		return false;
	}

	function hash(value) {
		return md5(value);
	}

	function fetchFromPreviousResponse(path) {
		if (currentResponse)
			return Util.findHierarchyStringInObject(currentResponse, path, '.');

		return null;
	}

	function convertPublicID(path, moduleName) {
		if (currentResponse) {
			var lastPublicID = fetchFromPreviousResponse(path);
			if (lastPublicID) return lastPublicID;
		}

		return forgePublicId(moduleName);
	}

	var moduleNameMapping = {
		policyHolders: 'PolicyHolder[]',
		policyAddress: 'Address',
		vehicles: 'QPMVehicle',
		driver: 'QPMVehicleDriver',
		policyDriver: 'QPMPolicyDriver',
		person: 'person',
		driverHistory: 'QPMDriverHistory',
		drivingHistory: 'QPMDrivingHistory',
		pattern: 'qbePattern'
	};

	var publicIDTransformationMapping = {
		'policyAddress.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		},
		'vehicles.0.publicID': function() {
			return forgePublicId(moduleNameMapping.vehicles);
		},
		'vehicles.0.garageAddress.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		},
		'vehicles.0.drivers.*.publicID': function() {
			return forgePublicId(moduleNameMapping.driver);
		},
		'vehicles.0.drivers.*.uniqueID': function() {
			return driverUniqueIdCtr++;
		},
		'vehicles.0.drivers.*.driver.publicID': function() {
			return forgePublicId(moduleNameMapping.policyDriver);
		},
		'vehicles.0.drivers.*.driver.person.publicID': function() {
			return forgePublicId(moduleNameMapping.person);
		},
		'vehicles.0.drivers.*.driver.person.primaryAddress.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		},
		'vehicles.0.drivers.*.driver.driverHistory.*.publicID': function() {
			return forgePublicId(moduleNameMapping.driverHistory);
		},
		'vehicles.0.drivers.*.driver.driverHistory.*.uniqueID': function() {
			return historyUniqueIdCtr++;
		},
		'policyHolders.*.contact.publicID': function() {
			return forgePublicId(moduleNameMapping.person);
		},
		'policyHolders.*.contact.drivingHistory.*.publicID': function() {
			return forgePublicId(moduleNameMapping.drivingHistory);
		},
		'policyHolders.*.contact.primaryAddress.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		}
	};

	var authorisedPersonsPublicIDTransformationMapping = {
		'policyHolders.*.contact.authorisedPersons.0.person.publicID': function() {
			return forgePublicId(moduleNameMapping.person);
		},
		'policyHolders.*.contact.authorisedPersons.0.person.primaryAddress.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		}
	};

	var publicIDConversionMapping = {
		'policyAddress.publicID': function(val) {
			return convertPublicID(
				'policyAddress.publicID',
				moduleNameMapping.policyAddress
			);
		},
		'vehicles.0.publicID': function(val) {
			return convertPublicID(
				'vehicles.0.publicID',
				moduleNameMapping.vehicles
			);
		},
		'vehicles.0.drivers.*.uniqueID': function() {
			return driverUniqueIdCtr++;
		},
		'vehicles.0.drivers.*.driver.driverHistory.*.uniqueID': function() {
			return historyUniqueIdCtr++;
		},
		'vehicles.0.garageAddress.publicID': function(val) {
			return convertPublicID(
				'vehicles.0.garageAddress.publicID',
				moduleNameMapping.policyAddress
			);
		},
		'policyHolders.*.contact.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'policyHolders.' +
					mappedValueStarIndices[0] +
					'.contact.publicID',
				moduleNameMapping.policyHolders
			);
		},
		'vehicles.0.drivers.*[driverUsage].publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'vehicles.0.drivers.' + mappedValueStarIndices[0] + '.publicID',
				moduleNameMapping.driver
			);
		},
		'vehicles.0.drivers.*[driverUsage].driver.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'vehicles.0.drivers.' +
					mappedValueStarIndices[0] +
					'.driver.publicID',
				moduleNameMapping.policyDriver
			);
		},
		'vehicles.0.drivers.*[driverUsage].driver.person.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'vehicles.0.drivers.' +
					mappedValueStarIndices[0] +
					'.driver.person.publicID',
				moduleNameMapping.person
			);
		},
		'vehicles.0.drivers.*[driverUsage].driver.driverHistory.*.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'vehicles.0.drivers.' +
					mappedValueStarIndices[0] +
					'.driver.driverHistory.' +
					mappedValueStarIndices[1] +
					'.publicID',
				moduleNameMapping.driverHistory
			);
		},
		'vehicles.0.drivers.*[driverUsage].driver.person.primaryAddress.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'vehicles.0.drivers.' +
					mappedValueStarIndices[0] +
					'driver.person.primaryAddress.publicID',
				moduleNameMapping.policyAddress
			);
		},
		'policyHolders.*.contact.primaryAddress.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'policyHolder.' +
					mappedValueStarIndices[0] +
					'.contact.primaryAddress.publicID',
				moduleNameMapping.policyAddress
			);
		},
		'policyHolders.*.contact.drivingHistory.*.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'policyHolders.' +
					mappedValueStarIndices[0] +
					'.contact.drivingHistory.' +
					mappedValueStarIndices[1] +
					'.publicID',
				moduleNameMapping.drivingHistory
			);
		}
	};

	var authorisedPersonsPublicIDConversionMapping = {
		'policyHolders.*.contact.authorisedPersons.0.person.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'policyHolders.' +
					mappedValueStarIndices[0] +
					'.contact.authorisedPersons.0.person.publicID',
				moduleNameMapping.person
			);
		},
		'policyHolders.*.contact.authorisedPersons.0.person.primaryAddress.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'policyHolders.' +
					mappedValueStarIndices[0] +
					'.contact.authorisedPersons.0.person.primaryAddress.publicID',
				moduleNameMapping.policyAddress
			);
		}
	};

	function removeDeletedAdditionalDrivers(transformedRequest) {
		var removedDrivers = aggregatedRemoveService.getList()
			? aggregatedRemoveService.getList()['driver']
			: null;
		var savedDrivers = fetchFromPreviousResponse('drivers.0.drivers');
		if (savedDrivers && removedDrivers) {
			angular.forEach(removedDrivers, function(removedDriver) {
				var matchingDriver = savedDrivers.filter(function(driver) {
					return (
						driver.driver.person.firstName ==
							removedDriver.person.firstName &&
						driver.driver.person.lastName ==
							removedDriver.person.lastName
					);
				});
				matchingDriver = matchingDriver[0] || null;
				if (matchingDriver) {
					matchingDriver.markedForDelete = true;
					transformedRequest.drivers[0].drivers.push(matchingDriver);
				}
			});
			aggregatedRemoveService.clear('driver');
		}

		return transformedRequest;
	}

	function removeDeletedDriverHistoryArrays(transformedRequest) {
		var drivers = transformedRequest.vehicles[0].drivers;
		var fieldName = 'driverUsage';
		angular.forEach(drivers, function(driver, index) {
			var fieldValue = driver[fieldName];
			var locator = '[' + fieldName + '=' + fieldValue + ']';
			var savedHistories = fetchFromPreviousResponse(
				'vehicles.0.drivers.' +
					index +
					locator +
					'.driver.driverHistory'
			);
			if (savedHistories && savedHistories.length > 0) {
				var driverHistories = driver.driver.driverHistory;
				angular.forEach(savedHistories, function(savedHistory) {
					var matchingInput = driverHistories.filter(function(
						history
					) {
						return history.publicID == savedHistory.publicID;
					});
					if (!matchingInput || matchingInput.length == 0) {
						savedHistory.markedForDelete = true;
						driverHistories.push(savedHistory);
					}
				});
			}
		});
		return transformedRequest;
	}

	function removeEmptyDriverHistoryArrays(transformedRequest) {
		var vehicle = transformedRequest.vehicles[0];
		if (vehicle && vehicle.drivers) {
			vehicle.drivers.forEach(function(policyDriver) {
				if (
					policyDriver.driver &&
					policyDriver.driver.driverHistory &&
					Array.isArray(policyDriver.driver.driverHistory) &&
					policyDriver.driver.driverHistory.length == 0
				)
					delete policyDriver.driver.driverHistory;
			});
		}

		return transformedRequest;
	}

	//dd-973 - requiring a sequence number for driver infringement
	function addUniqueHistoryID(transformedRequest) {
		var drivers = transformedRequest.vehicles[0].drivers;

		angular.forEach(drivers, function(driver, index) {
			historyUniqueIdCtr = 1;
			var driverHistory = driver.driver.driverHistory;
			if (driverHistory) {
				angular.forEach(driverHistory, function(driverHistory, index) {
					driverHistory.uniqueID = historyUniqueIdCtr;
					historyUniqueIdCtr++;
				});
			}

			// if (driver.driverUsage !== 'main') {
			// 	if (driver.driver.person && driver.driver.person.primaryAddress) {
			// 		delete driver.driver.person.primaryAddress;
			// 	}
			// }
		});
		return transformedRequest;
	}

	function transform(intermediateRequest, response) {
		currentResponse = response;
		driverUniqueIdCtr = 1;
		var transformedRequest = intermediateRequest;

		if (
			transformedRequest.policyHolders[0] &&
			transformedRequest.policyHolders[0].contact &&
			transformedRequest.policyHolders[0].contact.authorisedPersons
		) {
			publicIDConversionMapping = Object.extend(
				publicIDConversionMapping,
				authorisedPersonsPublicIDConversionMapping
			);
			publicIDTransformationMapping = Object.extend(
				publicIDTransformationMapping,
				authorisedPersonsPublicIDTransformationMapping
			);
		}

		if (!currentResponse)
			transformedRequest = jsonMapper.transform(
				intermediateRequest,
				publicIDTransformationMapping
			);
		else {
			transformedRequest = jsonMapper.convert(
				intermediateRequest,
				publicIDConversionMapping
			);
		}

		transformedRequest = addUniqueHistoryID(transformedRequest);
		transformedRequest = removeDeletedAdditionalDrivers(transformedRequest);
		transformedRequest = removeDeletedDriverHistoryArrays(
			transformedRequest
		);
		transformedRequest = removeEmptyDriverHistoryArrays(transformedRequest);

		return transformedRequest;
	}

	return {
		transform: transform
	};
}

function VehicleQuoteResultModel(quoteResultResponse) {
	this.isCoverAvailable = quoteResultResponse.quoteResult.totalPremium !== undefined ;
	this.coverType = quoteResultResponse.vehicles[0].coverType;
	this.quoteResult = quoteResultResponse.quoteResult;
	this.paymentPlan = quoteResultResponse.paymentPlan;
	this.totalPremium = quoteResultResponse.quoteResult.totalPremium ;
	this.totalFSL = quoteResultResponse.quoteResult.totalFSL ;
	this.totalGST = quoteResultResponse.quoteResult.totalGST ;
	this.totalStampDuty = quoteResultResponse.quoteResult.totalStampDuty ;
	this.premiumAfterDiscount = quoteResultResponse.quoteResult.premiumAfterDiscount ;
	this.totalPremium = quoteResultResponse.quoteResult.totalPremium ;
	this.paymentFrequency = quoteResultResponse.paymentPlan ? quoteResultResponse.paymentPlan.paymentFrequency : null ;
	this.excess = quoteResultResponse.vehicles[0].excess ;
	this.availableSumInsuredTypes = quoteResultResponse.vehicles[0].availableSumInsuredTypes;
	this.vehicleValue = {
		upper: quoteResultResponse.vehicles[0].agreedValueUpper,
		lower: quoteResultResponse.vehicles[0].agreedValueLower
	};
	this.coverageOptions = quoteResultResponse.vehicles[0].coverageOptions ;
	this.response = quoteResultResponse ;
}

function VehicleRetrieveSavedQuoteResponseTransformer($filter, jsonMapper, Util) {
    // transform functions
    var transformers = {
        camelcase: function(value) {
            if(value) {
                return value.charAt(0).toUpperCase() + value.slice(1);
            }
        },        
        date: function(dateString) {
            var date = moment(dateString, 'YYYY-MM-DD') ;
            return date.format('DD/MM/YYYY') ;
        },
        today : function() {
            return  moment().tz("Australia/Sydney").format('DD/MM/YYYY') ;
        },
        convertGender: function(gender) {
            var gc = {
                M : 'male',
                F : 'female',
                I : 'intersex',
            };
            return gc[gender] ;
        },
        yesNo: function(value) {
            return value == 'yes' ? true : false;
        },
        defaultNull: function(value) {
            return null;
        },
        checkbox: function(value) {
        },
        state: function(state) {
            if ( state )
                return state.replace('AU_', '');
        },
        coverType: function(coverType) {
            if(coverType === 'third_party' || coverType === 'third_party_fire_theft') {
                return 'third_party';
            }
            return coverType;
        },
        purchaseMonthFromMonthYear: function(monthYear) {
            if(monthYear){
                var month = monthYear.split('-')[1];
                return month;
            }else{
                return '';
            }

        },
        purchaseYearFromMonthYear: function(monthYear) {
            if(monthYear){
                var year = monthYear.split('-')[0];
                return year;
            }else{
                return '';
            }
        },
        thirdPartyPref: function(coverType) {
            if(coverType === 'comprehensive') {
                return null;
            }

            if(coverType==='third_party'){
                return 'standard';
            }
            return coverType;
        },
        financeWith: function(financeWith) {

            if(financeWith) {
                var carFinance = {};

                carFinance.label = financeWith.name;
                carFinance.value = financeWith.publicID;

                return carFinance;
            }
        },
        yearsHeld: function(years) {
            var yearsHeld;

            switch (years) {
                case '7':
                    yearsHeld = 'lessThan_1';
                    break;
                case '6':
                    yearsHeld = 'greaterThan_5';
                    break;
                default:
                    yearsHeld = years;
            }

            return yearsHeld;
        },
        hasModifications: function(modifications) {
            return modifications.length > 1 ? true : false;
        },
    };
    function transformPerson(person) {
        var transformMapping = {
                'returnObject.title':                                   '=_input.prefix',
                'returnObject.firstName':                               '=_input.firstName',
                'returnObject.lastName':                                '=_input.lastName',
                'returnObject.gender':                                  '=_input.gender',
                'returnObject.dateOfBirth':                             '=_input.dateOfBirth'
            },
            convertMapping = {
                'returnObject.title':                                   transformers.camelcase,
                'returnObject.gender':                                  transformers.convertGender,
                'returnObject.dateOfBirth':                             transformers.date
            };
        var transformedPerson = jsonMapper.convert(jsonMapper.transform(person, transformMapping), convertMapping);
        return transformedPerson.returnObject;
    }

    function transformDriver(driver) {

        // transformPersonalHistory(driver.driverHistory);

        var transformMapping = {
            'returnObject.yearsHeld':                                       '=_input.yearsLicenced',
            'returnObject.licenceType':                                     '=_input.licenceType',
            'returnObject.noClaimBonus':                                    '=_input.noClaimBonus',
            'returnObject.maxNoClaimBonusLength':                           '=_input.maxNoClaimBonusLength',
            'returnObject.previousInsurer':                                 '=_input.previousInsurer',
            'returnObject.NSWDemeritPoints':                                '=_input.zeroDemerits',
            'returnObject.fourYears_chargedOrConvictedOffences':            '=_input.hasInfringement',
            // 'returnObject.fourYears_chargedOrConvictedOffencesDetails':      '=_input.driverHistory',
            'returnObject.fourYears_licenceRSDC':                           '=_input.hasLostLicence',
            // 'returnObject.fourYears_licenceRSDCDetails':                 '=_input.driverHistory',
            'returnObject.fourYears_vehicleAccidentsClaims':                '=_input.hasClaim',
            // 'returnObject.fourYears_vehicleAccidentsClaimsDetails':          '=_input.driverHistory',
            'returnObject.tenYears_chargedOrConvictedOffences':             '=_input.hasConviction',
            // 'returnObject.tenYears_chargedOrConvictedOffencesDetails':      '=_input.driverHistory',
            },
            convertMapping = {
                'returnObject.yearsHeld':                                   transformers.yearsHeld,
                'returnObject.NSWDemeritPoints':                            transformers.yesNo,

                'returnObject.fourYears_chargedOrConvictedOffences':        transformers.defaultNull,
                // 'returnObject.fourYears_chargedOrConvictedOffencesDetails': transformers.history,

                'returnObject.fourYears_licenceRSDC':                       transformers.defaultNull,
                 // 'returnObject.fourYears_licenceRSDCDetails':                transformers.history,

                'returnObject.fourYears_vehicleAccidentsClaims':            transformers.defaultNull,
                // 'returnObject.fourYears_vehicleAccidentsClaimsDetails':      transformers.history,

                'returnObject.tenYears_chargedOrConvictedOffences':         transformers.defaultNull,
                // 'returnObject.tenYears_chargedOrConvictedOffencesDetails':  transformers.history
            };

        var transformedDriver = jsonMapper.convert(jsonMapper.transform(driver, transformMapping), convertMapping);
        var returnObject = transformedDriver.returnObject;
        if(driver.person) {
            returnObject.person = transformPerson(driver.person);
        }

         // extract driver history
        returnObject.fourYears_chargedOrConvictedOffencesDetails = [];
        returnObject.fourYears_vehicleAccidentsClaimsDetails = [];
        returnObject.tenYears_chargedOrConvictedOffencesDetails = [];
        returnObject.fourYears_licenceRSDCDetails = [];

        if (!!driver.driverHistory) {
            driver.driverHistory.forEach(function(record) {
                var matchedPattern = {};

                switch (record.pattern.filter1) {
                    case 'infringement_demerit':
                    // case 'infringement_licence':
                        returnObject.fourYears_chargedOrConvictedOffencesDetails.push(
                            extractHistory(globals.fourYears_offences.options, record)
                        );
                        break;
                    case 'infringement_licence':
                        returnObject.fourYears_licenceRSDCDetails.push(
                            extractHistory(globals.incidents.options, record)
                        );
                        break;
                    case 'claim' :
                        returnObject.fourYears_vehicleAccidentsClaimsDetails.push(
                            extractHistory(globals.accidents.options, record));
                        break;
                    case 'conviction' :
                        returnObject.tenYears_chargedOrConvictedOffencesDetails.push(
                            extractHistory(globals.tenYears_offences.options, record)
                        );
                        break;

                }
            });
        }

        returnObject.fourYears_chargedOrConvictedOffences = returnObject.fourYears_chargedOrConvictedOffencesDetails.length > 0 ;
        returnObject.fourYears_vehicleAccidentsClaims = returnObject.fourYears_vehicleAccidentsClaimsDetails.length > 0 ;
        returnObject.tenYears_chargedOrConvictedOffences = returnObject.tenYears_chargedOrConvictedOffencesDetails.length > 0 ;
        returnObject.fourYears_licenceRSDC = returnObject.fourYears_licenceRSDCDetails.length > 0 ;

        return returnObject;
    }

    function extractHistory(collection, record) {
        var matchedPattern = {};
        var month = {};
        var year = {};

        matchedPattern = collection.find(function(opt) {
            return opt.publicID == record.pattern.publicID;
        });

        month.label = month.value = moment(record.month, 'MM').format('MMMM') ; // Util.capitalize(record.month.toString());
        year.label = year.value = Util.capitalize(record.year.toString());

        record.description = matchedPattern;
        record.month = month;
        record.year = year;

        delete record.pattern;

        return record;
    }
        // WIP deconstruction of driver history to separate them into the different tables
        // function transformPersonalHistory(history) {
        //  console.info('history', history);
        //  console.info('labels', labelService.getOptionsFor('fourYears_chargedOrConvictedOffencesDetails'));
        // }

    function transformPolicyHolder(holder) {

        var transformMapping = {
            'returnObject.title':                                           '=_input.prefix',
            'returnObject.firstName':                                       '=_input.firstName',
            'returnObject.lastName':                                        '=_input.lastName',
            'returnObject.gender':                                          '=_input.gender',
            'returnObject.dateOfBirth':                                     '=_input.dateOfBirth',
            'returnObject.fourYears_chargedOrConvictedOffences':            '=_input.hasInfringement',
            'returnObject.fourYears_licenceRSDC':                           '=_input.hasLostLicence',
            'returnObject.fourYears_vehicleAccidentsClaims':                '=_input.hasClaim',
            'returnObject.tenYears_chargedOrConvictedOffences':             '=_input.hasConviction'
            },
            convertMapping = {
                'returnObject.title':                                       transformers.camelcase,
                'returnObject.gender':                                      transformers.convertGender,
                'returnObject.dateOfBirth':                                 transformers.date,
                'returnObject.fourYears_chargedOrConvictedOffences':        transformers.yesNo,
                'returnObject.fourYears_licenceRSDC':                       transformers.yesNo,
                'returnObject.fourYears_vehicleAccidentsClaims':            transformers.yesNo,
                'returnObject.tenYears_chargedOrConvictedOffences':         transformers.yesNo
            };

        var transformedPolicyHolder = jsonMapper.convert(jsonMapper.transform(holder, transformMapping), convertMapping);

        return transformedPolicyHolder.returnObject;
    }

    /**
     * Transforms the retrievedQuoteRepsonse into a format that can be injected into the userInputRepository
     * The returned value will populate all the forms in the quote process
     * @param {Object} retrievedQuoteResponse                   Response object from the retrieveSavedQuote service
     * @returns {Object}                                        Transformed object ready to inject into the userInputRepository
     */
    function transform(retrievedQuoteResponse) {
        void 0;

       var transformMapping = {
				// getStarted
				'returnObject.getStarted.policyStartDate':
					'=_input.periodStartDate',
				'returnObject.getStarted.personOrCompany':
					'=_input.policyHolders.0.contact.contactType',

				// aboutYourCar
				'returnObject.aboutYourCar.address':
					'=_input.vehicles.0.garageAddress',

				// carDetails
				'returnObject.carDetails.locationParked':
					'=_input.vehicles.0.garageType',
				'returnObject.carDetails.primaryCarUse':
					'=_input.vehicles.0.primaryUsage',
				'returnObject.carDetails.colour': '=_input.vehicles.0.colour',
				'returnObject.carDetails.last12Months':
					'=_input.vehicles.0.recentPurchase',
				'returnObject.carDetails.carCost':
					'=_input.vehicles.0.purchasePrice',
				'returnObject.carDetails.originalOwner':
					'=_input.vehicles.0.originalOwner',
				'returnObject.carDetails.whenDidYouBuyYear':
					'=_input.vehicles.0.purchaseMonthYear',
				'returnObject.carDetails.whenDidYouBuyMonth':
					'=_input.vehicles.0.purchaseMonthYear',
				'returnObject.carDetails.carFinance':
					'=_input.vehicles.0.financeType',
				'returnObject.carDetails.financeWith':
					'=_input.vehicles.0.financeCompany',
				'returnObject.carDetails.existingDamage':
					'=_input.vehicles.0.unrepairedDamage',
				'returnObject.carDetails.writtenEvidence':
					'=_input.vehicles.0.evidenceOfValueOrPrice',
				'returnObject.carDetails.salvageValue':
					'=_input.vehicles.0.salvageValue',
				'returnObject.carDetails.modificationsBuilt':
					'=_input.vehicles.0.afterMarketModifications',

				//tell us a bit more -------------------------------------
				'returnObject.tellUsABitMore.yourEmailAddress': '=_input.email',
				'returnObject.tellUsABitMore.promotionalCode':
					'=_input.campaignCode',
				'returnObject.stampDutyExemption.isSmallBusiness':
					'=_input.vehicles.0.isSmallBusiness',

				//driver
				// 'vehicleForm.driver.paymentOptions':             '=_input.?',

				//quote
				'returnObject.insuredExcessValue.coverType':
					'=_input.vehicles.0.coverType',
				'returnObject.insuredExcessValue.comprehensivePref':
					'=_input.vehicles.0.sumInsuredType',
				'returnObject.insuredExcessValue.thirdPartyOrThirdPartyFireAndTheft':
					'=_input.vehicles.0.coverType',
				'returnObject.insuredExcessValue.vehicleExcess':
					'=_input.vehicles.0.excess.voluntaryVehicleExcessOptions',
				'returnObject.insuredExcessValue.standardVehicleExcess':
					'=_input.vehicles.0.excess.standardVehicleExcess',
				'returnObject.insuredExcessValue.voluntaryVehicleExcess':
					'=_input.vehicles.0.excess.voluntaryVehicleExcess',
				'returnObject.insuredExcessValue.ageExcessTier1':
					'=_input.vehicles.0.excess.ageExcessTier1',
				'returnObject.insuredExcessValue.ageExcessTier2':
					'=_input.vehicles.0.excess.ageExcessTier2',
				'returnObject.insuredExcessValue.undeclaredDriverTier2':
					'=_input.vehicles.0.excess.undeclaredDriverTier2',
				'returnObject.insuredExcessValue.inexperiencedDriver':
					'=_input.vehicles.0.excess.inexperiencedDriver',
				'returnObject.insuredExcessValue.agreedValue':
					'=_input.vehicles.0.sumInsuredAmount',

				// optional benefits
				'returnObject.optionalBenefits.QPMMotVehHireCar':
					'=_input.vehicles.0.coverageOptions.0.selected',
				'returnObject.optionalBenefits.QPMMotVehWindscreen':
					'=_input.vehicles.0.coverageOptions.1.selected',
				'returnObject.optionalBenefits.QPMMotVehNCB':
					'=_input.vehicles.0.coverageOptions.2.selected',
				'returnObject.optionalBenefits.QPMMotVehLifetimeNCB':
					'=_input.vehicles.0.coverageOptions.2.selected',
				// registration details
				'returnObject.aboutYourCar.regoSearchResponse':
					'=_input.vehicles.0.vehicleInfo',
				'returnObject.aboutYourCar.retrievedQuoteRego.rego':
					'=_input.vehicles.0.registrationNumber',
				'returnObject.aboutYourCar.retrievedQuoteRego.state':
					'=_input.vehicles.0.garageAddress.state',
				'returnObject.tellUsYourRegoNumber.regoNumber':
					'=_input.vehicles.0.registrationNumber',
				// Contact
				'returnObject.mainPolicyHolderContact.passwordQuestion':
					'=_input.policyHolders.0.contact.passwordQuestion',
				'returnObject.mainPolicyHolderContact.passwordAnswer':
					'=_input.policyHolders.0.contact.passwordAnswer',
				'returnObject.mainPolicyHolderContact.primaryPhone':
					'=_input.policyHolders.0.contact.primaryPhone',
				'returnObject.mainPolicyHolderContact.personalContactDetailsMailingPreference':
					'=_input.documentDeliveryMethod',

				'returnObject.mainPolicyHolderContact.emailAddress1':
					'=_input.email'
			},
			convertMapping = {
				'returnObject.carDetails.colour': transformers.camelcase,
				'returnObject.getStarted.policyStartDate': transformers.date,
				'returnObject.carDetails.financeWith': transformers.financeWith,
				'returnObject.retrievedQuoteRego.state': transformers.state,
				'returnObject.insuredExcessValue.coverType':
					transformers.coverType,
				'returnObject.insuredExcessValue.thirdPartyOrThirdPartyFireAndTheft':
					transformers.thirdPartyPref,
				'returnObject.carDetails.whenDidYouBuyYear':
					transformers.purchaseYearFromMonthYear,
				'returnObject.carDetails.whenDidYouBuyMonth':
					transformers.purchaseMonthFromMonthYear
			};
        var transformedQuote = jsonMapper.convert(jsonMapper.transform(retrievedQuoteResponse, transformMapping), convertMapping);

        if(retrievedQuoteResponse.vehicles[0].primaryUsage) {
            var usage = retrievedQuoteResponse.vehicles[0].primaryUsage;
			switch (usage) {
				case 'commercial':
                transformedQuote.returnObject.carDetails.commercialActivityType = retrievedQuoteResponse.vehicles[0].businessUsage;
					break;
				case 'business':
                    transformedQuote.returnObject.carDetails.businessActivityType = retrievedQuoteResponse.vehicles[0].businessUsage;
					break;
			}            
        }

        // set primary phone number to mobile phone
        if(retrievedQuoteResponse.policyHolders[0].contact.cellPhone) {
            transformedQuote.returnObject.mainPolicyHolderContact.primaryPhoneNumber = retrievedQuoteResponse.policyHolders[0].contact.cellPhone;
        }

        // set primary phone number to home phone
        if(retrievedQuoteResponse.policyHolders[0].contact.homePhone) {
            transformedQuote.returnObject.mainPolicyHolderContact.primaryPhoneNumber = retrievedQuoteResponse.policyHolders[0].contact.homePhone;
        }

        // set primary phone number to work phone
        if(retrievedQuoteResponse.policyHolders[0].contact.workPhone) {
            transformedQuote.returnObject.mainPolicyHolderContact.primaryPhoneNumber = retrievedQuoteResponse.policyHolders[0].contact.workPhone;
        }

        // set comprehensive preference to null if the coverType is third party
        if(retrievedQuoteResponse.vehicles[0].coverType.length && retrievedQuoteResponse.vehicles[0].sumInsuredType.length) {
            var coverType = retrievedQuoteResponse.vehicles[0].coverType;
            if(coverType === 'third_party' || coverType === 'third_party_fire_theft') {
                transformedQuote.returnObject.insuredExcessValue.comprehensivePref = null;
            }
        }

        // set optional modifications
        // console.info(retrievedQuoteResponse.vehicles[0].vehicleInfo.selectedEquipments[0]);
        if(retrievedQuoteResponse.vehicles[0].vehicleInfo &&
            retrievedQuoteResponse.vehicles[0].vehicleInfo.selectedEquipments &&
            retrievedQuoteResponse.vehicles[0].vehicleInfo.selectedEquipments.length) {

            transformedQuote.returnObject.carDetails.modifications = true;

            transformedQuote.returnObject.carDetails.modificationsOptions = {};

            var selectedEquipments = retrievedQuoteResponse.vehicles[0].vehicleInfo.selectedEquipments;

            selectedEquipments.forEach(function(mod) {
                // console.info(mod.optionKey);
                transformedQuote.returnObject.carDetails.modificationsOptions[mod.optionKey] = true;
            });
        } else {
             transformedQuote.returnObject.carDetails.modifications = false;
        }

        if(retrievedQuoteResponse.vehicles[0] &&
            retrievedQuoteResponse.vehicles[0].afterMarketMods &&
            retrievedQuoteResponse.vehicles[0].afterMarketMods.length) {

            transformedQuote.returnObject.carDetails.modificationsBuilt = true;

            transformedQuote.returnObject.carDetails.modificationsBuiltOptions = {};

            var afterMarketMods = retrievedQuoteResponse.vehicles[0].afterMarketMods;

            afterMarketMods.forEach(function(mod) {
                transformedQuote.returnObject.carDetails.modificationsBuiltOptions[mod] = true;
            });
        }

        // sort drivers to put mainDriver first in the list
        if(retrievedQuoteResponse.vehicles && retrievedQuoteResponse.vehicles.length && retrievedQuoteResponse.vehicles[0].drivers) {
            var drivers = $filter('orderBy')(retrievedQuoteResponse.vehicles[0].drivers, function(driver) {
                return driver.driverUsage == 'main' ? 0 : 1;
            });
            transformedQuote.returnObject.driver = {};
            transformedQuote.returnObject.driver.drivers = [];
            drivers.forEach(function(driver, index) {
                transformedQuote.returnObject.driver.drivers.push(transformDriver(driver.driver));
            });
        }

        // set contact policy holders
        if(retrievedQuoteResponse.policyHolders && retrievedQuoteResponse.policyHolders.length) {
            var policyHolders = retrievedQuoteResponse.policyHolders;

            transformedQuote.returnObject.mainPolicyHolder = {};

            policyHolders.forEach(function(holder, index) {

                if(holder.mainHolder) {
                    transformedQuote.returnObject.mainPolicyHolder.mainPolicyHolder = true;
                    transformedQuote.returnObject.mainPolicyHolder = transformPolicyHolder(holder.contact);
                    transformedQuote.returnObject.mainPolicyHolder.policyHolders = [];

					if (holder.contact.contactType === 'company') {
						var authorisedPerson = holder.contact.authorisedPersons[0].person;

						transformedQuote.returnObject.aboutCompany = {};
						transformedQuote.returnObject.aboutCompany.name = holder.contact.name;
						transformedQuote.returnObject.aboutCompany.abn = holder.contact.abn;
						transformedQuote.returnObject.aboutCompany.email = holder.contact.emailAddress1;
						transformedQuote.returnObject.aboutCompany.officePhone = holder.contact.workPhone;
                        transformedQuote.returnObject.aboutCompany.companyAddress = holder.contact.primaryAddress;

                        transformedQuote.returnObject.companyContact = {};                        
						transformedQuote.returnObject.companyContact.primaryPhone = authorisedPerson.primaryPhone;
						transformedQuote.returnObject.companyContact.preferredNumber = authorisedPerson.homePhone || authorisedPerson.workPhone || authorisedPerson.cellPhone;
						transformedQuote.returnObject.companyContact.passwordQuestion = holder.contact.passwordQuestion;
                        transformedQuote.returnObject.companyContact.passwordAnswer = holder.contact.passwordAnswer;
                        transformedQuote.returnObject.companyContact
                            .companyContactDetailsMailingPreference = retrievedQuoteResponse.documentDeliveryMethod;
                        transformedQuote.returnObject.companyContact.address =
							authorisedPerson.primaryAddress;
                    } 
                  
                } else {
                    transformedQuote.returnObject.mainPolicyHolder.policyHolders.push(transformPolicyHolder(holder.contact));
                }
            });
        }

        void 0;

        return transformedQuote.returnObject;
    }
    return {
        transform: transform
    }
}

function VehicleStructureRequestTransformer(
	jsonMapper,
	util,
	quoteOptions,
	storage
) {
	var structureQuoteMapping = {
		periodStartDate: '=_input.vehicleForm.getStarted.policyStartDate',
		vehicles: [],
		'vehicles.0': '=_input.vehicleForm.carDetails',
		'vehicles.0.registrationState':
			'=_input.vehicleForm.aboutYourCar.regoDetails.state',
		'vehicles.0.garageType':
			'=_input.vehicleForm.carDetails.locationParked',
		'vehicles.0.afterMarketModifications':
			'=_input.vehicleForm.carDetails.modificationsBuilt',
		'vehicles.0.primaryUsage':
			'=_input.vehicleForm.carDetails.primaryCarUse',

		'vehicles.0.vin': '=_regoSearch.vin',
		'vehicles.0.drivers': [], //"=_input.vehicleForm.driver.drivers",
		'vehicles.0.vehicleInfo': '=_regoSearch',
		'vehicles.0.garageAddress': '=_addressSearch',

		'vehicles.0.excess.voluntaryVehicleExcess':
			'=_input.vehicleForm.insuredExcessValue.voluntaryVehicleExcess',

		policyHolders: [],
		'policyHolders.0': {},
		'policyHolders.0.mainHolder':
			'=_input.vehicleForm.mainPolicyHolder.mainPolicyHolder',
		'policyHolders.0.contact': '=_input.vehicleForm.mainPolicyHolder',
		'policyHolders.0.contact.primaryAddress': '=_addressSearch',

		// "policyHolders.0.contact.driverHistory": [],
		// "policyHolders.0.contact.driverHistory": "=_input.vehicleForm.mainPolicyHolder.fourYears_chargedOrConvictedOffencesDetails",

		policyAddress: '=_addressSearch',
		email: '=_input.email',
		campaignCode: '=_input.vehicleForm.promotionalCode.promotionalCode',
		mainContactAddress: '=_addressSearch-main-contact',
		postalAddress: '=_addressSearch-postal-address'
	};

	function updateVehicleDetails(transformedRequest, userInput) {
		transformedRequest.vehicles[0] = util.deepClone(
			transformedRequest.vehicles[0]
		);
		if (userInput.vehicleForm.insuredExcessValue) {
			transformedRequest.vehicles[0].sumInsuredType =
				userInput.vehicleForm.insuredExcessValue.comprehensivePref;
		}
		//userInput.vehicleForm.insuredExcessValue
		if (userInput.vehicleForm.carDetails) {
			transformedRequest.vehicles[0].purchasePrice =
				userInput.vehicleForm.carDetails.carCost;
			if (userInput.vehicleForm.carDetails.whenDidYouBuyYear) {
				transformedRequest.vehicles[0].purchaseMonthYear =
					userInput.vehicleForm.carDetails.whenDidYouBuyYear +
					'-' +
					userInput.vehicleForm.carDetails.whenDidYouBuyMonth;
			}

			if (!!userInput.vehicleForm.carDetails.businessActivityType) {
				transformedRequest.vehicles[0].businessUsage =
					userInput.vehicleForm.carDetails.businessActivityType;
			} else if (
				!!userInput.vehicleForm.carDetails.commercialActivityType
			) {
				transformedRequest.vehicles[0].businessUsage =
					userInput.vehicleForm.carDetails.commercialActivityType;
			}
		}

		return transformedRequest;
	}

	function updatePolicyHolders(transformedRequest, userInput) {
		if (userInput.vehicleForm.getStarted) {
			var personOrCompany =
				userInput.vehicleForm.getStarted.personOrCompany;
			if (personOrCompany == 'company')
				return updateCompanyContactDetails(
					transformedRequest,
					userInput
				);
			else
				return updatePersonContactDetails(
					transformedRequest,
					userInput
				);
		}

		return transformedRequest;
	}

	function updateCompanyContactDetails(transformedRequest, userInput) {
		var policyHolder = util.deepClone(transformedRequest.policyHolders[0]);

		if (
			userInput.vehicleForm.companyContact &&
			userInput.vehicleForm.aboutCompany
		) {
			// transformedRequest.email = userInput.vehicleForm.companyContact.email;
			// var policyHolder = util.deepClone(transformedRequest.policyHolders[0]);
			policyHolder.contact = policyHolder.contact || {};
			policyHolder.contact.workPhone =
				userInput.vehicleForm.aboutCompany.officePhone;
			policyHolder.contact = Object.extend(
				policyHolder.contact,
				userInput.vehicleForm.aboutCompany
			);
			policyHolder.contact.emailAddress1 =
				userInput.vehicleForm.aboutCompany.email;
			policyHolder.contact.primaryAddress =
				userInput.vehicleForm.aboutCompany.companyAddress;

			var authorisedPerson = {};
			authorisedPerson = Object.extend(
				authorisedPerson,
				userInput.vehicleForm.companyContact
			);
			authorisedPerson.contactType = 'person';
			authorisedPerson.primaryAddress =
				transformedRequest.mainContactAddress !== null
					? transformedRequest.mainContactAddress
					: transformedRequest.vehicles[0].garageAddress;
			authorisedPerson.emailAddress1 =
				userInput.vehicleForm.companyContact.email;

			policyHolder.contact.passwordQuestion =
				authorisedPerson.passwordQuestion;
			policyHolder.contact.passwordAnswer =
				authorisedPerson.passwordAnswer;

			policyHolder.contact.authorisedPersons = [
				{
					person: authorisedPerson
				}
			];

			policyHolder.contact.primaryPhone = 'work';

			delete authorisedPerson.address;
			delete policyHolder.contact.companyAddress;
			delete policyHolder.contact.email;
			delete policyHolder.contact.officePhone;
		} else {
			policyHolder.contact.authorisedPersons = [
				{
					person: {
						contactType: 'person',
						primaryAddress: transformedRequest.policyAddress
					}
				}
			];
		}

		policyHolder.contact.contactType = 'company';
		transformedRequest.policyHolders[0] = policyHolder;
		transformedRequest.policyHolders[0].mainHolder = true;

		if (
			userInput.vehicleForm &&
			userInput.vehicleForm.companyContact &&
			userInput.vehicleForm.companyContact
				.companyContactDetailsMailingPreference
		) {
			transformedRequest.documentDeliveryMethod =
				userInput.vehicleForm.companyContact.companyContactDetailsMailingPreference;
			delete transformedRequest.policyHolders[0].contact
				.companyContactDetailsMailingPreference;
		}

		return transformedRequest;
	}

	function updatePersonContactDetails(transformedRequest, userInput) {
		var vehicleForm = userInput.vehicleForm,
			mainPolicyHolder = vehicleForm.mainPolicyHolder;

		if (mainPolicyHolder) {
			var policyHolders = [];
			mainPolicyHolder.policyContact =
				vehicleForm.mainPolicyHolderContact;
			if (mainPolicyHolder.isMainDriverMainPolicyHolder) {
				var driver = util.deepClone(
					transformedRequest.vehicles[0].drivers[0].driver
				);
				Object.extend(mainPolicyHolder, driver.person);
			}

			policyHolders.push(mainPolicyHolder);
			if (
				vehicleForm.additionalPolicyHolders &&
				vehicleForm.additionalPolicyHolders.policyHolders
			) {
				policyHolders = policyHolders.concat(
					vehicleForm.additionalPolicyHolders.policyHolders
				);
			}

			policyHolders.forEach(function(policyHolder, index) {
				var contact = util.deepClone(policyHolder);
				if (!transformedRequest.policyHolders[index])
					transformedRequest.policyHolders[index] = {};

				var transformedContact =
					transformedRequest.policyHolders[index];
				if (!contact.contactType)
					contact.contactType =
						'person'; /* TODO : check to make sure this condition is always safe to use */

				contact.prefix = contact.title;

				if (contact.policyContact) {
					Object.extend(contact, contact.policyContact);
					if (contact.primaryPhone == 'mobile')
						contact.cellPhone = contact.primaryPhoneNumber;
					else if (contact.primaryPhone == 'home')
						contact.homePhone = contact.primaryPhoneNumber;
					else if (contact.primaryPhone == 'work')
						contact.workPhone = contact.primaryPhoneNumber;

					delete contact.policyContact;
				}

				if (!contact.primaryAddress)
					contact.primaryAddress = util.clone(
						mainPolicyHolder.primaryAddress
					);

				if (index == 0) {
					if (!contact.isMainDriverMainPolicyHolder) {
						if (
							contact.fourYears_chargedOrConvictedOffences &&
							(!contact.fourYears_chargedOrConvictedOffencesDetails ||
								contact
									.fourYears_chargedOrConvictedOffencesDetails
									.length < 1)
						) {
							contact.fourYears_chargedOrConvictedOffences = false;
						}

						if (
							contact.fourYears_vehicleAccidentsClaims &&
							(!contact.fourYears_vehicleAccidentsClaimsDetails ||
								contact.fourYears_vehicleAccidentsClaimsDetails
									.length < 1)
						) {
							contact.fourYears_vehicleAccidentsClaims = false;
						}

						if (
							contact.fourYears_licenceRSDC &&
							(!contact.fourYears_licenceRSDCDetails.length ||
								contact.fourYears_licenceRSDCDetails.length < 1)
						) {
							contact.fourYears_licenceRSDC = false;
						}

						if (
							contact.tenYears_chargedOrConvictedOffences &&
							(!contact.tenYears_chargedOrConvictedOffencesDetails ||
								contact
									.tenYears_chargedOrConvictedOffencesDetails
									.length < 1)
						) {
							contact.tenYears_chargedOrConvictedOffences = false;
						}

						contact.drivingHistory = [];

						if (contact.fourYears_chargedOrConvictedOffences) {
							contact.drivingHistory = contact.drivingHistory.concat(
								contact.fourYears_chargedOrConvictedOffencesDetails.slice()
							);
						}

						if (contact.fourYears_vehicleAccidentsClaims) {
							contact.drivingHistory = contact.drivingHistory.concat(
								contact.fourYears_vehicleAccidentsClaimsDetails.slice()
							);
						}

						if (contact.fourYears_licenceRSDC) {
							contact.drivingHistory = contact.drivingHistory.concat(
								contact.fourYears_licenceRSDCDetails.slice()
							);
						}

						if (contact.tenYears_chargedOrConvictedOffences) {
							contact.drivingHistory = contact.drivingHistory.concat(
								contact.tenYears_chargedOrConvictedOffencesDetails.slice()
							);
						}

						contact.drivingHistory.forEach(function(dh) {
							if (dh.description) {
								dh.pattern = {
									publicID: '',
									description: '',
									code: '',
									filter1: ''
								};
								dh.pattern.publicID = dh.description.publicID;
								dh.pattern.description = dh.description.label;
								dh.pattern.code = dh.description.code;
								dh.pattern.filter1 = dh.description.filter1;

								dh.month = transposeMonth(dh.month.value);
								dh.year = dh.year.value;

								delete dh.description;
							}
						});
					}
				} else {
					if (
						contact.additionalPolicyHolderFourYears_chargedOrConvictedOffences &&
						(!contact.additionalPolicyHolderFourYears_chargedOrConvictedOffencesDetails ||
							contact
								.additionalPolicyHolderFourYears_chargedOrConvictedOffencesDetails
								.length < 1)
					) {
						contact.additionalPolicyHolderFourYears_chargedOrConvictedOffences = false;
					}

					if (
						contact.additionalPolicyHolderFourYears_vehicleAccidentsClaims &&
						(!contact.additionalPolicyHolderFourYears_vehicleAccidentsClaimsDetails ||
							contact
								.additionalPolicyHolderFourYears_vehicleAccidentsClaimsDetails
								.length < 1)
					) {
						contact.additionalPolicyHolderFourYears_vehicleAccidentsClaims = false;
					}

					if (
						contact.additionalPolicyHolderFourYears_licenceRSDC &&
						(!contact
							.additionalPolicyHolderFourYears_licenceRSDCDetails
							.length ||
							contact
								.additionalPolicyHolderFourYears_licenceRSDCDetails
								.length < 1)
					) {
						contact.additionalPolicyHolderFourYears_licenceRSDC = false;
					}

					if (
						contact.additionalPolicyHolderTenYears_chargedOrConvictedOffences &&
						(!contact.additionalPolicyHolderTenYears_chargedOrConvictedOffencesDetails ||
							contact
								.additionalPolicyHolderTenYears_chargedOrConvictedOffencesDetails
								.length < 1)
					) {
						contact.additionalPolicyHolderTenYears_chargedOrConvictedOffences = false;
					}

					contact.drivingHistory = [];

					if (
						contact.additionalPolicyHolderFourYears_chargedOrConvictedOffences
					) {
						contact.drivingHistory = contact.drivingHistory.concat(
							contact.additionalPolicyHolderFourYears_chargedOrConvictedOffencesDetails.slice()
						);
					}

					if (
						contact.additionalPolicyHolderFourYears_vehicleAccidentsClaims
					) {
						contact.drivingHistory = contact.drivingHistory.concat(
							contact.additionalPolicyHolderFourYears_vehicleAccidentsClaimsDetails.slice()
						);
					}

					if (contact.additionalPolicyHolderFourYears_licenceRSDC) {
						contact.drivingHistory = contact.drivingHistory.concat(
							contact.additionalPolicyHolderFourYears_licenceRSDCDetails.slice()
						);
					}

					if (
						contact.additionalPolicyHolderTenYears_chargedOrConvictedOffences
					) {
						contact.drivingHistory = contact.drivingHistory.concat(
							contact.additionalPolicyHolderTenYears_chargedOrConvictedOffencesDetails.slice()
						);
					}

					contact.drivingHistory.forEach(function(dh) {
						if (dh.description) {
							dh.pattern = {
								publicID: '',
								description: '',
								code: '',
								filter1: ''
							};
							dh.pattern.publicID = dh.description.publicID;
							dh.pattern.description = dh.description.label;
							dh.pattern.code = dh.description.code;
							dh.pattern.filter1 = dh.description.filter1;

							dh.month = transposeMonth(dh.month.value);
							dh.year = dh.year.value;

							delete dh.description;
						}
					});
				}

				contact.hasClaim =
					contact.fourYears_vehicleAccidentsClaims ||
					contact.additionalPolicyHolderFourYears_vehicleAccidentsClaims ||
					false;
				contact.hasConviction =
					contact.tenYears_chargedOrConvictedOffences ||
					contact.additionalPolicyHolderTenYears_chargedOrConvictedOffences ||
					false;

				if (!transformedContact.contact)
					transformedContact.contact = {};
				Object.extend(transformedContact.contact, contact);
			});
		} else if (
			transformedRequest.vehicles[0].drivers[0] &&
			transformedRequest.vehicles[0].drivers[0].driver &&
			transformedRequest.vehicles[0].drivers[0].driver.person
		) {
			var driver = transformedRequest.vehicles[0].drivers[0].driver;
			var contact = transformedRequest.policyHolders[0].contact;
			Object.extend(contact, driver.person);
			contact.contactType =
				'person'; /* TODO : check to make sure this condition is always safe to use */
		}
		transformedRequest.policyHolders[0].mainHolder = true;
		if (userInput.email) {
			/** required for saving/retrieving the policy */
			if (
				userInput.vehicleForm &&
				userInput.vehicleForm.tellUsABitMore &&
				userInput.vehicleForm.tellUsABitMore.yourEmailAddress
			) {
				transformedRequest.policyHolders[0].contact.emailAddress1 =
					userInput.vehicleForm.tellUsABitMore.yourEmailAddress;
			} else if (
				userInput.vehicleForm.mainPolicyHolderContact &&
				userInput.vehicleForm.mainPolicyHolderContact.emailAddress1
			) {
				transformedRequest.policyHolders[0].contact.emailAddress1 =
					userInput.vehicleForm.mainPolicyHolderContact.emailAddress1;
			} else {
				transformedRequest.policyHolders[0].contact.emailAddress1 =
					userInput.email;
			}
		} else {
			if (
				userInput.vehicleForm.tellUsABitMore &&
				userInput.vehicleForm.tellUsABitMore.yourEmailAddress
			) {
				if (transformedRequest.policyHolders[0].contact.emailAddress1) {
					//use the existing if available
				} else {
					transformedRequest.policyHolders[0].contact.emailAddress1 =
						userInput.vehicleForm.tellUsABitMore.yourEmailAddress;
				}
			}
		}

		if (
			userInput.vehicleForm &&
			userInput.vehicleForm.mainPolicyHolderContact &&
			userInput.vehicleForm.mainPolicyHolderContact
				.personalContactDetailsMailingPreference
		) {
			transformedRequest.documentDeliveryMethod =
				userInput.vehicleForm.mainPolicyHolderContact.personalContactDetailsMailingPreference;
			delete transformedRequest.policyHolders[0].contact
				.personalContactDetailsMailingPreference;
		}

		return transformedRequest;
	}

	function updateDrivers(transformedRequest, userInput) {
		transformedRequest.vehicles[0].drivers = [];
		if (
			userInput.vehicleForm.driver &&
			userInput.vehicleForm.driver.drivers
		) {
			userInput.vehicleForm.driver.drivers.forEach(function(driver) {
				driver.person.contactType = 'person';
				driver.person.prefix = driver.person.title;
				driver.hasClaim = driver.person.hasClaim =
					driver.fourYears_vehicleAccidentsClaims;
				driver.hasInfringement =
					driver.fourYears_chargedOrConvictedOffences;
				driver.hasLostLicence = driver.fourYears_licenceRSDC;
				driver.hasConviction = driver.person.hasConviction =
					driver.tenYears_chargedOrConvictedOffences;
				driver.zeroDemerits = driver.NSWDemeritPoints;
				//driver.yearsLicenced = driver.yearsHeld ;

				driver.person.primaryAddress = transformedRequest.policyAddress;
				driver.person.primaryAddress.addressType =
					transformedRequest.vehicleForm.getStarted
						.personOrCompany === 'company'
						? 'business'
						: 'residential';

				switch (driver.yearsHeld) {
					case 'lessThan_1':
						driver.yearsLicenced = '7';
						break;
					case 'greaterThan_5':
						driver.yearsLicenced = '6';
						break;
					default:
						driver.yearsLicenced = driver.yearsHeld;
				}

				if (
					driver.fourYears_chargedOrConvictedOffences &&
					(!driver.fourYears_chargedOrConvictedOffencesDetails ||
						driver.fourYears_chargedOrConvictedOffencesDetails
							.length < 1)
				) {
					driver.fourYears_chargedOrConvictedOffences = false;
				}

				if (
					driver.fourYears_vehicleAccidentsClaims &&
					(!driver.fourYears_vehicleAccidentsClaimsDetails ||
						driver.fourYears_vehicleAccidentsClaimsDetails.length <
							1)
				) {
					driver.fourYears_chargedOrConvictedOffences = false;
				}

				if (
					driver.fourYears_licenceRSDC &&
					(!driver.fourYears_licenceRSDCDetails.length ||
						driver.fourYears_licenceRSDCDetails.length < 1)
				) {
					driver.fourYears_licenceRSDC = false;
				}

				if (
					driver.tenYears_chargedOrConvictedOffences &&
					(!driver.tenYears_chargedOrConvictedOffencesDetails ||
						driver.tenYears_chargedOrConvictedOffencesDetails
							.length < 1)
				) {
					driver.tenYears_chargedOrConvictedOffences = false;
				}

				driver.driverHistory = [];

				if (driver.fourYears_chargedOrConvictedOffences) {
					driver.driverHistory = driver.driverHistory.concat(
						driver.fourYears_chargedOrConvictedOffencesDetails.slice()
					);
				}

				if (driver.fourYears_vehicleAccidentsClaims) {
					driver.driverHistory = driver.driverHistory.concat(
						driver.fourYears_vehicleAccidentsClaimsDetails.slice()
					);
				}

				if (driver.fourYears_licenceRSDC) {
					driver.driverHistory = driver.driverHistory.concat(
						driver.fourYears_licenceRSDCDetails.slice()
					);
				}

				if (driver.tenYears_chargedOrConvictedOffences) {
					driver.driverHistory = driver.driverHistory.concat(
						driver.tenYears_chargedOrConvictedOffencesDetails.slice()
					);
				}

				driver.driverHistory.forEach(function(dh) {
					dh.pattern = {
						publicID: '',
						description: '',
						code: '',
						filter1: ''
					};
					dh.pattern.publicID = dh.description.publicID;
					dh.pattern.description = dh.description.label;
					dh.pattern.code = dh.description.code;
					dh.pattern.filter1 = dh.description.filter1;

					dh.month = transposeMonth(dh.month.value);
					dh.year = dh.year.value;

					delete dh.description;
				});

				var driverObj = {
					driver: driver
				};

				// var toDelete = isItemMarkedForDelete('driver', driver) ;
				// if (toDelete) driverObj.markedForDelete = true ;

				transformedRequest.vehicles[0].drivers.push(driverObj);
			});

			transformedRequest.vehicles[0].drivers[0].driverUsage = 'main';
		} else {
			transformedRequest.vehicles[0].drivers = [
				{
					driverUsage: 'main'
				}
			];
		}

		if (userInput.email) {
			/** required for saving/retrieving the policy */
			if (
				angular.isDefined(
					transformedRequest.vehicles[0].drivers[0].driver
				)
			) {
				if (
					userInput.vehicleForm.tellUsABitMore &&
					userInput.vehicleForm.tellUsABitMore.yourEmailAddress
				) {
					transformedRequest.vehicles[0].drivers[0].driver.person.emailAddress1 =
						userInput.vehicleForm.tellUsABitMore.yourEmailAddress;
				} else if (
					userInput.vehicleForm.mainPolicyHolderContact &&
					userInput.vehicleForm.mainPolicyHolderContact.emailAddress1
				) {
					transformedRequest.vehicles[0].drivers[0].driver.person.emailAddress1 =
						userInput.vehicleForm.mainPolicyHolderContact.emailAddress1;
				} else {
					transformedRequest.vehicles[0].drivers[0].driver.person.emailAddress1 =
						userInput.email;
				}
			}
		} else {
			if (
				userInput.vehicleForm.tellUsABitMore &&
				userInput.vehicleForm.tellUsABitMore.yourEmailAddress
			) {
				if (
					transformedRequest.vehicles[0].drivers[0].driver.person
						.emailAddress1
				) {
					//use the existing if available
				} else {
					transformedRequest.vehicles[0].drivers[0].driver.person.emailAddress1 =
						userInput.vehicleForm.tellUsABitMore.yourEmailAddress;
				}
			}
		}

		return transformedRequest;
	}

	function updateVehicleRegoDetails(transformedRequest, userInput) {
		var aboutYourCar = userInput.vehicleForm.aboutYourCar,
			tellUsYourRegoNumber = userInput.vehicleForm.tellUsYourRegoNumber,
			regoNumber = null;

		if (aboutYourCar && aboutYourCar.regoDetails) {
			regoNumber = aboutYourCar.regoDetails.regoNumber;
		} else if (tellUsYourRegoNumber && tellUsYourRegoNumber.regoNumber) {
			regoNumber = tellUsYourRegoNumber.regoNumber;
		}

		transformedRequest.vehicles[0].registrationNumber = regoNumber;
		return transformedRequest;
	}

	function updateAdditionalDrivers(transformedRequest, userInput) {
		var fromRapidEstimate = !userInput.fromFullQuote,
			driver = userInput.vehicleForm.driver,
			drivers = driver ? driver.drivers : null,
			/** required for when checking decline on step 1 */
			youngestDriver = null;

		if (!driver) return transformedRequest;

		var rapidEstimateYoungerDriver =
			fromRapidEstimate &&
			driver.youngestDriver &&
			driver.numberOfOtherDrivers > 0;
		if (!rapidEstimateYoungerDriver)
			youngestDriver = findYoungestDriver(drivers);

		transformedRequest.vehicles[0].youngestDriverGender = rapidEstimateYoungerDriver
			? driver.youngestDriverGender /** value from rapid estimate */
			: youngestDriver
			? youngestDriver.person.gender
			: null; /** value from full quote */

		transformedRequest.vehicles[0].otherDriverHasProLicense = fromRapidEstimate
			? driver.provisionalLicence /** value from rapid estimate */
			: youngestDriver
			? youngestDriver.licenceType == 'provisional'
			: false; /** value from full path */

		transformedRequest.vehicles[0].youngestDriverDOB = rapidEstimateYoungerDriver
			? driver.youngestDriverDob
			: youngestDriver
			? youngestDriver.person.dateOfBirth
			: null;

		transformedRequest.vehicles[0].otherDriverUsageTimes = fromRapidEstimate
			? numberOfOtherDrivers(
					driver.numberOfOtherDrivers
			  ) /* value from rapid estimate */
			: drivers.length - 1; /* value from full quote */

		return transformedRequest;
	}

	function numberOfOtherDrivers(num) {
		return num == 6 ? '5plus' : '' + num;
	}

	function updateMainDriverAddress(transformedRequest, userInput) {
		var phs = transformedRequest.policyHolders,
			ph = phs ? phs[0] : null,
			contact = ph ? ph.contact : null,
			phAddress = contact ? contact.primaryAddress : null;

		phAddress = phAddress || transformedRequest.policyAddress;

		return applyAddressForGoodDriverBonus(transformedRequest, phAddress);
	}

	/**
	 * setting the policy contact address on the main driver.
	 * This is required for good driver bonus discount to come through
	 */
	function applyAddressForGoodDriverBonus(transformedRequest, address) {
		if (
			transformedRequest.vehicles[0].drivers[0] &&
			transformedRequest.vehicles[0].drivers[0].driver &&
			transformedRequest.vehicles[0].drivers[0].driver.person
		) {
			transformedRequest.vehicles[0].drivers[0].driver.person.primaryAddress = address;

			if (
				transformedRequest.vehicleForm.getStarted.personOrCompany ===
					'company' &&
				transformedRequest.postalAddress !== null
			) {
				transformedRequest.vehicles[0].drivers[0].driver.person.primaryAddress =
					transformedRequest.postalAddress;
			}
			if (angular.isDefined(transformedRequest.vehicleForm)) {
				/****************************************************************************
				 * address is default to be residential to enable good driver bonus discount
				 * Check Transformed request if come from vehicle form
				 * Added Fallback to use the default values as residential
				 ***************************************************************************/
				// Added checking for business Address Type to be able to include to good driver discount
				transformedRequest.vehicles[0].drivers[0].driver.person.primaryAddress.addressType =
					transformedRequest.vehicleForm.getStarted
						.personOrCompany === 'company'
						? 'business'
						: 'residential';
			} else {
				transformedRequest.vehicles[0].drivers[0].driver.person.primaryAddress.addressType =
					'residential';
			}
		} else {
			if (angular.isDefined(transformedRequest.vehicleForm)) {
				// Replace Address Type via personOrCompany value
				transformedRequest.policyAddress.addressType =
					transformedRequest.vehicleForm.getStarted
						.personOrCompany === 'company'
						? 'business'
						: 'residential';
			}
		}

		if (transformedRequest.postalAddress !== null) {
			transformedRequest.postalAddress.addressType = transformedRequest.policyAddress.addressType =
				'postal';
		}
		return transformedRequest;
	}

	function findYoungestDriver(drivers) {
		var youngest = null;
		drivers.forEach(function(driver) {
			if (!youngest) youngest = driver;
			else if (isYounger(driver, youngest)) youngest = driver;
		});

		function isYounger(driver, otherDriver) {
			return (
				moment(driver.person.dateOfBirth, 'DD/MM/YYYY') >
				moment(otherDriver.person.dateOfBirth, 'DD/MM/YYYY')
			);
		}

		return youngest;
	}

	function updateVehicleInsuranceTypeAndAmount(
		transformedRequest,
		userInput
	) {
		var insuredExcessValue = userInput.vehicleForm.insuredExcessValue;
		if (insuredExcessValue) {
			transformedRequest.vehicles[0].sumInsuredType =
				insuredExcessValue.comprehensivePref;
			if (insuredExcessValue.comprehensivePref == 'agreed') {
				transformedRequest.vehicles[0].sumInsuredAmount =
					insuredExcessValue.agreedValue;
			} else if (quoteOptions.getSelectedQuoteResult()) {
				transformedRequest.vehicles[0].sumInsuredAmount = quoteOptions
					.getSelectedQuoteResult()
					.getAnnual().vehicleValue.lower;
			}
		}
		return transformedRequest;
	}

	function updateVehicleInsuranceOptionalBenefits(
		transformedRequest,
		userInput
	) {
		var optionalBenefits = userInput.vehicleForm.optionalBenefits;
		var coverageOptions = [];
		if (optionalBenefits) {
			for (var key in optionalBenefits) {
				coverageOptions.push({
					name: key,
					selected: optionalBenefits[key],
					required: false
				});
			}
			transformedRequest.vehicles[0].coverageOptions = coverageOptions;
		}
		return transformedRequest;
	}

	function updateModificationOptions(transformedRequest, userInput) {
		var carDetails = userInput.vehicleForm.carDetails;

		if (carDetails) {
			var modifications = carDetails.modifications;

			if (modifications) {
				var mods = carDetails.modificationsOptions,
					vehicleInfo = transformedRequest.vehicles[0].vehicleInfo;

				if (mods && vehicleInfo && vehicleInfo.optionalEquipments) {
					var selectedEquipments = vehicleInfo.optionalEquipments.slice();
					var modsKeys = Object.keys(mods);
					// need to do a look up to find code,optionKey and description from optionalEquipments
					selectedEquipments = selectedEquipments.filter(function(
						eq
					) {
						return modsKeys.indexOf(eq.optionKey) !== -1;
					});
					vehicleInfo.selectedEquipments = selectedEquipments;
				}
			}
		}

		return transformedRequest;
	}

	function updateAfterMarketModifications(transformedRequest, userInput) {
		var carDetails = userInput.vehicleForm.carDetails;
		if (carDetails) {
			var modificationsBuilt = carDetails.modificationsBuilt;

			if (modificationsBuilt) {
				var mods = carDetails.modificationsBuiltOptions;

				if (mods) {
					afterMarketMods = [];

					for (var key in mods) {
						if (mods[key] === true) {
							afterMarketMods.push(key);
						}
					}
					transformedRequest.vehicles[0].afterMarketMods = afterMarketMods;
				}
			}
		}
		return transformedRequest;
	}

	function updateExistingDamage(transformedRequest, userInput) {
		var carDetails = userInput.vehicleForm.carDetails,
			existingDamage = carDetails ? carDetails.existingDamage : null;

		if (existingDamage) {
			transformedRequest.vehicles[0].unrepairedDamage = existingDamage;
			if (existingDamage != 'none') {
				/** do we have to set this to agree and set sumInsured to Salvage value ??? */
				if (carDetails.salvageValue) {
					transformedRequest.vehicles[0].sumInsuredType = 'agreed';
					transformedRequest.vehicles[0].sumInsured =
						carDetails.salvageValue;
					transformedRequest.vehicles[0].evidenceOfValueOrPrice =
						carDetails.writtenEvidence;
				}
			}
		}

		return transformedRequest;
	}

	function updateFinanceType(transformedRequest, userInput) {
		var carDetails = userInput.vehicleForm.carDetails,
			carFinance = carDetails ? carDetails.carFinance : 'none';
		// , financeWith = carDetails.financeWith ? carDetails.financeWith : null;

		if (carDetails) {
			if (carDetails.financeWith) {
				financeWith = carDetails.financeWith;
			} else {
				financeWith = null;
			}
		} else {
			financeWith = null;
		}

		if (carFinance) {
			transformedRequest.vehicles[0].financeType = carFinance;

			if (
				financeWith &&
				financeWith.hasOwnProperty('label') &&
				financeWith.hasOwnProperty('value')
			) {
				transformedRequest.vehicles[0].financeCompany = {};

				transformedRequest.vehicles[0].financeCompany.name =
					financeWith.label;
				transformedRequest.vehicles[0].financeCompany.publicID =
					financeWith.value;
			}
		}

		return transformedRequest;
	}

	function updateRecentPurchase(transformedRequest, userInput) {
		var carDetails = userInput.vehicleForm.carDetails,
			last12Months = carDetails ? carDetails.last12Months : false,
			carCost = last12Months ? carDetails.carCost : null;

		if (last12Months) {
			transformedRequest.vehicles[0].recentPurchase = last12Months;

			if (carCost) {
				transformedRequest.vehicles[0].purchasePrice = carCost;
			}
		}

		return transformedRequest;
	}

	//updates the email
	function updateEmail(transformedRequest, userInput) {
		if (
			userInput.vehicleForm &&
			userInput.vehicleForm.tellUsABitMore &&
			userInput.vehicleForm.tellUsABitMore.yourEmailAddress
		) {
			transformedRequest.email =
				userInput.vehicleForm.tellUsABitMore.yourEmailAddress;
		} else {
			//set email from maincontact if not available in tellUsABitMore
			if (
				userInput.vehicleForm &&
				userInput.vehicleForm.mainPolicyHolderContact &&
				userInput.vehicleForm.mainPolicyHolderContact.emailAddress1
			) {
				transformedRequest.email =
					userInput.vehicleForm.mainPolicyHolderContact.emailAddress1;
			}
		}

		// send the campaign code to GW
		if (
			userInput.vehicleForm &&
			userInput.vehicleForm.tellUsABitMore &&
			userInput.vehicleForm.tellUsABitMore.promotionalCode
		) {
			transformedRequest.campaignCode =
				userInput.vehicleForm.tellUsABitMore.promotionalCode;
		}

		return transformedRequest;
	}

	function updateStampDutyEligibility(transformedRequest, userInput) {
		var stampDutyEligible = storage.getItem('stamp-duty');
		if (userInput.vehicleForm.stampDutyExemption && stampDutyEligible) {
			transformedRequest.vehicles[0].isSmallBusiness =
				userInput.vehicleForm.stampDutyExemption.isSmallBusiness;
		} else {
			delete transformedRequest.vehicles[0].isSmallBusiness;
		}
		return transformedRequest;
	}

	// function isItemMarkedForDelete(typeName, item) {
	// 	var toRemove = aggregatedRemoveService.getList();
	// 	var itemsToRemove = toRemove[typeName] || [];
	// 	var removeItem = false ;
	// 	itemsToRemove.some(function(itemToRemove) {
	// 		if ( itemToRemove._aggregator.id == item._aggregator.id){
	// 			removeItem = true;
	// 			return;
	// 		}
	// 	});
	// 	return removeItem;
	// }

	function updatePolicyAddress(transformedRequest, userInput) {
		var postalAddress = storage.getItem('policy-address');

		if (
			angular.isDefined(userInput.vehicleForm.mainPolicyHolderContact) ||
			angular.isDefined(userInput.vehicleForm.companyContact)
		) {
			if (transformedRequest.postalAddress !== null) {
				transformedRequest.policyAddress =
					transformedRequest.postalAddress;
			} else {
				var isPostalOption = true;
				if (
					userInput.vehicleForm.getStarted.personOrCompany == 'person'
				) {
					isPostalOption =
						userInput.vehicleForm.mainPolicyHolderContact
							.postalOption;
				} else {
					isPostalOption =
						userInput.vehicleForm.companyContact.postalOption;
				}

				if (Object.keys(postalAddress).length > 0 && !isPostalOption) {
					transformedRequest.policyAddress = postalAddress;
				}
			}
		} else {
			if (Object.keys(postalAddress).length > 0) {
				transformedRequest.policyAddress = postalAddress;
			}
		}

		delete transformedRequest.postalAddress;
		delete transformedRequest.mainContactAddress;
		return transformedRequest;
	}

	function transform(userInput) {
		var transformedRequest = jsonMapper.transform(
			userInput,
			structureQuoteMapping
		);
		transformedRequest = updateVehicleDetails(
			transformedRequest,
			userInput
		);
		transformedRequest = updateVehicleRegoDetails(
			transformedRequest,
			userInput
		);
		transformedRequest = updateStampDutyEligibility(
			transformedRequest,
			userInput
		);
		transformedRequest = updateDrivers(transformedRequest, userInput);
		transformedRequest = updateAdditionalDrivers(
			transformedRequest,
			userInput
		);
		transformedRequest = updatePolicyHolders(transformedRequest, userInput);
		transformedRequest = updateMainDriverAddress(
			transformedRequest,
			userInput
		);
		transformedRequest = updateVehicleInsuranceTypeAndAmount(
			transformedRequest,
			userInput
		);
		transformedRequest = updateVehicleInsuranceOptionalBenefits(
			transformedRequest,
			userInput
		);
		transformedRequest = updateAfterMarketModifications(
			transformedRequest,
			userInput
		);
		transformedRequest = updateModificationOptions(
			transformedRequest,
			userInput
		);
		transformedRequest = updateExistingDamage(
			transformedRequest,
			userInput
		);
		transformedRequest = updateFinanceType(transformedRequest, userInput);
		transformedRequest = updateRecentPurchase(
			transformedRequest,
			userInput
		);
		transformedRequest = updateEmail(transformedRequest, userInput);
		transformedRequest = updatePolicyAddress(transformedRequest, userInput);
		return transformedRequest;
	}

	function transposeMonth(monthName) {
		var months = {
			January: '01',
			February: '02',
			March: '03',
			April: '04',
			May: '05',
			June: '06',
			July: '07',
			August: '08',
			September: '09',
			October: '10',
			November: '11',
			December: '12'
		};

		return months[monthName];
	}

	return {
		transform: transform
	};
}

function CaravanCleanRequestTransformer(Util, jsonMapper) {

	function transform(intermediateRequest, userInput) {
		delete intermediateRequest.caravanForm;

		var caravan = intermediateRequest.caravans[0];
		var policyHolders = intermediateRequest.policyHolders[0];

		delete caravan.cost;
		delete caravan.existingDamage;
		delete caravan.financeWith;
		delete caravan.finance;
		delete caravan.regoNumber;
		delete caravan.sumInsuredAmount;
		delete caravan.whenDidYouBuyMonth;
		delete caravan.whenDidYouBuyYear;
		delete caravan.security;
		delete caravan.locationDescription;
		delete caravan.primaryUse;
		delete caravan.vehicleSubType;

		// Remove the subtype if the vehicle is any of these types
		if ( caravan.caravanType !== 'caravan' && caravan.caravanType !== 'campertrailer' && caravan.caravanType !== 'goodscarryingtrailer' ) {
			delete caravan.caravanSubType;
		}

		if ( caravan.drivers ) {
			caravan.drivers.forEach(function(policyDriver) {
				delete policyDriver.driver._HTMLID;
				delete policyDriver.driver.$$hashKey;
				delete policyDriver.driver._aggregator;

				delete policyDriver.driver.maxNoClaimBonus;
				delete policyDriver.driver.title;
				delete policyDriver.driver.yearsHeld;
				delete policyDriver.driver.fourYears_chargedOrConvictedOffences;
				delete policyDriver.driver.fourYears_chargedOrConvictedOffencesDetails;
				delete policyDriver.driver.fourYears_licenceRSDC;
				delete policyDriver.driver.fourYears_licenceRSDCDetails;
				delete policyDriver.driver.fourYears_vehicleAccidentsClaims;
				delete policyDriver.driver.fourYears_vehicleAccidentsClaimsDetails;
				delete policyDriver.driver.tenYears_chargedOrConvictedOffences;
				delete policyDriver.driver.tenYears_chargedOrConvictedOffencesDetails;

				/**
				* Guidewire creates duplicate records of other drivers criminal histories
				* if the driverHistory is sent as an empty array :)
				* For now this has been commented out and moved to PublicIDTransformer as that
				* is creating an array when going through and transforming public ID's for a list.  This behaviour should be changed for empty lists.
				* After changing that, this can be commented back in and removed from publicIDTransformer.
				if ( policyDriver.driver.driverHistory
					&& Array.isArray(policyDriver.driver.driverHistory)
					&& policyDriver.driver.driverHistory.length == 0 )
					delete policyDriver.driver.driverHistory;
				*/
			});
		};

		if ( policyHolders.contact ) {
			delete policyHolders.contact._HTMLID;
			delete policyHolders.contact.$$hashKey;
			delete policyHolders.contact._aggregator;

			delete policyHolders.contact.anyInfringements;
			delete policyHolders.contact.anyLostLicences;
			delete policyHolders.contact.mainPolicyHolder;

			delete policyHolders.contact.fourYears_chargedOrConvictedOffences;
			delete policyHolders.contact.fourYears_chargedOrConvictedOffencesDetails;
			delete policyHolders.contact.fourYears_licenceRSDC;
			delete policyHolders.contact.fourYears_licenceRSDCDetails;
			delete policyHolders.contact.fourYears_bikeAccidentsClaims;
			delete policyHolders.contact.fourYears_bikeAccidentsClaimsDetails;
			delete policyHolders.contact.tenYears_chargedOrConvictedOffences;
			delete policyHolders.contact.tenYears_chargedOrConvictedOffencesDetails;
		}



		if ( ! intermediateRequest.email )
			delete intermediateRequest.email ;

		return intermediateRequest;
	}

	return {
		transform: transform
	}
}

function CaravanCoverTypeTransformer(jsonMapper, util, quoteOptions) {
	function transform(intermediateRequest, coverTypeDescriptor) {

		intermediateRequest.caravans[0].coverType =  coverTypeDescriptor;

		return intermediateRequest;
	}

	return {
		transform: transform
	}
}

function CaravanDefaultValueRequestTransformer(Util, jsonMapper, userInputRepository, quoteOptions) {

	function formatDateAndTimeTheGuidewireWay(date, time) {
		var format = "{0} at {1} AEST" ;
		var timeFormatted = '4:00PM' ;
		if ( time )
			timeFormatted = moment().tz("Australia/Sydney").format('h:mma');
		return Util.stringFormat(format, moment().tz("Australia/Sydney").format('Do MMM YYYY') , timeFormatted) ;
	}

	var staticValuesMapping = {
		"quoteType": 'Full',
		"productCode": 'QPCCaravanTrailer',
		"caravans.0.financeType": "none",
		"caravans.0.sumInsuredType": "agreed",
		"caravans.0.garageType": "garage",
		"caravans.0.coverType": "comprehensive",
		"caravans.0.specifiedContents": false,
		"caravans.0.existingDamageType": "nodamage",
		"caravans.0.hasCurrentInsurance": false,
		"caravans.0.isEligibleforSDExemption": false,		
		"caravans.0.isCaravanRegistered": true,
		"caravans.0.isCycloneRatedSecurity": false,
		"caravans.0.locationType": "residentialaddress",
		"caravans.0.securityType": "garage",
		"caravans.0.registrationNumber": "RAPID_QUOTE_REGNUMBER",
		"caravans.0.chassisNumber": "Not Supplied",
		"caravans.0.isCaravanOnNonRetractableJacks": false,
		"caravans.0.isCaravanConnectedToPlumbing": false,
		"caravans.0.isPermResidence": false,
		"caravans.0.caravanUsageType": "private",
		"caravans.0.contentsCover": true,
		"caravans.0.purchaseMonthYear": moment().tz("Australia/Sydney").format('YYYY-MM'),
		"caravans.0.yearsContinuousInsurance": "0",
		"caravans.0.garageAddress.addressType": "postal",
		"caravans.0.drivers.*.driver.licenceType": "full",
		"caravans.0.drivers.*.driver.yearsLicenced": "6",
		"caravans.0.drivers.*.driver.hasConviction": false,
		"caravans.0.drivers.*.driver.hasClaim": false,
		"caravans.0.drivers.*.driver.hasInfringement": false,
		"caravans.0.drivers.*.driver.hasLostLicence": false,
		"caravans.0.drivers.*.driver.zeroDemerits": true ,
		"caravans.0.drivers.*.driver.previousInsurer": "none",
		"caravans.0.drivers.*.driver.person.contactType": "person",
		"caravans.0.drivers.*.driver.person.gender": "male",
		"caravans.0.drivers.*.driver.person.firstName": "An@n",
		"caravans.0.drivers.*.driver.person.lastName": "An@nym@us",
		"caravans.0.drivers.*.driver.person.isJustInsured": false,
		"caravans.0.drivers.*.driver.person.dateOfBirth": "01/06/2000",
		"caravans.0.availableCoverTypes" : [
          "comprehensive"
        ],
		"availableSumInsuredTypes": [
          "market",
          "agreed"
        ],
		"caravans.0.excess.standardVehicleExcess": 650,
	    "caravans.0.excess.ageExcessTier1": 1000,
	    "caravans.0.excess.ageExcessTier2": 750,
	    "caravans.0.excess.undeclaredDriverTier2": 500,
	    "caravans.0.excess.inexperiencedDriver": 750,
		"policyHolders.0.mainHolder": true,
		"policyHolders.0.contact.isJustInsured": false,
		"policyHolders.0.contact.contactType": "person",
		"policyHolders.0.contact.dateOfBirth": "01/06/2000",
		// full quote transformation :
        "status" : "Draft",
		"documentDeliveryMethod": 'email',
		"displayStatus": 'Draft',
		"periodStartDateTimeAEDT": formatDateAndTimeTheGuidewireWay(moment(), moment()),
		"periodEndDateTimeAEDT" : formatDateAndTimeTheGuidewireWay(moment().add(1,'years')),
		"channel": 'portal',
		"caravans.0.drivers.*.driverUsage" : "other",
	}

	function transform(intermediateRequest, userInput) {
		var staticValuesMappingNew = ApplyDefaultExcess(userInput);
		var transformedRequest = jsonMapper.setDefault(userInput, staticValuesMappingNew) ;
		return transformedRequest;
	}

	function ApplyDefaultExcess(userInput) {
		var staticValuesMappingNew  = staticValuesMapping;
		var excessValue = quoteOptions.getStateDefaultVoluntaryExcess(userInput.policyAddress.state);
		if(excessValue != null){
			var tempObj = {"caravans.0.excess.voluntaryVehicleExcess": excessValue};
			staticValuesMappingNew = Object.extend(staticValuesMapping, tempObj);
		}
		return staticValuesMappingNew;
	}

	return {
		transform: transform
	}
}

function CaravanFormatConverterTransformer(Util, jsonMapper) {

	function convertDateAndTimeTheGuidewireWay(dateTime) {
		var format = "{0} at {1} AEST" ;
		return Util.stringFormat(format, dateTime.format('Do MMM YYYY') , dateTime.format('h:mma')) ;
	}

	function convertDate(dateString) {
		var date = moment(dateString, 'DD/MM/YYYY') ;
		var formattedDate = date.format('YYYY-MM-DD') ;
		if ( formattedDate != "Invalid date")
			return formattedDate;


		// throw 'date format exception formatting ' + dateString ;
		return null;
	}

	function convertDateToGWTimeZone(dateString) {
		var formattedDate = moment(dateString,'DDMMYYYY').tz("Australia/Sydney").format('YYYY-MM-DD') ;
		if ( formattedDate != "Invalid date")
			return formattedDate;

		return null;
	}

	function convertGender(gender) {
		var gc = {
			male : 'M',
			female : 'F',
			intersex : 'I',
		};

		return gc[gender] ;
	}

	function convertLengthUnits(inUnit) {
		var units = {
			feet : 'ft',
			metres : 'm',
		};

		return units[inUnit] ;
	}

	function convertFalsyToUnknown(value) {
		if ( value === null || value === undefined )
			return 'unknown';

		return convertBooleanToYesNo(value) ;
	}

	function convertBooleanToYesNo(value) {
		return value ? 'yes' : 'no' ;
	}

	function convertStringToInt(value) {
		return !!value ? parseInt(value) : value;
	}

	function convertIntToString(value) {
		return !!value ? value.toString() : value;
	}

	function convertYearsContinuousInsurance(value) {
		return value === '3+' ? 4 : value;
	}


	var convertValueMapping = {
		'periodStartDate': convertDateToGWTimeZone,

		'policyHolders.*.contact.gender' : convertGender,
		'policyHolders.*.contact.hasClaim' : convertFalsyToUnknown,
		'policyHolders.*.contact.hasConviction' : convertFalsyToUnknown,
		'policyHolders.*.contact.anyLostLicences' : convertFalsyToUnknown,
		'policyHolders.*.contact.anyInfringements' : convertFalsyToUnknown,
		'policyHolders.*.contact.dateOfBirth' : convertDate,

		'caravans.0.caravanInfo.weight' : convertIntToString,
		'caravans.0.caravanInfo.caravanLength' : convertIntToString,
		'caravans.0.caravanInfo.lengthUnits' : convertLengthUnits,
		'caravans.0.timeSinceLastClaim' : convertIntToString,

		'caravans.0.drivers.*.driver.person.dateOfBirth' : convertDate,
		'caravans.0.drivers.*.driver.person.gender' : convertGender,
		"caravans.0.drivers.*.driver.hasConviction": convertFalsyToUnknown,
		"caravans.0.drivers.*.driver.person.hasConviction": convertBooleanToYesNo,
		"caravans.0.drivers.*.driver.hasClaim": convertFalsyToUnknown,
		"caravans.0.drivers.*.driver.person.hasClaim": convertBooleanToYesNo,
		"caravans.0.drivers.*.driver.hasLostLicence": convertFalsyToUnknown,
		"caravans.0.drivers.*.driver.hasInfringement": convertFalsyToUnknown,

		"caravans.0.yearsContinuousInsurance": convertYearsContinuousInsurance,
	};

	function transform(intermediateRequest, userInput) {
		var transformedRequest = jsonMapper.convert(intermediateRequest, convertValueMapping) ;
		return transformedRequest;
	}

	return {
		transform: transform
	}
}

function CaravanPolicyHolderHandler(Util, publicIDTransformer) {

	
	function handle(quoteRequest, userInput) {
		var mainPolicyholder = quoteRequest.policyHolders.filter(function (item) {
            return item['mainHolder'];
        })[0];

        var mainDriver = quoteRequest.caravans[0].drivers.filter(function (item) {
            return item['driverUsage'] == 'main';
        })[0];

        if ((!userInput.caravanForm.mainPolicyHolder ||
        (userInput.caravanForm.mainPolicyHolder && userInput.caravanForm.mainPolicyHolder.isMainDriverMainPolicyHolder))) {
            mainPolicyholder.contact.publicID = mainDriver.driver.person.publicID;
        } else if (userInput.caravanForm.mainPolicyHolder != undefined && userInput.caravanForm.mainPolicyHolder.isMainDriverMainPolicyHolder != undefined &&
                        !userInput.caravanForm.mainPolicyHolder.isMainDriverMainPolicyHolder &&
                        mainPolicyholder.contact.publicID == mainDriver.driver.person.publicID) {
            quoteRequest = publicIDTransformer.transform(quoteRequest);
            delete quoteRequest.secret;
            delete quoteRequest.quoteID;
        }

        if (mainPolicyholder.contact.publicID == mainDriver.driver.person.publicID) {
            mainDriver.driver.person.passwordQuestion = mainPolicyholder.contact.passwordQuestion;
            mainDriver.driver.person.passwordAnswer = mainPolicyholder.contact.passwordAnswer;
            mainDriver.driver.person.primaryPhone = mainPolicyholder.contact.primaryPhone;
            
			switch (mainPolicyholder.contact.primaryPhone) {
				case 'mobile':
					mainDriver.driver.person.cellPhone = mainPolicyholder.contact.cellPhone;
					break;
				case 'home':
					mainDriver.driver.person.homePhone = mainPolicyholder.contact.homePhone;
					break;
				case 'work':
					mainDriver.driver.person.workPhone = mainPolicyholder.contact.workPhone;
					break;
            }
            
            delete mainPolicyholder.contact.drivingHistory;
        }

        return quoteRequest;
	}

    return {
		handle: handle
	}
};
"use strict";

function CaravanPublicIDTransformer(Util, jsonMapper, serviceResponseRepository, aggregatedRemoveService) {

	var currentResponse = null;
	var driverUniqueIdCtr = 1;
	var historyUniqueIdCtr = 1;

	function forgePublicId(moduleName) {
		return Util.stringFormat('portal:{0}-{1}', moduleName, Util.generateRandomString(15));
	}

	function hasValidGWPublicID(publicID) {
		if (publicID && publicID.indexOf('portal:') === -1)
			return true;

		return false;
	}

	function hash(value) {
		return md5(value);
	}

	function fetchFromPreviousResponse(path) {
		if (currentResponse)
			return Util.findHierarchyStringInObject(currentResponse, path, '.');

		return null;
	}


	function convertPublicID(path, moduleName) {
		if (currentResponse) {
			var lastPublicID = fetchFromPreviousResponse(path);
			if (lastPublicID)
				return lastPublicID;
		}

		return forgePublicId(moduleName);
	}


	var moduleNameMapping = {
		'policyHolders': 'PolicyHolder[]',
		'policyAddress': 'Address',
		'caravan': "QPCCaravanTrailer",
		'driver': 'QPCVehicleDriver',
		'policyDriver': 'QPCPolicyDriver',
		'person': 'Person',
		'contentsItems': 'QPCSpecifiedItem',
		'coverageOptions': 'QPCLayupCover',
		'driverHistory': "QPCDriverHistory",
		"pattern": "qbePattern"
	};

	var publicIDTransformationMapping = {
		"policyAddress.publicID": function () {
			return forgePublicId(moduleNameMapping.policyAddress)
		},
		"caravans.0.publicID": function () {
			return forgePublicId(moduleNameMapping.caravan)
		},
		"caravans.0.garageAddress.publicID": function () {
			return forgePublicId(moduleNameMapping.policyAddress)
		},
		"caravans.0.drivers.*.publicID": function () {
			return forgePublicId(moduleNameMapping.driver)
		},
		"caravans.0.drivers.*.uniqueID": function () {
			return driverUniqueIdCtr++;
		},
		"caravans.0.drivers.*.driver.publicID": function () {
			return forgePublicId(moduleNameMapping.policyDriver)
		},
		"caravans.0.drivers.*.driver.person.publicID": function () {
			return forgePublicId(moduleNameMapping.person);
		},
		"caravans.0.drivers.*.driver.person.primaryAddress.publicID": function () {
			return forgePublicId(moduleNameMapping.policyAddress);
		},
		"caravans.0.drivers.*.driver.driverHistory.*.publicID": function () {
			return forgePublicId(moduleNameMapping.driverHistory)
		},
		"caravans.0.drivers.*.driver.driverHistory.*.uniqueID": function () {
			return historyUniqueIdCtr++;
		},
		"policyHolders.*.contact.publicID": function () {
			return forgePublicId(moduleNameMapping.person)
		},
		"policyHolders.*.contact.primaryAddress.publicID": function () {
			return forgePublicId(moduleNameMapping.policyAddress)
		},
		"policyHolders.*.contact.drivingHistory.*.publicID": function () {
			return forgePublicId(moduleNameMapping.driverHistory)
		},
		"caravans.0.specifiedItems.*.publicID": function () {
			return forgePublicId(moduleNameMapping.contentsItems)
		},
	};

	var authorisedPersonsPublicIDTransformationMapping = {
		"policyHolders.*.contact.authorisedPersons.0.person.publicID": function () {
			return forgePublicId(moduleNameMapping.person)
		},
	}

	var publicIDConversionMapping = {
		"policyAddress.publicID": function (val) {
			return convertPublicID('policyAddress.publicID', moduleNameMapping.policyAddress);
		},

		"caravans.0.publicID": function (val) {
			return convertPublicID('caravans.0.publicID', moduleNameMapping.caravan);
		},

		"caravans.0.drivers.*.uniqueID": function () {
			return driverUniqueIdCtr++;
		},

		"caravans.0.drivers.*.driver.driverHistory.*.uniqueID": function () {
			return historyUniqueIdCtr++;
		},

		"caravans.0.garageAddress.publicID": function (val) {
			return convertPublicID('caravans.0.garageAddress.publicID', moduleNameMapping.policyAddress);
		},

		"policyHolders.*.contact.publicID": function (val, mappedValueStarIndices) {
			return convertPublicID('policyHolders.' + mappedValueStarIndices[0] + '.contact.publicID', moduleNameMapping.policyHolders);
		},

		"caravans.0.drivers.*.publicID": function (val, mappedValueStarIndices) {
			return convertPublicID('caravans.0.drivers.' + mappedValueStarIndices[0] + '.publicID', moduleNameMapping.driver);
		},

		"caravans.0.drivers.*.driver.publicID": function (val, mappedValueStarIndices) {
			return convertPublicID('caravans.0.drivers.' + mappedValueStarIndices[0] + '.driver.publicID', moduleNameMapping.policyDriver);
		},

		"caravans.0.drivers.*.driver.person.publicID": function (val, mappedValueStarIndices) {
			return convertPublicID('caravans.0.drivers.' + mappedValueStarIndices[0] + '.driver.person.publicID', moduleNameMapping.person);
		},

		"caravans.0.drivers.*.driver.person.primaryAddress.publicID": function (val, mappedValueStarIndices) {
			return convertPublicID('caravans.0.drivers.' + mappedValueStarIndices[0] + 'driver.person.primaryAddress.publicID', moduleNameMapping.policyAddress);
		},

		"caravans.0.drivers.*.driver.driverHistory.*.publicID": function (val, mappedValueStarIndices) {
			return convertPublicID('caravans.0.drivers.' + mappedValueStarIndices[0] + '.driver.driverHistory.' + mappedValueStarIndices[1] + '.publicID', moduleNameMapping.driverHistory);
		},

		"policyHolders.*.contact.primaryAddress.publicID": function (val) {
			return convertPublicID('policyAddress.publicID', moduleNameMapping.policyAddress);
		},

		"caravans.0.specifiedItems.*.publicID": function (val, mappedValueStarIndices) {
			return convertPublicID('caravans.0.specifiedItems.' + mappedValueStarIndices[0] + '.publicID', moduleNameMapping.contentsItems);
		},

		'policyHolders.*.contact.drivingHistory.*.publicID': function (val, mappedValueStarIndex) {
			return convertPublicID('policyHolders.' + mappedValueStarIndex[0] + '.contact.drivingHistory.' + mappedValueStarIndex[1] + '.publicID', moduleNameMapping.drivingHistory);
		},

	};

	var authorisedPersonsPublicIDConversionMapping = {
		"policyHolders.*.contact.authorisedPersons.0.person.publicID": function (val, mappedValueStarIndices) {
			return convertPublicID('policyHolders.' + mappedValueStarIndices[0] + '.contact.authorisedPersons.0.person.publicID.', moduleNameMapping.person);
		}
	}


	function removeDeletedAdditionalDrivers(transformedRequest) {
		var removedDrivers = aggregatedRemoveService.getList() ? aggregatedRemoveService.getList()['driver'] : null;
		var savedDrivers = fetchFromPreviousResponse('caravans.0.drivers');
		if (savedDrivers && removedDrivers) {
			angular.forEach(removedDrivers, function (removedDriver) {
				var matchingDriver = savedDrivers.filter(function (driver) {
					return driver.driver.person.firstName == removedDriver.person.firstName &&
						driver.driver.person.lastName == removedDriver.person.lastName;
				});
				matchingDriver = matchingDriver[0] || null;
				if (matchingDriver) {
					matchingDriver.markedForDelete = true;
					transformedRequest.caravans[0].drivers.push(matchingDriver);
				}
			});
			aggregatedRemoveService.clear('driver');
		}

		return transformedRequest;
	}

	function updateSpecifiedItems(transformedRequest) {
		if (!transformedRequest.caravans[0].specifiedContents) {
			delete transformedRequest.caravans[0].specifiedItems;
		}
	}

	function removeDeletedDriverHistoryArrays(transformedRequest) {
		var drivers = transformedRequest.caravans[0].drivers;
		angular.forEach(drivers, function (driver, index) {
			var savedHistories = fetchFromPreviousResponse('caravans.0.drivers.' + index + '.driver.driverHistory');
			if (savedHistories && savedHistories.length > 0) {
				var driverHistories = driver.driver.driverHistory;
				angular.forEach(savedHistories, function (savedHistory) {
					var matchingInput = driverHistories.filter(function (history) {
						return history.publicID == savedHistory.publicID;
					});
					if (!matchingInput || matchingInput.length == 0) {
						savedHistory.markedForDelete = true;
						driverHistories.push(savedHistory);
					}
				});
			}
		});
		return transformedRequest;
	}

	function removeEmptyDriverHistoryArrays(transformedRequest) {
		var vehicle = transformedRequest.caravans[0];
		if (vehicle && vehicle.drivers) {
			vehicle.drivers.forEach(function (policyDriver) {
				if (policyDriver.driver &&
					policyDriver.driver.driverHistory &&
					Array.isArray(policyDriver.driver.driverHistory) &&
					policyDriver.driver.driverHistory.length == 0)
					delete policyDriver.driver.driverHistory;
			});
		}

		return transformedRequest;
	}

	//dd-973 - requiring a sequence number for driver infringement
	function addUniqueHistoryID(transformedRequest) {
		var drivers = transformedRequest.caravans[0].drivers;

		angular.forEach(drivers, function (driver, index) {
			historyUniqueIdCtr = 1;
			var driverHistory = driver.driver.driverHistory;
			if (driverHistory) {
				angular.forEach(driverHistory, function (driverHistory, index) {
					driverHistory.uniqueID = historyUniqueIdCtr;
					historyUniqueIdCtr++;
				})
			}
		});
		return transformedRequest;
	}

	function transform(intermediateRequest, response) {
		currentResponse = response;
		driverUniqueIdCtr = 1;
		var transformedRequest = intermediateRequest;

		if (transformedRequest.policyHolders[0] &&
			transformedRequest.policyHolders[0].contact &&
			transformedRequest.policyHolders[0].contact.authorisedPersons
		) {
			publicIDConversionMapping = Object.extend(publicIDConversionMapping, authorisedPersonsPublicIDConversionMapping);
			publicIDTransformationMapping = Object.extend(publicIDTransformationMapping, authorisedPersonsPublicIDTransformationMapping);
		}

		if (!currentResponse)
			transformedRequest = jsonMapper.transform(intermediateRequest, publicIDTransformationMapping);
		else {
			transformedRequest = jsonMapper.convert(intermediateRequest, publicIDConversionMapping);
		}

		transformedRequest = addUniqueHistoryID(transformedRequest);
		transformedRequest = removeDeletedAdditionalDrivers(transformedRequest);
		transformedRequest = removeDeletedDriverHistoryArrays(transformedRequest);
		transformedRequest = removeEmptyDriverHistoryArrays(transformedRequest);
		updateSpecifiedItems(transformedRequest);

		return transformedRequest;
	}


	return {
		transform: transform
	}
}

function CaravanQuoteResultModel(quoteResultResponse) {
	this.isCoverAvailable = quoteResultResponse.quoteResult.totalPremium !== undefined ;
	this.coverType = quoteResultResponse.caravans[0].coverType;
	this.quoteResult = quoteResultResponse.quoteResult;
	this.paymentPlan = quoteResultResponse.paymentPlan;
	this.totalPremium = quoteResultResponse.quoteResult.totalPremium ;
	this.totalFSL = quoteResultResponse.quoteResult.totalFSL ;
	this.totalGST = quoteResultResponse.quoteResult.totalGST ;
	this.totalStampDuty = quoteResultResponse.quoteResult.totalStampDuty ;
	this.premiumAfterDiscount = quoteResultResponse.quoteResult.premiumAfterDiscount ;
	this.paymentFrequency = quoteResultResponse.paymentPlan ? quoteResultResponse.paymentPlan.paymentFrequency : null ;
	this.excess = quoteResultResponse.caravans[0].excess ;
	this.availableSumInsuredTypes = quoteResultResponse.caravans[0].availableSumInsuredTypes;

	this.coverageOptions = quoteResultResponse.caravans[0].coverageOptions ;
	this.response = quoteResultResponse ;

}

function CaravanRetrieveSavedQuoteResponseTransformer($filter, jsonMapper,Util) {
    // transform functions
    var transformers = {
        camelcase: function(value) {
            if(value) {
                return value.charAt(0).toUpperCase() + value.slice(1);
            }
        },
        minimumTodaysDate: function(dateString) {
            var date = moment(dateString, 'YYYY-MM-DD')
                , today = new moment()
                , biggerDate = date >= today ? date : today ;

            return biggerDate.format('DD/MM/YYYY');
        }
        ,date: function(dateString) {
            var date = moment(dateString, 'YYYY-MM-DD') ;
            return date.format('DD/MM/YYYY') ;
        },
        financeType: function(financeType) {
            switch(financeType) {
                case 'none':
                    return '';
                    break;
            }
        },
        convertGender: function(gender) {
            var gc = {
                M : 'male',
                F : 'female',
                I : 'intersex',
            };
            return gc[gender] ;
        },
        convertUnit: function(unit) {
            var gc = {
                'ft' : 'feet',
                'm' : 'metres'
            };
            return gc[unit] ;
        },
        convertSpecifiedCategory: function(category) {
            var gc = {
                'camping_equipment' : 'Camping Equipment',
                'commnav_equipment' : 'Communication and Navigation Equipment',
                'electrical_equipment' : 'Electrical Equipment',
                'entertain_equipment' : 'Entertainment Equipment',
                'other' : 'Other',
                'sporting_equipment' : 'Sporting Equipment'

            };
            return gc[category] ;
        },
        yesNo: function(value) {
            return value == 'yes' ? true : false;
        },
        checkbox: function(value) {
        },
        state: function(state) {
            if ( state )
                return state.replace('AU_', '');
        },
        coverType: function(coverType) {
            if(coverType === 'third_party' || coverType === 'third_party_fire_theft') {
                return 'third_party';
            }
            return coverType;
        },
        purchaseMonthFromMonthYear: function(monthYear) {
            if(monthYear){
                return monthYear.split('-')[1];
            }else{
                return '';
            }

        },
        purchaseYearFromMonthYear: function(monthYear) {
            if(monthYear){
                return monthYear.split('-')[0];
            }else{
                return '';
            }
        },
        thirdPartyPref: function(coverType) {
            if(coverType === 'comprehensive') {
                return null;
            }
            return coverType;
        },
        convertToLabelValue: function(o) {
            if ( o )
                return {
                    label : o.name,
                    value : o.code,
                }

            return null;
        },
        yearsHeld: function(years) {
            var yearsHeld;

            switch (years) {
                case '7':
                    yearsHeld = 'lessThan_1';
                    break;
                case '6':
                    yearsHeld = 'greaterThan_5';
                    break;
                default:
                    yearsHeld = years;
            }

            return yearsHeld;
        }
    };
    function transformPerson(person) {
        var transformMapping = {
                'returnObject.title':                                   '=_input.prefix',
                'returnObject.firstName':                               '=_input.firstName',
                'returnObject.lastName':                                '=_input.lastName',
                'returnObject.gender':                                  '=_input.gender',
                'returnObject.dateOfBirth':                             '=_input.dateOfBirth'
            },
            convertMapping = {
                'returnObject.title':                                   transformers.camelcase,
                'returnObject.gender':                                  transformers.convertGender,
                'returnObject.dateOfBirth':                             transformers.date
            };
        var transformedPerson = jsonMapper.convert(jsonMapper.transform(person, transformMapping), convertMapping);
        return transformedPerson.returnObject;
    }

    function transformDriver(driver) {
        var transformMapping = {
            'returnObject.yearsHeld':                                               '=_input.driver.yearsLicenced',
            'returnObject.licenceType':                                             '=_input.driver.licenceType',
            'returnObject.noClaimBonus':                                            '=_input.driver.noClaimBonus',
            'returnObject.previousInsurer':                                         '=_input.driver.currentInsurer',
            'returnObject.licensedToRide':                                          '=_input.licensedToRide',
            'returnObject.threeYears_accidentsClaims':                              '=_input.driver.hasClaim',
            'returnObject.fiveYears_chargedOrConvicted':                            '=_input.driver.hasConviction',
            'returnObject.threeYears_restrictedSuspendedDisqualifiedCancelled':     '=_input.driver.hasLostLicence',
            'returnObject.visaType':                                                '=_input.driver.visaType',
            },
            convertMapping = {
                'returnObject.yearsHeld':                                           transformers.yearsHeld,
                'returnObject.licensedToRide':                                      transformers.yesNo,
                'returnObject.threeYears_accidentsClaims':                          transformers.yesNo,
                'returnObject.fiveYears_chargedOrConvicted':                        transformers.yesNo,
                'returnObject.threeYears_restrictedSuspendedDisqualifiedCancelled': transformers.yesNo
            };

        var mappedRider = jsonMapper.transform(driver, transformMapping);
        var transformedRider = jsonMapper.convert(mappedRider, convertMapping);
        var returnObject = transformedRider.returnObject;
        if(driver.driver.person) {
            transformedRider.returnObject.person = transformPerson(driver.driver.person);
        }

        // extract driver history
        returnObject.fourYears_chargedOrConvictedOffencesDetails = [];
        returnObject.fourYears_vehicleAccidentsClaimsDetails = [];
        returnObject.tenYears_chargedOrConvictedOffencesDetails = [];
        returnObject.fourYears_licenceRSDCDetails = [];

        if (!!driver.driver.driverHistory) {
            driver.driver.driverHistory.forEach(function(record) {
                var matchedPattern = {};

                switch (record.pattern.filter1) {
                    case 'infringement_demerit':
                    // case 'infringement_licence':
                        returnObject.fourYears_chargedOrConvictedOffencesDetails.push(
                            extractHistory(globals.fourYears_offences.options, record)
                        );
                        break;
                    case 'infringement_licence':
                        returnObject.fourYears_licenceRSDCDetails.push(
                            extractHistory(globals.incidents.options, record)
                        );
                        break;
                    case 'claim' :
                        returnObject.fourYears_vehicleAccidentsClaimsDetails.push(
                            extractHistory(globals.accidents.options, record));
                        break;
                    case 'conviction' :
                        returnObject.tenYears_chargedOrConvictedOffencesDetails.push(
                            extractHistory(globals.tenYears_offences.options, record)
                        );
                        break;

                }
            });
        }

        returnObject.fourYears_chargedOrConvictedOffences = returnObject.fourYears_chargedOrConvictedOffencesDetails.length > 0 ;
        returnObject.fourYears_vehicleAccidentsClaims = returnObject.fourYears_vehicleAccidentsClaimsDetails.length > 0 ;
        returnObject.tenYears_chargedOrConvictedOffences = returnObject.tenYears_chargedOrConvictedOffencesDetails.length > 0 ;
        returnObject.fourYears_licenceRSDC = returnObject.fourYears_licenceRSDCDetails.length > 0 ;

        return returnObject;
    }

    function extractHistory(collection, record) {
        var matchedPattern = {};
        var month = {};
        var year = {};

        matchedPattern = collection.find(function(opt) {
            return opt.publicID == record.pattern.publicID;
        });

        month.label = month.value = moment(record.month, 'MM').format('MMMM') ; // Util.capitalize(record.month.toString());
        year.label = year.value = Util.capitalize(record.year.toString());

        record.description = matchedPattern;
        record.month = month;
        record.year = year;

        delete record.pattern;

        return record;
    }

    function transformPolicyHolder(holder) {

        var transformMapping = {
            'returnObject.title':                                           '=_input.prefix',
            'returnObject.firstName':                                       '=_input.firstName',
            'returnObject.lastName':                                        '=_input.lastName',
            'returnObject.gender':                                          '=_input.gender',
            'returnObject.dateOfBirth':                                     '=_input.dateOfBirth',
            'returnObject.fourYears_chargedOrConvictedOffences':            '=_input.hasConviction',
            'returnObject.fourYears_licenceRSDC':                           '=_input.hasLostLicence',
            'returnObject.fourYears_vehicleAccidentsClaims':                '=_input.hasClaim',
            'returnObject.tenYears_chargedOrConvictedOffences':             '=_input.hasInfringement'
            },
            convertMapping = {
                'returnObject.title':                                       transformers.camelcase,
                'returnObject.gender':                                      transformers.convertGender,
                'returnObject.dateOfBirth':                                 transformers.date,
                'returnObject.fourYears_chargedOrConvictedOffences':        transformers.yesNo,
                'returnObject.fourYears_licenceRSDC':                       transformers.yesNo,
                'returnObject.fourYears_vehicleAccidentsClaims':            transformers.yesNo,
                'returnObject.tenYears_chargedOrConvictedOffences':         transformers.yesNo
            };

        var transformedPolicyHolder = jsonMapper.convert(jsonMapper.transform(holder, transformMapping), convertMapping);

        return transformedPolicyHolder.returnObject;
    }

    /**
     * Transforms the retrievedQuoteRepsonse into a format that can be injected into the userInputRepository
     * The returned value will populate all the forms in the quote process
     * @param {Object} retrievedQuoteResponse                   Response object from the retrieveSavedQuote service
     * @returns {Object}                                        Transformed object ready to inject into the userInputRepository
     */
    function transform(retrievedQuoteResponse) {
    	void 0;

       var transformMapping = {
				'returnObject.email': '=_input.email',

				// getStarted
				'returnObject.getStarted.policyStartDate':
					'=_input.periodStartDate',

				// aboutYourCaravan
				'returnObject.aboutYourCaravan.vehicleType':
					'=_input.caravans.0.caravanType',
				'returnObject.aboutYourCaravan.address':
					'=_input.caravans.0.garageAddress',

				// caravanDetails
				'returnObject.caravanDetails.vehicleSubType':
					'=_input.caravans.0.caravanSubType',
				'returnObject.caravanDetails.isCaravanRegistered':
					'=_input.caravans.0.isCaravanRegistered',
				'returnObject.caravanDetails.regoNumber':
					'=_input.caravans.0.registrationNumber',
				'returnObject.caravanDetails.locationDescription':
					'=_input.caravans.0.locationType',
				'returnObject.caravanDetails.security':
					'=_input.caravans.0.securityType',
				'returnObject.caravanDetails.primaryUse':
					'=_input.caravans.0.caravanUsageType',
				'returnObject.caravanDetails.existingDamage':
					'=_input.caravans.0.existingDamageType',
				'returnObject.caravanDetails.finance':
					'=_input.caravans.0.financeType',
				'returnObject.caravanDetails.financeWith':
					'=_input.caravans.0.financeCompany',
				'returnObject.caravanDetails.whenDidYouBuyYear':
					'=_input.caravans.0.purchaseMonthYear',
				'returnObject.caravanDetails.whenDidYouBuyMonth':
					'=_input.caravans.0.purchaseMonthYear',
				'returnObject.caravanDetails.purchasePrice':
					'=_input.caravans.0.purchasePrice',
				'returnObject.caravanDetails.cost':
					'=_input.caravans.0.purchasePrice',
				'returnObject.caravanDetails.isPremanentResidence':
					'=_input.caravans.0.isPermResidence',
				'returnObject.caravanDetails.nonRetractableJacksorPermanantFoundations':
					'=_input.caravans.0.isCaravanOnNonRetractableJacks',
				'returnObject.caravanDetails.permanentlyConnected':
					'=_input.caravans.0.isCaravanConnectedToPlumbing',

				// aboutYourContents
				'returnObject.aboutYourContents.insureContents':
					'=_input.caravans.0.contentsCover',
				'returnObject.aboutYourContents.generalContentsValue':
					'=_input.caravans.0.contentsCoverAmount',
				'returnObject.aboutYourContents.contentsItems':
					'=_input.caravans.0.specifiedItems',

				// quote excess and sum insured values
				'returnObject.sumInsured.agreedValue':
					'=_input.caravans.0.agreedAmountValue',
				'returnObject.sumInsured.annexeReplacementCost':
					'=_input.caravans.0.replacementCostValue',
				'returnObject.excess.voluntaryVehicleExcess':
					'=_input.caravans.0.excess.voluntaryVehicleExcess',

				//tell us a bit more -------------------------------------
				'returnObject.tellUsABitMore.yourEmailAddress': '=_input.email',
				'returnObject.tellUsABitMore.promotionalCode':
					'=_input.campaignCode',
				'returnObject.stampDutyExemption.isSmallBusiness':
					'=_input.caravans.0.isSmallBusiness',
				//driver
				// 'vehicleForm.driver.paymentOptions':             '=_input.?',

				// optional benefits
				// 'returnObject.discountOptions.discountLayup':               '=_input.caravans.0.coverageOptions.0.activeLayupMonths',

				// registration details
				'returnObject.caravanInfo': '=_input.caravans.0.caravanInfo',
				'returnObject.retrievedQuoteRego.rego':
					'=_input.caravans.0.registrationNumber',
				'returnObject.retrievedQuoteRego.state':
					'=_input.caravans.0.garageAddress.state',

				// Contact
				'returnObject.mainPolicyHolderContact.passwordQuestion':
					'=_input.policyHolders.0.contact.passwordQuestion',
				'returnObject.mainPolicyHolderContact.passwordAnswer':
					'=_input.policyHolders.0.contact.passwordAnswer',
				'returnObject.mainPolicyHolderContact.primaryPhone':
					'=_input.policyHolders.0.contact.primaryPhone',
				'returnObject.mainPolicyHolderContact.personalContactDetailsMailingPreference':
					'=_input.documentDeliveryMethod'
			},
			convertMapping = {
				'returnObject.getStarted.policyStartDate':
					transformers.minimumTodaysDate,
				'returnObject.caravanDetails.whenDidYouBuyYear':
					transformers.purchaseYearFromMonthYear,
				'returnObject.caravanDetails.whenDidYouBuyMonth':
					transformers.purchaseMonthFromMonthYear,
				'returnObject.caravanDetails.financeWith':
					transformers.convertToLabelValue
			};

        var transformedQuote = jsonMapper.convert(jsonMapper.transform(retrievedQuoteResponse, transformMapping), convertMapping);

        var returnObject = transformedQuote.returnObject;
        // set comprehensive preference to null if the coverType is third party
        void 0;
        // set primary phone number to mobile phone
        if(retrievedQuoteResponse.policyHolders[0].contact.cellPhone) {
            returnObject.mainPolicyHolderContact.primaryPhoneNumber = retrievedQuoteResponse.policyHolders[0].contact.cellPhone;
        }

        // set primary phone number to home phone
        if(retrievedQuoteResponse.policyHolders[0].contact.homePhone) {
            returnObject.mainPolicyHolderContact.primaryPhoneNumber = retrievedQuoteResponse.policyHolders[0].contact.homePhone;
        }

        // set primary phone number to work phone
        if(retrievedQuoteResponse.policyHolders[0].contact.workPhone) {
            returnObject.mainPolicyHolderContact.primaryPhoneNumber = retrievedQuoteResponse.policyHolders[0].contact.workPhone;
        }        

        if ( returnObject.caravanInfo && returnObject.caravanInfo.vgiId ){
            returnObject.aboutYourCaravan.searchType = 'yearMakeModel' ;
            returnObject.aboutYourCaravan.vgiId = returnObject.caravanInfo.vgiId;
            // returnObject.aboutYourCaravan.vehicleKey = returnObject.caravanInfo.
            returnObject.aboutYourCaravan.description= 'returnObject.caravanInfo.';
            returnObject.aboutYourCaravan.modelYear= returnObject.caravanInfo.modelYear;
            returnObject.aboutYourCaravan.make= returnObject.caravanInfo.make;
            returnObject.aboutYourCaravan.model= returnObject.caravanInfo.model;
            returnObject.aboutYourCaravan.bodyStyle= returnObject.caravanInfo.bodyType;
            returnObject.aboutYourCaravan.ratingGrade= 'returnObject.caravanInfo.';
            returnObject.aboutYourCaravan.weight= returnObject.caravanInfo.weight;

        } else {
            if(returnObject.caravanInfo){
                returnObject.aboutYourCaravan.searchType = 'manually' ;
                returnObject.aboutYourCaravan.year= ''+returnObject.caravanInfo.modelYear;
                returnObject.aboutYourCaravan.make= returnObject.caravanInfo.make;
                returnObject.aboutYourCaravan.model= returnObject.caravanInfo.model;
                returnObject.aboutYourCaravan.bodyType= returnObject.caravanInfo.bodyType;
                returnObject.aboutYourCaravan.berths= parseInt(returnObject.caravanInfo.berths);
                returnObject.aboutYourCaravan.weight= parseInt(returnObject.caravanInfo.weight);
                returnObject.aboutYourCaravan.manualLength= parseInt(returnObject.caravanInfo.caravanLength);
                returnObject.aboutYourCaravan.manualLengthUnits= transformers.convertUnit(returnObject.caravanInfo.lengthUnits);
                returnObject.aboutYourCaravan.customBuilt= returnObject.caravanInfo.customBuilt;
                returnObject.aboutYourCaravan.numOfAxels= returnObject.caravanInfo.numberOfAxles;
            }

        }

        // region Sort drivers to put mainRider first in the list
        if(retrievedQuoteResponse.caravans && retrievedQuoteResponse.caravans.length && retrievedQuoteResponse.caravans[0].drivers) {
            var drivers = $filter('orderBy')(retrievedQuoteResponse.caravans[0].drivers, function(driver) {
                return driver.driverUsage == 'main' ? 0 : 1;
            });
            transformedQuote.returnObject.driver = {};
            transformedQuote.returnObject.driver.drivers = [];
            drivers.forEach(function(driver, index) {
                transformedQuote.returnObject.driver.drivers.push(transformDriver(driver));
            });
            
            //dd-1040-extend driver object to reflect data
            if(transformedQuote.returnObject.driver && transformedQuote.returnObject.driver.drivers[0]){
                var years = retrievedQuoteResponse.caravans[0].yearsContinuousInsurance == '4'? '3+' : parseInt(retrievedQuoteResponse.caravans[0].yearsContinuousInsurance);
                var claims = Object.extend(transformedQuote.returnObject.driver.drivers[0], {yearsContinuousInsurance: years,
                        timeSinceLastClaim: retrievedQuoteResponse.caravans[0].timeSinceLastClaim});
            }
        }

        //add content items
        if(returnObject.aboutYourContents && returnObject.aboutYourContents.contentsItems){
            returnObject.aboutYourContents.contentsItems.forEach(function(item){
                var _label = transformers.convertSpecifiedCategory(item.category);
                var _category = {'label' : _label, 'value' : item.category };
                item.category = _category;
            });
        }

        if(retrievedQuoteResponse.caravans[0].caravanUsageType) {
            var usage = retrievedQuoteResponse.caravans[0].caravanUsageType;
			switch (usage) {
				case 'commercial':
                transformedQuote.returnObject.caravanDetails.commercialActivityType = retrievedQuoteResponse.caravans[0].businessUsageType;
					break;
				case 'business':
                    transformedQuote.returnObject.caravanDetails.businessActivityType = retrievedQuoteResponse.caravans[0].businessUsageType;
					break;
			}            
        }        

        // "category":{"label":"Electrical Equipment","value":"electrical_equipment"}

        // convert discount layups
        // convertDiscountLayups: function(list) {
        //     var rekeyedObject = {} ;

        //     angular.forEach(list, function(value, index) {
        //         rekeyedObject[value] = true ;
        //     });

        //     return rekeyedObject ;
        // }


        // set optional benefits
        // if(retrievedQuoteResponse.vehicles[0].coverageOptions.length) {
        //  var coverageOptions = retrievedQuoteResponse.vehicles[0].coverageOptions;
        //  coverageOptions.forEach(function(option, index) {
        //      console.info(option);
        //  })
        // }

        // set about your content section for items over $750

        // set contact policy holders
        // if(retrievedQuoteResponse.policyHolders && retrievedQuoteResponse.policyHolders.length) {
        //     var policyHolders = retrievedQuoteResponse.policyHolders;
        //     transformedQuote.returnObject.mainPolicyHolder = {};
        //     policyHolders.forEach(function(holder, index) {
        //         if(holder.mainHolder) {
        //             transformedQuote.returnObject.mainPolicyHolder.mainPolicyHolder = true;
        //             transformedQuote.returnObject.mainPolicyHolder = transformPolicyHolder(holder.contact);
        //             transformedQuote.returnObject.mainPolicyHolder.policyHolders = [];
        //         } else {
        //             transformedQuote.returnObject.mainPolicyHolder.policyHolders.push(transformPolicyHolder(holder.contact));
        //         }
        //     });
        // }

        void 0;

        return transformedQuote.returnObject;
    }
    return {
        transform: transform
    }
}

function CaravanStructureRequestTransformer(
	jsonMapper,
	util,
	quoteOptions,
	storage
) {
	var structureQuoteMapping = {
		periodStartDate: '=_input.caravanForm.getStarted.policyStartDate',
		caravans: [],

		'caravans.0': '=_input.caravanForm.caravanDetails',

		'caravans.0.caravanType':
			'=_input.caravanForm.aboutYourCaravan.vehicleType',
		'caravans.0.caravanInfo': '=_regoSearch',
		'caravans.0.garageAddress': '=_addressSearch',

		// caravanDetails
		'caravans.0.registrationNumber':
			'=_input.caravanForm.caravanDetails.regoNumber',
		'caravans.0.locationType':
			'=_input.caravanForm.caravanDetails.locationDescription',
		'caravans.0.securityType':
			'=_input.caravanForm.caravanDetails.security',
		'caravans.0.caravanUsageType':
			'=_input.caravanForm.caravanDetails.primaryUse',
		'caravans.0.existingDamageType':
			'=_input.caravanForm.caravanDetails.existingDamage',
		'caravans.0.purchaseMonthYear':
			'=_input.caravanForm.caravanDetails.whenDidYouBuyYear',
		'caravans.0.purchaseMonthYear':
			'=_input.caravanForm.caravanDetails.whenDidYouBuyMonth',
		'caravans.0.isCaravanRegistered':
			'=_input.caravanForm.caravanDetails.isCaravanRegistered',
		'caravans.0.isPermResidence':
			'=_input.caravanForm.caravanDetails.isPremanentResidence',
		'caravans.0.isCaravanOnNonRetractableJacks':
			'=_input.caravanForm.caravanDetails.nonRetractableJacksorPermanantFoundations',
		'caravans.0.isCaravanConnectedToPlumbing':
			'=_input.caravanForm.caravanDetails.permanentlyConnected',
		'caravans.0.chassisNumber':
			'=_input.caravanForm.caravanDetails.chassisNumber',

		'caravans.0.replacementCostValue':
			'=_input.caravanForm.sumInsured.annexeReplacementCost',
		'caravans.0.agreedAmountValue':
			'=_input.caravanForm.sumInsured.agreedValue',

		// aboutYourContents
		'caravans.0.agreedAmountValue':
			'=_input.caravanForm.aboutYourContents.agreedValue',
		'caravans.0.replacementCostValue':
			'=_input.caravanForm.aboutYourContents.annexeReplacementCost',
		'caravans.0.contentsCoverAmount':
			'=_input.caravanForm.aboutYourContents.generalContentsValue',

		'caravans.0.contentsCover':
			'=_input.caravanForm.aboutYourContents.insureContents',
		'caravans.0.excess.voluntaryVehicleExcess':
			'=_input.caravanForm.excess.voluntaryVehicleExcess',

		'caravans.0.yearsContinuousInsurance':
			'=_input.caravanForm.driver.yearsContinuousInsurance',
		'caravans.0.timeSinceLastClaim':
			'=_input.caravanForm.driver.timeSinceLastClaim',

		policyHolders: [],
		'policyHolders.0': {},
		'policyHolders.0.mainHolder':
			'=_input.caravanForm.mainPolicyHolder.mainPolicyHolder',
		'policyHolders.0.contact': '=_input.caravanForm.mainPolicyHolder',
		'policyHolders.0.contact.primaryAddress': '=_addressSearch',

		policyAddress: '=_addressSearch',
		email: '=_input.email',
		campaignCode: '=_input.caravanForm.promotionalCode.promotionalCode',
		postalAddress: '=_addressSearch-postal-address'
	};

	function updateCaravanInfo(transformedRequest, userInput) {
		var aboutYourCaravan = userInput.caravanForm.aboutYourCaravan,
			searchType = userInput.caravanForm.aboutYourCaravan.searchType,
			caravanInfo = transformedRequest.caravans[0].caravanInfo || {};

		if (aboutYourCaravan) {
			if (searchType === 'manually') {
				caravanInfo = {
					modelYear: aboutYourCaravan.year,
					make: aboutYourCaravan.make,
					model: aboutYourCaravan.model,
					bodyType: aboutYourCaravan.bodyType,
					berths: aboutYourCaravan.berths,
					weight: aboutYourCaravan.weight,
					caravanLength: aboutYourCaravan.manualLength,
					lengthUnits: aboutYourCaravan.manualLengthUnits,
					customBuilt: aboutYourCaravan.customBuilt,
					numberOfAxles: aboutYourCaravan.numOfAxels
				};

				transformedRequest.caravans[0].caravanInfo = caravanInfo;
			} else if (searchType === 'yearMakeModel') {
				if (caravanInfo && caravanInfo.vgiId) {
					//if aviailable continue
				} else {
					//set vgiId from retrive
					caravanInfo = {
						vgiId: aboutYourCaravan.vgiId
					};
					transformedRequest.caravans[0].caravanInfo = caravanInfo;
				}
			}
		}

		return transformedRequest;
	}

	function updateContentsItems(transformedRequest, userInput) {
		var aboutYourContents = userInput.caravanForm.aboutYourContents;

		if (
			aboutYourContents &&
			aboutYourContents.contentsItems &&
			aboutYourContents.contentsItems.length > 0
		) {
			var contents = aboutYourContents.contentsItems;

			var specifiedItems = contents.map(function(item, i) {
				return {
					category: item.category.value,
					description: item.description,
					value: item.value
				};
			});

			transformedRequest.caravans[0].specifiedContents = true;
			transformedRequest.caravans[0].specifiedItems = specifiedItems;
		}

		return transformedRequest;
	}

	function updateTotalSpecifiedContentsValue(transformedRequest, userInput) {
		var aboutYourContents = userInput.caravanForm.aboutYourContents;

		if (
			aboutYourContents &&
			aboutYourContents.contentsItems &&
			aboutYourContents.contentsItems.length > 0
		) {
			var contents = aboutYourContents.contentsItems,
				totalSpecifiedItemsValue = 0;

			for (var index in contents) {
				totalSpecifiedItemsValue += contents[index].value;
			}

			transformedRequest.caravans[0].totalSpecifiedItemsValue = totalSpecifiedItemsValue;
		}

		return transformedRequest;
	}

	function updateTotalContentsSpecifiedValue(transformedRequest, userInput) {
		var aboutYourContents = userInput.caravanForm.aboutYourContents;

		if (aboutYourContents && aboutYourContents.generalContentsValue) {
			var contentsCoverAmount =
					userInput.caravanForm.aboutYourContents
						.generalContentsValue,
				totalSpecifiedItemsValue =
					transformedRequest.caravans[0].totalSpecifiedItemsValue ||
					0;

			if (contentsCoverAmount && totalSpecifiedItemsValue) {
				transformedRequest.caravans[0].totalContentsAndSpecifiedValue =
					contentsCoverAmount + totalSpecifiedItemsValue;
			}
		}

		if (transformedRequest.caravans[0].contentsCover === false) {
			transformedRequest.caravans[0].contentsCoverAmount = '';
		}

		if (aboutYourContents.insureContents === undefined) {
			transformedRequest.caravans[0].contentsCover = false;
		}

		return transformedRequest;
	}

	function updateVehicleDetails(transformedRequest, userInput) {
		transformedRequest.caravans[0] = util.deepClone(
			transformedRequest.caravans[0]
		);

		if (userInput.caravanForm.insuredExcessValue) {
			transformedRequest.caravans[0].sumInsuredType =
				userInput.caravanForm.insuredExcessValue.comprehensivePref;
		}
		//userInput.caravanForm.insuredExcessValue
		if (userInput.caravanForm.caravanDetails) {
			if (userInput.caravanForm.caravanDetails.whenDidYouBuyYear) {
				transformedRequest.caravans[0].purchaseMonthYear =
					userInput.caravanForm.caravanDetails.whenDidYouBuyYear +
					'-' +
					userInput.caravanForm.caravanDetails.whenDidYouBuyMonth;
			}

			transformedRequest.caravans[0].businessUsageType =
				userInput.caravanForm.caravanDetails.businessActivityType ||
				userInput.caravanForm.caravanDetails.commercialActivityType ||
				undefined;
		}

		return transformedRequest;
	}

	function updatePolicyHolders(transformedRequest, userInput) {
		var caravanForm = userInput.caravanForm,
			mainPolicyHolder = caravanForm.mainPolicyHolder,
			drivers = transformedRequest.caravans[0].drivers;

		if (mainPolicyHolder) {
			var policyHolders = [];

			mainPolicyHolder.policyContact =
				caravanForm.mainPolicyHolderContact;

			if (mainPolicyHolder.isMainDriverMainPolicyHolder) {
				var driver = util.deepClone(
					transformedRequest.caravans[0].drivers[0].driver
				);
				Object.extend(mainPolicyHolder, driver.person);
			}

			policyHolders.push(mainPolicyHolder);

			if (
				caravanForm.additionalPolicyHolders &&
				caravanForm.additionalPolicyHolders.policyHolders
			) {
				policyHolders = policyHolders.concat(
					caravanForm.additionalPolicyHolders.policyHolders
				);
			}

			policyHolders.forEach(function(policyHolder, index) {
				var contact = util.deepClone(policyHolder);
				if (!transformedRequest.policyHolders[index])
					transformedRequest.policyHolders[index] = {};

				var transformedContact =
					transformedRequest.policyHolders[index];
				if (!contact.contactType)
					contact.contactType =
						'person'; /* TODO : check to make sure this condition is always safe to use */

				contact.prefix = contact.title;
				contact.hasClaim = contact.fourYears_vehicleAccidentsClaims;
				contact.hasInfringement =
					contact.fourYears_chargedOrConvictedOffences;
				contact.hasLostLicence = contact.fourYears_licenceRSDC;
				contact.hasConviction =
					contact.tenYears_chargedOrConvictedOffences;

				if (contact.policyContact) {
					Object.extend(contact, contact.policyContact);
					if (contact.primaryPhone == 'mobile')
						contact.cellPhone = contact.primaryPhoneNumber;
					else if (contact.primaryPhone == 'home')
						contact.homePhone = contact.primaryPhoneNumber;
					else if (contact.primaryPhone == 'work')
						contact.workPhone = contact.primaryPhoneNumber;

					delete contact.policyContact;
				}

				if (!contact.primaryAddress)
					contact.primaryAddress = util.clone(
						mainPolicyHolder.primaryAddress
					);

				contact.hasClaim = contact.fourYears_vehicleAccidentsClaims;
				contact.hasInfringement =
					contact.fourYears_chargedOrConvictedOffences;
				contact.hasLostLicence = contact.fourYears_licenceRSDC;
				contact.hasConviction =
					contact.tenYears_chargedOrConvictedOffences;
				contact.zeroDemerits = contact.NSWDemeritPoints;

				contact.drivingHistory = [];

				// 4 years Charged or Convicted Offences
				if (
					contact.fourYears_chargedOrConvictedOffences &&
					contact.fourYears_chargedOrConvictedOffencesDetails.length <
						1
				) {
					contact.fourYears_chargedOrConvictedOffences = false;
				}

				if (contact.fourYears_chargedOrConvictedOffences) {
					contact.drivingHistory = contact.drivingHistory.concat(
						contact.fourYears_chargedOrConvictedOffencesDetails.slice()
					);
				}

				// 4 years Licence RSDC
				if (
					contact.fourYears_licenceRSDC &&
					contact.fourYears_licenceRSDCDetails.length < 1
				) {
					contact.fourYears_licenceRSDC = false;
				}

				if (contact.fourYears_licenceRSDC) {
					contact.drivingHistory = contact.drivingHistory.concat(
						contact.fourYears_licenceRSDCDetails.slice()
					);
				}

				// 4 years accidents and claims
				if (
					contact.fourYears_vehicleAccidentsClaims &&
					contact.fourYears_vehicleAccidentsClaimsDetails.length < 1
				) {
					contact.fourYears_vehicleAccidentsClaims = false;
				}

				if (contact.fourYears_vehicleAccidentsClaims) {
					contact.drivingHistory = contact.drivingHistory.concat(
						contact.fourYears_vehicleAccidentsClaimsDetails.slice()
					);
				}

				// 10 years charged or convicted
				if (
					contact.tenYears_chargedOrConvictedOffences &&
					contact.tenYears_chargedOrConvictedOffencesDetails.length <
						1
				) {
					contact.tenYears_chargedOrConvictedOffences = false;
				}

				if (contact.tenYears_chargedOrConvictedOffences) {
					contact.drivingHistory = contact.drivingHistory.concat(
						contact.tenYears_chargedOrConvictedOffencesDetails.slice()
					);
				}

				// Concat time!
				contact.drivingHistory.forEach(function(dh) {
					dh.pattern = {
						publicID: '',
						description: '',
						code: '',
						filter1: ''
					};
					if (dh.description) {
					} else {
						if (dh.accident) {
							dh.description = dh.accident;
						} else if (dh.incident) {
							dh.description = dh.incident;
						}
					}
					dh.pattern.publicID = dh.description.publicID;
					dh.pattern.description = dh.description.label;
					dh.pattern.code = dh.description.code;
					dh.pattern.filter1 = dh.description.filter1;

					dh.month = transposeMonth(dh.month.value);
					dh.year = dh.year.value;

					delete dh.description;
				});

				if (!transformedContact.contact)
					transformedContact.contact = {};

				Object.extend(transformedContact.contact, contact);
			});
		} else if (
			transformedRequest.caravans[0].drivers[0] &&
			transformedRequest.caravans[0].drivers[0].driver &&
			transformedRequest.caravans[0].drivers[0].driver.person
		) {
			var driver = transformedRequest.caravans[0].drivers[0].driver;
			var contact = transformedRequest.policyHolders[0].contact;

			Object.extend(contact, driver.person);
			contact.contactType =
				'person'; /* TODO : check to make sure this condition is always safe to use */
			contact.hasClaim = driver.hasClaim;
			contact.hasConviction = driver.hasConviction;
		}

		transformedRequest.policyHolders[0].mainHolder = true;

		if (userInput.email) {
			/** required for saving/retrieving the policy */
			if (
				userInput.caravanForm.tellUsABitMore &&
				userInput.caravanForm.tellUsABitMore.yourEmailAddress
			) {
				transformedRequest.policyHolders[0].contact.emailAddress1 =
					userInput.caravanForm.tellUsABitMore.yourEmailAddress;
			} else if (
				userInput.caravanForm.mainPolicyHolderContact &&
				userInput.caravanForm.mainPolicyHolderContact.emailAddress1
			) {
				transformedRequest.policyHolders[0].contact.emailAddress1 =
					userInput.caravanForm.mainPolicyHolderContact.emailAddress1;
			} else {
				transformedRequest.policyHolders[0].contact.emailAddress1 =
					userInput.email;
			}

			if (
				angular.isDefined(
					transformedRequest.caravans[0].drivers[0].driver
				)
			) {
				if (
					userInput.caravanForm.tellUsABitMore &&
					userInput.caravanForm.tellUsABitMore.yourEmailAddress
				) {
					transformedRequest.caravans[0].drivers[0].driver.person.emailAddress1 =
						userInput.caravanForm.tellUsABitMore.yourEmailAddress;
				} else if (
					userInput.caravanForm.mainPolicyHolderContact &&
					userInput.caravanForm.mainPolicyHolderContact.emailAddress1
				) {
					transformedRequest.caravans[0].drivers[0].driver.person.emailAddress1 =
						userInput.caravanForm.mainPolicyHolderContact.emailAddress1;
				} else {
					transformedRequest.caravans[0].drivers[0].driver.person.emailAddress1 =
						userInput.email;
				}
			}
		} else {
			if (
				userInput.caravanForm.tellUsABitMore &&
				userInput.caravanForm.tellUsABitMore.yourEmailAddress
			) {
				if (transformedRequest.policyHolders[0].contact.emailAddress1) {
					//use the existing if available
				} else {
					transformedRequest.policyHolders[0].contact.emailAddress1 =
						userInput.caravanForm.tellUsABitMore.yourEmailAddress;
				}

				if (
					transformedRequest.caravans[0].drivers[0].driver.person
						.emailAddress1
				) {
					//use the existing if available
				} else {
					transformedRequest.caravans[0].drivers[0].driver.person.emailAddress1 =
						userInput.caravanForm.tellUsABitMore.yourEmailAddress;
				}
			}
		}

		if (
			userInput.caravanForm &&
			userInput.caravanForm.mainPolicyHolderContact &&
			userInput.caravanForm.mainPolicyHolderContact
				.personalContactDetailsMailingPreference
		) {
			transformedRequest.documentDeliveryMethod =
				userInput.caravanForm.mainPolicyHolderContact.personalContactDetailsMailingPreference;
			delete transformedRequest.policyHolders[0].contact
				.personalContactDetailsMailingPreference;
		}

		return transformedRequest;
	}

	function updateDrivers(transformedRequest, userInput) {
		transformedRequest.caravans[0].drivers = [];
		if (
			userInput.caravanForm.driver &&
			userInput.caravanForm.driver.drivers
		) {
			userInput.caravanForm.driver.drivers.forEach(function(driver) {
				driver.person.contactType = 'person';
				driver.person.prefix = driver.person.title;
				driver.person.primaryAddress = transformedRequest.policyAddress;
				driver.person.primaryAddress.addressType = 'residential';

				driver.hasClaim = driver.person.hasClaim =
					driver.fourYears_vehicleAccidentsClaims;
				driver.hasInfringement =
					driver.fourYears_chargedOrConvictedOffences;
				driver.hasLostLicence = driver.fourYears_licenceRSDC;
				driver.hasConviction = driver.person.hasConviction =
					driver.tenYears_chargedOrConvictedOffences;
				driver.zeroDemerits = driver.NSWDemeritPoints;
				//driver.yearsLicenced = driver.yearsHeld ;

				switch (driver.yearsHeld) {
					case 'lessThan_1':
						driver.yearsLicenced = '7';
						break;
					case 'greaterThan_5':
						driver.yearsLicenced = '6';
						break;
					default:
						driver.yearsLicenced = driver.yearsHeld;
				}

				if (
					driver.fourYears_chargedOrConvictedOffences &&
					(!driver.fourYears_chargedOrConvictedOffencesDetails ||
						driver.fourYears_chargedOrConvictedOffencesDetails
							.length < 1)
				) {
					driver.fourYears_chargedOrConvictedOffences = false;
				}

				if (
					driver.fourYears_vehicleAccidentsClaims &&
					(!driver.fourYears_vehicleAccidentsClaimsDetails ||
						driver.fourYears_vehicleAccidentsClaimsDetails.length <
							1)
				) {
					driver.fourYears_chargedOrConvictedOffences = false;
				}

				if (
					driver.fourYears_licenceRSDC &&
					(!driver.fourYears_licenceRSDCDetails.length ||
						driver.fourYears_licenceRSDCDetails.length < 1)
				) {
					driver.fourYears_licenceRSDC = false;
				}

				if (
					driver.tenYears_chargedOrConvictedOffences &&
					(!driver.tenYears_chargedOrConvictedOffencesDetails ||
						driver.tenYears_chargedOrConvictedOffencesDetails
							.length < 1)
				) {
					driver.tenYears_chargedOrConvictedOffences = false;
				}

				driver.driverHistory = [];

				if (driver.fourYears_chargedOrConvictedOffences) {
					driver.driverHistory = driver.driverHistory.concat(
						driver.fourYears_chargedOrConvictedOffencesDetails.slice()
					);
				}

				if (driver.fourYears_vehicleAccidentsClaims) {
					driver.driverHistory = driver.driverHistory.concat(
						driver.fourYears_vehicleAccidentsClaimsDetails.slice()
					);
				}

				if (driver.fourYears_licenceRSDC) {
					driver.driverHistory = driver.driverHistory.concat(
						driver.fourYears_licenceRSDCDetails.slice()
					);
				}

				if (driver.tenYears_chargedOrConvictedOffences) {
					driver.driverHistory = driver.driverHistory.concat(
						driver.tenYears_chargedOrConvictedOffencesDetails.slice()
					);
				}

				driver.driverHistory.forEach(function(dh) {
					dh.pattern = {
						publicID: '',
						description: '',
						code: '',
						filter1: ''
					};
					dh.pattern.publicID = dh.description.publicID;
					dh.pattern.description = dh.description.label;
					dh.pattern.code = dh.description.code;
					dh.pattern.filter1 = dh.description.filter1;

					dh.month = transposeMonth(dh.month.value);
					dh.year = dh.year.value;

					delete dh.description;
				});

				var driverObj = {
					driver: driver
				};

				// var toDelete = isItemMarkedForDelete('driver', driver) ;
				// if (toDelete) driverObj.markedForDelete = true ;

				transformedRequest.caravans[0].drivers.push(driverObj);
			});

			transformedRequest.caravans[0].drivers[0].driverUsage = 'main';
		} else {
			transformedRequest.caravans[0].drivers = [
				{
					driverUsage: 'main'
				}
			];
		}

		return transformedRequest;
	}

	function updateVehicleSubType(transformedRequest, userInput) {
		var caravanDetails = userInput.caravanForm.caravanDetails,
			caravanType = userInput.caravanForm.aboutYourCaravan.vehicleType,
			vehicleSubType = null;

		if (caravanDetails && caravanDetails.vehicleSubType) {
			vehicleSubType = caravanDetails.vehicleSubType;
		} else {
			switch (caravanType) {
				case 'caravan':
					vehicleSubType = 'standardcaravan';
					break;
				case 'campertrailer':
					vehicleSubType = 'standardcampertrailer';
					break;
				case 'goodscarryingtrailer':
					vehicleSubType = 'boxtrailer';
					break;
			}
		}

		transformedRequest.caravans[0].caravanSubType = vehicleSubType;

		return transformedRequest;
	}

	function updateTotalCaravanValue(transformedRequest, userInput) {
		var sumInsured = userInput.caravanForm.sumInsured;

		if (
			sumInsured &&
			sumInsured.annexeReplacementCost &&
			sumInsured.agreedValue
		) {
			transformedRequest.caravans[0].totalCaravanValue =
				sumInsured.agreedValue + sumInsured.annexeReplacementCost;
		}

		return transformedRequest;
	}

	function updateVehicleInsuranceTypeAndAmount(
		transformedRequest,
		userInput
	) {
		var insuredExcessValue = userInput.caravanForm.insuredExcessValue;

		if (insuredExcessValue) {
			transformedRequest.caravans[0].sumInsuredType =
				insuredExcessValue.comprehensivePref;
			if (insuredExcessValue.comprehensivePref == 'agreed') {
				transformedRequest.caravans[0].sumInsuredAmount =
					insuredExcessValue.agreedValue;
			} else if (quoteOptions.getSelectedQuoteResult()) {
				transformedRequest.caravans[0].sumInsuredAmount = quoteOptions
					.getSelectedQuoteResult()
					.getAnnual().vehicleValue.lower;
			}
		}
		return transformedRequest;
	}

	function updateDiscountLayup(transformedRequest, userInput) {
		var discountOptions = userInput.caravanForm.discountOptions;

		if (discountOptions && discountOptions.discountLayup) {
			var coverageOptions =
					transformedRequest.caravans[0].coverageOptions || [],
				discountLayup = {
					name: 'QPCLayupCover',
					selected: discountOptions.discountLayup,
					required: false
				};

			if (
				!!discountOptions.discountLayup &&
				!!discountOptions.discountLayupMonths
			) {
				discountLayup.activeLayupMonths = [];

				var layupMonths = Object.keys(
					discountOptions.discountLayupMonths
				);
				layupMonths.forEach(function(monthItem) {
					if (discountOptions.discountLayupMonths[monthItem]) {
						discountLayup.activeLayupMonths.push(monthItem);
					}
				});
			}

			coverageOptions.push(discountLayup);

			transformedRequest.caravans[0].coverageOptions = coverageOptions;
		}

		return transformedRequest;
	}

	function updateVehicleInsuranceOptionalBenefits(
		transformedRequest,
		userInput
	) {
		var optionalBenefits = userInput.caravanForm.optionalBenefits;

		if (optionalBenefits) {
			var coverageOptions =
				transformedRequest.caravans[0].coverageOptions || [];

			for (var key in optionalBenefits) {
				//dd-6512-Do not include "expiryDate" option
				if (key.indexOf('QPC') > -1) {
					coverageOptions.push({
						name: key,
						selected: optionalBenefits[key],
						required: false
					});
				}
			}
			transformedRequest.caravans[0].coverageOptions = coverageOptions;
		}
		return transformedRequest;
	}

	function updateOnSiteDiscount(transformedRequest, userInput) {
		var discountOptions = userInput.caravanForm.discountOptions;

		if (discountOptions) {
			var coverageOptions =
					transformedRequest.caravans[0].coverageOptions || [],
				onSiteDiscount = discountOptions.onSiteDiscount;

			if (onSiteDiscount === true) {
				coverageOptions.push({
					name: 'QPCOnSite',
					selected: true,
					required: true
				});

				// coverageOptions.push({
				// 	name:'QPCLayupCover',
				// 	selected:false
				// });
			}

			if (onSiteDiscount === false) {
				coverageOptions.push({
					name: 'QPCOnSite',
					selected: false,
					required: true
				});

				// coverageOptions.push({
				// 	name:'QPCLayupCover',
				// 	selected:false
				// });
			}

			transformedRequest.caravans[0].coverageOptions = coverageOptions;
		}

		return transformedRequest;
	}

	function updateFinanceType(transformedRequest, userInput) {
		var caravanDetails = userInput.caravanForm.caravanDetails,
			finance = caravanDetails ? caravanDetails.finance : 'none';

		if (caravanDetails) {
			if (caravanDetails.financeWith) {
				financeWith = caravanDetails.financeWith;
			} else {
				financeWith = null;
			}
		} else {
			financeWith = null;
		}

		if (finance) {
			transformedRequest.caravans[0].financeType = finance;

			if (
				financeWith &&
				financeWith.hasOwnProperty('label') &&
				financeWith.hasOwnProperty('value')
			) {
				transformedRequest.caravans[0].financeCompany = {};

				transformedRequest.caravans[0].financeCompany.name =
					financeWith.label;
				transformedRequest.caravans[0].financeCompany.publicID =
					financeWith.value;
			}
		}

		return transformedRequest;
	}

	// function isItemMarkedForDelete(typeName, item) {
	// 	var toRemove = aggregatedRemoveService.getList();
	// 	var itemsToRemove = toRemove[typeName] || [];
	// 	var removeItem = false ;
	// 	itemsToRemove.some(function(itemToRemove) {
	// 		if ( itemToRemove._aggregator.id == item._aggregator.id){
	// 			removeItem = true;
	// 			return;
	// 		}
	// 	});
	// 	return removeItem;
	// }

	function updateAgreedValue(transformedRequest, userInput) {
		var sumInsured = userInput.caravanForm.sumInsured;

		if (sumInsured && sumInsured.agreedValue) {
			transformedRequest.caravans[0].agreedAmountValue =
				sumInsured.agreedValue;
		}

		return transformedRequest;
	}

	function updateAnnexeValue(transformedRequest, userInput) {
		var sumInsured = userInput.caravanForm.sumInsured;

		if (sumInsured && sumInsured.annexeReplacementCost) {
			transformedRequest.caravans[0].replacementCostValue =
				sumInsured.annexeReplacementCost;
		}

		return transformedRequest;
	}

	function updatePurchasePrice(transformedRequest, userInput) {
		var caravanDetails = userInput.caravanForm.caravanDetails,
			aboutYourContents = userInput.caravanForm.aboutYourContents,
			purchasePrice = 100;

		if (caravanDetails && caravanDetails.purchasePrice) {
			purchasePrice = caravanDetails.purchasePrice;
		} else if (aboutYourContents && aboutYourContents.agreedValue) {
			// Use the agreed value if they're coming from rapid estimate
			purchasePrice = aboutYourContents.agreedValue;
		}

		transformedRequest.caravans[0].purchasePrice = purchasePrice;

		return transformedRequest;
	}

	//updates the email
	function updateEmail(transformedRequest, userInput) {
		if (
			userInput.caravanForm &&
			userInput.caravanForm.tellUsABitMore &&
			userInput.caravanForm.tellUsABitMore.yourEmailAddress
		) {
			transformedRequest.email =
				userInput.caravanForm.tellUsABitMore.yourEmailAddress;
		} else {
			//set email from maincontact if not available in tellUsABitMore
			if (
				userInput.caravanForm &&
				userInput.caravanForm.mainPolicyHolderContact &&
				userInput.caravanForm.mainPolicyHolderContact.emailAddress1
			) {
				transformedRequest.email =
					userInput.caravanForm.mainPolicyHolderContact.emailAddress1;
			}
		}

		// send the campaign code to GW
		if (
			userInput.caravanForm &&
			userInput.caravanForm.tellUsABitMore &&
			userInput.caravanForm.tellUsABitMore.promotionalCode
		) {
			transformedRequest.campaignCode =
				userInput.caravanForm.tellUsABitMore.promotionalCode;
		}

		return transformedRequest;
	}

	//dd-1040 - function to update hasCurrentInsurance field when yearContinuous Insurance > 0
	function updateCurrentInsurance(transformedRequest, userInput) {
		if (
			transformedRequest.caravans[0].drivers[0].driver &&
			transformedRequest.caravans[0].drivers[0].driverUsage == 'main'
		) {
			if (
				transformedRequest.caravans[0].drivers[0].driver
					.yearsContinuousInsurance != '0'
			) {
				var claims = Object.extend(transformedRequest.caravans[0], {
					yearsContinuousInsurance:
						transformedRequest.caravans[0].drivers[0].driver
							.yearsContinuousInsurance,
					timeSinceLastClaim:
						transformedRequest.caravans[0].drivers[0].driver
							.timeSinceLastClaim,
					hasCurrentInsurance: true
				});
			}
		}
		return transformedRequest;
	}

	function updateStampDutyEligibility(transformedRequest, userInput) {
		var stampDutyEligible = storage.getItem('stamp-duty');
		if (userInput.caravanForm.stampDutyExemption && stampDutyEligible) {
			transformedRequest.caravans[0].isSmallBusiness =
				userInput.caravanForm.stampDutyExemption.isSmallBusiness;
		} else {
			delete transformedRequest.caravans[0].isSmallBusiness;
		}
		return transformedRequest;
	}

	function updatePolicyAddress(transformedRequest, userInput) {
		var postalAddress = storage.getItem('policy-address');

		if (angular.isDefined(userInput.caravanForm.mainPolicyHolderContact)) {
			if (transformedRequest.postalAddress !== null) {
				transformedRequest.policyAddress =
					transformedRequest.postalAddress;
			} else {
				if (
					Object.keys(postalAddress).length > 0 &&
					!userInput.caravanForm.mainPolicyHolderContact.postalOption
				) {
					transformedRequest.policyAddress = postalAddress;
				}
			}
		} else {
			if (Object.keys(postalAddress).length > 0) {
				transformedRequest.policyAddress = postalAddress;
			}
		}
		delete transformedRequest.postalAddress;
		return transformedRequest;
	}

	function transform(userInput) {
		var transformedRequest = jsonMapper.transform(
			userInput,
			structureQuoteMapping
		);

		// Caravan
		transformedRequest = updateVehicleDetails(
			transformedRequest,
			userInput
		);
		transformedRequest = updateVehicleSubType(
			transformedRequest,
			userInput
		);
		transformedRequest = updateCaravanInfo(transformedRequest, userInput);
		transformedRequest = updateFinanceType(transformedRequest, userInput);
		transformedRequest = updateAgreedValue(transformedRequest, userInput);
		transformedRequest = updateAnnexeValue(transformedRequest, userInput);
		transformedRequest = updatePurchasePrice(transformedRequest, userInput);

		// Contents
		transformedRequest = updateContentsItems(transformedRequest, userInput);

		// Main driver/insured
		transformedRequest = updateStampDutyEligibility(
			transformedRequest,
			userInput
		);
		transformedRequest = updateDrivers(transformedRequest, userInput);

		// Contact
		transformedRequest = updatePolicyHolders(transformedRequest, userInput);

		// Quote
		transformedRequest = updateTotalCaravanValue(
			transformedRequest,
			userInput
		);
		transformedRequest = updateTotalSpecifiedContentsValue(
			transformedRequest,
			userInput
		);
		transformedRequest = updateTotalContentsSpecifiedValue(
			transformedRequest,
			userInput
		);
		transformedRequest = updateDiscountLayup(transformedRequest, userInput);
		transformedRequest = updateOnSiteDiscount(
			transformedRequest,
			userInput
		);
		transformedRequest = updateVehicleInsuranceOptionalBenefits(
			transformedRequest,
			userInput
		);
		transformedRequest = updateEmail(transformedRequest, userInput);
		transformedRequest = updateCurrentInsurance(
			transformedRequest,
			userInput
		);
		transformedRequest = updatePolicyAddress(transformedRequest, userInput);
		return transformedRequest;
	}

	function transposeMonth(monthName) {
		var months = {
			January: '01',
			February: '02',
			March: '03',
			April: '04',
			May: '05',
			June: '06',
			July: '07',
			August: '08',
			September: '09',
			October: '10',
			November: '11',
			December: '12'
		};

		return months[monthName];
	}

	return {
		transform: transform
	};
}

function CaravanTriggerGoalTransformer(jsonMapper, util, quoteOptions) {
	function transform(userInput) {
		var policyHolder = userInput.policyHolders[0];
		var address = userInput.policyAddress;
		
		var request = {
			Email:  policyHolder.contact.emailAddress1,
			FirstName: policyHolder.contact.firstName,
			LastName: policyHolder.contact.lastName,
			AddressLine: address.addressLine1,
			City: address.city,
			State: address.state,
			PostCode: address.postalCode,
			CountryCode: "Australia",
			Product: "Caravan",
			UserAgent: "SPA-Caravan"
		};
		return request;
	}

	return {
		transform: transform
	}
}

"use strict";

function GtmService($window, campaignService) {
	var dataLayer = $window.dataLayer;

	function addStandardTrackingToDataLayer(obj) {
		if (dataLayer) {
			if (dataLayer.length > 0) {
				var dataLayerLastItem = dataLayer[dataLayer.length - 1];
				var isMatched = (obj.event == dataLayerLastItem.event && 
					obj.eventAction == dataLayerLastItem.eventAction && 
					obj.eventCategory == dataLayerLastItem.eventCategory && 
					obj.eventLabel == dataLayerLastItem.eventLabel && 
					obj.nonInteraction == dataLayerLastItem.nonInteraction);

				if (!isMatched) {
					dataLayer.push(obj);
				}
			}
			else {
				dataLayer.push(obj);
			}
		}		
	}

	function trackTransactionCompleted(page, policyDetails, quoteModel, paymentRef, receiptNumber, paymentType) {
		var selectedQuote = quoteModel.selectedQuoteForPayment,
			offering = quoteModel.offering,
			coverType = selectedQuote ? selectedQuote.coverType : null,
			combinedCoverType = getCombinedCoverType(coverType, offering),
			paymentPlan = selectedQuote ? selectedQuote.paymentPlan : null,
			activeCampaign = campaignService.getCampaign(),
			campaignId = activeCampaign ? activeCampaign.sc_camp : null;

		var trackingData = {
			event: "virtualPageTransaction",
			virtualPageUrl: page.url,
			virtualPageTitle: page.name,
			productCode: quoteModel.productCode,
			transactionId: policyDetails.policyNumber,
			transactionAffiliation: quoteModel.gtmTransactionAffiliation,
			transactionTotal: selectedQuote ? selectedQuote.totalPremium : null,
			totalFSL: selectedQuote ? selectedQuote.totalFSL : null,
			totalGST: selectedQuote ? selectedQuote.totalGST : null,
			totalStampDuty: selectedQuote ? selectedQuote.totalStampDuty : null,
			data: {
				paymentReference: paymentRef,
				policyId: policyDetails.policyNumber,
				receiptNumber: receiptNumber,
				paymentType: paymentType,
			},
			transactionProducts: [
				{
					sku: quoteModel.productCode,
					name: quoteModel.productCode,
					category: combinedCoverType,
					coupon: quoteModel.campaignCode,
					paymentFrequency: paymentPlan
						? paymentPlan.paymentFrequency
						: null,
					price: selectedQuote
						? selectedQuote.premiumAfterDiscount
						: null,
					quantity: 1
				}
			]
		};
		dataLayer.push(trackingData);
	}

	function trackTransaction(page, policyDetails, quoteModel) {
		var selectedQuote = quoteModel.selectedQuoteForPayment,
			offering = quoteModel.offering,
			coverType = selectedQuote ? selectedQuote.coverType : null,
			combinedCoverType = getCombinedCoverType(coverType, offering),
			paymentPlan = selectedQuote ? selectedQuote.paymentPlan : null,
			activeCampaign = campaignService.getCampaign(),
			campaignId = activeCampaign ? activeCampaign.sc_camp : null;

		var trackingData = {
			event: "virtualPageTransaction",
			virtualPageUrl: page.url,
			virtualPageTitle: page.name,
			productCode: quoteModel.productCode,
			transactionId: policyDetails.policyNumber,
			transactionAffiliation: quoteModel.gtmTransactionAffiliation,
			transactionTotal: selectedQuote ? selectedQuote.totalPremium : null,
			totalFSL: selectedQuote ? selectedQuote.totalFSL : null,
			totalGST: selectedQuote ? selectedQuote.totalGST : null,
			totalStampDuty: selectedQuote ? selectedQuote.totalStampDuty : null,
			transactionProducts: [
				{
					sku: quoteModel.productCode,
					name: quoteModel.productCode,
					category: combinedCoverType,
					coupon: quoteModel.campaignCode,
					paymentFrequency: paymentPlan
						? paymentPlan.paymentFrequency
						: null,
					price: selectedQuote
						? selectedQuote.premiumAfterDiscount
						: null,
					quantity: 1
				}
			]
		};
		dataLayer.push(trackingData);
	}

	function getCombinedCoverType(coverType, offering) {
		var combinedCoverType = null;
		if (coverType) {
			combinedCoverType = coverType;
			if (offering) {
				combinedCoverType += "_" + offering;
			}
		}
		return combinedCoverType;
	}

	function trackEvent(eventName, evt) {
		var trackingData = {};

		if (evt === "validationError") {
			trackingData = {
				validationError: eventName
			};
		} else if (evt === "paymentError") {
			trackingData = {
				paymentError: eventName
			};
		} else if (evt === "formValidationError") {
			trackingData = eventName;
		}
		else {
			trackingData = {
				event: eventName
			};
		}

		dataLayer.push(trackingData);
	}

	/////gdd-8403
	function getSha256(dataString) {
		if (!dataString) { return null; }
		return sha256(dataString);
	}

	function streetTypeAbbreviation(addressLine) {		
		if (!addressLine) { return null; }
		return addressLine.trim().toLowerCase()
				.replace(' street', 'st').replace(' road', 'rd')
				.replace(' alley', 'ally').replace(' arcade', 'arc')
				.replace(' avenue', 'ave').replace(' boulevard', 'bvd')
				.replace(' bypass', 'bypa').replace(' circuit', 'cct')
				.replace(' close', 'cl').replace(' corner', 'crn')
				.replace(' court', 'ct').replace(' crescent', 'cres')
				.replace(' cul-de-sac', 'cds').replace(' drive', 'dr')
				.replace(' esplanade', 'esp').replace(' green', 'grn')
				.replace(' grove', 'gr').replace(' highway', 'hwy')
				.replace(' junction', 'jnc').replace(' parade', 'pde')
				.replace(' place', 'pl').replace(' ridge', 'rdge')
				.replace(' terrace', 'tce');
	}

	function nomalizeAddress(quoteModel) {
		if (!quoteModel || !quoteModel.address) {
			return null;
		}
		var addr = quoteModel.address;
		var address = streetTypeAbbreviation(addr.addressLine1)
						 + addr.city + addr.state + addr.postalCode;		
		return address.replace(/\s|,|:|-|AU_|_||\(|\)|'|\/|\./gi, '')
					  .trim().toLowerCase();
	}

	function harshAddress(quoteModel) {
		return getSha256(nomalizeAddress(quoteModel));
	}

	function harshEmail(emailAddress) {
		if (!emailAddress) { return null; }
		return getSha256(emailAddress.trim().replace(/\s/gi, '').toLowerCase());
	}

	function harshPhoneNumber(phoneNo) {
		if (!phoneNo) { return null; }
		return getSha256(phoneNo.trim().replace(/\s|-/gi, '').toLowerCase());
	}

	function harshRego(regoNo) {
		if (!regoNo) { return null; }
		return getSha256(regoNo.trim().replace(/\s/gi, '').toLowerCase());
	}

	function getPhoneNumber(quoteModel) {
		if (!quoteModel) { return null; }
		if (quoteModel.insuranceType === 'Bike') {
			if (!quoteModel 
				|| !quoteModel.gtmPolicyHolder 
				|| !quoteModel.gtmPolicyHolder.phoneNumber) {
				return null;
			}
			return quoteModel.gtmPolicyHolder.phoneNumber;
		}
		if (quoteModel.insuranceType === 'Caravan') {
			if (!quoteModel 
				|| !quoteModel.mainPolicyHolder 
				|| !quoteModel.mainPolicyHolder.primaryPhoneNumber) {
				return null;
			}
			return quoteModel.mainPolicyHolder.primaryPhoneNumber;
		}
		return null;
	}
	/////End gdd-8403

	function trackPageView(page, quoteModel) {
		//dd-6334 - do not trigger this event for Unauth Payments
		if (quoteModel.gtmTransactionAffiliation !== "payments") {
			var selectedQuote = quoteModel.selectedQuoteForPayment
					? quoteModel.selectedQuoteForPayment
					: null,
				offering = quoteModel.offering,
				coverType = selectedQuote ? selectedQuote.coverType : null,
				combinedCoverType = getCombinedCoverType(coverType, offering),
				gtmPolicyHolder = quoteModel.gtmPolicyHolder,
				postCode = quoteModel.postCode,
				activeCampaign = campaignService.getCampaign(),
				campaignId = activeCampaign ? activeCampaign.sc_camp : null;

			var trackingData = {
				event: "virtualPageView",
				virtualPageUrl: page.url,
				virtualPageTitle: page.name,
				qqOption: selectedQuote ? selectedQuote.totalPremium : null,
				qqEstimate: selectedQuote ? selectedQuote.totalPremium : null,
				DOB: gtmPolicyHolder
					? moment(gtmPolicyHolder.dateOfBirth, "DD/MM/YYYY").format(
							"DD/MM/YYYY"
					  )
					: null,
				custGender: gtmPolicyHolder ? gtmPolicyHolder.gender : null,
				postCode: postCode,
				insuranceType: quoteModel.insuranceType,
				coverType: combinedCoverType,
				quoteNo: quoteModel.quoteId,
				sitecoreCampaignId: campaignId,
				attributes: {
					route: page.url
				},
				data: {
					registrationHash: harshRego((quoteModel.regoDetails) ? quoteModel.regoDetails.regoNumber : null),
					emailHash: harshEmail(quoteModel.email),
					phoneHash: harshPhoneNumber(getPhoneNumber(quoteModel)),
					addressHash: harshAddress(quoteModel)
				}
			};
			dataLayer.push(trackingData);
		}
	}

	/*
	 * dd-6181-function to track events for unauthenticated payments
	 * parameters-page data, payment data
	 * return-none
	 */
	function trackUnauthPayments(page, paymentData, paymentType, receiptNumber, policyNumber) {
		var trackingData;

		if (page.name == "payments.payments") {
			trackingData = {
				event: "VirtualPageview",
				virtualPageUrl: page.url,
				virtualPageTitle: page.progressBarShortTitle,
				productCode: paymentData.selectInsuranceType,
				paymentRef: paymentData.enterPaymentRef,
				paymentMethod: paymentData.howToPay
			};
		} else {
			trackingData = {
				event: "virtualPageTransaction",
				virtualPageUrl: page.url,
				virtualPageTitle: page.progressBarShortTitle,
				transactionId: paymentData.transactionId,
				transactionTotal: paymentData.amount.amountPay,
				profile: "QBE Direct Online",
				data: {
					paymentReference: paymentData.referenceNumber,
					policyId: policyNumber,
					receiptNumber: receiptNumber,
					paymentType: paymentType,
				},
				transactionProducts: [
					{
						sku: paymentData.transactionId,
						name: paymentData.transactionId,
						coupon: "",
						price: paymentData.amount.amountPay,
						quantity: 1
					}
				]
			};
		}

		dataLayer.push(trackingData);
	}

	function trackCTPEvent(type, page, action) {
		var trackingData;
		var url = page.url.split("?");

		switch (type) {
			case "gaClick":
				trackingData = {
					event: type,
					eventCategory: page.progressBarTitle,
					eventAction: action,
					eventLabel: url[0]
				};
				break;
			case "VirtualPageview":
				trackingData = {
					event: type,
					virtualPageUrl: url[0],
					virtualPageTitle: "Summary"
				};
				break;
			case "gaFormSubmission":
				trackingData = {
					event: type,
					eventCategory: page.progressBarTitle,
					eventAction: action.event,
					eventLabel: url[0],
					expiryDate: action.expiryDate,
					paymentNumber: action.paymentNumber,
					clientNumber: action.clientNumber
				};
				break;
			default:
		}

		dataLayer.push(trackingData);
	}

	function trackStandardEvent(category, action, label, nonInteraction) {
		if (!$window.qbeTrack) {
			return;
		}

		var item = {
			event: 'standard',
			eventCategory: category, 
			eventAction: action,
			eventLabel: label,
			nonInteraction: nonInteraction
		};

		addStandardTrackingToDataLayer(item);
	}

	function trackProductSelect(productType) {
		if (!$window.qbeTrack || !productType) {
			return;
		}
		$window.qbeTrack.meta.appProduct = productType;
		trackStandardEvent('click drop down', 'Select Insurance Type', productType, false);
	}

	function trackTooltipMouseOver(tooltipMessage) {
		trackStandardEvent('mouse over', 'tooltip', tooltipMessage, false);
	}

	function trackPayBillVirtualPageLanding() {		
		dataLayer.push({
			event: 'virtualPageView',
			virtualPagePath: '/au/pay-bills/welcome',
			virtualPageTitle: 'Welcome - Pay My Bills | QBE AU',
		});
	}

	function trackPayBillVirtualBillFound(paymentRef, policyNumber) {
		var dataObj = {
			paymentReference: paymentRef,
			policyId: policyNumber,
		};

		dataLayer.push({
			event: 'virtualPageView',
			virtualPagePath: '/au/pay-bills/bill-found',
			virtualPageTitle: 'Bill Found - Pay My Bills | QBE AU',
			data: dataObj,
		});
	}

	function trackPayBillVirtualPageDetails(paymentRef, policyNumber, paymentType) {
		var dataObj = {
			paymentReference: paymentRef,
			policyId: policyNumber,
		};
		if (paymentType) {
			dataObj.paymentType = paymentType;
		}

		dataLayer.push({
			event: 'virtualPageView',
			virtualPagePath: '/au/pay-bills/payment-details',
			virtualPageTitle: 'Payment Details- Pay My Bills | QBE AU',
			data: dataObj,
		});
	}

	function trackApiError(errCode, errMessage) {
		dataLayer.push({
			event: 'standard',
			eventCategory: 'error',
			eventAction: 'api',
			eventLabel: errMessage, 
			nonInteraction: true,
			data: {
				errorCode: (!errCode) ? '(not set)' : errCode,
			}
		});
	}

	function createGtmValidationErrorEvent(errorMessageTitle) {
		return {
			event: 'validation_error',
			eventCategory: 'validation error',
			eventAction: 'validation error',
			eventLabel: errorMessageTitle, // error validation title
		};
	}

	return {
		trackTransaction: trackTransaction,
		trackTransactionCompleted: trackTransactionCompleted,
		trackPageView: trackPageView,
		trackEvent: trackEvent,
		trackUnauthPayments: trackUnauthPayments,
		trackCTPEvent: trackCTPEvent,
		trackStandardEvent: trackStandardEvent,
		trackProductSelect: trackProductSelect,
		trackTooltipMouseOver: trackTooltipMouseOver,
		trackPayBillVirtualPageLanding: trackPayBillVirtualPageLanding,
		trackPayBillVirtualBillFound: trackPayBillVirtualBillFound,
		trackPayBillVirtualPageDetails: trackPayBillVirtualPageDetails,
		trackApiError: trackApiError,
		createGtmValidationErrorEvent: createGtmValidationErrorEvent,
	};
}
(function() {
  'use strict';
 
  angular
    .module('qbePortal.routes')
    .run($run);
 
  var dataLayer = window.dataLayer = window.dataLayer || [];
 
  $run.$inject = ['$rootScope', '$state' , 'gtmService', 'quoteModelFactory'];

  /**
  * track virtual page views for all page.
  */ 
  function $run($rootScope, $state, gtmService, quoteModelFactory) {
 
    $rootScope.$on('$stateChangeSuccess', function() {
      gtmService.trackPageView($state.current, quoteModelFactory.create());
    });
 
  }
 
})(angular);

function AggregatedRemoveService(storage) {
	

	function markForDelete(typeName, item) {
		var itemsMarkedForDelete = storage.getItem('itemsMarkedForDelete') || {} ; 
		itemsMarkedForDelete[typeName] = itemsMarkedForDelete[typeName] || [] ; 
		itemsMarkedForDelete[typeName].push(item);
		storage.setItem('itemsMarkedForDelete', itemsMarkedForDelete) ; 
	}

	function getList() {
		var items = storage.getItem('itemsMarkedForDelete');
		if ( ! Object.keys(items) )
			items = null ; 

		return items;
	}

	function clear(typeName) {
		var itemsMarkedForDelete = storage.getItem('itemsMarkedForDelete') || {} ; 
		if ( itemsMarkedForDelete[typeName])
			delete itemsMarkedForDelete[typeName] ; 
		storage.setItem('itemsMarkedForDelete', itemsMarkedForDelete) ; 
	}

	return {
		markForDelete: markForDelete,
		getList: getList,
		clear: clear,
	}
}
function BikeQuoteConfiguration(){
	this.coverTypeClasses = {
		comprehensive : {
			label : 'Comprehensive',
			subClasses : {
				standard: {
					label: 'Comprehensive',
					descriptor: 'comprehensive',
					superType: 'comprehensive'
				},
			}
		},
		third_party: {
			label: 'Third Party',
			subClasses : {
				standard: {
					label: 'Third party only',
					descriptor: 'thirdpartyonly',
					superType: 'third_party'
				},
				fire_and_theft: {
					label: 'Third party fire and theft',
					descriptor: 'thirdpartyfiretheft',
					superType: 'third_party'
				},
			}
		}
	};

	this.allCoverTypes = {
		comprehensive_standard: this.coverTypeClasses.comprehensive.subClasses.standard,
		third_party_fire_theft:this.coverTypeClasses.third_party.subClasses.fire_and_theft,
		third_party_standard:  this.coverTypeClasses.third_party.subClasses.standard,
		// platinum: this.coverTypeClasses.platinum.subClasses.standard,
	};

	this.allCoverTypesByKey = {
		comprehensive: this.coverTypeClasses.comprehensive.subClasses.standard,
		third_party_fire_theft: this.coverTypeClasses.third_party.subClasses.fire_and_theft,
		third_party: this.coverTypeClasses.third_party.subClasses.standard,
	};


	this.allPaymentFrequencies = {
		annual: 'everyyear',
		monthly: 'monthly',
		fortnightly: 'everyotherweek'
	};

	this.defaultPaymentFrequency = 'annual' ; // this.allPaymentFrequencies.annual;

	this._reversePaymentFrequenciesLookup = {
		yearly: 'annual',
		monthly: 'monthly',
		fortnightly: 'fortnightly'
	};

	this.allQuoteTypes = {
		full: 'Full',
		quick: 'Quick',
	};

	this.quoteRuleOptions = {
		// Rapid estimate quote options
		'rapidEstimate': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'motorcycle.estimate' // Note : THESE ARE GUIDEWIRE RULESET AND DO NOT NECESSARILY CORRESPOND TO PAGE NAMES.
			},
			permutations: {
				quoteType: this.allQuoteTypes.quick,
				coverTypes: Object.values(this.allCoverTypes),
				paymentFrequencies: [this.allPaymentFrequencies.annual, this.allPaymentFrequencies.monthly]
			}
		},
		'bike.riders': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'motorcycle.rider' // Note : THESE ARE GUIDEWIRE RULESET AND DO NOT NECESSARILY CORRESPOND TO PAGE NAMES.
			},
			permutations: {
				quoteType: this.allQuoteTypes.quick,
				// coverTypes: Object.values(this.allCoverTypes),
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'bike.quote': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'motorcycle.quote'
			},
			permutations: {
				// coverTypes: Object.values(this.allCoverTypes),
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual, this.allPaymentFrequencies.monthly]
			}
		},
		'bike.contact': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'motorcycle.contacts'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'bike.payment': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'motorcycle.payment'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: Object.values(this.allPaymentFrequencies)
			}
		}
	};

	this.testQuoteDeclineOptions = {
		'bike.bike' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'motorcycle.motorcycle'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'bike.riders' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'motorcycle.rider'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'bike.quote' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'motorcycle.quote'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		}
	}

	this.defaultCoverType = this.allCoverTypes.comprehensive_standard;

	this.defaultRequotePageName = 'bike.quote';
}

'use strict';

function CampaignService(ipCookie, util, labelService, CAMPAIGN_COOKIE_EXPIRY) {
	var campaignId = null;

	function init() {
		var campaignIdFromCookie = ipCookie('sc_camp');
		var campaignIdFromQS = util.getQueryStringByName(window.location, 'sc_camp');

		// //expires: CAMPAIGN_COOKIE_EXPIRY, expirationUnit: 'milliseconds'
		campaignId = campaignIdFromQS ? campaignIdFromQS : campaignIdFromCookie;
		if (campaignIdFromQS)
			ipCookie('sc_camp', campaignIdFromQS, {});
	}

	function hasActiveCampaign() {
		return campaignId != null;
	}

	function getActiveCampaignId() {
		return campaignId;
	}

	function getCampaign() {
		if (!campaignId)
			return null;

		var campaign = labelService.extractCampaignInfoFor(campaignId);
		if (!campaign)
			void 0;

		return campaign;
	}

	function getCampaignConfig(code, isCampaignNextStep) {
		var campaignText;

		if (isCampaignNextStep) {
			campaignText = util.isUndefinedOrNull(labelService.getGlobalOptionLabel('campaignConfiguration', code)) ?
				null : labelService.getGlobalOptionLabel('campaignConfiguration', code);
		} else {
			campaignText = util.isUndefinedOrNull(labelService.getGlobalOption('campaignBannerConfiguration', code)) ?
				null : labelService.getGlobalOption('campaignBannerConfiguration', code).bannerContent;
		}
		var campaignData = {
			isCampaignCodeValid: true,
			content: campaignText
		}

		if (util.isUndefinedOrNull(campaignText)) {
			campaignData.isCampaignCodeValid = false;
		}

		return campaignData;
	}

	return {
		init: init,
		hasActiveCampaign: hasActiveCampaign,
		getActiveCampaignId: getActiveCampaignId,
		getCampaign: getCampaign,
		getCampaignConfig: getCampaignConfig
	}
}

function CaravanQuoteConfiguration(){
	this.coverTypeClasses = {
		comprehensive : {
			label : 'Comprehensive',
			subClasses : {
				standard: {
					label: 'Comprehensive',
					descriptor: 'comprehensive',
					superType: 'comprehensive'
				}
			}
		},
	};

	this.allCoverTypes = {
		comprehensive_standard: this.coverTypeClasses.comprehensive.subClasses.standard
	};

	this.allCoverTypesByKey = {
		comprehensive: this.coverTypeClasses.comprehensive.subClasses.standard
	};


	this.allPaymentFrequencies = {
		annual: 'everyyear',
		monthly: 'monthly',
		fortnightly: 'everyotherweek'
	};

	this.defaultPaymentFrequency = this.allPaymentFrequencies.annual;

	this._reversePaymentFrequenciesLookup = {
		yearly: 'annual',
		monthly: 'monthly',
		fortnightly: 'fortnightly'
	};

	this.allQuoteTypes = {
		full: 'Full',
		quick: 'Quick',
	};

	this.quoteRuleOptions = {
		// Rapid estimate quote options
		'rapidEstimate': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'caravan.estimate' // Note : THESE ARE GUIDEWIRE RULESET AND DO NOT NECESSARILY CORRESPOND TO PAGE NAMES.
			},
			permutations: {
				quoteType: this.allQuoteTypes.quick,
				coverTypes: Object.values(this.allCoverTypes),
				paymentFrequencies: [this.allPaymentFrequencies.annual, this.allPaymentFrequencies.monthly]
			}
		},
		'caravan.drivers': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'caravan.policyHolder' // Note : THESE ARE GUIDEWIRE RULESET AND DO NOT NECESSARILY CORRESPOND TO PAGE NAMES.
			},
			permutations: {
				quoteType: this.allQuoteTypes.quick,
				coverTypes: Object.values(this.allCoverTypes),
				paymentFrequencies: [this.allPaymentFrequencies.annual, this.allPaymentFrequencies.monthly]
			}
		},
		'caravan.quote': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'caravan.quote'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual, this.allPaymentFrequencies.monthly]
			}
		},
		'caravan.contact': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'caravan.contacts'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'caravan.payment': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'caravan.payment'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: Object.values(this.allPaymentFrequencies)
			}
		}
	};

	this.testQuoteDeclineOptions = {
		'caravan.caravan' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'caravan.caravan'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'caravan.drivers' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'caravan.policyHolder'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'caravan.quote' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'caravan.quote'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'caravan.contact' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'caravan.contacts'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		}
	}

	this.defaultCoverType = this.allCoverTypes.comprehensive_standard;
	this.defaultRequotePageName = 'caravan.quote';
}

(function() {
  'use strict';

  angular
    .module('qbePortal.routes')
    .run($run);


  $run.$inject = ['$rootScope', '$state' , '$stateParams', 'Util', 'storage', 'MODULE_INFO'];

  /**
  * track virtual page views for all page.
  */
  function $run($rootScope, $state, $stateParams, util, storage, MODULE_INFO) {


    $rootScope.$on('$stateChangeSuccess', function() {
      var completed = typeof(storage.getItem('completed-step')) === 'string' ? storage.getItem('completed-step') : null ;
      var fromRapidEstimate = typeof(storage.getItem('ignoreRapidEstimateRoute')) === 'string' ? true : false;
	  var isRetrieval = storage.getItem('retrieve');
      util.dispatchCustomEvent('route-changed' , {current: $state.current, completed: completed});


     /** clean up storage on the first load of the first route
      * it's important this does not run when user comes back to
      * the first route through back or progress bar.
      */
      if ( !completed && !isRetrieval
           && $state.current.name == MODULE_INFO.startRouteName
           && ! fromRapidEstimate
           ) {
         storage.clear();
      }

      storage.removeItem('ignoreRapidEstimateRoute');
    });

    window.addEventListener('route-disallowed', function (e) {
       var redirect = e.detail.redirect || MODULE_INFO.startRouteName ;
       $state.go(redirect);
    });

     window.addEventListener('cross-route-disallowed', function (e) {
       var redirect = MODULE_INFO.startRouteName ;
       storage.clear();
       $state.go(redirect);
    });

  }
})(angular);

angular
	.module('qbePortal.services')
	.constant('STATES', [
		{
			label: 'ACT',
			value: 'ACT'
		},
		{
			label: 'NSW',
			value: 'NSW'
		},
		{
			label: 'NT',
			value: 'NT'
		},
		{
			label: 'QLD',
			value: 'QLD'
		},
		{
			label: 'SA',
			value: 'SA'
		},
		{
			label: 'TAS',
			value: 'TAS'
		},
		{
			label: 'VIC',
			value: 'VIC'
		},
		{
			label: 'WA',
			value: 'WA'
		}
	])
	.constant('CAMPAIGN_COOKIE_EXPIRY', 30)
	.constant('CREDIT_CARD_ATTEMPT', 3)
	.service('Util', Util)
	.filter('excessValue', function() {
		return function(excessValue, baseExcess) {
			return excessValue + baseExcess;
		};
	})
	.service('labelService', ['$window', LabelService])
	.service('validationService', ['labelService', ValidationService])
	.service('storage', ['$window', '$state', SessionStorage])
	.service('userInputRepository', ['storage', 'Util', UserInputRepository])
	.service('hierarchyDecorator', HierarchyDecorator)
	.service('MAService', ['$http', 'campaignService', MAService])
	.service('quoteResultModelBuilder', ['Util', QuoteResultModelBuilder])
	.service('serviceResponseRepository', [
		'storage',
		ServiceResponseRepository
	])
	.service('quoteResultModelFactory', [
		'MODULE_INFO',
		QuoteResultModelFactory
	])
	.service('quoteServiceResponseTransformer', [
		'quoteResultModelBuilder',
		'serviceResponseRepository',
		'quoteResultModelFactory',
		QuoteServiceResponseTransformer
	])
	.service('jsonMapper', ['serviceResponseRepository', JsonMapper])
	.service('splitterRequestTransformer', [
		'Util',
		'serviceResponseRepository',
		'jsonMapper',
		'publicIDTransformer',
		'coverTypeTransformer',
		SplitterRequestTransformer
	])
	.service('quoteOptions', [
		'quoteConfiguration',
		'serviceResponseRepository',
		'quoteResultModelBuilder',
		'storage',
		QuoteOptions
	])
	.service('quoteRequestRepository', [
		'Util',
		'storage',
		'quoteOptions',
		'quoteConfiguration',
		'userInputRepository',
		'serviceResponseRepository',
		'structuredRequestTransformer',
		'defaultValueRequestTransformer',
		'formatConverterTransformer',
		'cleanRequestTransformer',
		'splitterRequestTransformer',
		'publicIDTransformer',
		'policyHolderHandler',
		'coverTypeTransformer',
		'coverTypeResolver',
		'coverOfferingResolver',
		'triggerGoalTransformer',
		QuoteRequestRepository
	])
	.service('portalServiceWrapper', [
		'guideWireService',
		'quoteRequestRepository',
		'serviceResponseRepository',
		'retrieveSavedQuoteResponseTransformer',
		'quoteServiceResponseTransformer',
		'quoteOptions',
		PortalServiceWrapper
	])
	.service('guideWireService', ['$http', 'storage', 'Util', GuideWireService])
	.service('regoSearchService', [
		'guideWireService',
		function(guideWireService) {
			return RegoSearchService.create(guideWireService);
		}
	])
	.service('gtmService', ['$window', 'campaignService', GtmService])
	.service('coverTypeResolver', ['MODULE_INFO', CoverTypeResolverService])
	.service('coverOfferingResolver', [
		'MODULE_INFO',
		CoverOfferingResolverService
	])
	.service('aggregatedRemoveService', ['storage', AggregatedRemoveService])
	.service('quoteResultFilter', QuoteResultFilter)
	.service('campaignService', [
		'ipCookie',
		'Util',
		'labelService',
		'CAMPAIGN_COOKIE_EXPIRY',
		CampaignService
	])
	.service('tokenTimeoutService', [
		'$state',
		'jwtHelper',
		'storage',
		'labelService',
		'MODULE_INFO',
		JWTTimeoutService
	]);

angular
	.module('qbePortal.services.bike')
	/** requires insurance form type */
	.constant('MODULE_INFO', {
		id: 'bike',
		insuranceType: 'Bike',
		routePrefix: 'bike.',
		startRouteName: 'bike.bike',
		productCode: 'QPMMotorBike',
		availableCoverTypes: [],
		mainFormName: 'bikeForm',
		paymentPageRouteName: 'bike.payment',
		donePageRouteName: 'bike.done',
		paymentPanelButtonText: {
			'bike.quote': 'purchase_now',
			'bike.contact': 'proceed_to_payment'
		}
	})
	.service('quoteConfiguration', BikeQuoteConfiguration)
	.service('retrieveSavedQuoteResponseTransformer', [
		'$filter',
		'jsonMapper',
		'Util',
		BikeRetrieveSavedQuoteResponseTransformer
	])
	.service('cleanRequestTransformer', [
		'Util',
		'jsonMapper',
		BikeCleanRequestTransformer
	])
	.service('formatConverterTransformer', [
		'Util',
		'jsonMapper',
		BikeFormatConverterTransformer
	])
	.service('defaultValueRequestTransformer', [
		'Util',
		'jsonMapper',
		BikeDefaultValueRequestTransformer
	])
	.service('structuredRequestTransformer', [
		'jsonMapper',
		'Util',
		'quoteOptions',
		'storage',
		BikeStructureRequestTransformer
	])
	.service('publicIDTransformer', [
		'Util',
		'jsonMapper',
		'serviceResponseRepository',
		'aggregatedRemoveService',
		BikePublicIDTransformer
	])
	.service('policyHolderHandler', [
		'Util',
		'publicIDTransformer',
		BikePolicyHolderHandler
	])
	.service('coverTypeTransformer', [
		'jsonMapper',
		'Util',
		BikeCoverTypeTransformer
	])
	.service('coverTypeResolver', ['MODULE_INFO', CoverTypeResolverService])
	.service('quoteModelFactory', [
		'MODULE_INFO',
		'userInputRepository',
		'serviceResponseRepository',
		'quoteOptions',
		'quoteRequestRepository',
		'Util',
		'$rootScope',
		QuoteModelFactory
	])
	.service('quoteResultModelFactory', [
		'MODULE_INFO',
		QuoteResultModelFactory
	])
	.service('paymentService', [
		'$http',
		'$state',
		'storage',
		'userInputRepository',
		'portalServiceWrapper',
		'quoteModelFactory',
		'Util',
		'quoteOptions',
		'paymentLoggerService',
		function(
			$http,
			$state,
			storage,
			userInputRepository,
			portalServiceWrapper,
			quoteModelFactory,
			util,
			quoteOptions,
			paymentLoggerService
		) {
			return PaymentService.bootstrap(
				$http,
				$state,
				storage,
				userInputRepository,
				portalServiceWrapper,
				quoteModelFactory,
				util,
				quoteOptions,
				paymentLoggerService
			);
		}
	])
	.service('triggerGoalTransformer', [
		'jsonMapper',
		'Util',
		BikeTriggerGoalTransformer
	]);

angular
	.module('qbePortal.services.caravan')
	/** requires insurance form type */
	.constant('MODULE_INFO', {
		id: 'caravan',
		insuranceType: 'Caravan',
		routePrefix: 'caravan.',
		startRouteName: 'caravan.caravan',
		productCode: 'QPCCaravanTrailer',
		mainFormName: 'caravanForm',
		paymentPageRouteName: 'caravan.payment',
		donePageRouteName: 'caravan.done',
		paymentPanelButtonText: {
			'caravan.quote': 'purchase_now',
			'caravan.contact': 'proceed_to_payment'
		}
	})
	.service('quoteConfiguration', CaravanQuoteConfiguration)
	.service('retrieveSavedQuoteResponseTransformer', [
		'$filter',
		'jsonMapper',
		'Util',
		CaravanRetrieveSavedQuoteResponseTransformer
	])
	.service('cleanRequestTransformer', [
		'Util',
		'jsonMapper',
		CaravanCleanRequestTransformer
	])
	.service('formatConverterTransformer', [
		'Util',
		'jsonMapper',
		CaravanFormatConverterTransformer
	])
	.service('defaultValueRequestTransformer', [
		'Util',
		'jsonMapper',
		'userInputRepository',
		'quoteOptions',
		CaravanDefaultValueRequestTransformer
	])
	.service('structuredRequestTransformer', [
		'jsonMapper',
		'Util',
		'quoteOptions',
		'storage',
		CaravanStructureRequestTransformer
	])
	.service('publicIDTransformer', [
		'Util',
		'jsonMapper',
		'serviceResponseRepository',
		'aggregatedRemoveService',
		CaravanPublicIDTransformer
	])
	.service('policyHolderHandler', [
		'Util',
		'publicIDTransformer',
		CaravanPolicyHolderHandler
	])
	.service('coverTypeTransformer', [
		'Util',
		'jsonMapper',
		CaravanCoverTypeTransformer
	])
	.service('coverTypeResolver', ['MODULE_INFO', CoverTypeResolverService])
	.service('quoteModelFactory', [
		'MODULE_INFO',
		'userInputRepository',
		'serviceResponseRepository',
		'quoteOptions',
		'quoteRequestRepository',
		'Util',
		'$rootScope',
		QuoteModelFactory
	])
	.service('paymentService', [
		'$http',
		'$state',
		'storage',
		'userInputRepository',
		'portalServiceWrapper',
		'quoteModelFactory',
		'Util',
		'quoteOptions',
		'paymentLoggerService',
		function(
			$http,
			$state,
			storage,
			userInputRepository,
			portalServiceWrapper,
			quoteModelFactory,
			Util,
			quoteOptions,
			paymentLoggerService
		) {
			return PaymentService.bootstrap(
				$http,
				$state,
				storage,
				userInputRepository,
				portalServiceWrapper,
				quoteModelFactory,
				Util,
				quoteOptions,
				paymentLoggerService
			);
		}
	])
	.filter('vehicleType', function() {
		return function(type) {
			var vehicleTypes = {
				caravan: 'Caravan',
				campertrailer: 'Camper Trailer',
				slideoncamper: 'Slide on Camper',
				goodscarryingtrailer: 'Goods Carrying Trailer',
				campervan: 'Camper Van',
				relocatablehome: 'Relocatable Home',
				motorhome: 'Motor Home'
			};

			return vehicleTypes[type];
		};
	})
	.service('triggerGoalTransformer', [
		'jsonMapper',
		'Util',
		CaravanTriggerGoalTransformer
	]);

angular
	.module('qbePortal.services.home')
	/** requires insurance form type */
	.constant('MODULE_INFO', {
		id: 'home',
		insuranceType: 'Home',
		routePrefix: 'home.',
		startRouteName: 'home.estimate',
		productCode: 'QPHHome',
		availableCoverTypes: [],
		mainFormName: 'homeForm',
		paymentPageRouteName: 'home.payment',
		donePageRouteName: 'home.done',
		paymentPanelButtonText: {
			'home.quote': 'purchase_now',
			'home.contact': 'proceed_to_payment'
		}
	})
	// service('commonData', 'storage', HomeCommonData ).
	.service('quoteConfiguration', HomeQuoteConfiguration)
	.service('retrieveSavedQuoteResponseTransformer', [
		'$filter',
		'jsonMapper',
		'Util',
		HomeRetrieveSavedQuoteResponseTransformer
	])
	.service('splitterRequestTransformer', [
		'Util',
		'serviceResponseRepository',
		'jsonMapper',
		'publicIDTransformer',
		'coverTypeTransformer',
		HomeSplitterRequestTransformer
	])
	.service('cleanRequestTransformer', [
		'Util',
		'jsonMapper',
		HomeCleanRequestTransformer
	])
	.service('formatConverterTransformer', [
		'Util',
		'jsonMapper',
		HomeFormatConverterTransformer
	])
	.service('defaultValueRequestTransformer', [
		'Util',
		'jsonMapper',
		'userInputRepository',
		'quoteOptions',
		HomeDefaultValueRequestTransformer
	])
	.service('structuredRequestTransformer', [
		'jsonMapper',
		'Util',
		'quoteOptions',
		'storage',
		HomeStructureRequestTransformer
	])
	.service('publicIDTransformer', [
		'Util',
		'jsonMapper',
		'serviceResponseRepository',
		HomePublicIDTransformer
	])
	.service('policyHolderHandler', [
		'Util',
		'publicIDTransformer',
		HomePolicyHolderHandler
	])
	.service('coverTypeTransformer', [
		'Util',
		'jsonMapper',
		HomeCoverTypeTransformer
	])
	.service('coverTypeResolver', ['MODULE_INFO', CoverTypeResolverService])
	.service('quoteModelFactory', [
		'MODULE_INFO',
		'userInputRepository',
		'serviceResponseRepository',
		'quoteOptions',
		'quoteRequestRepository',
		'Util',
		'$rootScope',
		QuoteModelFactory
	])
	.service('quoteResultModelFactory', [
		'MODULE_INFO',
		QuoteResultModelFactory
	])
	.service('paymentService', [
		'$http',
		'$state',
		'storage',
		'userInputRepository',
		'portalServiceWrapper',
		'quoteModelFactory',
		'Util',
		'quoteOptions',
		'paymentLoggerService',
		function(
			$http,
			$state,
			storage,
			userInputRepository,
			portalServiceWrapper,
			quoteModelFactory,
			Util,
			quoteOptions,
			paymentLoggerService
		) {
			return PaymentService.bootstrap(
				$http,
				$state,
				storage,
				userInputRepository,
				portalServiceWrapper,
				quoteModelFactory,
				Util,
				quoteOptions,
				paymentLoggerService
			);
		}
	])
	.service('triggerGoalTransformer', [
		'jsonMapper',
		'Util',
		BikeTriggerGoalTransformer
	]);;

angular
	.module('qbePortal.services.vehicle')
	/** requires insurance form type */
	.constant('MODULE_INFO', {
		id: 'vehicle',
		insuranceType: 'Car',
		routePrefix: 'vehicle.',
		startRouteName: 'vehicle.vehicle',
		productCode: 'QPMMotorVehicle',
		availableCoverTypes: [],
		mainFormName: 'vehicleForm',
		paymentPageRouteName: 'vehicle.payment',
		donePageRouteName: 'vehicle.done',
		paymentPanelButtonText: {
			'vehicle.quote': 'purchase_now',
			'vehicle.contact': 'proceed_to_payment'
		}
	})
	// service('commonData', [ 'storage', VehicleCommonData])
	.service('quoteConfiguration', VehicleQuoteConfiguration)
	.service('retrieveSavedQuoteResponseTransformer', [
		'$filter',
		'jsonMapper',
		'Util',
		VehicleRetrieveSavedQuoteResponseTransformer
	])
	.service('cleanRequestTransformer', [
		'Util',
		'jsonMapper',
		VehicleCleanRequestTransformer
	])
	.service('formatConverterTransformer', [
		'Util',
		'jsonMapper',
		VehicleFormatConverterTransformer
	])
	.service('defaultValueRequestTransformer', [
		'Util',
		'jsonMapper',
		'userInputRepository',
		'quoteOptions',
		VehicleDefaultValueRequestTransformer
	])
	.service('structuredRequestTransformer', [
		'jsonMapper',
		'Util',
		'quoteOptions',
		'storage',
		VehicleStructureRequestTransformer
	])
	.service('publicIDTransformer', [
		'Util',
		'jsonMapper',
		'serviceResponseRepository',
		'aggregatedRemoveService',
		VehiclePublicIDTransformer
	])
	.service('policyHolderHandler', [
		'Util',
		'publicIDTransformer',
		VehiclePolicyHolderHandler
	])
	.service('coverTypeTransformer', [
		'Util',
		'jsonMapper',
		VehicleCoverTypeTransformer
	])
	.service('coverTypeResolver', ['MODULE_INFO', CoverTypeResolverService])
	.service('quoteModelFactory', [
		'MODULE_INFO',
		'userInputRepository',
		'serviceResponseRepository',
		'quoteOptions',
		'quoteRequestRepository',
		'Util',
		'$rootScope',
		QuoteModelFactory
	])
	.service('paymentService', [
		'$http',
		'$state',
		'storage',
		'userInputRepository',
		'portalServiceWrapper',
		'quoteModelFactory',
		'Util',
		'quoteOptions',
		'paymentLoggerService',
		function(
			$http,
			$state,
			storage,
			userInputRepository,
			portalServiceWrapper,
			quoteModelFactory,
			Util,
			quoteOptions,
			paymentLoggerService
		) {
			return PaymentService.bootstrap(
				$http,
				$state,
				storage,
				userInputRepository,
				portalServiceWrapper,
				quoteModelFactory,
				Util,
				quoteOptions,
				paymentLoggerService
			);
		}
	]);

angular
	.module('qbePortal.services.ctp')
	/** requires insurance form type */
	.constant('MODULE_INFO', {
		id: 'ctp',
		insuranceType: 'CTP SA',
		routePrefix: 'ctp.',
		startRouteName: 'ctp.ctp',
		productCode: '',
		availableCoverTypes: [],
		mainFormName: 'ctpForm',
		paymentPageRouteName: '',
		donePageRouteName: '',
		paymentPanelButtonText: {}
	})
	.service('quoteConfiguration', GenericConfiguration)
	.service('retrieveSavedQuoteResponseTransformer', [
		'$filter',
		'jsonMapper',
		'Util',
		GenericConfiguration
	])
	.service('cleanRequestTransformer', [
		'Util',
		'jsonMapper',
		GenericConfiguration
	])
	.service('formatConverterTransformer', [
		'Util',
		'jsonMapper',
		GenericConfiguration
	])
	.service('defaultValueRequestTransformer', [
		'Util',
		'jsonMapper',
		GenericConfiguration
	])
	.service('structuredRequestTransformer', [
		'jsonMapper',
		'Util',
		'quoteOptions',
		GenericConfiguration
	])
	.service('publicIDTransformer', [
		'Util',
		'jsonMapper',
		'serviceResponseRepository',
		'aggregatedRemoveService',
		GenericConfiguration
	])
	.service('policyHolderHandler', [
		'Util',
		'publicIDTransformer',
		GenericConfiguration
	])
	.service('coverTypeTransformer', [
		'Util',
		'jsonMapper',
		GenericConfiguration
	])
	.service('coverTypeResolver', ['MODULE_INFO', GenericConfiguration])
	.service('quoteModelFactory', [
		'MODULE_INFO',
		'userInputRepository',
		'serviceResponseRepository',
		'quoteOptions',
		'quoteRequestRepository',
		'Util',
		'$rootScope',
		QuoteModelFactory
	])
	.service('paymentService', [
		'$http',
		'$state',
		'storage',
		'userInputRepository',
		'portalServiceWrapper',
		'quoteModelFactory',
		'Util',
		'quoteOptions',
		function(
			$http,
			$state,
			storage,
			userInputRepository,
			portalServiceWrapper,
			quoteModelFactory,
			Util,
			quoteOptions
		) {
			return PaymentService.bootstrap(
				$http,
				$state,
				storage,
				userInputRepository,
				portalServiceWrapper,
				quoteModelFactory,
				Util,
				quoteOptions
			);
		}
	])
	.service('triggerGoalTransformer', [
		'jsonMapper',
		'Util',
		BikeTriggerGoalTransformer
	]);;

angular
	.module('qbePortal.services.payments')
	.constant('MODULE_INFO', {
		/*id is for QBE bar on top and side bar on left*/
		id: 'payments',
		insuranceType: 'Car',
		routePrefix: 'payments.',
		startRouteName: 'payments.payments',
		productCode: 'QPMMotorVehicle',
		availableCoverTypes: [],
		mainFormName: 'paybillForm',
		paymentPageRouteName: 'payments.payments',
		donePageRouteName: 'payments.complete',
		paymentPanelButtonText: {
			'payments.quote': 'purchase_now',
			'payments.contact': 'proceed_to_payment'
		}
	})
	.service('quoteConfiguration', GenericConfiguration)
	.service('retrieveSavedQuoteResponseTransformer', [
		'$filter',
		'jsonMapper',
		'Util',
		GenericConfiguration
	])
	.service('cleanRequestTransformer', [
		'Util',
		'jsonMapper',
		GenericConfiguration
	])
	.service('formatConverterTransformer', [
		'Util',
		'jsonMapper',
		GenericConfiguration
	])
	.service('defaultValueRequestTransformer', [
		'Util',
		'jsonMapper',
		GenericConfiguration
	])
	.service('structuredRequestTransformer', [
		'jsonMapper',
		'Util',
		'quoteOptions',
		GenericConfiguration
	])
	.service('publicIDTransformer', [
		'Util',
		'jsonMapper',
		'serviceResponseRepository',
		'aggregatedRemoveService',
		GenericConfiguration
	])
	.service('policyHolderHandler', [
		'Util',
		'publicIDTransformer',
		GenericConfiguration
	])
	.service('coverTypeTransformer', [
		'Util',
		'jsonMapper',
		GenericConfiguration
	])
	.service('coverTypeResolver', ['MODULE_INFO', GenericConfiguration])
	.service('quoteModelFactory', [
		'MODULE_INFO',
		'userInputRepository',
		'serviceResponseRepository',
		'quoteOptions',
		'quoteRequestRepository',
		'Util',
		'$rootScope',
		QuoteModelFactory
	])
	.service('paymentService', [
		'$http',
		'$state',
		'storage',
		'userInputRepository',
		'portalServiceWrapper',
		'quoteModelFactory',
		'Util',
		'quoteOptions',
		'paymentLoggerService',
		function(
			$http,
			$state,
			storage,
			userInputRepository,
			portalServiceWrapper,
			quoteModelFactory,
			Util,
			quoteOptions,
			paymentLoggerService
		) {
			return PaymentService.bootstrap(
				$http,
				$state,
				storage,
				userInputRepository,
				portalServiceWrapper,
				quoteModelFactory,
				Util,
				quoteOptions,
				paymentLoggerService
			);
		}
	])
	.service('triggerGoalTransformer', [
		'jsonMapper',
		'Util',
		BikeTriggerGoalTransformer
	]);;

'use strict';
function CoverOfferingResolverService(MODULE_INFO) {
	function resolve(quote) {
		switch (MODULE_INFO.id) {
			case 'home':
				return quote.dwellings[0].offering;
			case 'bike':
			case 'vehicle' :
			case 'caravan':
				return null;
			default:
				throw 'Unknown module info';
		}
	}

	return {
		resolve: resolve
	}
}

'use strict';
function CoverTypeResolverService(MODULE_INFO) {
	function resolve(quote) {
		switch (MODULE_INFO.id) {
			case 'home':
				return quote.dwellings[0].coverType;
			case 'bike':
				return quote.motorcycles[0].coverType ;
			case 'vehicle' :
				return quote.vehicles[0].coverType ;
			case 'caravan':
				return quote.caravans[0].coverType ;
				// return quote.coverType ;
			default:
				throw 'Unknown module info';
		}
	}

	return {
		resolve: resolve
	}
}

"use strict";

function dynamicRouterProvider($stateProvider, util) {
	this.$get = function () {
		return new DynamicRouter(stacks, util);
	};

	var stacks = {};

	function registerCommonRoutes(conf, route, routeName) {
		if( conf.pages[routeName]) {
			var routeConfig = angular.extend({}, conf.pages[routeName], route.config);
			routeConfig.views = {
				'@': {
					title: routeConfig.title,
					templateUrl: routeConfig.templateUrl,
					controller  : routeConfig.controller,
					controllerAs : routeConfig.controllerAs
				},
				'header@': {
					template: routeConfig.title
				}
			};
			$stateProvider.state(routeName, routeConfig);
		}
	}

	function registerStepsRoutes(conf, stack, stackName) {
		var allRoutes = stack.steps.slice();
		allRoutes.push(stack.home);

		for (var key in allRoutes) {
			var route = allRoutes[key];
			var page = conf.pages[route.name];
			var stepNum = parseInt(key) + 1;
			
			if (!(page || route.config.abstract ))
				throw 'Qbe Portal : Expected state URL for state ' + route.name + ' but could not find it';

			if (page) {
				route.config.url = page.url;
				route.config.views['@'].title = page.title;
				route.config.views['@'].templateUrl = page.templateUrl;
				route.config.views['sidebar@'].templateUrl = page.sidebarTemplateUrl;
				// start add updates
		        //route.config.views['progressbar@'].templateUrl = page.progressbarTemplateUrl;
		        //route.config.views['headbar@'].templateUrl = page.headbarTemplateUrl;
		        // end
				route.config.views['meta@'].templateUrl = page.metaTemplateUrl;
				route.config.views['header@'].template = page.title;
				route.config.progressBarTitle = page.progressBarTitle;
				route.config.progressBarShortTitle = 'Step ' + stepNum + ' - ' + page.progressBarShortTitle;
				route.config.stateName = route.name;

				if(page.params) {
					route.config.params = page.params;
				}
			}

			$stateProvider.state(route.name, route.config);
		}
		stacks[stackName] = stack;
	}

	this.init = function (conf, stacks) {
		for (var routeName in routes.common) {
			var route = routes.common[routeName],
				routeConfig;

			if (!route) {
				throw 'Qbe Portal : Expected routing stack with name ' + routeName + ' but could not find it';
			}

			registerCommonRoutes(conf, route, routeName) ;
		}

		for (var key in stacks) {
			var stackName = stacks[key];
			var stack = routes[stackName];
			if (!stack)
				throw 'Qbe Portal : Expected routing stack with name ' + stackName + ' but could not find it';

			registerStepsRoutes(conf, stack, stackName) ;
		}
	};
}

function DynamicRouter(stacks, util) {
	var currentStack,
		currentState,
		currentStep,
		totalSteps,
		steps,
		conditions,
		lastCompletedStep;


	window.addEventListener('route-changed', function (e) {
		lastCompletedStep = typeof(e.detail.completed) === 'string' ? e.detail.completed : null;
	}, false);


	/**
	 * Initialises the dynamic router.
	 * @stateName:  state name of current page e.g. 'vehicle.drivers'
	 * @stackname: name of the parent of current page e.e. 'vehicle'
	 * @stepConditions: optional - a conditions object which may includes conditions for certain states determining if they are visible.
	 */
	function initialise(stateName, stackName, stepConditions, markCompletedFn) {
		if (stackName == "") stackName = stateName; // state is parent state.
		conditions = stepConditions || {} ;
		currentStack = stacks[stackName];
		clearSteps() ;
		steps = getSteps() ;
		var currentStepDef = findStepByName(steps, stateName) ;
		currentState = currentStepDef.name;
		currentStep = currentStepDef.index;
		totalSteps = steps.length;
		checkRouteAllowed(markCompletedFn);
	}

	function checkRouteAllowed(markCompletedFn) {
		/** first route step is always allowed */
		var step = findStepByName(steps, lastCompletedStep);

		if ( currentState.indexOf('.done') !== -1 )
			return true;

		if (!step && lastCompletedStep) {
			dispatchCustomEvent('cross-route-disallowed');
			return false;
		}

		if(currentState == 'home.property'){
			//special condition to allow the home retrieve
			return true;
		}

		if(currentState == 'bike.quote'){
			//special condition to allow the home retrieve
			return true;
		}

		if(currentState == 'caravan.quote'){
			//special condition to allow the home retrieve
			return true;
		}

		if (currentStep > 0) {
			if ( ! step || currentStep > step.index + 1 ){
				dispatchCustomEvent('route-disallowed',
					{
					redirect: lastCompletedStep,
					msg :'Not allowed to navigate to route ' + currentStep
					}
				);
				return false;
			}
		}

		/**
		 * updates the completed route only when backtracking
		 * to previous steps.  For going next update completed
		 * needs to be updated by the next() function.
		 */
		if (step && currentStep < step.index)
			markCompletedFn(currentState) ;

		return true;
	}

	function findStepByName(steps, stateName) {
		var selectedStep = null ;
		steps.some(
			function (step, i) {
				if (step.stateName == stateName) {
					selectedStep = {
						name : stateName,
						index : i,
					};
					return true;
				}
			}
		);
		return selectedStep ;
	}

	function getPageTitle() {
		return steps[currentStep].progressBarTitle;
	}

	function getSteps() {
		if ( currentStack && currentStack.steps ) {
			if ( !steps) {
				steps = currentStack.steps.map(
					function (step, i) {
						var addStep = !conditions[step.config.stateName] || conditions[step.config.stateName]() ;
						if ( addStep )
							return {
								title: step.config.title,
								progressBarTitle: step.config.progressBarTitle,
								progressBarShortTitle: step.config.progressBarShortTitle,
								stepNumber: i,
								stateName : step.config.stateName
							}
					}
				);

				steps = steps.filter(function(step){ return !!step}) ;
			}
		}
		return steps;
	}

	function clearSteps() {
		steps = null ;
	}

	function next(markCompletedFn) {
		markCompletedFn(getCurrentState().name);
		return steps[++currentStep].stateName;
	}

	function getNextState() {
		return steps[currentStep+1].stateName;
	}


	function getCurrentState() {
		return {
			name: steps[currentStep].stateName,
			number: currentStep
		}
	}

	function back() {
		if ( currentStep > 0)
			return steps[--currentStep].stateName;

		return false;
	}

	function getState(step) {
		return steps[step].stateName;
	}

	return {
		initialise: initialise,
		next: next,
		back: back,
		getPageTitle: getPageTitle,
		getSteps: getSteps,
		getState: getState,
		getCurrentState: getCurrentState,
		getNextState: getNextState,
	};
}

(function() {
	"use strict";

	angular
		.module("qbePortal")
		.service("embargoTestService", embargoTestService);

	embargoTestService.$inject = ["$state"];

	function embargoTestService($state) {
		this.testEmbargoDecline = testEmbargoDecline;

		function testEmbargoDecline(response) {
			var data = response.data || response.quote;

			if (data.quoteResult) {
				var declineParams = {
					declineType: "",
					declineCodes: []
				};

				if (data.quoteResult.embargo) {
					declineParams.declineType = "embargo";
				} else if (
					data.quoteResult.referral &&
					!data.quoteResult.embargo
				) {
					declineParams.declineType = "referral";
				} else if (
					data.quoteResult.decline &&
					!data.quoteResult.embargo
				) {
					declineParams.declineType = "decline";
				}

				data.quoteResult.uwIssues.forEach(function(element) {
					declineParams.declineCodes.push(element.typeCode);
				}, this);

				return declineParams;
			}
			return null;
		}
	}
})();

"use strict";

function FormSchemaService(DOM) {
	var schema = {},
		structure = {} ;

	DOM.addEventListener('register-schema', function (e) {
		registerSchema(DOM.qbe);
	}, false);

	function registerSchema(conf) {
		schema = conf.formSchema;
		structure = conf.formStructure;
	}
	
	function extractGroup(groupName, param) {
		var field = structure[groupName] ;
		if ( ! field )
			throw groupName + ' does not exist in the form structure';
		else if ( typeof(field) == 'string' )
			return extractGroup(field) ; 

		return structure[groupName] ; 
	}

	function extractField(fieldName) {
		var field = schema[fieldName];
		if ( ! field )
			throw fieldName + ' does not exist in the form schema/structure';
		return field;
	}
	
	function getGenericValidationMessageFor(rule) {
		return 'generic error message' ; 
	}

	return {
		extractGroup: extractGroup,
		extractField: extractField,
		getGenericValidationMessageFor: getGenericValidationMessageFor,
	};
}

function GenericConfiguration() {
	// handles routes that are not part of the quote process
}

"use strict";

function GuideWireService($http, storage, util) {

    var mulesoftApiHeaders = (endpointUrls.rego.mulesoftApiHeader) 
    ? { 
        'X-SourceSystem': 'Sitecore',
        'X-TrackingID': '',
        'X-Mockable': (endpointUrls.rego.mulesoftApiHeader.xMockable) ? true : false,
    }
    : {};

    var conf = {
        embargo: {
            method: 'GET',
            url: '',
            headers: {
                'X-Mockable': endpointUrls.quote.embargoxMockable,
                'X-SourceSystem': '',
                'X-TrackingID': '',
                'X-TargetEnv': '',
            },
        },
        regoSearch: {
            method: 'GET',
            url: endpointUrls.rego.regoSearch,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc',
                'X-Requested-By': '98wuebh3e2',
                'UserID': ""
            },
        },
        makeSearch: {
            method: 'GET',
            url: endpointUrls.rego.makeSearch,
            headers: getMulesoftApiHeadersForVgi(mulesoftApiHeaders),
        },
        modelSearch: {
            method: 'GET',
            url: endpointUrls.rego.modelSearch,
            headers: getMulesoftApiHeadersForVgi(mulesoftApiHeaders),
        },
        carSearch: {
            method: 'GET',
            url: endpointUrls.rego.carSearch,
            headers: getMulesoftApiHeadersForVgi(mulesoftApiHeaders),
        },
        addressSearch: {
            method: 'GET',
            url: endpointUrls.addresses.addressSearch,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc'
            },
        },
        createQuote: {
            method: 'POST',
            url: endpointUrls.quote.quote,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc',
                'channel': 'portal',
                Accept: "application/json, text/plain, */*",
                'Cache-Control': "no-cache",
                Pragma: "no-cache",
                'X-Requested-By': "92tvt8iy2b"
            },
        },
        updateQuote: {
            method: 'PUT',
            url: endpointUrls.quote.quote,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc',
                'channel': 'portal',
                Accept: "application/json, text/plain, */*",
                'Cache-Control': "no-cache",
                Pragma: "no-cache",
                'X-Requested-By': "92tvt8iy2b"
            },
        },
        quickQuote: {
            method: 'POST',
            url: endpointUrls.quote.quickQuote,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc',
                'channel': 'portal',
                Accept: "application/json, text/plain, */*",
                'Cache-Control': "no-cache",
                Pragma: "no-cache",
                'X-Requested-By': "92tvt8iy2b"
            },
        },
		triggerGoal: {
			method: 'POST',
			url: '/sitecore/api/qbe/Experience/TriggerGoal',
			headers: {
				'EY-Access-Key': 'test123',
				'EY-Product-Type': 'pc',
				'channel': 'portal',
				Accept: "application/json, text/plain, */*",
				'Cache-Control': "no-cache",
				Pragma: "no-cache",
				'X-Requested-By': "92tvt8iy2b"
			},
		},		
        retrieveSavedQuote: {
            method: 'GET',
            url: endpointUrls.quote.retrieveSavedQuote,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc',
                'channel': 'portal',
                Accept: "application/json, text/plain, */*",
                'Cache-Control': "no-cache",
                Pragma: "no-cache",
                'X-Requested-By': "92tvt8iy2b"
            },
        },
        isCampaignCodeValid: {
            method: 'HEAD',
            url: endpointUrls.quote.campaign,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc',
                'X-Requested-By': '92tvt8iy2b'
            },
        },
        refreshAddress: {
            method: 'POST',
            url: endpointUrls.addresses.refresh,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc',
                Accept: "application/json, text/plain, */*",
                'Cache-Control': "no-cache",
                Pragma: "no-cache",
                'X-Requested-By': "92tvt8iy2b"
            },
        },
        refreshVehicleDetails: {
            method: 'GET',
            url: endpointUrls.rego.refresh,
            headers: getMulesoftApiHeadersForVgi(mulesoftApiHeaders),
        },
        refreshCaravanDetails: {
            method: 'GET',
            url: endpointUrls.rego.refresh,
            headers: getMulesoftApiHeadersForVgi(mulesoftApiHeaders),
        },
        isBSBValid: {
            method: 'GET',
            url: endpointUrls.quote.bsbValidation,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc',
                'X-Requested-By': '92tvt8iy2b'
            },
        },
        doesUserExist: {
            method: 'HEAD',
            url: endpointUrls.quote.doesUserExist,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc',
                'X-Requested-By': '92tvt8iy2b'
            },
        },
        getPayment: {
            method: 'GET',
            url: endpointUrls.payments.referenceNumber,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc'
            }
        }
    };

    return {
        regoSearch: function (data) {
            var req = conf.regoSearch;
            req.params = data;
            req.headers.UserID = checkUserID();
            return $http(req);
        },
        addressSearch: function (data) {
            var req = conf.addressSearch;
            req.params = data;
            return $http(req);
        },
        makeSearch: function (data) {
            var req = conf.makeSearch;
            req.params = data;
            return $http(req);
        },
        modelSearch: function (data) {
            var req = conf.modelSearch;
            req.params = data;
            return $http(req);
        },
        carSearch: function (data) {
            var req = conf.carSearch;
            req.params = data;
            return $http(req);
        },
        saveQuote: function (quoteRequest, credentials, params) {
            var req = quoteRequest.quoteID ? conf.updateQuote : conf.createQuote;
            req = Object.extend({}, req);
            req.data = quoteRequest;

            if (params) {
                req.params = params;
            }

            if (quoteRequest.quoteID) {
                req.url = req.url + '/' + quoteRequest.quoteID;
            }
            if (credentials) {
                req.headers['EY-USER-TOKEN'] = credentials.eyUserToken;
            }
            return $http(req);
        },
        getQuickQuote: function (quoteRequests, params, credentials) {
            var req = conf.quickQuote;
            req.data = quoteRequests;
            req.params = params;
            return $http(req);
        },
		triggerGoal: function (quoteRequests) {
			var req = conf.triggerGoal;         
			req.data = quoteRequests;
			return $http(req);
		},
        retrieveSavedQuote: function (quoteId, email) {
            var req = conf.retrieveSavedQuote;
            req = Object.extend({}, req);
            req.url += quoteId;
            req.params = {
                email: email
            };
            return $http(req);
        },
        isCampaignCodeValid: function (code) {
            var req = conf.isCampaignCodeValid;
            req.params = {
                code: code,
                timestamp: (new Date()).getTime()
            };
            return $http(req);
        },
        refreshAddress: function (address) {
            var req = conf.refreshAddress;
            req.data = address;
            return $http(req);
        },
        refreshVehicleDetails: function (vgiId, effectiveDate) {
            var req = conf.refreshVehicleDetails;
            req.params = {
                effectiveDate: effectiveDate,
                id: vgiId,                
                categoryId: 'VehID'
            }
            return $http(req);
        },
        refreshCaravanDetails: function (vgiId, effectiveDate) {
            var req = conf.refreshCaravanDetails;

            req.params = {
                effectiveDate: effectiveDate,
                id: vgiId,
                categoryId: 'VehID'
            }
            return $http(req);
        },
        isBSBValid: function (bsb) {
            var req = conf.isBSBValid, bsbReformatted = null;
            req = Object.extend({}, req);
            // reformat bsb to xxx-xxx format for service
            try {
                bsbReformatted = bsb.replace(/[^0-9.]/g, "").match(/.{3}/g).join('-');
                req.url = req.url + '/' + bsbReformatted;
                return $http(req);
            } catch (ex) {
                throw 'Invalid BSB provided';
            }
        },
        doesUserExist: function (email) {
            var req = conf.doesUserExist;
            req = Object.extend({}, req);
            req.url = req.url + '/' + email;
            return $http(req);
        },
        getPaymentInfo: function (refNumber){
            var req = conf.getPayment;
            req = Object.extend({}, req);
            req.url = req.url + '/' + refNumber;
            return $http(req);
        },
        checkEmbargo: function(postcode, type) {
            var req = conf.embargo;
            req.headers['X-TrackingID'] = uuidv4();
            req.headers['X-SourceSystem'] = 'QBE-SPA-' + type + '-QuoteBuy';  //type: 'Bike' 'Caravan'
            req.headers['X-TargetEnv'] = endpointUrls.quote.embargoTargetEnv;
            req.url = endpointUrls.quote.embargo + "?postalCode=[postcode]&policyLine=" + endpointUrls.quote.embargoPolicyLine + "&asOfDate=[date]";
            req.url = req.url.replace("[date]", moment().tz("Australia/Sydney").format("YYYY-MM-DD"));
            req.url = req.url.replace("[postcode]", postcode);
            return $http(req);
        }
    };

    function checkUserID() {
        if (storage.getItem('uKey').uKey) {
            return storage.getItem('uKey').uKey;
        } else {
            var newKey = util.generateRandomString(5);
            storage.setItem('uKey', { uKey : newKey });
            return newKey;
        }
    }

    function uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    function getMulesoftApiHeadersForVgi(mulesoftApiHeadersConfig) {
        if (endpointUrls.quote && endpointUrls.quote.embargoTargetEnv) {
            mulesoftApiHeadersConfig['X-TargetEnv'] = endpointUrls.quote.embargoTargetEnv;
        }    
        mulesoftApiHeadersConfig['X-TrackingID'] = uuidv4();
        return mulesoftApiHeadersConfig;
    }

    return new GuideWireService(new gwService());
}

function HierarchyDecorator() {
	
	function attach($scope, params) {
		var element = params.element,
			name = params.name,
			hierarchy = params.hierarchy; 
		
		if ( name === '') 
			name = 'ag_' + $scope.$id ; 

		$scope.hierarchyList = [name] ;  

		$scope.setHierarchy(
			{
			 name : name, 
			 setHierarchyFn : function(parentHierarchy) {
			 		$scope.hierarchyList = parentHierarchy.concat($scope.hierarchyList);
					$scope.HTMLId = $scope.hierarchyList.slice().join('_');
					element.attr('id' , $scope.HTMLId);
					$scope.$emit('element-id-set',element.attr('label-key'), $scope.HTMLId);
				}
			}
		) ; 
	}

	return {
		attach: attach
	}	
}
function HomeQuoteConfiguration(){
	this.coverTypeClasses = {
		building_and_contents: {
			label : 'Building & contents',
			subClasses : {
				standard: {
					label: 'Building & contents',
					descriptor: 'building_and_contents',
					superType: 'building_and_contents'
				},
			}
		},

		building_only: {
			label : 'Building only',
			subClasses : {
				standard: {
					label: 'Building only',
					descriptor: 'building_only',
					superType: 'building_only'
				},
			}
		},
		contents_only: {
			label : 'Contents',
			subClasses : {
				standard: {
					label: 'Contents',
					descriptor: 'contents_only',
					superType: 'contents_only'
				},
			}
		},
	};

	this.allCoverTypes = {
		building_and_contents: this.coverTypeClasses.building_and_contents.subClasses.standard,
		building_only: this.coverTypeClasses.building_only.subClasses.standard,
		contents_only: this.coverTypeClasses.contents_only.subClasses.preferred,
	};

	this.allOfferings = {
		QPHStandardOffering: {
			label: 'Standard',
			descriptor: 'QPHStandardOffering',
			superType: ''
		},
		QPHPrestigeOffering: {
			label: 'Prestige',
			descriptor: 'QPHPrestigeOffering',
			superType: ''
		},
		QPHLandlordOffering: {
			label: 'Landlord',
			descriptor: 'QPHLandlordOffering',
			superType: ''
		},
		QPHStrataContentsOffering: {
			label: 'Strata Contents',
			descriptor: 'QPHStrataContentsOffering',
			superType: ''
		}
	};


		//get required covertypes
	this.getOfferingPermutations = function(quoteOptions, coverOptions, selectedCoverType, selectedOffering){
		quoteOptions.permutations.offerings = [selectedOffering];
		quoteOptions.permutations.coverTypes = [selectedCoverType];

		if ( ! selectedOffering ) {
			applicableOfferings = getOfferings( coverOptions.homeOccupancy, coverOptions.buildingType, coverOptions.needs, coverOptions.needRapidEstimate);
			//select permutations in homequote configuration based on the above logic
			var permutationsBasedOnSelection = [];
			angular.forEach(this.allOfferings, function(offering){
				if(applicableOfferings.indexOf(offering.descriptor)>-1){
					permutationsBasedOnSelection.push(offering);
				}
			});
			quoteOptions.permutations.offerings = permutationsBasedOnSelection;
		}

		return quoteOptions;
	}


	function getOfferings(homeOccupancy, buildingType, needs, needRapidEstimate){
		//logic from exsting portal
		var offerings = [];
		if (
			(homeOccupancy === 'own_live' ||
			homeOccupancy === 'rent_live' ||
			homeOccupancy === 'own_holidayhome') && !(buildingType === 'unit' || buildingType === 'flat')
		) {
			offerings.push('QPHStandardOffering');
			if (needRapidEstimate) {
				offerings.push('QPHPrestigeOffering');
			}

		} else if (
			(homeOccupancy === 'own_live' ||
			homeOccupancy === 'rent_live' ||
			homeOccupancy === 'own_holidayhome') &&
			(buildingType === 'unit' || buildingType === 'flat') &&
			needs.building
		) {
			offerings.push('QPHStandardOffering');
			if (needRapidEstimate) {
				offerings.push('QPHPrestigeOffering');
			}

		} else if (
			(homeOccupancy === 'own_live' ||
			homeOccupancy === 'rent_live' ||
			homeOccupancy === 'own_holidayhome') &&
			(buildingType === 'unit' || buildingType === 'flat') &&
			needs.contents
		) {
			offerings.push('QPHStrataContentsOffering');
			if (needRapidEstimate) {
				offerings.push('QPHPrestigeOffering');
			}

		} else if (
			(homeOccupancy === 'own_rent_tenants' ||
			homeOccupancy === 'own_rent_tenants_causalbasis' ||
			homeOccupancy === 'property_used_hostel_or_guest')
		) {
			offerings.push('QPHLandlordOffering');
		}
		return offerings;
	}

	this.allPaymentFrequencies = {
		annual: 'everyyear',
		monthly: 'monthly',
		fortnightly: 'everyotherweek',
	};

	this.defaultPaymentFrequency = this.allPaymentFrequencies.annual;

	this._reversePaymentFrequenciesLookup = {
		yearly: 'annual',
		monthly: 'monthly',
		fortnightly: 'fortnightly',
	};

	this.allQuoteTypes = {
		full: 'Full',
		quick: 'Quick',
	};

	this.defaultOffering = this.allOfferings.QPHStandardOffering ;

	this.quoteRuleOptions = {
		// Rapid estimate quote options
		'rapidEstimate': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'home.estimate' // Note : THESE ARE GUIDEWIRE RULESET AND DO NOT NECESSARILY CORRESPOND TO PAGE NAMES.
			},
			permutations: {
				quoteType: this.allQuoteTypes.quick,
				useSelectedOffering: false,
				paymentFrequencies: [this.allPaymentFrequencies.annual, this.allPaymentFrequencies.monthly]
			}
		},
		'home.property': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'home.property' // Note : THESE ARE GUIDEWIRE RULESET AND DO NOT NECESSARILY CORRESPOND TO PAGE NAMES.
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'home.building': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'home.building'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual, this.allPaymentFrequencies.monthly]
			}
		},
		'home.covers': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'home.covers'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'home.details': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'home.details'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: Object.values(this.allPaymentFrequencies)
			}
		},
		'home.quote': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'home.quote'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: Object.values(this.allPaymentFrequencies)
			}
		},
		'home.contact': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'home.additional'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: Object.values(this.allPaymentFrequencies)
			}
		},
		'home.payment': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'home.payment'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: Object.values(this.allPaymentFrequencies)
			}
		}
	};

	this.testQuoteDeclineOptions = {
		'home.estimate' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'home.estimate'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'home.property' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'home.property'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'home.building' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'home.building'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'home.covers' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'home.covers'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'home.details' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'home.details'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'home.quote' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'home.quote'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'home.contact' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'home.additional'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'home.payment' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'home.payment'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				useSelectedOffering: true,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
	}

	/** cover type for home needs to be determine in step 1 and cannot be defaulted */
	this.defaultCoverType = null;
	this.defaultRequotePageName = 'home.quote';
}

function HouseCommonData(userInputRepository, houseForm) {

    var commonData = null ;

    this.data = {} ;

    function set(item, value) {
        commonData[item] = value ;
    }

    function getCommonMaterial() {
        return houseForm.commonMaterial ;
    }


}

  'use strict';
 
  /**
  * track virtual page views for all page.
  */ 
  function JWTTimeoutService($state, jwtHelper, storage, labelService, MODULE_INFO) {

    function isSessionTimedout() {
    	var eyUserToken = storage.getItem('eyUserToken');
      	if( typeof(eyUserToken) == 'string' &&
			jwtHelper.isTokenExpired(eyUserToken)){
			return true;
	    } else {
	    	return false;
	    }

  	}

  	function handleTimeout() {
  		var sessionTimeoutMessage = labelService.getGlobalOptionLabel('content', 'session_timeout_message');
  		void 0;
		storage.clear();
		$state.go(MODULE_INFO.startRouteName);
  	}

    return {
    	isSessionTimedout : isSessionTimedout,
    	handleTimeout : handleTimeout	
    } 
  }

"use strict";

function LabelService(DOM) {
	var schema = {} ;
	var section_schema = {};
	var remoteOptions = {} ;
	var globals = {} ;
	var genericValidationMessages = {} ;
	var content = {} ;
	var campaigns = {} ;

	DOM.addEventListener('register-labels', function (e) {
		registerLabels(DOM);
	}, false);

	function registerLabels(conf) {
		schema = conf.qbe.fieldLabels;
		section_schema = conf.qbe.sectionLabels;
		genericValidationMessages = conf.qbe.validationMessages ;
		content = conf.qbe.content;
		campaigns = conf.qbe.campaigns;
		globals = conf.globals;
	}

	function extractLabelsFor(fieldName) {
		var field = schema[fieldName] ;
		if ( ! field ) {
			return '' ;
			// throw fieldName + ' does not exist in the form schema';
		}

		return schema[fieldName] ;
	}

	function extractSectionLabelsFor(fieldName) {
		var field = section_schema[fieldName] ;
		if ( ! field ) {
			return '' ;
			// throw fieldName + ' does not exist in the form schema';
		}

		return section_schema[fieldName] ;
	}

	function extractContentLabelsFor(fieldName) {
		var field = content[fieldName] ;
		if ( ! field ) {
			return '' ;
			// throw fieldName + ' does not exist in the form schema';
		}

		return content[fieldName] ;
	}

	function extractCampaignInfoFor(campaignId) {
		return function findCampaignById(campaigns) {
			var campaign;
			angular.forEach(campaigns, function(c){
				if ( c.sc_camp == campaignId){
					return campaign = c ; 	
				}
			});
			return campaign;
		}(campaigns) ;
	}

	function getObjectValue(fieldName, fieldLabel) { 
		return extractLabelsFor(fieldName)[fieldLabel] ;
	}

	function getLabelFor(fieldName) {
		return extractLabelsFor(fieldName)['label'] ;
	}

	function getSectionLabelFor(fieldName) {
		return extractSectionLabelsFor(fieldName)['sectionHeadingText'] ;
	}

	function getSectionDescriptionFor(fieldName) {
		return extractSectionLabelsFor(fieldName)['sectionDescriptionText'] ;
	}

	function getHintTextFor(fieldName) {
		return extractLabelsFor(fieldName)['hintText'] ;
	}

	function getHelpTextFor(fieldName) {
		return extractLabelsFor(fieldName)['extendedHintText'] ;
	}

	function getTooltipFor(fieldName) {
		return extractLabelsFor(fieldName)['tooltip'] ;
	}

	function getSecondaryInfoTextFor(fieldName){
		return extractLabelsFor(fieldName)['secondaryInfoText'];
	}

	function getValidationMessagesFor(fieldName, rule) {
		var validations = extractLabelsFor(fieldName)['validationMessages'] ;
		if ( ! validations || ! validations[rule] )
			return getGenericValidationMessageFor(rule) ;

		return validations[rule];
	}

	function getGenericValidationMessageFor(rule) {
		return genericValidationMessages[rule] ;
	}

	function getOptionsFor(fieldName) {
		return schema[fieldName].options;
	}

	function getGlobalOptionsFor(fieldName) {
		return globals[fieldName].options;
	}

	function getLabelForRemoteOption(fieldName, option) {
		//return schema[fieldName].remoteOptions[options];
		var arr = schema[fieldName].remoteOptions;
		var obj = arr.filter(function ( obj ) {
			return obj.key === option;
		})[0];
		return obj;
	}

	function getSecondaryInfoTextFlag(fieldName){
		return Boolean(schema[fieldName]['secondaryInfoTextDisplayOn']);
	}


	function getContent(fieldName) {
		return extractContentLabelsFor(fieldName);
	}

	function getGlobalOptionLabel(optionType, optionValue) {
		var optionKeyValues = this.getGlobalOptionsFor(optionType) ;
		var label = null;
		if ( optionKeyValues ) {
			angular.forEach(optionKeyValues, function(option){
				if ( option.value == optionValue )
					label = option.label ;
			})
		}

		return label;
	}
	function getGlobalOption(optionType, optionValue) {
		var optionKeyValues = this.getGlobalOptionsFor(optionType) ;
		var returnOption = null;
		if ( optionKeyValues ) {
			angular.forEach(optionKeyValues, function(option){
				if ( option.value === optionValue )
					returnOption = option ;
			});
		}
		return returnOption;
	}

	return {
		init:registerLabels,
		getObjectValue: getObjectValue,
		getLabelFor: getLabelFor,
		getSectionLabelFor: getSectionLabelFor,
		getSectionDescriptionFor: getSectionDescriptionFor,
		getHintTextFor: getHintTextFor,
		getHelpTextFor: getHelpTextFor,
		getTooltipFor: getTooltipFor,
		getValidationMessagesFor: getValidationMessagesFor,
		getGenericValidationMessageFor: getGenericValidationMessageFor,
		getOptionsFor: getOptionsFor,
		getGlobalOptionsFor: getGlobalOptionsFor,
		getLabelForRemoteOption: getLabelForRemoteOption,
		getContent: getContent,
		extractCampaignInfoFor: extractCampaignInfoFor,
		getSecondaryInfoTextFor: getSecondaryInfoTextFor,
		getSecondaryInfoTextFlag: getSecondaryInfoTextFlag,
		getGlobalOptionLabel: getGlobalOptionLabel,
		getGlobalOption: getGlobalOption
	};
}

"use strict";

function MAService(serviceWrapper, campaignService) {
    var endpoint= '/api/qbe/marketing';

    function send(event, data) {

        if ( ! qbe.marketing || ! qbe.marketing.Marketing)
            return;

        //var isFullQuote = false;
        //if (data.pageName != 'vehicle.vehicle' && data.pageName != 'vehicle.drivers' && data.pageName != 'rapid-estimate')
        //    isFullQuote = true;
        var isSave = (event === 'save');
        var isfromRapidEstimate = (data.pageName === 'rapid-estimate');
        var isDeclined = (event === 'declined');

        //debugger;
        var qbeContact = {

            EmailAddress: data.policyEmail ? data.policyEmail : null,
            Enrol: false,
            Unenrol: false,
            Address : data.address ? data.address : null,
            ContactNumber : data.contactNumber ? data.contactNumber : null,
            InceptionDate : data.inceptionDate ? data.inceptionDate : null,
            Product: {

                QuoteReferenceId: data.quoteId ? data.quoteId : null,
                CoverType: data.annualResult?(data.annualResult.coverType ? data.annualResult.coverType : (data.monthlyResult.coverType ? data.monthlyResult.coverType : null)):null,
                PromotionalCode: data.campaignCode ? data.campaignCode : null,
                NoClaimBonus: data.noClaimBonus ? data.noClaimBonus : null,
                Declined: isDeclined
            }
        }

        if (!isfromRapidEstimate)
        {
            if (data.mainPolicyHolder != null) {
                qbeContact.FirstName = data.mainPolicyHolder.firstName ? data.mainPolicyHolder.firstName : null;
                qbeContact.Surname = data.mainPolicyHolder.lastName ? data.mainPolicyHolder.lastName : null;

                qbeContact.DOB = data.mainPolicyHolder.dateOfBirth ? data.mainPolicyHolder.dateOfBirth : null;

                qbeContact.State = data.state ? data.state : null;
                qbeContact.PostCode = data.postCode ? data.postCode : null;
            }

            qbeContact.SaveQuoteOutcomeId = qbe.marketing.Marketing.SaveOutcome ? qbe.marketing.Marketing.SaveOutcome : null;
            qbeContact.TriggerSaveOutcome= isSave;
            qbeContact.SaveQuoteGoalId= qbe.marketing.Marketing.SaveGoal ? qbe.marketing.Marketing.SaveGoal : null;
            qbeContact.OutcomeId= qbe.marketing.Marketing.Outcome ? qbe.marketing.Marketing.Outcome : null;
            qbeContact.EngagementPlanId= qbe.marketing.Marketing.EngagementPlan ? qbe.marketing.Marketing.EngagementPlan : null;
            qbeContact.EngagementStateId=qbe.marketing.Marketing.EngagementState ? qbe.marketing.Marketing.EngagementState : null;
            qbeContact.Unenrol= qbe.marketing.Marketing.Unenrol ? qbe.marketing.Marketing.Unenrol : false;
            qbeContact.Enrol= isSave;
            qbeContact.Product.InsuranceType= qbe.marketing.Marketing.InsuranceType;
        }

        var isFullQuote = false;
        if(data.monthlyResult && data.monthlyResult.paymentPlan && data.monthlyResult.paymentPlan.installment){
            isFullQuote = true;
        }

        // var isFullQuote = data.monthlyResult.paymentPlan.installment? true : false;

        if (isFullQuote) {
            qbeContact.Product.FullQuoteAnnualPremium = data.annualResult.totalPremium ? data.annualResult.totalPremium.toFixed(2) : null;
            qbeContact.Product.FullQuoteMonthlyPremium = data.monthlyResult.paymentPlan.installment ? data.monthlyResult.paymentPlan.installment.toFixed(2) : null;
            qbeContact.Product.FullQuoteMonthlyTotal = data.monthlyResult.totalPremium ? data.monthlyResult.totalPremium.toFixed(2) : null;

            qbeContact = createPremiumBreakdown(qbeContact, data);

        } else {
            qbeContact.Product.QuickQuoteAnnualPremium = data.annualResult?(data.annualResult.totalPremium ? data.annualResult.totalPremium.toFixed(2) : null):null;
            qbeContact.Product.QuickQuoteMonthlyPremium = data.monthlyResult?(data.monthlyResult.totalPremium ? data.monthlyResult.totalPremium.toFixed(2) : null):null;
            //qbeContact.Product.QuickQuoteMonthlyTotal = data.monthlyResult.totalPremium ? data.monthlyResult.totalPremium : null;

            qbeContact = createPremiumBreakdown(qbeContact, data);
        }

        var activeCampaign = campaignService.getCampaign() ;
        if (activeCampaign) {
           qbeContact.Product.CampaignId = activeCampaign.sc_camp;
           qbeContact.Product.CampaignHeader = activeCampaign.header;
           qbeContact.Product.CampaignImgUrl = activeCampaign.emailImageUrl ? activeCampaign.emailImageUrl : activeCampaign.imgURL;
           qbeContact.Product.CampaignTerms = activeCampaign.termsAndConditions;
       }

        var req = {
            method: 'POST',
            url: endpoint,
            data: qbeContact
        }

        serviceWrapper(req).then(function () {
            void 0
        }, function (error) {
            void 0;
        });
    }

    function mergeContacts(event, data) {
        try {
            send(event, data);
        } catch(ex) {
            void 0 ;
        }
    }

    function createPremiumBreakdown(qbeContact, data) {
        qbeContact.Product.AnnualPremium = data.annualResult.quoteResult.premiumAfterDiscount ? data.annualResult.quoteResult.premiumAfterDiscount.toFixed(2) : null;
        qbeContact.Product.AnnualTotalFSL = data.annualResult.quoteResult.totalFSL ? data.annualResult.quoteResult.totalFSL.toFixed(2) : null;
        qbeContact.Product.AnnualTotalGST = data.annualResult.quoteResult.totalGST ? data.annualResult.quoteResult.totalGST.toFixed(2) : null;
        qbeContact.Product.AnnualStampDuty = data.annualResult.quoteResult.totalStampDuty ? data.annualResult.quoteResult.totalStampDuty.toFixed(2) : null;
        qbeContact.Product.MonthlyPremium = data.monthlyResult.quoteResult.premiumAfterDiscount ? data.monthlyResult.quoteResult.premiumAfterDiscount.toFixed(2) : null;
        qbeContact.Product.MonthlyTotalFSL = data.monthlyResult.quoteResult.totalFSL ? data.monthlyResult.quoteResult.totalFSL.toFixed(2) : null;
        qbeContact.Product.MonthlyTotalGST = data.monthlyResult.quoteResult.totalGST ? data.monthlyResult.quoteResult.totalGST.toFixed(2) : null;
        qbeContact.Product.MonthlyStampDuty = data.monthlyResult.quoteResult.totalStampDuty ? data.monthlyResult.quoteResult.totalStampDuty.toFixed(2) : null;      

        return qbeContact;
    }

    return {
        mergeContacts: mergeContacts
    };
}

(function() {
	'use strict';

	angular
		.module('qbePortal')
		.service('paymentLoggerService', paymentLoggerService);

	paymentLoggerService.$inject = [
		'$log',
		'$http',
		'Util',
		'quoteModelFactory',
		'MODULE_INFO',
		'storage'
	];
	function paymentLoggerService(
		$log,
		$http,
		util,
		quoteModelFactory,
		MODULE_INFO,
		storage
	) {
		this.trackQuoteStatus = trackQuoteStatus;
		var endpoint = '/api/QuoteAndBuyLog/QuoteAndBuyLogger'; // put sitecore endpoint here

		function trackQuoteStatus(serviceCallStatus, nextStep, response) {
			var processData = {};
			try {
				if (MODULE_INFO.id === 'payments') {
					var referenceNumber = util.b64DecodeUnicode(
						storage.getItem('unauth-reference')
					);
					processData = {
						quoteId: referenceNumber,
						currentService: serviceCallStatus,
						nextService: nextStep,
						response: JSON.stringify(response)
					};
				} else {
					var quoteModel = quoteModelFactory.create(),
						quoteId = quoteModel.quoteId;
					processData = {
						quoteId: quoteId,
						currentService: serviceCallStatus,
						nextService: nextStep,
						response: JSON.stringify(response)
					};
				}
				$log.log(processData);
				sendLogs(processData);
			} catch (error) {
				$log.log(error);
			}
		}

		function sendLogs(processData) {
			var req = {
				method: 'POST',
				url: endpoint,
				data: processData
			};

			$http(req).then(
				function() {
					$log.log('successfully called the logger API');
				},
				function(error) {
					$log.log(error.status + ' : ' + error.statusText);
				}
			);
		}
	}
})();

"use strict";

function PaymentService(
	serviceWrapper,
	portalServiceWrapper,
	$state,
	storage,
	userInputRepository,
	quoteModelFactory,
	util,
	quoteOptions,
	paymentLoggerService
) {
	var EMBARGO_STATE = "embargo";

	function getItemById (key, configs) {
		for (var i = 0; i < configs.length; i++) {
			if (configs[i].id === key) {
				return configs[i].title;
			}
		}
		return '';
	};

	//global variable from page layout
	// return data structure {clientId: '', clientSecret: '', merchantIdentifier: '', mulesoftFlexiMicroformApiUrl: ''}
	function getPaybillConfig() {
		//return endpointUrls.payments.ausPortalUISettings;
		return appConfigs.payments.ausPortalUISettings;
	}

	/* call mulesoft to prepare tokenization of cc number */
	function initialCreditcardPayment(initialCreditcardPaymentUrl, host, guid, merchantId, clientId, clientSecret, successCallback, errorCallback) {
		serviceWrapper.initialCreditcardPayment(initialCreditcardPaymentUrl, host, guid, merchantId, clientId, clientSecret)
		.then(function(response) {
			var jwk = response.data.jwk;
			successCallback(jwk);
		})
		.catch(function(error) {
			errorCallback(error);
		});
	}

	function generateUniqueId() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {  
			var r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);  
			return v.toString(16);  
		 });
	}
	function getKeyData(jwk, cardNumberFieldId, cardNumberLabelId, placeholderText) {
        return {
            keyId: jwk.kid,
            keystore: jwk,
            container: cardNumberFieldId,
            label: cardNumberLabelId,
            placeholder: placeholderText,
            styles: {
                'input': {
                    'font-family': 'Verdana',
                    'font-size': '15px',
                    'line-height': '1.5',
					'color': '#343e44'
                },
                ':focus': {'color': '#343e44'},
                ':disabled': {'cursor': 'not-allowed'},
                'valid': {'color': '#343e44'},
                'invalid': {'color': '#343e44'},
            },
            encryptionType: 'rsaoaep'
        };
    }
    function flexiFormFunction (microformInstance, payButton, cardExpirationMonth, cardExpirationYear, flexResponse, submitForm) {

        // intercept the form submission and make a tokenize request instead
        payButton.addEventListener('click', function () {

            // Send in optional parameters from other parts of your payment form
            var options = {
                cardExpirationMonth: cardExpirationMonth, //expMonth.value,
                cardExpirationYear: cardExpirationYear, //expYear.value
            };

            microformInstance.createToken(options, function (err, response) {
                if (err) {
                    void 0;
                    return;
                }

                // At this point the token may be added to the form
                // as hidden fields and the submission continued
                flexResponse.value = JSON.stringify(response);
                submitForm();
            });
        });
    }
	/**
	 * Pays by credit card
	 * The entire flow is as follows:
	 * 	1 - Create a payment with GuideWire
	 * 	2 - Generate Cybersource form data using response from GuideWire and credit card data entered by the user
	 * 	3 - Convert the form data into a form (in an iFrame on the Payments page)
	 * 	4 - The following happens in the iFrame
	 * 		4.1 - Submit the form (in the iFrame) to Cybersource using a form.submit()
	 * 		4.2 - Cybersource responds back with an HTML page that contains a form. This form auto-submits to GuideWire
	 * 		4.3 - Guidewire loads a callback page (Angular) in the iFrame. This page tells the parent (Payment) page that the payment was successful/unsuccessful
	 * 	5 - When the Payment page receives the payment complete from the iFrame, transition to the Confirmation page
	 *
	 * @param {Object} creditCard					Object with credit card data submitted by user
	 * @param {Function} successCallback			Success callback that accepts argument of type `Object` with form data to submit to Cybersource
	 * @param errorCallback							Error callback that accepts argument argument of type `ErrorResponse`
	 */
	function payByCreditCard(creditCard, successCallback, errorCallback) {
		portalServiceWrapper.updateQuote(userInputRepository.get());
		var paymentFrequency = quoteOptions.getSelectedPaymentFrequencyForService();

		portalServiceWrapper
			.saveQuote(paymentFrequency, {
				issueCheck: "true",
				quote: "true"
			})
			.then(function(response) {
				testEmbargoDecline(response);
				paymentLoggerService.trackQuoteStatus(
					"attempting to save quote-credit card",
					"generate cybersource form data",
					null
				);
				return _createCreditCardPayment();
			})
			.then(function(_createCreditCardPaymentResponse) {
				var formData = _generateCybersourceFormData(
					_createCreditCardPaymentResponse,
					creditCard
				);
				paymentLoggerService.trackQuoteStatus(
					"generating Cybersource form data",
					"submit payment to Cybersource",
					null
				);
				successCallback(formData);
			})
			.catch(function(response) {
				paymentLoggerService.trackQuoteStatus(
					"saveQuote error-credit card",
					null,
					response
				);
				if (response.declineType === "embargo")
					$state.go(EMBARGO_STATE, response);
				else if (errorCallback) {
					/* gtm track api error */
					if (response && response.status) {
						gtmService.trackApiError(response.status, 'saveQuote error-credit card');
					}

					errorCallback(response);							
				}
			});
	}

	function unAuthCreditCardPayment(
		creditCard,
		successCallback,
		errorCallback
	) {
		var paymentData = {
			referenceID: creditCard.referenceNumber,
			paymentType: creditCard.paymentType,
			redirectUrl: $state.href(
				"cybersourceCallback",
				{},
				{
					absolute: true
				}
			),
			payWithToken: true,
			payment_token: creditCard.cardToken
		};

		// call GW to get to create payload
		serviceWrapper
			.createCreditcardPayment(paymentData)
			.then(function(_createCreditCardPaymentResponse) {
				var formData = _generateCybersourceFormData(
					_createCreditCardPaymentResponse,
					creditCard
				);
				paymentLoggerService.trackQuoteStatus(
					"generating Cybersource form data",
					"submit payment to Cybersource",
					null
				);
				successCallback(formData);
			})
			.catch(function(response) {
				paymentLoggerService.trackQuoteStatus(
					"pay bills error-credit card",
					null,
					response
				);
				
				/* gtm track api error */
				if (response && response.status) {
					gtmService.trackApiError(response.status, 'pay bills error-credit card');
				}

				errorCallback(response);
			});
	}

	function unAuthPaypalPayment(paymentInfo, successCallback, errorCallback) {
		var paymentData = {
			referenceID: paymentInfo.referenceNumber,
			paymentType: paymentInfo.paymentType,
			redirectUrl: $state.href(
				"paypalCallback",
				{},
				{
					absolute: true
				}
			)
		};

		serviceWrapper
			.createPaypalPayment(paymentData)
			.then(function(_createPaypalPaymentResponse) {
				paymentLoggerService.trackQuoteStatus(
					"generating Paypal payment response",
					"submit payment to Paypal",
					null
				);
				successCallback(_createPaypalPaymentResponse.data.redirectURL);
			})
			.catch(function(response) {
				paymentLoggerService.trackQuoteStatus(
					"pay bills error-paypal",
					null,
					response
				);

				/* gtm track api error */
				if (response && response.status) {
					gtmService.trackApiError(response.status, 'pay bills error-paypal');
				}

				errorCallback(response);
			});
	}

	/**
	 * Pays by PayPal
	 * The flow is as follows:
	 * 	1 - Create a payment with GuideWire
	 * 	2 - GuideWire responds with a PayPal redirect URL
	 * 	3 - The browser is redirected to PayPal (using the redirect URL returned from the GuideWire service)
	 * 	4 - User completes payment in PayPal and is redirected back to a PayPal Payment Success page (Angular page)
	 * 	5 - If success parameters are passed to the PayPal Payment Success Page, send data to GuideWire PayPal Success service
	 * 	6 - Transition to Confirmation Page
	 *
	 * @param {Function} successCallback			Success callback that accepts argument `redirectUrl` of type `String`
	 * @param {Function} errorCallback				Error callback that accepts argument argument of type `ErrorResponse`
	 */
	function payByPaypal(successCallback, errorCallback) {
		portalServiceWrapper.updateQuote(userInputRepository.get());

		var paymentFrequency = quoteOptions.getSelectedPaymentFrequencyForService();

		portalServiceWrapper
			.saveQuote(paymentFrequency, {
				issueCheck: "true",
				quote: "true"
			})
			.then(function(response) {
				testEmbargoDecline(response);
				paymentLoggerService.trackQuoteStatus(
					"attempting to save quote-paypal",
					"generate Paypal payment response",
					null
				);
				return _createPaypalPayment();
			})
			.then(function(_createPaypalPaymentResponse) {
				paymentLoggerService.trackQuoteStatus(
					"generating Paypal payment response",
					"submit payment to Paypal",
					null
				);
				successCallback(_createPaypalPaymentResponse.data.redirectURL);
			})
			.catch(function(response) {
				paymentLoggerService.trackQuoteStatus(
					"saveQuote error-paypal",
					null,
					response
				);
				if (response.declineType === "embargo") {
					$state.go(EMBARGO_STATE, response);
					/* gtm track api error */
					if (response && response.status) {
						gtmService.trackApiError(response.status, 'saveQuote error-paypal. Declined. Type: embargo.');
					}
				}					
				else if (errorCallback) {
					/* gtm track api error */
					if (response && response.status) {
						gtmService.trackApiError(response.status, 'saveQuote error-paypal');
					}
					errorCallback(response);
				}
			});
	}

	function unAuthDirectDebitPayment(
		bankAccount,
		successCallback,
		errorCallback
	) {
		bankAccount.bsb = convertBsbNumberToGuidewireFormat(bankAccount.bsb);

		var quoteModel = quoteModelFactory.create(),
			paymentData = {
				amount: bankAccount.amountPay,
				referenceID: bankAccount.referenceNumber,
				paymentType: bankAccount.paymentType,
				bsbNumber: bankAccount.bsb,
				bankAccountNumber: bankAccount.accountNumber,
				accountHolderName: bankAccount.accountName
			};

		serviceWrapper
			.createDirectDebitPayment(paymentData)
			.then(function(_createDirectDebitPaymentResponse) {
				paymentLoggerService.trackQuoteStatus(
					"create direct debit payment response",
					"create direct debit payment",
					null
				);
				successCallback(_createDirectDebitPaymentResponse.data);
			})
			.catch(function(response) {
				paymentLoggerService.trackQuoteStatus(
					"pay bills error-direct debit",
					null,
					response
				);

				/* gtm track api error */
				if (response && response.status) {
					gtmService.trackApiError(response.status, 'pay bills error-direct debit');
				}

				if (errorCallback) {
					errorCallback(response);
				}
			});
	}

	/**
	 * Pays by Direct Debit
	 * A straight forward AJAX call to the directDebit service
	 * @param {Object} bankAccount					Bank account details entered by the user
	 * @param {Function} successCallback			Success callback that accept service response data as argument
	 * @param {Function} errorCallback				Error callback that accepts service error response as argument
	 */
	function payByDirectDebit(bankAccount, successCallback, errorCallback) {
		portalServiceWrapper.updateQuote(userInputRepository.get());
		var paymentFrequency = quoteOptions.getSelectedPaymentFrequencyForService();

		portalServiceWrapper
			.saveQuote(paymentFrequency, {
				issueCheck: "true",
				quote: "true"
			})
			.then(function(response) {
				testEmbargoDecline(response);
				paymentLoggerService.trackQuoteStatus(
					"attempting to save quote-direct debit",
					"create direct debit payment",
					null
				);
				return _createDirectDebitPayment(bankAccount);
			})
			.then(function(_createDirectDebitPaymentResponse) {
				paymentLoggerService.trackQuoteStatus(
					"create direct debit payment response",
					"create direct debit payment",
					null
				);
				successCallback(_createDirectDebitPaymentResponse.data);
			})
			.catch(function(response) {
				paymentLoggerService.trackQuoteStatus(
					"saveQuote error-direct debit",
					null,
					response
				);
				if (response.declineType === "embargo") {
					/* gtm track api error */
					if (response && response.status) {
						gtmService.trackApiError(response.status, 'saveQuote error-direct debit. Declined. Type: embargo.');
					}

					$state.go(EMBARGO_STATE, response);
				}					
				else if (errorCallback) {
					/* gtm track api error */
					if (response && response.status) {
						gtmService.trackApiError(response.status, 'saveQuote error-direct debit.');
					}
					errorCallback(response);
				}
			});
	}

	function testEmbargoDecline(response) {
		// var data = response.data;

		// if (data.quoteResult && data.quoteResult.embargo == true) {
		// 	var declineParams = {
		// 		declineType: "embargo",
		// 		declineCodes: []
		// 	};

		// 	data.quoteResult.uwIssues.forEach(function(element) {
		// 		declineParams.declineCodes.push(element.typeCode);
		// 	}, this);

		// 	throw declineParams;
		// }
	}

	/**
	 * Creates a Direct Debit Payment in GuideWire
	 * Calls the GuideWire service to create a direct debit payment
	 * @param {Object} bankAccount
	 * @private
	 */
	function _createDirectDebitPayment(bankAccount) {
		bankAccount.bsb = convertBsbNumberToGuidewireFormat(bankAccount.bsb);

		var quoteModel = quoteModelFactory.create(),
			paymentData = {
				referenceID: quoteModel.quoteId,
				paymentType: "QUOTE",
				bsbNumber: bankAccount.bsb,
				bankAccountNumber: bankAccount.accountNumber,
				accountHolderName: bankAccount.accountName
			};

		return serviceWrapper.createDirectDebitPayment(paymentData);
	}

	/**
	 * Converts BSB from a number to a string in this format "XXX-XXX".  As input is a number, leading 0's are removed by default
	 * so function pads with 0s if shorter than 6 digits
	 */
	function convertBsbNumberToGuidewireFormat(bsb) {
		var bsb = bsb + "";
		bsb = util.padNumber(bsb, 6, "0");
		return bsb.match(/.{3}/g).join("-");
	}

	/**
	 * Creates a Credit Card Payment in GuideWire
	 * Calls the GuideWire service to create a credit card payment. The data returned from this is then augmented with the credit card details, injected into a form and submitted to CyberSource
	 * @private
	 */
	function _createCreditCardPayment() {
		var quoteModel = quoteModelFactory.create(),
			paymentData = {
				referenceID: quoteModel.quoteId,
				paymentType: "QUOTE",
				redirectUrl: $state.href(
					"cybersourceCallback",
					{},
					{
						absolute: true
					}
				)
			};
		return serviceWrapper.createCreditcardPayment(paymentData);
	}

	/**
	 * Creates a PayPal Payment in GuideWire
	 * Calls the GuideWire service to create a PayPal payment. The data returned is a redirectURL that is used to redirect the browser to PayPal for payment processing
	 * @private
	 */
	function _createPaypalPayment() {
		var quoteModel = quoteModelFactory.create(),
			paymentData = {
				referenceID: quoteModel.quoteId,
				paymentType: "QUOTE",
				redirectUrl: $state.href(
					"paypalCallback",
					{},
					{
						absolute: true
					}
				)
			};

		return serviceWrapper.createPaypalPayment(paymentData);
	}

	/**
	 * Sends successful PayPal payment data to GuideWire
	 * @param {String} payerId						PayerID querystring parameter returned by PayPal in the PayPal Callback page
	 * @param {String} sessionId					SessionID querystring parameter returned by PayPal in the PayPal Callback page
	 * @returns {Promise}							Promise to fulfil after data is sent to GuideWire service
	 */
	function sendPaypalPaymentToGW(payerId, sessionId) {
		var paymentData = {
			payerID: payerId,
			sessionID: sessionId
		};

		return serviceWrapper.sendPaypalPaymentToGw(paymentData);
	}

	/**
	 * Sends successful Unauthenticated PayPal payment data to GuideWire
	 * @param {String} payerId						PayerID querystring parameter returned by PayPal in the PayPal Callback page
	 * @param {String} sessionId					SessionID querystring parameter returned by PayPal in the PayPal Callback page
	 * @param {String} paymentId					PaymentID querystring parameter returned by PayPal in the PayPal Callback page
	 * @returns {Promise}							Promise to fulfil after data is sent to GuideWire service
	 */
	function unAuthSendPaypalPaymentToGW(payerId, sessionId, paymentId) {
		var paymentData = {
			payerID: payerId,
			sessionID: sessionId,
			paymentID: paymentId
		};

		return serviceWrapper.sendPaypalPaymentToGw(paymentData);
	}

	/**
	 * Generates data to submit to CyberSource
	 * This data will be used by a form in an iFrame to generate the form fields, which will then be posted to Cybersource
	 * @param {AJAXResponse} _createCreditCardPaymentResponse			Response from the GuideWire `_createCreditCardPayment` service call
	 * @param {Object} creditCard										Credit card data submitted by the user
	 * @private
	 */
	function _generateCybersourceFormData(
		_createCreditCardPaymentResponse,
		creditCard
	) {
		if (
			_createCreditCardPaymentResponse &&
			_createCreditCardPaymentResponse.data &&
			_createCreditCardPaymentResponse.data.formData
		) {
			if (creditCard.cardExpiryDate) {
				var date = moment(creditCard.cardExpiryDate, "MM/YY");
				var formattedDate = date.format("MM/YY");
				creditCard.cardExpiryDate = formattedDate.replace(
					/(\d+)\//,
					"$1-20"
				);
			}

			var formData = (creditCard.cardNumber) ?
			 angular.extend(
				{},
				_createCreditCardPaymentResponse.data.formData,
				{
					card_type: _getCyberSourceCardType(creditCard.type),
					card_number: creditCard.cardNumber,
					card_expiry_date: creditCard.cardExpiryDate,
					card_cvn: creditCard.cvc,
					merchant_secure_data1: creditCard.cardHolderName
				}
			 )
			 :
			 // payment_token is in _createCreditCardPaymentResponse.data.formData
			 angular.extend(
				{},
				_createCreditCardPaymentResponse.data.formData,
				{
					card_type: creditCard.type,
					card_expiry_date: creditCard.cardExpiryDate,
					card_cvn: creditCard.cvc,
					merchant_secure_data1: creditCard.cardHolderName,
				}
			 );

			return formData;
		}
	}

	/**
	 * Converts credit card type to Cybersource cardType ID
	 * @param cardType
	 * @returns {String}
	 * @private
	 */
	 function _getCyberSourceCardType(cardType) {
		var type = "";

		if (cardType) {
			type = cardType.toLowerCase();
		}

		switch (type) {
			case "visa":
				return "001";
			case "mastercard":
				return "002";
			case "american express":
				return "003";
		}
	}

	return {
		getPaybillConfig: getPaybillConfig,
		initialCreditcardPayment: initialCreditcardPayment,
		generateUniqueId: generateUniqueId,
		getKeyData: getKeyData,
		flexiFormFunction: flexiFormFunction,
		payByCreditCard: payByCreditCard,
		payByPaypal: payByPaypal,
		payByDirectDebit: payByDirectDebit,
		sendPaypalPaymentToGW: sendPaypalPaymentToGW,
		unAuthCreditCardPayment: unAuthCreditCardPayment,
		unAuthPaypalPayment: unAuthPaypalPayment,
		unAuthSendPaypalPaymentToGW: unAuthSendPaypalPaymentToGW,
		unAuthDirectDebitPayment: unAuthDirectDebitPayment
	};
}

PaymentService.bootstrap = function(
	$http,
	$state,
	storage,
	userInputRepository,
	portalServiceWrapper,
	quoteModelFactory,
	util,
	quoteOptions,
	paymentLoggerService
) {
	var userToken =
		"eyJhbGciOiJIUzI1NiJ9.eyJhdXRob3JpdGllcyI6WyJRVU9URToxMDAwMDQwODU2Il0sImlhdCI6MTQ2NDc0ODU1MiwiZXhwIjoxNDY0NzUyMTUyfQ.0GFJ-SxgqEq16Rr1PPC-lhAL0PxblesSRVa2bkRBWxM";

	var conf = {
		paybillConfig: function(host) {
			//for local
			var host1 = host;
			if (host1.indexOf('localhost') !== -1) {
				host1 = 'https://gsc-sys.au.qbe.com/';
			}

			return {
				method: "GET",
				url: host1 + '/api/spa/v3/configuration?id={89E52B78-FAE0-4B62-A2E1-CDD8F5F8713E}'
			}
		},
		initPaymentToken: function(initPaymentTokenUrl, host, guid, merchantId, clientId, clientSecret) {
			return {
				method: "POST",
				url: initPaymentTokenUrl,
				headers: {
					"X-ClientId": clientId,
					"X-ClientSecret": clientSecret,
					"X-SourceSystem": "SIteCore",
					"X-TargetOrigin": host,
					"X-Mockable": "false"
				},
				data: {
					"guid": guid,
					"merchantIdentifier": merchantId
				}
			}
		},
		createCreditcardPayment: {
			method: "POST",
			url: endpointUrls.payments.createCreditcardPayment,
			headers: {
				"EY-Access-Key": "test123",
				"EY-Product-Type": "pc",
				"EY-USER-TOKEN": userToken,
				"X-Requested-By": "92tvt8iy2b"
			}
		},
		createPaypalPayment: {
			method: "POST",
			url: endpointUrls.payments.createPaypalPayment,
			headers: {
				"EY-Access-Key": "test123",
				"EY-Product-Type": "pc",
				"EY-USER-TOKEN": userToken,
				"X-Requested-By": "92tvt8iy2b"
			}
		},
		createDirectDebitPayment: {
			method: "POST",
			url: endpointUrls.payments.createDirectDebitPayment,
			headers: {
				"EY-Access-Key": "test123",
				"EY-Product-Type": "pc",
				"EY-USER-TOKEN": userToken,
				"X-Requested-By": "92tvt8iy2b"
			}
		},
		sendPaypalPaymentToGw: {
			method: "POST",
			url: endpointUrls.payments.sendPaypalPaymentToGw,
			headers: {
				"EY-Access-Key": "test123",
				"EY-Product-Type": "pc",
				"EY-USER-TOKEN": userToken,
				"X-Requested-By": "92tvt8iy2b"
			}
		}
	};

	var serviceWrapper = function() {
		return {
			paybillConfig: function(host) {
				var req = conf.paybillConfig(host);
				return $http(req);
			},
			initialCreditcardPayment: function(initPaymentTokenUrl, host, guid, merchantId, clientId, clientSecret) {
				var req = conf.initPaymentToken(initPaymentTokenUrl, host, guid, merchantId, clientId, clientSecret);
				return $http(req);
			},
			createCreditcardPayment: function(data) {
				if (storage.getItem("eyUserToken")) {
					userToken = storage.getItem("eyUserToken");
				}
				var req = conf.createCreditcardPayment;
				req.data = data;
				req.headers["EY-USER-TOKEN"] = userToken;

				return $http(req);
			},
			createPaypalPayment: function(data) {
				if (storage.getItem("eyUserToken")) {
					userToken = storage.getItem("eyUserToken");
				}

				var req = conf.createPaypalPayment;
				req.data = data;
				req.headers["EY-USER-TOKEN"] = userToken;

				return $http(req);
			},
			createDirectDebitPayment: function(data) {
				if (storage.getItem("eyUserToken")) {
					userToken = storage.getItem("eyUserToken");
				}

				var req = conf.createDirectDebitPayment;
				req.data = data;
				req.headers["EY-USER-TOKEN"] = userToken;

				return $http(req);
			},
			sendPaypalPaymentToGw: function(data) {
				if (storage.getItem("eyUserToken")) {
					userToken = storage.getItem("eyUserToken");
				}

				var req = conf.sendPaypalPaymentToGw;
				req.data = data;
				req.headers["EY-USER-TOKEN"] = userToken;

				return $http(req);
			}
		};
	};
	return new PaymentService(
		new serviceWrapper(),
		portalServiceWrapper,
		$state,
		storage,
		userInputRepository,
		quoteModelFactory,
		util,
		quoteOptions,
		paymentLoggerService
	);
};

"use strict";

function QuoteModelFactory(MODULE_INFO, userInputRepository, serviceResponseRepository, quoteOptions, quoteRequestRepository, Util, $rootScope) {
	function create() {
		quoteOptions.setAvailableQuoteResults(serviceResponseRepository.getLastResponseFrom('quickQuote'));

		switch (MODULE_INFO.id) {
			case 'vehicle':
				return new QuoteModel(MODULE_INFO, userInputRepository, serviceResponseRepository, quoteOptions, quoteRequestRepository, Util);
			case 'bike':
				return new BikeQuoteModel(MODULE_INFO, userInputRepository, serviceResponseRepository, quoteOptions, quoteRequestRepository, Util);
			case 'caravan':
				return new CaravanQuoteModel(MODULE_INFO, userInputRepository, serviceResponseRepository, quoteOptions, quoteRequestRepository, Util);
			case 'payments':
				return new PaymentsQuoteModel(MODULE_INFO, userInputRepository, serviceResponseRepository, Util);
			case 'home':
				return new HomeQuoteModel(MODULE_INFO, userInputRepository, serviceResponseRepository, quoteOptions, quoteRequestRepository, Util, $rootScope);
			case 'ctp':
				return new CTPModel(MODULE_INFO, userInputRepository, serviceResponseRepository, Util);
			default:
				throw 'Unknown module info';
		}
	}

	return {
		create: create
	}
}

function QuoteOptions(quoteConfiguration, serviceResponseRepository, quoteResultModelBuilder, storage) {

	var coverTypeClasses = quoteConfiguration.coverTypeClasses;

	var allCoverTypes = quoteConfiguration.allCoverTypes;

	var allCoverTypesByKey = quoteConfiguration.allCoverTypesByKey;

	var allPaymentFrequencies = quoteConfiguration.allPaymentFrequencies;

	var _reversePaymentFrequenciesLookup = quoteConfiguration._reversePaymentFrequenciesLookup;

	var allQuoteTypes = quoteConfiguration.allQuoteTypes;

	var quoteRuleOptions = quoteConfiguration.quoteRuleOptions;

	var testQuoteDeclineOptions = quoteConfiguration.testQuoteDeclineOptions;

	var defaultCoverType = quoteConfiguration.defaultCoverType;
	var defaultPaymentFrequency = quoteConfiguration.defaultPaymentFrequency ;
	var availableQuoteResults =[];
	var defaultRequotePageName = quoteConfiguration.defaultRequotePageName;

	var defaultOffering = quoteConfiguration.defaultOffering || null ;

	function setSelectedCoverType(coverTypeClass, coverTypeSubClass) {
		if ( ! coverTypeClass )
			throw 'Invalid cover type class provided' ;

		if ( ! coverTypeSubClass )
			coverTypeSubClass = 'standard' ;
		if (!coverTypeClasses[coverTypeClass] || !coverTypeClasses[coverTypeClass].subClasses[coverTypeSubClass]) {
		    selectedCoverType = allCoverTypesByKey[coverTypeClass];
		}
		else {
		    selectedCoverType = coverTypeClasses[coverTypeClass].subClasses[coverTypeSubClass];
		}
		if ( ! selectedCoverType) {
			void 0;
		}

		storage.setItem('selectedCoverType' , selectedCoverType ) ;
	}

	function setSelectedOffering(offering) {
		if ( ! offering )
			throw 'Invalid offering provided' ;

		//get offering object from the configuration
		selectedOffering = quoteConfiguration.allOfferings[offering];

		if ( ! selectedOffering) {
			void 0;
		}

		storage.setItem('selectedOffering' , selectedOffering ) ;
	}

	function getSelectedOffering(){
		var so = storage.getItem('selectedOffering');
		if ( ! so.descriptor )
			so = defaultOffering;
		return so;
	}

	function setDefaultCoverType() {
		setSelectedCoverType(defaultCoverType.superType, defaultCoverType.subType);
	}


	function setSelectedPaymentFrequency(paymentFrequency) {
		selectedPaymentFrequency = _reversePaymentFrequenciesLookup[paymentFrequency];
		storage.setItem('selectedPaymentFrequency' , selectedPaymentFrequency ) ;
		if ( ! selectedPaymentFrequency )
			throw 'Invalid payment frequencey selected' ;
	}

	function getSelectedCoverType(){
		var ct = storage.getItem('selectedCoverType');
		if ( ! ct.descriptor )
			ct = defaultCoverType;
		return ct;
	}

	function getSelectedPaymentFrequency() {
		var selectedPaymentFrequency = storage.getItem('selectedPaymentFrequency');
		if ( typeof(selectedPaymentFrequency) != 'string' )
			selectedPaymentFrequency = defaultPaymentFrequency ;

		return selectedPaymentFrequency;
	}

	function getSelectedPaymentFrequencyForService() {
		var selectedPaymentFrequency = getSelectedPaymentFrequency();
		return allPaymentFrequencies[selectedPaymentFrequency] ;
	}

	function getSelectedQuoteResult() {
		var selectedQuoteResult = null ;
		var mergedQuoteResults = getMergedQuoteResults(availableQuoteResults);
		var coverTypeSelector = getCoverTypeSelector() ; 
		if ( mergedQuoteResults && coverTypeSelector )
			return mergedQuoteResults[coverTypeSelector];

		return null ;
	}

	function getCoverTypeSelector() {
		if (getSelectedCoverType()) {
			var coverTypeSelector = getSelectedCoverType().descriptor ;
			var selectedOffering = getSelectedOffering();
			if ( selectedOffering )
				coverTypeSelector += '_' + selectedOffering.descriptor ;

			return coverTypeSelector;	
		}
	}


	/**
	* @return the selected quote result for the selected payment frequency.
	*/
	function getSelectedQuoteResultForPayment() {
		var qr = getSelectedQuoteResult() ;
		if ( qr ) {
			return qr.getQuoteResult( getSelectedPaymentFrequency() );
		}

		return null;
	}

	function setAvailableQuoteResults(quoteResults) {
		availableQuoteResults = quoteResults ;
	}

	function clearQuoteResults() {
		quoteResultModelBuilder.clear() ; 
	}

	function getMergedQuoteResults(quoteResults) {
		if ( ! quoteResults ) return null;

		quoteResults.forEach(function(result) {
			quoteResultModelBuilder.addQuoteResult(result) ;
		});

		return quoteResultModelBuilder.getMergedQuoteResults();
	}

	function getAvailableCoverTypes() {
		var availableQuoteResults = serviceResponseRepository.getLastResponseFrom('quote') ;
		var availableCoverTypes = [];
		if ( availableQuoteResults ) {
			availableQuoteResults.vehicles[0].availableCoverTypes.forEach(function(qr) {	
				availableCoverTypes.push(allCoverTypesByKey[qr] );
			})
		}
		return availableCoverTypes;
	}

	function getAvailableSumInsuredTypes(){
		var availableQuoteResults = serviceResponseRepository.getLastResponseFrom('quote') ;
		var availableSumInsuredTypes = [];
		if (availableQuoteResults) {
		    if (availableQuoteResults.productCode == "QPYPersonalMotorcycle") {
		        availableQuoteResults.motorcycles[0].availableSumInsuredTypes.forEach(function (qr) {
		            availableSumInsuredTypes.push(qr);
		        })
		    }
		    else {
		        availableQuoteResults.vehicles[0].availableSumInsuredTypes.forEach(function (qr) {
		            availableSumInsuredTypes.push(qr);
		        })
		    }
		}
		return availableSumInsuredTypes;
	}

	function isSumInsuredTypeAvailable(insuredType){
		var availableSumInsuredTypes = getAvailableSumInsuredTypes();
		return (availableSumInsuredTypes.indexOf(insuredType)>-1);
	}

	function isCoverTypeAvailable(coverTypeClass) {
		var availableCoverTypes = getAvailableCoverTypes() ;
		if (availableCoverTypes) {
			for (var key in availableCoverTypes) {
				var ct = availableCoverTypes[key] ;
				if (ct.superType == coverTypeClass )
					return true ;
			}
		}

		return false ;
	}

	function isCoverSubTypeAvailable(coverTypeClass, coverTypeSubClass) {
		var availableCoverTypes = getAvailableCoverTypes() ;
		var expectedType = coverTypeClasses[coverTypeClass].subClasses[coverTypeSubClass];
		return availableCoverTypes.indexOf(expectedType) !== -1 ;
	}

	function getRequoteOptions(pageName) {
		if ( ! pageName )
			pageName = defaultRequotePageName;

		return quoteRuleOptions[pageName] ;
	}

	function isReplacementAvailable(){
		//not used as this info is not available in vehicle page
		var availableQuoteResults = serviceResponseRepository.getLastResponseFrom('quickQuote') ;
		var sumInsuredTypes = [];
		if(availableQuoteResults && (availableQuoteResults.length>0)){
			sumInsuredTypes = availableQuoteResults[0].response.vehicles[0].availableSumInsuredTypes;

			void 0;
		}

		if(sumInsuredTypes.indexOf('replacement')>-1){
			return true;
		}else{
			return false;
		}

	}

	function getTestQuoteDeclineOptions(stepName) {
		return testQuoteDeclineOptions[stepName];
	}

	function getQuickQuoteOptionsForStep(stepName) {
		return quoteRuleOptions[stepName] ;
	}

	function getAllOfferings(){
		return quoteConfiguration.allOfferings;
	}

	function getOfferingPermutations(stepName, coverOptions) {
		var qqOptions = getQuickQuoteOptionsForStep(stepName);
		if ( ! qqOptions )
			return null;

		var offering = null
		if ( qqOptions.permutations.useSelectedOffering == true )
			offering = getSelectedOffering() ;

		return quoteConfiguration.getOfferingPermutations(qqOptions, coverOptions, getSelectedCoverType(), offering);
	}

	function getStateDefaultVoluntaryExcess(state, itemIndex){

		itemIndex = typeof itemIndex !== 'undefined' ? itemIndex : 0;
		
		if(window.globals.defaultExcessMapping == undefined || window.globals.defaultExcessMapping.options == undefined || state == undefined){
			return null;
		}

		var prefix = 'AU_';
		if(state.indexOf(prefix) == -1){
			state = prefix + state;
		}

		var excessMapping = window.globals.defaultExcessMapping.options[itemIndex];

		return excessMapping[state];
	}

	return {
		getQuickQuoteOptionsForStep: getQuickQuoteOptionsForStep,
		getRequoteOptions: getRequoteOptions,
		setSelectedCoverType: setSelectedCoverType,
		setDefaultCoverType: setDefaultCoverType,
		getSelectedCoverType: getSelectedCoverType,
		setSelectedPaymentFrequency: setSelectedPaymentFrequency,
		getSelectedPaymentFrequency: getSelectedPaymentFrequency,
		getSelectedPaymentFrequencyForService: getSelectedPaymentFrequencyForService,
		getSelectedQuoteResult: getSelectedQuoteResult,
		getSelectedQuoteResultForPayment: getSelectedQuoteResultForPayment,
		getSelectedOffering: getSelectedOffering,
		getOfferingPermutations: getOfferingPermutations,
		setSelectedOffering: setSelectedOffering,
		setAvailableQuoteResults: setAvailableQuoteResults,
		getMergedQuoteResults: getMergedQuoteResults,
		isCoverTypeAvailable: isCoverTypeAvailable,
		isCoverSubTypeAvailable: isCoverSubTypeAvailable,
		getTestQuoteDeclineOptions: getTestQuoteDeclineOptions,
		getAllCoverTypes: function() { return allCoverTypes },
		getAllPaymentFrequencies: function() {return allPaymentFrequencies},
		getAllQuoteTypes: function() {return allQuoteTypes},
		getCoverTypeSelector: getCoverTypeSelector,
		isReplacementAvailable: isReplacementAvailable,
		isSumInsuredTypeAvailable: isSumInsuredTypeAvailable,
		getAllOfferings:getAllOfferings,
		clearQuoteResults: clearQuoteResults,
		getStateDefaultVoluntaryExcess: getStateDefaultVoluntaryExcess
	}

}

'use strict' ;

function QuoteResultFilter() {
	return {
		filter : function(filter, list) {
			if ( !filter) return list;

			var filteredList = list.filter(function(quoteResult) {
				return !filter.displayCover || filter.displayCover[quoteResult.coverType] === true ;
			});

			if ( !!filter.displayOffering ) {
				filteredList = filteredList.filter(function(quoteResult) {
					return ! filter.displayOffering || filter.displayOffering[quoteResult.offering] === true ;
				});
			}

			var orderedList = filteredList.sort(function(cover1, cover2) {
				if ( filter.order && filter.order.orderByPrice ){
					var cover1Bigger = cover1.totalPremium > cover2.totalPremium ;
					return filter.order.cheapestFirst ? cover1Bigger : ! cover1Bigger ;
				}
				return 0;
			})

			return orderedList;
		}
	}
}

'use strict';

function QuoteResultModelFactory(MODULE_INFO) {
	function newQuoteResultModel(response) {
		switch (MODULE_INFO.id) {
			case 'vehicle':
				return new VehicleQuoteResultModel(response);
			case 'bike':
				return new BikeQuoteResultModel(response);
			case 'caravan':
				return new CaravanQuoteResultModel(response);
			case 'home':
				return new HomeQuoteResultModel(response);
			default:
				throw 'Unknown module info';
		}
	}

	return {
		newQuoteResultModel: newQuoteResultModel
	}
}

"use strict";

function QuoteService(serviceWrapper, quoteModel, Util) {

	function getQuote() {
		return serviceWrapper.getQuote();
	}

	return {
		getQuote: getQuote
	}
}

QuoteService.createDummyService = function ($q, quoteModel, Util) {
	var conf = {};

	var serviceWrapper = function () {
		return {
			getQuote: function (data) {
				return $q(function (resolve, reject) {
					resolve({
						"return": "data"
					});
				});
			}
		}
	};
	return new QuoteService(new serviceWrapper());
}

QuoteService.bootstrap = function (http, $q, quoteModel, Util) {
	var conf = {
		getQuote: {
			method: 'PUT',
			url: '#URL',
			headers: {
				'EY-Access-Key': 'test123',
				'EY-Product-Type': 'pc',
				'EY-USER-TOKEN': 'eyJhbGciOiJIUzI1NiJ9.eyJhdXRob3JpdGllcyI6WyJRVU9URToxMDAxMDYyNTc1Il0sImlhdCI6MTQ2Mjg2MTM4OCwiZXhwIjoxNDYyODY0OTg4fQ.u1254ES1-_6com7Y2lSltBkVEV6z_WlP43MwbsuwnjE'
			}
		}
	};

	var serviceWrapper = function () {
		return {
			getQuote: function (data, success, error) {
				var req = conf.createPayment;
				req.params = data;
				http(req).then(function (response) {
					success(response);
				}, function (error) {
					void 0;
				});
			}
		}
	};
	return new QuoteService(new serviceWrapper(), quoteModel, Util);
}

function RegisterFieldDecorator() {
	
	function attach($scope, params) {
		
	}

	return {
		attach: attach
	}	
}
"use strict";

function RegoSearchService(guideWireService, transformers) {
	var formData = {},
		gwResponse = {}, // response as received from guideWire
		serviceResponse = {}, // response after being process by any registered transformers
		lastStatus = {}, // error or success in last service call
		transformers = transformers || {} ;

	function transformGWResponse(serviceName, resp) {
		var response = resp;
		if ( transformers.serviceName )
			response = transformers.serviceName.transform(resp);

		return response;
	}

	function processErrorResponse(serviceName, resp, errorFn) {
		gwResponse[serviceName]= resp;
		lastStatus[serviceName]=false;
		serviceResponse[serviceName] = transformGWResponse(serviceName, resp);
		errorFn(serviceResponse[serviceName]);
	}

	function processSuccessResponse(serviceName, resp, successFn) {
		gwResponse[serviceName]= resp;
		lastStatus[serviceName]= true;
		serviceResponse[serviceName] = transformGWResponse(serviceName, resp);
		successFn(serviceResponse[serviceName]);
	}

	function search(data, success, error) {

		guideWireService.regoSearch(data)
            .then(function(response) {
				//console.log(response.data);
                success(response.data);
            })
            .catch(function(response) {
                if(error) {
                    error(response);
                }
            });
	}

	function searchMake(data, success, error) {

		guideWireService.makeSearch(data)
            .then(function(response) {				
				var data1 = convertSearchMakeResponse(response.data.make);
                success(data1);
            })
            .catch(function(response) {
                if(error) {
                    error(response);
                }
            });
	}

	//after vgi uplift, payload changed
	function convertSearchMakeResponse(response) {
		var makes = []; 
		if (!response || response.length == 0) {
			return makes;
		}		
		for (var idx1 = 0; idx1 < response.length; idx1++) {
			var priorityNum1 = parseInt(response[idx1].priority);
			makes.push({
				name: response[idx1].description,
				code: response[idx1].makeCode,
				priority: (priorityNum1 !== NaN) ? priorityNum1 : 0,
			});
		}
		return makes;
	}

	function searchModel(data, success, error) {

		guideWireService.modelSearch(data)
            .then(function(response) {				
				var data2 = convertSearchModelResponse(response.data.model);
                success(data2);
            })
            .catch(function(response) {				
                if(error) {
                    error(response);
                }
            });
	}

	function convertSearchModelResponse(response) {
		var models = [];
		if (!response || response.length == 0) {
			return models;
		}		
		for (var idx2 = 0; idx2 < response.length; idx2++) {
			var priorityNum = parseInt(response[idx2].priority);
			models.push({
				name: response[idx2].description,
				code: response[idx2].modelCode,
				priority: (priorityNum !== NaN) ? priorityNum : 0,
			});
		}
		return models;
	}

	function searchCar(data, success, error) {

		guideWireService.carSearch(data)
            .then(function(response) {
				var searchedData = response.data;
				for (var i = 0; searchedData && i < searchedData.length; i++) {
					if (!searchedData[i].goodRetailPrice) {
						searchedData[i].goodRetailPrice = "0";
					}					
				}
				success(searchedData);
            })
            .catch(function(response) {
                if(error) {
                    error(response);
                }
            });
	}

	function getLastResponse(serviceName) {
		return serviceResponse[serviceName] ;
	}

	function getLastRequest(serviceName) {
		return formData[serviceName] ;
	}

	return {
		search: search,
		searchMake: searchMake,
		searchModel: searchModel,
		searchCar: searchCar,
		getLastRequest: getLastRequest,
		getLastResponse: getLastResponse,
	}
}

RegoSearchService.create=function(guideWireService) {
	var transformers = {
		search: function(resp) {
			return {
				year: resp.modelYear,
				make: resp.make,
				model: resp.model,
				series: resp.series,
				body: resp.bodyStyle,
				transmission: resp.gearType,
				drive: resp.driveDescription,
				engine: resp.engineDescription,
			}
		},
		searchMake: function(resp) {
			return {
				code: resp.code,
				name: resp.name
			}
		}
	}

	return new RegoSearchService(guideWireService)
}

"use strict" ;

function SessionStorage(window) {
	var engine = window.sessionStorage ;

	var setItem = function(key, value) {
		engine.setItem(key, JSON.stringify(value)) ;
	}

	var getItem = function(key) {
		var value = engine.getItem(key) || "{}";
		return JSON.parse(value) ;
	}

	var removeItem = function(key) {
		engine.removeItem(key);
	}

	var clear = function() {
		engine.clear();
	}

	return {
		setItem: setItem,
		getItem: getItem,
		removeItem: removeItem,
		clear: clear
	};
}

(function () {
	"use strict";

	angular.module("qbePortal").service("smartLinkService", smartLinkService);

	function smartLinkService() {
		this.generateLink = generateLink;

		function generateLink(customerData) {
			// JS Implementation of the buildSmartlink code
			var url = customerData.smartLinkURL; //do not change this
			var sharedkey = customerData.hashKey;

			//required arguments
			var merchantidentifer = "qbe-insurance"; // your feefo merchant identifier. This account must have Smartlink activated.
			var name = customerData.policyHolderName; // the customer name
			var email = customerData.email; // the customer email address
			var orderref =
				customerData.policyNumber != null
					? customerData.policyNumber
					: undefined; // your unique order reference number

			var descriptions = [customerData.description]; // description(s) of item(s) purchased

			var productrefs = [customerData.productRefs]; // product ref(s) of items purchased - usually SKU or equivalent

			// recommended arguments
			var date = moment().tz("Australia/Sydney").format("YYYY-MM-DD"); // date of the transaction

			var productlink; // URL to web page of product(s) purchased

			// variable list ends - we now have all the inforamtion we need to build a SmartLink

			// Do not change the variables immediately below
			var markerstart = "|!";
			var markers = {
				EMAIL: "B",
				NAME: "C",
				DATE: "D",
				FEEDBACKDATE: "E",
				DESCRIPTION: "F",
				LINK: "G",
				PRODUCTREF: "H",
				ORDERREF: "I",
				AMOUNT: "J",
				CURRENCY: "K",
				CUSTOMERREF: "M",
				MERCHANTIDENTIFIER: "N",
				TAG: "O",
			};

			// this "if" checks that all required fields exist and are not empty

			if (
				typeof merchantidentifer !== "undefined" &&
				merchantidentifer.length > 0 &&
				typeof email !== "undefined" &&
				email.length > 0 &&
				typeof name !== "undefined" &&
				name.length > 0 &&
				typeof descriptions !== "undefined" &&
				descriptions.length > 0 &&
				typeof productrefs !== "undefined" &&
				productrefs.length > 0 &&
				typeof orderref !== "undefined" &&
				orderref.length > 0
			) {
				// this enormous "if" checks whether the multiline fields all have the same number of items

				if (
					descriptions.length == productrefs.length &&
					(typeof productlinks === "undefined" ||
						productlinks.length == descriptions.length) &&
					(typeof tags === "undefined" ||
						tags.length == descriptions.length) &&
					(typeof amounts === "undefined" ||
						amounts.length == descriptions.length)
				) {
					var initialparams = "";
					initialparams +=
						markerstart +
						markers.MERCHANTIDENTIFIER +
						merchantidentifer;
					initialparams += markerstart + markers.EMAIL + email;
					initialparams += markerstart + markers.NAME + name;
					initialparams += markerstart + markers.ORDERREF + orderref;
					if (typeof date !== "undefined" && date.length > 0) {
						initialparams += markerstart + markers.DATE + date;
					}

					if (
						typeof customerref !== "undefined" &&
						customerref.length > 0
					) {
						initialparams +=
							markerstart + markers.CUSTOMERREF + customerref;
					}
					if (
						typeof feedbackdate !== "undefined" &&
						feedbackdate.length > 0
					) {
						initialparams +=
							markerstart + markers.FEEDBACKDATE + feedbackdate;
					}
					if (
						typeof currencyid !== "undefined" &&
						currencyid.length > 0
					) {
						initialparams +=
							markerstart + markers.CURRENCY + currencyid;
					}
					for (var count = 1; count <= descriptions.length; count++) {
						initialparams +=
							markerstart +
							markers.DESCRIPTION +
							count +
							descriptions[count - 1];
					}
					for (var count = 1; count <= productrefs.length; count++) {
						initialparams +=
							markerstart +
							markers.PRODUCTREF +
							count +
							productrefs[count - 1];
					}
					if (typeof productlinks !== "undefined") {
						for (
							var count = 1;
							count <= productlinks.length;
							count++
						) {
							initialparams +=
								markerstart +
								markers.LINK +
								count +
								productlinks[count - 1];
						}
					}
					if (typeof amounts !== "undefined") {
						for (var count = 1; count <= amounts.length; count++) {
							initialparams +=
								markerstart +
								markers.AMOUNT +
								count +
								amounts[count - 1];
						}
					}
					if (typeof tags !== "undefined") {
						for (var count = 1; count <= tags.length; count++) {
							initialparams +=
								markerstart +
								markers.TAG +
								count +
								tags[count - 1];
						}
					}

					var key = Sha1.hash(
						Sha1.hash(initialparams + sharedkey) + sharedkey
					);
					var smartlink = url + bin2hex(initialparams) + key;

					void 0;
					return smartlink;
				} else {
					void 0;
				}
			} else {
				void 0;
			}
		}
	}

	var Sha1 = {};

	/**
	 * Generates SHA-1 hash of string
	 *
	 * @param {String} msg                String to be hashed
	 * @param {Boolean} [utf8encode=true] Encode msg as UTF-8 before generating hash
	 * @returns {String}                  Hash of msg as hex character string
	 */
	Sha1.hash = function (msg, utf8encode) {
		utf8encode = typeof utf8encode == "undefined" ? true : utf8encode;

		// convert string to UTF-8, as SHA only deals with byte-streams
		if (utf8encode) msg = Utf8.encode(msg);

		// constants [§4.2.1]
		var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];

		// PREPROCESSING

		msg += String.fromCharCode(0x80);

		// convert string msg into 512-bit/16-integer blocks arrays of ints [§5.2.1]
		var l = msg.length / 4 + 2;
		var N = Math.ceil(l / 16);
		var M = new Array(N);

		for (var i = 0; i < N; i++) {
			M[i] = new Array(16);
			for (var j = 0; j < 16; j++) {
				M[i][j] =
					(msg.charCodeAt(i * 64 + j * 4) << 24) |
					(msg.charCodeAt(i * 64 + j * 4 + 1) << 16) |
					(msg.charCodeAt(i * 64 + j * 4 + 2) << 8) |
					msg.charCodeAt(i * 64 + j * 4 + 3);
			} // note running off the end of msg is ok 'cos bitwise ops on NaN return 0
		}
		// add length (in bits) into final pair of 32-bit integers (big-endian) [§5.1.1]
		M[N - 1][14] = ((msg.length - 1) * 8) / Math.pow(2, 32);
		M[N - 1][14] = Math.floor(M[N - 1][14]);
		M[N - 1][15] = ((msg.length - 1) * 8) & 0xffffffff;

		// set initial hash value [§5.3.1]
		var H0 = 0x67452301;
		var H1 = 0xefcdab89;
		var H2 = 0x98badcfe;
		var H3 = 0x10325476;
		var H4 = 0xc3d2e1f0;

		// HASH COMPUTATION [§6.1.2]

		var W = new Array(80);
		var a, b, c, d, e;
		for (var i = 0; i < N; i++) {
			// 1 - prepare message schedule 'W'
			for (var t = 0; t < 16; t++) W[t] = M[i][t];
			for (var t = 16; t < 80; t++)
				W[t] = Sha1.ROTL(
					W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16],
					1
				);

			// 2 - initialise five working variables a, b, c, d, e with previous hash value
			a = H0;
			b = H1;
			c = H2;
			d = H3;
			e = H4;

			// 3 - main loop
			for (var t = 0; t < 80; t++) {
				var s = Math.floor(t / 20);
				var T =
					(Sha1.ROTL(a, 5) + Sha1.f(s, b, c, d) + e + K[s] + W[t]) &
					0xffffffff;
				e = d;
				d = c;
				c = Sha1.ROTL(b, 30);
				b = a;
				a = T;
			}

			// 4 - compute the new intermediate hash value
			H0 = (H0 + a) & 0xffffffff;
			H1 = (H1 + b) & 0xffffffff;
			H2 = (H2 + c) & 0xffffffff;
			H3 = (H3 + d) & 0xffffffff;
			H4 = (H4 + e) & 0xffffffff;
		}

		return (
			Sha1.toHexStr(H0) +
			Sha1.toHexStr(H1) +
			Sha1.toHexStr(H2) +
			Sha1.toHexStr(H3) +
			Sha1.toHexStr(H4)
		);
	};

	//
	// function 'f' [§4.1.1]
	//
	Sha1.f = function (s, x, y, z) {
		switch (s) {
			case 0:
				return (x & y) ^ (~x & z); // Ch()
			case 1:
				return x ^ y ^ z; // Parity()
			case 2:
				return (x & y) ^ (x & z) ^ (y & z); // Maj()
			case 3:
				return x ^ y ^ z; // Parity()
		}
	};

	//
	// rotate left (circular left shift) value x by n positions [§3.2.5]
	//
	Sha1.ROTL = function (x, n) {
		return (x << n) | (x >>> (32 - n));
	};

	//
	// hexadecimal representation of a number
	//   (note toString(16) is implementation-dependant, and
	//   in IE returns signed numbers when used on full words)
	//
	Sha1.toHexStr = function (n) {
		var s = "",
			v;
		for (var i = 7; i >= 0; i--) {
			v = (n >>> (i * 4)) & 0xf;
			s += v.toString(16);
		}
		return s;
	};

	var Utf8 = {}; // Utf8 namespace

	/**
	 * Encode multi-byte Unicode string into utf-8 multiple single-byte characters
	 * (BMP / basic multilingual plane only)
	 *
	 * Chars in range U+0080 - U+07FF are encoded in 2 chars, U+0800 - U+FFFF in 3 chars
	 *
	 * @param {String} strUni Unicode string to be encoded as UTF-8
	 * @returns {String} encoded string
	 */
	Utf8.encode = function (strUni) {
		var strUtf = strUni.replace(/[\u0080-\u07ff]/g, function (c) {
			var cc = c.charCodeAt(0);
			return String.fromCharCode(0xc0 | (cc >> 6), 0x80 | (cc & 0x3f));
		});
		strUtf = strUtf.replace(/[\u0800-\uffff]/g, function (c) {
			var cc = c.charCodeAt(0);
			return String.fromCharCode(
				0xe0 | (cc >> 12),
				0x80 | ((cc >> 6) & 0x3f),
				0x80 | (cc & 0x3f)
			);
		});
		return strUtf;
	};

	function bin2hex(s) {
		// http://kevin.vanzonneveld.net
		// +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
		// +   bugfixed by: Onno Marsman
		// +   bugfixed by: Linuxworld
		// +   improved by: ntoniazzi (http://phpjs.org/functions/bin2hex:361#comment_177616)
		// *     example 1: bin2hex('Kev');
		// *     returns 1: '4b6576'
		// *     example 2: bin2hex(String.fromCharCode(0x00));
		// *     returns 2: '00'

		var i,
			l,
			o = "",
			n;

		s += "";

		for (i = 0, l = s.length; i < l; i++) {
			n = s.charCodeAt(i).toString(16);
			o += n.length < 2 ? "0" + n : n;
		}

		return o;
	}
})();

"use strict";

function UserInputRepository(storage, Util) {
	// var userInput = {};

	function update(input) {
		var userInput = this.get();
		userInput = angular.extend(userInput, input);
		storage.setItem('userInput', userInput);
		// console.log(input);
	}

	function get(defaultData, dotSeperatedFieldPath) {
		defaultData = defaultData || {}
		var userInput = storage.getItem('userInput');
		userInput = Object.extend(defaultData, userInput);
		if (dotSeperatedFieldPath)
			return Util.findHierarchyStringInObject(userInput, dotSeperatedFieldPath, '.');

		return userInput;
	}

	return {
		update: update,
		get: get
	};
}

function dispatchCustomEvent(event, detail) {
	if (
		$("html").hasClass("lt-ie10") ||
		$("html").hasClass("is-ie10") ||
		$("html").hasClass("is-ie11")
	) {
		var newEvent = document.createEvent("CustomEvent");
		newEvent.initCustomEvent(event, true, true, detail);
		window.dispatchEvent(newEvent);
	} else {
		window.dispatchEvent(
			new CustomEvent(event, {
				detail: detail
			})
		);
	}
}

function Util() {
	this.findHierarchyStringInObject = function(object, pathString, delimiter) {
		var keys = pathString.split(delimiter);
		return this.findHierarchyArrayInObject(object, keys);
	};

	this.findHierarchyArrayInObject = function(object, hierarchyArray) {
		var val = object;
		for (var i = 0; i < hierarchyArray.length; i++) {
			var index = i;
			var key = hierarchyArray[i];
			if (key.indexOf("[") == 1 && key.indexOf("]") == key.length - 1) {
				var propertyName = key.substring(2, key.indexOf("="));
				var propertyValue = key.substring(
					key.indexOf("=") + 1,
					key.length - 1
				);
				// GDD-3853 - modified for mixed driver usages
				// var matchingOne = val.filter(function (item) {
				// 	return item[propertyName] == propertyValue;
				// });
				var matchingOne = val;
				var index = key.replace(
					"[" + propertyName + "=" + propertyValue + "]",
					""
				);

				if ((index != "") & (index != "0")) {
					var propertyIndex = parseInt(index);

					if (!isNaN(propertyIndex)) {
						val = matchingOne[propertyIndex];
						continue;
					}
				}

				val = matchingOne[0];

				if (val == null) {
					return null;
				}

				continue;
			}

			if (val[hierarchyArray[index]] == null) return null;

			val = val[hierarchyArray[index]];
		}
		return val;
	};

	this.updateValueInObject = function(object, value, pathString, delimiter) {
		var pathStringArray = pathString.split(delimiter);
		var lastKey = pathStringArray.pop();
		var val = object;
		for (var i = 0; i < pathStringArray.length; i++) {
			if (!val[pathStringArray[i]]) return;

			val = val[pathStringArray[i]];
		}
		val[lastKey] = value;
	};

	this.stringFormat = function(str) {
		var args = Array.prototype.slice.call(arguments, 1);

		return str.replace(/{(\d+)}/g, function(match, number) {
			return typeof args[number] != "undefined" ? args[number] : match;
		});
	};

	this.padNumber = function(num, width, padWith) {
		var padWith = padWith || "0",
			num = num + "";
		return num.length >= width
			? num
			: new Array(width - num.length + 1).join(padWith) + num;
	};

	this.clone = function(value) {
		return jQuery.extend({}, value);
	};

	this.deepClone = function(value) {
		return jQuery.extend(true, {}, value);
	};

	this.generateRandomChar = function() {
		var s = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
		return s.charAt(Math.floor(Math.random() * s.length));
	};

	this.generateRandomString = function(length) {
		var self = this;
		return new Array(length + 1)
			.join("0")
			.split("")
			.map(function() {
				return self.generateRandomChar();
			})
			.join("");
	};

	this.dispatchCustomEvent = function(event, detail) {
		dispatchCustomEvent(event, detail);
	};

	this.arrayFill = function(number, object) {
		if (!Array.prototype.fill) {
			//console.info('hi');
			Array.prototype.fill = function(value) {
				// Steps 1-2.
				if (this == null) {
					throw new TypeError("this is null or not defined");
				}

				var O = Object(this);

				// Steps 3-5.
				var len = O.length >>> 0;

				// Steps 6-7.
				var start = arguments[1];
				var relativeStart = start >> 0;

				// Step 8.
				var k =
					relativeStart < 0
						? Math.max(len + relativeStart, 0)
						: Math.min(relativeStart, len);

				// Steps 9-10.
				var end = arguments[2];
				var relativeEnd = end === undefined ? len : end >> 0;

				// Step 11.
				var final =
					relativeEnd < 0
						? Math.max(len + relativeEnd, 0)
						: Math.min(relativeEnd, len);

				// Step 12.
				while (k < final) {
					O[k] = value;
					k++;
				}

				// Step 13.
				return O;
			};
		}
		//console.info(Array(number).fill(object));
		return Array(number).fill(object);
	};

	this.generatePermutationsArray = function(options1, options2) {
		var permutations = [];
		angular.forEach(options1, function(option1) {
			angular.forEach(options2, function(option2) {
				permutations.push({
					option1: option1,
					option2: option2
				});
			});
		});
		return permutations;
	};

	this.getQueryStringByName = function(location, name) {
		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
			results = regex.exec(location.search);
		return results === null
			? ""
			: decodeURIComponent(results[1].replace(/\+/g, " "));
	};

	this.capitalize = function(token) {
		if (token) {
			return token.charAt(0).toUpperCase() + token.slice(1).toLowerCase();
		}
	};

	this.compareDays = function(responseDate) {
		var expiredQuote;
		var today = moment().tz("Australia/Sydney");
		var quoteDate = moment(responseDate).tz("Australia/Sydney");
		var dateDiff = today.diff(quoteDate, "days");
		if (dateDiff >= 30) {
			return (expiredQuote = true);
		} else return (expiredQuote = false);
	};

	this.linkBuilder = function(generalLink) {
		var sessionProt = window.location.protocol;
		var sessionProtHost = window.location.host;
		var sessionProtPath = generalLink;
		var sessionProtURL =
			sessionProt + "//" + sessionProtHost + sessionProtPath;

		return sessionProtURL;
	};

	this.isUndefinedOrNull = function(arg) {
		if (angular.isUndefined(arg) || arg == null) {
			return true;
		}

		return false;
	};

	this.b64EncodeUnicode = function(str) {
		return btoa(
			encodeURIComponent(str).replace(
				/%([0-9A-F]{2})/g,
				function toSolidBytes(match, p1) {
					return String.fromCharCode("0x" + p1);
				}
			)
		);
	};

	this.b64DecodeUnicode = function(str) {
		return decodeURIComponent(
			atob(str)
				.split("")
				.map(function(c) {
					return (
						"%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
					);
				})
				.join("")
		);
	};
}

angular.module("qbePortal").filter("capitalize", function() {
	return function(token) {
		if (token) {
			return token.charAt(0).toUpperCase() + token.slice(1).toLowerCase();
		}
	};
});

angular.module("qbePortal").filter("sortalpha", function() {
	return function(list, prop) {
		return list.sort(function(a, b) {
			var nameA = a[prop].toUpperCase(); // ignore upper and lowercase
			var nameB = b[prop].toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});
	};
});

angular.module("qbePortal").filter("formatAddress", function() {
	return function(address) {
		function parseState(state) {
			return state.replace("AU_", "");
		}

		if (address)
			return (
				address.addressLine1 +
				" " +
				address.city +
				", " +
				parseState(address.state) +
				", " +
				address.postalCode
			);
	};
});

angular.module("qbePortal").filter("removeNonAlpha", function() {
	return function(token) {
		if (token) {
			var value = token.replace(/[^a-zA-Z0-9]+/g, " ");
			return value.charAt(0).toUpperCase() + value.slice(1);
		}
	};
});

angular.module("qbePortal").filter("splitJoinedWords", function() {
	return function(token) {
		if (token) {
			var value = token.replace(/([A-Z])/g, " $1");
			return value.charAt(0).toUpperCase() + value.slice(1);
		}
	};
});

angular.module("qbePortal").filter("styledCurrency", ["$filter", function($filter) {
	return function(token) {
		if (token) {
			var value = $filter("currency")(token)
				.toString()
				.split(".");
			return value;
		}
	};
}]);

angular.module("qbePortal").filter("useFilter", ["$filter", function($filter) {
	return function() {
		var filterName = [].splice.call(arguments, 1, 1)[0];
		return $filter(filterName).apply(null, arguments);
	};
}]);

angular.module("qbePortal").filter("calculateTotal", function() {
	return function(list, fieldName) {
		var total = null;
		angular.forEach(list, function(value) {
			total += parseFloat(value[fieldName]);
		});
		return total;
	};
});

angular.module("qbePortal").filter("wildcardReplace", [
	"Util",
	function(Util) {
		return function(inString, replaceWith) {
			var args = [].slice.call(arguments);
			if (args[0]) {
				if (typeof args[0] !== "string") {
					args[0] = args[0].$$unwrapTrustedValue();
				}

				return Util.stringFormat.apply(null, args);
			}
		};
	}
]);

angular.module("qbePortal").filter("driverInsured", [
	"Util",
	function(Util) {
		return function(inString, vehicleType) {
			var finalString;

			if (inString) {
				if (typeof inString !== "string") {
					inString = inString.$$unwrapTrustedValue();
				}

				finalString = inString;

				var replaceWith = "insured",
					replace = true;

				switch (vehicleType) {
					case undefined:
						replace = false;
						break;
					case "motorhome":
						replace = false;
						break;
					case "campervan":
						replace = false;
						break;
				}

				// if(vehicleType == undefined)
				// {
				// 	replace = false;
				// }

				if (replace) {
					finalString = inString
						.toLowerCase()
						.replace("driver", replaceWith);
				}
			}

			return finalString;
		};
	}
]);

angular.module("qbePortal").filter("booleanToYesNo", ["$filter", function($filter) {
	return function(token) {
		var value = null;
		if (typeof token === "string") {
			if (["yes", "no"].indexOf(token.toLowerCase()) != -1) {
				value = token.toLowerCase() === "yes";
			} else if (["true", "false"].indexOf(token.toLowerCase() != -1)) {
				value = token.toLowerCase() === "true";
			} else if (["1", "0"].indexOf(token) != -1) {
				value = String(token) === "1";
			}
		} else if (typeof token === "number") {
			if ([1, 0].indexOf(token) != -1) {
				value = token == 1;
			}
		} else if (typeof token === "boolean") {
			value = token;
		}

		return value ? "Yes" : "No";
	};
}]);

angular.module("qbePortal").filter("stringToSummaryDate", ["$filter", function($filter) {
	return function(token) {
		if (isNaN(Date.parse(token))) {
			var returnObject = null;

			var dateObject = {
				day: "",
				month: "",
				year: ""
			};

			if (token && token.length > 0 && token.length == 8) {
				dateObject.day = token.substr(0, 2);
				dateObject.month = token.substr(2, 2);
				dateObject.year = token.substr(4, 4);

				if (
					!isNaN(dateObject.day) &&
					!isNaN(dateObject.month) &&
					!isNaN(dateObject.year)
				) {
					return (
						dateObject.day +
						"/" +
						dateObject.month +
						"/" +
						dateObject.year
					);
				}
			}
			return null;
		}
		return token;
	};
}]);

angular.module("qbePortal").filter("showFslOnlyNsw", function() {
	return function(referenceDocuments, state) {
		return state != "AU_NSW"
			? referenceDocuments.filter(function(d) {
					return d.type != "fsl";
			  })
			: referenceDocuments;
	};
});

angular.module("qbePortal").filter("unique", function() {
	// we will return a function which will take in a collection
	// and a keyname
	return function(collection, keyname) {
		// we define our output and keys array;
		var output = [],
			keys = [];

		// we utilize angular's foreach function
		// this takes in our original collection and an iterator function
		angular.forEach(collection, function(item) {
			// we check to see whether our object exists
			var key = item[keyname];
			// if it's not already part of our keys array
			if (keys.indexOf(key) === -1) {
				// add it to our keys array
				keys.push(key);
				// push this item to our final output array
				output.push(item);
			}
		});
		// return our array which should be devoid of
		// any duplicates
		return output;
	};
});

"use strict";

function ValidationService(labelService) {
	var errors = {} ; 
	
	var supressErrorTypes = [
		'ccNumberType'/** cc validation library used
						 generates two error messages 
						 for invalid card number and invalid
						 card type, the latter is not required
						 to be displayed. */
	];

	function isFormValid() {
		return errors.length > 0;
	}

	function clearAllErrors() {
		errors = {} ; 
	}

	function getFieldErrors(fieldSelector) {
		var err = null ; 
		for (var elementId in errors) {
			var error = errors[elementId] ; 
			if ( error.input == fieldSelector ){
				err = error ; 
				break ; 
			}
		}
		return err;
	}

	/**
	* Error types that are redundant are supressed/filtered out, to avoid displaying them to users. 
	*/
	function removeSupressedErrors(inputErrors) {
		angular.forEach(supressErrorTypes, function(errorType) {
			if ( inputErrors.hasOwnProperty(errorType)) 
				delete inputErrors[errorType] ; 
		});
		return inputErrors ; 
	}

	function registerInputErrors(element, fieldSelector, inputErrors) {
		var commonFieldArray = element.parents('ng-form').map(function(index, parent){return 	$(parent).attr('name');}) ; 
		var commonFieldId =  /** this is meant to be common among multiple radio or checkbox inputs */
			Array.prototype.join.call(commonFieldArray, '_') + element.attr('name') ; 

		var wildcard = element.parents('.ctrl-holder').attr('label-wildcard') ; 
		inputErrors = removeSupressedErrors(inputErrors) ; 

		errors[commonFieldId] = {
			input : fieldSelector, 
			label: labelService.getLabelFor(element.attr('label-key')),
			element: element, 
			wildcard : wildcard,
			errors : inputErrors
		};
	}

	function getAllErrors() {
		return getNonEmptyErrors(errors) ; 
	}

	function getNonEmptyErrors(errors) {
		var nonEmptyErrors = {} ; 
		for (var key in errors) {
			if ( errors[key] && errors[key].errors && Object.keys(errors[key].errors).length > 0 )
				nonEmptyErrors[key] = errors[key] ; 
		}

		return nonEmptyErrors ; 
	}

	/*
	* Validate input fields
	* Param - field name of element
	*/
	function validateField(fieldKey){
		var nonEmptyErrors = {} ; 
		for (var key in errors) {

			if ( errors[key] && errors[key].errors && Object.keys(errors[key].errors).length > 0 && key.indexOf(fieldKey) >= 0 ){
				nonEmptyErrors[key] = errors[key] ; 
				break;
			}
		}

		return nonEmptyErrors ; 
	}

	function validateInput(element, fieldSelector, messageKey) {
		var inputErrors = {} ; 
		if ( ! fieldSelector ) {
			void 0;
			return {};
		}

		var $error = fieldSelector.$error ;
		if ( ! $error ) {
			inputErrors = {};
			return inputErrors ; 
		}

		for (var key in $error) {
			inputErrors[key] = labelService.getValidationMessagesFor(messageKey, key) ; 
			//console.log('input errors for ' + key , inputErrors[key]) ;
		}

		registerInputErrors(element, fieldSelector, inputErrors) ; 

		return  inputErrors ;
	}

	return {
		getFieldErrors: getFieldErrors,
		validateInput: validateInput,
		getAllErrors: getAllErrors,
		clearAllErrors: clearAllErrors,
		validateField: validateField
	};
}

function VehicleQuoteConfiguration(){
	this.coverTypeClasses = {
		comprehensive : {
			label : 'Comprehensive',
			subClasses : {
				standard: {
					label: 'Comprehensive',
					descriptor: 'comprehensive',
					superType: 'comprehensive',
					subType:'standard',
				},
				nominated : {
					label: 'Comprehensive Nominated',
					descriptor: 'comprehensive_nominated',
					superType: 'comprehensive',
					subType: 'nominated',
				},
				preferred: {
					label: 'Comprehensive Preferred',
					descriptor: 'comprehensive_preferred',
					superType: 'comprehensive',
					subType : 'preferred',
				}
			}
		},
		third_party: {
			label: 'Third Party',
			subClasses : {
				standard: {
					label: 'Third party only',
					descriptor: 'third_party',
					superType: 'third_party',
					subType: 'standard',
				},
				fire_and_theft: {
					label: 'Third party fire and theft',
					descriptor: 'third_party_fire_theft',
					superType: 'third_party',
					subType: 'fire_and_theft',
				},
			}
		}
	};

	this.allCoverTypes = {
		comprehensive_standard: this.coverTypeClasses.comprehensive.subClasses.standard,
		comprehensive_nominated: this.coverTypeClasses.comprehensive.subClasses.nominated,
		comprehensive_preferred: this.coverTypeClasses.comprehensive.subClasses.preferred,
		third_party_fire_theft: this.coverTypeClasses.third_party.subClasses.fire_and_theft,
		third_party_standard: this.coverTypeClasses.third_party.subClasses.standard,
	};

	this.allCoverTypesByKey = {
		comprehensive: this.coverTypeClasses.comprehensive.subClasses.standard,
		comprehensive_nominated: this.coverTypeClasses.comprehensive.subClasses.nominated,
		comprehensive_preferred: this.coverTypeClasses.comprehensive.subClasses.preferred,
		third_party_fire_theft:  this.coverTypeClasses.third_party.subClasses.fire_and_theft,
		third_party: this.coverTypeClasses.third_party.subClasses.standard,
	};

	this.allPaymentFrequencies = {
		annual: 'everyyear',
		monthly: 'monthly',
		fortnightly: 'everyotherweek',
	};

	this.defaultPaymentFrequency = this.allPaymentFrequencies.annual;

	this._reversePaymentFrequenciesLookup = {
		yearly: 'annual',
		monthly: 'monthly',
		fortnightly: 'fortnightly',
	};

	this.allQuoteTypes = {
		full: 'Full',
		quick: 'Quick',
	};

	this.quoteRuleOptions = {
		// Rapid estimate quote options
		'rapidEstimate': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'vehicle.estimate' // Note : THESE ARE GUIDEWIRE RULESET AND DO NOT NECESSARILY CORRESPOND TO PAGE NAMES.
			},
			permutations: {
				quoteType: this.allQuoteTypes.quick,
				coverTypes: Object.values(this.allCoverTypes),
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'vehicle.drivers': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'vehicle.vehicle' // Note : THESE ARE GUIDEWIRE RULESET AND DO NOT NECESSARILY CORRESPOND TO PAGE NAMES.
			},
			permutations: {
				quoteType: this.allQuoteTypes.quick,
				coverTypes: Object.values(this.allCoverTypes),
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'vehicle.quote': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'vehicle.quote'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual, this.allPaymentFrequencies.monthly]
			}
		},
		'vehicle.contact': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'vehicle.additional'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'vehicle.payment': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'vehicle.payment'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: Object.values(this.allPaymentFrequencies)
			}
		}
	};

	this.testQuoteDeclineOptions = {
		'vehicle.vehicle' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'vehicle.vehicle'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'vehicle.drivers' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'vehicle.driver'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'vehicle.quote' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'vehicle.quote'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'vehicle.contact' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'vehicle.additional'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		}
	}

	this.defaultCoverType = this.allCoverTypes.comprehensive_standard;
	this.defaultRequotePageName = 'vehicle.quote';
}

(function () {
	'use strict';

	angular.module('qbePortal').directive('addressValidation', function () {

		return {
			require: 'ngModel',
			restrict: 'A',
			link: function (scope, elm, attrs, ctrl) {

				//important- this handler is to manage selection from type-ahead
				scope.$on('type-ahead-value-received', function (value) {
					if (scope.$eval(attrs.addressValidation) == true) {
						//false mark valid
						ctrl.$setValidity('address', true);
					} else {
						//false marks invalid
						ctrl.$setValidity('address', false);
					}
				})


				function validateAddress(ngModelValue) {
					// //console.log(scope.$eval(attrs.addressValidation));
					if (scope.$eval(attrs.addressValidation) == 'true') {
						//false mark valid
						ctrl.$setValidity('address', true);
					} else {
						//false marks invalid
						ctrl.$setValidity('address', false);
					}

					return ngModelValue;
				}

				ctrl.$parsers.push(validateAddress);
			}
		};
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').directive('fullEmailValidation', function () {
		//var EMAIL_REGEXP = /^[_a-zA-Z0-9]+(\.'[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/;
		var EMAIL_REGEXP = /^(?!.*\.{2})[A-Za-z0-9._-]+@[A-Za-z0-9._-]+\.[A-Za-z]{2,4}$/;
		return {
			require: 'ngModel',
			restrict: '',
			link: function (scope, elm, attrs, ctrl) {
				// only apply the validator if ngModel is present and Angular has added the email validator
				if (ctrl && ctrl.$validators.email) {

					// this will overwrite the default Angular email validator
					ctrl.$validators.email = function (modelValue) {
						return ctrl.$isEmpty(modelValue) || EMAIL_REGEXP.test(modelValue);
					};
				}
			}
		};
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').directive('mutualExclusiveValidation', function () {

		return {
			require: 'ngModel',
			restrict: 'A',
			scope: {
				mutualExclusiveValidation: "="
			},
			link: function (scope, elm, attrs, ngModel) {
				// only apply the validator if ngModel is present and Angular has added the email validator
				elm.change(function () {

					if (scope.mutualExclusiveValidation) {
						//atleast 1 option should be present for the validation to function
						if (scope.mutualExclusiveValidation.exclusiveOptions.length > 1) {
							var optionValue = attrs.value;

							//Is the current element one of the mutually exclusive options
							var isRequiredForValidation = scope.mutualExclusiveValidation.exclusiveOptions.indexOf(optionValue) > -1;
							if (isRequiredForValidation) {

								//Get the state of that option and proceed with the validation if true
								if (scope.mutualExclusiveValidation.modelValue[attrs.value]) {
									scope.mutualExclusiveValidation.exclusiveOptions.forEach(function(item){
										if(item!=optionValue){
											scope.mutualExclusiveValidation.modelValue[item] = false;
										}
									})
									scope.$apply();
								}
							}
						}
					}
				});
			}
		};
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').directive('qbAmountDue',
		function () {
			return {
				templateUrl: '../ngviews/directives/qbAmountDue.html',
				restrict: 'E',
				scope: {
					amountDue: '=',
				}, 
			    transclude: true,							
				link: function (scope, element, attrs) {					
					
				}
			};
		});

})();

(function () {
	'use strict';

	angular.module('qbePortal').directive('qbAutoSubmitForm', ["$timeout", function ($timeout) {
		return {
			restrict: 'A',
			link: function ($scope, $el, $attr) {
				$timeout(function () {
					angular.element($el).submit();
				});
			}
		}
	}]);
})();

(function() {
	'use strict';

	angular.module('qbePortal').controller('QBConfirmDialog', QBConfirmDialog);

	QBConfirmDialog.$inject = [
		'$scope',
		'ngDialog',
		'gtmService',
		'labelService',
		'$state',
		'userInputRepository',
		'MODULE_INFO',
		'$sce',
		'$http',
		'storage',
		'Util',
		'$sanitize'
	];

	function QBConfirmDialog(
		$scope,
		ngDialog,
		gtmService,
		labelService,
		$state,
		userInputRepository,
		MODULE_INFO,
		$sce,
		$http,
		storage,
		util,
		$sanitize
	) {
		var vm = this;
		vm.formData = {};

		$scope.$root.$on('open-confirmation-dialog', openDialog);

		function openDialog() {
			getFormName();

			gtmService.trackCTPEvent('VirtualPageview', $state.current, null);

			ngDialog
				.openConfirm({
					template: '../ngviews/directives/qbConfirmDialog.html',
					className: 'ngdialog-theme-default',
					appendClassName: 'ngdialog--confirm',
					scope: $scope,
					closeByDocument: false,
					closeByEscape: false,
					showClose: false,
					disableAnimation: true
				})
				.then(
					function(value) {
						callSaveData(value);
					},
					function(reason) {
						gtmService.trackCTPEvent(
							'gaClick',
							$state.current,
							reason
						);
						$scope.$root.$broadcast('loading-animation-end');
						$scope.$root.$broadcast('reload-recaptcha');
					}
				);
		}

		function callSaveData(event) {
			var req = {
				method: 'POST',
				url: '/api/ctpswitch/savedata',
				data: vm.formData
			};

			$http(req).then(
				function() {
					vm.incentiveDetails.event = event;
					gtmService.trackCTPEvent(
						'gaFormSubmission',
						$state.current,
						vm.incentiveDetails
					);
					storage.clear();
					var sessionProtPath = labelService.getLabelFor(
						'redirectURL'
					);
					window.location.href = util.linkBuilder(sessionProtPath);
				},
				function(err) {
					storage.clear();
					$state.go('error');
				}
			);
		}

		function getFormName() {
			vm.formName = MODULE_INFO.mainFormName;

			switch (vm.formName) {
				case 'ctpForm': {
					vm.formData = userInputRepository.get();

					delete vm.formData.email;
					delete vm.formData.ctpForm.expiryDate;
					delete vm.formData.ctpForm.formConsent.expiryDate;
					delete vm.formData.ctpForm.contactDetails.expiryDate;

					angular.forEach(vm.formData.ctpForm, function(value, key) {
						vm.formData.ctpForm[key] = sanitizeForm(
							vm.formData.ctpForm[key]
						);
					});

					if (
						angular.isDefined(
							vm.formData.ctpForm.incentiveDetails.paymentNumber
						)
					) {
						if (
							vm.formData.ctpForm.incentiveDetails.directDebit ===
							'true'
						)
							vm.formData.ctpForm.incentiveDetails.paymentNumber =
								'';
					} else {
						vm.formData.ctpForm.incentiveDetails.paymentNumber = '';
					}

					vm.incentiveDetails = vm.formData.ctpForm.incentiveDetails;

					if (
						!angular.isDefined(
							vm.formData.ctpForm.contactDetails.surName
						)
					) {		
						vm.formData.ctpForm.contactDetails.surName = '';				
					}
					
					vm.contactDetails = vm.formData.ctpForm.contactDetails;
				}
			}
		}

		function sanitizeForm(object) {
			angular.forEach(object, function(value, key) {
				object[key] = $sanitize(value);
			});
			return object;
		}

		vm.getLabelFor = function(fieldName) {
			return $sce.trustAsHtml(labelService.getLabelFor(fieldName));
		};

		vm.getSectionLabelFor = function(fieldName) {
			return $sce.trustAsHtml(labelService.getSectionLabelFor(fieldName));
		};

		vm.getSectionDescriptionFor = function(fieldName) {
			return $sce.trustAsHtml(
				labelService.getSectionDescriptionFor(fieldName)
			);
		};
	}

	angular.module('qbePortal').directive('qbConfirmDialog', function() {
		return {
			restrict: 'E',
			controller: 'QBConfirmDialog',
			controllerAs: 'vm',
			scope: {},
			transclude: true,
			link: function($scope, element, attrs) {}
		};
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').directive('qbCoverIncludes',
		function () {
			return {
				templateUrl: '../ngviews/directives/qbCoverIncludes.html',
				restrict: 'E',
				scope: {
					coverIncludes: '=',
					coverIncludesTitle: '='
				}, 
			    transclude: true,							
				link: function (scope, element, attrs) {					
					
				}
			};
		});

})();

(function () {
	'use strict';

	// angular.module('qbePortal').controller('ctpProgress', ctpProgress);

	// ctpProgress.$inject = ['$scope'];

	// function ctpProgress($scope) {
	// 	var vm = this;
	// 	vm.ctpCompleted = false;

	// 	$scope.$on('ctp-completed', function(event){
	// 		vm.ctpCompleted = true;
	// 	});	

	// }	

	angular.module('qbePortal').directive('qbCtpProgress', 
		function () {
			return {
				templateUrl: '../ngviews/directives/qbCtpProgress.html',
				//controller: ctpProgress,
				//controllerAs: 'vm',				
				restrict: 'E',
			     scope: {
			     		textDisplay:'=',
			     		ctpStepTotal:'=',
			     		ctpStepNum:'=',
			     		ctpCompleted:'='			              
			            },
			     transclude: true,							
				link: function (scope, element, attrs) {					
					scope.backToForm = function() {
						if(scope.ctpStepNum == 2){
							scope.$emit('show-form-entry');
						}
					}
				}
			};
		});

})();

(function () {
	'use strict';

	angular.module('qbePortal').directive('qbCvcNumeric',

		function () {
			var regexNumber = /^\d+$/;

			return {
				restrict: 'A',
				require: 'ngModel',
				link: function (scope, element, attrs, ngModel) {
					scope.$watch(function () {
						return ngModel.$viewValue;
					}, function (newValue, oldValue) {

						if (newValue && !regexNumber.test(newValue)) {
							ngModel.$setViewValue(oldValue);
							ngModel.$render();
						}
					});
				}
			};
		});
})();

(function () {
	'use strict';
	/*
	 * 	usage
	 * 	minDate:maxDate in jQuery datepicker format
	 *	0d:30d - shows from today to next 30 days
	 *	-1y:1y - shows from last yesr to next year
	 */
	//TODO: Add year range to display all the possible years
	angular.module('qbePortal').directive('qbDatePicker', ['$timeout', '$filter', function ($timeout, $filter) {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, element, attrs, ngModelCtrl) {
				var dateRange = attrs.qbDatePicker;

				//set start date and end date
				var startDate = (dateRange.split(':')[0]) ? dateRange.split(':')[0] : '';
				var endDate = (dateRange.split(':')[1]) ? dateRange.split(':')[1] : '';

				var datePickerOptions = {
					changeYear: true,
					changeMonth: true,
					minDate: startDate,
					maxDate: endDate,
					dateFormat: 'dd/mm/yy',
					yearRange: "-100:+0",
					defaultDate: '+0'
				};
				//timeout is added to add datepicker in next digest cycle
				$timeout(function () {
					element.datepicker(datePickerOptions).change(
						function (e) {
							//if user inputs an oout of range date then datepicker changes it to within range
							element.datepicker('setDate', element.datepicker('getDate'));
							//setting the ngModel explicity after the value on the textbox is modified in the previous step
							ngModelCtrl.$setViewValue($filter('date')(element.datepicker('getDate'), 'dd/MM/yyyy'));
						});

				}, 0, ngModelCtrl, element);
			}
		}
	}]);
})();

(function () {
	'use strict';
	/*
	 * 	usage
	 * 	minDate:maxDate in jQuery datepicker format
	 *	0d:30d - shows from today to next 30 days
	 *	-1y:1y - shows from last year to next year
	 */
	//TODO: Add year range to display all the possible years
	angular.module('qbePortal').directive('qbDateRange', [function () {
		return {
			restrict: 'A',
			getDateUnit: function (u) {
				if (u === 'm') {
					return 'months';
				}
				else {
					return u;
				}
			},
			parseDate: function (dateString) {
				if (dateString !== '') {
					var unitSplit = dateString.match(/[a-zA-Z]+|[\-0-9]+/g);
					if (unitSplit.length === 2) {
						var dateUnit = this.getDateUnit(unitSplit[1]);
						dateString = moment().startOf('day').add(parseInt(unitSplit[0]), dateUnit);
					}
				}
				return dateString;
			},
			link: function (scope, element, attrs, ctrl) {
				var dateRange = attrs.qbDateRange.split(':');

				//set start date and end date
				var startDate = (!!dateRange[0]) ? dateRange[0] : '';
				var endDate = (!!dateRange[1]) ? dateRange[1] : '';
				startDate = this.parseDate(startDate);
				endDate = this.parseDate(endDate);

				element.text('Enter a date between ' + startDate.format('DD/MM/YYYY') + ' and ' + endDate.format('DD/MM/YYYY'));
			}
		}
	}]);
})();

(function () {
	'use strict';
	/*
	 * 	usage
	 * 	minDate:maxDate in jQuery datepicker format
	 *	0d:30d - shows from today to next 30 days
	 *	-1y:1y - shows from last year to next year
	 */
	//TODO: Add year range to display all the possible years
	angular.module('qbePortal').directive('qbDateValidation', [function () {
		return {
			restrict: 'A',
			require: 'ngModel',
			getDateUnit: function (u) {
				if (u === 'm') {
					return 'months';
				} else {
					return u;
				}
			},
			parseDate: function (dateString) {
				if (dateString !== '') {
					var unitSplit = dateString.match(/[a-zA-Z]+|[\-0-9]+/g);
					if (unitSplit.length === 2) {
						var dateUnit = this.getDateUnit(unitSplit[1]);
						dateString = moment().startOf('day').add(parseInt(unitSplit[0]), dateUnit);
					}
				}
				return dateString;
			},
			isValid: function (value, startDate, endDate) {
				var d = moment(value, 'DDMMYYYY');
				if (d.isValid()) {
					return moment(d).isBetween(startDate, endDate, null, '[]');
				}
				return false;
			},
			link: function (scope, element, attrs, ctrl) {

				var dateRange = attrs.qbDateValidation.split(':');

				//set start date and end date
				var startDate = (!!dateRange[0]) ? dateRange[0] : '';
				var endDate = (!!dateRange[1]) ? dateRange[1] : '';
				startDate = this.parseDate(startDate);
				endDate = this.parseDate(endDate);

				// bind enter key
				element.bind("keydown keypress", function (event) {
					if (event.which === 13 && !ctrl.$valid) {
						scope.$apply(function () {
							ctrl.$setViewValue(moment(startDate).startOf('day').format('DDMMYYYY'));
							ctrl.$render();
						});
						event.preventDefault();
					}
				});

				ctrl.$validators.date = function (modelValue) {
					return ctrl.$isEmpty(modelValue) || this.isValid(modelValue, startDate, endDate);
				}.bind(this);
			}
		}
	}]);
})();

(function () {
	'use strict';

		angular.module('qbePortal').directive('qbEmptyShedValidation', [function () {
			return {
				restrict:'AE',
				scope: {
					shedModels:'<',
					ngModel:'<',
					trigger:'<'
				},
				hasValidSheds:function(shedModels){
					var zeroItems=0;
					if(Array.isArray(shedModels)){
						shedModels.forEach(function(item){
							if(item!=undefined && item!=null && item===0){
								zeroItems++;
							}
						});
					}
					return zeroItems!=shedModels.length;
				},
				link: function (scope, element, attrs){
					scope.checkValidSheds = this.hasValidSheds;

					scope.$watch('shedModels',function(newValue,oldValue,scope){
						if (scope.ngModel!=undefined) {
							if(scope.trigger){
					 			scope.ngModel.$setValidity('qbEmptyShedValidation', scope.checkValidSheds(newValue));
						 	}
						 	else{
						 		scope.ngModel.$setValidity('qbEmptyShedValidation', false);
						 	}
						}
						
					});

					scope.$watch('trigger',function(newValue,oldValue,scope){
						
						if (scope.ngModel!=undefined) {
							if(newValue!=undefined && newValue===false ){
							scope.ngModel.$setValidity('qbEmptyShedValidation', true);
							}
							else{
								scope.ngModel.$setValidity('qbEmptyShedValidation', scope.checkValidSheds(scope.shedModels));
							}
						}						
					});
				},

			}
		}]);
	})();

(function () {
	'use strict';

	angular.module('qbePortal').directive('qbEmptyTableValidation', ['aggregatedRemoveService', function (aggregatedRemoveService) {
		return {
			restrict: 'AE',
			scope: {
				tableData: '<',
				ngModel: '<',
				trigger: '<',
				validYears: '<',
			},
			link: function (scope, elm, attrs, ctrl) {
				function tableHasData(rows) {
					var hasData = false;
					if (rows && rows.length > 0) {
						var removedData = aggregatedRemoveService.getList();
						if (!angular.isArray(removedData)) {
							return true;
						}

						rows.some(function (row) {
							if (removedData.indexOf(row) === -1) {
								hasData = true;
								return true;
							}
						});
					}
					return hasData;
				}

				var months = {
					'January': '01',
					'February': '02',
					'March': '03',
					'April': '04',
					'May': '05',
					'June': '06',
					'July': '07',
					'August': '08',
					'September': '09',
					'October': '10',
					'November': '11',
					'December': '12',
				};
				
				/*
				* Function - validate year position via index
				* Params - table data, year length
				* Return - boolean
				*/
				function validMonths(rows, validYears) {
					var isMonthValid = true;
					var lastYearIndex = validYears.length - 1;
					angular.forEach(validYears, function (years, index) {
						if (isMonthValid) {
							for (var i = 0; rows.length > i; i++) {
								if (years.value == rows[i].year.value && isMonthValid) {
									if (index == 0) {
										var month = rows[i].month.value;
										isMonthValid = getEligibleMonths(months[month], true);
									}
									else if (index == lastYearIndex) {
										var month = rows[i].month.value;
										isMonthValid = getEligibleMonths(months[month], false);
									} else {
										isMonthValid = true;
									}
								}
							}
						}
					})
					return isMonthValid;
				}

				/*
				* Function - validate month input against current month
				* Params - month, is current year
				* Return - boolean
				*/				
				function getEligibleMonths(month, currentYear) {
					var validMonth = true;
					var currentMonth = moment().tz("Australia/Sydney").format("M");

					if (!currentYear && parseInt(currentMonth) >= parseInt(month)) {
						validMonth = false;
					}

					if (currentYear && parseInt(month) > parseInt(currentMonth)) {
						validMonth = false;
					}

					return validMonth;
				}

				// scope.$on('table-number-of-rows-changed', function() {
				//   validateTable();
				// });

				scope.$on('form-submitted', function () {
					validateTable();
				});

				function validateTable() {
					if (scope.trigger) {
						scope.ngModel.$setValidity('qbEmptyTableValidation', tableHasData(scope.tableData));
						if (scope.validYears)
							scope.ngModel.$setValidity('qbInvalidMonth', validMonths(scope.tableData, scope.validYears));
					}
					else {
						scope.ngModel.$setValidity('qbEmptyTableValidation', true);
						if (scope.validYears)
							scope.ngModel.$setValidity('qbInvalidMonth', true);						
					}
						
				}
			}
		};
	}]);
})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('qbRadioLabel', qbRadioLabelController);

	qbRadioLabelController.$inject = ['$scope', 'labelService'];

	function qbRadioLabelController($scope, labelService) {
		var vm = this,
			fieldKey = $scope.fieldKey;

		vm.fieldName = $scope.name;
		vm.isError = false;

		$scope.$on('enable-field-error-class', function (event) {
			vm.isError = true;
		});

		$scope.$on('element-id-set', function (event, labelKey, id) {
			if (fieldKey !== labelKey) return;
			vm.labelFor = id;
		});

		vm.label = $scope.label || labelService.getLabelFor(fieldKey);

		vm.addTooltip = $scope.hasOwnProperty('addTooltip');
		if (vm.addTooltip)
			vm.tooltip = labelService.getTooltipFor(fieldKey);
	}

	angular.module('qbePortal').directive('qbRadioLabel', function () {
		return {
			templateUrl: '../ngviews/directives/qbRadioLabel.html',
			restrict: 'E',
			controller: qbRadioLabelController,
			controllerAs: 'vm',
			// transclude: true,
			scope: {
				label: '@',
				fieldKey: '@',
				addTooltip: '@?',
			},
		}
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('FieldWrapper', FieldWrapper);

	FieldWrapper.$inject = ['$scope', 'labelService', '$sce', '$filter', 'gtmService'];

	function FieldWrapper($scope, labelService, $sce, $filter, gtmService) {
		var vm = this,
			fieldKey = $scope.fieldKey,
			qbTrack = $scope.qbTrack;

		vm.fieldName = $scope.name;
		vm.showErrorBottom = $scope.showErrorBottom;
		vm.isError = false;
		vm.hintCatcher = null;
		vm.expandHintText = $scope.expandHintText == undefined ? false : $scope.expandHintText;

		vm.getGlobalOptionLabel = function (optionType, optionValue) {
			return labelService.getGlobalOptionLabel(optionType, optionValue);
		}

		$scope.$on('enable-field-error-class', function (event) {			
			vm.isError = true;
		});

		$scope.$on('element-id-set', function (event, labelKey, id) {
			if (fieldKey !== labelKey) return;
			vm.labelFor = id;
		});

		$scope.$on('hide-hint', function(event){
			vm.showHint = false;
		});

		$scope.$on('show-hint', function(event){
			setTimeout(function () {
				QBE.expandCollapse.init();
			}, 1000)			
			vm.showHint = true;
		});		


		// If there's a fieldKey, look up all the labels/helptext
		if (fieldKey) {
			//Additional hint param
			vm.showHint = true;
			
			// Wildcard
			vm.labelWildcard = $scope.labelWildcard;

			// Label
			vm.label = labelService.getLabelFor(fieldKey);

			// Hide labels which are used for accessibility
			vm.hideLabel = $scope.hasOwnProperty('hideLabel');

			// Tooltip
			vm.tooltip = labelService.getTooltipFor(fieldKey);

			// HTML Label
			// vm.labelMarkup = $sce.trustAsHtml(labelService.getLabelFor(fieldKey));

			// Help Text
			if(typeof vm.labelWildcard == 'string' || typeof vm.labelWildcard == 'undefined'){
				vm.hintText = $sce.trustAsHtml($filter('wildcardReplace')(labelService.getHintTextFor(fieldKey), vm.labelWildcard));			
			}else{
				// Handle multiple wildcard
				var argArr = [];
				argArr.push(labelService.getHintTextFor(fieldKey));
				argArr = argArr.concat(vm.labelWildcard);
				vm.hintText = $sce.trustAsHtml($filter('wildcardReplace').apply(null, argArr));			
			}
			
			// Extended Help Text
			// TODO: fix this to not use timeout
			setTimeout(function () {
				QBE.expandCollapse.init();
			}, 1000)
			vm.helpText = $sce.trustAsHtml(labelService.getHelpTextFor(fieldKey));

			// Secondary info Text
			vm.secondaryInfoText = $sce.trustAsHtml(labelService.getSecondaryInfoTextFor(fieldKey));
		}

		vm.getLabel = function () {
			var label = vm.label;

			vm.labelWildcard = $scope.labelWildcard;

			if (vm.labelWildcard) {
				label = $filter('wildcardReplace')($sce.trustAsHtml(vm.label), vm.labelWildcard);
			}

			return label;
		}

		vm.showImageRefForPayment = function(data) {
			void 0;
			if(data == 'enterPaymentRef') {
				angular.element('#pay-img-ref').toggleClass('ng-hide');
			}
		}

		/*
			When select a product from drop down
			validate product and do Gtm tracking
		*/
		vm.tooltipMouseOver = function(tooltipMessage) {
			if (qbTrack === 'true') {
				gtmService.trackTooltipMouseOver(tooltipMessage);
			}
		}
	}

	angular.module('qbePortal').directive('qbFieldWrapper', function () {
		return {
			templateUrl: '/ngviews/directives/qbFieldWrapper.html',
			restrict: 'A',
			controller: FieldWrapper,
			controllerAs: 'vm',
			transclude: true,
			scope: {
				fieldKey: '@',
				hideLabel: '@?',
				labelWildcard: '<',
				secondaryInfoTextDisplayOn: '=?',
				validationSelector: '@',
				showErrorBottom: '@',
				expandHintText: '=',
				qbTrack:'@?',
			}
		}
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').directive('qbFormField', ['hierarchyDecorator', 'validationService', 'userInputRepository',
		function (hierarchyDecorator, validationService, userInputRepository) {
			return {
				restrict: 'A',
				controllerAs: 'vm',
				require: 'ngModel',
				scope: {
					name: '@',
					labelKey: '@',
					setHierarchy: '&?',
					commonValue: '@?',
					spinner:'<',
				},
				link: function (scope, element, attrs, ngModelCtrl, transclude) {
					var hasError = false;
					scope._element = element;
					var model = ngModelCtrl;

					scope.$on('broadcast-field-errors', function () {
						hasError = true;
					});

					function formIsSubmitted() {
						return hasError == true;
					}

					scope.$watch(function () {
						validationService.validateInput(element, ngModelCtrl, scope.labelKey);
						var parent = element.parents('div.ctrl-holder');
						if (!parent || !parent[0]) return;
						parent = $(parent).first();
						
						if (ngModelCtrl.$invalid && (ngModelCtrl.$dirty || formIsSubmitted())) {
							parent.addClass('is-error');
						} else {
							parent.find('[data-name='+scope.labelKey+']').addClass('ng-hide'); //applicable only for CTP forms
							parent.removeClass('is-error');
						}
					});

					if (scope.commonValue !== undefined) {
						// console.log( model.$modelValue ) ;
						model.$viewChangeListeners.push(function () {
							scope.$emit('common-value-update', {name: scope.commonValue, value: model.$modelValue});
						});
						model.$formatters.push(function () {
							/** run on initialisation of model value */
							scope.$emit('common-value-update', {name: scope.commonValue, value: model.$modelValue});
							return model.$modelValue;
						});
					}

					if (scope.setHierarchy !== undefined)
						hierarchyDecorator.attach(scope, {element: scope._element, name: scope.name});
				}
			};
		}]);
})();

/**
 * qbFormSection (qb-form-section) aims to implement a reusable binding container which facilitate access to reference values
 * and main functionalities and services available to different sections of the form without coupling each section to the parent
 * data structure.
 */
(function () {
	"use strict";

	angular.module("qbePortal").controller("FormSection", FormSection);

	FormSection.$inject = [
		"$scope",
		"$rootScope",
		"$state",
		"$sce",
		"$window",
		"quoteOptions",
		"quoteModelFactory",
		"labelService",
		"userInputRepository",
		"serviceResponseRepository",
		"paymentService",
		"Util",
		"$http",
		"$filter",
		"$location",
		"storage",
		"campaignService",
		"paymentLoggerService",
		"gtmService"
	];

	function FormSection(
		$scope,
		$rootScope,
		$state,
		$sce,
		$window,
		quoteOptions,
		quoteModelFactory,
		labelService,
		userInputRepository,
		serviceResponseRepository,
		paymentService,
		Util,
		$http,
		$filter,
		$location,
		storage,
		campaignService,
		paymentLoggerService,
		gtmService
	) {
		var vm = this;
		var userInputValues = {},
			children = {},
			sectionData = {};
		var errorCount = 0;
		var isRetrieval = storage.getItem("retrieve");
		$scope.hierarchyList = [$scope.name];
		vm.sectionName = $scope.name;
		vm.fieldValues = $scope.fieldValues || {};
		vm.formSelector = $scope.formSelector;
		vm.aggregatedListName = $scope.aggregatedListName;
		vm.fieldOptions = {};
		vm.children = children;
		vm.commonValues = {};
		vm.isEligible = false;
		vm.showError = false;
		vm.showPaypalError = false;
		vm.showAustpostBillpay = 0;
		vm.showSDExemption = storage.getItem("stamp-duty");
		vm.showCreditCard = false;
		vm.microformInstance = undefined;		

		vm.policyStartDateChanged = function(value) {
			if (!moment(value, "DD/MM/YYYY").isValid()) {
				return;
			}
			storage.setItem(
				'policy-start-date', 
				moment(
					value,
					"DD/MM/YYYY"
				).format("YYYY-MM-DD"));
			$rootScope.$broadcast("recall-get-details");
		};

		vm.toolTipHover = function(message) {
			gtmService.trackTooltipMouseOver(message);
		};

		function trackformErrorByErrorMessage(errMessage) {
			/* gtm track error message */
			if (errMessage) {
				gtmService.trackStandardEvent('error', 'error message', errMessage, true);
			}			
			/* end gtm track error message */
		}

		if (
			!isUndefinedOrNull($window.qbe.fieldLabels.config) &&
			!isUndefinedOrNull(
				$window.qbe.fieldLabels.config.AllowClaimsPayments
			)
		) {
			vm.showAustpostBillpay =
				$window.qbe.fieldLabels.config.AllowClaimsPayments;
		}

		if ($window.qbe.fieldLabels.validationSummary != undefined) {
			vm.formErrorMessage =
				$window.qbe.fieldLabels.validationSummary.formErrorMessage;

			if (vm.showError) {
				trackformErrorByErrorMessage(vm.formErrorMessage);
			}			
		}

		//unauthenticated payment
		vm.showPaymentSection = false;
		vm.isEnterPaymentRefError = false;
		vm.isEnterPaymentRefErrorLength = false;
		vm.policyCategory = "";
		vm.validateProducts = validateProducts;
		vm.selectProduct = selectProduct;

		vm.showContentsSumInsuredInLowerRange = false;
		vm.showYourContentsSumInsuredInLowerRange = false;
		vm.getBuildingEstimate = getBuildingEstimate;
		vm.getBuildingMaximum = getBuildingMaximum;
		vm.getBuildingMinimum = getBuildingMinimum;
		vm.getEstimateRebuild = getEstimateRebuild;
		vm.stateName = $state.$current.name;
		vm.validateBuildingSumInsured = validateBuildingSumInsured;
		vm.toggleContentsSumInsuredInLowerRange = toggleContentsSumInsuredInLowerRange;
		vm.toggleYourContentsSumInsuredInLowerRange = toggleYourContentsSumInsuredInLowerRange;
		vm.showAggregate = false;

		vm.csCCInvalid = false;
		vm.csCVCInvalid = false;

		$scope.$on("credit-card-number-isvalid", function (e, val) {
			vm.csCCInvalid = !val;
		});

		$scope.$on("credit-card-cvc-isvalid", function (e, val) {
			vm.csCVCInvalid = !val;
		});

		$scope.$on("bike-selected", function (e, val) {
			if (vm.fieldValues.insuredExcessValue){
				if (vm.fieldValues.insuredExcessValue.comprehensivePref === "agreed") {
					vm.fieldValues.insuredExcessValue.comprehensivePref = "market";
					vm.requote();
				}
			}			
		});
		//validate if quote is from retrieval to show driver aggregates
		if (angular.equals(isRetrieval, {})) vm.showAggregate = true;

		/*
		 * Polyfill for startswith for non supported browser
		 *
		 */
		if (!String.prototype.startsWith) {
			String.prototype.startsWith = function (searchString, position) {
				position = position || 0;
				return (
					this.substr(position, searchString.length) === searchString
				);
			};
		}

		//Fill in old details if returned from Paypal
		function restoreDetails() {
			var formDetails = storage.getItem("userInput");

			vm.fieldValues.selectInsuranceType =
				formDetails.paybillForm.selectInsuranceType.selectInsuranceType;
			validateProducts(vm.fieldValues.selectInsuranceType);
			vm.fieldValues.enterPaymentRef =
				formDetails.paybillForm.selectInsuranceType.enterPaymentRef;
			storage.setItem("auto-find-bill", {
				trigger: true,
			});
		}

		if ($window.qbe.fieldLabels != undefined) {
			vm.sessionLabels = $window.qbe.fieldLabels.sessionFunction;
		}

		$scope.$on("restore-payment-details", function () {
			restoreDetails();
		});

		$scope.$on("clear-field-values", function () {
			storage.clear();
			$scope.formData = {};
		});

		$scope.$root.$on("common-value-update", function (event, update) {
			vm.commonValues[update.name] = update.value;
		});

		$scope.$on("switch-to-QBE", function (event, isEligible) {
			vm.isEligible = isEligible;
		});

		//show amount on top right payments pag
		$scope.$on("switch-payment-amount", function (
			event,
			showPaymentSection
		) {
			vm.showPaymentSection = showPaymentSection;
		});

		$scope.$on("show-aggregate", function () {
			vm.showAggregate = true;
		});

		/** Event received from child sections to receive common values upon initialisation
		 * This is for cases when sections requiring common values are registered after those providing them
		 */
		$scope.$on("request-common-values", function (event, update) {
			$scope.$broadcast("received-common-values", vm.commonValues);
		});

		/** updates common values upon receiving from parent section */
		$scope.$on("received-common-values", function (event, commonValues) {
			vm.commonValues = commonValues;
		});

		$scope.$on("broadcast-field-errors", function (event) {
			vm.showError = true;
			vm.showPaypalError = false;
			vm.formErrorMessage =
				$window.qbe.fieldLabels.validationSummary == undefined
					? null
					: $window.qbe.fieldLabels.validationSummary
							.formErrorMessage;
			trackformErrorByErrorMessage(vm.formErrorMessage);
		});

		$scope.$on("broadcast-no-field-errors", function (event) {
			vm.showError = false;
			vm.showPaypalError = false;
		});

		$scope.$on("paypal-payment-error", function (event) {
			vm.showPaypalError = true;
			vm.formErrorMessage =
				$window.qbe.fieldLabels.paypalCodeMessage.value;
			trackformErrorByErrorMessage(vm.formErrorMessage);
		});

		$scope.$on("payment-already-made", function (event) {
			vm.showError = true;
			vm.showPaypalError = false;
			vm.formErrorMessage =
				$window.qbe.fieldLabels.validationSummary.alreadyPaidMessage;
			trackformErrorByErrorMessage(vm.formErrorMessage);
		});

		$scope.$on("payment-error", function (event) {
			vm.showError = true;
			vm.showPaypalError = false;
			vm.formErrorMessage =
				$window.qbe.fieldLabels.validationSummary.paymentErrorMessage;
			trackformErrorByErrorMessage(vm.formErrorMessage);
		});

		$scope.$on("invalid-payment-reference-number", function (event) {
			vm.showError = true;
			vm.showPaypalError = false;
			if ($window.qbe.fieldLabels.paymentRefNoMatchFound) {
				vm.formErrorMessage =
				$window.qbe.fieldLabels.paymentRefNoMatchFound.pleaseCheckRefNumber;
				trackformErrorByErrorMessage(vm.formErrorMessage);
			}
		});

		$scope.$on("direct-debit-payment-error", function (event) {
			vm.showError = true;
			vm.showPaypalError = false;
			vm.formErrorMessage =
				$window.qbe.fieldLabels.directDebitMessage.value;
			trackformErrorByErrorMessage(vm.formErrorMessage);
		});

		// $scope.$on('credit-card-form-error', function (event) {
		// 	vm.showError = true;
		// 	vm.showPaypalError = false;
		// 	vm.formErrorMessage = $window.qbe.fieldLabels.validationSummary.formErrorMessage;
		// });
		/**
		 * Holds all the reference values to be used by the form section to access
		 * other values entered by the user in other steps of the form.
		 */
		vm.quoteModel = quoteModelFactory.create();

		$scope.$root.$on("selected-quote-changed", function () {
			vm.quoteModel = quoteModelFactory.create();
		});

		// Check the return of campaign code validation
		$scope.$on("valid-campaign", function (event, args) {
			if (args.isValid) {
				vm.campaignBanner = campaignService.getCampaignConfig(
					args.promoValue,
					false
				).content;
				vm.isCampaignCodeValid = campaignService.getCampaignConfig(
					args.promoValue,
					false
				).isCampaignCodeValid;
			} else {
				vm.isCampaignCodeValid = false;
			}
		});

		$scope.$root.$on("update-quote-model-reference", function () {
			vm.quoteModel = quoteModelFactory.create();
		});
		/**
		 * Creates an Array and assigns it to the fieldValues with the given name @fieldName
		 */
		vm.initialiseListFor = function (fieldName) {
			if (
				!vm.fieldValues[fieldName] ||
				!Array.isArray(vm.fieldValues[fieldName])
			)
				vm.fieldValues[fieldName] = [];
		};

		/**
		 * Creates an object {} and assings it to the fieldValues with given name @fieldName
		 */
		vm.initialiseFieldValue = function (formObjectName) {
			if (!vm.fieldValues[formObjectName]) {
				vm.fieldValues[formObjectName] = {};
			}
		};

		/**
		 * Gets the list of options from labelService for the fieldName provided @fieldName
		 * optionally adds @defaultValue to the list.
		 */
		vm.getOptionsFor = function (fieldName, defaultValue) {
			return getOptions(fieldName, defaultValue);
		};

		vm.disableNext = function (disable) {
			$scope.$emit("disable-next", disable);
		};

		vm.disableNextForConvictions = function (key, value, section) {
			$scope.$emit("conviction-check", {
				conviction: key,
				input: value,
				section: section,
			});
		};

		function getOptions(fieldName, defaultValue) {
			if (!vm.fieldOptions[fieldName]) {
				vm.fieldOptions[fieldName] = labelService
					.getOptionsFor(fieldName)
					.slice();
				if (defaultValue)
					vm.fieldOptions[fieldName].unshift(defaultValue);
			}

			return vm.fieldOptions[fieldName];
		}

		// TODO: set campaign code for ctp sa
		vm.getCtpBanner = function () {
			var codeFromLink = userInputRepository.get(
				{},
				"ctpForm.promotionalCode.value"
			);

			if (!isUndefinedOrNull(codeFromLink)) {
				vm.campaignBanner = campaignService.getCampaignConfig(
					codeFromLink,
					false
				).content;
				if (isUndefinedOrNull(vm.campaignBanner)) {
					return false;
				} else return true;
			}
		};

		vm.getCampaignSteps = function (text) {
			return $sce.trustAsHtml(text);
		};

		vm.getObjectValue = function (fieldName, fieldLabel) {
			return $sce.trustAsHtml(
				labelService.getObjectValue(fieldName, fieldLabel)
			);
		};

		vm.getObjectValueRaw = function (fieldName, fieldLabel) {
			return labelService.getObjectValue(fieldName, fieldLabel);
		};

		vm.getLabelFor = function (fieldName) {
			return $sce.trustAsHtml(labelService.getLabelFor(fieldName));
		};

		vm.getSectionLabelFor = function (fieldName) {
			return $sce.trustAsHtml(labelService.getSectionLabelFor(fieldName));
		};

		vm.getSectionDescriptionFor = function (fieldName) {
			return $sce.trustAsHtml(
				labelService.getSectionDescriptionFor(fieldName)
			);
		};

		vm.getHintTextFor = function (fieldName) {
			return $sce.trustAsHtml(labelService.getHintTextFor(fieldName));
		};

		vm.getHelpTextFor = function (fieldName) {
			return $sce.trustAsHtml(labelService.getHelpTextFor(fieldName));
		};

		vm.getGlobalOptionsFor = function (optionType, defaultValue) {
			var options = labelService.getGlobalOptionsFor(optionType).slice();
			if (defaultValue) {
				options.unshift(defaultValue);
			}

			return options;
		};

		vm.getGlobalOptionLabel = function (optionType, optionValue) {
			var optionKeyValues = this.getGlobalOptionsFor(optionType);
			var label = null;
			if (optionKeyValues) {
				angular.forEach(optionKeyValues, function (option) {
					if (option.value == optionValue) label = option.label;
				});
			}

			return label;
		};

		/**
		 * Gets content-authored option names from the label service for options returned by the service.
		 * This allows content-authors to define labels for values returned by GuideWire services for example.
		 */
		vm.getLabelForRemoteOption = function (fieldName, labelKey) {
			return labelService.getLabelForRemoteOption(fieldName, labelKey);
		};

		vm.hasServiceResponseFrom = function (serviceName) {
			//call getUserInput method in form.controller to have a session storage
			$scope.$root.$broadcast("get-user-input");
			QBE.expandCollapse.init();
			return (
				serviceResponseRepository.getLastResponseFrom(serviceName) !==
				null
			);
		};

		vm.setCoverTypeClass = function (coverTypeClass) {
			vm.setSelectedCoverType(coverTypeClass, "standard");
		};

		vm.setCoverTypeClassWithMotorSubClass = function (
			coverTypeClass,
			comprehensiveCoverTypeSubClass,
			thirdPartyCoverTypeSubClass
		) {
			if (coverTypeClass === "comprehensive") {
				//comprehensive set to standard
				vm.setSelectedCoverType(coverTypeClass, "standard");
			} else if (coverTypeClass === "third_party") {
				if (thirdPartyCoverTypeSubClass === "third_party") {
					//production issue fix [CPJIRA-4147] as default 3rd party is standard
					thirdPartyCoverTypeSubClass = "standard";
				}
				vm.setSelectedCoverType(
					coverTypeClass,
					thirdPartyCoverTypeSubClass
				);
			} else {
				//else do a standard subclass
				vm.setSelectedCoverType(coverTypeClass, "standard");
			}
		};

		vm.setCoverTypeSubClass = function (coverTypeSubClass) {
			var coverType = quoteOptions.getSelectedCoverType();
			vm.setSelectedCoverType(coverType.superType, coverTypeSubClass);
		};

		vm.setSelectedCoverType = function (coverTypeClass, coverTypeSubClass) {
			quoteOptions.setSelectedCoverType(
				coverTypeClass,
				coverTypeSubClass
			);
			vm.requote();
			// $scope.$root.$broadcast('selected-quote-changed') ;
		};

		vm.setSelectedOffering = function (offering) {
			quoteOptions.setSelectedOffering(offering);
			vm.requote();
			// $scope.$root.$broadcast('selected-quote-changed') ;
		};

		/*
		 *calculates the claimable rent
		 * weeks - in format '4Weeks'...'15Weeks'
		 */
		vm.getRentClaimValue = function (weeklyRent, weeks) {
			return parseInt(weeks) * weeklyRent;
		};

		vm.isSumInsuredTypeAvailable = function (insuredType) {
			return quoteOptions.isSumInsuredTypeAvailable(insuredType);
		};

		vm.isCoverTypeAvailable = function (coverTypeClass) {
			return quoteOptions.isCoverTypeAvailable(coverTypeClass);
		};

		vm.isCoverSubTypeAvailable = function (
			coverTypeClass,
			coverTypeSubClass
		) {
			return quoteOptions.isCoverSubTypeAvailable(
				coverTypeClass,
				coverTypeSubClass
			);
		};

		vm.getSelectedCoverType = function () {
			return quoteOptions.getSelectedCoverType();
		};

		vm.getSelectedQuote = function () {
			return quoteOptions.getSelectedQuoteResponse();
		};

		vm.getQuickQuoteData = function () {
			return serviceResponseRepository.getLastResponseFrom("quickQuote");
		};

		vm.isStrataOrRegisteredVisible = function () {
			var buildingType = userInputRepository.get(
				{},
				"homeForm.tellUsAboutTheProperty.typeOfBuilding"
			);
			var state = userInputRepository.get(
				{},
				"homeForm.tellUsAboutTheProperty.address.state"
			);
			var includedTypes = [
				"unit",
				"duplex",
				"triplex",
				"flat",
				"villa",
				"townhouse",
			];
			if (state === "AU_WA" && includedTypes.indexOf(buildingType) > -1) {
				return true;
			} else {
				return false;
			}
		};

		vm.getAddressState = function () {
			var state = userInputRepository.get(
				{},
				"homeForm.tellUsAboutTheProperty.address.state"
			);
			return state;
		};

		vm.isRapidEstimatePanelVisible = function () {
			var visible = true;
			if (vm.sectionName === "homeForm") {
				var howIsHomeOccupied = vm.commonValues.howIsHomeOccupied;
				if (howIsHomeOccupied === "unoccupied") {
					visible = false;
				}

				if (
					vm.commonValues.coverNeeds_contents == true ||
					vm.commonValues.coverNeeds_building == true
				) {
				} else {
					visible = false;
				}
			}

			return visible;
		};

		vm.isDisplayRapidEstimate = function () {
			var display = false;
			if ($window.qbe.rapidEstimateDisplay) {
				if ($window.qbe.rapidEstimateDisplay.display == true) {
					display = true;
				} else {
					display = false;
				}
			}
			return display;
		};
		vm.$onInit = function () {
			if ($scope.register)
				// gtm track landing page
				if ($scope.name === 'paybillForm') {
					gtmService.trackPayBillVirtualPageLanding();
				}
				$scope.register({
					name: $scope.name,
					init: vm.initFn,
					get: vm.getValue,
				});

			if ($scope.formData) {
				//sets it back to the formsection as the object has not been fully initialised when called in form controller
				Util.dispatchCustomEvent("register-labels");
				vm.fieldValues = $scope.formData[$scope.name] || {};
			}

			if (vm.sectionName == "yourBuilding") {
				//dd-3747 - added building sum insured checking because radio buttons are not in the data model
				checkBuildingSumInsured();
			}

			if (vm.sectionName == "mainPolicyHolderContact") {
				vm.fieldValues.emailAddress1 = vm.quoteModel.email;
			}

			if (vm.sectionName == "selectInsuranceType") {
				var paymentError = storage.getItem("payment-error-details");
				if (paymentError && paymentError.mode == "paypal") {
					$scope.$broadcast("paypal-payment-error");
					restoreDetails();
					storage.removeItem("payment-error-details");
				}

				if (paymentError && paymentError.mode == "cc") {
					$scope.$broadcast("payment-error");
					restoreDetails();
					storage.removeItem("payment-error-details");
				}				

				// open section according to param
				var uiSelectedInsuranceType = '';
				var uiSelectedInsuranceTypeCode = $location.search().t;
				var uiRefNum =  $location.search().r;

				var selectedInsuranceTypeOptions = vm.getOptionsFor('selectInsuranceType');

				if (uiSelectedInsuranceTypeCode) {
					uiSelectedInsuranceTypeCode = uiSelectedInsuranceTypeCode.toLowerCase();

					if (selectedInsuranceTypeOptions && selectedInsuranceTypeOptions.length > 0) {
						for (var n = 0; n < selectedInsuranceTypeOptions.length; n++) {
							var selectedInsuranceTypeItem = selectedInsuranceTypeOptions[n];
							if (selectedInsuranceTypeItem.attributes != "" && selectedInsuranceTypeItem.attributes == uiSelectedInsuranceTypeCode) {
								uiSelectedInsuranceType = selectedInsuranceTypeItem.value;
								break;
							}
						}
					}
				}
				
				if (uiSelectedInsuranceType) {
					vm.fieldValues.selectInsuranceType = uiSelectedInsuranceType;
					vm.selectProduct(vm.fieldValues.selectInsuranceType);
				}				

				if (uiRefNum) {
					vm.fieldValues.enterPaymentRef = uiRefNum;
				}

				// // perform search
				if (vm.fieldValues.selectInsuranceType && vm.fieldValues.enterPaymentRef) {
					setTimeout(function (){
						var findBillButton = document.getElementById("find-bill");
						if (findBillButton) {
							findBillButton.click();
						}
					}, 500);
				}				
			}

			// Check if campaign code is valid
			if (vm.quoteModel && vm.quoteModel.quoteResult) {
				var quoteResponse = vm.quoteModel.quoteResult.response;
				if (
					quoteResponse.isCampaignCodeValid ||
					quoteResponse.isGiftCardApplied
				) {
					vm.campaignBanner = campaignService.getCampaignConfig(
						quoteResponse.campaignCode,
						false
					).content;
					vm.isCampaignCodeValid = campaignService.getCampaignConfig(
						quoteResponse.campaignCode,
						false
					).isCampaignCodeValid;
				} else {
					vm.isCampaignCodeValid = false;
				}
			}

			if (vm.quoteModel && !vm.quoteModel.policyStartDate) {
				storage.setItem('policy-start-date', moment().tz("Australia/Sydney").format("YYYY-MM-DD"));
			}
		};

		/**
		 * Registers child form sections with the current form section.
		 * Similar to registerSection in form controller, it keeps track of child sections, their value and
		 * initialisation.
		 */
		vm.registerFormField = function (childName, initValueFn, getValueFn) {
			if (!children[childName]) children[childName] = {};
			children[childName].initValueFn = initValueFn;
			children[childName].getValueFn = getValueFn;
			$scope.$emit("request-common-values");
			if (vm.fieldValues && vm.fieldValues[childName]) {
				initValueFn(vm.fieldValues[childName]);
			}
		};

		vm.registerIdGenerator = function (childName, initIdFn) {
			if (!children[childName]) children[childName] = {};

			children[childName].initIdFn = initIdFn;
			initIdFn($scope.name);
		};

		/**
		 * keep track of the hierarchy of form sections and is used to generate automatic, unique HTML IDs.
		 */
		vm.registerHierarchy = function (childName, setHierarchyFn) {
			if (!children[childName]) children[childName] = {};
			children[childName].setHierarchyFn = setHierarchyFn;
			setHierarchyFn($scope.hierarchyList);
		};

		/**
		 * @return the value of all child form sections as well as all direct inputs of the current section.
		 */
		vm.getValue = function () {
			for (var key in children) {
				if (children[key].getValueFn) {
					if (vm.aggregatedListName)
						vm.fieldValues[vm.aggregatedListName][
							parseInt(key)
						] = children[key].getValueFn();
					else vm.fieldValues[key] = children[key].getValueFn();
				}
			}

			return vm.fieldValues;
		};

		vm.resetInsuredExcessValue = function() {
			var test = vm.fieldValues;
		}

		/**
		 * Callback used by components to update their value and pass it back to the parent form section.
		 */
		vm.updateComponentValue = function (name, value) {
			vm.fieldValues[name] = value;
		};

		vm.removeSection = function (aggregator) {
			var childSectionsToRemove = [];
			for (var key in vm.children) {
				var childSection = vm.children[key],
					childValue = childSection.getValueFn();
				if (childValue._aggregator == aggregator) {
					childSectionsToRemove.push(key);
				}
			}
			childSectionsToRemove.forEach(function (sectionKey) {
				delete vm.children[sectionKey];
			});
		};

		/**
		 * Initialises the form section and all its child sections.
		 */
		vm.initFn = function (data, parentName) {
			vm.fieldValues = data;
			// for (var key in children) {
			// 	child.setParent()
			// 	var child = children[key] ;
			// 	if ( child.initIdFn ) child.initIdFn(parentName);
			// 	if ( child.setHierarchyFn ) child.setHierarchyFn(parentName);
			// };
		};

		vm.getAge = function (dob) {
			return Math.floor(
				moment(new Date()).diff(
					moment(dob, "DD/MM/YYYY"),
					"years",
					true
				)
			);
		};

		vm.getCeilingAge = function (dob, floatPoint) {
			return Math.ceil(
				moment(new Date()).diff(
					moment(dob, "DD/MM/YYYY"),
					"years",
					true
				)
			);
		};

		vm.getAgeInDays = function (dob) {
			return Math.floor(
				moment(new Date()).diff(moment(dob, "DD/MM/YYYY"), "days", true)
			);
		};

		vm.getPastYears = function (numYears) {
			if (!vm.fieldOptions["years_" + numYears]) {
				var years = [];
				var prevYear = "";
				for (var i = 0; i < numYears; i++) {
					prevYear = moment().subtract(i, "year").format("Y");
					years.push({
						label: prevYear,
						value: prevYear,
					});
				}
				vm.fieldOptions["years_" + numYears] = years;
			}
			return vm.fieldOptions["years_" + numYears];
		};

		vm.getPastYearsFrom = function (year) {
			var currentYear = parseInt(moment().format("Y"));
			return vm.getPastYears(currentYear - (year - 1));
		};

		vm.payByPaypal = function () {
			$scope.$root.$broadcast("loading-animation-start");

			paymentService.payByPaypal(
				// on successfully calling the Create Paypal Payment service
				function (redirectUrl) {
					paymentLoggerService.trackQuoteStatus(
						"redirecting to paypal",
						"waiting for Paypal callback"
					);
					$window.location.href = redirectUrl;
				},
				// on error
				function (errorResponse) {
					paymentLoggerService.trackQuoteStatus(
						"cannot connect to paypal",
						null,
						errorResponse
					);
					void 0;
				}
			);
		};

		vm.requote = function (form, isRequoteBlocked) {
			if (isRequoteBlocked === true) {
				//to do additional checking for requote, if set to true requote is not done
			} else {
				$scope.$root.$broadcast("requote", form);
			}
		};

		vm.setMainPolicyHolderEmail = function (email) {
			userInputRepository.update({
				email: email,
			});
		};

		vm.onPaymentFrequencyChanged = function (paymentFrequency) {
			$scope.$root.$broadcast("update-payment-options", paymentFrequency);
			quoteOptions.setSelectedPaymentFrequency(paymentFrequency);
			vm.updatePaymentSummary(paymentFrequency);
			vm.updatePaymentStartDate(paymentFrequency);
		};

		/**
		 * vm.updatePaymentStartDate - Update payment start date
		 * @param {string} data selected payment option
		 */
		vm.updatePaymentStartDate = function (data) {
			if (data === "monthly" || data === "fortnightly") {
				vm.fieldValues.paymentStartDate = moment(
					vm.quoteModel.policyStartDate,
					"DDMMYYYY"
				).format("DD/MM/YYYY");
			}
		};

		vm.getRange = function (data) {
			if (
				moment(vm.quoteModel.policyStartDate, "DDMMYYYY").format(
					"DDMMYYYY"
				) === moment().tz("Australia/Sydney").format("DDMMYYYY")
			) {
				return "0d:14d";
			}
			var sDate =
				moment(vm.quoteModel.policyStartDate, "DDMMYYYY").diff(
					moment(),
					"days"
				) + 1;
			var eDate =
				parseInt(
					moment(vm.quoteModel.policyStartDate, "DDMMYYYY").diff(
						moment(),
						"days"
					) + 1
				) + parseInt(data);
			return sDate + "d:" + eDate + "d";
		};

		/**
		 * vm.updatePaymentSummary - Update payment summary
		 *
		 * @param {string} data selected payment option
		 */
		vm.updatePaymentSummary = function (data) {
			if (data == "yearly") {
				//yearly frequency should not allow bankaccount
				if (vm.fieldValues.paymentMethod == "bankaccount") {
					//sets credit card as the default option
					vm.fieldValues.paymentMethod = "creditcard";
					$scope.$root.$broadcast(
						"payment-method-changed",
						"creditcard"
					);
				}
			} else {
				//any frequency other than yearly should not allow paypal
				if (vm.fieldValues.paymentMethod == "paypal") {
					//sets credit card as the default option
					vm.fieldValues.paymentMethod = "creditcard";
					$scope.$root.$broadcast(
						"payment-method-changed",
						"creditcard"
					);
				}
			}
		};

		vm.paymentMethodChanged = function (paymentMethod) {
			$scope.$root.$broadcast("payment-method-changed", paymentMethod);
			void 0;
		};

		vm.termsAndConditionsChanged = function (termsAndConditions) {
			$scope.$root.$broadcast(
				"terms-and-conditions-changed",
				termsAndConditions ? true : false
			);
			void 0;
		};

		vm.noItemIsChecked = function (list) {
			if (Object.keys(list)) {
				for (var key in list) {
					if (list[key] == true) return false;
				}
			}
			return true;
		};

		vm.numberOfItemsChecked = function (list) {
			var counter = 0;
			angular.forEach(list, function (value) {
				if (value === true) counter++;
			});
			return counter;
		};

		vm.refreshPolicy = function (paymentType) {
			vm.showCreditCard = false;
			//option choose credit card
			if (paymentType === 'credit-card') {	
				vm.showError = false;	
				vm.showCreditCard = true;
				
				var hostOrigin = $window.location.origin;
				
				//get concig
				var paymentConfig = paymentService.getPaybillConfig()
				if (!paymentConfig) {
					errorDuringTokenization();						
				}
				else {
					paymentService.initialCreditcardPayment(
						paymentConfig.mulesoftFlexiMicroformApiUrl,
						hostOrigin, 
						paymentService.generateUniqueId(),
						paymentConfig.merchantIdentifier,
						paymentConfig.clientId,
						paymentConfig.clientSecret,
						initialCreditcardPaymentSuccessCallback,
						initialCreditcardPaymentFailCallback);
				}				
			}
			if (vm.sectionName == "getStartedCtp")
				$scope.$emit(
					"set-has-personOrCompany",
					vm.fieldValues.personOrCompany == "no"
				);
			else if (vm.sectionName == "selectInsuranceType") {
				/* track payment details to gtm */
				$scope.$root.$broadcast('trackPaymentDetailsPaymentType', vm.fieldValues.howToPay);
				/* end track payment details to gtm */
			}
			
			//console.log('invalidting quick quote responses');
			$scope.$emit("invalidate-quotes");
		};
		function initialCreditcardPaymentSuccessCallback(jwk) {
			vm.showCreditCard = true;

			// cybersourceService
			FLEX.microform(
				paymentService.getKeyData(
					jwk, 
					'#cardNumber-container', 
					'#cardNumber-label',
					''),
				function (setupError, microformInstance) {
					if (setupError) {
						// handle error
						errorDuringTokenization();
						return;
					}

					$rootScope.$broadcast("set-micoform-instance", microformInstance);
				}
			);
		}

		function initialCreditcardPaymentFailCallback(error) {			
			errorDuringTokenization();
		}

		function errorDuringTokenization(message) {
			vm.showCreditCard = false;
			vm.showError = true;
			vm.showPaypalError = false;
			errorCount++;

			vm.formErrorMessage = 'Credit card service is not available at the moment. Please try again later.';

			scrollViewTo($("#content"));
		}

		vm.getOptionsForBuildingYearBuilt = function (fieldName) {
			if (!vm.fieldOptions[fieldName]) {
				var options = vm.getGlobalOptionsFor(fieldName);
				for (var i = 2000; i <= new Date().getFullYear(); i++) {
					options.unshift({
						label: String(i),
						value: String(i),
					});
				}
				vm.fieldOptions[fieldName] = options;
				return options;
			} else return vm.fieldOptions[fieldName];
		};

		/*
		 * TO BE MOVED TO HOME QUOTE MODEL
		 *
		 * Checks if the provided cover need is available for the options selected on page
		 */
		vm.isHomeCoverNeedAvailable = function (coverNeed) {
			var typeOfBuilding = "";
			var isPropertyProfessionalAgent = false;
			var howIsHomeOccupied = "";

			if (vm.commonValues.typeOfBuilding) {
				typeOfBuilding = vm.commonValues.typeOfBuilding;
			}

			if (vm.commonValues.propertyProfessionalAgent !== undefined) {
				isPropertyProfessionalAgent =
					vm.commonValues.propertyProfessionalAgent;
			} else if (
				!!vm.quoteModel.homeForm &&
				!!vm.quoteModel.homeForm.tellUsAboutTheProperty
					.propertyProfessionalAgent
			) {
				isPropertyProfessionalAgent =
					vm.quoteModel.homeForm.tellUsAboutTheProperty
						.propertyProfessionalAgent;
			}

			if (vm.commonValues.howIsHomeOccupied) {
				howIsHomeOccupied = vm.commonValues.howIsHomeOccupied;
			}

			if (coverNeed === "contents") {
				return true;
			} else if (coverNeed === "building") {
				//dont show building if rent and live
				if (howIsHomeOccupied === "rent_live") {
					return false;
				}

				if (typeOfBuilding === "unit" || typeOfBuilding === "flat") {
					return false;
				} else {
					return true;
				}
			} else if (coverNeed === "rent_default") {
				if (
					isPropertyProfessionalAgent === true &&
					howIsHomeOccupied === "own_rent_tenants"
				) {
					return false;
				} else {
					return false;
				}
			} else if (coverNeed === "malicious_damage") {
				if (
					isPropertyProfessionalAgent === true &&
					howIsHomeOccupied === "own_rent_tenants"
				) {
					return true;
				} else {
					return false;
				}
			}
			return true;
		};

		vm.yearHomeBuilt = function () {
			var cycloneRating = vm.getObjectValueRaw("cycloneRating", "value");
			var cycloneParams = [
				userInputRepository.get(
					{},
					"homeForm.tellUsAboutTheBuilding.yearHomeBuilt"
				),
				parseInt(cycloneRating),
			];
			return cycloneParams;
		};

		// Show/Hide of Payment Failure - Credit Card error message
		$scope.$on("cyber-source-error", function (event, code) {
			validateCybersourceError(code);
		});

		function validateCybersourceError(data) {
			var cybersourceList =
				$window.qbe.fieldLabels.cybersourceCodeMessage.cybersourceError;
			if (!isUndefinedOrNull(data)) {
				vm.showError = true;
				vm.showPaypalError = false;
				errorCount++;

				if (typeof cybersourceList[data] !== "undefined") {
					vm.formErrorMessage = cybersourceList[data];
				} else {
					vm.formErrorMessage = cybersourceList["default"];
				}
				trackformErrorByErrorMessage(vm.formErrorMessage);

				scrollViewTo($("#content"));
			} else {
				vm.showError = false;
			}
		}

		function splitKeyInValidation(key) {
			key.split(",");
		}

		/**
		 * Scrolls to the field element
		 */
		function scrollViewTo($element) {
			var offset = $element.offset();
			if (offset) {
				$("html, body").animate({
					scrollTop: offset.top - 50,
					scrollLeft: offset.left,
				});
			}
		}
		//return options to the needs checkbox
		vm.getOptionsForCoverNeeds = function (fieldName) {
			var options = getOptions(fieldName).slice();
			var returnOptions = [];
			for (var item in options) {
				if (vm.isHomeCoverNeedAvailable(options[item].value)) {
					returnOptions.push(options[item]);
				} else {
					vm.commonValues[
						"coverNeeds_" + options[item].value
					] = false;
				}
			}
			return returnOptions;
		};

		vm.showNeedsCoverOutsideHome = function () {
			var show =
				!!vm.commonValues.coverNeeds_contents &&
				[
					"own_live",
					"rent_live",
					"unoccupied",
					"own_holidayhome",
				].indexOf(vm.commonValues.howIsHomeOccupied) != -1;
			// update the form value
			vm.commonValues.needCoverOutsideHome =
				vm.fieldValues.needCoverOutsideHome;

			return show;
		};

		//methods for home
		vm.submitRapidEstimate = function (form, isNavigatingForward) {
			$scope.$root.$broadcast("home-rapid-estimate", form);
		};

		/**
		 *    Set default selected payment option
		 */
		vm.paymentOptions = "yearly";
		vm.updatePaymentSummary("yearly");

		vm.moveToPage = function (page) {
			$scope.$root.$broadcast("moveToPage", page);
		};

		$scope.$on("confirm-form-data", function (event, formData) {
			if (
				vm.sectionName == "nearCompleteCtp" ||
				vm.sectionName == "paybillForm"
			) {
				vm.fieldValues.firstName =
					formData.vehicleFormCtp.registeredOwnerCtp.firstName;
				vm.fieldValues.surName =
					formData.vehicleFormCtp.registeredOwnerCtp.surName;
				var bDate =
					formData.vehicleFormCtp.registeredOwnerCtp.birthDate;
				vm.fieldValues.birthDate = bDate; //bDate.substr(0, 2) + "/" + bDate.substr(3,2) + "/" + bDate.substr(6,4);
				vm.fieldValues.regEmail =
					formData.vehicleFormCtp.registeredOwnerCtp.regEmail;
				vm.fieldValues.regMobileNum =
					formData.vehicleFormCtp.registeredOwnerCtp.regMobileNum;
				vm.fieldValues.regPostCode =
					formData.vehicleFormCtp.registeredOwnerCtp.regPostCode;

				//about your card
				var regDate =
					formData.vehicleFormCtp.aboutYourCarCtp.registrationDueDate;
				vm.fieldValues.registrationDueDate = regDate; //regDate.substr(0, 2) + "/" + regDate.substr(3,2) + "/" + regDate.substr(6,4);
				vm.fieldValues.driverLicenseNum =
					formData.vehicleFormCtp.aboutYourCarCtp.driverLicenseNum;
				vm.fieldValues.vehicleRegNum =
					formData.vehicleFormCtp.aboutYourCarCtp.vehicleRegNum;
				vm.fieldValues.vehicleType =
					formData.vehicleFormCtp.aboutYourCarCtp.vehicleType;
				vm.fieldValues.insurancePeriod =
					formData.vehicleFormCtp.insurancePeriodCtp.insurancePeriod;
			}
		});

		$scope.$watch("vm.fieldValues.enterPaymentRef", function () {
			vm.showPaymentSection = false;
			vm.isEnterPaymentRefError = false;
			vm.isEnterPaymentRefErrorLength = false;
		});

		$scope.$watch("vm.fieldValues.birthDay", function (value) {
			validateBirthDate();
		});

		$scope.$watch("vm.fieldValues.birthMonth", function (value) {
			validateBirthDate();
		});

		$scope.$watch("vm.fieldValues.birthYear", function (value) {
			validateBirthDate();
		});

		$scope.$watch("vm.fieldValues.birthDate", function (value) {
			if (vm.sectionName == "registeredOwnerCtp" && value.length >= 8) {
				vm.formSelector.birthDate.$setValidity("age", true);
				var isValid = isDate(vm.fieldValues.birthDate);
				var parent = angular.element(
					document.querySelector("[field-key='birthDate']")
				);
				if (!isValid) {
					parent.addClass("is-error");
					vm.formSelector.birthDate.$setValidity("date", false);
					vm.formSelector.birthDate.$setValidity("age", true);
				} else {
					parent.removeClass("is-error");
					vm.formSelector.birthDate.$setValidity("date", true);
					var birthDate = new Date(
						vm.fieldValues.birthYear,
						vm.fieldValues.birthMonth - 1,
						vm.fieldValues.birthDay
					);
					var age = getYearDiff(birthDate, Date.now());
					if (age >= 16) {
						vm.formSelector.birthDate.$setValidity("age", true);
						parent.removeClass("is-error");
					} else {
						vm.formSelector.birthDate.$setValidity("age", false);
						parent.addClass("is-error");
					}
				}
			}
		});

		$scope.$watch("vm.fieldValues.regDueDay", function (value) {
			validateRegistrationDueDate();
		});

		$scope.$watch("vm.fieldValues.regDueMonth", function (value) {
			validateRegistrationDueDate();
		});

		$scope.$watch("vm.fieldValues.regDueYear", function (value) {
			validateRegistrationDueDate();
		});

		$scope.$watch("vm.fieldValues.regPostCode", function (value) {
			validatePostCode();
		});

		// $scope.$watch('vm.fieldValues.enterPaymentRef', function (value) {
		// 	vm.showError = false;
		// 	if (value) {
		// 		validatePaymentRefNum();
		// 		searchForRefNum();
		// 	} else {
		// 		$scope.$emit('billUpdate');
		// 		$scope.$emit('toggle-amount-due');
		// 	}
		// });

		$scope.$watch("vm.fieldValues.registrationDueDate", function (value) {
			if (vm.sectionName == "aboutYourCarCtp" && value.length >= 8) {
				var isValid = isDate(vm.fieldValues.registrationDueDate);
				var parent = angular.element(
					document.querySelector("[field-key='registrationDueDate']")
				);
				if (!isValid) {
					parent.addClass("is-error");
					vm.formSelector.registrationDueDate.$setValidity(
						"date",
						false
					);
				} else {
					parent.removeClass("is-error");
					vm.formSelector.registrationDueDate.$setValidity(
						"date",
						true
					);
					var regDueDate = new Date(
						vm.fieldValues.regDueYear,
						vm.fieldValues.regDueMonth - 1,
						vm.fieldValues.regDueDay
					);
					var dateToday = new Date(Date.now());
					dateToday.setHours(0);
					dateToday.setMinutes(0);
					dateToday.setSeconds(0);
					dateToday.setMilliseconds(0);
					var maxRegDate = new Date(Date.now());
					maxRegDate.setFullYear(dateToday.getFullYear() + 1);
					if (regDueDate >= dateToday && regDueDate <= maxRegDate) {
						vm.formSelector.registrationDueDate.$setValidity(
							"maxdate",
							true
						);
					} else
						vm.formSelector.registrationDueDate.$setValidity(
							"maxdate",
							false
						);
				}
			}
		});

		$scope.$on("form-submitted", function (event, args) {
			validateBirthDate();
			validateRegistrationDueDate();
			validatePostCode();
			validateExpiryDate();
		});

		function getYearDiff(fromDate, toDate) {
			//var birthDate = new Date(vm.fieldValues.birthYear, vm.fieldValues.birthMonth - 1, vm.fieldValues.birthDay);
			var ageDifMs = toDate - fromDate.getTime();
			var ageDate = new Date(ageDifMs); // miliseconds
			return Math.abs(ageDate.getUTCFullYear() - 1970);
		}

		function validateBirthDate() {
			if (vm.sectionName != "registeredOwnerCtp") return;
			var dateHasPartialValue = false;
			if (
				!isUndefinedOrNull(vm.fieldValues.birthDay) ||
				!isUndefinedOrNull(vm.fieldValues.birthMonth) ||
				!isUndefinedOrNull(vm.fieldValues.birthYear)
			) {
				dateHasPartialValue = true;
			}

			if (
				isUndefinedOrNull(vm.fieldValues.birthDay) ||
				isUndefinedOrNull(vm.fieldValues.birthMonth) ||
				isUndefinedOrNull(vm.fieldValues.birthYear)
			) {
				vm.formSelector.birthDate.$setValidity("age", true);
				vm.fieldValues.birthDate = "";
				if (dateHasPartialValue) {
					vm.formSelector.birthDate.$setValidity("required", true);
					vm.formSelector.birthDate.$setValidity("date", false);
				} else {
					vm.formSelector.birthDate.$setValidity("required", false);
					vm.formSelector.birthDate.$setValidity("date", true);
				}
				return;
			}

			var birthDate =
				vm.fieldValues.birthDay +
				"/" +
				vm.fieldValues.birthMonth +
				"/" +
				vm.fieldValues.birthYear;
			var date = moment(birthDate, "DDMMYYYY");

			if (date.isValid()) {
				if (vm.fieldValues.birthYear.toString().length == 4) {
					vm.fieldValues.birthDate = birthDate;
					vm.formSelector.birthDate.$setValidity("date", true);
				} else {
					vm.formSelector.birthDate.$setValidity("date", false);
				}
			} else {
				vm.formSelector.birthDate.$setValidity("date", false);
			}
		}

		function validateRegistrationDueDate() {
			if (vm.sectionName != "aboutYourCarCtp") return;
			var dateHasPartialValue = false;
			if (
				!isUndefinedOrNull(vm.fieldValues.regDueDay) ||
				!isUndefinedOrNull(vm.fieldValues.regDueMonth) ||
				!isUndefinedOrNull(vm.fieldValues.regDueYear)
			) {
				dateHasPartialValue = true;
			}

			if (
				isUndefinedOrNull(vm.fieldValues.regDueDay) ||
				isUndefinedOrNull(vm.fieldValues.regDueMonth) ||
				isUndefinedOrNull(vm.fieldValues.regDueYear)
			) {
				vm.fieldValues.registrationDueDate = "";
				if (dateHasPartialValue) {
					vm.formSelector.registrationDueDate.$setValidity(
						"required",
						true
					);
					vm.formSelector.registrationDueDate.$setValidity(
						"date",
						false
					);
				} else
					vm.formSelector.registrationDueDate.$setValidity(
						"required",
						false
					);
				return;
			}

			var regDueDate =
				vm.fieldValues.regDueDay +
				"/" +
				vm.fieldValues.regDueMonth +
				"/" +
				vm.fieldValues.regDueYear;
			var date = moment(regDueDate, "DDMMYYYY");

			if (date.isValid()) {
				if (vm.fieldValues.regDueYear.toString().length == 4) {
					vm.fieldValues.registrationDueDate = regDueDate;
					vm.formSelector.registrationDueDate.$setValidity(
						"date",
						true
					);
				} else {
					vm.formSelector.registrationDueDate.$setValidity(
						"date",
						false
					);
				}
			}
		}

		function validatePostCode() {
			if (vm.sectionName == "registeredOwnerCtp") {
				vm.formSelector.regPostCode.$setValidity("valid", true);
				if (!isUndefinedOrNull(vm.fieldValues.regPostCode)) {
					var postCode = parseInt(vm.fieldValues.regPostCode);
					var postCodeIsValid =
						(postCode >= 4000 && postCode <= 4999) ||
						postCode == 9726;
					if (!postCodeIsValid) {
						vm.formSelector.regPostCode.$setValidity(
							"valid",
							false
						);
					}
				}
			}
		}

		function isDate(value) {
			//format(dd/MM/yyyy)
			var re = /^(?=\d)(?:(?:31(?!.(?:0?[2469]|11))|(?:30|29)(?!.0?2)|29(?=.0?2.(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00)))(?:\x20|$))|(?:2[0-8]|1\d|0?[1-9]))([-.\/])(?:1[012]|0?[1-9])\1(?:1[6-9]|[2-9]\d)?\d\d(?:(?=\x20\d)\x20|$))?(((0?[1-9]|1[012])(:[0-5]\d){0,2}(\x20[AP]M))|([01]\d|2[0-3])(:[0-5]\d){1,2})?$/;
			var flag = re.test(value);
			return flag;
		}

		function isUndefinedOrNull(arg) {
			if (angular.isUndefined(arg) || arg == null) {
				return true;
			}

			return false;
		}

		vm.confirmSwitch = function () {
			$scope.$emit("confirm-switch");
		};

		vm.backToForm = function () {
			$scope.$emit("show-form-entry");
		};

		function getYearDiff(fromDate, toDate) {
			//var birthDate = new Date(vm.fieldValues.birthYear, vm.fieldValues.birthMonth - 1, vm.fieldValues.birthDay);
			var ageDifMs = toDate - fromDate.getTime();
			var ageDate = new Date(ageDifMs); // miliseconds
			return Math.abs(ageDate.getUTCFullYear() - 1970);
		}

		function validateBirthDate() {
			if (vm.sectionName != "registeredOwnerCtp") return;
			var dateHasPartialValue = false;
			if (
				!isUndefinedOrNull(vm.fieldValues.birthDay) ||
				!isUndefinedOrNull(vm.fieldValues.birthMonth) ||
				!isUndefinedOrNull(vm.fieldValues.birthYear)
			) {
				dateHasPartialValue = true;
			}

			if (
				isUndefinedOrNull(vm.fieldValues.birthDay) ||
				isUndefinedOrNull(vm.fieldValues.birthMonth) ||
				isUndefinedOrNull(vm.fieldValues.birthYear)
			) {
				vm.formSelector.birthDate.$setValidity("age", true);
				vm.fieldValues.birthDate = "";
				if (dateHasPartialValue) {
					vm.formSelector.birthDate.$setValidity("required", true);
					vm.formSelector.birthDate.$setValidity("date", false);
				} else {
					vm.formSelector.birthDate.$setValidity("required", false);
					vm.formSelector.birthDate.$setValidity("date", true);
				}
				return;
			}

			var birthDate =
				vm.fieldValues.birthDay +
				"/" +
				vm.fieldValues.birthMonth +
				"/" +
				vm.fieldValues.birthYear;
			if (isDate(birthDate)) vm.fieldValues.birthDate = birthDate;

			vm.formSelector.birthDate.$setValidity("date", true);
		}

		function validateRegistrationDueDate() {
			if (vm.sectionName != "aboutYourCarCtp") return;
			var dateHasPartialValue = false;
			if (
				!isUndefinedOrNull(vm.fieldValues.regDueDay) ||
				!isUndefinedOrNull(vm.fieldValues.regDueMonth) ||
				!isUndefinedOrNull(vm.fieldValues.regDueYear)
			) {
				dateHasPartialValue = true;
			}

			if (
				isUndefinedOrNull(vm.fieldValues.regDueDay) ||
				isUndefinedOrNull(vm.fieldValues.regDueMonth) ||
				isUndefinedOrNull(vm.fieldValues.regDueYear)
			) {
				vm.fieldValues.registrationDueDate = "";
				if (dateHasPartialValue) {
					vm.formSelector.registrationDueDate.$setValidity(
						"required",
						true
					);
					vm.formSelector.registrationDueDate.$setValidity(
						"date",
						false
					);
				} else
					vm.formSelector.registrationDueDate.$setValidity(
						"required",
						false
					);
				return;
			}

			var regDueDate =
				vm.fieldValues.regDueDay +
				"/" +
				vm.fieldValues.regDueMonth +
				"/" +
				vm.fieldValues.regDueYear;
			if (isDate(regDueDate))
				vm.fieldValues.registrationDueDate = regDueDate;
			vm.formSelector.registrationDueDate.$setValidity("date", true);
		}

		function validatePostCode() {
			if (vm.sectionName == "registeredOwnerCtp") {
				vm.formSelector.regPostCode.$setValidity("valid", true);
				if (!isUndefinedOrNull(vm.fieldValues.regPostCode)) {
					var postCode = parseInt(vm.fieldValues.regPostCode);
					var postCodeIsValid =
						(postCode >= 4000 && postCode <= 4999) ||
						postCode == 9726;
					if (!postCodeIsValid) {
						vm.formSelector.regPostCode.$setValidity(
							"valid",
							false
						);
					}
				}
			}
		}

		/*
			When select a product from drop down
			validate product and do Gtm tracking
		*/
		function selectProduct(value) {
			validateProducts(value);
			gtmService.trackProductSelect(value);			
		}		

		/*
		 * Redirect to other payment sites
		 * Param - Product value from drop down list
		 
		vm.payNonQbe = function () {			
			var sessionProt = window.location.protocol;
			var sessionProtHost = window.location.host;
			var sessionProtPath = $window.qbe.fieldLabels && $window.qbe.fieldLabels.nonQbeRedirect ? $window.qbe.fieldLabels.nonQbeRedirect.QBE : '/';               
			var sessionProtURL = sessionProt + "//" + sessionProtHost + sessionProtPath;
			
			window.location.href = sessionProtURL;			
		};
		*/

		/*
		 * Validate Products for Redirect Link
		 * Param - Product value from drop down list
		 */
		function validateProducts(value) {
			var QBEProducts = [
				"CAR",
				"BOAT",
				"CARAVAN",
				"CONTENTS",
				"HOME",
				"LANDLORD",
				"MOTORCYCLE",
			];
			var NonQBEProducts = [
				"CTP - NSW GREEN SLIP",
				"CTP - QLD",
				"TRAVEL",
				"SMALL BUSINESS"
			];
			var redirectLinks = $window.qbe.fieldLabels.nonQbeRedirect;

			if (!isUndefinedOrNull(value)) {
				$scope.$broadcast("broadcast-no-field-errors");
				var productLabel = value.replace(/[^a-z\d\s]+/gi, "");
				vm.productCode = value;
				vm.otherWaysLabel = productLabel;
				value = value.toUpperCase();

				if (containsInArray(QBEProducts, value)) {
					vm.productValue = "QBEProducts";
				} else if (containsInArray(NonQBEProducts, value)) {
					vm.productValue = "NonQBEProducts";
					switch (value) {
						case "CTP - NSW GREEN SLIP":
							vm.nonQbeLink = redirectLinks.NSW;
							break;

						case "CTP - QLD":
							vm.nonQbeLink = redirectLinks.QLD;
							break;

						case "TRAVEL":
							vm.nonQbeLink = redirectLinks.Travel;
							break;
						case "SMALL BUSINESS":
							vm.nonQbeLink = redirectLinks.SmallBusiness;
							break;
					}
				} else if (containsInArray(MotorProducts, value)) {
					vm.productValue = "MotorProducts";
				}

				vm.showPaymentSection = false;

				$scope.$emit("pay-now-button", vm.productValue);
			}
		}

		function containsInArray(arrayList, value) {
			return arrayList.indexOf(value) > -1;
		}

		//PAYMENTS FORM END

		function isDate(value) {
			//format(dd/MM/yyyy)
			var re = /^(?=\d)(?:(?:31(?!.(?:0?[2469]|11))|(?:30|29)(?!.0?2)|29(?=.0?2.(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00)))(?:\x20|$))|(?:2[0-8]|1\d|0?[1-9]))([-.\/])(?:1[012]|0?[1-9])\1(?:1[6-9]|[2-9]\d)?\d\d(?:(?=\x20\d)\x20|$))?(((0?[1-9]|1[012])(:[0-5]\d){0,2}(\x20[AP]M))|([01]\d|2[0-3])(:[0-5]\d){1,2})?$/;
			var flag = re.test(value);
			return flag;
		}

		function isUndefinedOrNull(arg) {
			if (angular.isUndefined(arg) || arg == null) {
				return true;
			}

			return false;
		}

		vm.confirmSwitch = function () {
			$scope.$emit("confirm-switch");
		};

		vm.backToForm = function () {
			$scope.$emit("show-form-entry");
		};

		vm.back = function () {
			var backState = dynamicRouter.back();
			if (backState) $state.go(backState);

			return false;
		};

		function validateBuildingSumInsured(event) {
			vm.showContentsSumInsuredInLowerRange = false;

			var key = $window.event ? event.keyCode : event.which;
			if (key < 48 || key > 57) {
				event.preventDefault();
			} else {
				return true;
			}
		}

		function getBuildingEstimate() {
			return Math.floor(
				vm.quoteModel.cordelInfo.spotValue
			).toLocaleString("en-US");
		}

		function getBuildingMaximum() {
			return vm.quoteModel.maxSumInsured.toLocaleString("en-US");
		}

		function getBuildingMinimum() {
			return vm.quoteModel.minSumInsured.toLocaleString("en-US");
		}

		function toggleContentsSumInsuredInLowerRange() {
			vm.showContentsSumInsuredInLowerRange =
				vm.quoteModel.isSumInsuredInLowerRange(
					vm.fieldValues.buildingSumInsured
				) && vm.fieldValues.isEstimatedRebuildCost == "no";
		}

		function toggleYourContentsSumInsuredInLowerRange() {
			vm.showYourContentsSumInsuredInLowerRange =
				vm.quoteModel.isSumInsuredInLowerRange(
					vm.fieldValues.yourBuildingSumInsured
				) && vm.fieldValues.isYourEstimatedRebuildCost == "no";
		}

		function checkBuildingSumInsured() {
			if (!isUndefinedOrNull(vm.fieldValues.buildingSumInsured)) {
				vm.fieldValues.isEstimatedRebuildCost = "no";
			}
		}
		//dd-3747 - function to assign building sum insured if estimated is selected
		function getEstimateRebuild() {
			if (vm.fieldValues.isEstimatedRebuildCost == "yes") {
				vm.fieldValues.buildingSumInsured = Math.floor(
					vm.quoteModel.cordelInfo.spotValue
				);
			}
			if (vm.fieldValues.isYourEstimatedRebuildCost == "yes") {
				vm.fieldValues.yourBuildingSumInsured = Math.floor(
					vm.quoteModel.cordelInfo.spotValue
				);
			}
		}

		vm.dutyClicked = function ($event) {
			var $target = $($event.currentTarget);
			if ($target.hasClass("is-expanded")) {
				$target.parent().removeClass("expanded");
			} else $target.parent().addClass("expanded");
		};

		/*
		 * Function to limit numbers on text input
		 * Param - key event
		 */

		$scope.validNumber = function (event) {
			var key = $window.event ? event.keyCode : event.which;
			if (key === 8) {
				return true;
			} else if (key < 48 || key > 57) {
				event.preventDefault();
			} else {
				return true;
			}
		};

		$scope.validPhoneNum = function (event, element) {
			var futureValue = event.delegateTarget.value;
			var key = $window.event ? event.keyCode : event.which;

			if (key === 43) {
				return true;
			} else if (key === 8) {
				return true;
			} else if (key < 48 || key > 57) {
				event.preventDefault();
			} else {
				return true;
			}
		};

		function validateBuildingSumInsured(event) {
			vm.showContentsSumInsuredInLowerRange = false;

			var key = $window.event ? event.keyCode : event.which;
			if (key < 48 || key > 57) {
				event.preventDefault();
			} else {
				return true;
			}
		}

		$scope.$watch("vm.fieldValues.expiryMonth", function (value) {
			validateExpiryDate();
		});

		$scope.$watch("vm.fieldValues.expiryYear", function (value) {
			validateExpiryDate();
		});

		function validateExpiryDate() {
			if (
				isUndefinedOrNull(vm.fieldValues.expiryMonth) ||
				isUndefinedOrNull(vm.fieldValues.expiryYear)
			) {
				// if(!isUndefinedOrNull(vm.formSelector) && !isUndefinedOrNull(vm.formSelector.expiryDate)){
				// vm.formSelector.expiryDate.$setValidity('required', false);
				// }
				vm.fieldValues.expiryDate = "";
				return;
			}

			var expiryDate =
				vm.fieldValues.expiryMonth + "/" + vm.fieldValues.expiryYear;
			var date = moment(expiryDate, "MMYY");
			// vm.formSelector.expiryDate.$setValidity('required', true);
			if (date.isValid()) {
				vm.fieldValues.expiryDate = expiryDate;
				// vm.formSelector.expiryDate.$setValidity('invalidDate', true);
			}
		}

		function getBuildingEstimate() {
			return Math.floor(
				vm.quoteModel.cordelInfo.spotValue
			).toLocaleString("en-US");
		}

		function getBuildingMaximum() {
			return vm.quoteModel.maxSumInsured.toLocaleString("en-US");
		}

		function getBuildingMinimum() {
			return vm.quoteModel.minSumInsured.toLocaleString("en-US");
		}

		function toggleContentsSumInsuredInLowerRange() {
			vm.showContentsSumInsuredInLowerRange =
				vm.quoteModel.isSumInsuredInLowerRange(
					vm.fieldValues.buildingSumInsured
				) && vm.fieldValues.isEstimatedRebuildCost == "no";
		}

		$scope.validPhoneNum = function (event, element) {
			var futureValue = event.delegateTarget.value;
			var key = $window.event ? event.keyCode : event.which;

			if (key === 43) {
				return true;
			} else if (key === 8) {
				return true;
			} else if (key < 48 || key > 57) {
				event.preventDefault();
			} else {
				return true;
			}
		};

		function validateBuildingSumInsured(event) {
			vm.showContentsSumInsuredInLowerRange = false;

			var key = $window.event ? event.keyCode : event.which;
			if (key < 48 || key > 57) {
				event.preventDefault();
			} else {
				return true;
			}
		}

		function getBuildingEstimate() {
			return Math.floor(
				vm.quoteModel.cordelInfo.spotValue
			).toLocaleString("en-US");
		}

		function getBuildingMaximum() {
			return vm.quoteModel.maxSumInsured.toLocaleString("en-US");
		}

		function getBuildingMinimum() {
			return vm.quoteModel.minSumInsured.toLocaleString("en-US");
		}

		function toggleContentsSumInsuredInLowerRange() {
			vm.showContentsSumInsuredInLowerRange =
				vm.quoteModel.isSumInsuredInLowerRange(
					vm.fieldValues.buildingSumInsured
				) && vm.fieldValues.isEstimatedRebuildCost == "no";
		}
	}

	angular.module("qbePortal").directive("qbFormSection", [
		"hierarchyDecorator",
		function (hierarchyDecorator) {
			return {
				restrict: "EA",
				controller: FormSection,
				controllerAs: "vm",
				transclude: true,
				scope: {
					init: "&",
					register: "&?",
					name: "@",
					/**
					 * @formData : Used on the highest level of form sections to bind values to the controller.
					 */
					formData: "<",
					/**
					 * @setHierarchy:  Callback used by hierarchy decorator to set the current hierarchy of a form section
					 */
					setHierarchy: "&",
					/**
					 * @fieldValues: Binding to set the field values for a section.
					 */
					fieldValues: "<?",
					/**
					 * @formSelector : Selector pointing to ng-form of the current form section.  Used for maintaining native angular form validation.
					 */
					formSelector: "<?",
					/**
					 * @aggregatedListName : optional value provided for aggregated lists to bind their values to an array with the given name
					 */
					aggregatedListName: "@?",
				},
				link: function (scope, element, attrs, ctrl, transclude) {
					scope.element = element;
					scope.getHTMLId = function () {
						return scope.element.attr("id");
					};

					if (scope.setHierarchy !== undefined)
						hierarchyDecorator.attach(scope, {
							element: element,
							name: scope.name,
							$id: scope.$id,
						});

					transclude(scope, function (clone) {
						element.append(clone);
					});
				},
			};
		},
	]);
})();

(function () {
	'use strict';

	angular.module('qbePortal').directive('qbFrequentlyAskedQuestions',
		function () {
			return {
				templateUrl: '../ngviews/directives/qbFrequentlyAskedQuestions.html',
				restrict: 'E',
				scope: {
					frequentlyAskedQuestions: '=',
					frequentlyAskedQuestionsTitle: '='
				}, 
			    transclude: true,							
				link: function (scope, element, attrs) {					
					
				}
			};
		});

})();

(function () {
	'use strict';

	angular.module('qbePortal').directive('qbGroupCheckboxMaxLimit', function () {
		return {
			restrict: 'AE',
			scope: {
				numberChecked: '<',
				maxAllowed: '<',
				ngModel: '<',
			},
			link: function (scope, elm, attrs, ctrl) {
				scope.$watch('numberChecked', function () {
					scope.ngModel.$setValidity('qbMaxAllowed', scope.numberChecked <= scope.maxAllowed);
				})
			}
		};
	});
})();

(function () {
	'use strict';

	// angular.module('qbePortal').controller('ctpProgress', ctpProgress);

	// ctpProgress.$inject = ['$scope'];

	// function ctpProgress($scope) {
	// 	var vm = this;
	// 	vm.ctpCompleted = false;
	// }


	angular.module('qbePortal').directive('qbHeadBar', 
		function () {
			return {
				templateUrl: '../ngviews/directives/qbHeadBar.html',
				// controller: ctpProgress,
				// controllerAs: 'vm',				
				restrict: 'E',
			     scope: {
						 headBar:'=',	              
			            },
			     transclude: true,							
				link: function (scope, element, attrs) {
					element.click(function () {
						if (scope.headBar && scope.headBar.click) {
							scope.headBar.click();
						}
					});
				}
			};
		});

})();

(function () {
	'use strict';

	angular.module('qbePortal').directive('qbHeadBarCtp',
		function () {
			return {
				templateUrl: '../ngviews/directives/qbHeadBarCtp.html',
				restrict: 'E',
				scope: {
					headBarCtp: "=",
				},
			    transclude: true,							
				link: function (scope, element, attrs) {					
					
				}
			};
		});

})();

(function () {
	'use strict';

	angular.module('qbePortal').directive('qbModal',
		function () {
			return {
				templateUrl: '../ngviews/directives/qbModal.html',
				restrict: 'A',
				transclude: true,
				link: function (scope, element, attrs) {
					$('.js-modal-container').ddModals();

					//dd-5174-remove modal on save
					//scope.$root.$on('open-modal', openModal);
					//scope.$root.$on('close-modal', closeModal);

					function openModal(event, args) {
						setTimeout(function () {
							$.ddModals.open(args.modal);
						}, 1);
					}

					function closeModal(event, args) {
						$.ddModals.close(args.modal);
					}

				}
			};
		});

})();

(function () {
	"use strict";

	angular.module("qbePortal").controller("QBNgDialog", QBNgDialog);

	QBNgDialog.$inject = [
		"$scope",
		"ngDialog",
		"$timeout",
		"ActivityMonitor",
		"$window",
		"$rootScope",
		"storage",
		"$interval",
		"Util",
	];

	function QBNgDialog(
		$scope,
		ngDialog,
		$timeout,
		ActivityMonitor,
		$window,
		$rootScope,
		storage,
		$interval,
		util
	) {
		var vm = this;

		if ($window.qbe.fieldLabels != undefined) {
			$scope.contentData = $window.qbe.fieldLabels.sessionFunction;
		}

		var timerLengthMinutes =
			$scope.contentData.timerLengthMinutes != undefined
				? $scope.contentData.timerLengthMinutes
				: null;
		var timerLengthSeconds =
			$scope.contentData.timerLengthSeconds != undefined
				? $scope.contentData.timerLengthSeconds
				: null;
		var sessionLengthMinutes =
			$scope.contentData.sessionLengthMinutes != undefined
				? $scope.contentData.sessionLengthMinutes
				: null;
		var sessionLengthSeconds =
			$scope.contentData.sessionLengthSeconds != undefined
				? $scope.contentData.sessionLengthSeconds
				: null;
		var sessionCount =
			$scope.contentData.sessionCount != undefined
				? $scope.contentData.sessionCount
				: null;
		var inactivityTimeMinutes =
			$scope.contentData.inactivityTimeMinutes != undefined
				? $scope.contentData.inactivityTimeMinutes
				: null;
		var inactivityTimeSeconds =
			$scope.contentData.inactivityTimeSeconds != undefined
				? $scope.contentData.inactivityTimeSeconds
				: null;
		var initSession = 0;
		var startTimeOut = null;
		var stopTimeOut = null;
		var continueTimer = true;
		var inactivityTime = null;
		var activeDialog = false;
		var redirectURL = null;
		var timeLeft = null;

		vm.takeoverHeader = $scope.contentData.takeoverHeader;
		vm.takeoverContent = $scope.contentData.takeoverContent;
		vm.yesLabel = $scope.contentData.yesLabel;
		vm.noLabel = $scope.contentData.noLabel;
		vm.redirectURL = $scope.contentData.redirectURL;
		vm.noRedirectURL = $scope.contentData.noRedirectURL;

		activate("init");

		/*
		 * activate - main function to track inactivity and session length
		 * Param - none
		 * Return - none
		 */
		function activate(data) {
			//assign session count depending on storage item set
			var storedSession = storage.getItem("session-count");

			if (data === "init") {
				if (angular.isNumber(storedSession)) {
					initSession = storedSession;
				} else {
					initSession++;
				}
			} else {
				if (angular.isNumber(storedSession)) {
					initSession = storedSession;
				}
				initSession++;
			}

			//store session count in storage
			storage.setItem("session-count", initSession);

			if (!isUndefinedOrNull(inactivityTimeMinutes)) {
				if (isUndefinedOrNull(inactivityTimeSeconds)) {
					inactivityTimeSeconds = 0;
				}

				// compute total idle time
				inactivityTime =
					(inactivityTimeMinutes + inactivityTimeSeconds / 60) * 60;

				// how long (in seconds) until user is considered inactive
				ActivityMonitor.options.inactive = inactivityTime;

				// user is considered inactive, logout etc.
				ActivityMonitor.on("inactive", function () {
					validateSession();
				});
			}

			if (!isUndefinedOrNull(sessionLengthMinutes)) {
				if (isUndefinedOrNull(sessionLengthSeconds)) {
					sessionLengthSeconds = 0;
				}

				//compute total session length on storage
				var storedTime = storage.getItem("time-left");
				if (angular.isNumber(storedTime)) {
					if (storedTime <= 0) {
						timeLeft =
							(sessionLengthMinutes + sessionLengthSeconds / 60) *
							60;
					} else {
						timeLeft = storedTime;
					}
				} else {
					timeLeft =
						(sessionLengthMinutes + sessionLengthSeconds / 60) * 60;
				}

				startTimer();
			}
		}

		/*
		 * startTimer/stopTimer - function to start/stop $timeout function
		 * Param - none
		 * Return -none
		 */
		function startTimer() {
			startTimeOut = $interval(function () {
				timeLeft--;
				if (timeLeft === 0) {
					//$interval.cancel(startTimeout);
					validateSession();
				}
			}, 1000);
		}

		function stopTimer() {
			$interval.cancel(startTimeOut);
		}

		function stopEvents() {
			ActivityMonitor.off("inactive");
			if (startTimeOut) {
				storage.setItem("time-left", timeLeft);
				$interval.cancel(startTimeOut);
			}
		}

		$scope.$on("$destroy", function () {
			stopEvents();
		});

		/*
		 * isUndefinedOrNull - nullity checking
		 * Param - none
		 * Return - boolean
		 */
		function isUndefinedOrNull(arg) {
			if (angular.isUndefined(arg) || arg == null) {
				return true;
			}
			return false;
		}

		/*
		 * dialogCountdown - function to display timer in dialog box
		 * Param - minutes, seconds
		 * Return - none
		 */

		function dialogCountdown(minutes, seconds) {
			var endTime, hours, mins, msLeft, time;

			function twoDigits(n) {
				return n <= 9 ? "0" + n : n;
			}

			function updateTimer() {
				msLeft = endTime - +new Date();
				if (msLeft < 1000) {
					redirectLink(true);
				} else {
					time = new Date(msLeft);
					hours = time.getUTCHours();
					mins = time.getUTCMinutes();
					$scope.timeLeft =
						(hours ? hours + ":" + twoDigits(mins) : mins) +
						":" +
						twoDigits(time.getUTCSeconds());
					angular.element("#timeLeft").html($scope.timeLeft);
					if (continueTimer)
						//stops timer on 'yes' of dialog
						setTimeout(
							updateTimer,
							time.getUTCMilliseconds() + 500
						);
				}
			}

			endTime = +new Date() + 1000 * (60 * minutes + seconds) + 500;
			updateTimer();
		}

		/*
		 * openDialog - function to display dialog box with yes/no buttons
		 * Param - none
		 * Return - none
		 */
		function openDialog() {
			if (!activeDialog) {
				continueTimer = true;
				activeDialog = true;

				dialogCountdown(timerLengthMinutes, timerLengthSeconds);

				ngDialog
					.openConfirm({
						template: "../ngviews/directives/qbNgDialog.html",
						className: "ngdialog-theme-default",
						scope: $scope,
						closeByDocument: false,
						closeByEscape: false,
						showClose: false,
						disableAnimation: true,
					})
					.then(
						function (value) {
							stopEvents();
							activate("timeout");
							continueTimer = false;
							activeDialog = false;
							void 0;
						},
						function (reason) {
							activeDialog = false;
							redirectLink(false);
							void 0;
						}
					);
			} else {
				return;
			}
		}

		/*
		 * validateSession - function to validate session count
		 * Param - none
		 * Return - none
		 */
		function validateSession() {
			if (!isUndefinedOrNull(timeLeft)) {
				stopTimer();
			}

			if (!isUndefinedOrNull(sessionCount)) {
				if (initSession >= sessionCount) {
					redirectLink(true);
				} else {
					openDialog();
				}
			} else {
				openDialog();
			}
		}

		/*
		 * redirectLink - redirect URL
		 * Param - true/false
		 * Return - none
		 */
		function redirectLink(arg) {
			vm.sessionProtPath =
				arg == true ? vm.redirectURL : vm.noRedirectURL;
			$rootScope.$broadcast("session-save-quote");
			// $rootScope.$broadcast("clear-field-values");
			// window.location.href = util.linkBuilder(sessionProtPath);
		}

		$scope.$on("session-redirect", function () {
			void 0;
			window.location.href = util.linkBuilder(vm.sessionProtPath);
		});
	}

	angular.module("qbePortal").directive("qbNgDialog", function () {
		return {
			restrict: "A",
			controller: "QBNgDialog",
			controllerAs: "vm",
			scope: {},
			transclude: true,
			link: function ($scope, element, attrs) {
				$scope.timeLeft = null;
				$scope.contentData = {};
			},
		};
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('QBParentClass', QBParentClass);

	QBParentClass.$inject = ['$scope'];

	function QBParentClass($scope) {
		var vm = this;
	}

	angular.module('qbePortal').directive('qbParentClass', [
		function () {
			return {
				restrict: 'A',
				controller: QBParentClass,
				controllerAs: 'vm',
				scope: {
					qbParentClass: '<',
					qbParentElement: '@?'
				},
				link: function (scope, element, attrs, ctrl) {

					scope.$watch(function () {
						var classes = $(element).find('input').attr('class');
						return classes;
					}, function (newValue, oldValue) {
						if (!newValue) return;
						if (newValue.indexOf('ng-invalid') >= 0)
							void 0;
						else
							void 0


					});


					// for (var cssClass in scope.qbParentClass ) {
					// 	var condition = scope.qbParentClass[cssClass] ;
					// 	var parent = scope.qbParentElement ? element.parents(scope.qbParentElement) : element.parent() ;
					// 	if (condition)
					// 		parent.addClass(cssClass);
					// 	else
					// 		parent.removeClass(cssClass) ;
					// }


				}
			};
		}]);
})();

(function () {
	'use strict';

	// angular.module('qbePortal').controller('ctpProgress', ctpProgress);

	// ctpProgress.$inject = ['$scope'];

	// function ctpProgress($scope) {
	// 	var vm = this;
	// 	vm.ctpCompleted = false;
	// }


	angular.module('qbePortal').directive('qbPaybillProgress', 
		function () {
			return {
				templateUrl: '../ngviews/directives/qbPaybillProgress.html',
				// controller: ctpProgress,
				// controllerAs: 'vm',				
				restrict: 'E',
			     scope: {
			     		textDisplay:'=',
			     		ctpStepTotal:'=',
			     		ctpStepNum:'=',
			     		ctpCompleted:'='			              
			            },
			     transclude: true,							
				link: function (scope, element, attrs) {					

				}
			};
		});

})();

(function() {
	'use strict';

	angular
		.module('qbePortal')
		.controller('QBPaymentSummary', QBPaymentSummary);
	QBPaymentSummary.$inject = [
		'$scope',
		'quoteModelFactory',
		'$filter',
		'$state',
		'MODULE_INFO',
		'labelService',
		'userInputRepository',
		'$window',
	];

	function QBPaymentSummary(
		$scope,
		quoteModelFactory,
		$filter,
		$state,
		MODULE_INFO,
		labelService,
		userInputRepository,
		$window
	) {
		var vm = this,
			quoteHasCoverType = false;

		vm.state = $state;
		vm.saveSuccess = null;
		var quoteModel = quoteModelFactory.create();

		vm.saveQuote = function() {
			if (validateMail()) {
				$scope.$root.$broadcast(
					'sidebar-save-quote',
					vm.yourEmailAddress
				);
			} else {
				vm.saveSuccess = false;
			}
		};

		vm.assignEmail = function() {
			$scope.$root.$broadcast('sidebar-assign-mail', vm.yourEmailAddress);
		};

		function validateMail() {
			if (
				vm.yourEmailAddress == '' ||
				vm.yourEmailAddress == null ||
				angular
					.element('div')
					.find('[label-key=yourEmailAddress]')
					.hasClass('ng-invalid-email')
			) {
				return false;
			} else {
				userInputRepository.update({
					email: vm.yourEmailAddress
				});
				return true;
			}
		}

		// Add print specific class to pages with payment summary
		if (
			window.location.href.indexOf('quote') > -1 ||
			window.location.href.indexOf('contact') > -1 ||
			window.location.href.indexOf('payment') > -1
		) {
			var $columns = $('.columns').get(0);
			$columns.classList.add('print-ready');
		}

		$scope.$on('save-quote-success', function() {
			vm.saveSuccess = true;
		});

		$scope.$on('quote-received', onNewQuoteReceived);

		$scope.$on('selected-quote-changed', function() {
			setSelectedQuoteModel();
		});

		$scope.$root.$on('update-payment-options', updatePaymentOptions);

		$scope.$root.$on('$stateChangeSuccess', function() {
			$scope.mobileUnmatch();
		});

		$scope.mobileUnmatch = function() {
			var $colMain = document.querySelector('.col--main');
			// var colMainPosTop = $colMain.getClientRects()[0].top;
			var $content = document.getElementById('content');
			var $floatingModule = document.querySelector('.floating-module');

			$colMain.style.removeProperty('margin-top');

			// Reset element position
			// colMainPosTop = $colMain.getClientRects()[0].top;

			// Remove sticky classes
			$content.classList.remove('sticky');
			if (!!$floatingModule) {
				$floatingModule.classList.remove('sticky-mobile');
			}
		};

		vm.paymentPanelButtonText = getPaymentButtonText();
		vm.displayPaymentButton = vm.paymentPanelButtonText != null;

		function getPaymentButtonText() {
			if (
				MODULE_INFO.paymentPanelButtonText &&
				MODULE_INFO.paymentPanelButtonText[$state.current.name]
			)
				return MODULE_INFO.paymentPanelButtonText[$state.current.name];

			return null;
		}

		function onNewQuoteReceived(event, resp) {
			setSelectedQuoteModel();
		}

		function setSelectedQuoteModel(frequency) {
			quoteModel = quoteModelFactory.create();

			if (quoteModel.email != '') {
				vm.yourEmailAddress = quoteModel.email;
			}

			if (quoteModel.selectedQuote) {
				quoteHasCoverType = true;
			}

			if (!frequency) frequency = 'annual';

			if (quoteHasCoverType) {
				vm.quoteModel = quoteModel.selectedQuote;
				refreshPrices(frequency);
			}
		}

		vm.paymentOptions = 'yearly';

		function updatePaymentOptions(event, paymentOptions) {
			var frequency;
			// Set payment option
			vm.paymentOptions = paymentOptions;

			if (quoteHasCoverType) {
				// Set frequency label
				if (paymentOptions === 'yearly') {
					frequency = 'annual';
					vm.frequencyLabel = 'per_annum';
				} else if (paymentOptions === 'monthly') {
					frequency = 'monthly';
					vm.frequencyLabel = 'per_month';
				} else if (paymentOptions === 'fortnightly') {
					frequency = 'fortnightly';
					vm.frequencyLabel = 'per_fortnight';
				}

				setSelectedQuoteModel(frequency);
				// refreshPrices(frequency) ;
			}
		}

		function refreshPrices(frequency) {
			// Set cover type
			vm.frequencyLabel = 'per_annum';

			vm.coverType = vm.quoteModel.getQuoteResult(frequency).coverType;

			//additional condition for home
			if (
				vm.coverType === 'building_and_contents' ||
				vm.coverType === 'building_only' ||
				vm.coverType === 'contents_only'
			) {
				vm.coverType = vm.quoteModel.getQuoteResult(frequency).offering;
			}

			// Set quote results
			vm.quoteResults = vm.quoteModel.getQuoteResult(frequency).response;

			// Set discounts
			vm.discounts = vm.quoteResults.quoteResult.discounts;

			// Filter discounts per mapping and amount is greater than zero
			if (vm.discounts) {
				vm.savings = [];
				angular.forEach(vm.discounts, function(index) {
					if (
						!vm.mapServiceValue(
							'paymentSummaryDiscounts',
							index.discountType
						) &&
						index.amount !== 0
					) {
						vm.savings.push({
							discountType: index.discountType,
							amount: index.amount
						});
					}
				});
			}

			// Apply gift card
			if (
				vm.quoteResults.isGiftCardApplied &&
				vm.quoteResults.isGiftCardApplied === true
			) {
				if (
					vm.mapServiceValue(
						'paymentSummaryGiftCards',
						vm.quoteResults.campaignCode
					)
				) {
					vm.savings.push({
						discountType: vm.mapServiceValue(
							'paymentSummaryGiftCards',
							vm.quoteResults.campaignCode
						)
					});
				}
			}

			// Set payment plan
			vm.paymentPlan = vm.quoteResults.paymentPlan;

			// If there are any payment installments
			if (vm.paymentPlan.installment) {
				vm.paymentInstallment = $filter('styledCurrency')(
					vm.paymentPlan.installment
				);
			}

			//set monthly values
			vm.quoteMonthly = vm.quoteModel.getMonthly();
			vm.monthlyQuoteAmount = $filter('styledCurrency')(
				vm.quoteMonthly.paymentPlan.installment
			);

			//downpayment
			vm.monthlyDownPayment = $filter('styledCurrency')(
				vm.quoteMonthly.paymentPlan.downPayment
			);

			//set fortnightly values
			vm.quoteFortnightly = vm.quoteModel.getFortnightly();
			vm.fortnightlyQuoteAmount = $filter('styledCurrency')(
				vm.quoteFortnightly.paymentPlan.installment
			);

			//down payment
			vm.fortnightlyDownPayment = $filter('styledCurrency')(
				vm.quoteFortnightly.paymentPlan.downPayment
			);

			// Set quote after discounts
			vm.quote = $filter('styledCurrency')(
				vm.quoteResults.quoteResult.totalPremium
			);

			// Set total monthly premium
			vm.premAfterDisc = $filter('styledCurrency')(
				vm.quoteMonthly.totalPremium
			);

			// Set reference documents
			vm.referenceDocuments = $filter('showFslOnlyNsw')(
				vm.quoteResults.referenceDocuments,
				vm.quoteResults.policyAddress.state
			);

			if (
				vm.referenceDocuments &&
				(vm.quoteResults.productCode === 'QPHHome' ||
					vm.quoteResults.productCode === 'QPHLandlord')
			) {
				angular.forEach(vm.referenceDocuments, function(
					documents,
					index
				) {
					if (documents.type === 'pds') {
						switch (vm.coverType) {
							case 'QPHStandardOffering':
								vm.referenceDocuments[
									index
								].name = labelService.getGlobalOptionLabel(
									'PDS',
									'standardPDSLabel'
								);
								break;

							case 'QPHPrestigeOffering':
								vm.referenceDocuments[
									index
								].name = labelService.getGlobalOptionLabel(
									'PDS',
									'prestigePDSLabel'
								);
								break;

							case 'QPHLandlordOffering':
								vm.referenceDocuments[
									index
								].name = labelService.getGlobalOptionLabel(
									'PDS',
									'landlordPDSLabel'
								);
								break;

							case 'QPHStrataContentsOffering':
								vm.referenceDocuments[
									index
								].name = labelService.getGlobalOptionLabel(
									'PDS',
									'strataPDSLabel'
								);
								break;
						}
					}
				});
			} else {
				angular.forEach(vm.referenceDocuments, function(
					documents,
					index
				) {
					if (documents.type === 'pds') {
						vm.referenceDocuments[
							index
						].name = labelService.getGlobalOptionLabel(
							'PDS',
							'sideBarlinkLabel'
						);
					}
				});
			}
		}

		vm.purchaseNow = function() {
			$scope.$root.$broadcast('form-submit', MODULE_INFO.mainFormName);
		};

		vm.printPage = function() {
			window.print();
		};

		vm.getPage = function() {
			return vm.state.current.name.split('.')[1];
		};

		vm.isPaymentOptionVisible = function(paymentOption) {
			if (vm.getPage() === 'payment') {
				//on payment page display baed on the user selection
				if (vm.paymentOptions === paymentOption) {
					return true;
				}
			} else {
				//if not on payment page display yearly and monthly
				if (paymentOption === 'yearly' || paymentOption === 'monthly') {
					return true;
				} else {
					return false;
				}
			}

			return false;
		};

		vm.lookupLabel = function(fieldName) {
			return labelService.getGlobalOptionLabel(
				'paymentSummary',
				fieldName
			);
		};

		vm.getDocument = function(gwDocument) {
			if (!gwDocument.url || !gwDocument.name) {
				return gwDocument;
			}
			if ($window.location.pathname.indexOf('/bike') !== -1) {
				if (gwDocument.name.indexOf('Insurance PDS') !== -1) {
					var bikePdsLink = vm.getGlobalOption('PDS', 'bikePdsLink');
					if (bikePdsLink) {
						gwDocument.url = bikePdsLink.label;
						return gwDocument;
					}				
				}				
			}
			else if ($window.location.pathname.indexOf('/caravan') !== -1) {
				if (gwDocument.name.indexOf('Insurance PDS') !== -1) {
					var caravanPdsLink = vm.getGlobalOption('PDS', 'caravanPdsLink');
					if (caravanPdsLink)	{
						gwDocument.url = caravanPdsLink.label;
						return gwDocument;
					}
				}
			}
			return gwDocument;
		}

		vm.mapServiceValue = function(serviceName, option) {
			option = option.trim();
			/** some service values come back untrimmed :) */
			return labelService.getGlobalOptionLabel(serviceName, option);
		};
		vm.getGlobalOption = function(key, option) {
			option = option.trim();
			return labelService.getGlobalOption(key, option);
		};

		setSelectedQuoteModel();
	}

	angular
		.module('qbePortal')
		.directive('qbPaymentSummary', ["$window", "$timeout", function($window, $timeout) {
			return {
				restrict: 'E',
				templateUrl: '../ngviews/sections/common/payment-summary.html',
				controller: QBPaymentSummary,
				controllerAs: 'vm',
				link: function(scope, element) {
					// $timeout(function () {

					// Get qbPaymentSummary position and width
					var qbPaymentSummaryPosTop = element[0].getClientRects()[0]
						.top;
					var qbPaymentSummaryPosLeft = element[0].getClientRects()[0]
						.left;
					var qbPaymentSummaryWidth = element[0]
						.querySelector('div')
						.getClientRects()[0].width;

					// Floating module
					var $floatingModule = element[0].querySelector(
						'.floating-module'
					);
					var $floatingModuleContainer = element[0].querySelector(
						'.floating-module-container'
					);

					var $floatingModulePosTop = $floatingModule.getClientRects()[0]
						.top;
					// var breakPoint = $floatingModuleContainer.getClientRects()[0].bottom;

					// Cover details
					var $coverDetails = element[0].querySelector(
						'.expandcollapse'
					);
					var coverDetailsPosTop = $coverDetails.getClientRects()[0]
						.top;

					// Content element
					var $content = document.getElementById('content');

					var $colMain = document.querySelector('.col--main');
					var colMainHeight = $colMain.offsetHeight;
					var colMainPosTop = $colMain.getClientRects()[0].top;

					// Footer element
					var $footer = $('.footer').get(0);
					var footerHeight = $footer.offsetHeight;

					// For mobile
					enquire.register(DD.bp.get('0, s'), {
						match: function() {
							$content.classList.add('sticky');
							colMainPosTop = $colMain.getClientRects()[0].top;

							angular.element($window).off('scroll');

							// Set Initial Window position
							var windowPosition = $(window).scrollTop();
							angular.element($window).on('scroll', function() {
								// Set Floating module height and top position
								var $floatingModuleHeight =
									$floatingModule.clientHeight;
								var colMainPos = $colMain.getClientRects()[0]
									.top;

								// When scroll position is below quote panel
								if (colMainPos <= 0) {
									// Check scroll position
									var windowScroll = $(window).scrollTop();
									var floatingModuleHeight =
										'-' + $floatingModuleHeight + 'px';

									// Scrolling Down
									if (windowScroll > windowPosition) {
										$floatingModule.style.top = floatingModuleHeight;
									}
									// Scrolling Up
									else {
										$floatingModule.style.top = '0px';
										$floatingModule.classList.add(
											'sticky-mobile'
										);
									}

									windowPosition = windowScroll;
								}
								// Other scroll positions
								else {
									$floatingModule.classList.remove(
										'sticky-mobile'
									);
									$floatingModule.style.top = '0px';
								}
							});

							$timeout(function() {
								$colMain.style.marginTop =
									$floatingModule.offsetHeight - 10 + 'px';
							}, 1000);
						},
						unmatch: scope.mobileUnmatch
					});

					// For table and above
					enquire.register(DD.bp.get('m'), {
						match: function() {
							angular.element('.floating-module').css('top', '');

							// Update position and width on resize
							angular.element($window).on('resize', function() {
								if ($floatingModule.length > 0) {
									// Set element position and width
									qbPaymentSummaryPosLeft = element[0].getClientRects()[0]
										.left;
									qbPaymentSummaryWidth = element[0]
										.querySelector('div')
										.getClientRects()[0].width;

									colMainHeight = $colMain.offsetHeight;
									colMainPosTop = $colMain.getClientRects()[0]
										.top;

									coverDetailsPosTop = $coverDetails.getClientRects()[0]
										.top;
									// breakPoint = $floatingModuleContainer.getClientRects()[0].bottom;

									footerHeight = $footer.offsetHeight;
								}
							});

							angular.element($window).off('scroll');
							angular.element($window).on('scroll', function() {
								var $sidebarContainer = $('.floating-module');
								if ($sidebarContainer.length > 0) {
									// Floating save quote
									var $floatingSave =
										$('.floating-save-quote').length > 0
											? $('.floating-save-quote')[0]
													.offsetHeight * 4
											: 0;

									// When scroll position is below quote panel
									if (
										$window.pageYOffset >=
											coverDetailsPosTop &&
										$window.pageYOffset + footerHeight <
											$colMain.offsetHeight +
												colMainPosTop -
												$floatingSave
									) {
										// $floatingModule.style.width = qbPaymentSummaryWidth + 'px';
										// $floatingModule.style.left = qbPaymentSummaryPosLeft + 'px';
										$content.classList.remove(
											'sidebar-fixed'
										);
										$content.classList.add(
											'sidebar-follow'
										);

										// When scroll position is near the bottom of the page
									} else if (
										$window.pageYOffset + footerHeight >=
										$colMain.offsetHeight +
											colMainPosTop -
											$floatingSave
									) {
										// $floatingModule.style.left = '';
										$content.classList.remove(
											'sidebar-follow'
										);
										$content.classList.add('sidebar-fixed');

										// Other scroll positions
									} else {
										$floatingModule.removeAttribute(
											'style'
										);
										$content.classList.remove(
											'sidebar-follow'
										);
										$content.classList.remove(
											'sidebar-fixed'
										);
									}
								}
							});
						},
						unmatch: function() {
							if ($floatingModule.length > 0) {
								// Reset element position and width
								qbPaymentSummaryPosLeft = element[0].getClientRects()[0]
									.left;
								qbPaymentSummaryWidth = element[0]
									.querySelector('div')
									.getClientRects()[0].width;

								colMainHeight = $colMain.offsetHeight;
								colMainPosTop = $colMain.getClientRects()[0]
									.top;

								coverDetailsPosTop = $coverDetails.getClientRects()[0]
									.top;

								footerHeight = $footer.offsetHeight;

								// Remove sticky classes
								$floatingModule.removeAttribute('style');
								$content.classList.remove('sidebar-follow');
								$content.classList.remove('sidebar-fixed');
							}
						}
					});
				}
			};
		}]);
})();

(function () {
	'use strict';

	angular.module('qbePortal').directive('qbPhoneNumberValidation', function () {
		
		return {
			require: 'ngModel',
			restrict: '',
			link: function (scope, elm, attrs, ctrl) {
				
				ctrl.$validators.pattern = function(modelValue, viewValue) {

					//Polyfill code for the "startswith" to be use in IE *Can be move in a startup where the JS executes
					if (!String.prototype.startsWith) {
						String.prototype.startsWith = function(searchString, position) {
							position = position || 0;
							return this.indexOf(searchString, position) === position;
						};
					}		

					if (ctrl.$isEmpty(modelValue)) {
						// consider empty models to be valid
						return true;
					}else{
						var validPhone = false;

						if(viewValue.length >= 8){
							validPhone = true;
						}

						// Starts with 13 and is 6 digits long
						// Starts with 1300 and is 10 digits long
						if(viewValue.startsWith("13")){
							if(viewValue.startsWith("1300")){
								validPhone = viewValue.length === 10 || viewValue.length === 6;
							}else{
								validPhone = viewValue.length === 6;
							}
						}

						// Starts with (0_) followed by 8 digits (where _ is 1-9), and is a minimum of 10 digits long
						// This should account for international numbers as well as local Australian numbers "0011"
						if(viewValue.startsWith("0")){
							if(viewValue.startsWith("0011")){
								validPhone = viewValue.length === 10;
							}else{
								if(viewValue[1] >= 1 && viewValue[1] <= 9){
									validPhone = viewValue.length === 10;
								}
							}
						}

						// Starts with +61 followed by 9 digits
						if(viewValue.startsWith("+")){
							validPhone = false;
							if(viewValue.startsWith("+61")){
								validPhone = viewValue.length === 12;
							}
						}

						if(viewValue.indexOf('+') > 0 || (viewValue.match(/\+/g)||[]).length > 1){
							validPhone = false;
						}

						return validPhone;
					}
				}
			}
		};
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').directive('qbPromoBox',
		function () {
			return {
				templateUrl: '../ngviews/directives/qbPromoBox.html',				
				restrict: 'E',
			    transclude: true,	
				scope: {
					isConfirmed: '=',
					coreData: '=',
					showThankYou: '=',
					promoData: '='
				},						
				link: function (scope, element, attrs) {					
					scope.clearUserForm = function() {
						scope.$emit('clear-User-Input');
					}
				}
			};
		});

})();


(function () {
	'use strict';

	angular.module('qbePortal').directive('qbPromoCode', ['guideWireService', 'labelService', '$rootScope', '$q', function (guideWireService, labelService, $rootScope, $q) {

		function addValidPromoMessage(wrapper, promoValue) {
			if (wrapper) {
				try {
					$rootScope.$broadcast('valid-campaign', {
						isValid: true,
						promoValue: promoValue
					});
					if ($(wrapper).find('em.valid-promo').length == 0) {
						var promoMessage = labelService.getGlobalOptionLabel('content', 'promo_acknowledged_message');
						$(wrapper).append('<em class="help valid-promo">' + promoMessage + '</em>');
					}
				} catch (ex) {
					void 0;
				}
			}
		}

		function removeValidPromoMessage(wrapper) {
			if (wrapper) {
				$(wrapper).find('em.valid-promo').remove();
				$rootScope.$broadcast('valid-campaign', {
					isValid: false
				});
			}
		}

		function validateInput(element, ngModel) {
			if (!ngModel || typeof (element.val()) != 'string') return;
			var currentValue = element.val();
			var promoWrapper = element.parent('.promo-wrapper');
			if (currentValue && currentValue != '') {
				return guideWireService.isCampaignCodeValid(currentValue)
					.then(function (unique) {
						addValidPromoMessage(promoWrapper, currentValue);
						return $q.resolve();
					}).catch(function () {
						removeValidPromoMessage(promoWrapper);
						return $q.reject();
					});
			} else {
				removeValidPromoMessage(promoWrapper);
				return $q.resolve();
			}
		}

		function _link(scope, element, attrs, ngModel) {
			ngModel.$asyncValidators.qbPromoCode = function (modelValue) {
				return validateInput(element, ngModel);
			}
		}

		return {
			require: 'ngModel',
			link: _link,
		};
	}]);
})();

(function() {
	'use strict';

	angular.module('qbePortal').directive('qbRestrictInput', function() {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function($scope, element, attr, ctrl) {
				// ng-trim must be set to false if you want to prevent whitespaces
				if (attr.ngTrim == 'false') {
					element.bind('keydown', function(e) {
						if (e.which === 32) {
							e.preventDefault();
							return false;
						}
					});
				}

				ctrl.$parsers.push(function(value) {
					var viewValue;
					var options = $scope.$eval(attr.qbRestrictInput);

					if (options.type) {
						switch (options.type) {
							case 'digitsOnly':
								viewValue = value.replace(/\D/g, '');
								break;
							case 'lettersAndDigitsOnly':
								viewValue = value.replace(/\W/g, '');
								break;
							case 'lettersAndDigitsSpaceOnly':
								if (/\s/g.test(value)) {
									viewValue = value.replace(
										/[^a-zA-Z0-9 ]/g,
										''
									);
								} else {
									viewValue = value.replace(/\W/g, '');
								}
								break;
							default:
								viewValue = '';
						}
					}

					if (viewValue !== value) {
						ctrl.$setViewValue(viewValue);
						ctrl.$render();
					}
					return viewValue;
				});
			}
		};
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').directive('qbSimpleSelectArrowClick',
		function () {
			return {
				restrict: 'A',
				link: function (scope, elm, attrs, ctrl) {
					var $select = $(elm).find('select');

					var openSelect = function (element) {
						var worked = false;
						if (document.createEvent) { // all browsers
							var e = document.createEvent("MouseEvents");
							e.initMouseEvent("mousedown", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
							worked = element.dispatchEvent(e);
						} else if (element.fireEvent) { // ie
							worked = element.fireEvent("onmousedown");
						}
					}

					$(elm).click(function (event) {
						openSelect($select.get(0));
					});
				}
			};
		});
})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('QBSmartLink', QBSmartLink);

	QBSmartLink.$inject = ['$scope', '$window', '$rootScope'];

	function QBSmartLink($scope, $window, $rootScope) {
		var vm = this;

		if ($window.qbe.fieldLabels != undefined) {
			$scope.contentData = $window.qbe.fieldLabels.smartLink;
		}

		vm.header = $scope.contentData.header;
		vm.content = $scope.contentData.content;
		vm.star = $scope.contentData.feefoStar;
		vm.feedbackButton = $scope.contentData.feedbackButton;
		vm.feefoLogo = $scope.contentData.feefoLogo;

		vm.submitFeedback = function () {
			$rootScope.$broadcast('submit-feedback');
		}
	}

	angular.module('qbePortal').directive('qbSmartLink',
		["$window", function ($window) {
			return {
				templateUrl: '../ngviews/directives/qbSmartLink.html',
				restrict: 'E',
				controller: QBSmartLink,
				controllerAs: 'vm',
				link: function (scope, element) {

					//Repeat by defined number of times
					scope.starCount = function (count) {
						return new Array(count);
					}

					if ($window.innerWidth > 767) {
						setFeefoPosition();
					} else {
						scope.feefoStyle = {
							"position": "relative",
							"top": "0px"
						};
					}

					//Feefo container position
					angular.element($window).bind('resize', function () {
						if ($window.innerWidth > 767) {
							setFeefoPosition();
						} else {
							scope.feefoStyle = {
								"position": "relative",
								"top": "0px"
							};
						}
						scope.$apply();
					});

					function setFeefoPosition() {
						var receiptPosition = document.querySelector('.form-group__container').offsetTop;
						var feefoNewPosition = receiptPosition - 30 + 'px';

						scope.feefoStyle = {
							"position": "relative",
							"top": feefoNewPosition
						};
					}
				}
			};
		}]);

})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('SummarySection', SummarySection);

	SummarySection.$inject = ['$scope', '$state', 'dynamicRouter', '$window','$filter'
		, 'quoteModelFactory' // labelService is not directly referenced but is required before initialisation
		, 'userInputRepository'
		, 'serviceResponseRepository'
		, 'Util'
		, 'labelService'
	];

	function SummarySection($scope, $state, dynamicRouter, window,$filter, quoteModelFactory, userInputRepository, serviceResponseRepository, Util, labelService) {
		var vm = this;
		var children = {}, sectionData = {};

		//dispatch label event as this summary view is outside the form controller
		Util.dispatchCustomEvent('register-labels');
		vm.labelService = labelService;

		vm.quoteModel = quoteModelFactory.create();

		$scope.$root.$on('selected-quote-changed', function () {
			vm.quoteModel = quoteModelFactory.create();
		});

		$scope.HTML_ID = $scope.name;
		$scope.hierarchyList = [$scope.name];

		vm.sectionName = $scope.name;

		vm.summary = $scope.summaryModel
		void 0;
		void 0;
		vm.getLabel = function (labelKey) {
			var excessLabel = vm.labelService.getLabelForRemoteOption('driverExcess', labelKey);
			return (excessLabel) ? excessLabel.label : '';
		};

		vm.getRiderExcessLabel = function (labelKey) {
			var excessLabel = vm.labelService.getLabelForRemoteOption('riderExcess', labelKey);
			return (excessLabel) ? excessLabel.label : '';
		};

		vm.getWallConstructionLabel = function (labelKey) {
			var wallConstruction = this.getGlobalOptionLabel('wallsMadeOf', labelKey);
			return (wallConstruction) ? wallConstruction : '';
		};

		vm.getLabelForRemoteOption = function (labelSet, labelKey) {
			var label = vm.labelService.getLabelForRemoteOption(labelSet, labelKey);
			return (label) ? label.label : '';
		};

		vm.getGlobalOptionsFor = function (optionType) {
			return labelService.getGlobalOptionsFor(optionType);
		};

		vm.getGlobalOptionLabel = function (optionType, optionValue) {
			var optionKeyValues = this.getGlobalOptionsFor(optionType);
			void 0;
			var label = null;
			var values=$filter('filter')(optionKeyValues, {value:optionValue}); 
			void 0;
			if (values && values.length>0) {
				label=values[0].label;				
			}
			return label;
		};

		vm.getGlobalOption = function (key, option) {
			option = option.trim();
			return labelService.getGlobalOption(key, option);
		};

		vm.getLiability = function () {
			var liability = vm.getGlobalOption('content', 'legal_liability');
			return (liability) ? liability.content : '';
		};

		vm.moveToState = function (step) {
			void 0;
			$state.go(dynamicRouter.getState(step));
		};

		vm.moveToHomeState = function (step) {
			void 0;
			if(vm.summary.annualCoverType.coverType==='contents_only' && step>2)
				step--;
			vm.moveToState(step);
		};

		vm.getStateName = function(address){
			return address!=null && address.state && address.state!=null ?address.state.replace(/AU_/,''):'';
		}

		vm.generateAddressText = function(address){
			
			var addressText='';
			addressText = address.addressLine1 + " " +address.city+", "+ vm.getStateName(address)+", "
				+address.postalCode;
			return addressText;
		}

		vm.liability = vm.getLiability();

		vm.getYearHomeBuilt = function(yearValue){
			var yearHomeBuiltOptions = this.getOptionsForBuildingYearBuilt('yearHomeBuilt');
			if(yearHomeBuiltOptions!=null && vm.summary.homeForm && vm.summary.homeForm.tellUsAboutTheBuilding.yearHomeBuilt
				&& vm.summary.homeForm.tellUsAboutTheBuilding.yearHomeBuilt){
				var filteredResult = $filter('filter')(yearHomeBuiltOptions,{value:vm.summary.homeForm.tellUsAboutTheBuilding.yearHomeBuilt});
				if(filteredResult.length>0){
					return filteredResult[0].label;
				}
			}
			return null;
		}

		vm.getOptionsForBuildingYearBuilt = function (fieldName) {
			var options = vm.getGlobalOptionsFor(fieldName);
			for (var i = 2000; i <= (new Date()).getFullYear(); i++) {
				options.unshift({
					label: String(i),
					value: String(i)
				});
			}
			return options;		
		}

		vm.includeFloodCover = function(){			
			var quickQuoteResponse = serviceResponseRepository.getLastResponseFrom('quote');
			if(quickQuoteResponse && quickQuoteResponse!=null){

				return quickQuoteResponse.includeFloodCover!=undefined && quickQuoteResponse.includeFloodCover==true;

			}
			return false;
		}
	}

	angular.module('qbePortal').directive('qbSummarySection', [function () {
		return {
			restrict: 'EA',
			controller: SummarySection,
			controllerAs: 'vm',
			transclude: true,
			scope: {
				init: '&',
				summaryModel: '='
			},
			link: function (scope, element, attrs, ctrl, transclude) {
				if (scope.setHierarchy !== undefined)
					hierarchyDecorator.attach(scope, {element: element, name: scope.name});

				transclude(scope, function (clone) {
					element.append(clone);
				});
			}
		}
	}]);
})();

(function () {
	'use strict';
	angular.module('qbePortal').directive('qbTabs',
		["quoteOptions", "userInputRepository", function (quoteOptions, userInputRepository) {
			return {
				templateUrl: '../ngviews/directives/qbTabs.html',
				restrict: 'E',
				transclude: true,
				scope: {
					selectedTab: '<',
					setSelectedTab: '&',
				},
				link: function (scope, element, attrs) {
					scope.vm = {};

					$(element).on('changeTab.tabs', function (event, $activeTabId) {
						var $tab = $($activeTabId);
						var tabId = $tab.attr('tab-id');
						scope.setSelectedTab({
							'tabId': tabId
						});
					});

					function initTabs(selectedTab) {
						$(element).find('[tab-id=' + selectedTab + ']').addClass('is-active');
						QBE.tabs.init();
					}

					initTabs(scope.selectedTab);
				}
			};
		}]
	);
})();

(function () {
	'use strict';

	angular.module('qbePortal').directive('qbThankYou',
		function () {
			return {
				templateUrl: '../ngviews/directives/qbThankYou.html',
				restrict: 'E',
				scope: {
					thankYou: "=",
					isEligible: "=",
					isConfirmed: '=',
					coreData: '=',
					showThankYou: '=',
					promoData: '=',
		     		textDisplay:'=',
		     		ctpStepTotal:'=',
		     		ctpStepNum:'=',
		     		ctpCompleted:'='										
				},
			    transclude: true,							
				link: function (scope, element, attrs) {					
							
				}
			};
		});

})();

(function () {
	'use strict';

	angular.module('qbePortal').directive('qbTooltip',
		function () {
			return {
				restrict: 'A',
				scope: {
					tooltip: '@'
				},
				link: function (scope, element, attrs) {
					element.attr('title', scope.tooltip);
					$('.js-tooltip').ddTooltip();
				}
			};
		});

})();

(function () {
	'use strict';

	angular.module('qbePortal').directive('qbValidBsb', ['guideWireService', function (guideWireService) {

		return {
			require: 'ngModel',
			link: function (scope, element, attrs, ngModel) {
				ngModel.gwService = guideWireService;

				ngModel.$setValidity('qbValidBsb', true);

				element.bind('keyup', function (e) {
					if (!ngModel || typeof(element.val()) != 'string') return;

					// var keyProperty = scope.$eval(attrs.wcUnique);
					var currentValue = element.val();
					if (currentValue && currentValue != ''
						&& currentValue.length >= 6
						&& Number.isNumeric(currentValue)
					) {
						ngModel.gwService.isBSBValid(currentValue)
							.then(function (bsbResult) {
								var valid = bsbResult.data ?
									( bsbResult.data.bankName != undefined
									&& bsbResult.data.bankName != 'Unknown' )
									: false;
								ngModel.$setValidity('qbValidBsb', valid);
							}).catch(function () {
							ngModel.$setValidity('qbValidBsb', false);
						});
					} else {
						ngModel.$setValidity('qbValidBsb', true);
						return true;
					}
				});

			}
		};
	}]);
})();

(function () {
	'use strict';

	angular.module('qbePortal').directive('qbValidExpiryDate', function () {
		var EXPIRY_DATE_REGEXP = /^([0-9]{2})\/([0-9]{2})$/;

		return {
			require: 'ngModel',
			restrict: '',
			link: function (scope, elm, attrs, ctrl) {
				// only apply the validator if ngModel is present and Angular has added the email validator
				if (ctrl) {

					// this will overwrite the default Angular email validator
					ctrl.$validators.invalidDate = function (modelValue) {
						return ctrl.$isEmpty(modelValue)
							|| (EXPIRY_DATE_REGEXP.test(ctrl.$viewValue) && validDate(ctrl.$viewValue));
					};
				}

				function validDate(modelValue) {
					var monthValue = parseInt(modelValue.match(EXPIRY_DATE_REGEXP)[1]),
						yearValue = parseInt(modelValue.match(EXPIRY_DATE_REGEXP)[2]);

					return monthValue > 0 && monthValue <= 12 && validYearAndMonth(monthValue, yearValue);
				}

				function validYearAndMonth(monthValue, yearValue) {
					var yearMonthConcat = yearValue * 100 + monthValue;
					return parseInt(moment().format('YYMM')) <= yearMonthConcat;
				}

			}
		};
	});
})();

/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 1.3.3 - 2016-05-22
 * License: MIT
 */
angular.module("ui.bootstrap", ["ui.bootstrap.typeahead", "ui.bootstrap.debounce", "ui.bootstrap.position"]);
angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
	.factory('uibTypeaheadParser', ['$parse', function ($parse) {
		//                      00000111000000000000022200000000000000003333333333333330000000000044000
		var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
		return {
			parse: function (input) {
				var match = input.match(TYPEAHEAD_REGEXP);
				if (!match) {
					throw new Error(
						'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
						' but got "' + input + '".');
				}

				return {
					itemName: match[3],
					source: $parse(match[4]),
					viewMapper: $parse(match[2] || match[1]),
					modelMapper: $parse(match[1])
				};
			}
		};
	}])

	.controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser',
		function (originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
			var HOT_KEYS = [9, 13, 27, 38, 40];
			var eventDebounceTime = 200;
			var modelCtrl, ngModelOptions;
			//SUPPORTED ATTRIBUTES (OPTIONS)

			//minimal no of characters that needs to be entered before typeahead kicks-in
			var minLength = originalScope.$eval(attrs.typeaheadMinLength);
			if (!minLength && minLength !== 0) {
				minLength = 1;
			}

			originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
				minLength = !newVal && newVal !== 0 ? 1 : newVal;
			});

			//minimal wait time after last character typed before typeahead kicks-in
			var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

			//should it restrict model values to the ones selected from the popup only?
			var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
			originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
				isEditable = newVal !== false;
			});

			//binding to a variable that indicates if matches are being retrieved asynchronously
			var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

			//a function to determine if an event should cause selection
			var isSelectEvent = attrs.typeaheadShouldSelect ? $parse(attrs.typeaheadShouldSelect) : function (scope, vals) {
				var evt = vals.$event;
				return evt.which === 13 || evt.which === 9;
			};

			//a callback executed when a match is selected
			var onSelectCallback = $parse(attrs.typeaheadOnSelect);

			//should it select highlighted popup value when losing focus?
			var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

			//binding to a variable that indicates if there were no results after the query is completed
			var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;

			var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

			var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

			var appendTo = attrs.typeaheadAppendTo ?
				originalScope.$eval(attrs.typeaheadAppendTo) : null;

			var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

			//If input matches an item of the list exactly, select it automatically
			var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

			//binding to a variable that indicates if dropdown is open
			var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;

			var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;

			//INTERNAL VARIABLES

			//model setter executed upon match selection
			var parsedModel = $parse(attrs.ngModel);
			var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
			var $setModelValue = function (scope, newValue) {
				if (angular.isFunction(parsedModel(originalScope)) &&
					ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) {
					return invokeModelSetter(scope, {$$$p: newValue});
				}

				return parsedModel.assign(scope, newValue);
			};

			//expressions used by typeahead
			var parserResult = typeaheadParser.parse(attrs.uibTypeahead);

			var hasFocus;

			//Used to avoid bug in iOS webview where iOS keyboard does not fire
			//mousedown & mouseup events
			//Issue #3699
			var selected;

			//create a child scope for the typeahead directive so we are not polluting original scope
			//with typeahead-specific data (matches, query etc.)
			var scope = originalScope.$new();
			var offDestroy = originalScope.$on('$destroy', function () {
				scope.$destroy();
			});
			scope.$on('$destroy', offDestroy);

			// WAI-ARIA
			var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
			element.attr({
				'aria-autocomplete': 'list',
				'aria-expanded': false,
				'aria-owns': popupId
			});

			var inputsContainer, hintInputElem;
			//add read-only input to show hint
			if (showHint) {
				inputsContainer = angular.element('<div></div>');
				inputsContainer.css('position', 'relative');
				element.after(inputsContainer);
				hintInputElem = element.clone();
				hintInputElem.attr('placeholder', '');
				hintInputElem.attr('tabindex', '-1');
				hintInputElem.val('');
				hintInputElem.css({
					'position': 'absolute',
					'top': '0px',
					'left': '0px',
					'border-color': 'transparent',
					'box-shadow': 'none',
					'opacity': 1,
					'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
					'color': '#999'
				});
				element.css({
					'position': 'relative',
					'vertical-align': 'top',
					'background-color': 'transparent'
				});
				inputsContainer.append(hintInputElem);
				hintInputElem.after(element);
			}

			//pop-up element used to display matches
			var popUpEl = angular.element('<div uib-typeahead-popup popup-template-url="/ngviews/directives/typeahead-popup.html"></div>');
			popUpEl.attr({
				id: popupId,
				matches: 'matches',
				active: 'activeIdx',
				select: 'select(activeIdx, evt)',
				'move-in-progress': 'moveInProgress',
				query: 'query',
				position: 'position',
				'assign-is-open': 'assignIsOpen(isOpen)',
				debounce: 'debounceUpdate'
			});
			//custom item template
			if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
				popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
			}

			if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
				popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
			}

			var resetHint = function () {
				if (showHint) {
					hintInputElem.val('');
				}
			};

			var resetMatches = function () {
				scope.matches = [];
				scope.activeIdx = -1;
				element.attr('aria-expanded', false);
				resetHint();
			};

			var getMatchId = function (index) {
				return popupId + '-option-' + index;
			};

			// Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
			// This attribute is added or removed automatically when the `activeIdx` changes.
			scope.$watch('activeIdx', function (index) {
				if (index < 0) {
					element.removeAttr('aria-activedescendant');
				} else {
					element.attr('aria-activedescendant', getMatchId(index));
				}
			});

			var inputIsExactMatch = function (inputValue, index) {
				if (scope.matches.length > index && inputValue) {
					return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
				}

				return false;
			};

			var getMatchesAsync = function (inputValue, evt) {
				var locals = {$viewValue: inputValue};
				isLoadingSetter(originalScope, true);
				isNoResultsSetter(originalScope, false);
				$q.when(parserResult.source(originalScope, locals)).then(function (matches) {
					//it might happen that several async queries were in progress if a user were typing fast
					//but we are interested only in responses that correspond to the current view value
					var onCurrentRequest = inputValue === modelCtrl.$viewValue;
					if (onCurrentRequest && hasFocus) {
						if (matches && matches.length > 0) {
							scope.activeIdx = focusFirst ? 0 : -1;
							isNoResultsSetter(originalScope, false);
							scope.matches.length = 0;

							//transform labels
							for (var i = 0; i < matches.length; i++) {
								locals[parserResult.itemName] = matches[i];
								scope.matches.push({
									id: getMatchId(i),
									label: parserResult.viewMapper(scope, locals),
									model: matches[i]
								});
							}

							scope.query = inputValue;
							//position pop-up with matches - we need to re-calculate its position each time we are opening a window
							//with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
							//due to other elements being rendered
							recalculatePosition();

							element.attr('aria-expanded', true);

							//Select the single remaining option if user input matches
							if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
								if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
									$$debounce(function () {
										scope.select(0, evt);
									}, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
								} else {
									scope.select(0, evt);
								}
							}

							if (showHint) {
								var firstLabel = scope.matches[0].label;
								if (angular.isString(inputValue) &&
									inputValue.length > 0 &&
									firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
									hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
								} else {
									hintInputElem.val('');
								}
							}
						} else {
							resetMatches();
							isNoResultsSetter(originalScope, true);
						}
					}
					if (onCurrentRequest) {
						isLoadingSetter(originalScope, false);
					}
				}, function () {
					resetMatches();
					isLoadingSetter(originalScope, false);
					isNoResultsSetter(originalScope, true);
				});
			};

			// bind events only if appendToBody params exist - performance feature
			if (appendToBody) {
				angular.element($window).on('resize', fireRecalculating);
				$document.find('body').on('scroll', fireRecalculating);
			}

			// Declare the debounced function outside recalculating for
			// proper debouncing
			var debouncedRecalculate = $$debounce(function () {
				// if popup is visible
				if (scope.matches.length) {
					recalculatePosition();
				}

				scope.moveInProgress = false;
			}, eventDebounceTime);

			// Default progress type
			scope.moveInProgress = false;

			function fireRecalculating() {
				if (!scope.moveInProgress) {
					scope.moveInProgress = true;
					scope.$digest();
				}

				debouncedRecalculate();
			}

			// recalculate actual position and set new values to scope
			// after digest loop is popup in right position
			function recalculatePosition() {
				scope.position = appendToBody ? $position.offset(element) : $position.position(element);
				scope.position.top += element.prop('offsetHeight');
			}

			//we need to propagate user's query so we can higlight matches
			scope.query = undefined;

			//Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
			var timeoutPromise;

			var scheduleSearchWithTimeout = function (inputValue) {
				timeoutPromise = $timeout(function () {
					getMatchesAsync(inputValue);
				}, waitTime);
			};

			var cancelPreviousTimeout = function () {
				if (timeoutPromise) {
					$timeout.cancel(timeoutPromise);
				}
			};

			resetMatches();

			scope.assignIsOpen = function (isOpen) {
				isOpenSetter(originalScope, isOpen);
			};

			scope.select = function (activeIdx, evt) {
				//called from within the $digest() cycle
				var locals = {};
				var model, item;

				selected = true;
				locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
				model = parserResult.modelMapper(originalScope, locals);
				$setModelValue(originalScope, model);
				modelCtrl.$setValidity('editable', true);
				modelCtrl.$setValidity('parse', true);

				onSelectCallback(originalScope, {
					$item: item,
					$model: model,
					$label: parserResult.viewMapper(originalScope, locals),
					$event: evt
				});

				resetMatches();

				//return focus to the input element if a match was selected via a mouse click event
				// use timeout to avoid $rootScope:inprog error
				if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
					$timeout(function () {
						element[0].focus();
					}, 0, false);
				}
			};

			//bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
			element.on('keydown', function (evt) {
				//typeahead is open and an "interesting" key was pressed
				if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
					return;
				}

				var shouldSelect = isSelectEvent(originalScope, {$event: evt});

				/**
				 * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
				 * or
				 * shift + tab is pressed to bring focus to the previous element
				 * then clear the results
				 */
				if (scope.activeIdx === -1 && shouldSelect || evt.which === 9 && !!evt.shiftKey) {
					resetMatches();
					scope.$digest();
					return;
				}

				evt.preventDefault();
				var target;
				switch (evt.which) {
					case 27: // escape
						evt.stopPropagation();

						resetMatches();
						originalScope.$digest();
						break;
					case 38: // up arrow
						scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
						scope.$digest();
						target = popUpEl.find('li')[scope.activeIdx];
						target.parentNode.scrollTop = target.offsetTop;
						break;
					case 40: // down arrow
						scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
						scope.$digest();
						target = popUpEl.find('li')[scope.activeIdx];
						target.parentNode.scrollTop = target.offsetTop;
						break;
					default:
						if (shouldSelect) {
							scope.$apply(function () {
								if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
									$$debounce(function () {
										scope.select(scope.activeIdx, evt);
									}, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
								} else {
									scope.select(scope.activeIdx, evt);
								}
							});
						}
				}
			});

			element.bind('focus', function (evt) {
				hasFocus = true;
				if (minLength === 0 && !modelCtrl.$viewValue) {
					$timeout(function () {
						getMatchesAsync(modelCtrl.$viewValue, evt);
					}, 0);
				}
			});

			element.bind('blur', function (evt) {
				if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
					selected = true;
					scope.$apply(function () {
						if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
							$$debounce(function () {
								scope.select(scope.activeIdx, evt);
							}, scope.debounceUpdate.blur);
						} else {
							scope.select(scope.activeIdx, evt);
						}
					});
				}
				if (!isEditable && modelCtrl.$error.editable) {
					modelCtrl.$setViewValue();
					// Reset validity as we are clearing
					modelCtrl.$setValidity('editable', true);
					modelCtrl.$setValidity('parse', true);
					element.val('');
				}
				hasFocus = false;
				selected = false;
			});

			// Keep reference to click handler to unbind it.
			var dismissClickHandler = function (evt) {
				// Issue #3973
				// Firefox treats right click as a click on document
				if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
					resetMatches();
					if (!$rootScope.$$phase) {
						originalScope.$digest();
					}
				}
			};

			$document.on('click', dismissClickHandler);

			originalScope.$on('$destroy', function () {
				$document.off('click', dismissClickHandler);
				if (appendToBody || appendTo) {
					$popup.remove();
				}

				if (appendToBody) {
					angular.element($window).off('resize', fireRecalculating);
					$document.find('body').off('scroll', fireRecalculating);
				}
				// Prevent jQuery cache memory leak
				popUpEl.remove();

				if (showHint) {
					inputsContainer.remove();
				}
			});

			var $popup = $compile(popUpEl)(scope);

			if (appendToBody) {
				$document.find('body').append($popup);
			} else if (appendTo) {
				angular.element(appendTo).eq(0).append($popup);
			} else {
				element.after($popup);
			}

			this.init = function (_modelCtrl, _ngModelOptions) {
				modelCtrl = _modelCtrl;
				ngModelOptions = _ngModelOptions;

				scope.debounceUpdate = modelCtrl.$options && $parse(modelCtrl.$options.debounce)(originalScope);

				//plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
				//$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
				modelCtrl.$parsers.unshift(function (inputValue) {
					hasFocus = true;

					if (minLength === 0 || inputValue && inputValue.length >= minLength) {
						if (waitTime > 0) {
							cancelPreviousTimeout();
							scheduleSearchWithTimeout(inputValue);
						} else {
							getMatchesAsync(inputValue);
						}
					} else {
						isLoadingSetter(originalScope, false);
						cancelPreviousTimeout();
						resetMatches();
					}

					if (isEditable) {
						return inputValue;
					}

					if (!inputValue) {
						// Reset in case user had typed something previously.
						modelCtrl.$setValidity('editable', true);
						return null;
					}

					modelCtrl.$setValidity('editable', false);
					return undefined;
				});

				modelCtrl.$formatters.push(function (modelValue) {
					var candidateViewValue, emptyViewValue;
					var locals = {};

					// The validity may be set to false via $parsers (see above) if
					// the model is restricted to selected values. If the model
					// is set manually it is considered to be valid.
					if (!isEditable) {
						modelCtrl.$setValidity('editable', true);
					}

					if (inputFormatter) {
						locals.$model = modelValue;
						return inputFormatter(originalScope, locals);
					}

					//it might happen that we don't have enough info to properly render input value
					//we need to check for this situation and simply return model value if we can't apply custom formatting
					locals[parserResult.itemName] = modelValue;
					candidateViewValue = parserResult.viewMapper(originalScope, locals);
					locals[parserResult.itemName] = undefined;
					emptyViewValue = parserResult.viewMapper(originalScope, locals);

					return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
				});
			};
		}])

	.directive('uibTypeahead', function () {
		return {
			controller: 'UibTypeaheadController',
			require: ['ngModel', '^?ngModelOptions', 'uibTypeahead'],
			link: function (originalScope, element, attrs, ctrls) {
				ctrls[2].init(ctrls[0], ctrls[1]);
			}
		};
	})

	.directive('uibTypeaheadPopup', ['$$debounce', function ($$debounce) {
		return {
			scope: {
				matches: '=',
				query: '=',
				active: '=',
				position: '&',
				moveInProgress: '=',
				select: '&',
				assignIsOpen: '&',
				debounce: '&'
			},
			replace: true,
			templateUrl: function (element, attrs) {
				return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
			},
			link: function (scope, element, attrs) {
				scope.templateUrl = attrs.templateUrl;

				scope.isOpen = function () {
					var isDropdownOpen = scope.matches.length > 0;
					scope.assignIsOpen({isOpen: isDropdownOpen});
					return isDropdownOpen;
				};

				scope.isActive = function (matchIdx) {
					return scope.active === matchIdx;
				};

				scope.selectActive = function (matchIdx) {
					scope.active = matchIdx;
				};

				scope.selectMatch = function (activeIdx, evt) {
					var debounce = scope.debounce();
					if (angular.isNumber(debounce) || angular.isObject(debounce)) {
						$$debounce(function () {
							scope.select({activeIdx: activeIdx, evt: evt});
						}, angular.isNumber(debounce) ? debounce : debounce['default']);
					} else {
						scope.select({activeIdx: activeIdx, evt: evt});
					}
				};
			}
		};
	}])

	.directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function ($templateRequest, $compile, $parse) {
		return {
			scope: {
				index: '=',
				match: '=',
				query: '='
			},
			link: function (scope, element, attrs) {
				var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
				$templateRequest(tplUrl).then(function (tplContent) {
					var tplEl = angular.element(tplContent.trim());
					element.replaceWith(tplEl);
					$compile(tplEl)(scope);
				});
			}
		};
	}])

	.filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function ($sce, $injector, $log) {
		var isSanitizePresent;
		isSanitizePresent = $injector.has('$sanitize');

		function escapeRegexp(queryToEscape) {
			// Regex: capture the whole query string and replace it with the string that will be used to match
			// the results, for example if the capture is "a" the result will be \a
			return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
		}

		function containsHtml(matchItem) {
			return /<.*>/g.test(matchItem);
		}

		return function (matchItem, query) {
			if (!isSanitizePresent && containsHtml(matchItem)) {
				$log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
			}
			matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
			if (!isSanitizePresent) {
				matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
			}
			return matchItem;
		};
	}]);

angular.module('ui.bootstrap.debounce', [])
/**
 * A helper, internal service that debounces a function
 */
	.factory('$$debounce', ['$timeout', function ($timeout) {
		return function (callback, debounceTime) {
			var timeoutPromise;

			return function () {
				var self = this;
				var args = Array.prototype.slice.call(arguments);
				if (timeoutPromise) {
					$timeout.cancel(timeoutPromise);
				}

				timeoutPromise = $timeout(function () {
					callback.apply(self, args);
				}, debounceTime);
			};
		};
	}]);

angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods for working with the DOM.
 * It is meant to be used where we need to absolute-position elements in
 * relation to another element (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
	.factory('$uibPosition', ['$document', '$window', function ($document, $window) {
		/**
		 * Used by scrollbarWidth() function to cache scrollbar's width.
		 * Do not access this variable directly, use scrollbarWidth() instead.
		 */
		var SCROLLBAR_WIDTH;
		/**
		 * scrollbar on body and html element in IE and Edge overlay
		 * content and should be considered 0 width.
		 */
		var BODY_SCROLLBAR_WIDTH;
		var OVERFLOW_REGEX = {
			normal: /(auto|scroll)/,
			hidden: /(auto|scroll|hidden)/
		};
		var PLACEMENT_REGEX = {
			auto: /\s?auto?\s?/i,
			primary: /^(top|bottom|left|right)$/,
			secondary: /^(top|bottom|left|right|center)$/,
			vertical: /^(top|bottom)$/
		};
		var BODY_REGEX = /(HTML|BODY)/;

		return {

			/**
			 * Provides a raw DOM element from a jQuery/jQLite element.
			 *
			 * @param {element} elem - The element to convert.
			 *
			 * @returns {element} A HTML element.
			 */
			getRawNode: function (elem) {
				return elem.nodeName ? elem : elem[0] || elem;
			},

			/**
			 * Provides a parsed number for a style property.  Strips
			 * units and casts invalid numbers to 0.
			 *
			 * @param {string} value - The style value to parse.
			 *
			 * @returns {number} A valid number.
			 */
			parseStyle: function (value) {
				value = parseFloat(value);
				return isFinite(value) ? value : 0;
			},

			/**
			 * Provides the closest positioned ancestor.
			 *
			 * @param {element} element - The element to get the offest parent for.
			 *
			 * @returns {element} The closest positioned ancestor.
			 */
			offsetParent: function (elem) {
				elem = this.getRawNode(elem);

				var offsetParent = elem.offsetParent || $document[0].documentElement;

				function isStaticPositioned(el) {
					return ($window.getComputedStyle(el).position || 'static') === 'static';
				}

				while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
					offsetParent = offsetParent.offsetParent;
				}

				return offsetParent || $document[0].documentElement;
			},

			/**
			 * Provides the scrollbar width, concept from TWBS measureScrollbar()
			 * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
			 * In IE and Edge, scollbar on body and html element overlay and should
			 * return a width of 0.
			 *
			 * @returns {number} The width of the browser scollbar.
			 */
			scrollbarWidth: function (isBody) {
				if (isBody) {
					if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
						var bodyElem = $document.find('body');
						bodyElem.addClass('uib-position-body-scrollbar-measure');
						BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
						BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
						bodyElem.removeClass('uib-position-body-scrollbar-measure');
					}
					return BODY_SCROLLBAR_WIDTH;
				}

				if (angular.isUndefined(SCROLLBAR_WIDTH)) {
					var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
					$document.find('body').append(scrollElem);
					SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
					SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
					scrollElem.remove();
				}

				return SCROLLBAR_WIDTH;
			},

			/**
			 * Provides the padding required on an element to replace the scrollbar.
			 *
			 * @returns {object} An object with the following properties:
			 *   <ul>
			 *     <li>**scrollbarWidth**: the width of the scrollbar</li>
			 *     <li>**widthOverflow**: whether the the width is overflowing</li>
			 *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
			 *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
			 *     <li>**heightOverflow**: whether the the height is overflowing</li>
			 *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
			 *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
			 *   </ul>
			 */
			scrollbarPadding: function (elem) {
				elem = this.getRawNode(elem);

				var elemStyle = $window.getComputedStyle(elem);
				var paddingRight = this.parseStyle(elemStyle.paddingRight);
				var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
				var scrollParent = this.scrollParent(elem, false, true);
				var scrollbarWidth = this.scrollbarWidth(scrollParent, BODY_REGEX.test(scrollParent.tagName));

				return {
					scrollbarWidth: scrollbarWidth,
					widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
					right: paddingRight + scrollbarWidth,
					originalRight: paddingRight,
					heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
					bottom: paddingBottom + scrollbarWidth,
					originalBottom: paddingBottom
				};
			},

			/**
			 * Checks to see if the element is scrollable.
			 *
			 * @param {element} elem - The element to check.
			 * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
			 *   default is false.
			 *
			 * @returns {boolean} Whether the element is scrollable.
			 */
			isScrollable: function (elem, includeHidden) {
				elem = this.getRawNode(elem);

				var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
				var elemStyle = $window.getComputedStyle(elem);
				return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
			},

			/**
			 * Provides the closest scrollable ancestor.
			 * A port of the jQuery UI scrollParent method:
			 * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
			 *
			 * @param {element} elem - The element to find the scroll parent of.
			 * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
			 *   default is false.
			 * @param {boolean=} [includeSelf=false] - Should the element being passed be
			 * included in the scrollable llokup.
			 *
			 * @returns {element} A HTML element.
			 */
			scrollParent: function (elem, includeHidden, includeSelf) {
				elem = this.getRawNode(elem);

				var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
				var documentEl = $document[0].documentElement;
				var elemStyle = $window.getComputedStyle(elem);
				if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
					return elem;
				}
				var excludeStatic = elemStyle.position === 'absolute';
				var scrollParent = elem.parentElement || documentEl;

				if (scrollParent === documentEl || elemStyle.position === 'fixed') {
					return documentEl;
				}

				while (scrollParent.parentElement && scrollParent !== documentEl) {
					var spStyle = $window.getComputedStyle(scrollParent);
					if (excludeStatic && spStyle.position !== 'static') {
						excludeStatic = false;
					}

					if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
						break;
					}
					scrollParent = scrollParent.parentElement;
				}

				return scrollParent;
			},

			/**
			 * Provides read-only equivalent of jQuery's position function:
			 * http://api.jquery.com/position/ - distance to closest positioned
			 * ancestor.  Does not account for margins by default like jQuery position.
			 *
			 * @param {element} elem - The element to caclulate the position on.
			 * @param {boolean=} [includeMargins=false] - Should margins be accounted
			 * for, default is false.
			 *
			 * @returns {object} An object with the following properties:
			 *   <ul>
			 *     <li>**width**: the width of the element</li>
			 *     <li>**height**: the height of the element</li>
			 *     <li>**top**: distance to top edge of offset parent</li>
			 *     <li>**left**: distance to left edge of offset parent</li>
			 *   </ul>
			 */
			position: function (elem, includeMagins) {
				elem = this.getRawNode(elem);

				var elemOffset = this.offset(elem);
				if (includeMagins) {
					var elemStyle = $window.getComputedStyle(elem);
					elemOffset.top -= this.parseStyle(elemStyle.marginTop);
					elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
				}
				var parent = this.offsetParent(elem);
				var parentOffset = {top: 0, left: 0};

				if (parent !== $document[0].documentElement) {
					parentOffset = this.offset(parent);
					parentOffset.top += parent.clientTop - parent.scrollTop;
					parentOffset.left += parent.clientLeft - parent.scrollLeft;
				}

				return {
					width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
					height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
					top: Math.round(elemOffset.top - parentOffset.top),
					left: Math.round(elemOffset.left - parentOffset.left)
				};
			},

			/**
			 * Provides read-only equivalent of jQuery's offset function:
			 * http://api.jquery.com/offset/ - distance to viewport.  Does
			 * not account for borders, margins, or padding on the body
			 * element.
			 *
			 * @param {element} elem - The element to calculate the offset on.
			 *
			 * @returns {object} An object with the following properties:
			 *   <ul>
			 *     <li>**width**: the width of the element</li>
			 *     <li>**height**: the height of the element</li>
			 *     <li>**top**: distance to top edge of viewport</li>
			 *     <li>**right**: distance to bottom edge of viewport</li>
			 *   </ul>
			 */
			offset: function (elem) {
				elem = this.getRawNode(elem);

				var elemBCR = elem.getBoundingClientRect();
				return {
					width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
					height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
					top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
					left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
				};
			},

			/**
			 * Provides offset distance to the closest scrollable ancestor
			 * or viewport.  Accounts for border and scrollbar width.
			 *
			 * Right and bottom dimensions represent the distance to the
			 * respective edge of the viewport element.  If the element
			 * edge extends beyond the viewport, a negative value will be
			 * reported.
			 *
			 * @param {element} elem - The element to get the viewport offset for.
			 * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
			 * of the first scrollable element, default is false.
			 * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
			 * be accounted for, default is true.
			 *
			 * @returns {object} An object with the following properties:
			 *   <ul>
			 *     <li>**top**: distance to the top content edge of viewport element</li>
			 *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
			 *     <li>**left**: distance to the left content edge of viewport element</li>
			 *     <li>**right**: distance to the right content edge of viewport element</li>
			 *   </ul>
			 */
			viewportOffset: function (elem, useDocument, includePadding) {
				elem = this.getRawNode(elem);
				includePadding = includePadding !== false ? true : false;

				var elemBCR = elem.getBoundingClientRect();
				var offsetBCR = {top: 0, left: 0, bottom: 0, right: 0};

				var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
				var offsetParentBCR = offsetParent.getBoundingClientRect();

				offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
				offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
				if (offsetParent === $document[0].documentElement) {
					offsetBCR.top += $window.pageYOffset;
					offsetBCR.left += $window.pageXOffset;
				}
				offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
				offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;

				if (includePadding) {
					var offsetParentStyle = $window.getComputedStyle(offsetParent);
					offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
					offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
					offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
					offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
				}

				return {
					top: Math.round(elemBCR.top - offsetBCR.top),
					bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
					left: Math.round(elemBCR.left - offsetBCR.left),
					right: Math.round(offsetBCR.right - elemBCR.right)
				};
			},

			/**
			 * Provides an array of placement values parsed from a placement string.
			 * Along with the 'auto' indicator, supported placement strings are:
			 *   <ul>
			 *     <li>top: element on top, horizontally centered on host element.</li>
			 *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
			 *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
			 *     <li>bottom: element on bottom, horizontally centered on host element.</li>
			 *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
			 *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
			 *     <li>left: element on left, vertically centered on host element.</li>
			 *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
			 *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
			 *     <li>right: element on right, vertically centered on host element.</li>
			 *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
			 *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
			 *   </ul>
			 * A placement string with an 'auto' indicator is expected to be
			 * space separated from the placement, i.e: 'auto bottom-left'  If
			 * the primary and secondary placement values do not match 'top,
			 * bottom, left, right' then 'top' will be the primary placement and
			 * 'center' will be the secondary placement.  If 'auto' is passed, true
			 * will be returned as the 3rd value of the array.
			 *
			 * @param {string} placement - The placement string to parse.
			 *
			 * @returns {array} An array with the following values
			 * <ul>
			 *   <li>**[0]**: The primary placement.</li>
			 *   <li>**[1]**: The secondary placement.</li>
			 *   <li>**[2]**: If auto is passed: true, else undefined.</li>
			 * </ul>
			 */
			parsePlacement: function (placement) {
				var autoPlace = PLACEMENT_REGEX.auto.test(placement);
				if (autoPlace) {
					placement = placement.replace(PLACEMENT_REGEX.auto, '');
				}

				placement = placement.split('-');

				placement[0] = placement[0] || 'top';
				if (!PLACEMENT_REGEX.primary.test(placement[0])) {
					placement[0] = 'top';
				}

				placement[1] = placement[1] || 'center';
				if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
					placement[1] = 'center';
				}

				if (autoPlace) {
					placement[2] = true;
				} else {
					placement[2] = false;
				}

				return placement;
			},

			/**
			 * Provides coordinates for an element to be positioned relative to
			 * another element.  Passing 'auto' as part of the placement parameter
			 * will enable smart placement - where the element fits. i.e:
			 * 'auto left-top' will check to see if there is enough space to the left
			 * of the hostElem to fit the targetElem, if not place right (same for secondary
			 * top placement).  Available space is calculated using the viewportOffset
			 * function.
			 *
			 * @param {element} hostElem - The element to position against.
			 * @param {element} targetElem - The element to position.
			 * @param {string=} [placement=top] - The placement for the targetElem,
			 *   default is 'top'. 'center' is assumed as secondary placement for
			 *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
			 *   <ul>
			 *     <li>top</li>
			 *     <li>top-right</li>
			 *     <li>top-left</li>
			 *     <li>bottom</li>
			 *     <li>bottom-left</li>
			 *     <li>bottom-right</li>
			 *     <li>left</li>
			 *     <li>left-top</li>
			 *     <li>left-bottom</li>
			 *     <li>right</li>
			 *     <li>right-top</li>
			 *     <li>right-bottom</li>
			 *   </ul>
			 * @param {boolean=} [appendToBody=false] - Should the top and left values returned
			 *   be calculated from the body element, default is false.
			 *
			 * @returns {object} An object with the following properties:
			 *   <ul>
			 *     <li>**top**: Value for targetElem top.</li>
			 *     <li>**left**: Value for targetElem left.</li>
			 *     <li>**placement**: The resolved placement.</li>
			 *   </ul>
			 */
			positionElements: function (hostElem, targetElem, placement, appendToBody) {
				hostElem = this.getRawNode(hostElem);
				targetElem = this.getRawNode(targetElem);

				// need to read from prop to support tests.
				var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
				var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');

				placement = this.parsePlacement(placement);

				var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
				var targetElemPos = {top: 0, left: 0, placement: ''};

				if (placement[2]) {
					var viewportOffset = this.viewportOffset(hostElem, appendToBody);

					var targetElemStyle = $window.getComputedStyle(targetElem);
					var adjustedSize = {
						width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
						height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
					};

					placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
						placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
							placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
								placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
									placement[0];

					placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
						placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
							placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
								placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
									placement[1];

					if (placement[1] === 'center') {
						if (PLACEMENT_REGEX.vertical.test(placement[0])) {
							var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
							if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
								placement[1] = 'left';
							} else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
								placement[1] = 'right';
							}
						} else {
							var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
							if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
								placement[1] = 'top';
							} else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
								placement[1] = 'bottom';
							}
						}
					}
				}

				switch (placement[0]) {
					case 'top':
						targetElemPos.top = hostElemPos.top - targetHeight;
						break;
					case 'bottom':
						targetElemPos.top = hostElemPos.top + hostElemPos.height;
						break;
					case 'left':
						targetElemPos.left = hostElemPos.left - targetWidth;
						break;
					case 'right':
						targetElemPos.left = hostElemPos.left + hostElemPos.width;
						break;
				}

				switch (placement[1]) {
					case 'top':
						targetElemPos.top = hostElemPos.top;
						break;
					case 'bottom':
						targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
						break;
					case 'left':
						targetElemPos.left = hostElemPos.left;
						break;
					case 'right':
						targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
						break;
					case 'center':
						if (PLACEMENT_REGEX.vertical.test(placement[0])) {
							targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
						} else {
							targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
						}
						break;
				}

				targetElemPos.top = Math.round(targetElemPos.top);
				targetElemPos.left = Math.round(targetElemPos.left);
				targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];

				return targetElemPos;
			},

			/**
			 * Provides a way for positioning tooltip & dropdown
			 * arrows when using placement options beyond the standard
			 * left, right, top, or bottom.
			 *
			 * @param {element} elem - The tooltip/dropdown element.
			 * @param {string} placement - The placement for the elem.
			 */
			positionArrow: function (elem, placement) {
				elem = this.getRawNode(elem);

				var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
				if (!innerElem) {
					return;
				}

				var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');

				var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
				if (!arrowElem) {
					return;
				}

				var arrowCss = {
					top: '',
					bottom: '',
					left: '',
					right: ''
				};

				placement = this.parsePlacement(placement);
				if (placement[1] === 'center') {
					// no adjustment necessary - just reset styles
					angular.element(arrowElem).css(arrowCss);
					return;
				}

				var borderProp = 'border-' + placement[0] + '-width';
				var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];

				var borderRadiusProp = 'border-';
				if (PLACEMENT_REGEX.vertical.test(placement[0])) {
					borderRadiusProp += placement[0] + '-' + placement[1];
				} else {
					borderRadiusProp += placement[1] + '-' + placement[0];
				}
				borderRadiusProp += '-radius';
				var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];

				switch (placement[0]) {
					case 'top':
						arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
						break;
					case 'bottom':
						arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
						break;
					case 'left':
						arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
						break;
					case 'right':
						arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
						break;
				}

				arrowCss[placement[1]] = borderRadius;

				angular.element(arrowElem).css(arrowCss);
			}
		};
	}]);
angular.module('ui.bootstrap.typeahead').run(function () {
	!angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>');
	angular.$$uibTypeaheadCss = true;
});
angular.module('ui.bootstrap.position').run(function () {
	!angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>');
	angular.$$uibPositionCss = true;
});

(function () {
	'use strict';

	angular.module('qbePortal').directive('uiSelectRequired', ['validationService',
		function (validationService) {

			return {
				require: 'ngModel',
				link: function (scope, element, attrs, ctrl) {

					var formIsSubmitted = false;

					scope.$on('broadcast-field-errors', function () {
						formIsSubmitted = true;
					});

					scope.$on('reset-field-errors', function () {
						formIsSubmitted = true;
					});

					ctrl.$validators.uiSelectRequired = function (modelValue, viewValue) {
						if (!modelValue || !modelValue.$select)
							return true;

						var value = ( modelValue.$select ) ? modelValue.$select.selected : null;
						var valid = value !== undefined;
						validationService.validateInput(element, ctrl, attrs.labelKey);

						if (valid) {
							if (ctrl.$error.required)
								delete ctrl.$error.required;
						} else {
							ctrl.$error.required = true;
						}

						if (ctrl.$error.uiSelectRequired)
							delete ctrl.$error.uiSelectRequired;

						var parent = element.parents('div.ctrl-holder');
						if (!parent || !parent[0]) return;
						parent = $(parent).first();

						if (valid) {
							parent.removeClass('is-error');
						} else if (ctrl.$dirty || formIsSubmitted) {
							parent.addClass('is-error');
						}

						return valid;
					};

					scope.$watch(ctrl.$validators.uiSelectRequired);
				}
			};
		}])
})();

angular.module("qbePortal").controller("BikeFormController", [
	"$rootScope",
	"$scope",
	"$state",
	"$stateParams",
	"$window",
	"userInputRepository",
	"serviceResponseRepository",
	"quoteOptions",
	"paymentService",
	"quoteModelFactory",
	"dynamicRouter",
	"portalServiceWrapper",
	"MAService",
	"labelService",
	"Util",
	"$q",
	"storage",
	"gtmService",
	"quoteRequestRepository",
	"tokenTimeoutService",
	"$compile",
	"smartLinkService",
	"campaignService",
	function (
		$rootScope,
		$scope,
		$state,
		$stateParams,
		$window,
		userInputRepository,
		serviceResponseRepository,
		quoteOptions,
		paymentService,
		quoteModelFactory,
		dynamicRouter,
		portalServiceWrapper,
		MAService,
		labelService,
		util,
		$q,
		storage,
		gtmService,
		quoteRequestRepository,
		tokenTimeoutService,
		$compile,
		smartLinkService,
		campaignService
	) {
		var $ctrl = this;

		//check if session function is embedded and append directive
		if ($window.qbe.fieldLabels != undefined) {
			if (angular.isObject($window.qbe.fieldLabels.sessionFunction))
				angular
					.element("div#phglobaloptions_0_divOptionsComponents")
					.after($compile("<div qb-ng-dialog></div>")($scope));
		}

		/**
		 * routing initialisation, enabling/disabling (hiding/showing) available routes
		 * testing for allowed routes and redirecting when not allowed
		 */
		function initialiseRouting() {
			storage.removeItem("policy-date-input");

			var stepConditions = {
				"bike.payment": function () {
					return $state.$current.name != "bike.done";
				},
				"bike.done": function () {
					return $state.$current.name == "bike.done";
				},
				"bike.policy-start-date": function () {
					return $state.$current.name == "bike.policy-start-date";
				},
			};
			dynamicRouter.initialise(
				$state.current.name,
				$state.$current.parent.name,
				stepConditions,
				markCompletedRouteCallback
			);
			$ctrl.title = dynamicRouter.getPageTitle();
			$ctrl.steps = dynamicRouter.getSteps();
		}

		function markCompletedRouteCallback(stateName) {
			storage.setItem("completed-step", stateName);
		}
		/** End of routing logic */

		$rootScope.$broadcast("loading-animation-end");
		$ctrl.elementName = "Form Controller";
		$ctrl.validationErrors = null;
		$ctrl.sections = {};
		$ctrl.state = $state;
		$ctrl.storage = storage;
		$ctrl.sideBarEmail = null;
		$ctrl.quoteModel = quoteModelFactory.create();
		$ctrl.saveOnExit = false;
		$ctrl.smartLink = null;

		$window.onbeforeunload = function (event) {
			exitSaveQuote();
			if ($ctrl.saveOnExit) {
				$rootScope.$digest();
				return "Are you sure you want to leave?";
			}
		};

		$scope.$on("session-save-quote", exitSaveQuote);

		function exitSaveQuote() {
			var emailAddress = angular
				.element("div")
				.find("[label-key=yourEmailAddress]")
				.val();

			if (dynamicRouter.getPageTitle() != "Payment") {
				if (
					$ctrl.quoteModel.email != null ||
					$ctrl.sideBarEmail != null ||
					emailAddress != ""
				) {
					if ($ctrl.quoteModel && $ctrl.quoteModel.quoteResult) {
						$ctrl.saveOnExit = true;
						var formData = getUserInput();
						var paymentFrequency = "everyyear";

						portalServiceWrapper.updateQuote(formData);

						portalServiceWrapper
							.saveQuote(paymentFrequency, {
								quote: "true",
							})
							.then(function () {
								$rootScope.$broadcast("session-redirect");
							})
							.catch(function () {
								$rootScope.$broadcast("session-redirect");
							});
					} else {
						$rootScope.$broadcast("session-redirect");
					}
				} else $rootScope.$broadcast("session-redirect");
			}
		}

		function getDefaultValues() {
			return {
				fromFullQuote: true,
				bikeForm: {
					getStarted: {
						policyStartDate: moment()
							.tz("Australia/Sydney")
							.format("DD/MM/YYYY"),
						personOrCompany: "person",
					},
					insuredExcessValue: {
						thirdPartyOrThirdPartyFireAndTheft: "standard",
						comprehensivePref: "market",
						voluntaryMotorcycleExcess: 0,
						excess: 0,
						flexiExcess: 0,
					},
				},
				paymentForm: {
					paymentDetails: {
						paymentOptions: "yearly",
					},
				},
			};
		}

		/**
		 * QbFormSections register themselves with the form controller.
		 * This is done automatically by the form section upon initialisation.
		 * @name : name of the form section
		 * @init : function callback initialise the section
		 * @getValueFn: function callback to get the value of the section.
		 */
		$ctrl.registerSection = function (name, init, getValueFn) {
			$ctrl.sections[name] = {
				initValue: init,
				getValue: getValueFn,
			};
		};

		/**
		 * Any generic breaking errors should broadcast 'error' to the rootScope. This will cause redirection
		 * to the main error page.
		 */
		$scope.$on("error", function (event, error) {
			$state.go("error", error);
		});

		/**
		 * calls MA Services to add marketing data.
		 */
		$scope.$on("perform-ma-service", function (event, triggeredBy) {
			performMAServices(triggeredBy);
		});

		$scope.$on("back", function () {
			gtmService.trackEvent("back");
			$ctrl.back();
		});

		$scope.$on("invalidate-quotes", invalidatePreviousQuote);

		function invalidatePreviousQuote() {
			serviceResponseRepository.update("quote", null);
			quoteRequestRepository.clearQuoteCredentials();
			storage.removeItem("policy-address");
		}

		/**
		 * message broadcasted by qbPaymentSummary to submit the form
		 */
		//hadles form submit from child elements
		$scope.$on("form-submit", function (event, formName) {
			$ctrl.submit($scope[formName]);
		});

		/**
		 * message broadcasted by qbPaymentSummary to save the form
		 */
		$scope.$on("sidebar-save-quote", function (event, data) {
			$ctrl.sideBarEmail = data;
			$ctrl.save();
		});

		/**
		 * message broadcasted by qbPaymentSummary to assign the email address
		 */
		 $scope.$on("sidebar-assign-mail", function (event, data) {
			if (data != "") $ctrl.sideBarEmail = data;
		});

		function requote(form) {
			var isValid = !form || form.$valid;
			var formData = getUserInput();
			
			if (isValid) {								
				gtmService.trackEvent("requote");
				$rootScope.$broadcast("loading-animation-start");
				getRequote(formData, null, function (resp) {
					$scope.$broadcast("reset-field-errors");
					$rootScope.$broadcast("loading-animation-end");
					$rootScope.$broadcast("quote-received", resp);
					$rootScope.$broadcast("selected-quote-changed");
				});
			} else {
				displayFormErrors();
			}
		}
		/**
		 * called from qbFormSection and any other panel that requires a requote based on new values.
		 */
		$scope.$on("requote", function (event, form) {			
			requote(form);
		});

		/**
		 * message broadcasted by qbFormSection.directive to move to a page
		 */
		$scope.$on("moveToPage", function (event, page) {
			$ctrl.moveToPage(page);
		});

		function prepopulateRetrievedQuote() {
			if ($stateParams.quoteNo && $stateParams.email) {
				gtmService.trackEvent("retrieve-quote");
				$rootScope.$broadcast("loading-animation-start");
				portalServiceWrapper
					.retrieveSavedQuote(
						$stateParams.quoteNo,
						$stateParams.email
					)
					.then(function (transformedQuote) {
						$q.all([
							portalServiceWrapper.refreshAddress(
								transformedQuote.address
							),
							portalServiceWrapper.refreshVehicleDetails(
								transformedQuote.motorcycleInfo.vgiId,
								storage.getItem('policy-start-date'))
						]).then(function (resps) {
							var bikeFormData = ($ctrl.formData.bikeForm = transformedQuote);
							var serviceResponse = storage.getItem(
								"service-response"
							);

							storage.setItem(
								"policy-address",
								serviceResponse.quote.policyAddress
							);

							if (!bikeFormData.aboutYourBike)
								bikeFormData.aboutYourBike = {};
							bikeFormData.aboutYourBike.address = resps[0].data;
							userInputRepository.update($ctrl.formData);
							storage.setItem("retrieve", true);
							if (
								moment()
									.tz("Australia/Sydney")
									.format("YYYY/MM/DD") >
								moment(serviceResponse.quote.periodStartDate)
									.tz("Australia/Sydney")
									.format("YYYY/MM/DD")
							) {
								storage.setItem(
									"policy-date-input",
									$ctrl.formData
								);
								$state.go(
									"bike.policy-start-date",
									{
										quoteNo: "",
										email: "",
									},
									{
										location: true,
										reload: true,
									}
								);
							} else {
								$state.go(
									"bike.bike",
									{
										quoteNo: "",
										email: "",
									},
									{
										location: true,
										reload: true,
									}
								);
							}
						});
					})
					.catch(function () {
						var expiredQuote = storage.getItem("expired-quote");
						if (expiredQuote.displayStatus == "Expired") {
							storage.removeItem("expired-quote");
							window.location.href = util.linkBuilder(
								window.qbe.fieldLabels.expiredQuoteRedirect
									.bikeExpired
							);
						}
					});
			}
		}

		function applyPromoCodeThroughLink() {
			if ($stateParams.promotionalCode) {
				var formData = $ctrl.formData;
				if (formData.bikeForm) {
					if (!formData.bikeForm.tellUsABitMore) {
						formData.bikeForm.tellUsABitMore = {};
					}
					formData.bikeForm.tellUsABitMore.promotionalCode =
						$stateParams.promotionalCode;
				}
			}
		}

		function getUserInput() {
			var formData = getFormInput();
			if (formData.bikeForm && formData.bikeForm.insuredExcessValue) {
				if (formData.bikeForm.insuredExcessValue.excess > 0) {
					formData.bikeForm.insuredExcessValue.flexiExcess = 
					formData.bikeForm.insuredExcessValue.excess - $ctrl.quoteModel.excess.standardExcess;
				}					
			}
			userInputRepository.update(formData);
			return userInputRepository.get(getDefaultValues());
		}

		function getFormInput() {
			var formData = {};
			for (var key in $ctrl.sections) {
				formData[key] = $ctrl.sections[key].getValue();
			}

			if ($ctrl.sideBarEmail != null) {
				if (
					formData.bikeForm.tellUsABitMore &&
					formData.bikeForm.tellUsABitMore.yourEmailAddress
				)
					formData.bikeForm.tellUsABitMore.yourEmailAddress =
						$ctrl.sideBarEmail;
				if (
					formData.bikeForm.mainPolicyHolderContact &&
					formData.bikeForm.mainPolicyHolderContact.emailAddress1
				)
					formData.bikeForm.mainPolicyHolderContact.emailAddress1 =
						$ctrl.sideBarEmail;
			}

			return formData;
		}

		function displayFormErrors() {
			$scope.$broadcast("broadcast-field-errors");
			$ctrl.showErrorSummary = true;
			$scope.$broadcast("reset-field-errors");
			scrollViewTo($("#combinedValidationListing"));
		}

		$ctrl.submit = function (form) {
			$scope.$broadcast("form-submitted");
			$ctrl.showErrorSummary = false;
			isInvalid = form.$invalid;
			if (isInvalid) {
				displayFormErrors();
				return;
			}

			gtmService.trackEvent("next");

			setDefaultContactValuesIfRequired();

			$rootScope.$broadcast("loading-animation-start");

			var formData = getUserInput();
			
			//send quote to decline when isRegistered is NO
			if (formData.bikeForm.aboutYourBike.isRegistered === false) {
				//decline quote
				performMAServices("declined");
				storage.clear();
				redirectToDecline("decline", "Policy Was Declined");
				return;
			}

			var quickQuote = getQuickQuote(formData, function (resp) {
				$ctrl.quoteModel = quoteModelFactory.create();				
				var regoSearchDetails = serviceResponseRepository.getLastResponseFrom('regoSearch');
				if (regoSearchDetails && regoSearchDetails.goodRetailPrice === '0') {
					var quickQuoteResultList = resp.data;
					if (quickQuoteResultList && quickQuoteResultList.length > 0) {
						var quickQuoteResult = quickQuoteResultList[0];
						var motorcycles = quickQuoteResult.motorcycles;					
						if (motorcycles && motorcycles.length > 0) {
							//update goodRetailPrice when quickquote provided sumInsuredAmount
							regoSearchDetails.goodRetailPrice = motorcycles[0].sumInsuredAmount;
							serviceResponseRepository.update('regoSearch', regoSearchDetails);
						}
					}					
				}
				$rootScope.$broadcast("perform-ma-service", "next");
				proceedToNextStep(formData);
			});

			if (!quickQuote) {
				proceedToNextStep(formData);
			}
		};

		function setDefaultContactValuesIfRequired(formData) {
			var contactValuesRequired = ["bike.contact"];
			var testRequired =
				contactValuesRequired.indexOf($state.$current.name) >= 0;
			if (testRequired) {
				setDefaultContactValues();
			}
		}

		function testDeclineIfRequired(formData) {
			var declineTestRequiredFor = [
				"bike.riders",
				"bike.bike",
				"bike.quote",
			];
			var testRequired =
				declineTestRequiredFor.indexOf($state.$current.name) >= 0;
			if (testRequired) {
				testDecline(formData);
			}
		}

		function testDecline(formData) {
			portalServiceWrapper.updateQuote(formData);

			var declineQuoteOptions = quoteOptions.getTestQuoteDeclineOptions(
				$state.$current.name
			);
			//test quote decline and then check embargo
			var postcode = formData.bikeForm.aboutYourBike.address.postalCode;
			portalServiceWrapper.checkEmbargo(postcode, 'Bike')
			.then(function(resp) {
				if (resp) {
					//it is embargo
					performMAServices("declined");
					storage.clear();	
					var declineObj = {declineType: 'embargo'};
					redirectToDecline(declineObj, "Policy Was Declined");
				}
				else {
					portalServiceWrapper
					.testQuoteDecline(declineQuoteOptions)
					.catch(function (decline) {
						performMAServices("declined");
						storage.clear();
						redirectToDecline(decline, "Policy Was Declined");
					});	
				}
			});								
		}

		function redirectToDecline(decline) {
			var redirectPage = decline.declineType || "decline";
			$state.go(redirectPage, decline);
		}

		function saveQuoteIfRequired(formData) {
			saveQuoteNotRequiredFor = ["bike.bike", "bike.done"];
			var notRequired =
				saveQuoteNotRequiredFor.indexOf($state.$current.name) >= 0;
			if (!notRequired) {
				saveQuote(formData);
			}
		}

		function triggerGoalCompleteQuoteIfRequired() {
			if ($state.$current.name == "bike.done") {
				var userInputFromRepo = quoteRequestRepository.getUserInput();
				if (!userInputFromRepo || !userInputFromRepo.email) {
					var formData = getUserInput();
					quoteRequestRepository.update(formData);
				}				
				portalServiceWrapper.triggerGoalCompleteQuote();
			}
		}

		function getRequote(formData, page, callback) {
			portalServiceWrapper.updateQuote(formData);
			var requoteOptions =
				page == "payment"
					? quoteOptions.getRequoteOptions("bike.payment")
					: quoteOptions.getRequoteOptions();
			if (requoteOptions) {
				portalServiceWrapper
					.getQuickQuote(
						requoteOptions.permutations,
						requoteOptions.rules
					)
					.then(function (resp) {
						if (callback) callback(resp);
					})
					.catch(function (err) {
						void 0;
						broadcastError(err, "Requote error");
					});
			} else {
				return false;
			}
			return true;
		}

		function getQuickQuote(formData, callback) {
			portalServiceWrapper.updateQuote(formData);
			var quickQuoteOptions = quoteOptions.getQuickQuoteOptionsForStep(
				$state.current.name
			);
			if (quickQuoteOptions) {
				portalServiceWrapper
					.getQuickQuote(
						quickQuoteOptions.permutations,
						quickQuoteOptions.rules
					)
					.then(function (resp) {
						if (callback) callback(resp);
					})
					.catch(function (err) {
						broadcastError(err, "getQuickQuote error");
					});
			} else {
				return false;
			}
			return true;
		}

		function broadcastError(err, msg) {
			$rootScope.$broadcast("error", {
				errorMessage: msg,
				response: err,
			});
		}

		function saveQuote(formData, callback) {
			portalServiceWrapper.updateQuote(formData);

			var paymentFrequency = quoteOptions.getSelectedPaymentFrequencyForService();

			portalServiceWrapper
				.saveQuote(paymentFrequency)
				.then(function (resp) {
					if (callback) callback(resp);
					// If quoteId found and email found, triggerGoal service quote
					var qr = quoteRequestRepository.getSaveQuoteRequest(paymentFrequency);
					void 0;
					if (qr && qr.quoteID && qr.email) {
						portalServiceWrapper.triggerGoalSaveQuote();
					}
					return resp;
				})
				.catch(function (err) {
					if (tokenTimeoutService.isSessionTimedout()) {
						tokenTimeoutService.handleTimeout();
					} else {
						broadcastError(err, "Save quote error");
					}
					return err;
				});
		}

		function proceedToNextStep(formData) {
			$rootScope.$broadcast("loading-animation-start");
			saveQuoteIfRequired(formData);
			testDeclineIfRequired(formData);
			$state.go(dynamicRouter.next(markCompletedRouteCallback));
		}

		function performMAServices(eventName) {
			getUserInput();
			var mainPolicyHolder = userInputRepository.get(
				{},
				"bikeForm.mainPolicyHolder"
			);
			var policyEmail = userInputRepository.get({}, "email");
			var quoteResult = quoteOptions.getSelectedQuoteResult();
			var savedQuote = serviceResponseRepository.getLastResponseFrom(
				"quote"
			);
			var quoteModel = $ctrl.quoteModel;
			var maData = {
				state: quoteModel ? quoteModel.state : null,
				postCode: quoteModel ? quoteModel.postCode : null,
				campaignCode: quoteModel ? quoteModel.campaignCode : null,
				noClaimBonus: quoteModel ? quoteModel.noClaimBonus : null,
				pageName: $state.current.name,
				mainPolicyHolder: mainPolicyHolder,
				policyEmail: policyEmail,
				annualResult: quoteResult ? quoteResult.getAnnual() : null,
				monthlyResult: quoteResult ? quoteResult.getMonthly() : null,
				quoteId: savedQuote ? savedQuote.quoteID : null,
			};

			if ($state.current.name == "bike.done") {
				maData.inceptionDate = moment()
					.tz("Australia/Sydney")
					.format("DD/MM/YYYY");
			}

			if (
				quoteModel &&
				quoteModel.address &&
				quoteModel.address.addressLine1
			) {
				maData.address =
					quoteModel.address.addressLine1 +
					" " +
					quoteModel.address.city;
			}

			if (
				quoteModel &&
				quoteModel.gtmPolicyHolder &&
				quoteModel.gtmPolicyHolder.phoneNumber
			) {
				maData.contactNumber = quoteModel.gtmPolicyHolder.phoneNumber;
			}

			MAService.mergeContacts(eventName, maData);
		}

		// Payments

		/**
		 * Scrolls a field into view when an error is clicked
		 * @param {Object} error                    Error object with key `name`
		 */
		$ctrl.showInView = function (error) {
			//console.log(error);
			scrollViewTo($('[name="' + error.name + '"]'));
		};

		function scrollViewTo($element) {
			var offset = $element.offset();
			if (offset) {
				$("html, body").animate({
					scrollTop: offset.top - 50,
					scrollLeft: offset.left,
				});
			}
		}

		/**
		 * determines if a quote is available to enable save button.
		 */
		$ctrl.isSaveButtonEnabled = function () {
			var formData = getUserInput();
			return formData.rapidEstimateUrl != null;
		};

		$ctrl.isQuoteAvailable = function () {
			return quoteOptions.getSelectedQuoteResult() !== null;
		};

		/**
		 * Takes care of
		 * - registering the labels generated by sitecore
		 * - setting default values
		 * - prepopulating retrieve quote if required.
		 */
		$ctrl.initPage = function () {
			initialiseRouting();

			util.dispatchCustomEvent("register-labels");
			$ctrl.formData = getUserInput();
			overwritePromoCodeFromQueryString();
			var currentPageName = $ctrl.state.current.name;
			$ctrl.displayBack =
				$ctrl.formData.rapidEstimateUrl != null ||
				currentPageName != "bike.bike";
			if (
				$ctrl.formData.rapidEstimateUrl &&
				currentPageName === "bike.bike"
			) {
				invalidatePreviousQuote();
			}
			triggerGoalCompleteQuoteIfRequired();
			prepopulateRetrievedQuote();
			applyPromoCodeThroughLink();
		};

		function overwritePromoCodeFromQueryString() {
			var promoCode = util.getQueryStringByName(
				window.location,
				"promotionalCode"
			);
			if (promoCode) {
				$ctrl.formData.promotionalCode =
					$ctrl.formData.promotionalCode || {};
				$ctrl.formData.promotionalCode.promotionalCode = promoCode;
			}
		}

		$ctrl.initQuotePage = function () {
			$ctrl.initPage();
			var selectedCoverType = quoteOptions.getSelectedCoverType();
			var formData = getUserInput(),
				form = formData.bikeForm;

			// getRequote(formData);
			$scope.$broadcast("requote");

			if (!form.insuredExcessValue) form.insuredExcessValue = {};

			form.saveOnPremium = form.saveOnPremium || {};
			form.saveOnPremium.saveOnYourPremium = selectedCoverType.subType;

			if (selectedCoverType.superType == "third_party")
				form.insuredExcessValue.thirdPartyOrThirdPartyFireAndTheft =
					selectedCoverType.subType;

			$ctrl.formData.bikeForm = form;
		};

		$ctrl.initContact = function () {
			$ctrl.initPage();
			setDefaultContactValues();
		};

		function setDefaultContactValues() {
			var formData = getUserInput(),
				form = formData.bikeForm,
				postalAddress = storage.getItem("policy-address");

			if (form.getStarted.personOrCompany === "person") {
				form.mainPolicyHolder = form.mainPolicyHolder || {};
				if (
					form.mainPolicyHolder.isMainRiderMainPolicyHolder !== false
				) {
					form.mainPolicyHolder.isMainRiderMainPolicyHolder = true;
					form.mainPolicyHolder.title =
						form.mainPolicyHolder.title ||
						form.rider.riders[0].person.title;
					form.mainPolicyHolder.firstName =
						form.rider.riders[0].person.firstName;
					form.mainPolicyHolder.lastName =
						form.rider.riders[0].person.lastName;
					form.mainPolicyHolder.gender =
						form.rider.riders[0].person.gender;
					form.mainPolicyHolder.dateOfBirth =
						form.rider.riders[0].person.dateOfBirth;

					form.mainPolicyHolder.threeYears_restrictedSuspendedDisqualifiedCancelled =
						form.rider.riders[0].threeYears_restrictedSuspendedDisqualifiedCancelled;
					form.mainPolicyHolder.threeYears_restrictedSuspendedDisqualifiedCancelledDetails =
						form.rider.riders[0].threeYears_restrictedSuspendedDisqualifiedCancelledDetails;

					form.mainPolicyHolder.threeYears_accidentsClaims =
						form.rider.riders[0].threeYears_accidentsClaims;
					form.mainPolicyHolder.threeYears_accidentsClaimsDetails =
						form.rider.riders[0].threeYears_accidentsClaimsDetails;

					form.mainPolicyHolder.fiveYears_chargedOrConvicted =
						form.rider.riders[0].fiveYears_chargedOrConvicted;
					form.mainPolicyHolder.fiveYears_chargedOrConvictedDetails =
						form.rider.riders[0].fiveYears_chargedOrConvictedDetails;

					form.mainPolicyHolderContact =
						form.mainPolicyHolderContact || {};
					form.mainPolicyHolderContact.postalOption =
						form.mainPolicyHolderContact.postalOption || true;
					form.mainPolicyHolderContact.emailAddress1 =
						form.mainPolicyHolderContact.emailAddress1 ||
						formData.email;
					form.mainPolicyHolderContact.primaryPhone =
						form.mainPolicyHolderContact.primaryPhone || "mobile";
				}

				if (
					!!form.mainPolicyHolderContact &&
					!form.mainPolicyHolderContact.address
				) {
					form.mainPolicyHolderContact.address =
						form.aboutYourBike.address;
				}

				if (Object.keys(postalAddress).length > 0) {
					if (
						postalAddress.addressLine1 !==
							form.mainPolicyHolderContact.address.addressLine1 &&
						postalAddress.postalCode !==
							form.mainPolicyHolderContact.address.postalCode
					) {
						form.mainPolicyHolderContact.postalOption = false;
						form.mainPolicyHolderContact.postalAddress = postalAddress;
					}
				}
			}

			if (form.getStarted.personOrCompany === "company") {
				form.aboutCompany = form.aboutCompany || {};
				form.aboutCompany.name = form.aboutCompany.name || "";
				form.aboutCompany.abn = form.aboutCompany.abn || "";
				form.aboutCompany.email = form.aboutCompany.email || "";
				form.aboutCompany.officePhone =
					form.aboutCompany.officePhone || "";
				form.aboutCompany.companyAddress =
					form.aboutCompany.companyAddress || undefined;

				form.companyContact = form.companyContact || {};
				form.companyContact.postalOption =
					form.companyContact.companyContactDetailsPostalOption ||
					true;
				form.companyContact.companyContactTitle =
					util.capitalize(form.companyContact.companyContactTitle) ||
					form.rider.riders[0].person.title;
				form.companyContact.companyContactFirstName =
					form.companyContact.companyContactFirstName ||
					form.rider.riders[0].person.firstName;
				form.companyContact.companyContactLastName =
					form.companyContact.companyContactLastName ||
					form.rider.riders[0].person.lastName;
				form.companyContact.companyContactGender =
					parseGender(form.companyContact.companyContactGender) ||
					form.rider.riders[0].person.gender;
				form.companyContact.companyContactDateOfBirth =
					form.companyContact.companyContactDateOfBirth ||
					form.rider.riders[0].person.dateOfBirth;
				form.companyContact.companyContactDetailsAddress =
					form.companyContact.companyContactDetailsAddress ||
					form.aboutYourBike.address;
				form.companyContact.companyContactDetailsEmail =
					form.companyContact.companyContactDetailsEmail ||
					formData.email;
				form.companyContact.companyContactDetailsPostalAddress =
					form.companyContact.companyContactDetailsPostalAddress ||
					undefined;
				form.companyContact.primaryPhone =
					form.companyContact.primaryPhone || "mobile";
				form.companyContact.preferredNumber =
					form.companyContact.preferredNumber || "";
				form.companyContact.passwordQuestion = !!form.companyContact
					.enterAQuestion
					? "customerCreatedQuestion"
					: "" || "";
				form.companyContact.enterAQuestion =
					form.companyContact.enterAQuestion || "";
				form.companyContact.passwordAnswer =
					form.companyContact.passwordAnswer || "";

				if (Object.keys(postalAddress).length > 0) {
					if (
						postalAddress.addressLine1 !==
							form.companyContact.companyContactDetailsAddress
								.addressLine1 &&
						postalAddress.postalCode !==
							form.companyContact.companyContactDetailsAddress
								.postalCode
					) {
						form.companyContact.postalOption = false;
					}
				}
			}

			$ctrl.formData.bikeForm = form;
		}

		function parseGender(gender) {
			if (gender === "F") {
				return "female";
			} else if (gender === "I") {
				return "intersex";
			} else return "male";
		}

		function constructDonePageViewModel() {
			var done = {
				policyNumber: $stateParams.policyNumber,
				accountNumber: $stateParams.accountNumber,
				isAwaitingProcess: $stateParams.isAwaitingProcess,
				policyType: quoteOptions.getSelectedCoverType().label,
				policyStartDate: $ctrl.quoteModel.policyStartDate,
				showYearMakeModelInSummary: false,
				smartLinkURL: $window.qbe.fieldLabels.smartLink.url,
				hashKey: $window.qbe.fieldLabels.smartLink.hashKey,
				email: $ctrl.quoteModel.email,
				description: "Motorcycle Insurance",
				productRefs: "Motorcycle Insurance",
			};

			var regoNumber = $ctrl.quoteModel.regoNumber || "";
			if (
				$ctrl.quoteModel.bikeForm.tellUsYourRegoNumber &&
				$ctrl.quoteModel.bikeForm.tellUsYourRegoNumber.regoNumber
			) {
				done.showYearMakeModelInSummary = true;
			}

			done.regoNumber = regoNumber.toUpperCase();

			if ($ctrl.quoteModel.bikeForm.aboutYourBike.regoDetails) {
				var year =
						$ctrl.quoteModel.bikeForm.aboutYourBike.regoDetails
							.modelYear,
					make =
						$ctrl.quoteModel.bikeForm.aboutYourBike.regoDetails
							.make,
					model =
						$ctrl.quoteModel.bikeForm.aboutYourBike.regoDetails
							.model;

				done.yearMakeModel = year + " " + make + " " + model;
			}

			if ($ctrl.quoteModel.bikeForm.mainPolicyHolder) {
				done.policyHolderName =
					$ctrl.quoteModel.bikeForm.mainPolicyHolder.firstName +
					" " +
					$ctrl.quoteModel.bikeForm.mainPolicyHolder.lastName;
			} else if ($ctrl.quoteModel.bikeForm.companyContact) {
				done.policyHolderName =
					$ctrl.quoteModel.bikeForm.companyContact.firstName +
					" " +
					$ctrl.quoteModel.bikeForm.companyContact.lastName;
				done.email = $ctrl.quoteModel.bikeForm.companyContact.email;
			}

			done.purchaseDate = moment()
				.tz("Australia/Sydney")
				.format("DD/MM/YYYY");
			return done;
		}

		$ctrl.initDonePage = function () {
			$ctrl.initPage();

			var quoteModel = $ctrl.quoteModel;
			var done = storage.getItem("done");
			if (!done || !done.policyNumber) {
				done = constructDonePageViewModel();
				$ctrl.smartLink = smartLinkService.generateLink(done);
				gtmService.trackTransaction(
					$state.current,
					done,
					$ctrl.quoteModel
				);
				performMAServices("paid");
			}

			$ctrl.storage.clear();
			storage.setItem("done", done);
			var $columns = $(".columns").get(0);
			$columns.classList.remove("print-ready");
			$ctrl.done = done;
			$ctrl.done.campaignSteps = {};

			// check if campaign code is valid
			if (
				quoteModel.quoteResult.response.isCampaignCodeValid ||
				quoteModel.quoteResult.response.isGiftCardApplied
			) {
				// get campaign next steps
				$ctrl.done.campaignSteps = campaignService.getCampaignConfig(
					quoteModel.quoteResult.response.campaignCode,
					true
				);
			} else $ctrl.done.campaignSteps.isCampaignCodeValid = false;
		};

		$scope.$on("submit-feedback", submitFeedback);

		function submitFeedback() {
			if ($ctrl.done.policyNumber != null && $ctrl.smartLink != null) {
				window.open($ctrl.smartLink, "_blank");
			} else {
				void 0;
			}
		}

		// TODO: fix this to not use timeout
		setTimeout(function () {
			QBE.expandCollapse.init();
		}, 1000);

		$ctrl.clear = function () {
			$scope.$broadcast("clear");
		};

		$ctrl.save = function () {
			$ctrl.title = dynamicRouter.getPageTitle();

			$ctrl.showErrorSummary = false;
			isInvalid = $scope.bikeForm.$invalid;
			if (isInvalid) {
				$scope.$broadcast("broadcast-field-errors");
				$ctrl.showErrorSummary = true;
				$scope.$broadcast("reset-field-errors");
				scrollViewTo($("#combinedValidationListing"));
				return;
			}

			getUserInput();
			$rootScope.$broadcast("open-modal", {
				modal: "saveQuote",
			});
		};

		$ctrl.back = function () {
			gtmService.trackEvent("back");
			$scope.$root.$broadcast("hide-top-banner");
			$scope.$broadcast("reset-field-errors");
			var backState = dynamicRouter.back();
			if (backState) $state.go(backState);
			else {
				var formData = getUserInput();
				if (formData.rapidEstimateUrl)
					window.location.href = formData.rapidEstimateUrl;
			}
		};

		$ctrl.moveToStep = function (step) {
			$state.go(dynamicRouter.getState(step));
		};
		$ctrl.moveToPage = function (page) {
			$state.go(page);
		};
	},
]);

angular.module('qbePortal.rapidEstimate.bike')
	.controller('BikeRapidEstimateController', [
		'$scope',
		'$state',
		'userInputRepository',
		'labelService',
		'portalServiceWrapper',
		'quoteOptions',
		'Util',
		'serviceResponseRepository',
		'gtmService',
		'$sce',
		function($scope, $state, userInputRepository, labelService, portalServiceWrapper, quoteOptions, util, serviceResponseRepository, gtmService, $sce) {
			var vm = this;
			vm.formData = {};
			vm.promoCode = util.getQueryStringByName(window.location, 'promotionalCode') ;
			void 0 ; 
			vm.elementName = 'Form Controller';
			vm.validationErrors = null;
			vm.sections = {};

			vm.initPage= function() {
				util.dispatchCustomEvent('register-labels');
				vm.formData = userInputRepository.get({
					bikeForm: {
						tellUsMore: {
							promotionalCode: vm.promoCode
						}
					}
				});
			}

			

			vm.registerSection = function (name, init, getValueFn) {
				vm.sections[name] = getValueFn;
			}

			// Submit form to get quickQuote
			vm.submit = function(event, form) {
				event.preventDefault();

				gtmService.trackEvent('rapid-estimate-submit') ;

				vm.showErrorSummary = false;
				isInvalid = form.$invalid;

				if (isInvalid) {
					$scope.$broadcast('broadcast-field-errors');
					vm.showErrorSummary = true;
					$scope.$broadcast('reset-field-errors');
					scrollViewTo($('#combinedValidationListing')) ;
					void 0;
					return;
				}

				$scope.$root.$broadcast('loading-animation-start');

				// Populate formData
				var formData = {};
				for (var key in this.sections) {
					formData[key] = this.sections[key]();
				}
				var now = moment().tz("Australia/Sydney").format('DD/MM/YYYY');
				formData.bikeForm.getStarted = {
					personOrCompany: 'person',
					policyStartDate: now
				};
				formData.bikeForm.rider.riders = [];
				formData.bikeForm.rider.riders[0] = {
					person: util.deepClone(formData.bikeForm.rider)
				};

				if(formData.bikeForm.tellUsMore) {
					formData.email = formData.bikeForm.tellUsMore.email;
					formData.bikeForm.promotionalCode = {
						promotionalCode: formData.bikeForm.tellUsMore.promotionalCode
					};
				}

				userInputRepository.update(formData);

				portalServiceWrapper.updateQuote(formData);

				var quickQuoteOptions = quoteOptions.getQuickQuoteOptionsForStep('rapidEstimate') ;

				portalServiceWrapper.getQuickQuote(quickQuoteOptions.permutations, quickQuoteOptions.rules)
					.then(function(resp) {
						vm.applyFormPath = this.endpointUrls.estimateRedirect;
						var quoteResults = serviceResponseRepository.getLastResponseFrom('quickQuote') ;
						serviceResponseRepository.update('rapidEstimate' , quoteResults ) ;
						$scope.$root.$broadcast('process-rapid-estimates', {
							formData: formData,
							results : quoteResults,
						});
					})
					.catch(function(err) {
						$scope.$root.$broadcast('error', {
							errorMessage: 'getQuickQuote error',
							response: err
						});
					});

			};

			/**
			 * Scrolls a field into view when an error is clicked
			 * @param {Object} error                    Error object with key `name`
			 */
			vm.showInView = function (error) {
				//console.log(error);
				scrollViewTo($('[name="' + error.name + '"]')) ;
			}

			function scrollViewTo($element) {
				var offset = $element.offset();
				if ( offset ) {
					$('html, body').animate({
						scrollTop: (offset.top - 50),
						scrollLeft: offset.left
					});
				}
			}

			vm.getSectionDescriptionFor = function (fieldName) {
				return $sce.trustAsHtml(labelService.getSectionDescriptionFor(fieldName));
			}

			// Scroll to estimates once they're loaded
			$scope.$root.$on('show-rapid-estimates', function() {
				vm.showRapidEstimatesPanel = true;
			});

			$scope.$root.$on('rapid-estimates-panel-initialised', function() {
		 		var rapidEstimateResults = serviceResponseRepository.getLastResponseFrom('rapidEstimate') ;
				if ( rapidEstimateResults ) {
					vm.applyFormPath = this.endpointUrls.estimateRedirect;
					$scope.$root.$broadcast('process-rapid-estimates', {
						results: rapidEstimateResults,
						formData: userInputRepository.get()
					});
				}
			});
		}
	]);

angular.module("qbePortal").controller("CaravanFormController", [
	"$rootScope",
	"$scope",
	"$state",
	"$stateParams",
	"$window",
	"userInputRepository",
	"serviceResponseRepository",
	"quoteOptions",
	"paymentService",
	"quoteModelFactory",
	"dynamicRouter",
	"portalServiceWrapper",
	"MAService",
	"labelService",
	"Util",
	"$q",
	"storage",
	"gtmService",
	"quoteRequestRepository",
	"tokenTimeoutService",
	"$compile",
	"smartLinkService",
	"campaignService",
	function (
		$rootScope,
		$scope,
		$state,
		$stateParams,
		$window,
		userInputRepository,
		serviceResponseRepository,
		quoteOptions,
		paymentService,
		quoteModelFactory,
		dynamicRouter,
		portalServiceWrapper,
		MAService,
		labelService,
		util,
		$q,
		storage,
		gtmService,
		quoteRequestRepository,
		tokenTimeoutService,
		$compile,
		smartLinkService,
		campaignService
	) {
		var $ctrl = this;

		//check if session function is embedded and append directive
		if ($window.qbe.fieldLabels != undefined) {
			if (angular.isObject($window.qbe.fieldLabels.sessionFunction))
				angular
					.element("div#phglobaloptions_0_divOptionsComponents")
					.after($compile("<div qb-ng-dialog></div>")($scope));
		}

		/**
		 * routing initialisation, enabling/disabling (hiding/showing) available routes
		 * testing for allowed routes and redirecting when not allowed
		 */
		function initialiseRouting() {
			storage.removeItem("policy-date-input");

			var stepConditions = {
				"caravan.payment": function () {
					return $state.$current.name != "caravan.done";
				},
				"caravan.done": function () {
					return $state.$current.name == "caravan.done";
				},
				"caravan.policy-start-date": function () {
					return $state.$current.name == "caravan.policy-start-date";
				},
			};
			dynamicRouter.initialise(
				$state.current.name,
				$state.$current.parent.name,
				stepConditions,
				markCompletedRouteCallback
			);
			$ctrl.title = dynamicRouter.getPageTitle();
			$ctrl.steps = dynamicRouter.getSteps();
		}

		function markCompletedRouteCallback(stateName) {
			storage.setItem("completed-step", stateName);
		}
		/** End of routing logic */

		$rootScope.$broadcast("loading-animation-end");
		$ctrl.elementName = "Form Controller";
		$ctrl.validationErrors = null;
		$ctrl.sections = {};
		$ctrl.state = $state;
		$ctrl.storage = storage;
		$ctrl.sideBarEmail = null;
		$ctrl.quoteModel = quoteModelFactory.create();
		$ctrl.saveOnExit = false;
		$ctrl.smartLink = null;
		$ctrl.goToNextStep = true;

		$window.onbeforeunload = function (event) {
			exitSaveQuote();
			if ($ctrl.saveOnExit) {
				$rootScope.$digest();
				return "Are you sure you want to leave?";
			}
		};

		$scope.$on("session-save-quote", exitSaveQuote);

		function exitSaveQuote() {
			var emailAddress = angular
				.element("div")
				.find("[label-key=yourEmailAddress]")
				.val();

			if (dynamicRouter.getPageTitle() != "Payment") {
				if (
					$ctrl.quoteModel.email != null ||
					$ctrl.sideBarEmail != null ||
					emailAddress != ""
				) {
					if ($ctrl.quoteModel && $ctrl.quoteModel.quoteResult) {
						$ctrl.saveOnExit = true;
						var formData = getUserInput();
						var paymentFrequency = "everyyear";

						portalServiceWrapper.updateQuote(formData);

						portalServiceWrapper
							.saveQuote(paymentFrequency, {
								quote: "true",
							})
							.then(function () {
								$rootScope.$broadcast("session-redirect");
							})
							.catch(function () {
								$rootScope.$broadcast("session-redirect");
							});
					} else {
						$rootScope.$broadcast("session-redirect");
					}
				} else $rootScope.$broadcast("session-redirect");
			}
		}

		function getDefaultValues() {
			var defaultValues = {
				fromFullQuote: true,
				caravanForm: {
					getStarted: {
						policyStartDate: moment()
							.tz("Australia/Sydney")
							.format("DD/MM/YYYY"),
					},
					aboutYourCaravan: {
						vehicleType: "caravan",
					},
					discountOptions: {
						discountLayup: false,
						onSiteDiscount: false,
					},
					saveOnPremium: {
						saveOnYourPremium: "standard",
					},
					mainPolicyHolderContact: {
						primaryPhone: "mobile",
					},
				},
			};

			var defaultStateExcess = quoteOptions.getStateDefaultVoluntaryExcess(
				$ctrl.quoteModel.state
			);
			if (defaultStateExcess != null) {
				var tempObj = {
					caravanForm: {
						excess: {
							voluntaryVehicleExcess: defaultStateExcess,
						},
					},
				};
				defaultValues = Object.extend(defaultValues, tempObj);
			}
			return defaultValues;
		}

		/**
		 * QbFormSections register themselves with the form controller.
		 * This is done automatically by the form section upon initialisation.
		 * @name : name of the form section
		 * @init : function callback initialise the section
		 * @getValueFn: function callback to get the value of the section.
		 */
		$ctrl.registerSection = function (name, init, getValueFn) {
			$ctrl.sections[name] = {
				initValue: init,
				getValue: getValueFn,
			};
		};

		/**
		 * Any generic breaking errors should broadcast 'error' to the rootScope. This will cause redirection
		 * to the main error page.
		 */
		$scope.$on("error", function (event, error) {
			$state.go("error", error);
		});

		/**
		 * calls MA Services to add marketing data.
		 */
		$scope.$on("perform-ma-service", function (event, triggeredBy) {
			performMAServices(triggeredBy);
		});

		$scope.$on("back", function () {
			gtmService.trackEvent("back");
			$ctrl.back();
		});

		$scope.$on("invalidate-quotes", invalidatePreviousQuote);

		function invalidatePreviousQuote() {
			serviceResponseRepository.update("quote", null);
			quoteRequestRepository.clearQuoteCredentials();
			storage.removeItem("policy-address");
		}

		/**
		 * message broadcasted by qbPaymentSummary to submit the form
		 */
		//hadles form submit from child elements
		$scope.$on("form-submit", function (event, formName) {
			$ctrl.submit($scope[formName]);
		});

		/**
		 * message broadcasted by qbPaymentSummary to save the form
		 */
		$scope.$on("sidebar-save-quote", function (event, data) {
			$ctrl.sideBarEmail = data;
			$ctrl.save();
		});

		/**
		 * message broadcasted by qbPaymentSummary to assign the email address
		 */
		$scope.$on("sidebar-assign-mail", function (event, data) {
			if (data != "") $ctrl.sideBarEmail = data;
		});

		/**
		 * called from qbFormSection and any other panel that requires a requote based on new values.
		 */
		$scope.$on("requote", function (event, form) {
			var isValid = !form || form.$valid;
			var formData = getUserInput();
			if (isValid) {
				gtmService.trackEvent("requote");
				$rootScope.$broadcast("loading-animation-start");
				getRequote(formData, null, function (resp) {
					$scope.$broadcast("reset-field-errors");
					$rootScope.$broadcast("loading-animation-end");
					$rootScope.$broadcast("quote-received", resp);
					$rootScope.$broadcast("selected-quote-changed");
				});
			} else {
				displayFormErrors();
			}
		});

		/**
		 * message broadcasted by qbFormSection.directive to move to a page
		 */
		$scope.$on("moveToPage", function (event, page) {
			$ctrl.moveToPage(page);
		});

		function prepopulateRetrievedQuote() {
			if ($stateParams.quoteNo && $stateParams.email) {
				gtmService.trackEvent("retrieve-quote");
				$rootScope.$broadcast("loading-animation-start");
				portalServiceWrapper
					.retrieveSavedQuote(
						$stateParams.quoteNo,
						$stateParams.email
					)
					.then(function (transformedQuote) {
						void 0;
						$q.all([
							portalServiceWrapper.refreshAddress(
								transformedQuote.aboutYourCaravan.address
							),							
							portalServiceWrapper.refreshCaravanDetails(
								transformedQuote.caravanInfo.vgiId,
								storage.getItem('policy-start-date'))
						]).then(function (resps) {
							var caravanFormData = ($ctrl.formData.caravanForm = transformedQuote);
							var serviceResponse = storage.getItem(
								"service-response"
							);

							$ctrl.formData.email = $stateParams.email;

							storage.setItem(
								"policy-address",
								serviceResponse.quote.policyAddress
							);

							if (!caravanFormData.aboutYourCaravan)
								caravanFormData.aboutYourCaravan = {};
							caravanFormData.aboutYourCaravan.address =
								resps[0].data;
							userInputRepository.update($ctrl.formData);
							storage.setItem("retrieve", true);
							if (
								moment()
									.tz("Australia/Sydney")
									.format("YYYY/MM/DD") >
								moment(serviceResponse.quote.periodStartDate)
									.tz("Australia/Sydney")
									.format("YYYY/MM/DD")
							) {
								storage.setItem(
									"policy-date-input",
									$ctrl.formData
								);
								$state.go(
									"caravan.policy-start-date",
									{
										quoteNo: "",
										email: "",
									},
									{
										location: true,
										reload: true,
									}
								);
							} else {
								$state.go(
									"caravan.caravan",
									{
										quoteNo: "",
										email: "",
									},
									{
										location: true,
										reload: true,
									}
								);
							}
						});
					})
					.catch(function () {
						var expiredQuote = storage.getItem("expired-quote");
						if (expiredQuote.displayStatus == "Expired") {
							storage.removeItem("expired-quote");
							window.location.href = util.linkBuilder(
								window.qbe.fieldLabels.expiredQuoteRedirect
									.caravanExpired
							);
						}
					});
			}
		}

		function applyPromoCodeThroughLink() {
			if ($stateParams.promotionalCode) {
				var formData = $ctrl.formData;
				if (formData.caravanForm) {
					if (!formData.caravanForm.tellUsABitMore) {
						formData.caravanForm.tellUsABitMore = {};
					}
					formData.caravanForm.tellUsABitMore.promotionalCode =
						$stateParams.promotionalCode;
				}
			}
		}

		function getUserInput() {
			var formData = getFormInput();
			userInputRepository.update(formData);
			return userInputRepository.get(getDefaultValues());
		}

		function getFormInput() {
			var formData = {};
			for (var key in $ctrl.sections) {
				formData[key] = $ctrl.sections[key].getValue();
			}

			if ($ctrl.sideBarEmail != null) {
				if (
					formData.caravanForm.tellUsABitMore &&
					formData.caravanForm.tellUsABitMore.yourEmailAddress
				)
					formData.caravanForm.tellUsABitMore.yourEmailAddress =
						$ctrl.sideBarEmail;
				if (
					formData.caravanForm.mainPolicyHolderContact &&
					formData.caravanForm.mainPolicyHolderContact.emailAddress1
				)
					formData.caravanForm.mainPolicyHolderContact.emailAddress1 =
						$ctrl.sideBarEmail;
			}

			return formData;
		}

		function displayFormErrors() {
			$scope.$broadcast("broadcast-field-errors");
			$ctrl.showErrorSummary = true;
			$scope.$broadcast("reset-field-errors");
			scrollViewTo($("#combinedValidationListing"));
		}

		$ctrl.submit = function (form) {
			$scope.$broadcast("form-submitted");
			$ctrl.showErrorSummary = false;
			isInvalid = form.$invalid;
			if (isInvalid) {
				displayFormErrors();
				return;
			}

			gtmService.trackEvent("next");

			setDefaultContactValuesIfRequired();

			$rootScope.$broadcast("loading-animation-start");

			var formData = getUserInput();

			var quickQuote = getQuickQuote(formData, function () {
				$ctrl.quoteModel = quoteModelFactory.create();
				$rootScope.$broadcast("perform-ma-service", "next");
				proceedToNextStep(formData);
			});

			if (!quickQuote) {
				proceedToNextStep(formData);
			}
		};

		function setDefaultContactValuesIfRequired(formData) {
			var contactValuesRequired = ["caravan.contact"];
			var testRequired =
				contactValuesRequired.indexOf($state.$current.name) >= 0;
			if (testRequired) {
				setDefaultContactValues();
			}
		}

		function testDeclineIfRequired(formData) {
			var declineTestRequiredFor = [
				"caravan.drivers",
				"caravan.caravan",
				"caravan.quote",
				"caravan.contact",
			];
			var testRequired =
				declineTestRequiredFor.indexOf($state.$current.name) >= 0;
			if (testRequired) {
				testDecline(formData, nextStep);
			}
		}

		function testDecline(formData, callback) {
			portalServiceWrapper.updateQuote(formData);					
			
			var declineQuoteOptions = quoteOptions.getTestQuoteDeclineOptions(
				$state.$current.name
			);
			var postcode = formData.caravanForm.aboutYourCaravan.address.postalCode;
			portalServiceWrapper.checkEmbargo(postcode, 'Caravan')
			.then(function(resp) {
				if (resp) {
					//it is embargo
					performMAServices("declined");
					storage.clear();
					var declineObj = {declineType: 'embargo'};
					redirectToDecline(declineObj, "Policy Was Declined");
				}
				else {
					portalServiceWrapper
					.testQuoteDecline(declineQuoteOptions)
					.then(function (resp) {						
						// post testQuoteDecline
						if (
							angular.isDefined(
								resp.data[0].caravans[0].isEligibleforSDExemption
							)
						) {
							storage.setItem(
								"stamp-duty",
								resp.data[0].caravans[0].isEligibleforSDExemption
							);
						} else {
							storage.setItem("stamp-duty", false);
						}
						if ($ctrl.goToNextStep) callback();
					})
					.catch(function (decline) {
						performMAServices("declined");
						storage.clear();
						redirectToDecline(decline, "Policy Was Declined");
					});		
				}
			});
							
		}

		function redirectToDecline(decline) {
			var redirectPage = decline.declineType || "decline";
			$state.go(redirectPage, decline);
		}

		function saveQuoteIfRequired(formData) {
			saveQuoteNotRequiredFor = ["caravan.caravan", "caravan.done"];
			var notRequired =
				saveQuoteNotRequiredFor.indexOf($state.$current.name) >= 0;
			if (!notRequired) {
				saveQuote(formData);
			}
		}

		function getRequote(formData, page, callback) {
			portalServiceWrapper.updateQuote(formData);
			var requoteOptions =
				page == "payment"
					? quoteOptions.getRequoteOptions("caravan.payment")
					: quoteOptions.getRequoteOptions();
			if (requoteOptions) {
				portalServiceWrapper
					.getQuickQuote(
						requoteOptions.permutations,
						requoteOptions.rules
					)
					.then(function (resp) {
						if (callback) callback(resp);
					})
					.catch(function (err) {
						void 0;
						broadcastError(err, "Requote error");
					});
			} else {
				return false;
			}
			return true;
		}

		function getQuickQuote(formData, callback) {
			portalServiceWrapper.updateQuote(formData);
			var quickQuoteOptions = quoteOptions.getQuickQuoteOptionsForStep(
				$state.current.name
			);
			if (quickQuoteOptions) {
				portalServiceWrapper
					.getQuickQuote(
						quickQuoteOptions.permutations,
						quickQuoteOptions.rules
					)
					.then(function (resp) {
						if (callback) callback(resp);
					})
					.catch(function (err) {
						broadcastError(err, "getQuickQuote error");
					});
			} else {
				return false;
			}
			return true;
		}

		function broadcastError(err, msg) {
			$rootScope.$broadcast("error", {
				errorMessage: msg,
				response: err,
			});
		}

		function saveQuote(formData, callback) {
			portalServiceWrapper.updateQuote(formData);

			var paymentFrequency = quoteOptions.getSelectedPaymentFrequencyForService();

			portalServiceWrapper
				.saveQuote(paymentFrequency)
				.then(function (resp) {
					if (callback) callback(resp);
					var qr = quoteRequestRepository.getSaveQuoteRequest(paymentFrequency);
					if (qr && qr.quoteID && qr.email && $state.$current.name !== "caravan.done") {
						portalServiceWrapper.triggerGoalSaveQuote();
					}
					return resp;
				})
				.catch(function (err) {
					if (tokenTimeoutService.isSessionTimedout()) {
						tokenTimeoutService.handleTimeout();
					} else {
						$ctrl.goToNextStep = false;
						broadcastError(err, "Save quote error");
					}
					return err;
				});
		}

		function proceedToNextStep(formData) {
			$rootScope.$broadcast("loading-animation-start");
			saveQuoteIfRequired(formData);			
			testDeclineIfRequired(formData);
		}

		function nextStep() {
			$state.go(dynamicRouter.next(markCompletedRouteCallback));
		}

		function triggerGoalCompleteQuoteIfRequired() {
			if ($state.$current.name == "caravan.done") {
				var userInputFromRepo = quoteRequestRepository.getUserInput();
				if (!userInputFromRepo || !userInputFromRepo.email) {
					var formData = getUserInput();
					quoteRequestRepository.update(formData);
				}				
				portalServiceWrapper.triggerGoalCompleteQuote();
			}
		}

		function performMAServices(eventName) {
			getUserInput();
			var mainPolicyHolder = userInputRepository.get(
				{},
				"caravanForm.mainPolicyHolder"
			);
			var policyEmail = userInputRepository.get({}, "email");
			var quoteResult = quoteOptions.getSelectedQuoteResult();
			var savedQuote = serviceResponseRepository.getLastResponseFrom(
				"quote"
			);
			var quoteModel = $ctrl.quoteModel;
			var maData = {
				state: quoteModel ? quoteModel.state : null,
				postCode: quoteModel ? quoteModel.postCode : null,
				campaignCode: quoteModel ? quoteModel.campaignCode : null,
				noClaimBonus: quoteModel ? quoteModel.noClaimBonus : null,
				pageName: $state.current.name,
				mainPolicyHolder: mainPolicyHolder,
				policyEmail: policyEmail,
				annualResult: quoteResult ? quoteResult.getAnnual() : null,
				monthlyResult: quoteResult ? quoteResult.getMonthly() : null,
				quoteId: savedQuote ? savedQuote.quoteID : null,
			};

			if ($state.current.name == "caravan.done") {
				maData.inceptionDate = moment()
					.tz("Australia/Sydney")
					.format("DD/MM/YYYY");
			}

			if (
				quoteModel &&
				quoteModel.address &&
				quoteModel.address.addressLine1
			) {
				maData.address =
					quoteModel.address.addressLine1 +
					" " +
					quoteModel.address.city;
			}

			if (
				quoteModel &&
				quoteModel.mainPolicyHolder &&
				quoteModel.mainPolicyHolder.primaryPhoneNumber
			) {
				maData.contactNumber =
					quoteModel.mainPolicyHolder.primaryPhoneNumber;
			}

			MAService.mergeContacts(eventName, maData);
		}

		// Payments

		/**
		 * Scrolls a field into view when an error is clicked
		 * @param {Object} error                    Error object with key `name`
		 */
		$ctrl.showInView = function (error) {
			//console.log(error);
			scrollViewTo($('[name="' + error.name + '"]'));
		};

		function scrollViewTo($element) {
			var offset = $element.offset();
			if (offset) {
				$("html, body").animate({
					scrollTop: offset.top - 50,
					scrollLeft: offset.left,
				});
			}
		}

		/**
		 * determines if a quote is available to enable save button.
		 */
		$ctrl.isSaveButtonEnabled = function () {
			var formData = getUserInput();
			return formData.rapidEstimateUrl != null;
		};

		$ctrl.isQuoteAvailable = function () {
			return quoteOptions.getSelectedQuoteResult() !== null;
		};

		/**
		 * Takes care of
		 * - registering the labels generated by sitecore
		 * - setting default values
		 * - prepopulating retrieve quote if required.
		 */
		$ctrl.initPage = function () {
			initialiseRouting();
			util.dispatchCustomEvent("register-labels");
			$ctrl.formData = getUserInput();
			overwritePromoCodeFromQueryString();
			var currentPageName = $ctrl.state.current.name;
			$ctrl.displayBack =
				$ctrl.formData.rapidEstimateUrl != null ||
				currentPageName != "caravan.caravan";
			if (
				$ctrl.formData.rapidEstimateUrl &&
				currentPageName == "caravan.caravan"
			) {
				invalidatePreviousQuote();
			}
			triggerGoalCompleteQuoteIfRequired();
			prepopulateRetrievedQuote();
			applyPromoCodeThroughLink();
		};

		function overwritePromoCodeFromQueryString() {
			var promoCode = util.getQueryStringByName(
				window.location,
				"promotionalCode"
			);
			if (promoCode) {
				$ctrl.formData.promotionalCode =
					$ctrl.formData.promotionalCode || {};
				$ctrl.formData.promotionalCode.promotionalCode = promoCode;
			}
		}

		$ctrl.initDriversPage = function () {
			$ctrl.initPage();
			var formData = getUserInput(),
				form = formData.caravanForm;

			if (form.sumInsured == null) form.sumInsured = {};

			// Set agreed value default
			if (
				form.sumInsured.agreedValue === undefined &&
				form.aboutYourContents !== undefined &&
				form.aboutYourContents.agreedValue !== undefined
			)
				form.sumInsured.agreedValue =
					form.aboutYourContents.agreedValue;
			else if (form.caravanDetails)
				form.sumInsured.agreedValue = form.caravanDetails.purchasePrice;

			// Set annexe value default
			if (
				form.sumInsured.annexeReplacementCost === undefined &&
				form.aboutYourContents !== undefined &&
				form.aboutYourContents.annexeReplacementCost !== undefined
			)
				form.sumInsured.annexeReplacementCost =
					form.aboutYourContents.annexeReplacementCost;

			$ctrl.formData.caravanForm = form;
		};

		$ctrl.initQuotePage = function () {
			$ctrl.initPage();
			// var selectedCoverType = quoteOptions.getSelectedCoverType() ;
			// var formData = getUserInput(),
			// 	form = formData.bikeForm;
			//
			// // getRequote(formData);
			// $scope.$broadcast('requote') ;
			//
			// if ( ! form.insuredExcessValue )
			// 	form.insuredExcessValue = {} ;
			//
			// form.saveOnPremium = form.saveOnPremium || {} ;
			// form.saveOnPremium.saveOnYourPremium =  selectedCoverType.subType ;
			//
			// if ( selectedCoverType.superType == 'third_party')
			// 	form.insuredExcessValue.thirdPartyOrThirdPartyFireAndTheft = selectedCoverType.subType ;
			//
			// $ctrl.formData.bikeForm = form;
		};

		$ctrl.initContact = function () {
			$ctrl.initPage();
			setDefaultContactValues();
		};

		function setDefaultContactValues() {
			var formData = getUserInput(),
				form = formData.caravanForm,
				postalAddress = storage.getItem("policy-address");

			form.tellUsYourRegoNumber = form.tellUsYourRegoNumber || {};

			if ($ctrl.quoteModel.isCaravanRegistered) {
				form.tellUsYourRegoNumber.regoNumber =
					$ctrl.quoteModel.regoNumber;
			}

			form.mainPolicyHolder = form.mainPolicyHolder || {};

			if (form.mainPolicyHolder.isMainDriverMainPolicyHolder !== false) {
				form.mainPolicyHolder.isMainDriverMainPolicyHolder = true;

				form.mainPolicyHolder.title =
					form.mainPolicyHolder.title ||
					form.driver.drivers[0].person.title;
				form.mainPolicyHolder.firstName =
					form.driver.drivers[0].person.firstName;
				form.mainPolicyHolder.lastName =
					form.driver.drivers[0].person.lastName;
				form.mainPolicyHolder.gender =
					form.driver.drivers[0].person.gender;
				form.mainPolicyHolder.dateOfBirth =
					form.driver.drivers[0].person.dateOfBirth;

				form.mainPolicyHolder.fourYears_chargedOrConvictedOffences =
					form.driver.drivers[0].fourYears_chargedOrConvictedOffences;
				form.mainPolicyHolder.fourYears_chargedOrConvictedOffencesDetails =
					form.driver.drivers[0].fourYears_chargedOrConvictedOffencesDetails;

				form.mainPolicyHolder.fourYears_licenceRSDC =
					form.driver.drivers[0].fourYears_licenceRSDC;
				form.mainPolicyHolder.fourYears_licenceRSDCDetails =
					form.driver.drivers[0].fourYears_licenceRSDCDetails;

				form.mainPolicyHolder.fourYears_vehicleAccidentsClaims =
					form.driver.drivers[0].fourYears_vehicleAccidentsClaims;
				form.mainPolicyHolder.fourYears_vehicleAccidentsClaimsDetails =
					form.driver.drivers[0].fourYears_vehicleAccidentsClaimsDetails;

				form.mainPolicyHolder.tenYears_chargedOrConvictedOffences =
					form.driver.drivers[0].tenYears_chargedOrConvictedOffences;
				form.mainPolicyHolder.tenYears_chargedOrConvictedOffencesDetails =
					form.driver.drivers[0].tenYears_chargedOrConvictedOffencesDetails;

				form.mainPolicyHolderContact =
					form.mainPolicyHolderContact || {};
				form.mainPolicyHolderContact.postalOption = true;
				form.mainPolicyHolderContact.emailAddress1 = formData.email;
			}

			if (form.mainPolicyHolderContact.address == undefined) {
				form.mainPolicyHolderContact.address =
					form.aboutYourCaravan.address;
			}

			if (Object.keys(postalAddress).length > 0) {
				if (
					postalAddress.addressLine1 !==
						form.mainPolicyHolderContact.address.addressLine1 &&
					postalAddress.postalCode !==
						form.mainPolicyHolderContact.address.postalCode
				) {
					form.mainPolicyHolderContact.postalOption = false;
					form.mainPolicyHolderContact.postalAddress = postalAddress;
				}
			}

			$ctrl.formData.caravanForm = form;
		}

		function constructDonePageViewModel() {
			var regoNumber = $ctrl.quoteModel.regoNumber || "";

			var done = {
				vehicleType: $ctrl.quoteModel.vehicleType,
				policyNumber: $stateParams.policyNumber,
				accountNumber: $stateParams.accountNumber,
				isAwaitingProcess: $stateParams.isAwaitingProcess,
				policyType: quoteOptions.getSelectedCoverType().label,
				policyStartDate: $ctrl.quoteModel.policyStartDate,
				yearMakeModel: $ctrl.quoteModel.yearMakeModel,
				regoNumber: regoNumber.toUpperCase(),
				purchaseDate: moment()
					.tz("Australia/Sydney")
					.format("DD/MM/YYYY"),
				smartLinkURL: $window.qbe.fieldLabels.smartLink.url,
				hashKey: $window.qbe.fieldLabels.smartLink.hashKey,
				email: $ctrl.quoteModel.email,
				description: "Caravan Insurance",
				productRefs: "Caravan Insurance",
			};

			if ($ctrl.quoteModel.caravanForm.mainPolicyHolder) {
				done.policyHolderName =
					$ctrl.quoteModel.caravanForm.mainPolicyHolder.firstName +
					" " +
					$ctrl.quoteModel.caravanForm.mainPolicyHolder.lastName;
			} else if ($ctrl.quoteModel.caravanForm.companyContact) {
				done.policyHolderName =
					$ctrl.quoteModel.caravanForm.companyContact.firstName +
					" " +
					$ctrl.quoteModel.caravanForm.companyContact.lastName;
				done.email = $ctrl.quoteModel.caravanForm.companyContact.email;
			}

			return done;
		}

		$ctrl.initDonePage = function () {
			$ctrl.initPage();

			var quoteModel = $ctrl.quoteModel;
			var done = storage.getItem("done");
			if (!done || !done.policyNumber) {
				done = constructDonePageViewModel();
				$ctrl.smartLink = smartLinkService.generateLink(done);
				gtmService.trackTransaction(
					$state.current,
					done,
					$ctrl.quoteModel
				);
				performMAServices("paid");
			}

			$ctrl.storage.clear();
			storage.setItem("done", done);
			var $columns = $(".columns").get(0);
			$columns.classList.remove("print-ready");
			$ctrl.done = done;
			$ctrl.done.campaignSteps = {};

			// check if campaign code is valid
			if (
				quoteModel.quoteResult.response.isCampaignCodeValid ||
				quoteModel.quoteResult.response.isGiftCardApplied
			) {
				// get campaign next steps
				$ctrl.done.campaignSteps = campaignService.getCampaignConfig(
					quoteModel.quoteResult.response.campaignCode,
					true
				);
			} else $ctrl.done.campaignSteps.isCampaignCodeValid = false;
		};

		$scope.$on("submit-feedback", submitFeedback);

		function submitFeedback() {
			if ($ctrl.done.policyNumber != null && $ctrl.smartLink != null) {
				window.open($ctrl.smartLink, "_blank");
			} else {
				void 0;
			}
		}

		// TODO: fix this to not use timeout
		setTimeout(function () {
			QBE.expandCollapse.init();
		}, 1000);

		$ctrl.clear = function () {
			$scope.$broadcast("clear");
		};

		$ctrl.save = function () {
			$ctrl.title = dynamicRouter.getPageTitle();

			$ctrl.showErrorSummary = false;
			isInvalid = $scope.caravanForm.$invalid;
			if (isInvalid) {
				$scope.$broadcast("broadcast-field-errors");
				$ctrl.showErrorSummary = true;
				$scope.$broadcast("reset-field-errors");
				scrollViewTo($("#combinedValidationListing"));
				return;
			}

			getUserInput();
			$rootScope.$broadcast("open-modal", {
				modal: "saveQuote",
			});
		};

		$ctrl.back = function () {
			gtmService.trackEvent("back");
			$scope.$root.$broadcast("hide-top-banner");
			$scope.$broadcast("reset-field-errors");
			var backState = dynamicRouter.back();
			if (backState) $state.go(backState);
			else {
				var formData = getUserInput();
				if (formData.rapidEstimateUrl)
					window.location.href = formData.rapidEstimateUrl;
			}
		};

		$ctrl.moveToStep = function (step) {
			$state.go(dynamicRouter.getState(step));
		};
		$ctrl.moveToPage = function (page) {
			$state.go(page);
		};
	},
]);

angular.module('qbePortal.rapidEstimate.caravan')
	.controller('CaravanRapidEstimateController', [
		'$scope',
		'$state',
		'userInputRepository',
		'labelService',
		'portalServiceWrapper',
		'quoteOptions',
		'Util',
		'serviceResponseRepository',
		'gtmService',
		'$sce',
		function($scope, $state, userInputRepository, labelService, portalServiceWrapper, quoteOptions, util, serviceResponseRepository, gtmService, $sce) {
			var vm = this;
			vm.formData = {};
			vm.elementName = 'Form Controller';
			vm.validationErrors = null;
			vm.sections = {};
			vm.promoCode = util.getQueryStringByName(window.location, 'promotionalCode') ;

			vm.initPage= function() {
				util.dispatchCustomEvent('register-labels');
				vm.formData = {
					caravanForm: {
						aboutYourCaravan: {
							vehicleType: 'caravan'
						},
						tellUsMore: {
							promotionalCode: vm.promoCode
						}
					}
				}
			}

			vm.registerSection = function (name, init, getValueFn) {
				vm.sections[name] = getValueFn;
			}

			// Submit form to get quickQuote
			vm.submit = function(event, form) {
				event.preventDefault();

				gtmService.trackEvent('rapid-estimate-submit') ;

				vm.showErrorSummary = false;
				isInvalid = form.$invalid;

				if (isInvalid) {
					$scope.$broadcast('broadcast-field-errors');
					vm.showErrorSummary = true;
					$scope.$broadcast('reset-field-errors');
					scrollViewTo($('#combinedValidationListing')) ;
					return;
				}

				$scope.$root.$broadcast('loading-animation-start');

				// Populate formData
				var formData = {};
				for (var key in this.sections) {
					formData[key] = this.sections[key]();
				}
				var now = moment().tz("Australia/Sydney").format('DD/MM/YYYY');
				formData.caravanForm.getStarted = {
					policyStartDate: now
				};
				formData.caravanForm.driver.drivers = [];
				formData.caravanForm.driver.drivers[0] = {
					person: util.deepClone(formData.caravanForm.driver)
				};

				if(formData.caravanForm.tellUsMore) {
					formData.email = formData.caravanForm.tellUsMore.email;
					formData.caravanForm.promotionalCode = {
						promotionalCode: formData.caravanForm.tellUsMore.promotionalCode
					};
				}

				userInputRepository.update(formData);

				portalServiceWrapper.updateQuote(formData);

				var quickQuoteOptions = quoteOptions.getQuickQuoteOptionsForStep('rapidEstimate') ;

				portalServiceWrapper.getQuickQuote(quickQuoteOptions.permutations, quickQuoteOptions.rules)
					.then(function(resp) {
						vm.applyFormPath = this.endpointUrls.estimateRedirect;
						var quoteResults = serviceResponseRepository.getLastResponseFrom('quickQuote') ;
						serviceResponseRepository.update('rapidEstimate' , quoteResults ) ;
						$scope.$root.$broadcast('process-rapid-estimates', {
							// resp: resp,
							formData: formData,
							results : quoteResults,
						});
					})
					.catch(function(err) {
						$scope.$root.$broadcast('error', {
							errorMessage: 'getQuickQuote error',
							response: err
						});
					});

			}

			function scrollViewTo($element) {
				var offset = $element.offset();
				if ( offset ) {
					$('html, body').animate({
						scrollTop: (offset.top - 50),
						scrollLeft: offset.left
					});
				}
			}
		
			vm.getSectionDescriptionFor = function (fieldName) {
				return $sce.trustAsHtml(labelService.getSectionDescriptionFor(fieldName));
			}

			// Scroll to estimates once they're loaded
			$scope.$root.$on('show-rapid-estimates', function() {
				vm.showRapidEstimatesPanel = true;
			});

			$scope.$root.$on('rapid-estimates-panel-initialised', function() {
		 		var rapidEstimateResults = serviceResponseRepository.getLastResponseFrom('rapidEstimate') ;
				if ( rapidEstimateResults ) {
					vm.applyFormPath = this.endpointUrls.estimateRedirect;
					$scope.$root.$broadcast('process-rapid-estimates', {
						results: rapidEstimateResults,
						formData: userInputRepository.get()
					});
				}
			});
		}
	]);

angular.module('qbePortal').controller('ctpFormController', [
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'userInputRepository',
	'dynamicRouter',
	'labelService',
	'Util',
	'$http',
	'storage',
	'gtmService',
	'MODULE_INFO',
	'vcRecaptchaService',
	function(
		$rootScope,
		$scope,
		$state,
		$stateParams,
		userInputRepository,
		dynamicRouter,
		labelService,
		util,
		$http,
		storage,
		gtmService,
		MODULE_INFO,
		vcRecaptchaService
	) {
		var $ctrl = this;

		/**
		 * routing initialisation, enabling/disabling (hiding/showing) available routes
		 * testing for allowed routes and redirecting when not allowed
		 */
		function markCompletedRouteCallback(stateName) {
			storage.setItem('completed-step', stateName);
		}

		function initialiseRouting() {
			dynamicRouter.initialise(
				$state.current.name,
				$state.$current.parent.name,
				null,
				markCompletedRouteCallback
			);
			$ctrl.title = dynamicRouter.getPageTitle();
			$ctrl.steps = dynamicRouter.getSteps();
		}
		/** End of routing logic */

		$ctrl.state = $state;
		$ctrl.storage = storage;
		$ctrl.sections = {};
		$ctrl.moduleId = MODULE_INFO.id;
		$ctrl.recaptchaResponse = null;

		function getDefaultValues() {
			var defaultValues = {
				ctpForm: {
					promotionalCode: {
						value: $stateParams.promotionalCode
							? $stateParams.promotionalCode
							: ''
					},
					token: {
						widgetId: null,
						response: ''
					},
					incentiveDetails: {
						directDebit: true
					}
					
				}
			};
			return defaultValues;
		}

		function scrollViewTo($element) {
			var offset = $element.offset();
			if (offset) {
				$('html, body').animate({
					scrollTop: offset.top - 50,
					scrollLeft: offset.left
				});
			}
		}

		/**
		 * QbFormSections register themselves with the form controller.
		 * This is done automatically by the form section upon initialisation.
		 * @name : name of the form section
		 * @init : function callback initialise the section
		 * @getValueFn: function callback to get the value of the section.
		 */
		$ctrl.registerSection = function(name, init, getValueFn) {
			$ctrl.sections[name] = {
				initValue: init,
				getValue: getValueFn
			};
		};

		/**
		 * Any generic breaking errors should broadcast 'error' to the rootScope. This will cause redirection
		 * to the main error page.
		 */
		$scope.$on('error', function(event, error) {
			$state.go('error', error);
		});

		function getUserInput() {
			var formData = getFormInput();

			if ($ctrl.response && $ctrl.response !== '') {
				formData.ctpForm.token.widgetId = $ctrl.widgetId;
				formData.ctpForm.token.response = $ctrl.response;
			}

			userInputRepository.update(formData);
			var defaultValues = getDefaultValues();
			return userInputRepository.get(defaultValues);
		}

		function getFormInput() {
			var formData = {};
			for (var key in $ctrl.sections) {
				formData[key] = $ctrl.sections[key].getValue();
			}
			return formData;
		}

		function openDialog() {
			$rootScope.$broadcast('loading-animation-start');

			getUserInput();

			$rootScope.$broadcast('open-confirmation-dialog');
		}

		$ctrl.submit = function(e, form) {
			$ctrl.showErrorSummary = false;

			gtmService.trackCTPEvent(
				'gaClick',
				$state.current,
				e.target.textContent
			);

			if (form.$invalid) {
				$scope.$broadcast('broadcast-field-errors');
				$ctrl.showErrorSummary = true;
				$scope.$broadcast('reset-field-errors');
				scrollViewTo($('#combinedValidationListing'));
				return;
			}

			if ($ctrl.visible == 'invisible') {
				vcRecaptchaService.execute($ctrl.widgetId);
			} else {
				if ($ctrl.response !== '') {
					openDialog();
				}
			}
		};

		/**
		 * Initialisation method of the payment page
		 */
		$ctrl.initPage = function() {
			storage.clear();

			$ctrl.visible = globals.recaptchaConfiguration.options[0].type;
			$ctrl.recaptchaKey = globals.recaptchaConfiguration.options[0].key;

			initialiseRouting();
			util.dispatchCustomEvent('register-labels');
			$ctrl.termsAndConditions = false;
			var formData = getUserInput();
			$ctrl.formData = formData;
			var defaultValues = getDefaultValues();	
			userInputRepository.update(defaultValues);
		};

		$ctrl.setResponse = function(response) {
			$ctrl.response = response;

			if ($ctrl.visible === 'invisible' && $ctrl.response !== '') {
				openDialog();
			}
		};

		$ctrl.setWidgetId = function(widgetId) {
			$ctrl.widgetId = widgetId;
		};

		$ctrl.cbExpiration = function() {
			vcRecaptchaService.reload($scope.widgetId);

			$ctrl.response = '';
		};

		$scope.$on('terms-and-conditions-changed', function(
			event,
			termsAndConditions
		) {
			$ctrl.termsAndConditions = termsAndConditions;
		});

		$scope.$on('reload-recaptcha', $ctrl.cbExpiration);
	}
]);

angular.module('qbePortal').controller('CybersourceCallbackController', [
	'$scope',
	'$stateParams',
	'dynamicRouter',
	'Util',
	'paymentLoggerService',
	function($scope, $stateParams, dynamicRouter, Util, paymentLoggerService) {
		var $ctrl = this;
		$scope.$root.$broadcast('loading-animation-end');

		var success =
			$stateParams.status === 'SUCCESS' ||
			$stateParams.status === 'AWAITING_PROCESS';

		paymentLoggerService.trackQuoteStatus(
			'processing Cybersource callback',
			'show done page or error page',
			null
		);

		void 0;
		// Access parent window to call the callback function
		if (window.parent && window.parent.$controllerScope) {
			parent.$controllerScope.onPaymentCallback(success, $stateParams);
		}
	}
]);

angular.module('qbePortal').controller('CybersourcePaymentFormController', [
	'$scope',
	'$state',
	'$sce',
	'dynamicRouter',
	'Util',
	'paymentLoggerService',
	function($scope, $state, $sce, dynamicRouter, Util, paymentLoggerService) {
		var $ctrl = this;
		$scope.$root.$broadcast('loading-animation-end');

		if (window.parent && window.parent.$controllerScope) {
			$ctrl.creditCardPaymentData =
				window.parent.$controllerScope.creditCardPaymentData;
		}

		$ctrl.cybersourceEndpoint = $sce.trustAsResourceUrl(
			endpointUrls.payments.cybersourcePaymentEndpoint
		);

		paymentLoggerService.trackQuoteStatus(
			'submitting payment to Cybersource',
			'waiting for Cybersource callback',
			null
		);
	}
]);

angular.module("qbePortal").controller("DeclineController", [
	"$scope",
	"$state",
	"$stateParams",
	"$sce",
	"$filter",
	"labelService",
	"Util",
	"storage",
	"MODULE_INFO",
	function(
		$scope,
		$state,
		$stateParams,
		$sce,
		$filter,
		labelService,
		util,
		storage,
		MODULE_INFO
	) {
		var $ctrl = this;
		$ctrl.declineMessages = [];

		$ctrl.initPage = function() {
			util.dispatchCustomEvent("register-labels");
			getDeclineCodes();
			var declineType = $state.current.name;
			$ctrl.title = labelService.getSectionLabelFor(declineType);
			$ctrl.descriptionHTML = labelService.getSectionDescriptionFor(
				declineType
			);
			$ctrl.nextStep = processWildCard(
				labelService.getLabelFor("nextStep"),
				getStartRoute()
			);
			storage.clear();
		};

		// gdd-3756 - unauthenticated payments decline
		$ctrl.initPayBills = function() {
			util.dispatchCustomEvent("register-labels");
			storage.clear();
			if (qbe.fieldLabels) {
				$ctrl.headBar = qbe.fieldLabels.headBar;
				$ctrl.phoneNumber = qbe.fieldLabels.enterPaymentRef.phone;
				$ctrl.paymentDeclineLabel =
					qbe.fieldLabels.paymentDecline.title;
				$ctrl.paymentDeclineDescription =
					qbe.fieldLabels.paymentDecline.description;
				$ctrl.paymentDeclineSubDescription =
					qbe.fieldLabels.paymentDecline.subDescription;
				$ctrl.chatAgentLabel = qbe.fieldLabels.buttonLabel.chatAgent;
				$ctrl.callAgentLabel = qbe.fieldLabels.buttonLabel.callAgent;
				$ctrl.referenceNumber = $stateParams.referenceNumber;

				var footHeight = $(".footer").outerHeight(),
					windowHeight = $(window).height(),
					documentHeight = $(document).height(),
					minHeight;

				if ($(window).outerWidth() >= 768) {
					if (documentHeight > windowHeight) {
						minHeight = documentHeight - footHeight - 5;
					} else {
						minHeight = windowHeight - footHeight - 5;
					}

					$(".col1").css("min-height", minHeight + "px");
				} else {
					$(".col1").css("min-height", "auto");
				}
			}
		};

		/**
		 * Get decline codes - typeCodes submitted from product controllers
		 * @param {none}
		 * @return {none}
		 */
		function getDeclineCodes() {
			var codes = $stateParams.declineCodes; // get typeCodes from $stateParams

			if ($state.current.name === 'embargo') {
				var message = "Potential or current weather conditions in the area";
				$ctrl.declineMessages.push({
					message: message
				});
			}
			// loop through array and lookup labels
			else if (!util.isUndefinedOrNull(codes) && codes !== "null") {
				angular.forEach(codes, function(value) {
					var message = $ctrl.lookupLabel([value]);

					// get default message in case typeCode is not setup
					if (util.isUndefinedOrNull(message)) {
						message = $ctrl.lookupLabel("default");
					}

					if (value === "ccPaymentError") {
						message += " " + $stateParams.declineType;
					}

					$ctrl.declineMessages.push({
						message: message
					});
				});
			} else {
				$ctrl.declineMessages.push({
					message: "the information provided in this quote"
				});

				void 0;
			}
		}

		/**
		 * Start route - create URL for step 1 of all products
		 * @param {none}
		 * @return {string} - Step 1 URL
		 */
		function getStartRoute() {
			var routeName = MODULE_INFO.startRouteName.split(".");
			var currentURL = window.location.href.split("/");

			currentURL[currentURL.length - 1] = routeName[1];
			var newURL =
				'<a target="_self" href="' +
				currentURL.join("/") +
				'">new quote</a>';
			var homeURL =
				'<a target="_self" href="' +
				window.location.origin +
				'/au">QBE Homepage</a>';

			return [newURL, homeURL];
		}

		/**
		 * Process wildcard - handle multiple wildcards to be replaced
		 * @param {string} - target string
		 * @param {array} - array of string
		 * @return {string} - destination string
		 */
		function processWildCard(targetString, wildcardValue) {
			if (
				typeof wildcardValue == "string" ||
				typeof wildcardValue == "undefined"
			) {
				targetString = util.stringFormat(targetString, wildcardValue);
			} else {
				var argArr = [];
				argArr.push(targetString);
				argArr = argArr.concat(wildcardValue);
				targetString = util.stringFormat.apply(null, argArr);
			}
			return targetString;
		}

		/**
		 * Label lookup - get labels from global options
		 * @param {string} - fieldName
		 * @return {string} - labels
		 */
		$ctrl.lookupLabel = function(fieldName) {
			return labelService.getGlobalOptionLabel(
				"declineConfiguration",
				fieldName
			);
		};

		$ctrl.getProduct = function() {
			return MODULE_INFO.id;
		};

		$ctrl.getLabelFor = function(fieldName) {
			return $sce.trustAsHtml(labelService.getLabelFor(fieldName));
		};

		$scope.$root.$broadcast("loading-animation-end");
	}
]);

angular.module('qbePortal').
controller('ErrorController', [
	'$scope',
	'$state',
	'$stateParams',
	'$sce',
	'labelService',
	'Util',
	'MODULE_INFO',
	function($scope, $state, $stateParams, $sce, labelService, Util, MODULE_INFO) {
		var $ctrl = this ;
		$scope.$root.$broadcast('loading-animation-end');

		$ctrl.title = 'Error';
		// $scope.$root.$broadcast('page-title-set', $ctrl.title);
		Util.dispatchCustomEvent('register-labels');

		if ( $stateParams.errorMessage )
			void 0;

		$ctrl.errorMessage = $sce.trustAsHtml(labelService.getLabelFor('defaultErrorMessage'));
		$ctrl.defaultErrorTitle = labelService.getLabelFor('defaultErrorTitle');
		$ctrl.tryAgainLinkMessage = labelService.getLabelFor('tryAgainLinkMessage');
		$ctrl.retry= function() {
			$state.go(MODULE_INFO.startRouteName);
		}; 
}]);

angular.module("qbePortal").controller("FormController", [
	"$rootScope",
	"$scope",
	"$state",
	"$stateParams",
	"$window",
	"userInputRepository",
	"serviceResponseRepository",
	"quoteOptions",
	"paymentService",
	"quoteModelFactory",
	"dynamicRouter",
	"portalServiceWrapper",
	"MAService",
	"labelService",
	"Util",
	"$q",
	"storage",
	"gtmService",
	"quoteRequestRepository",
	"tokenTimeoutService",
	"$compile",
	"smartLinkService",
	"campaignService",
	function (
		$rootScope,
		$scope,
		$state,
		$stateParams,
		$window,
		userInputRepository,
		serviceResponseRepository,
		quoteOptions,
		paymentService,
		quoteModelFactory,
		dynamicRouter,
		portalServiceWrapper,
		MAService,
		labelService,
		util,
		$q,
		storage,
		gtmService,
		quoteRequestRepository,
		tokenTimeoutService,
		$compile,
		smartLinkService,
		campaignService
	) {
		var $ctrl = this;

		//check if session function is embedded and append directive
		if ($window.qbe.fieldLabels != undefined) {
			if (angular.isObject($window.qbe.fieldLabels.sessionFunction))
				angular
					.element("div#phglobaloptions_0_divOptionsComponents")
					.after($compile("<div qb-ng-dialog></div>")($scope));
		}

		/**
		 * routing initialisation, enabling/disabling (hiding/showing) available routes
		 * testing for allowed routes and redirecting when not allowed
		 */
		function initialiseRouting() {
			storage.removeItem("policy-date-input");

			var stepConditions = {
				"vehicle.payment": function () {
					return $state.$current.name != "vehicle.done";
				},
				"vehicle.done": function () {
					return $state.$current.name == "vehicle.done";
				},
				"vehicle.policy-start-date": function () {
					return $state.$current.name == "vehicle.policy-start-date";
				},
			};
			dynamicRouter.initialise(
				$state.current.name,
				$state.$current.parent.name,
				stepConditions,
				markCompletedRouteCallback
			);
			$ctrl.title = dynamicRouter.getPageTitle();
			$ctrl.steps = dynamicRouter.getSteps();
		}

		function markCompletedRouteCallback(stateName) {
			storage.setItem("completed-step", stateName);
		}
		/** End of routing logic */

		$rootScope.$broadcast("loading-animation-end");

		$ctrl.elementName = "Form Controller";

		$ctrl.validationErrors = null;
		$ctrl.sections = {};
		$ctrl.state = $state;
		$ctrl.storage = storage;
		$ctrl.sideBarEmail = null;
		$ctrl.quoteModel = quoteModelFactory.create();
		$ctrl.saveOnExit = false;
		$ctrl.smartLink = null;
		$ctrl.goToNextStep = true;

		$window.onbeforeunload = function (event) {
			exitSaveQuote();
			if ($ctrl.saveOnExit) {
				$rootScope.$digest();
				return "Are you sure you want to leave?";
			}
		};

		$scope.$on("session-save-quote", exitSaveQuote);

		function exitSaveQuote() {
			var emailAddress = angular
				.element("div")
				.find("[label-key=yourEmailAddress]")
				.val();

			if (dynamicRouter.getPageTitle() != "Payment") {
				if (
					$ctrl.quoteModel.email != null ||
					$ctrl.sideBarEmail != null ||
					emailAddress != ""
				) {
					if ($ctrl.quoteModel && $ctrl.quoteModel.quoteResult) {
						$ctrl.saveOnExit = true;
						var formData = getUserInput();
						var paymentFrequency = "everyyear";

						portalServiceWrapper.updateQuote(formData);

						portalServiceWrapper
							.saveQuote(paymentFrequency, {
								quote: "true",
							})
							.then(function () {
								$rootScope.$broadcast("session-redirect");
							})
							.catch(function () {
								$rootScope.$broadcast("session-redirect");
							});
					} else {
						$rootScope.$broadcast("session-redirect");
					}
				} else $rootScope.$broadcast("session-redirect");
			}

			// $ctrl.submit($scope[formName]);
		}

		function getDefaultValues() {
			var defaultValues = {
				fromFullQuote: true,
				vehicleForm: {
					getStarted: {
						policyStartDate: moment()
							.tz("Australia/Sydney")
							.format("DD/MM/YYYY"),
						personOrCompany: "person",
					},
					insuredExcessValue: {
						thirdPartyOrThirdPartyFireAndTheft: "standard",
						comprehensivePref: "market",
					},
					optionalBenefits: {
						QPMMotVehHireCar: false,
						QPMMotVehWindscreen: false,
						QPMMotVehNCB: false,
					},
				},
			};

			var defaultStateExcess = quoteOptions.getStateDefaultVoluntaryExcess(
				$ctrl.quoteModel.state
			);
			if (defaultStateExcess != null) {
				var tempObj = {
					vehicleForm: {
						insuredExcessValue: {
							voluntaryVehicleExcess: defaultStateExcess,
						},
					},
				};
				defaultValues = Object.extend(defaultValues, tempObj);
			}
			return defaultValues;
		}

		/**
		 * QbFormSections register themselves with the form controller.
		 * This is done automatically by the form section upon initialisation.
		 * @name : name of the form section
		 * @init : function callback initialise the section
		 * @getValueFn: function callback to get the value of the section.
		 */
		$ctrl.registerSection = function (name, init, getValueFn) {
			$ctrl.sections[name] = {
				initValue: init,
				getValue: getValueFn,
			};
		};

		/**
		 * Any generic breaking errors should broadcast 'error' to the rootScope. This will cause redirection
		 * to the main error page.
		 */
		$scope.$on("error", function (event, error) {
			$state.go("error", error);
		});

		/**
		 * calls MA Services to add marketing data.
		 */
		$scope.$on("perform-ma-service", function (event, triggeredBy) {
			performMAServices(triggeredBy);
		});

		$scope.$on("back", function () {
			gtmService.trackEvent("back");
			$ctrl.back();
		});

		$scope.$on("invalidate-quotes", invalidatePreviousQuote);

		function invalidatePreviousQuote() {
			serviceResponseRepository.update("quote", null);
			quoteRequestRepository.clearQuoteCredentials();
			storage.removeItem("policy-address");
		}

		/**
		 * message broadcasted by qbPaymentSummary to submit the form
		 */
		$scope.$on("form-submit", function (event, formName) {
			$ctrl.submit($scope[formName]);
		});

		/**
		 * message broadcasted by qbPaymentSummary to save the form
		 */
		$scope.$on("sidebar-save-quote", function (event, data) {
			$ctrl.sideBarEmail = data;
			$ctrl.save();
		});

		/**
		 * message broadcasted by qbPaymentSummary to assign the email address
		 */
		$scope.$on("sidebar-assign-mail", function (event, data) {
			if (data != "") $ctrl.sideBarEmail = data;
		});

		/**
		 * message broadcasted by qbFormSection to have a session storage of rego search results.
		 */
		$scope.$on("get-user-input", getUserInput);

		/**
		 * called from qbFormSection and any other panel that requires a requote based on new values.
		 */
		$scope.$on("requote", function (event, form) {
			gtmService.trackEvent("requote");
			$rootScope.$broadcast("loading-animation-start");
			var formData = getUserInput();
			getRequote(formData, null, function (resp) {
				$rootScope.$broadcast("loading-animation-end");
				$rootScope.$broadcast("quote-received", resp);
				$rootScope.$broadcast("selected-quote-changed");
			});
		});

		function prepopulateRetrievedQuote() {
			if ($stateParams.quoteNo && $stateParams.email) {
				gtmService.trackEvent("retrieve-quote");
				$rootScope.$broadcast("loading-animation-start");
				portalServiceWrapper
					.retrieveSavedQuote(
						$stateParams.quoteNo,
						$stateParams.email
					)
					.then(function (transformedQuote) {
						$q.all([
							portalServiceWrapper.refreshAddress(
								transformedQuote.aboutYourCar.address
							),
							portalServiceWrapper.refreshVehicleDetails(
								transformedQuote.aboutYourCar.regoSearchResponse.modelYear,
								transformedQuote.aboutYourCar.regoSearchResponse.make,
								transformedQuote.aboutYourCar.regoSearchResponse.model
							),
						]).then(function (resps) {
							var vehicleFormData = ($ctrl.formData.vehicleForm = transformedQuote);
							var serviceResponse = storage.getItem(
								"service-response"
							);
							$ctrl.formData.email = $stateParams.email;

							storage.setItem(
								"policy-address",
								serviceResponse.quote.policyAddress
							);

							if (!vehicleFormData.aboutYourCar)
								vehicleFormData.aboutYourCar = {};
							vehicleFormData.aboutYourCar.address =
								resps[0].data;
							userInputRepository.update($ctrl.formData);
							storage.setItem("retrieve", true);
							if (
								moment()
									.tz("Australia/Sydney")
									.format("YYYY/MM/DD") >
								moment(serviceResponse.quote.periodStartDate)
									.tz("Australia/Sydney")
									.format("YYYY/MM/DD")
							) {
								storage.setItem(
									"policy-date-input",
									$ctrl.formData
								);
								$state.go(
									"vehicle.policy-start-date",
									{
										quoteNo: "",
										email: "",
									},
									{
										location: true,
										reload: true,
									}
								);
							} else {
								$state.go(
									"vehicle.vehicle",
									{
										quoteNo: "",
										email: "",
									},
									{
										location: true,
										reload: true,
									}
								);
							}
						});
					})
					.catch(function () {
						var expiredQuote = storage.getItem("expired-quote");
						if (expiredQuote.displayStatus == "Expired") {
							storage.removeItem("expired-quote");
							window.location.href = util.linkBuilder(
								window.qbe.fieldLabels.expiredQuoteRedirect
									.vehicleExpired
							);
						}
					});
			}
		}

		function applyPromoCodeThroughLink() {
			if ($stateParams.promotionalCode) {
				var formData = $ctrl.formData;

				if (formData.vehicleForm) {
					if (!formData.vehicleForm.tellUsABitMore) {
						formData.vehicleForm.tellUsABitMore = {};
					}
					formData.vehicleForm.tellUsABitMore.promotionalCode =
						$stateParams.promotionalCode;
				}
			}
		}

		function getUserInput() {
			var formData = getFormInput();
			userInputRepository.update(formData);
			return userInputRepository.get(getDefaultValues());
		}

		function getFormInput() {
			var formData = {};
			for (var key in $ctrl.sections) {
				formData[key] = $ctrl.sections[key].getValue();
			}

			if ($ctrl.sideBarEmail != null) {
				if (
					formData.vehicleForm.tellUsABitMore &&
					formData.vehicleForm.tellUsABitMore.yourEmailAddress
				)
					formData.vehicleForm.tellUsABitMore.yourEmailAddress =
						$ctrl.sideBarEmail;
				if (
					formData.vehicleForm.mainPolicyHolderContact &&
					formData.vehicleForm.mainPolicyHolderContact.emailAddress1
				)
					formData.vehicleForm.mainPolicyHolderContact.emailAddress1 =
						$ctrl.sideBarEmail;
			}

			return formData;
		}

		$ctrl.submit = function (form) {
			$scope.$broadcast("form-submitted");
			$ctrl.showErrorSummary = false;
			isInvalid = form.$invalid;
			if (isInvalid) {
				$scope.$broadcast("broadcast-field-errors");
				$ctrl.showErrorSummary = true;
				$scope.$broadcast("reset-field-errors");
				scrollViewTo($("#combinedValidationListing"));
				return;
			}

			gtmService.trackEvent("next");

			setDefaultContactValuesIfRequired();

			$rootScope.$broadcast("loading-animation-start");

			var formData = getUserInput();

			var quickQuote = getQuickQuote(formData, function () {
				$ctrl.quoteModel = quoteModelFactory.create();
				$rootScope.$broadcast("perform-ma-service", "next");
				proceedToNextStep(formData);
			});

			if (!quickQuote) {
				proceedToNextStep(formData);
			}
		};

		function setDefaultContactValuesIfRequired(formData) {
			var contactValuesRequired = ["vehicle.contact"];
			var testRequired =
				contactValuesRequired.indexOf($state.$current.name) >= 0;
			if (testRequired) {
				setDefaultContactValues();
			}
		}

		function testDeclineIfRequired(formData) {
			var declineTestRequiredFor = [
				"vehicle.drivers",
				"vehicle.vehicle",
				"vehicle.quote",
				"vehicle.contact",
			];
			var testRequired =
				declineTestRequiredFor.indexOf($state.$current.name) >= 0;
			if (testRequired) {
				testDecline(formData, nextStep);
			}
		}

		function testDecline(formData, callback) {
			portalServiceWrapper.updateQuote(formData);
			var declineQuoteOptions = quoteOptions.getTestQuoteDeclineOptions(
				$state.$current.name
			);
			portalServiceWrapper
				.testQuoteDecline(declineQuoteOptions)
				.then(function (resp) {
					if (
						angular.isDefined(
							resp.data[0].vehicles[0].isEligibleforSDExemption
						)
					) {
						storage.setItem(
							"stamp-duty",
							resp.data[0].vehicles[0].isEligibleforSDExemption
						);
					} else {
						storage.setItem("stamp-duty", false);
					}
					if ($ctrl.goToNextStep) callback();
				})
				.catch(function (decline) {
					performMAServices("declined");
					storage.clear();
					redirectToDecline(decline, "Policy Was Declined");
				});
		}

		function redirectToDecline(decline) {
			var redirectPage = decline.declineType || "decline";
			$state.go(redirectPage, decline);
		}

		function saveQuoteIfRequired(formData) {
			saveQuoteNotRequiredFor = ["vehicle.vehicle", "vehicle.done"];
			var notRequired =
				saveQuoteNotRequiredFor.indexOf($state.$current.name) >= 0;
			if (!notRequired) {
				saveQuote(formData);
			}
		}

		function getRequote(formData, page, callback) {
			portalServiceWrapper.updateQuote(formData);
			var requoteOptions =
				page == "payment"
					? quoteOptions.getRequoteOptions("vehicle.payment")
					: quoteOptions.getRequoteOptions();
			if (requoteOptions) {
				portalServiceWrapper
					.getQuickQuote(
						requoteOptions.permutations,
						requoteOptions.rules,
						true
					)
					.then(function (resp) {
						if (callback) callback(resp);
					})
					.catch(function (err) {
						void 0;
						broadcastError(err, "Requote error");
					});
			} else {
				return false;
			}
			return true;
		}

		function getQuickQuote(formData, callback) {
			portalServiceWrapper.updateQuote(formData);
			var quickQuoteOptions = quoteOptions.getQuickQuoteOptionsForStep(
				$state.current.name
			);

			if (quickQuoteOptions) {
				portalServiceWrapper
					.getQuickQuote(
						quickQuoteOptions.permutations,
						quickQuoteOptions.rules
					)
					.then(function (resp) {
						if (callback) callback(resp);
					})
					.catch(function (err) {
						broadcastError(err, "getQuickQuote error");
					});
			} else {
				return false;
			}
			return true;
		}

		function broadcastError(err, msg) {
			$rootScope.$broadcast("error", {
				errorMessage: msg,
				response: err,
			});
		}

		function saveQuote(formData, callback) {
			portalServiceWrapper.updateQuote(formData);

			var paymentFrequency = quoteOptions.getSelectedPaymentFrequencyForService();

			portalServiceWrapper
				.saveQuote(paymentFrequency)
				.then(function (resp) {
					if (callback) callback(resp);
					return resp;
				})
				.catch(function (err) {
					if (tokenTimeoutService.isSessionTimedout()) {
						tokenTimeoutService.handleTimeout();
					} else {
						$ctrl.goToNextStep = false;
						broadcastError(err, "Save quote error");
					}
					return err;
				});
		}

		function proceedToNextStep(formData) {
			$rootScope.$broadcast("loading-animation-start");
			saveQuoteIfRequired(formData);
			testDeclineIfRequired(formData);
		}

		function nextStep() {
			$state.go(dynamicRouter.next(markCompletedRouteCallback));
		}

		function performMAServices(eventName) {
			getUserInput();
			var mainPolicyHolder = userInputRepository.get(
				{},
				"vehicleForm.mainPolicyHolder"
			);
			var policyEmail = userInputRepository.get({}, "email");
			var quoteResult = quoteOptions.getSelectedQuoteResult();
			var savedQuote = serviceResponseRepository.getLastResponseFrom(
				"quote"
			);
			var quoteModel = $ctrl.quoteModel;
			var maData = {
				state: quoteModel ? quoteModel.state : null,
				postCode: quoteModel ? quoteModel.postCode : null,
				campaignCode: quoteModel ? quoteModel.campaignCode : null,
				noClaimBonus: quoteModel ? quoteModel.noClaimBonus : null,
				pageName: $state.current.name,
				mainPolicyHolder: mainPolicyHolder,
				policyEmail: policyEmail,
				annualResult: quoteResult ? quoteResult.getAnnual() : null,
				monthlyResult: quoteResult ? quoteResult.getMonthly() : null,
				quoteId: savedQuote ? savedQuote.quoteID : null,
			};

			if ($state.current.name == "vehicle.done") {
				maData.inceptionDate = moment()
					.tz("Australia/Sydney")
					.format("DD/MM/YYYY");
			}

			if (
				quoteModel &&
				quoteModel.address &&
				quoteModel.address.addressLine1
			) {
				maData.address =
					quoteModel.address.addressLine1 +
					" " +
					quoteModel.address.city;
			}

			if (
				quoteModel &&
				quoteModel.gtmPolicyHolder &&
				quoteModel.gtmPolicyHolder.phoneNumber
			) {
				maData.contactNumber = quoteModel.gtmPolicyHolder.phoneNumber;
			}

			MAService.mergeContacts(eventName, maData);
		}

		/**
		 * Scrolls a field into view when an error is clicked
		 * @param {Object} error                    Error object with key `name`
		 */
		$ctrl.showInView = function (error) {
			//console.log(error);
			scrollViewTo($('[name="' + error.name + '"]'));
		};

		function scrollViewTo($element) {
			var offset = $element.offset();
			if (offset) {
				$("html, body").animate({
					scrollTop: offset.top - 50,
					scrollLeft: offset.left,
				});
			}
		}

		/**
		 * determines if a quote is available to enable save button.
		 */
		$ctrl.isSaveButtonEnabled = function () {
			var formData = getUserInput();
			return formData.rapidEstimateUrl != null;
		};

		/**
		 * Takes care of
		 * - registering the labels generated by sitecore
		 * - setting default values
		 * - prepopulating retrieve quote if required.
		 */
		$ctrl.initPage = function () {
			initialiseRouting();
			util.dispatchCustomEvent("register-labels");
			$ctrl.formData = getUserInput();
			overwritePromoCodeFromQueryString();
			var currentPageName = $ctrl.state.current.name;
			$ctrl.displayBack =
				$ctrl.formData.rapidEstimateUrl != null ||
				currentPageName != "vehicle.vehicle";
			if (
				$ctrl.formData.rapidEstimateUrl &&
				currentPageName == "vehicle.vehicle"
			) {
				invalidatePreviousQuote();
			}

			prepopulateRetrievedQuote();
			applyPromoCodeThroughLink();
		};

		function overwritePromoCodeFromQueryString() {
			var promoCode = util.getQueryStringByName(
				window.location,
				"promotionalCode"
			);
			if (promoCode) {
				$ctrl.formData.promotionalCode =
					$ctrl.formData.promotionalCode || {};
				$ctrl.formData.promotionalCode.promotionalCode = promoCode;
			}
		}

		$ctrl.initQuotePage = function () {
			$ctrl.initPage();
			//check for the data from retieved quote
			if (
				$ctrl.formData.vehicleForm.insuredExcessValue &&
				$ctrl.formData.vehicleForm.insuredExcessValue.coverType
			) {
				quoteOptions.setSelectedCoverType(
					$ctrl.formData.vehicleForm.insuredExcessValue.coverType,
					$ctrl.formData.vehicleForm.insuredExcessValue
						.thirdPartyOrThirdPartyFireAndTheft
				);
			}

			var selectedCoverType = quoteOptions.getSelectedCoverType();
			var formData = getUserInput(),
				form = formData.vehicleForm;

			$scope.$broadcast("requote");

			if (!form.insuredExcessValue) form.insuredExcessValue = {};

			form.saveOnPremium = form.saveOnPremium || {};
			form.saveOnPremium.saveOnYourPremium = selectedCoverType.subType;

			if (selectedCoverType.superType == "third_party")
				form.insuredExcessValue.thirdPartyOrThirdPartyFireAndTheft =
					selectedCoverType.subType;

			$ctrl.formData.vehicleForm = form;
		};

		$ctrl.initContact = function () {
			$ctrl.initPage();
			setDefaultContactValues();
		};

		function setDefaultContactValues() {
			var formData = getUserInput(),
				form = formData.vehicleForm,
				postalAddress = storage.getItem("policy-address");

			if (form.getStarted.personOrCompany == "person") {
				form.mainPolicyHolder = form.mainPolicyHolder || {};

				if (
					form.mainPolicyHolder.isMainDriverMainPolicyHolder !== false
				) {
					form.mainPolicyHolder.isMainDriverMainPolicyHolder = true;
					form.mainPolicyHolder.title =
						form.mainPolicyHolder.title ||
						form.driver.drivers[0].person.title;
					form.mainPolicyHolder.firstName =
						form.driver.drivers[0].person.firstName;
					form.mainPolicyHolder.lastName =
						form.driver.drivers[0].person.lastName;
					form.mainPolicyHolder.gender =
						form.driver.drivers[0].person.gender;
					form.mainPolicyHolder.dateOfBirth =
						form.driver.drivers[0].person.dateOfBirth;

					form.mainPolicyHolder.fourYears_chargedOrConvictedOffences =
						form.driver.drivers[0].fourYears_chargedOrConvictedOffences;
					form.mainPolicyHolder.fourYears_chargedOrConvictedOffences =
						form.driver.drivers[0].fourYears_chargedOrConvictedOffences;
					form.mainPolicyHolder.fourYears_chargedOrConvictedOffences =
						form.driver.drivers[0].fourYears_chargedOrConvictedOffences;
					form.mainPolicyHolder.fourYears_licenceRSDC =
						form.driver.drivers[0].fourYears_licenceRSDC;
					form.mainPolicyHolder.fourYears_vehicleAccidentsClaims =
						form.driver.drivers[0].fourYears_vehicleAccidentsClaims;
					form.mainPolicyHolder.tenYears_chargedOrConvictedOffences =
						form.driver.drivers[0].tenYears_chargedOrConvictedOffences;

					form.mainPolicyHolderContact =
						form.mainPolicyHolderContact || {};
					form.mainPolicyHolderContact.postalOption = true;
					form.mainPolicyHolderContact.emailAddress1 = formData.email;
				}

				if (form.mainPolicyHolderContact.address == undefined) {
					form.mainPolicyHolderContact.address =
						form.aboutYourCar.address;
				}

				if (Object.keys(postalAddress).length > 0) {
					if (
						postalAddress.addressLine1 !==
							form.mainPolicyHolderContact.address.addressLine1 &&
						postalAddress.postalCode !==
							form.mainPolicyHolderContact.address.postalCode
					) {
						form.mainPolicyHolderContact.postalOption = false;
						form.mainPolicyHolderContact.postalAddress = postalAddress;
					}
				}
			}

			if (form.getStarted.personOrCompany == "company") {
				form.companyContact = form.companyContact || {};

				form.companyContact.postalOption = true;

				form.companyContact.title = form.driver.drivers[0].person.title;
				form.companyContact.firstName =
					form.driver.drivers[0].person.firstName;
				form.companyContact.lastName =
					form.driver.drivers[0].person.lastName;
				form.companyContact.gender =
					form.driver.drivers[0].person.gender;
				form.companyContact.dateOfBirth =
					form.driver.drivers[0].person.dateOfBirth;

				if (form.companyContact.address == undefined) {
					form.companyContact.address = form.aboutYourCar.address;
				}

				if (Object.keys(postalAddress).length > 0) {
					if (
						postalAddress.addressLine1 !==
							form.companyContact.address.addressLine1 &&
						postalAddress.postalCode !==
							form.companyContact.address.postalCode
					) {
						form.companyContact.postalOption = false;
						form.companyContact.postalAddress = postalAddress;
					}
				}

				form.companyContact.email = formData.email;
			}

			$ctrl.formData.vehicleForm = form;
		}

		function constructDonePageViewModel() {
			var done = {
				policyNumber: $stateParams.policyNumber,
				accountNumber: $stateParams.accountNumber,
				isAwaitingProcess: $stateParams.isAwaitingProcess,
				policyType: quoteOptions.getSelectedCoverType().label,
				policyStartDate: $ctrl.quoteModel.policyStartDate,
				showYearMakeModelInSummary: false,
				smartLinkURL: $window.qbe.fieldLabels.smartLink.url,
				hashKey: $window.qbe.fieldLabels.smartLink.hashKey,
				email: $ctrl.quoteModel.email,
				description: "Motor Insurance",
				productRefs: "Motor Insurance",
			};

			var regoNumber = $ctrl.quoteModel.regoNumber || "";
			if (
				$ctrl.quoteModel.vehicleForm.tellUsYourRegoNumber &&
				$ctrl.quoteModel.vehicleForm.tellUsYourRegoNumber.regoNumber
			) {
				done.showYearMakeModelInSummary = true;
			}
			done.regoNumber = regoNumber.toUpperCase();

			if ($ctrl.quoteModel.vehicleForm.aboutYourCar.regoSearchResponse) {
				var year =
						$ctrl.quoteModel.vehicleForm.aboutYourCar
							.regoSearchResponse.modelYear,
					make =
						$ctrl.quoteModel.vehicleForm.aboutYourCar
							.regoSearchResponse.make,
					model =
						$ctrl.quoteModel.vehicleForm.aboutYourCar
							.regoSearchResponse.model;

				done.yearMakeModel = year + " " + make + " " + model;
			}

			if ($ctrl.quoteModel.vehicleForm.mainPolicyHolder) {
				done.policyHolderName =
					$ctrl.quoteModel.vehicleForm.mainPolicyHolder.firstName +
					" " +
					$ctrl.quoteModel.vehicleForm.mainPolicyHolder.lastName;
			} else if ($ctrl.quoteModel.vehicleForm.companyContact) {
				done.policyHolderName =
					$ctrl.quoteModel.vehicleForm.companyContact.firstName +
					" " +
					$ctrl.quoteModel.vehicleForm.companyContact.lastName;
				done.email = $ctrl.quoteModel.vehicleForm.companyContact.email;
			}

			done.purchaseDate = moment()
				.tz("Australia/Sydney")
				.format("DD/MM/YYYY");
			return done;
		}

		$ctrl.initDonePage = function () {
			$ctrl.initPage();

			var quoteModel = $ctrl.quoteModel;
			var done = storage.getItem("done");
			if (!done || !done.policyNumber) {
				done = constructDonePageViewModel();
				$ctrl.smartLink = smartLinkService.generateLink(done);

				/* tracking payment complete for gtm */
				var paymentConfirmationDetails = storage.getItem("confirmation-details");
				var receiptNumber = '';
				var paymentType = '';
				var creditCardConfirmation = storage.getItem(
					"creditcard-confirm-details"
				);
				var paypalConfirmationData = storage.getItem("paypal-confirm-details");
				var directDebitConfirmationData = storage.getItem(
					"direct-debit-confirm-details"
				);
				var creditCardConfirmationData = storage.getItem(
					"creditcard-confirm-details"
				);
				if (paypalConfirmationData.isSuccess) {
					receiptNumber = paypalConfirmationData.receiptNumber;
					paymentType = 'payPal';
				}
				else if (creditCardConfirmationData.isSuccess) {
					receiptNumber = creditCardConfirmationData.receiptNumber;
					paymentType= 'creditCard';
				}
				else if (directDebitConfirmationData.isSuccess) {
					receiptNumber = directDebitConfirmationData.receiptNumber;
					paymentType= 'bankAccount';
				}				

				gtmService.trackTransactionCompleted(
					$state.current,
					done,
					$ctrl.quoteModel,
					paymentConfirmationDetails.referenceNumber,
					receiptNumber,
					paymentType
				);
				/* end tracking payment complete for gtm */

				performMAServices("paid");
			}

			$ctrl.storage.clear();
			storage.setItem("done", done);
			var $columns = $(".columns").get(0);
			$columns.classList.remove("print-ready");
			$ctrl.done = done;
			$ctrl.done.campaignSteps = {};

			// check if campaign code is valid
			if (
				quoteModel.quoteResult.response.isCampaignCodeValid ||
				quoteModel.quoteResult.response.isGiftCardApplied
			) {
				// get campaign next steps
				$ctrl.done.campaignSteps = campaignService.getCampaignConfig(
					quoteModel.quoteResult.response.campaignCode,
					true
				);
			} else $ctrl.done.campaignSteps.isCampaignCodeValid = false;
		};

		$scope.$on("submit-feedback", submitFeedback);

		function submitFeedback() {
			if ($ctrl.done.policyNumber != null && $ctrl.smartLink != null) {
				window.open($ctrl.smartLink, "_blank");
			} else {
				void 0;
			}
		}

		// TODO: fix this to not use timeout
		setTimeout(function () {
			QBE.expandCollapse.init();
		}, 1000);

		$ctrl.clear = function () {
			$scope.$broadcast("clear");
		};

		$ctrl.save = function () {
			$ctrl.title = dynamicRouter.getPageTitle();

			$ctrl.showErrorSummary = false;
			isInvalid = $scope.vehicleForm.$invalid;
			if (isInvalid) {
				$scope.$broadcast("broadcast-field-errors");
				$ctrl.showErrorSummary = true;
				$scope.$broadcast("reset-field-errors");
				scrollViewTo($("#combinedValidationListing"));
				return;
			}

			getUserInput();
			$rootScope.$broadcast("open-modal", {
				modal: "saveQuote",
			});
		};

		$ctrl.back = function () {
			gtmService.trackEvent("back");
			$scope.$root.$broadcast("hide-top-banner");
			$scope.$broadcast("reset-field-errors");
			var backState = dynamicRouter.back();
			if (backState) $state.go(backState);
			else {
				var formData = getUserInput();
				if (formData.rapidEstimateUrl)
					window.location.href = formData.rapidEstimateUrl;
			}
		};

		$ctrl.moveToStep = function (step) {
			$state.go(dynamicRouter.getState(step));
		};
	},
]);

angular.module("qbePortal").controller("HomeFormController", [
	"$rootScope",
	"$scope",
	"dynamicRouter",
	"$state",
	"storage",
	"gtmService",
	"MAService",
	"Util",
	"userInputRepository",
	"portalServiceWrapper",
	"quoteOptions",
	"serviceResponseRepository",
	"quoteModelFactory",
	"paymentService",
	"$stateParams",
	"quoteRequestRepository",
	"$q",
	"tokenTimeoutService",
	"$compile",
	"$window",
	"smartLinkService",
	"campaignService",
	"embargoTestService",
	function (
		$rootScope,
		$scope,
		dynamicRouter,
		$state,
		storage,
		gtmService,
		MAService,
		util,
		userInputRepository,
		portalServiceWrapper,
		quoteOptions,
		serviceResponseRepository,
		quoteModelFactory,
		paymentService,
		$stateParams,
		quoteRequestRepository,
		$q,
		tokenTimeoutService,
		$compile,
		$window,
		smartLinkService,
		campaignService,
		embargoTestService
	) {
		var $ctrl = this;
		var MAX_ACCESSORY_VALUE = 5000;

		//check if session function is embedded and append directive
		if ($window.qbe.fieldLabels != undefined) {
			if (angular.isObject($window.qbe.fieldLabels.sessionFunction))
				angular
					.element("div#phglobaloptions_0_divOptionsComponents")
					.after($compile("<div qb-ng-dialog></div>")($scope));
		}

		/**
		 * routing initialisation, enabling/disabling (hiding/showing) available routes
		 * testing for allowed routes and redirecting when not allowed
		 */
		function initialiseRouting() {
			storage.removeItem("policy-date-input");

			var stepConditions = {
				"home.building": function () {
					return displayBuildingStep();
				},
				"home.payment": function () {
					return $state.$current.name != "home.done";
				},
				"home.done": function () {
					return $state.$current.name == "home.done";
				},
				"home.policy-start-date": function () {
					return $state.$current.name == "home.policy-start-date";
				},
			};
			dynamicRouter.initialise(
				$state.current.name,
				$state.$current.parent.name,
				stepConditions,
				markCompletedRouteCallback
			);
			$ctrl.title = dynamicRouter.getPageTitle();
			$ctrl.steps = dynamicRouter.getSteps();
		}

		function markCompletedRouteCallback(stateName) {
			storage.setItem("completed-step", stateName);
		}
		/** End of routing logic */

		function displayBuildingStep() {
			return !!userInputRepository.get(
				{},
				"homeForm.tellUsHowWeCanInsureYou.coverNeeds.building"
			);
		}

		$ctrl.validationErrors = null;
		$ctrl.sections = {};
		$ctrl.state = $state;
		$ctrl.isNextDisabled = false;
		$ctrl.storage = storage;
		$ctrl.formData = {};
		$ctrl.rapidEstimate = {};
		$ctrl.showRapidEstimate = false;
		$ctrl.pageState = {};
		$ctrl.convicitonDataObject = {};
		$ctrl.sideBarEmail = null;

		$ctrl.commonValues = {};

		$ctrl.quoteModel = quoteModelFactory.create();
		$ctrl.saveOnExit = false;
		$ctrl.smartLink = null;

		$window.onbeforeunload = function (event) {
			exitSaveQuote();
			if ($ctrl.saveOnExit) {
				$rootScope.$digest();
				return "Are you sure you want to leave?";
			}
		};

		$scope.$on("session-save-quote", exitSaveQuote);

		function exitSaveQuote() {
			var emailAddress = angular
				.element("div")
				.find("[label-key=yourEmailAddress]")
				.val();

			if (dynamicRouter.getPageTitle() != "Payment") {
				if (
					$ctrl.quoteModel.email != null ||
					$ctrl.sideBarEmail != null ||
					emailAddress != ""
				) {
					if ($ctrl.quoteModel && $ctrl.quoteModel.quoteResult) {
						$ctrl.saveOnExit = true;
						var formData = getUserInput();
						var paymentFrequency = "everyyear";

						portalServiceWrapper.updateQuote(formData);

						portalServiceWrapper
							.saveQuote(paymentFrequency, {
								quote: "true",
							})
							.then(function () {
								$rootScope.$broadcast("session-redirect");
							})
							.catch(function () {
								$rootScope.$broadcast("session-redirect");
							});
					} else {
						$rootScope.$broadcast("session-redirect");
					}
				} else $rootScope.$broadcast("session-redirect");
			}
		}

		// Broadcasts
		$rootScope.$broadcast("loading-animation-end");
		$rootScope.$broadcast("page-title-set", $ctrl.title);

		//Functions
		function scrollViewTo($element) {
			var offset = $element.offset();
			if (offset) {
				$("html, body").animate({
					scrollTop: offset.top - 50,
					scrollLeft: offset.left,
				});
			}
		}

		//Function call for Quick Quote
		function getQuickQuote(formData, callback) {
			portalServiceWrapper.updateQuote(formData);
			var quickQuoteOptions = quoteOptions.getOfferingPermutations(
				$state.current.name,
				getCoverOptions(formData)
			);
			if (quickQuoteOptions) {
				getQuickQuoteWith(quickQuoteOptions, callback);
			} else {
				return false;
			}
			return true;
		}

		function getRapidEstimate(formData, callback) {
			portalServiceWrapper.updateQuote(formData);
			var rapidEstimateOptions = quoteOptions.getOfferingPermutations(
				"rapidEstimate",
				getCoverOptions(formData)
			);
			getQuickQuoteWith(rapidEstimateOptions, callback);
		}

		function getQuickQuoteWith(quoteOptions, callback) {
			portalServiceWrapper
				.getQuickQuote(quoteOptions.permutations, quoteOptions.rules)
				.then(function (resp) {
					if (callback) callback(resp);
				})
				.catch(function (err) {
					broadcastError(err, "getQuickQuote error");
				});
		}

		function getRequote(formData, page, callback) {
			portalServiceWrapper.updateQuote(formData);
			var requoteOptions = quoteOptions.getOfferingPermutations(
				$state.current.name,
				getCoverOptions(formData)
			);
			if (requoteOptions) {
				portalServiceWrapper
					.getQuickQuote(
						requoteOptions.permutations,
						requoteOptions.rules
					)
					.then(function (resp) {
						if (callback) callback(resp);
					})
					.catch(function (err) {
						void 0;
						broadcastError(err, "Requote error");
					});
			} else {
				return false;
			}
			return true;
		}

		function getCoverOptions(formData) {
			if (formData.homeForm && formData.homeForm.tellUsAboutTheProperty) {
				return {
					homeOccupancy:
						formData.homeForm.tellUsAboutTheProperty
							.howIsHomeOccupied,
					buildingType:
						formData.homeForm.tellUsAboutTheProperty.typeOfBuilding,
					needs: formData.homeForm.tellUsHowWeCanInsureYou.coverNeeds,
					needRapidEstimate: true,
				};
			}

			throw "Not able to find the data for calculating permutations";
		}

		//Setting up initial values
		function getDefaultValues() {
			var defaultValues = {
				homeForm: {
					letsGetStarted: {
						startCoverDate: moment()
							.tz("Australia/Sydney")
							.format("DD/MM/YYYY"),
						personOrCompany: "person",
					},
					rapidEstimate: {
						needRapidEstimate: false,
					},
					mainPolicyHolderContact: {
						primaryPhone: "mobile",
					},
					additionalPolicyHolders: {
						primaryPhone: "mobile",
					},
					companyContactContact: {
						companyContactSamePostalAddress: true,
					},
					tellUsAboutTheBuilding: {
						homeLevels: "1",
					},
					mortgageOnProperty: {
						propertyMortgagedWith: [],
					},
					//quote page
					// confirmYourOptionalBenefits:{
					// 	accdLossDmgCoverBuilding: true,
					// 	accdLossDmgCoverContents: true
					// }
				},
			};

			var defaultStateExcess = quoteOptions.getStateDefaultVoluntaryExcess(
				$ctrl.quoteModel.state
			);
			if (defaultStateExcess != null) {
				var tempObj = {
					homeForm: {
						chooseYourExcess: {
							homeExcess: defaultStateExcess,
						},
					},
				};
				defaultValues = Object.extend(defaultValues, tempObj);
			}

			var defaultPortableContentStateExcess = quoteOptions.getStateDefaultVoluntaryExcess(
				$ctrl.quoteModel.state,
				1
			);
			if (defaultStateExcess != null) {
				var tempObj2 = {
					homeForm: {
						chooseYourExcess: {
							portableContentsExcess: defaultPortableContentStateExcess,
						},
					},
				};
				defaultValues = Object.extend(defaultValues, tempObj2);
			}

			return defaultValues;
		}

		function getUserInput() {
			var formData = getFormInput();
			userInputRepository.update(formData);
			return userInputRepository.get(getDefaultValues());
		}

		function getFormInput() {
			var formData = {};
			for (var key in $ctrl.sections) {
				formData[key] = $ctrl.sections[key].getValue();
			}

			if ($ctrl.sideBarEmail != null) {
				if (
					formData.homeForm.tellUsABitMore &&
					formData.homeForm.tellUsABitMore.yourEmailAddress
				)
					formData.homeForm.tellUsABitMore.yourEmailAddress =
						$ctrl.sideBarEmail;
				if (
					formData.homeForm.mainPolicyHolderContact &&
					formData.homeForm.mainPolicyHolderContact.emailAddress1
				)
					formData.homeForm.mainPolicyHolderContact.emailAddress1 =
						$ctrl.sideBarEmail;
			}

			return formData;
		}

		// This method does not work for arrays
		$ctrl.getFormItem = function (formNameWithField) {
			var finalValue = getFormInput();
			var items = formNameWithField.split(".");
			items.forEach(function (value, idx) {
				finalValue = finalValue[value];
			});
			return finalValue;
		};

		function proceedToNextStep(formData) {
			$rootScope.$broadcast("loading-animation-start");
			saveQuoteIfRequired(formData);
			testDeclineIfRequired(formData);
			$state.go(dynamicRouter.next(markCompletedRouteCallback));
		}

		function saveQuoteIfRequired(formData) {
			saveQuoteNotRequiredFor = []; // 'home.estimate' , 'home.property' , 'home.building' , 'home.covers', 'home.details', 'home.done'] ;
			var notRequired =
				saveQuoteNotRequiredFor.indexOf($state.$current.name) >= 0;
			if (!notRequired) {
				saveQuote(formData);
			}
		}

		$ctrl.back = function () {
			gtmService.trackEvent("back");
			$scope.$root.$broadcast("hide-top-banner");
			$scope.$broadcast("reset-field-errors");
			var backState = dynamicRouter.back();
			if (backState) $state.go(backState);
			else {
				var formData = getUserInput();
				if (formData.rapidEstimateUrl)
					window.location.href = formData.rapidEstimateUrl;
			}
		};

		function broadcastError(err, msg) {
			$rootScope.$broadcast("error", {
				errorMessage: msg,
				response: err,
			});
		}

		function saveQuote(formData, callback) {
			portalServiceWrapper.updateQuote(formData);

			var paymentFrequency = quoteOptions.getSelectedPaymentFrequencyForService();

			portalServiceWrapper
				.saveQuote(paymentFrequency)
				.then(function (resp) {
					$rootScope.$broadcast("loading-animation-end");
					var testEmbargo = embargoTestService.testEmbargoDecline(
						resp
					);

					if (testEmbargo != null) {
						$state.go(testEmbargo.declineType, testEmbargo);
						return false;
					}

					if (callback) callback(resp);
					return resp;
				})
				.catch(function (err) {
					if (tokenTimeoutService.isSessionTimedout()) {
						tokenTimeoutService.handleTimeout();
					} else {
						broadcastError(err, "Save quote error");
					}
					return err;
				});
		}

		$ctrl.save = function () {
			$ctrl.title = dynamicRouter.getPageTitle();

			$ctrl.showErrorSummary = false;
			isInvalid = $scope.homeForm.$invalid;
			if (isInvalid) {
				$scope.$broadcast("broadcast-field-errors");
				$ctrl.showErrorSummary = true;
				$scope.$broadcast("reset-field-errors");
				scrollViewTo($("#combinedValidationListing"));
				return;
			}

			getUserInput();
			setSelectedCoverType();
			$rootScope.$broadcast("open-modal", {
				modal: "saveQuote",
			});
		};

		$ctrl.getCoverType = function () {
			var formData = getUserInput();
			if (
				formData.homeForm.tellUsHowWeCanInsureYou &&
				formData.homeForm.tellUsHowWeCanInsureYou.coverNeeds
			) {
			} else {
				return null;
			}

			var building =
				formData.homeForm.tellUsHowWeCanInsureYou.coverNeeds.building;
			var content =
				formData.homeForm.tellUsHowWeCanInsureYou.coverNeeds.contents;

			if (building && content) {
				return "building_and_contents";
			} else if (building && !content) {
				return "building_only";
			} else if (!building && content) {
				return "contents_only";
			} else {
				return null;
			}
		};

		function clearPreviousQuotes() {
			serviceResponseRepository.update("quote", null);
			serviceResponseRepository.update("quickQuote", null);
			quoteRequestRepository.clearQuoteCredentials();
			quoteOptions.clearQuoteResults();
		}

		$ctrl.submitRapidEstimate = function (form) {
			var isInvalid = form.$invalid;
			if (isInvalid) {
				$scope.$broadcast("broadcast-field-errors");
				$ctrl.showErrorSummary = true;
				$scope.$broadcast("reset-field-errors");
				scrollViewTo($("#combinedValidationListing"));
				return;
			}

			gtmService.trackEvent("rapid-estimate-submit");

			clearPreviousQuotes();

			$rootScope.$broadcast("loading-animation-start");
			var formData = getUserInput();

			setSelectedCoverType();
			setOfferingOrDecline();
			getRapidEstimate(formData, function () {
				var quoteResults = serviceResponseRepository.getLastResponseFrom(
					"quickQuote"
				);
				$ctrl.showRapidEstimate = true;
				$scope.$root.$broadcast("process-rapid-estimates", {
					formData: formData,
					results: quoteResults,
				});
				$rootScope.$broadcast("loading-animation-end");
			});
		};

		/**
		 * message broadcasted by qbPaymentSummary to submit the form
		 */
		$scope.$on("form-submit", function (event, formName) {
			$ctrl.submit($scope[formName]);
		});

		/**
		 * message broadcasted by qbPaymentSummary to save the form
		 */
		$scope.$on("sidebar-save-quote", function (event, data) {
			$ctrl.sideBarEmail = data;
			$ctrl.save();
		});

		/**
		 * message broadcasted by qbPaymentSummary to assign the email address
		 */
		$scope.$on("sidebar-assign-mail", function (event, data) {
			if (data != "") $ctrl.sideBarEmail = data;
		});

		/*
		 * Emited by rapid estimate panel component
		 */
		$scope.$on("rapid-estimate-redirect", function () {
			$state.go(dynamicRouter.next(markCompletedRouteCallback));
		});

		$ctrl.submit = function (form) {
			$scope.$broadcast("form-submitted");
			var isInvalid = form.$invalid;
			if (isInvalid) {
				$scope.$broadcast("broadcast-field-errors");
				$ctrl.showErrorSummary = true;
				$scope.$broadcast("reset-field-errors");
				scrollViewTo($("#combinedValidationListing"));
				return;
			}
			gtmService.trackEvent("next");
			$scope.$root.$broadcast("loading-animation-start");
			var formData = getUserInput();

			checkEstimatedRebuildCost(formData);

			checkPrerequestDecline(formData);

			setSelectedCoverType();
			if (setOfferingOrDecline($state.$current.name == "home.estimate")) {
				var quickQuote = getQuickQuote(formData, function () {
					$ctrl.quoteModel = quoteModelFactory.create();
					$rootScope.$broadcast("perform-ma-service", "next");
					proceedToNextStep(formData);
				});
				if (!quickQuote) {
					proceedToNextStep(formData);
				}
			}
		};

		function checkSpotValue(quoteModel) {
			if (util.isUndefinedOrNull(quoteModel.cordelInfo)) {
				$state.go("referral", declineParams);
			}

			var sumInsured = util.isUndefinedOrNull(
				quoteModel.cordelInfo.spotValue
			)
				? 0
				: Math.floor(quoteModel.cordelInfo.spotValue);
			var lowerBand = util.isUndefinedOrNull(
				quoteModel.cordelInfo.lowerBand
			)
				? 0
				: Math.floor(quoteModel.cordelInfo.lowerBand);
			var declineParams = {
				declineType: "",
				declineCodes: "",
			};
			if (
				isNaN(sumInsured) ||
				sumInsured <= 0 ||
				isNaN(lowerBand) ||
				lowerBand <= 0
			) {
				$state.go("referral", declineParams);
			}
		}

		function checkEstimatedRebuildCost(formData) {
			if (
				formData.homeForm.yourBuilding &&
				formData.homeForm.yourBuilding.isEstimatedRebuildCost == "yes"
			) {
				var quoteModel = $ctrl.quoteModel;
				formData.homeForm.yourBuilding.buildingSumInsured = Math.floor(
					quoteModel.cordelInfo.spotValue
				);
			}

			if (
				formData.homeForm.confirmYourSumsInsured &&
				formData.homeForm.confirmYourSumsInsured
					.isYourEstimatedRebuildCost == "yes"
			) {
				var quoteModel = $ctrl.quoteModel;
				formData.homeForm.confirmYourSumsInsured.yourBuildingSumInsured = Math.floor(
					quoteModel.cordelInfo.spotValue
				);
			}
		}

		function setSelectedCoverType() {
			quoteOptions.setSelectedCoverType($ctrl.getCoverType(), "standard");
		}

		function setOfferingOrDecline(overwrite) {
			try {
				setSelectedOffering(overwrite);
				return true;
			} catch (ex) {
				/*
				 * this condition happens in case of no offering being available based on
				 * occupancy or other conditions.  This is condition happens for 'unoccupied' buildings
				 * at the moment.  @see HomeQuoteModel.getOfferings() for more details.
				 */
				declinePolicy({
					declineType: "decline",
				});
				return false;
			}
		}

		//!important - decline check is added in frontend as it is required for
		// release and GW wont be able to do that now
		function checkPrerequestDecline(formData) {
			var decline = false;

			if (
				formData.homeForm &&
				formData.homeForm.tellUsAboutTheProperty &&
				formData.homeForm.tellUsAboutTheProperty.address &&
				formData.homeForm.tellUsAboutTheProperty.address.state ==
					"AU_WA"
			) {
				//address in WA
				if (
					["duplex", "triplex", "villa", "townhouse"].indexOf(
						formData.homeForm.tellUsAboutTheProperty.typeOfBuilding
					) > -1
				) {
					// is 'duplex', 'triplex', 'villa', 'townhouse'
					if (
						formData.homeForm.tellUsAboutTheBuilding
							.isStrataRegdCorp === "yes"
					) {
						//managed by professional agent
						if (formData.homeForm.tellUsAboutTheBuilding) {
							if (
								formData.homeForm.tellUsAboutTheBuilding
									.areUnitAboveBelow === true
							) {
								//decline if units are above or below
								decline = true;
							} else {
								if (
									formData.homeForm.tellUsAboutTheBuilding
										.corpInsureUnit === "no"
								) {
									//decine if body corporate doesnt allows to insure
									decline = true;
								}
							}
						}
					}
				}
			}

			if (decline) {
				declinePolicy({
					declineType: "decline",
				});
			}
		}

		//sets the selected offering if none is available
		//overwrite - if true the offering is updated even if it is already available
		function setSelectedOffering(overwrite) {
			$ctrl.quoteModel = quoteModelFactory.create();
			var availableOfferings = $ctrl.quoteModel.getOfferings();
			if (overwrite) {
				quoteOptions.setSelectedOffering(availableOfferings[0]);
			} else {
				if (!quoteOptions.getSelectedOffering())
					quoteOptions.setSelectedOffering(availableOfferings[0]);
			}
		}

		//handler for the home Events
		$scope.$on("home-rapid-estimate", function (event, form) {
			$ctrl.submitRapidEstimate(form);
		});

		$ctrl.isRapidEstimateVisible = function () {
			if ($ctrl.commonValues.needRapidEstimate) {
				return true;
			} else {
				return false;
			}
		};

		$ctrl.refreshAddress = function () {
			$ctrl.formData = getUserInput();
			var address = null;
			if (
				$ctrl.formData.homeForm &&
				$ctrl.formData.homeForm.tellUsAboutTheProperty &&
				$ctrl.formData.homeForm.tellUsAboutTheProperty.address
			) {
				address =
					$ctrl.formData.homeForm.tellUsAboutTheProperty.address;
			}
			portalServiceWrapper.refreshAddress(address).then(
				function (resp) {
					serviceResponseRepository.update(
						"addressSearch",
						resp.data
					);
					$rootScope.$broadcast("update-quote-model-reference");
				},
				function (error) {
					void 0;
				}
			);
		};

		function testDeclineIfRequired(formData) {
			var declineTestRequiredFor = [
				"home.property",
				"home.building",
				"home.covers",
				"home.details",
				"home.quote",
				"home.contact",
			];
			var testRequired =
				declineTestRequiredFor.indexOf($state.$current.name) >= 0;
			if (testRequired) {
				testDecline(formData);
			}
		}

		function testDecline(formData) {
			portalServiceWrapper.updateQuote(formData);
			var declineQuoteOptions = quoteOptions.getTestQuoteDeclineOptions(
				$state.$current.name
			);
			portalServiceWrapper
				.testQuoteDecline(declineQuoteOptions)
				.catch(function (decline) {
					performMAServices("declined");
					declinePolicy(decline, "Policy Was Declined");
				});
		}

		function declinePolicy(decline) {
			var redirectPage = decline.declineType || "decline";

			//Check if needs to be redirected
			formData = getUserInput();

			if (
				formData.homeForm &&
				formData.homeForm.cycleCover &&
				formData.homeForm.cycleCover.coverItemsList
			) {
				var shouldRefer =
					getTotalValue(formData.homeForm.cycleCover.coverItemsList) >
					MAX_ACCESSORY_VALUE;
				if (shouldRefer) {
					redirectPage = "referral";
					decline.declineType = "referral";
				}
			}

			storage.clear();
			if (redirectPage == "referral") {
				$state.go(redirectPage, decline);
			} else {
				$state.go(redirectPage, decline);
			}
			// window.location.href = $ctrl.parentPath + '/home/' + redirectPage;
			return;
		}

		function getTotalValue(list) {
			var totalValue = 0;

			list.forEach(function (value) {
				totalValue += Number(value.value);
			});

			return totalValue;
		}

		/**
		 * QbFormSections register themselves with the form controller.
		 * This is done automatically by the form section upon initialisation.
		 * @name : name of the form section
		 * @init : function callback initialise the section
		 * @getValueFn: function callback to get the value of the section.
		 */
		$ctrl.registerSection = function (name, init, getValueFn) {
			$ctrl.sections[name] = {
				initValue: init,
				getValue: getValueFn,
			};
		};

		/**
		 * Takes care of
		 * - registering the labels generated by sitecore
		 * - setting default values
		 * - prepopulating retrieve quote if required.
		 */
		$ctrl.initPage = function () {
			initialiseRouting();
			// $ctrl.isNextDisabled = false;
			$scope.$on("disable-next", function (event, disable) {
				$ctrl.isNextDisabled = disable;
			});

			$scope.$on("conviction-check", function (event, convictionData) {
				// $ctrl.isNextDisabled = disable;
				if (convictionData) {
					$ctrl.convicitonDataObject[
						convictionData.conviction
					] = convictionData;
				}

				var disabled = false;
				for (var item in $ctrl.convicitonDataObject) {
					// console.log($ctrl.convicitonDataObject[item].section[$ctrl.convicitonDataObject[item].conviction].$name)
					if ($ctrl.convicitonDataObject[item].input === "unknown") {
						//additional check to see if the element exists on screen
						if (
							$(
								'[name="' +
									$ctrl.convicitonDataObject[item].section[
										$ctrl.convicitonDataObject[item]
											.conviction
									].$name +
									'"]'
							).length > 0
						) {
							disabled = true;
						}
					}
				}
				$ctrl.isNextDisabled = disabled;
			});

			// debugger;
			util.dispatchCustomEvent("register-labels");
			$ctrl.formData = getUserInput();
			var form = $ctrl.formData.homeForm;

			$ctrl.quoteModel = quoteModelFactory.create();

			if ($ctrl.state.current.name == "home.estimate") {
				invalidatePreviousQuote();
			}
			prepopulateRetrievedQuote();

			//enrich address
			$ctrl.refreshAddress();
			applyPromoCodeThroughLink();
			setWebBotValues();
		};

		function applyPromoCodeThroughLink() {
			if ($stateParams.promotionalCode) {
				var formData = $ctrl.formData;
				if (formData.homeForm) {
					formData.homeForm.tellUsABitMore =
						formData.homeForm.tellUsABitMore || {};
					formData.homeForm.tellUsABitMore.promotionalCode =
						$stateParams.promotionalCode;
				}
			}
		}

		function setWebBotValues() {
			if (
				$stateParams.isSyntheticTransaction_Ext &&
				$stateParams.syntheticSource_Ext
			) {
				var formData = $ctrl.formData;

				if (
					formData.homeForm &&
					$stateParams.isSyntheticTransaction_Ext == "true"
				) {
					formData.homeForm.isSyntheticTransaction_Ext =
						$stateParams.isSyntheticTransaction_Ext;
					formData.homeForm.syntheticSource_Ext =
						$stateParams.syntheticSource_Ext;
				}
			}
		}

		function prepopulateRetrievedQuote() {
			if ($stateParams.quoteNo && $stateParams.email) {
				gtmService.trackEvent("retrieve-quote");
				$rootScope.$broadcast("loading-animation-start");
				portalServiceWrapper
					.retrieveSavedQuote(
						$stateParams.quoteNo,
						$stateParams.email
					)
					.then(function (transformedQuote) {
						$q.when(
							portalServiceWrapper.refreshAddress(
								transformedQuote.tellUsAboutTheProperty.address
							)
						).then(function () {
							$ctrl.formData.homeForm = transformedQuote;
							var serviceResponse = storage.getItem(
								"service-response"
							);

							storage.setItem(
								"policy-address",
								serviceResponse.quote.policyAddress
							);

							userInputRepository.update($ctrl.formData);
							quoteOptions.setSelectedOffering(
								transformedQuote.info.offering
							);
							storage.setItem("retrieve", true);

							var testEmbargo = embargoTestService.testEmbargoDecline(
								serviceResponse
							);

							if (testEmbargo != null) {
								$state.go(testEmbargo.declineType, testEmbargo);
								return false;
							}

							if (
								moment()
									.tz("Australia/Sydney")
									.format("YYYY/MM/DD") >
								moment(serviceResponse.quote.periodStartDate)
									.tz("Australia/Sydney")
									.format("YYYY/MM/DD")
							) {
								storage.setItem(
									"policy-date-input",
									$ctrl.formData
								);
								$state.go(
									"home.policy-start-date",
									{
										quoteNo: "",
										email: "",
									},
									{
										location: true,
										reload: true,
									}
								);
							} else {
								$state.go(
									"home.property",
									{
										quoteNo: "",
										email: "",
									},
									{
										location: true,
										reload: true,
									}
								);
							}
						});
					})
					.catch(function () {
						var expiredQuote = storage.getItem("expired-quote");
						if (expiredQuote.displayStatus == "Expired") {
							storage.removeItem("expired-quote");
							window.location.href = util.linkBuilder(
								window.qbe.fieldLabels.expiredQuoteRedirect
									.homeExpired
							);
						}
					});
			}
		}

		//Updated data based on the common value
		function updateFormDataBasedOnCommonValues(name) {
			if (
				[
					"typeOfBuilding",
					"wallsMadeOf",
					"howIsHomeOccupied",
					"propertyProfessionalAgent",
				].indexOf(name) > -1
			) {
				$ctrl.formData = getUserInput();
				var formData = $ctrl.formData;
				//reset cover needs
				if (
					formData.homeForm.tellUsHowWeCanInsureYou &&
					formData.homeForm.tellUsHowWeCanInsureYou.coverNeeds
				) {
					formData.homeForm.tellUsHowWeCanInsureYou.coverNeeds = {};
				}

				$ctrl.formData = formData;
			}
		}

		$ctrl.initEstimatePage = function () {
			$ctrl.initPage();
			// $ctrl.refreshAddress();

			$scope.$root.$on("common-value-update", function (event, update) {
				$ctrl.commonValues[update.name] = update.value;
				updateFormDataBasedOnCommonValues(update.name);
			});

			var form = $ctrl.formData.homeForm;
			var quoteModel = $ctrl.quoteModel;

			if (form.rapidEstimate) {
				// form.rapidEstimate.needRapidEstimate = false;
				// QBE would like to keep this persistent.
			}
			$ctrl.formData.homeForm = form;
		};

		$ctrl.initPropertyPage = function () {
			// re-trigger pulsating icon to wait for the quote service return
			var triggerPulse = storage.getItem("retrieve");
			if (angular.equals(triggerPulse, {})) {
				$rootScope.$broadcast("loading-animation-start");
			}

			$ctrl.initPage();
			var form = $ctrl.formData.homeForm;
			var quoteModel = $ctrl.quoteModel;

			if (quoteModel.address.state === "AU_WA") {
				if (
					["unit", "flat"].indexOf(
						form.tellUsAboutTheProperty.typeOfBuilding
					) != -1 &&
					quoteModel.getHomeNeedType() != "contents_only" &&
					quoteModel.isBuildingFloodSafe()
				) {
					if (!form.tellUsAboutTheBuilding) {
						form.tellUsAboutTheBuilding = {};
					}
					form.tellUsAboutTheBuilding.isUnitAboveGround = false;
				} else {
				}
			}

			$ctrl.formData.homeForm = form;
		};

		$ctrl.initCoverPage = function () {
			$ctrl.initPage();
			var form = $ctrl.formData.homeForm;
			var quoteModel = $ctrl.quoteModel;

			if (quoteModel.dwelling.coverType !== "contents_only") {
				checkSpotValue(quoteModel);
			}

			if (form.tellUsHowWeCanInsureYou) {
				if (!form.portableContents) {
					form.portableContents = {};
					form.portableContents.coverPortableContents =
						form.tellUsHowWeCanInsureYou.needCoverOutsideHome ==
						true;
				}
			}

			if (form.rapidEstimate) {
				// copy quote/confirmYourSumsInsured to cover/yourBuilding values after requote
				if (form.confirmYourSumsInsured) {
					if (
						form.confirmYourSumsInsured.isYourEstimatedRebuildCost
					) {
						form.yourBuilding.isEstimatedRebuildCost =
							form.confirmYourSumsInsured.isYourEstimatedRebuildCost;
					}

					if (form.confirmYourSumsInsured.yourBuildingSumInsured) {
						form.yourBuilding.buildingSumInsured =
							form.confirmYourSumsInsured.yourBuildingSumInsured;
					}

					if (form.confirmYourSumsInsured.yourContentsSumInsured) {
						form.yourContents.contentsSumInsured =
							form.confirmYourSumsInsured.yourContentsSumInsured;
					}
				} else {
					if (!form.yourBuilding) {
						form.yourBuilding = {};

						if (form.rapidEstimate.buildingInsureAmount) {
							form.yourBuilding.buildingSumInsured =
								form.rapidEstimate.buildingInsureAmount;
						}
					}
					if (!form.yourContents) {
						form.yourContents = {};

						if (form.rapidEstimate.contentInsureAmount) {
							form.yourContents.contentsSumInsured =
								form.rapidEstimate.contentInsureAmount;
						}
					}
				}

				//set rent from rapid estimate if available
				if (!form.rentDefault) {
					form.rentDefault = {};

					form.rentDefault.rentDefault = true;
					if (form.rapidEstimate.rentDefaultCoverAmount) {
						form.rentDefault.rentCurrentWeekly =
							form.rapidEstimate.rentDefaultCoverAmount;
					}

					if (form.rapidEstimate.uptoWeeks) {
						form.rentDefault.rentXWeeks =
							form.rapidEstimate.uptoWeeks;
					}
				}
			}

			if (
				form.tellUsHowWeCanInsureYou &&
				form.tellUsHowWeCanInsureYou.coverNeeds &&
				form.tellUsHowWeCanInsureYou.coverNeeds.malicious_damage
			) {
				if (!form.theftAndVandalismByTenants) {
					form.theftAndVandalismByTenants = {
						theftCoverContents: true,
						theftCoverBuilding: true,
					};
				}
			}

			$ctrl.formData.homeForm = form;
		};

		$ctrl.initQuotePage = function () {
			$ctrl.initPage();

			var form = $ctrl.formData.homeForm;
			var quoteModel = $ctrl.quoteModel;

			if (!form.confirmYourLevelOfCover) {
				form.confirmYourLevelOfCover = {};
			}

			//sets selected offering
			var offering = quoteOptions.getSelectedOffering();
			if (offering.descriptor) {
				form.confirmYourLevelOfCover.yourChosenCover =
					offering.descriptor;
			} else {
				void 0;
			}

			//sets the sum insured
			if (!form.confirmYourSumsInsured) {
				form.confirmYourSumsInsured = {};
			}

			if (form.yourBuilding && form.yourBuilding.isEstimatedRebuildCost) {
				form.confirmYourSumsInsured.isYourEstimatedRebuildCost =
					form.yourBuilding.isEstimatedRebuildCost;
			}

			if (form.yourBuilding && form.yourBuilding.buildingSumInsured) {
				form.confirmYourSumsInsured.yourBuildingSumInsured =
					form.yourBuilding.buildingSumInsured;
			}

			if (form.yourContents && form.yourContents.contentsSumInsured) {
				form.confirmYourSumsInsured.yourContentsSumInsured =
					form.yourContents.contentsSumInsured;
			}

			if (
				form.portableContents &&
				form.portableContents.coverPortableContentLimit
			) {
				form.confirmYourSumsInsured.generalPortableContentsLimit =
					form.portableContents.coverPortableContentLimit;
			}

			//accidental Damage
			if (!form.confirmYourOptionalBenefits) {
				form.confirmYourOptionalBenefits = {};
			}
			if (
				form.accidentalLossOrDamage &&
				form.accidentalLossOrDamage.coverAccDmgBuilding
			) {
				// confirmYourOptionalBenefits
				form.confirmYourOptionalBenefits.accdLossDmgCoverBuilding =
					form.accidentalLossOrDamage.coverAccDmgBuilding == true;
			} else {
				form.confirmYourOptionalBenefits.accdLossDmgCoverBuilding = false;
			}

			if (
				form.accidentalLossOrDamage &&
				form.accidentalLossOrDamage.coverAccDmgContents
			) {
				form.confirmYourOptionalBenefits.accdLossDmgCoverContents =
					form.accidentalLossOrDamage.coverAccDmgContents == true;
			} else {
				form.confirmYourOptionalBenefits.accdLossDmgCoverContents = false;
			}

			if (
				form.domesticWorkerCompensation &&
				form.domesticWorkerCompensation.domesticWorkerCompCover
			) {
				form.confirmYourOptionalBenefits.domesticWrkCompCover =
					form.domesticWorkerCompensation.domesticWorkerCompCover ==
					true;
			} else {
				form.confirmYourOptionalBenefits.domesticWrkCompCover = false;
			}

			$ctrl.formData.homeForm = form;
			// getRequote(formData);
			// $scope.$broadcast('requote') ;
			void 0;
		};

		$ctrl.initContactPage = function () {
			$ctrl.initPage();
			setDefaultContactValues();
			// 	var form 		= $ctrl.formData.homeForm;
			// 	var quoteModel 	= $ctrl.quoteModel;
			//
			// 	// if ( !form.mainPolicyHolderContact ){
			// 	// 	form.mainPolicyHolderContact = {};
			// 	// 	form.mainPolicyHolderContact.primaryPhone = 'mobile';
			// 	// }
			//
			//
			//
			// 	$ctrl.formData.homeForm = form;
			//
		};

		function setDefaultContactValues() {
			var formData = getUserInput(),
				form = formData.homeForm,
				postalAddress = storage.getItem("policy-address");

			if (form.letsGetStarted.personOrCompany == "person") {
				form.mainPolicyHolder = form.mainPolicyHolder || {};

				form.mainPolicyHolderContact.personContactSamePostalAddress = true;

				if (form.mainPolicyHolderContact.address == undefined) {
					form.mainPolicyHolderContact.address =
						form.tellUsAboutTheProperty.address;
				}

				if (Object.keys(postalAddress).length > 0) {
					if (
						postalAddress.addressLine1 !==
							form.mainPolicyHolderContact.address.addressLine1 &&
						postalAddress.postalCode !==
							form.mainPolicyHolderContact.address.postalCode
					) {
						form.mainPolicyHolderContact.personContactSamePostalAddress = false;
						form.mainPolicyHolderContact.postalAddress = postalAddress;
					}
				}
			} else {
				if (Object.keys(postalAddress).length > 0) {
					if (
						postalAddress.addressLine1 !==
							form.companyContactContact
								.companyContactResidentialAddress
								.addressLine1 &&
						postalAddress.postalCode !==
							form.companyContactContact
								.companyContactResidentialAddress.postalCode
					) {
						form.companyContactContact.companyContactSamePostalAddress = false;
						form.companyContactContact.postalAddress = postalAddress;
					}
				}
			}
			$ctrl.formData.homeForm = form;
		}

		/**
		 * Initialisation method of the payment page
		 */
		$ctrl.initPaymentPage = function () {
			// $ctrl.storage.checkValidity();
			$ctrl.initPage();

			var form = $ctrl.formData.homeForm;
			var quoteModel = $ctrl.quoteModel;
			// $ctrl.termsAndConditions = false;
			//
			// var formData = getUserInput();
			// formData.paymentForm.paymentDetails.termsAndConditions = false ;
			// $ctrl.formData = formData ;
			//
			// getQuickQuote(formData);
			$scope.$on("payment-method-changed", function (
				event,
				paymentMethod
			) {
				$ctrl.paymentMethod = paymentMethod;
			});

			$scope.$on("terms-and-conditions-changed", function (
				event,
				termsAndConditions
			) {
				$ctrl.termsAndConditions = termsAndConditions;
			});
		};

		function constructDonePageViewModel() {
			var done = {
				policyNumber: $stateParams.policyNumber,
				accountNumber: $stateParams.accountNumber,
				isAwaitingProcess: $stateParams.isAwaitingProcess,
				policyType: $ctrl.quoteModel.getSelectedOffering().label,
				policyStartDate: $ctrl.quoteModel.policyStartDate,
				address: $ctrl.quoteModel.address,
				purchaseDate: moment()
					.tz("Australia/Sydney")
					.format("DD/MM/YYYY"),
				smartLinkURL: $window.qbe.fieldLabels.smartLink.url,
				hashKey: $window.qbe.fieldLabels.smartLink.hashKey,
				email: $ctrl.quoteModel.email,
				description: "Home Insurance",
				productRefs: "Home Insurance",
			};

			if ($ctrl.quoteModel.homeForm.mainPolicyHolder) {
				done.policyHolderName =
					$ctrl.quoteModel.homeForm.mainPolicyHolder.firstName +
					" " +
					$ctrl.quoteModel.homeForm.mainPolicyHolder.lastName;
			} else if ($ctrl.quoteModel.homeForm.companyContact) {
				done.policyHolderName =
					$ctrl.quoteModel.homeForm.companyContact.firstName +
					" " +
					$ctrl.quoteModel.homeForm.companyContact.lastName;
				done.email = $ctrl.quoteModel.homeForm.companyContact.email;
			}

			return done;
		}

		$ctrl.initDonePage = function () {
			$ctrl.initPage();

			var quoteModel = $ctrl.quoteModel;
			var done = storage.getItem("done");
			if (!done || !done.policyNumber) {
				done = constructDonePageViewModel();
				$ctrl.smartLink = smartLinkService.generateLink(done);
				gtmService.trackTransaction(
					$state.current,
					done,
					$ctrl.quoteModel
				);
				performMAServices("paid");
			}

			$ctrl.storage.clear();
			storage.setItem("done", done);
			var $columns = $(".columns").get(0);
			$columns.classList.remove("print-ready");
			$ctrl.done = done;
			$ctrl.done.campaignSteps = {};

			// check if campaign code is valid
			if (
				quoteModel.quoteResult.response.isCampaignCodeValid ||
				quoteModel.quoteResult.response.isGiftCardApplied
			) {
				// get campaign next steps
				$ctrl.done.campaignSteps = campaignService.getCampaignConfig(
					quoteModel.quoteResult.response.campaignCode,
					true
				);
			} else $ctrl.done.campaignSteps.isCampaignCodeValid = false;
		};

		$scope.$on("submit-feedback", submitFeedback);

		function submitFeedback() {
			if ($ctrl.done.policyNumber != null && $ctrl.smartLink != null) {
				window.open($ctrl.smartLink, "_blank");
			} else {
				void 0;
			}
		}

		//Events
		/**
		 * Any generic breaking errors should broadcast 'error' to the rootScope. This will cause redirection
		 * to the main error page.
		 */
		$scope.$on("error", function (event, error) {
			$state.go("error", error);
		});

		/**
		 * calls MA Services to add marketing data.
		 */
		$scope.$on("perform-ma-service", function (event, triggeredBy) {
			performMAServices(triggeredBy);
		});

		/**
		 * Enrich address on address selection
		 */
		$scope.$on("enrich-address", function (value) {
			$ctrl.refreshAddress();
		});

		$scope.$on("back", function () {
			gtmService.trackEvent("back");
			$ctrl.back();
		});

		$scope.$on("invalidate-quotes", invalidatePreviousQuote);

		function invalidatePreviousQuote() {
			serviceResponseRepository.update("quote", null);
			quoteRequestRepository.clearQuoteCredentials();
			storage.removeItem("policy-address");
		}

		/**
		 * called from qbFormSection and any other panel that requires a requote based on new values.
		 */
		$scope.$on("requote", function (event, form) {
			gtmService.trackEvent("requote");
			$rootScope.$broadcast("loading-animation-start");
			var formData = getUserInput();

			checkEstimatedRebuildCost(formData);

			getRequote(formData, null, function (resp) {
				$rootScope.$broadcast("loading-animation-end");
				$rootScope.$broadcast("quote-received", resp);
				$rootScope.$broadcast("selected-quote-changed");
			});
		});

		/**
		 * message broadcasted by qbFormSection.directive to move to a page
		 */
		$scope.$on("moveToPage", function (event, page) {
			$ctrl.moveToPage(page);
		});

		$ctrl.moveToPage = function (page) {
			$state.go(page);
		};

		function performMAServices(eventName) {
			getUserInput();
			var mainPolicyHolder = userInputRepository.get(
				{},
				"homeForm.mainPolicyHolder"
			);
			var policyEmail = userInputRepository.get({}, "email");
			if (policyEmail) {
			} else {
				policyEmail = userInputRepository.get(
					{},
					"homeForm.tellUsABitMore.yourEmailAddress"
				);
			}
			var quoteResult = quoteOptions.getSelectedQuoteResult();
			var savedQuote = serviceResponseRepository.getLastResponseFrom(
				"quote"
			);
			var quoteModel = $ctrl.quoteModel;
			var maData = {
				state: quoteModel ? quoteModel.state : null,
				postCode: quoteModel ? quoteModel.postCode : null,
				campaignCode: quoteModel ? quoteModel.campaignCode : null,
				pageName: $state.current.name,
				mainPolicyHolder: mainPolicyHolder,
				policyEmail: policyEmail,
				annualResult: quoteResult ? quoteResult.getAnnual() : null,
				monthlyResult: quoteResult ? quoteResult.getMonthly() : null,
				quoteId: savedQuote ? savedQuote.quoteID : null,
			};

			if ($state.current.name == "home.done") {
				maData.inceptionDate = moment()
					.tz("Australia/Sydney")
					.format("DD/MM/YYYY");
			}

			if (
				quoteModel &&
				quoteModel.address &&
				quoteModel.address.addressLine1
			) {
				maData.address =
					quoteModel.address.addressLine1 +
					" " +
					quoteModel.address.city;
			}

			if (
				quoteModel &&
				quoteModel.homeForm &&
				quoteModel.homeForm.mainPolicyHolderContact &&
				quoteModel.homeForm.mainPolicyHolderContact.contactNumber
			) {
				maData.contactNumber =
					quoteModel.homeForm.mainPolicyHolderContact.contactNumber;
			}

			MAService.mergeContacts(eventName, maData);
		}
	},
]);

angular.module("qbePortal").controller("PaymentController", [
	"$rootScope",
	"$scope",
	"$state",
	"$stateParams",
	"$window",
	"userInputRepository",
	"serviceResponseRepository",
	"quoteOptions",
	"paymentService",
	"quoteModelFactory",
	"dynamicRouter",
	"portalServiceWrapper",
	"MAService",
	"labelService",
	"Util",
	"$q",
	"storage",
	"jwtHelper",
	"gtmService",
	"quoteRequestRepository",
	"MODULE_INFO",
	"$compile",
	"$sce",
	"paymentLoggerService",
	"CREDIT_CARD_ATTEMPT",
	function (
		$rootScope,
		$scope,
		$state,
		$stateParams,
		$window,
		userInputRepository,
		serviceResponseRepository,
		quoteOptions,
		paymentService,
		quoteModelFactory,
		dynamicRouter,
		portalServiceWrapper,
		MAService,
		labelService,
		util,
		$q,
		storage,
		jwtHelper,
		gtmService,
		quoteRequestRepository,
		MODULE_INFO,
		$compile,
		$sce,
		paymentLoggerService,
		CREDIT_CARD_ATTEMPT
	) {
		var $ctrl = this;
		$ctrl.showPaymentProcessError = false;
		$ctrl.paymentAttempCounter = 0;
		$rootScope.$broadcast("loading-animation-end");

		//check if session function is embedded and append directive
		if ($window.qbe.fieldLabels != undefined) {
			if (angular.isObject($window.qbe.fieldLabels.sessionFunction))
				angular
					.element("div#phglobaloptions_0_divOptionsComponents")
					.after($compile("<div qb-ng-dialog></div>")($scope));
		}

		$scope.$on("session-save-quote", function () {
			$rootScope.$broadcast("session-redirect");
		});

		$ctrl.getLabelFor = function (fieldName) {
			return $sce.trustAsHtml(labelService.getLabelFor(fieldName));
		};

		/**
		 * routing initialisation, enabling/disabling (hiding/showing) available routes
		 * testing for allowed routes and redirecting when not allowed
		 */
		function markCompletedRouteCallback(stateName) {
			storage.setItem("completed-step", stateName);
		}

		function initialiseRouting() {
			switch ($state.$current.parent.name) {
				case "vehicle":
					var stepConditions = {
						"vehicle.policy-start-date": function () {
							return (
								$state.$current.name ==
								"vehicle.policy-start-date"
							);
						},
					};
					break;
				case "home":
					var stepConditions = {
						"home.policy-start-date": function () {
							return (
								$state.$current.name == "home.policy-start-date"
							);
						},
					};
					break;
				case "caravan":
					var stepConditions = {
						"caravan.policy-start-date": function () {
							return (
								$state.$current.name ==
								"caravan.policy-start-date"
							);
						},
					};
					break;
				case "bike":
					var stepConditions = {
						"bike.policy-start-date": function () {
							return (
								$state.$current.name == "bike.policy-start-date"
							);
						},
					};
					break;
				default:
			}

			dynamicRouter.initialise(
				$state.current.name,
				$state.$current.parent.name,
				stepConditions,
				markCompletedRouteCallback
			);
			$ctrl.title = dynamicRouter.getPageTitle();
			$ctrl.steps = dynamicRouter.getSteps();
		}
		/** End of routing logic */

		$ctrl.state = $state;
		$ctrl.storage = storage;
		$ctrl.sections = {};
		$ctrl.moduleId = MODULE_INFO.id;

		$ctrl.cybersourceiFrameUrl = $state.href(
			"cybersourcePaymentForm",
			null,
			{ absolute: true }
		);

		// TODO: better iframe solution
		$ctrl.addCybersourceiFrame = $ctrl.addCybersourceRetryAttempt = $ctrl.addCybersourceLastAttempt = false;

		$ctrl.summaryModel = quoteModelFactory.create();

		function getDefaultValues() {
			return {
				fromFullQuote: true,
				paymentForm: {
					paymentDetails: {
						paymentOptions: "yearly",
					},
				},
			};
		}

		function scrollViewTo($element) {
			var offset = $element.offset();
			if (offset) {
				$("html, body").animate({
					scrollTop: offset.top - 50,
					scrollLeft: offset.left,
				});
			}
		}

		/**
		 * QbFormSections register themselves with the form controller.
		 * This is done automatically by the form section upon initialisation.
		 * @name : name of the form section
		 * @init : function callback initialise the section
		 * @getValueFn: function callback to get the value of the section.
		 */
		$ctrl.registerSection = function (name, init, getValueFn) {
			$ctrl.sections[name] = {
				initValue: init,
				getValue: getValueFn,
			};
		};

		/**
		 * Any generic breaking errors should broadcast 'error' to the rootScope. This will cause redirection
		 * to the main error page.
		 */
		$scope.$on("error", function (event, error) {
			$state.go("error", error);
		});

		/**
		 * calls MA Services to add marketing data.
		 */
		$scope.$on("perform-ma-service", function (event, triggeredBy) {
			performMAServices(triggeredBy);
		});

		$scope.$on("back", function () {
			gtmService.trackEvent("back");
			$ctrl.back();
		});

		/**
		 * called from qbFormSection and any other panel that requires a requote based on new values.
		 */
		$scope.$on("requote", function (event, page) {
			gtmService.trackEvent("requote");
			$rootScope.$broadcast("loading-animation-start");
			var formData = getUserInput();
			getRequote(formData, page, function (resp) {
				$rootScope.$broadcast("loading-animation-end");
				$rootScope.$broadcast("quote-received", resp);
				$rootScope.$broadcast("selected-quote-changed");
			});
		});

		function getUserInput() {
			var formData = getFormInput();
			userInputRepository.update(formData);
			return userInputRepository.get(getDefaultValues());
		}

		function getFormInput() {
			var formData = {};
			for (var key in $ctrl.sections) {
				formData[key] = $ctrl.sections[key].getValue();
			}
			return formData;
		}

		function getRequote(formData, page, callback) {
			portalServiceWrapper.updateQuote(formData);
			var requoteOptions = quoteOptions.getRequoteOptions(
				MODULE_INFO.paymentPageRouteName
			);
			if (requoteOptions) {
				portalServiceWrapper
					.getQuickQuote(
						requoteOptions.permutations,
						requoteOptions.rules
					)
					.then(function (resp) {
						if (callback) callback(resp);
					})
					.catch(function (err) {
						void 0;
						broadcastError(err, "Requote error");
					});
			} else {
				return false;
			}
			return true;
		}

		$ctrl.save = function () {
			$rootScope.$broadcast("open-modal", { modal: "saveQuote" });
		};

		$ctrl.back = function () {
			gtmService.trackEvent("back");
			$scope.$root.$broadcast("hide-top-banner");
			$scope.$broadcast("reset-field-errors");
			var backState = dynamicRouter.back();
			if (backState) $state.go(backState);
			else {
				var formData = getUserInput();
				if (formData.rapidEstimateUrl)
					window.location.href = formData.rapidEstimateUrl;
			}
		};

		$ctrl.submit = function (form) {
			gtmService.trackEvent("click-payment");
			$ctrl.showErrorSummary = false;
			if (form.$invalid) {
				$scope.$broadcast("broadcast-field-errors");
				$ctrl.showErrorSummary = true;
				$scope.$broadcast("reset-field-errors");
				scrollViewTo($("#combinedValidationListing"));
				return;
			}

			processPayment(form);
		};

		function performMAServices(eventName) {
			getUserInput();
			var mainPolicyHolder = userInputRepository.get(
				{},
				"caravanForm.mainPolicyHolder"
			);
			var policyEmail = userInputRepository.get({}, "email");
			var quoteResult = quoteOptions.getSelectedQuoteResult();
			var savedQuote = serviceResponseRepository.getLastResponseFrom(
				"quote"
			);
			var maData = {
				pageName: $state.current.name,
				mainPolicyHolder: mainPolicyHolder,
				policyEmail: policyEmail,
				annualResult: quoteResult.getAnnual(),
				monthlyResult: quoteResult.getMonthly(),
				quoteId: savedQuote ? savedQuote.quoteID : null,
			};
			MAService.mergeContacts(eventName, maData);
		}

		function processPayment(form) {
			formData = getUserInput();

			var paymentDetailsForm = form.paymentDetails;

			userInputRepository.update(formData);

			$ctrl.paymentAttempCounter++; // iterate payment attempt
			$ctrl.showPaymentProcessError = false;
			$ctrl.paymentMethod =
				formData.paymentForm.paymentDetails.paymentMethod;

			$rootScope.$broadcast("loading-animation-start");
			switch (formData.paymentForm.paymentDetails.paymentMethod) {
				case "creditcard":
					payByCreditCard(formData, paymentDetailsForm);
					break;
				case "paypal":
					// handled by qbFormSection.directive.payByPaypal()
					break;
				case "bankaccount":
					payByDirectDebit(formData);
					break;
			}
		}

		function payByCreditCard(formData, form) {
			paymentService.payByCreditCard(
				// pass credit card data
				{
					cardNumber: formData.paymentForm.paymentDetails.cardNumber,
					cardHolderName:
						formData.paymentForm.paymentDetails.cardHolderName,
					cvc: formData.paymentForm.paymentDetails.cardCvc,
					type: form.cardNumber.$ccType,
					cardExpiryDate: form.cardExpiryDate.$viewValue,
				},
				// on successfully calling the Create Creditcard Payment service
				function (creditCardPaymentData) {
					// make the scope available globally. This data will be used by the iFrame to construct the form that will post to Cybersource
					$window.$controllerScope = $scope;
					// set the data to send to Cybersource to the scope
					$scope.creditCardPaymentData = creditCardPaymentData;
					// set the URL for the iFrame to the Cybersource Payment Form (which will use the `creditCardPaymentData`) to generate and submit the form
					$ctrl.addCybersourceiFrame = true;

					if ($ctrl.paymentAttempCounter == 2) {
						$ctrl.addCybersourceRetryAttempt = true;
					}

					if ($ctrl.paymentAttempCounter == CREDIT_CARD_ATTEMPT) {
						$ctrl.addCybersourceLastAttempt = true;
					}
				},
				// on error
				function (errorResponse) {
					paymentLoggerService.trackQuoteStatus(
						"cc payment error",
						"show oh snap page",
						errorResponse
					);
					//dd-4003-push error to gtm data layer
					gtmService.trackEvent(errorResponse, "paymentError");
					void 0;
					$state.go("error");
				}
			);
		}

		function payByDirectDebit(formData) {
			paymentService.payByDirectDebit(
				// pass bank account data
				{
					bsb: formData.paymentForm.paymentDetails.bsb,
					accountNumber:
						formData.paymentForm.paymentDetails.accountNumber,
					accountName:
						formData.paymentForm.paymentDetails.accountName,
				},
				// on successfully calling the Create Direct Debit Payment service
				function (directDebitPaymentData) {
					$scope.onPaymentCallback(true, directDebitPaymentData);
				},
				// on error
				function (errorResponse) {
					paymentLoggerService.trackQuoteStatus(
						"bank debit payment error",
						"show oh snap page",
						errorResponse
					);
					//dd-4003-push error to gtm data layer
					gtmService.trackEvent(errorResponse, "paymentError");
					void 0;
					//yearly bank account will not redirect to oh snap page
					if (
						formData.paymentForm.paymentDetails.paymentOptions ===
						"yearly"
					) {
						$rootScope.$broadcast("loading-animation-end");
						$ctrl.showPaymentProcessError = true;
					} else {
						$state.go("error");
					}
				}
			);
		}

		/**
		 * Initialisation method of the payment page
		 */
		$ctrl.initPaymentPage = function () {
			initialiseRouting();

			util.dispatchCustomEvent("register-labels");
			$ctrl.termsAndConditions = false;
			var formData = getUserInput();
			formData.paymentForm.paymentDetails.termsAndConditions = false;
			quoteOptions.setSelectedPaymentFrequency(
				formData.paymentForm.paymentDetails.paymentOptions
			);
			$ctrl.formData = formData;
			getRequote(formData);
			$scope.$on("payment-method-changed", function (
				event,
				paymentMethod
			) {
				$ctrl.paymentMethod = paymentMethod;
			});
			$scope.$on("terms-and-conditions-changed", function (
				event,
				termsAndConditions
			) {
				$ctrl.termsAndConditions = termsAndConditions;
			});
		};

		/**
		 * This callback is called from the iFrame when the response is received from the GuideWire payment service
		 * @param success
		 * @param stateParams
		 */
		$scope.onPaymentCallback = function (success, params) {
			$rootScope.$broadcast("loading-animation-end");

			if (success && params.status !== "PROCESS_FAIL") {
				var confirmationData = {
					policyNumber: params.policyNumber,
					accountNumber: params.accountNumber,
					isAwaitingProcess: params.status === "AWAITING_PROCESS",
				};
				paymentLoggerService.trackQuoteStatus(
					"payment successful",
					"show done page",
					null
				);
				// Go to confirmation
				$state.go(MODULE_INFO.donePageRouteName, confirmationData);
			} else {
				// payment error - show error page
				// yearly bank account will not redirect to oh snap page
				if (
					$ctrl.formData.paymentForm.paymentDetails.paymentOptions ===
						"yearly" &&
					$ctrl.paymentMethod === "bankaccount"
				) {
					paymentLoggerService.trackQuoteStatus(
						"payment unsuccessful - bank debit",
						"show oh snap page",
						null
					);
					$ctrl.showPaymentProcessError = true;
					$ctrl.paymentErrorDescription = $ctrl.getLabelFor(
						"bankAccountError"
					);
				}

				// credit card payment retry
				// catch error param from GW
				// send to referral after max attempts
				if ($ctrl.paymentMethod === "creditcard") {
					if (
						angular.isDefined(params.error) &&
						params.error !== ""
					) {
						$ctrl.paymentErrorDescription =
							labelService.getValidationMessagesFor(
								"paymentMethod",
								"ccError"
							) +
							" " +
							params.error;
					} else {
						$ctrl.paymentErrorDescription = labelService.getValidationMessagesFor(
							"paymentMethod",
							"ccErrorDefault"
						);
					}

					if ($ctrl.paymentAttempCounter === CREDIT_CARD_ATTEMPT) {
						paymentLoggerService.trackQuoteStatus(
							"payment unsuccessful - credit card",
							"show referral page",
							null
						);

						var savedQuote = serviceResponseRepository.getLastResponseFrom(
							"quote"
						);
						var referralParams = {
							declineType: savedQuote.quoteID,
							declineCodes: ["ccPaymentError"],
						};
						$state.go("referral", referralParams);
					} else {
						$ctrl.showPaymentProcessError = true;

						paymentLoggerService.trackQuoteStatus(
							"payment unsuccessful - credit card",
							"show payment page",
							null
						);
					}
				}
			}
		};
	},
]);

angular.module("qbePortal").controller("paymentsFormController", [
	"$rootScope",
	"$scope",
	"$state",
	"$window",
	"userInputRepository",
	"paymentService",
	"Util",
	"storage",
	"gtmService",
	"paymentLoggerService",
	"CREDIT_CARD_ATTEMPT",
	function(
		$rootScope,
		$scope,
		$state,
		$window,
		userInputRepository,
		paymentService,
		util,
		storage,
		gtmService,
		paymentLoggerService,
		CREDIT_CARD_ATTEMPT
	) {
		var $ctrl = this;

		if ($window.qbe.fieldLabels.buttonLabel) {
			$ctrl.closeWindowLabel =
				$window.qbe.fieldLabels.buttonLabel.closeWindow;
			$ctrl.payYourBillNowLabel =
				$window.qbe.fieldLabels.buttonLabel.payYourBillNow;
			$ctrl.printLabel = $window.qbe.fieldLabels.buttonLabel.print;
			$ctrl.payMoreBillLabel =
				$window.qbe.fieldLabels.buttonLabel.payMoreBill;
			$ctrl.chatAgentLabel =
				$window.qbe.fieldLabels.buttonLabel.chatAgent;
			$ctrl.callAgentLabel =
				$window.qbe.fieldLabels.buttonLabel.callAgent;
		}

		if ($window.qbe.fieldLabels.config) {
			$ctrl.returnDeclineURLPath =
				$window.qbe.fieldLabels.config.DeclinePath;
			$ctrl.paymentsPath = $window.qbe.fieldLabels.config.PaymentsPath;
		}

		if ($window.qbe.fieldLabels.frequentlyAsked) {
			$ctrl.frequentlyAsked =
				$window.qbe.fieldLabels.frequentlyAsked.list;
			$ctrl.frequentlyAskedTitle = qbe.fieldLabels.frequentlyAsked;
		}

		$ctrl.amountDue = qbe.fieldLabels.amountDue;
		$ctrl.headBar = qbe.fieldLabels.headBar;
		$ctrl.paymentDate = moment().format("Do MMM. YYYY");
		$ctrl.showQbAmountDue = false;

		if ($ctrl.headBar) {
			$ctrl.headBar.click = function() {
				/* gtm track phone click */
				gtmService.trackStandardEvent('click button', 'phone', '', false);
				/* end gtm track phone click */
			};
		}

		if (qbe.fieldLabels.otherWaysToPay) {
			$ctrl.otherWaysToPay = qbe.fieldLabels.otherWaysToPay.list;
		}

		if ($window.qbe.fieldLabels.paymentConfirmation) {
			$ctrl.paymentConfirmationLabel =
				$window.qbe.fieldLabels.paymentConfirmation.title;
			$ctrl.paymentConfirmationDescription =
				$window.qbe.fieldLabels.paymentConfirmation.description;
			$ctrl.paymentConfirmationSubDescription =
				$window.qbe.fieldLabels.paymentConfirmation.subDescription;
		}

		if ($window.qbe.fieldLabels.paymentConfirmationSummary) {
			$ctrl.paymentConfirmationSummaryLabel =
				$window.qbe.fieldLabels.paymentConfirmationSummary.title;
			$ctrl.paymentConfirmationSummaryDetailsLabel =
				$window.qbe.fieldLabels.paymentConfirmationSummary.options;				
		}

		if ($window.qbe.fieldLabels.enterPaymentRef) {
			$ctrl.phoneNumber = $window.qbe.fieldLabels.enterPaymentRef.phone;
		}

		$ctrl.totalSteps = 2;
		$ctrl.initStep = 1;
		$ctrl.stepNum = null;
		$ctrl.Completed = false;
		$ctrl.ctpCompleted = false;
		$ctrl.showPayButton = true;
		$ctrl.paymentAttempt = 0;

		function ctpStepCounter(step) {
			var currentStep = step;

			for (var i = 0; i <= currentStep; i++) {
				$ctrl.stepNum = i;
			}
		}

		$ctrl.trackWindowPrint = function() {
			gtmService.trackStandardEvent('click link', 'print', '', false);
		};

		// This will catch the success callback
		var paypalConfirmation = storage.getItem("paypal-confirm-details");
		if (paypalConfirmation.isSuccess) {
			var formDetails = storage.getItem("confirmation-details");
			var paymentRef = formDetails.referenceNumber;
			(receiptNum = paypalConfirmation.receiptNumber),
				(amountPay = parseFloat(formDetails.amount.amountPay).toFixed(
					2
				)),
				(paymentDate = $ctrl.paymentDate);

			$ctrl.paymentConfirmationSummaryDetailsValue = [
				paymentRef,
				receiptNum,
				"$" + amountPay,
				paymentDate
			];

			loadAmount(amountPay);

			//dd-6181 - call gtm service on payment complete
			gtmService.trackUnauthPayments($state.current, formDetails, 'payPal', receiptNum, paypalConfirmation.policyNumber);

			storage.removeItem("paypal-confirm-details");			
		} else if (paypalConfirmation.isSuccess === false) {
			storage.removeItem("paypal-confirm-details");
			storage.setItem("payment-error-details", {
				mode: "paypal"
			});
			$state.go("payments.payments");
		}

		var creditCardConfirmation = storage.getItem(
			"creditcard-confirm-details"
		);
		if (creditCardConfirmation.isSuccess) {
			var formDetails = storage.getItem("confirmation-details");
			var paymentRef = formDetails.referenceNumber;
			(receiptNum = creditCardConfirmation.receiptNumber),
				(amountPay = parseFloat(formDetails.amount.amountPay).toFixed(
					2
				)),
				(paymentDate = $ctrl.paymentDate);

			$ctrl.paymentConfirmationSummaryDetailsValue = [
				paymentRef,
				receiptNum,
				"$" + amountPay,
				paymentDate
			];
			loadAmount(amountPay);
			storage.removeItem("creditcard-confirm-details");

			//dd-6181 - call gtm service on payment complete
			gtmService.trackUnauthPayments($state.current, formDetails, 'creditCard', receiptNum, formDetails.policyNumber);
		} else if (creditCardConfirmation.isSuccess === false) {
			storage.removeItem("creditcard-confirm-details");
			storage.setItem("payment-error-details", {
				mode: "cc"
			});
			$state.go("payments.payments");
		}

		var directDebitConfirmation = storage.getItem(
			"direct-debit-confirm-details"
		);
		if (directDebitConfirmation.isSuccess) {
			var formDetails = storage.getItem("confirmation-details");
			var paymentRef = formDetails.referenceNumber,
				amountPay = parseFloat(formDetails.amount.amountPay).toFixed(2),
				paymentDate = $ctrl.paymentDate;

			$ctrl.paymentConfirmationSummaryDetailsValue = [
				paymentRef,
				null,
				"$" + amountPay,
				paymentDate
			];
			loadAmount(amountPay);
			storage.removeItem("direct-debit-confirm-details");

			$ctrl.paymentConfirmationSubDescription =
				$window.qbe.fieldLabels.paymentConfirmation.bankSubDescription;

			//dd-6181 - call gtm service on payment complete
			gtmService.trackUnauthPayments($state.current, formDetails, 'bankAccount', directDebitConfirmation.receiptNumber, directDebitConfirmation.policyNumber);
		} else if (directDebitConfirmation.isSuccess === false) {
			storage.removeItem("direct-debit-confirm-details");
			$state.go("payments.payments");
		}

		function loadAmount(amountPay) {
			$ctrl.amountDue.amountPay = amountPay;
			var cents = amountPay.substring(amountPay.indexOf("."));
			$ctrl.amountDue.amountCents = cents;

			var dollars = amountPay.substring(0, amountPay.indexOf("."));
			$ctrl.amountDue.amountDollars = dollars;
		}

		$ctrl.cybersourceiFrameUrl = $state.href(
			"cybersourcePaymentForm",
			null,
			{
				absolute: true
			}
		);

		$ctrl.addCybersourceiFrame = false;

		$ctrl.elementName = "Form Controller";

		$ctrl.validationErrors = null;
		$ctrl.sections = {};
		$ctrl.state = $state;
		$ctrl.storage = storage;
		$ctrl.showConfirm = false;
		$ctrl.showThankYou = false;
		$ctrl.showSwitchButton = false;
		$ctrl.isConfirmed = false;
		$ctrl.closeWindow = function() {
			/* gtm track close window */
			gtmService.trackStandardEvent('click link', 'exit', '', false);
			/* end gtm track close window */

			$scope.$destroy();
			window.location.href =
				$window.qbe.fieldLabels.buttonLabel.targetUrl;					
		};

		$ctrl.goToPayments = function() {
			window.location.href = util.linkBuilder($ctrl.paymentsPath);
		};		

		function getDefaultValues() {
			return {
				paybillForm: {
					selectInsuranceType: {
						creditCardForm: {
							ccName: "",
							cvcNum: ""
						}
					}
				}
			};
		}

		/**
		 * QbFormSections register themselves with the form controller.
		 * This is done automatically by the form section upon initialisation.
		 * @name : name of the form section
		 * @init : function callback initialise the section
		 * @getValueFn: function callback to get the value of the section.
		 */
		$ctrl.registerSection = function(name, init, getValueFn) {
			$ctrl.sections[name] = {
				initValue: init,
				getValue: getValueFn
			};
		};

		/**
		 * Any generic breaking errors should broadcast 'error' to the rootScope. This will cause redirection
		 * to the main error page.
		 */
		$scope.$on("error", function(event, error) {
			$state.go("error", error);
		});

		function getUserInput() {
			var formData = getFormInput();
			userInputRepository.update(formData);
			return userInputRepository.get(getDefaultValues());
		}

		function getFormInput() {
			var formData = {};
			for (var key in $ctrl.sections) {
				formData[key] = $ctrl.sections[key].getValue();
			}
			return formData;
		}

		$scope.$on("pay-now-button", function(event, args) {
			if (args != "QBEProducts") {
				$ctrl.showPayButton = false;
			} else {
				$ctrl.showPayButton = true;
			}
		});

		$scope.$on("show-form-entry", function(event, args) {
			ctpStepCounter($ctrl.initStep);
			$ctrl.showConfirm = false;
			$ctrl.showThankYou = false;
			$ctrl.isConfirmed = false;
			$scope.$broadcast("show-hint");
		});

		$scope.$on("confirm-switch", function(event, args) {
			$ctrl.showConfirm = false;
			$ctrl.showThankYou = true;
			$ctrl.ctpCompleted = true;

			$scope.$broadcast("switch-to-QBE", $ctrl.core.isEligible);
		});

		/**
		 * Scrolls a field into view when an error is clicked
		 * @param {Object} error Error object with key `name`
		 */
		$ctrl.showInView = function(error) {
			scrollViewTo($('[name="' + error.name + '"]'));
		};

		function scrollViewTo($element) {
			var offset = $element.offset();
			if (offset) {
				$("html, body").animate({
					scrollTop: offset.top - 50,
					scrollLeft: offset.left
				});
			}
		}

		// PAYMENTS FORM START
		$scope.$on("billUpdate", function(event, details) {
			if (details) {
				$ctrl.amountDue.amountPay = details.amount;
				if (details.amount.indexOf(".") > 0) {
					var cents = details.amount.substring(
						details.amount.indexOf(".")
					);
					$ctrl.amountDue.amountCents = cents;

					var dollars = details.amount.substring(
						0,
						details.amount.indexOf(".")
					);
					$ctrl.amountDue.amountDollars = dollars;
				} else {
					$ctrl.amountDue.amountCents = "00";
					$ctrl.amountDue.amountDollars = details.amount;
				}

				$ctrl.amountDue.reference_number = details.reference_number;
				$ctrl.amountDue.referenceId = details.referenceId;
				$ctrl.amountDue.paymentType = details.paymentType;
			} else {
				$ctrl.amountDue.amountDollars = null;
				$ctrl.showQbAmountDue = false;
			}
		});

		/* gtm track payment type select in payment details page */
		$scope.$on("trackPaymentDetailsPaymentType", function(event, paymentType) {
			if (paymentType) {
				var pType = 'bankAccount';
				if (paymentType == 'credit-card') {
					pType = 'creditCard';
				}
				else if (paymentType == 'paypal') {
					pType = 'payPal';
				}
				gtmService.trackPayBillVirtualPageDetails($ctrl.amountDue.reference_number, $ctrl.amountDue.referenceId, pType);
			}
		});
		/* end gtm track payment type select in payment details page */

		$scope.$on("toggle-amount-due", function() {
			$ctrl.showQbAmountDue = $ctrl.amountDue.amountDollars != null;
		});

		$scope.$on("set-micoform-instance", function(event, instance){
			$ctrl.microformInstance = instance;
		});

		function isCrditCardPaymentMethod(howToPay) {
			return howToPay === 'credit-card';
		}

		function validateCybersourceCreditCardField() {
			var cardNumberContainerValidClass = document.getElementsByClassName('flex-microform-valid');
			return (cardNumberContainerValidClass && cardNumberContainerValidClass.length > 0) ? true : false;
		}
		$ctrl.payBillNow = function(form) {
			var formData = getUserInput();
			var payByCreditCard = isCrditCardPaymentMethod(formData.paybillForm.selectInsuranceType.howToPay);

			$scope.$broadcast("form-submitted");

			$ctrl.showErrorSummary = false;
			isInvalid = form.$invalid;
			
			if (payByCreditCard) {
				//init refresh cvc validation stataus
				$scope.$broadcast("credit-card-cvc-isvalid", true);

				if (!validateCybersourceCreditCardField()) {
					if (!isInvalid) {
						isInvalid = true;
					}				
					$scope.$broadcast("credit-card-number-isvalid", false);
				}
				else {
					$scope.$broadcast("credit-card-number-isvalid", true);
				}
			}
			
			if (isInvalid) {
				$scope.$broadcast("broadcast-field-errors");
				$ctrl.showErrorSummary = true;
				$scope.$broadcast("reset-field-errors");
				if ($("#combinedValidationListing").length) {
					scrollViewTo($("#combinedValidationListing"));
				} else {
					scrollViewTo($("#content"));
				}
				return;
			}

			var formData = getUserInput();
			if (!formData.paybillForm.selectInsuranceType.howToPay) {
				return;
			}

			if (
				formData.paybillForm.selectInsuranceType.selectInsuranceType ===
				null
			) {
				return false;
			} else
				$ctrl.selectInsuranceType =
					formData.paybillForm.selectInsuranceType.selectInsuranceType;

			// dd-6181 - call gtm service to track payment
			gtmService.trackUnauthPayments(
				$state.current,
				formData.paybillForm.selectInsuranceType
			);

			$ctrl.paymentAttempt++;

			if (formData.paybillForm.selectInsuranceType.howToPay == "paypal") {
				paymentService.unAuthPaypalPayment(
					{
						referenceNumber: $ctrl.amountDue.referenceId,
						paymentType: $ctrl.amountDue.paymentType,
						redirectUrl: ""
					},
					// on successfully calling the Create Paypal Payment service
					function(redirectUrl) {
						storage.setItem("confirmation-details", {
							referenceNumber: $ctrl.amountDue.reference_number,
							amount: $ctrl.amountDue,
							transactionId: $ctrl.selectInsuranceType
						});
						$window.location.href = redirectUrl;
					},
					// on error
					function(errorResponse) {
						paymentLoggerService.trackQuoteStatus(
							"paypal payment error",
							"show oh snap page",
							errorResponse
						);
						storage.removeItem("unauth-reference");
						void 0;
					}
				);
			} else if (
				formData.paybillForm.selectInsuranceType.howToPay ==
				"bank-account"
			) {
				$rootScope.$broadcast("loading-animation-start");

				paymentService.unAuthDirectDebitPayment(
					{
						amountPay: $ctrl.amountDue.amountPay,
						referenceNumber: $ctrl.amountDue.referenceId,
						paymentType: $ctrl.amountDue.paymentType,
						bsb:
							formData.paybillForm.selectInsuranceType
								.bankAccountForm.bsb,
						accountNumber:
							formData.paybillForm.selectInsuranceType
								.bankAccountForm.accountNumber,
						accountName:
							formData.paybillForm.selectInsuranceType
								.bankAccountForm.accountName
					},
					// on successfully calling the Payment service
					function(response) {
						if (response.status === "SUCCESS") {
							storage.setItem("direct-debit-confirm-details", {
								isSuccess: true
							});

							storage.setItem("confirmation-details", {
								referenceNumber:
									$ctrl.amountDue.reference_number,
								amount: $ctrl.amountDue,
								transactionId: $ctrl.selectInsuranceType
							});

							paymentLoggerService.trackQuoteStatus(
								"payment successful",
								"show done page",
								null
							);
							
							$state.go("payments.complete");
						} else {
							paymentLoggerService.trackQuoteStatus(
								"payment unsuccessful",
								"show error page",
								null
							);
							$rootScope.$broadcast("loading-animation-end");
							$scope.$broadcast("direct-debit-payment-error");
						}
					},
					// on error
					function(errorResponse) {
						paymentLoggerService.trackQuoteStatus(
							"bank debit payment error",
							"show oh snap page",
							errorResponse
						);
						storage.removeItem("unauth-reference");
						$rootScope.$broadcast("loading-animation-end");
						$scope.$broadcast("direct-debit-payment-error");
					}
				);
			} else {
				// pay by credit card
				tokeniseAndPayByCreditCard(
					formData.paybillForm.selectInsuranceType.creditCardForm
				);
			}
		};

		$scope.$on("redirect-payment-decline", function() {
			window.location.href = util.linkBuilder(
				$ctrl.returnDeclineURLPath + "?return=true"
			);
		});

		function setPaymentErrorAfterCybersourceTokenization(err) {
			paymentLoggerService.trackQuoteStatus(
				"payment unsuccessful",
				"return payment page",
				err
			);
			$rootScope.$broadcast(
				"cyber-source-error",
				"Form validation error"
			);
			storage.removeItem("creditcard-confirm-details");
			storage.setItem("payment-error-details", {
				mode: "cc"
			});
			$state.go("payments.payments");

			$scope.$broadcast("credit-card-number-isvalid", false);
			$rootScope.$broadcast("loading-animation-end");
		}
		function setPaymentErrorAfterCybersourceTokenizationCvcInvalid(err) {
			paymentLoggerService.trackQuoteStatus(
				"payment unsuccessful",
				"return payment page",
				err
			);
			$rootScope.$broadcast(
				"cyber-source-error",
				"Form validation error"
			);
			storage.removeItem("creditcard-confirm-details");
			storage.setItem("payment-error-details", {
				mode: "cc"
			});
			$state.go("payments.payments");

			$scope.$broadcast("credit-card-cvc-isvalid", false);
			$rootScope.$broadcast("loading-animation-end");
		}
		function tokeniseAndPayByCreditCard(creditCardForm) {			
			$rootScope.$broadcast("loading-animation-start");

			// Send in optional parameters from other parts of your payment form
			var options = {
				cardExpirationMonth: creditCardForm.expiryMonth,
				cardExpirationYear: new Date().getFullYear().toString().substr(0, 2) + creditCardForm.expiryYear,
				cardCvc: creditCardForm.cvcNum,
				referenceNumber: $ctrl.amountDue.referenceId,
				paymentType: $ctrl.amountDue.paymentType
			};

			$ctrl.microformInstance.createToken(options, function (err, response) {
				if (err) {
					setPaymentErrorAfterCybersourceTokenization(err);
					return;
				}
				else if (response) {		
					if (response.cardType != '001' && response.cardType != '002' && response.cardType != '003') {
						setPaymentErrorAfterCybersourceTokenization(err);
						return;
					}
					else {
						if (response.cardType === '001' || response.cardType === '002') {
							if (creditCardForm.cvcNum && creditCardForm.cvcNum.toString().length != 3) {
								setPaymentErrorAfterCybersourceTokenizationCvcInvalid('Invalid CVC');
								return;
							}
						}
						else if (creditCardForm.cvcNum && creditCardForm.cvcNum.toString().length != 4) {
							setPaymentErrorAfterCybersourceTokenizationCvcInvalid('Invalid CVC');
							return;							
						}						
					}			
				}

				payByCreditCard(creditCardForm, response);
			});
		}

		function payByCreditCard(creditCardForm, flexiResponse) {
			
			paymentService.unAuthCreditCardPayment(
				// pass credit card data
				{
					cardToken: flexiResponse.token,
					cardHolderName: creditCardForm.ccName,
					cvc: creditCardForm.cvcNum,
					type: flexiResponse.cardType,
					cardExpiryDate: creditCardForm.expiryDate,
					referenceNumber: $ctrl.amountDue.referenceId,
					paymentType: $ctrl.amountDue.paymentType
				},
				// on successfully calling the Create Creditcard Payment service
				function(creditCardPaymentData) {
					// make the scope available globally. This data will be used by the iFrame to construct the form that will post to Cybersource
					$window.$controllerScope = $scope;

					// set the data to send to Cybersource to the scope
					$scope.creditCardPaymentData = creditCardPaymentData;
					// set the URL for the iFrame to the Cybersource Payment Form (which will use the `creditCardPaymentData`) to generate and submit the form
					$ctrl.addCybersourceiFrame = true;

					if ($ctrl.paymentAttempt == 2) {
						$ctrl.addCybersourceRetryAttempt = true;
					}

					if ($ctrl.paymentAttempt == CREDIT_CARD_ATTEMPT) {
						$ctrl.addCybersourceLastAttempt = true;
					}
				},
				// on error
				function(errorResponse) {
					paymentLoggerService.trackQuoteStatus(
						"cc payment error",
						"show oh snap page",
						errorResponse
					);
					storage.removeItem("unauth-reference");
					// dd-4003-push error to gtm data layer
					gtmService.trackEvent(errorResponse, "ccPaymentError");
				}
			);
		}

		$scope.onPaymentCallback = function(success, params) {
			$rootScope.$broadcast("loading-animation-end");

			if (success) {
				var confirmationData = {
					policyNumber: params.policyNumber,
					//accountNumber: params.accountNumber,
					receiptNumber: params.receiptNumber,
					isSuccess: params.status === "SUCCESS"
				};

				storage.setItem("creditcard-confirm-details", confirmationData);

				storage.setItem("confirmation-details", {
					referenceNumber: $ctrl.amountDue.reference_number,
					amount: $ctrl.amountDue,
					policyNumber: params.policyNumber,
					transactionId: $ctrl.selectInsuranceType
					// accountNumber: params.accountNumber
				});

				paymentLoggerService.trackQuoteStatus(
					"payment successful",
					"show done page",
					null
				);
				storage.removeItem("unauth-reference");

				// Go to confirmation
				$state.go("payments.complete", confirmationData);
			} else {
				var declineParam = {
					referenceNumber: $ctrl.amountDue.reference_number
				};

				if ($ctrl.paymentAttempt === CREDIT_CARD_ATTEMPT) {
					paymentLoggerService.trackQuoteStatus(
						"payment unsuccessful",
						"show referral page",
						null
					);
					storage.removeItem("unauth-reference");
					$state.go("decline", declineParam);
				} else {
					paymentLoggerService.trackQuoteStatus(
						"payment unsuccessful",
						"show decline page",
						null
					);
					$rootScope.$broadcast(
						"cyber-source-error",
						params.reasonCode
					);
				}
			}
		};

		/**
		 * Takes care of
		 * - registering the labels generated by sitecore
		 * - setting default values
		 * - prepopulating retrieve quote if required.
		 */
		$ctrl.initPage = function() {
			resizePayBills();
			util.dispatchCustomEvent("register-labels");
			ctpStepCounter($ctrl.initStep); //Progress Counter
		};

		function resizePayBills() {
			var footHeight = $(".footer").outerHeight(),
				windowHeight = $(window).height(),
				documentHeight = $(document).height(),
				minHeight;

			if ($(window).outerWidth() >= 768) {
				if (documentHeight > windowHeight) {
					minHeight = documentHeight - footHeight - 5;
				} else {
					minHeight = windowHeight - footHeight - 5;
				}

				$(".col1, .col2").css("min-height", minHeight + "px");
			} else {
				$(".col1, .col2").css("min-height", "auto");
			}
		}
	}
]);

angular.module('qbePortal').controller('PaypalCallbackController', [
	'$scope',
	'$state',
	'$stateParams',
	'dynamicRouter',
	'paymentService',
	'storage',
	'Util',
	'MODULE_INFO',
	'paymentLoggerService',
	function(
		$scope,
		$state,
		$stateParams,
		dynamicRouter,
		paymentService,
		storage,
		Util,
		MODULE_INFO,
		paymentLoggerService
	) {
		var $ctrl = this;
		$scope.$root.$broadcast('loading-animation-end');

		var success = ($stateParams.success = !!$stateParams.PayerID);

		if (!success) {
			// Go back to payment page if unsuccessful
			storage.setItem('paypal-confirm-details', {
				isSuccess: false,
				mode: 'paypal'
			});
			return $state.go(MODULE_INFO.paymentPageRouteName);
		}

		if (MODULE_INFO.id == 'payments') {
			paymentService
				.unAuthSendPaypalPaymentToGW(
					$stateParams.PayerID,
					$stateParams.sessionId,
					$stateParams.paymentId
				)
				.then(function(_guidewirePaypalPaymentResponse) {
					var confirmationData = {
						policyNumber:
							_guidewirePaypalPaymentResponse.data.policyNumber,
						accountNumber:
							_guidewirePaypalPaymentResponse.data.accountNumber,
						receiptNumber:
							_guidewirePaypalPaymentResponse.data.receiptNumber,
						isAwaitingProcess:
							_guidewirePaypalPaymentResponse.data.status ===
							'AWAITING_PROCESS',
						isSuccess:
							_guidewirePaypalPaymentResponse.data.status ===
							'SUCCESS'
					};

					storage.setItem('paypal-confirm-details', confirmationData);

					paymentLoggerService.trackQuoteStatus(
						'sending Paypal payment to GW',
						'show done page or error page',
						null
					);

					$state.go(MODULE_INFO.donePageRouteName, confirmationData);
					void 0;
				});
		} else {
			paymentService
				.sendPaypalPaymentToGW(
					$stateParams.PayerID,
					$stateParams.sessionId
				)
				.then(function(_guidewirePaypalPaymentResponse) {
					var confirmationData = {
						policyNumber:
							_guidewirePaypalPaymentResponse.data.policyNumber,
						accountNumber:
							_guidewirePaypalPaymentResponse.data.accountNumber,
						isAwaitingProcess:
							_guidewirePaypalPaymentResponse.data.status ===
							'AWAITING_PROCESS'
					};
					paymentLoggerService.trackQuoteStatus(
						'sending Paypal payment to GW - payment successful',
						'show done page or error page',
						null
					);
					$state.go(MODULE_INFO.donePageRouteName, confirmationData);
					void 0;
				});
		}
	}
]);

angular.module('qbePortal').controller('PlaneController', [
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'$window',
	'userInputRepository',
	'serviceResponseRepository',
	'quoteOptions',
	'paymentService',
	'quoteModelFactory',
	'dynamicRouter',
	'portalServiceWrapper',
	'MAService',
	'labelService',
	'Util',
	'$q',
	'storage',
	'jwtHelper',
	'gtmService',
	'quoteRequestRepository',
	'MODULE_INFO',
	function ($rootScope, $scope, $state, $stateParams, $window, userInputRepository, serviceResponseRepository, quoteOptions, paymentService, quoteModelFactory, dynamicRouter, portalServiceWrapper, MAService, labelService, util, $q, storage, jwtHelper, gtmService, quoteRequestRepository, MODULE_INFO) {
		var $ctrl = this;
		$rootScope.$broadcast('loading-animation-end');

		/** 
		* routing initialisation, enabling/disabling (hiding/showing) available routes
		* testing for allowed routes and redirecting when not allowed
		*/
		function markCompletedRouteCallback(stateName){
			storage.setItem('completed-step', stateName);
		}

		function initialiseRouting(){
			dynamicRouter.initialise($state.current.name, $state.$current.parent.name, null, markCompletedRouteCallback);
			$ctrl.title = dynamicRouter.getPageTitle();
			$ctrl.steps = dynamicRouter.getSteps();
		}
		/** End of routing logic */
		
		$ctrl.state = $state;
		$ctrl.storage = storage;
		$ctrl.sections = {};
		$ctrl.moduleId = MODULE_INFO.id ;

		$ctrl.cybersourceiFrameUrl = $state.href('cybersourcePaymentForm', null, {absolute: true});
		$ctrl.addCybersourceiFrame = false ; 
		$ctrl.summaryModel = quoteModelFactory.create();

		function getDefaultValues() {
			return {
				fromFullQuote: true,
				paymentForm: {
					paymentDetails :{
						paymentOptions: 'yearly'
					}
				}
			};
		}

		function scrollViewTo($element) {
			var offset = $element.offset();
			if ( offset ) {
				$('html, body').animate({
					scrollTop: (offset.top - 50),
					scrollLeft: offset.left
				});
			}
		}

		/**
		* QbFormSections register themselves with the form controller.
		* This is done automatically by the form section upon initialisation.
		* @name : name of the form section
		* @init : function callback initialise the section
		* @getValueFn: function callback to get the value of the section.
		*/
		$ctrl.registerSection = function (name, init, getValueFn) {
			$ctrl.sections[name] = {
				initValue: init,
				getValue: getValueFn
			};
		}

		/**
		* Any generic breaking errors should broadcast 'error' to the rootScope. This will cause redirection
		* to the main error page.
		*/
		$scope.$on('error', function(event, error) {
			$state.go('error', error);
		});

		/**
		* calls MA Services to add marketing data.
		*/
		$scope.$on('perform-ma-service', function(event, triggeredBy) {
			performMAServices(triggeredBy) ;
		});

		$scope.$on('back', function () {
			gtmService.trackEvent('back') ;
			$ctrl.back()
		});

		/**
		* called from qbFormSection and any other panel that requires a requote based on new values.
		*/
		$scope.$on('requote', function(event, page) {
			gtmService.trackEvent('requote') ;
			$rootScope.$broadcast('loading-animation-start');
			var formData = getUserInput();
			getRequote(formData, page, function(resp) {
				$rootScope.$broadcast('loading-animation-end');
				$rootScope.$broadcast('quote-received', resp);
				$rootScope.$broadcast('selected-quote-changed') ;
			});
		});

		function getUserInput() {
			var formData = getFormInput() ;
			userInputRepository.update(formData);
			return userInputRepository.get(getDefaultValues());
		}

		function getFormInput() {
			var formData = {};
			for (var key in $ctrl.sections) {
				formData[key] = $ctrl.sections[key].getValue();
			}
			return formData;
		}

		function getRequote(formData, page, callback) {
			portalServiceWrapper.updateQuote(formData);
			var requoteOptions = quoteOptions.getRequoteOptions(MODULE_INFO.paymentPageRouteName);
			if ( requoteOptions ) {
				portalServiceWrapper
					.getQuickQuote(requoteOptions.permutations, requoteOptions.rules).then(function(resp) {
						if (callback )
							callback(resp) ;
					})
					.catch(function(err) {
						void 0 ;
						broadcastError(err, 'Requote error');
					});
			} else {
				return false ;
			}
			return true;
		}

		$ctrl.save = function () {
			$rootScope.$broadcast('open-modal', { modal: 'saveQuote' });
		};

		$ctrl.back = function () {
			gtmService.trackEvent('back') ;
			$scope.$broadcast('reset-field-errors');
			var backState = dynamicRouter.back();
			if ( backState )
				$state.go(backState);
			else {
				var formData = getUserInput() ;
				if ( formData.rapidEstimateUrl )
					window.location.href = formData.rapidEstimateUrl ;
			}
		};

		$ctrl.submit = function (form) {
			gtmService.trackEvent('next') ;
			$ctrl.showErrorSummary = false;
			if (form.$invalid) {
				$scope.$broadcast('broadcast-field-errors');
				$ctrl.showErrorSummary = true;
				$scope.$broadcast('reset-field-errors');
				scrollViewTo($('#combinedValidationListing')) ;
				return;
			}

			processPayment(form) ;
		};

		function performMAServices(eventName) {
			getUserInput() ;
			var mainPolicyHolder = userInputRepository.get({}, 'caravanForm.mainPolicyHolder');
			var policyEmail = userInputRepository.get({}, 'email') ;
			var quoteResult = quoteOptions.getSelectedQuoteResult();
			var savedQuote = serviceResponseRepository.getLastResponseFrom('quote') ;
			var maData = {
				pageName: $state.current.name,
				mainPolicyHolder: mainPolicyHolder,
				policyEmail: policyEmail,
				annualResult: quoteResult.getAnnual(),
				monthlyResult: quoteResult.getMonthly(),
				quoteId : savedQuote ? savedQuote.quoteID : null,
			};
			MAService.mergeContacts(eventName, maData) ;
		}

		function processPayment(form) {
			formData = getUserInput();

			var paymentDetailsForm = form.paymentDetails;

			userInputRepository.update(formData);

			$rootScope.$broadcast('loading-animation-start');
			switch (formData.paymentForm.paymentDetails.paymentMethod) {
				case 'creditcard':
					payByCreditCard(formData, paymentDetailsForm);
					break;
				case 'paypal':
					// handled by qbFormSection.directive.payByPaypal()
					break;
				case 'bankaccount':
					payByDirectDebit(formData);
					break;
			}
		}

		function payByCreditCard(formData, form) {
			paymentService.payByCreditCard(
				// pass credit card data
				{
					cardNumber: formData.paymentForm.paymentDetails.cardNumber,
					cardHolderName: formData.paymentForm.paymentDetails.cardHolderName,
					cvc: formData.paymentForm.paymentDetails.cardCvc,
					type: form.cardNumber.$ccType,
					cardExpiryDate: formData.paymentForm.paymentDetails.cardExpiryDate
				},
				// on successfully calling the Create Creditcard Payment service
				function (creditCardPaymentData) {
					// make the scope available globally. This data will be used by the iFrame to construct the form that will post to Cybersource
					$window.$controllerScope = $scope;
					// set the data to send to Cybersource to the scope
					$scope.creditCardPaymentData = creditCardPaymentData;
					// set the URL for the iFrame to the Cybersource Payment Form (which will use the `creditCardPaymentData`) to generate and submit the form
					$ctrl.addCybersourceiFrame = true ; 
				},
				// on error
				function (errorResponse) {
					void 0;
					$state.go('error');
				}
			);
		}

		function payByDirectDebit(formData) {
			paymentService.payByDirectDebit(
				// pass bank account data
				{
					bsb: formData.paymentForm.paymentDetails.bsb,
					accountNumber: formData.paymentForm.paymentDetails.accountNumber,
					accountName: formData.paymentForm.paymentDetails.accountName
				},
				// on successfully calling the Create Direct Debit Payment service
				function (directDebitPaymentData) {
					$scope.onPaymentCallback(true, directDebitPaymentData);
				},
				// on error
				function (errorResponse) {
					void 0;
					$state.go('error');
				}
			);
		}


		/**
		 * Initialisation method of the payment page
		 */
		$ctrl.initPaymentPage = function () {
			initialiseRouting();
			
			util.dispatchCustomEvent('register-labels');
			$ctrl.termsAndConditions = false;
			var formData = getUserInput();
			formData.paymentForm.paymentDetails.termsAndConditions = false ;
			quoteOptions.setSelectedPaymentFrequency(formData.paymentForm.paymentDetails.paymentOptions) ;
			$ctrl.formData = formData ;
			getRequote(formData);
			$scope.$on('payment-method-changed', function(event, paymentMethod) {
				$ctrl.paymentMethod = paymentMethod;
			});
			$scope.$on('terms-and-conditions-changed', function(event, termsAndConditions) {
				$ctrl.termsAndConditions = termsAndConditions;
			});
		}


		/**
		 * This callback is called from the iFrame when the response is received from the GuideWire payment service
		 * @param success
		 * @param stateParams
		 */
		$scope.onPaymentCallback = function (success, params) {
			$rootScope.$broadcast('loading-animation-end');

			if (success) {
				var confirmationData = {
					policyNumber: params.policyNumber,
					accountNumber: params.accountNumber,
					isAwaitingProcess: params.status === 'AWAITING_PROCESS'
				};

				// Go to confirmation
				$state.go(MODULE_INFO.donePageRouteName, confirmationData);
				// console.log('Great success! Payment completed! Move to confirmation page', confirmationData);
			}else{
				//payment error - show error page
				$state.go('error');
			}

		}
	}]
);

angular.module('qbePortal').controller('PolicyStartDateController', [
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'$window',
	'userInputRepository',
	'serviceResponseRepository',
	'dynamicRouter',
	'labelService',
	'Util',
	'$q',
	'storage',
	'gtmService',
	function ($rootScope, $scope, $state, $stateParams, $window, userInputRepository, serviceResponseRepository, dynamicRouter, labelService, util, $q, storage, gtmService) {
		var $ctrl = this;
		$ctrl.validationErrors = null;
		$ctrl.sections = {};
		$ctrl.state = $state;
		$ctrl.storage = storage;		

		$scope.$root.$broadcast('loading-animation-end');

		$ctrl.registerSection = function (name, init, getValueFn) {
			$ctrl.sections[name] = {
				initValue: init,
				getValue: getValueFn
			};
		}

		function markCompletedRouteCallback(stateName) {
			storage.setItem('completed-step', stateName);
		}

		function initialiseRouting() {
			var isRetrieve = storage.getItem('policy-date-input');
			if (angular.equals(isRetrieve, {})) // check 
				dynamicRouter.initialise($ctrl.state.current.name, $ctrl.state.$current.parent.name, null, markCompletedRouteCallback);
		}

		$ctrl.initPolicyStartDatePage = function () {
			initialiseRouting();
			util.dispatchCustomEvent('register-labels');
			$ctrl.formData = getUserInput();
		}

		$ctrl.submit = function (form) {

			//gtmService.trackEvent('next');
			$ctrl.showErrorSummary = false;
			if (form.$invalid) {
				$scope.$broadcast('broadcast-field-errors');
				$ctrl.showErrorSummary = true;
				$scope.$broadcast('reset-field-errors');
				scrollViewTo($('#combinedValidationListing'));
				return;
			}
			var formData = getUserInput();
			$ctrl.formData = formData;
			var product = $state.$current.parent.name + 'Form';
			var input = storage.getItem('policy-date-input');	
			if(product !== 'homeForm'){		
				input[product].getStarted.policyStartDate = $ctrl.formData.pastPolicyStartDateForm.pastPolicyStartDateDetails.policyStartDate;				
			}				
			else{
				input[product].letsGetStarted.startCoverDate = $ctrl.formData.pastPolicyStartDateForm.pastPolicyStartDateDetails.policyStartDate;				
				storage.setItem('completed-step', dynamicRouter.getState(0));
			}		
			userInputRepository.update(input);				
			storage.removeItem('policy-date-input');						
			moveToState($state.$current.parent.name);
		}

		function moveToState(stateParent) {
			if(stateParent !== 'home')
				$state.go(dynamicRouter.getState(0));
			else {
				$state.go(dynamicRouter.getState(1));
			}	
		}

		function getUserInput() {
			var formData = getFormInput();
			userInputRepository.update(formData);
			return userInputRepository.get(getDefaultValues());
		}

		function getFormInput() {
			var formData = {};
			for (var key in $ctrl.sections) {
				formData[key] = $ctrl.sections[key].getValue();
			}
			return formData;
		}

		function getDefaultValues() {
			var defaultValues = {
				pastPolicyStartDateForm: {
					pastPolicyStartDateDetails: {
						policyStartDate: moment().tz("Australia/Sydney").format('DD/MM/YYYY'),
					}
				},
			};
			return defaultValues;
		}

		function scrollViewTo($element) {
			var offset = $element.offset();
			if ( offset ) {
				$('html, body').animate({
					scrollTop: (offset.top - 50),
					scrollLeft: offset.left
				});
			}
		}

		
	}
]);

angular.module('qbePortal.rapidEstimate.vehicle')
	.controller('RapidEstimateController', [
		'$scope',
		'$location',
		'userInputRepository',
		'labelService',
		'portalServiceWrapper',
		'quoteOptions',
		'Util',
		'serviceResponseRepository',
		'gtmService',
		'$sce',
		function($scope, $location, userInputRepository, labelService, portalServiceWrapper, quoteOptions, util, serviceResponseRepository, gtmService, $sce) {
			var vm = this;
			vm.formData = {};
			vm.validationErrors = null;
			vm.sections = {};
			vm.promoCode = util.getQueryStringByName(window.location, 'promotionalCode') ;

			vm.initPage= function() {
				util.dispatchCustomEvent('register-labels');
			}

			vm.formData = userInputRepository.get({
				vehicleForm: {
					tellUsMore: {
						promotionalCode: vm.promoCode
					}
				}
			});

			vm.registerSection = function (name, init, getValueFn) {
				vm.sections[name] = getValueFn;
			}

			// Submit form to get quickQuote
			vm.submit = function(event, form) {
				event.preventDefault();

				gtmService.trackEvent('rapid-estimate-submit') ;

				vm.showErrorSummary = false;
				isInvalid = form.$invalid;

				if (isInvalid) {
					$scope.$broadcast('broadcast-field-errors');
					vm.showErrorSummary = true;
					$scope.$broadcast('reset-field-errors');
					void 0;
					scrollViewTo($('#combinedValidationListing')) ;
					return;
				}

				$scope.$root.$broadcast('loading-animation-start');

				// Populate formData
				var formData = {};
				for (var key in this.sections) {
					formData[key] = this.sections[key]();
				}
				
				//var formattedDate = moment().tz("Australia/Sydney").format('YYYY-MM-DD') ;

				var now = moment().tz("Australia/Sydney").format('DD/MM/YYYY');
				formData.vehicleForm.getStarted = {
					personOrCompany: 'person',
					policyStartDate: now
				};
				formData.vehicleForm.driver.drivers = [];
				formData.vehicleForm.driver.drivers[0] = {
					person: util.deepClone(formData.vehicleForm.driver)
				};

				if(formData.vehicleForm.tellUsMore) {
					formData.email = formData.vehicleForm.tellUsMore.email;
					formData.vehicleForm.promotionalCode = {
						promotionalCode: formData.vehicleForm.tellUsMore.promotionalCode
					};
				}

				userInputRepository.update(formData);

				portalServiceWrapper.updateQuote(formData);

				var quickQuoteOptions = quoteOptions.getQuickQuoteOptionsForStep('rapidEstimate') ;

				portalServiceWrapper.getQuickQuote(quickQuoteOptions.permutations, quickQuoteOptions.rules)
					.then(function(resp) {
						vm.applyFormPath = this.endpointUrls.estimateRedirect;
						var quoteResults = serviceResponseRepository.getLastResponseFrom('quickQuote') ;
						serviceResponseRepository.update('rapidEstimate' , quoteResults ) ;
						$scope.$root.$broadcast('process-rapid-estimates', {
							formData: formData,
							results : quoteResults,
						});
					})
					.catch(function(err) {
						$scope.$root.$broadcast('error', {
							errorMessage: 'getQuickQuote error',
							response: err
						});
					});

			}

			vm.getSectionDescriptionFor = function (fieldName) {
				return $sce.trustAsHtml(labelService.getSectionDescriptionFor(fieldName));
			}

			/**
			 * Scrolls a field into view when an error is clicked
			 * @param {Object} error                    Error object with key `name`
			 */
			$scope.showInView = function (error) {
				//console.log(error);
				scrollViewTo($('[name="' + error.name + '"]')) ;
			}

			function scrollViewTo($element) {
				var offset = $element.offset();
				if ( offset ) {
					$('html, body').animate({
						scrollTop: (offset.top - 50),
						scrollLeft: offset.left
					});
				}
			}

			// Scroll to estimates once they're loaded
			$scope.$root.$on('show-rapid-estimates', function() {
				vm.showRapidEstimatesPanel = true;
			});

			$scope.$root.$on('rapid-estimates-panel-initialised', function() {
		 		var rapidEstimateResults = serviceResponseRepository.getLastResponseFrom('rapidEstimate') ;
				if ( rapidEstimateResults ) {
					vm.applyFormPath = this.endpointUrls.estimateRedirect;
					$scope.$root.$broadcast('process-rapid-estimates', {
						results: rapidEstimateResults,
						formData: userInputRepository.get()
					});
				}
			});


		}
	]);

(function () {
	'use strict';

	angular.module('qbePortal').controller('AddressSearchController', AddressSearchController);

	AddressSearchController.$inject = ['$state', '$scope', 'serviceResponseRepository', 'quoteModelFactory', '$timeout', '$q', 'guideWireService'];

	function AddressSearchController($state, $scope, serviceResponseRepository, quoteModelFactory, $timeout, $q, guideWireService) {
		var vm = this;

		vm.$onInit = function () {
			if (!vm.name) {
				vm.name = 'address';
			}

			var name = $state.current.name;
			vm.addressResponses = [];
			vm.isSearchInProgress = false;
			if (name === 'bike.bike') {
				vm.messageAddressNotFound = 'Can’t find your address? Call us on 1800 24 34 64.';
			} else {
				vm.messageAddressNotFound = 'Can’t find your address? Call us on 133 723.';
			}

			vm.addressFound = true;

			if (vm.address !== null) {
				vm.addressInput = vm.address;
			}

			if (vm.addressType) {
				if (vm.address && !vm.address.addressType) {
					vm.address.addressType = vm.addressType;
					vm.update({
						name: 'address',
						value: vm.address
					});
				}
			}
		}

		$scope.$watch(vm.addressResponse);

		vm.refreshAddresses = function (viewValue) {
			vm.isSearchInProgress = true;
			return guideWireService.addressSearch({
				search: viewValue,
				type: 'physical'
			}).then(function (resp) {
				vm.isSearchInProgress = false;

				if (!!resp.data && resp.data.length <= 0) {
					vm.addressFound = false;
					return null;
				} else {
					vm.addressFound = true;
					return resp.data.map(function (item) {
						vm.addressResponse = item;
						return item;
					});
				}
			}).catch(function (resp) {
				vm.isSearchInProgress = false;
			});
		}

		// on selection of address
		vm.onSelect = function ($item, $model, $label) {
			if (vm.addressType)
				$model.addressType = vm.addressType;

			vm.update({
				name: vm.name,
				value: $model
			});

			//called with a timer to delay the validation
			$timeout(function () {
				$scope.$broadcast('type-ahead-value-received');
				if (vm.enrich == 'true') {
					$scope.$root.$broadcast('enrich-address');
				}
			}, 1000);

			if (vm.serviceName) {
				serviceResponseRepository.update(vm.serviceName, $model);
			}
		};

		vm.isAddressValid = function () {
			if (vm.addressResponse) {
				//check for the address line 1 in the addressResponse
				if (!!vm.addressResponse.addressLine1) {
					return true;
				} else {
					return false;
				}
			} else {
				//validates only if the not blank, blank is validated by the required
				return false;
			}
		}

		vm.registerHierarchy = function (name, setHierarchyFn) {
			vm.setHierarchy({
				name: name,
				setHierarchyFn: setHierarchyFn
			});
		}

	};

	angular.module('qbePortal').component('addressSearch', {
		templateUrl: '/ngviews/components/qbAddressSearch.html',
		controller: AddressSearchController,
		controllerAs: 'vm',
		bindings: {
			fieldKey: '@',
			validationSelector: '@',
			update: '&',
			setHierarchy: '&',
			labelKey: '@',
			address: '<?',
			labelWildcard: '<',
			enrich: '@?',
			name: '@?',
			serviceName: '@?',
			/** name under which the service
			 * response is captured.  To differentiate differet primary and secondary addresses
			 */
			addressType: '@?',
			/**
			 * type of address.  residential/postal and etc.
			 */
		}
	});

})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('qbCampaign', qbCampaign);

	qbCampaign.$inject = ['$scope', 'campaignService'];

	function qbCampaign($scope, campaignService) {
		var vm = this;
		vm.campaign = {} ; 
		vm.show = false;

		campaignService.init();
		var hasActiveCampaign = campaignService.hasActiveCampaign() ; 
		if ( hasActiveCampaign){
			try {
				var campaign = campaignService.getCampaign();
				vm.campaign = campaign ; 
				vm.show = true;
				QBE.listAccordion.init();
			} catch(ex) {
				vm.show = false ; 
				void 0 ; 
			}
		}	
	}

	angular.module('qbePortal').component('qbCampaign', {
		templateUrl: '/ngviews/components/qbCampaign.html',
		controller: qbCampaign,
		controllerAs: 'vm',
		bindings: {
		}
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('QBCombinedValidationController', QBCombinedValidationController);

	QBCombinedValidationController.$inject = ['$scope', 'validationService', 'Util', 'gtmService'];

	function QBCombinedValidationController($scope, validationService, util, gtmService) {
		var vm = this;
		var errorsByField = [];

		$scope.$on('reset-field-errors', resetFieldErrors);
		function resetFieldErrors() {
			validationService.clearAllErrors();
			errorsByField = [];
		}

		vm.fetchErrorsByField = function () {
			var errors = validationService.getAllErrors();
			if (!errors) return [];

			for (var input in errors) {
				// console.log('errors' , errors) ;

				var error = errors[input];
				var element = error.element;
				var fieldLabel = error.label;
				var fieldErrors = error.errors;
				var ngModel = error.input;
				for (var errorType in fieldErrors) {
					var msg = fieldErrors[errorType];

					if (error.wildcard) {
						var wildcardValue = error.element.scope().$eval(error.wildcard);
						fieldLabel = processWildCard(fieldLabel, wildcardValue);
					}

					var wildcardErrorAttr = element.attr('wildcard-' + errorType);
					if (typeof wildcardErrorAttr != 'undefined') {
						wildcardErrorAttr = error.element.scope().$eval(wildcardErrorAttr);
						msg = processWildCard(msg, wildcardErrorAttr);
					}

					errorsByField.push({
						name: element.attr('name'),
						label: fieldLabel,
						id: element.attr('id'),
						errorType: errorType,
						viewValue: element.$viewValue,
						validationMessage: msg,
						section: ngModel.$$parentForm
					});

				}
			}
			//TODO: call function to track event to gtm
			processGTM(errorsByField);
			return errorsByField;
		}

		vm.hasErrors = function () {
			if (errorsByField.length == 0)
				errorsByField = vm.fetchErrorsByField();

			return errorsByField.length > 0;
		}

		vm.showInView = function (error) {
			var offset = $('#' + error.id).offset();

			$('html, body').animate({
				scrollTop: (offset.top - 50),
				scrollLeft: offset.left
			});
		}

		vm.getErrorsByField = function () {

			return errorsByField;
		}

		function processWildCard(targetString, wildcardValue) {
			if (typeof wildcardValue == 'string' || typeof wildcardValue == 'undefined') {
				targetString = util.stringFormat(targetString, wildcardValue);
			} else {
				// Handle multiple wildcard
				var argArr = [];
				argArr.push(targetString);
				argArr = argArr.concat(wildcardValue);
				targetString = util.stringFormat.apply(null, argArr);
			}
			return targetString;
		}

		/*
		* dd-4003 - push to gtm data layer on field errors
		* param = errors by field
		*/
		function processGTM(errorsByField) {
			if (errorsByField.length > 0) {				
				angular.forEach(errorsByField, function (errorsByField, index) {										
					var errorByFieldLabel = errorsByField.label;
					var errorEvent = gtmService.createGtmValidationErrorEvent(errorByFieldLabel);
					gtmService.trackEvent(errorEvent, 'formValidationError');
				});				
			}			
		}
	}

	angular.module('qbePortal').component('qbCombinedValidation', {
		templateUrl: '/ngviews/components/qbCombinedValidation.html',
		controller: QBCombinedValidationController,
		controllerAs: 'vm',
		bindings: {
			formSelector: '<',
			show: '<',
		}
	});
})();

(function () {

	angular.module('qbePortal').controller('QBCrossSell', QBCrossSell);

	QBCrossSell.$inject = ['$scope', '$sce'];

	function QBCrossSell($scope, $sce) {
		var vm = this;

		vm.$onInit = function () {
			vm.obj = JSON.parse(vm.content);

			for (var i = 0; i < vm.obj.length; i++) {
				if (vm.obj[i].subheading != '' || vm.obj[i].description != '' || vm.obj[i].ctaLabel != '' || vm.obj[i].hyperlinkLabel != '' || vm.obj[i].image != '') {
					vm.hasContent = true;
					break;
				}
			}
		}

		vm.getRichText = function (text) {
			return $sce.trustAsHtml(text);
		}
	}

	angular.module('qbePortal').component('qbCrossSell', {
		templateUrl: '../ngviews/components/qbCrossSell.html',
		controller: QBCrossSell,
		controllerAs: 'vm',
		bindings: {
			heading: '@',
			content: '@'
		}
	});

})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('QBCtpValidationController', QBCtpValidationController);

	QBCtpValidationController.$inject = ['$scope', 'validationService', 'Util'];

	function QBCtpValidationController($scope, validationService, util) {
		var vm = this;
			vm.errorField = [];

		var errorsByField = [];

		/*
		* Reset call to validation service		
		*/
		$scope.$on('confirm-form-data', resetFieldErrors);
		function resetFieldErrors() {
			validationService.clearAllErrors();
			errorsByField = [];
			vm.validationSelector = false;
		}

		/*
		* Call validation service to validate fields
		* Param - attribute name of element
		* Output - error object to display in element
		*/
		vm.fetchErrorsByField = function () {
			vm.errorField = [];
			var errors = validationService.validateField(vm.messageKey);

			if (!errors) {
				return [];
				vm.validationSelector = false;
			}		

			for (var input in errors) {
				var error = errors[input];
				var element = error.element;
				var fieldLabel = error.label;
				var fieldErrors = error.errors;
				var ngModel = error.input;
				for (var errorType in fieldErrors) {
					var msg = fieldErrors[errorType];

					if (error.wildcard) {
						var wildcardValue = error.element.scope().$eval(error.wildcard);
						fieldLabel = util.stringFormat(fieldLabel, wildcardValue);
					}

					vm.errorField.push({
						name: element.attr('name'),
						label: fieldLabel,
						id: element.attr('id'),
						errorType: errorType,
						viewValue: element.$viewValue,
						validationMessage: msg,
						section: ngModel.$$parentForm
					});

				}
			}

			if (vm.errorField.length > 0) {
				angular.element('div').find('[data-name='+vm.messageKey+']').removeClass('ng-hide');
			}

			vm.validationSelector = true;
			return vm.errorField;
		}

		/*
		* Broadcast call if field has errors
		*/
		$scope.$on('broadcast-field-errors', function (event) {	
			//validationService.clearAllErrors();		
			errorsByField = vm.fetchErrorsByField();			
		});

		vm.getErrorsByField = function () {
			return errorsByField;						
		}
		
	}

	angular.module('qbePortal').component('qbCtpValidation', {
		templateUrl: '/ngviews/components/qbCtpValidation.html',
		controller: QBCtpValidationController,
		controllerAs: 'vm',
		bindings: {
			validationSelector: '<',
			messageKey: '<',
		}
	});
})();

(function () {

	angular.module('qbePortal').controller('QBCurrency', QBCurrency);

	QBCurrency.$inject = ['$scope'];

	function QBCurrency($scope) {
		var vm = this;

		vm.fieldValue = null;
		//vm.dateOfBirth = new Date(1991, 3, 21); // To be replaced with date from DOB field

		//console.log(vm.dob);

		vm.registerHierarchy = function (name, setHierarchyFn) {
			vm.setHierarchy({name: name, setHierarchyFn: setHierarchyFn});
		}

		vm.onValueChanged = function () {
			vm.update({name: vm.name, value: vm.fieldValue});
		}
	}

	angular.module('qbePortal').component('qbCurrency', {
		templateUrl: '../ngviews/components/qbCurrency.html',
		controller: QBCurrency,
		controllerAs: 'vm',
		bindings: {
			name: '@',
			update: '&',
			setHierarchy: '&',
		}
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('QBCycleCoverSummaryController', QBCycleCoverSummaryController);
	QBCycleCoverSummaryController.$inject = ['$scope'];


	function QBCycleCoverSummaryController($scope) {
		var vm = this;
		var tableValues = {
			cycleCover: $scope.cycleCover,
			generalEquipment: $scope.generalEquipment,
			specifiedEquipment: $scope.specifiedEquipment,
			includeCycleRacing: $scope.includeCycleRacing
		};

	}

	angular.module('qbePortal').component('qbCycleCoverSummary', {
		templateUrl: '../ngviews/components/qbCycleCoverSummary.html',
		controller: QBCycleCoverSummaryController,
		controllerAs: 'vm',
		bindings: {
			cycleCover: '=',
			generalEquipment: '=',
			specifiedEquipment: '=',
			includeCycleRacing: '='
		}
	});
})();

(function () {
	'use strict';
	angular.module('qbePortal')
		.component('qbListAccordion', {
			templateUrl: '/ngviews/components/qbListAccordion.html',
			controllerAs: 'vm',
			transclude: true,
			bindings: {
				includedList : '<',
				excludedList : '<',
			}
		})
		.directive('onRepeatEnd', ["$timeout", function ($timeout) {
			return function (scope, element, attrs) {
				if (scope.$last) {
					$timeout(function () {
						QBE.listAccordion.init();
					});
				}
			}
		}]);
})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('QBListAggregatorController', 'quoteModelFactory', QBListAggregatorController);
	QBListAggregatorController.$inject = ['$scope', 'Util', 'quoteModelFactory'];

	function QBListAggregatorController($scope, Util, quoteModelFactory) {
		var vm = this;
		var _aggregatorPrefix = "agg_";

		vm.$onInit = function () {
			vm.items = vm.list || [];
			vm.quoteModel = quoteModelFactory.create();

			/**
			 * to make this compatible with data coming from rapid-estimate or retrieve quote.
			 */
			vm.items.forEach(function (element, index) {
				if (!element._aggregator) {
					var name = (index == 0 && vm.defaultValue) ? vm.defaultValue._aggregator.name : 'additional';
					var id = _aggregatorPrefix + index;
					element._aggregator = {
						id: id,
						name: name,
						title: (index == 0 && vm.defaultValue) ? vm.defaultValue._aggregator.title : 'additional',
					};
					element._HTMLID = name + id;
					setFullHeadingForItem(element);
				}
				$scope.$emit('show-aggregate');
			})

			if (vm.items.length == 0 && vm.defaultValue) {
				var item = vm.defaultValue;
				item._HTMLID = item._aggregator.name + item._aggregator.id;
				setFullHeadingForItem(item);
				vm.items.push(item);
				updateParentSection();
			}

			vm.addItem = function (id, item) {
				id = id || vm.items.length;
				id = _aggregatorPrefix + id;
				item = Util.deepClone(item);
				item._aggregator.id = id;
				item._HTMLID = item._aggregator.name + item._aggregator.id;

				setFullHeadingForItem(item);

				vm.items.push(item);
				updateParentSection();
			}
		}

		function setFullHeadingForItem(item) {
			if (item._aggregator.id > 0) {
				item._aggregator.fullHeading = item._aggregator.title + ' ' + vm.typeName + ' ' + item._aggregator.id;
			} else {
				item._aggregator.fullHeading = item._aggregator.title + ' ' + vm.typeName;
			}
		}

		function updateParentSection() {
			vm.update({
				name: vm.name,
				value: vm.items
			});
		}
	}

	angular.module('qbePortal').component('qbListAggregator', {
		templateUrl: '../ngviews/components/qbListAggregator.html',
		controller: QBListAggregatorController,
		controllerAs: 'vm',
		bindings: {
			list: '<',
			name: '@',
			item: '<',
			defaultValue: '<',
			typeName: '@',
			update: '&',
			max: '<'
		}
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('QBListReducerController', 'quoteModelFactory', QBListReducerController);
	QBListReducerController.$inject = ['$scope', 'aggregatedRemoveService', 'quoteModelFactory'];

	function QBListReducerController($scope, aggregatedRemoveService, quoteModelFactory) {
		var vm = this;

		vm.$onInit = function () {
			vm.items = vm.list;
			vm.quoteModel = quoteModelFactory.create();
		}

		vm.removeItem = function (item) {
			vm.items.splice(vm.items.indexOf(item), 1);
			aggregatedRemoveService.markForDelete(vm.typeName, item);
			vm.update({
				name: vm.name,
				value: vm.items
			});
		}
	}

	angular.module('qbePortal').component('qbListReducer', {
		templateUrl: '../ngviews/components/qbListReducer.html',
		controller: QBListReducerController,
		controllerAs: 'vm',
		bindings: {
			list: '<',
			item: '<',
			name: '@',
			typeName: '@',
			update: '&',
		}
	});
})();

(function () {
	"use strict";

	angular
		.module("qbePortal")
		.controller(
			"QBLoadingAnimationController",
			QBLoadingAnimationController
		);

	QBLoadingAnimationController.$inject = ["$scope", "labelService"];

	function QBLoadingAnimationController($scope, labelService) {
		var vm = this;

		$scope.$root.$on("loading-animation-start", onLoadAnimationStart);
		$scope.$root.$on("loading-animation-end", onLoadAnimationEnd);

		function onLoadAnimationStart() {
			$scope.$root.$broadcast("hide-top-banner");
			$("body").addClass("no-scroll");
			vm.animationInProgress = true;
		}

		function onLoadAnimationEnd() {
			$("body").removeClass("no-scroll");
			vm.animationInProgress = false;
		}
	}

	angular.module("qbePortal").component("qbLoadingAnimation", {
		templateUrl: "/ngviews/components/qbLoadingAnimation.html",
		controller: QBLoadingAnimationController,
		controllerAs: "vm",
		bindings: {},
	});
})();

(function () {

	angular.module('qbePortal').controller('QBMaxNoClaimBonus', QBMaxNoClaimBonus);

	QBMaxNoClaimBonus.$inject = ['$scope'];

	function QBMaxNoClaimBonus($scope) {
		var vm = this;

		vm.$onInit = function () {
			vm.fieldValue = vm.ngModel;
		}

		function calcAge() {
			return (moment(new Date()).diff(moment(vm.dob, 'DD/MM/YYYY'), 'years', true));
		}

		vm.getFilteredOptions = function () {

			var fullOptions = vm.options.slice();

			//if yerls help is not greater than 5 the 0 is the only option
			if (vm.yearsHeld !== 'greaterThan_5') {
				return fullOptions.splice(0, 1);
			}

			var age = calcAge();
			if (age == 22) {
				fullOptions = fullOptions.splice(0, 1);
			} else if (age == 23) {
				fullOptions = fullOptions.splice(0, 2);
			} else {
				fullOptions = fullOptions.splice(0, 3);
			}

			return fullOptions;

		}


		vm.registerHierarchy = function (name, setHierarchyFn) {
			vm.setHierarchy({
				name: name,
				setHierarchyFn: setHierarchyFn
			});
		}

		vm.onValueChanged = function () {
			vm.update({
				name: vm.name,
				value: vm.fieldValue
			});
		}


	}

	angular.module('qbePortal').component('qbMaxNoClaimBonus', {
		templateUrl: '../ngviews/components/qbMaxNoClaimBonus.html',
		controller: QBMaxNoClaimBonus,
		controllerAs: 'vm',
		bindings: {
			options: '<',
			name: '@',
			ngModel: '<',
			update: '&',
			setHierarchy: '&',
			yearsHeld: '<',
			dob: '<'
		}
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('QBTable', QBTableController);
	QBTableController.$inject = ['$scope', '$timeout', 'aggregatedRemoveService'];

	function QBTableController($scope, $timeout, aggregatedRemoveService) {
		var vm = this;
		// vm.isEditable = true;

		vm.$onInit = function () {
			vm.selectedRows = [];
			vm.editingRows = [];
			vm.allRowsSelected = false;
			vm.newRow = {};
			vm.isEditable = (vm.editDisabled != true);
			vm.isAddable = (vm.addDisabled != true);
			vm.IDPrefix = vm.sectionName + '_' + vm.name;

			vm.isRowInEditMode = function (row) {
				return vm.editingRows.indexOf(row) !== -1;
			}

			vm.onEditRow = function (row) {
				if (vm.editingRows.indexOf(row) == -1)
					vm.editingRows.push(row);
			}

			vm.isAddRequired = function () {
				return vm.rows.length == 0;
			}

			vm.onEditDone = function (row) {
				var rowIndex = vm.editingRows.indexOf(row);
				if (rowIndex != -1) {
					vm.editingRows.splice(rowIndex, 1);
					updateParentSection();
				}
			}

			vm.isAddEnabled = function () {
				if (Object.keys(vm.newRow).length < vm.columns.length)
					return false;

				for (var col in vm.newRow) {
					if (vm.newRow[col] === null || vm.newRow[col] == '') {
						return false;
					}
				}
				return true;
			}

			vm.onAdd = function () {
				if (vm.isAddEnabled()) {
					vm.rows.push(vm.newRow);
					updateParentSection();
					vm.newRow = {};
					$timeout(function () {
						if (vm.rows.length > 0) {
							$(document).trigger('enhance.tablesaw');
						}
					}.bind(vm), 0);
				}
			}

			vm.onSelectAllChanged = function () {
				if (vm.allRowsSelected) {
					vm.selectedRows = vm.rows.map(function () {
						return true
					});
				} else {
					vm.selectedRows = vm.rows.map(function () {
						return false
					});
				}
			}

			vm.onRemoveSelection = function () {
				angular.forEach(vm.selectedRows, function (row, index) {
					if (row)
						aggregatedRemoveService.markForDelete(vm.name, vm.rows[index]);
				});

				var rows = vm.rows.filter(function (row, index) {
					return vm.selectedRows[index] != true;
				})

				vm.selectedRows = [];
				vm.rows = rows;
				updateParentSection();
			}


			vm.registerHierarchy = function (name, setHierarchyFn) {
				vm.setHierarchy({
					name: name,
					setHierarchyFn: setHierarchyFn
				});
			}
		}

		// trigger table saw after binding complete.
		$timeout(function () {
			if (vm.rows.length > 0) {
				$(document).trigger('enhance.tablesaw');
			}
		}.bind(vm), 0);

		function updateParentSection() {
			vm.update({
				name: vm.name,
				value: vm.rows
			});
			// $scope.$broadcast('table-number-of-rows-changed') ;
		}

	}

	angular.module('qbePortal').component('qbTable', {
		templateUrl: '../ngviews/components/qbMultiEntryTable.html',
		controller: QBTableController,
		controllerAs: 'vm',
		bindings: {
			update: '&',
			name: '@',
			sectionName: '<',
			valueAggregator: '<',
			rows: '=',
			columns: '=',
			editDisabled: '<',
			addDisabled: '<',
			setHierarchy: '&',
		}
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('MultiselectDropdown', MultiselectDropdown);

	MultiselectDropdown.$inject = ['$scope', 'serviceResponseRepository', 'quoteModelFactory', 'labelService'];

	function MultiselectDropdown($scope, serviceResponseRepository, quoteModelFactory, labelService) {
		var vm = this;

		vm.ls = labelService;

		vm.registerHierarchy = function (name, setHierarchyFn) {
			vm.setHierarchy({name: name, setHierarchyFn: setHierarchyFn});
		}

		vm.onValueChanged = function (event) {

			if (!!vm.fieldValue) {
				if (vm.selectedOptions.indexOf(vm.fieldValue) == -1) {
					vm.selectedOptions.push(vm.fieldValue);
				}
				vm.fieldValue = '';
			}

		}

		vm.getLabelFor = function (value) {
			var label = '';

			for (var item in vm.options) {
				if (vm.options[item].value == value) {
					label = vm.options[item].label;
				}
			}
			return label;
		}

		vm.removeItem = function (item) {
			if (vm.selectedOptions.length <= 1) {
				vm.selectedOptions = [];
			} else {
				var index = vm.selectedOptions.indexOf(item);
				vm.selectedOptions.splice(index, 1);
			}

		}

		vm.getOptions = function () {
			return vm.options;
		}

	}

	angular.module('qbePortal').component('multiselectDropdown', {
		templateUrl: '../ngviews/components/qbMultiselectDropdown.html',
		controller: MultiselectDropdown,
		controllerAs: 'vm',
		bindings: {
			name: '@',
			update: '&',
			setHierarchy: '&',
			validationSelector: '@',
			fieldValue: '<',
			options: '<',
			selectedOptions: '=',
			labelWildcard: '<',
			selectionLimit: '<'
		}
	});
})();

(function () {

	angular.module('qbePortal').controller('QBNoClaimBonus', QBNoClaimBonus);

	QBNoClaimBonus.$inject = ['$scope', '$state'];

	function QBNoClaimBonus($scope, $state) {
		var vm = this;

		vm.$onInit = function () {
			vm.fieldValue = vm.ngModel;
		}

		vm.stateName = $state.$current.name;

		function calcAge() {
			return (moment(new Date()).diff(moment(vm.dob, 'DD/MM/YYYY'), 'years', true));
		}

		vm.getFilteredOptions = function () {

			var fullOptions = vm.options.slice();
			var age = Math.round(calcAge());
			var product = vm.stateName.split(".");
			//removed age check and added check based on years held
			fullOptions.reverse();
			//additional check if age is below 17 or dob is undefined
			if ((age < 17) || (!vm.dob)) {
				return fullOptions.splice(0, 1);
			}

			if (product[0] != 'bike') {
				if (vm.yearsHeld == 'lessThan_1') {
					fullOptions = fullOptions.splice(0, 1);
				} else if (vm.yearsHeld == '1') {
					fullOptions = fullOptions.splice(0, 2);
				} else if (vm.yearsHeld == '2') {
					fullOptions = fullOptions.splice(0, 3);
				} else if (vm.yearsHeld == '3') {
					fullOptions = fullOptions.splice(0, 4);
				} else if (vm.yearsHeld == '4') {
					fullOptions = fullOptions.splice(0, 5);
				}
			} else {
				if (age == 17) {
					fullOptions = fullOptions.splice(0, 1);
				} else if (age == 18) {
					fullOptions = fullOptions.splice(0, 2);
				} else if (age == 19) {
					fullOptions = fullOptions.splice(0, 3);
				} else if (age == 20) {
					fullOptions = fullOptions.splice(0, 4);
				} else if (age == 21) {
					fullOptions = fullOptions.splice(0, 5);
				}
			}

			return fullOptions;

		}


		vm.registerHierarchy = function (name, setHierarchyFn) {
			vm.setHierarchy({
				name: name,
				setHierarchyFn: setHierarchyFn
			});
		}

		vm.onValueChanged = function () {
			vm.update({
				name: vm.name,
				value: vm.fieldValue
			});
		}


	}

	angular.module('qbePortal').component('qbNoClaimBonus', {
		templateUrl: '/ngviews/components/qbNoClaimBonus.html',
		controller: QBNoClaimBonus,
		controllerAs: 'vm',
		bindings: {
			options: '<',
			name: '@',
			ngModel: '<',
			update: '&',
			setHierarchy: '&',
			dob: '<',
			yearsHeld: '<'
		}
	});
})();

(function() {
	'use strict';

	angular
		.module('qbePortal')
		.controller('paymentRefNumController', paymentRefNumController);

	paymentRefNumController.$inject = [
		'$rootScope',
		'$scope',
		'$q',
		'$sce',
		'$window',
		'$http',
		'guideWireService',
		'labelService',
		'storage',
		'Util',
		'gtmService',
	];
	function paymentRefNumController(
		$rootScope,
		$scope,
		$q,
		$sce,
		$window,
		$http,
		guideWireService,
		labelService,
		storage,
		util,
		gtmService
	) {
		var vm = this;
		vm.findYourBill = findYourBill;
		vm.imageTooltipPath = labelService.getObjectValue(
			'enterPaymentRef',
			'img'
		);
		activate();

		function activate() {
			var autoTrigger = storage.getItem('auto-find-bill');
			if (autoTrigger && autoTrigger.trigger) {
				searchForRefNum();
				storage.removeItem('auto-find-bill');
			}
		}

		$scope.$on('reset-defaults', function(event) {
			vm.showPaymentSection = false;
		});

		vm.getObjectValue = function(fieldName, fieldLabel) {
			return $sce.trustAsHtml(
				labelService.getObjectValue(fieldName, fieldLabel)
			);
		};

		vm.getImagePath = function(fieldName, fieldLabel) {
			var path = labelService.getObjectValue(fieldName, fieldLabel);
			return path;
		};

		function isUndefinedOrNull(arg) {
			if (angular.isUndefined(arg) || arg == null) {
				return true;
			}
			return false;
		}

		function findYourBill() {
			vm.validRef = true;
			vm.paymentFlag = true;

			validatePaymentRefNum();
			if (
				checkProductIfInGuidewire() &&
				vm.validationSelector.enterPaymentRef.$valid
			) {
				searchForRefNum();
			}
		}

		function validatePaymentRefNum() {
			if (
				!isUndefinedOrNull(
					vm.validationSelector.enterPaymentRef.$$rawModelValue
				)
			) {
				//clear errors and hide validation message
				//$rootScope.$broadcast('broadcast-no-field-errors');
				if (!isUndefinedOrNull(vm.validationSelector)) {
					vm.validationSelector.enterPaymentRef.$setValidity(
						'minlength',
						true
					);
				}

				var referenceNo =
					vm.validationSelector.enterPaymentRef.$$rawModelValue;
				var refLength = referenceNo.length;
				var refLengthIsValid = refLength <= 14 && refLength >= 8;

				if (
					vm.postBillPay != 1 &&
					referenceNo.startsWith('1000') &&
					refLength >= 14
				) {
					return;
				}

				if (!referenceNo.startsWith('1000') && refLength == 14) {
					return;
				}

				if (!refLengthIsValid) {
					vm.validationSelector.enterPaymentRef.$setValidity(
						'minlength',
						false
					);
				}
			} else {
				vm.validationSelector.enterPaymentRef.$setValidity(
					'required',
					false
				);
				vm.validationSelector.enterPaymentRef.$setValidity(
					'minlength',
					true
				);
				vm.validationSelector.enterPaymentRef.$setValidity(
					'wrongref',
					true
				);
			}

			if (!vm.validationSelector.enterPaymentRef.$valid)
				$rootScope.$broadcast('broadcast-field-errors');
		}

		function checkProductIfInGuidewire() {
			var prodRefNum = vm.fieldValues.enterPaymentRef;

			if (!isUndefinedOrNull(prodRefNum)) {
				var min = prodRefNum.substr(1, 2);

				//Turn Off Claims Payment and redirect to Billpay site
				if (
					vm.postBillPay != 1 &&
					prodRefNum.startsWith('1000') &&
					prodRefNum.length == 14
				) {
					$window.open('http://billpay.qbe.com.au', '_blank');
					window.location.href = 'https://qbe.com.au';
					return false;
				} else if (
					!prodRefNum.startsWith('1000') &&
					prodRefNum.length == 14
				) {
					// Anubis
					// && min <= 26
					$window.open('http://billpay.qbe.com.au', '_blank');
					window.location.href = 'https://qbe.com.au';
					return false;
				} else if (prodRefNum.length < 8) {
					vm.validationSelector.enterPaymentRef.$setValidity(
						'wrongref',
						true
					);
				}

				if (
					prodRefNum.startsWith('1000') ||
					prodRefNum.startsWith('5000')
				) {
					if (prodRefNum.startsWith('1000')) {
						vm.policyCategory = 'claim';
					} else if (prodRefNum.startsWith('5000')) {
						vm.policyCategory = 'policy';
					}
				}
			}

			return true;
		}

		function searchForRefNum() {
			var info = guideWireService.getPaymentInfo(
				vm.fieldValues.enterPaymentRef
			);

			info.then(function(resp) {
				searchForRefNumberSuccess(resp);
			}).catch(function(err) {				
				if (err && err.status) {
					/* gtm track api error */
					gtmService.trackApiError(err.status, 'invalid payment reference number');
				}

				vm.validationSelector.enterPaymentRef.$setValidity(
					'wrongref',
					true
				);
				$rootScope.$broadcast('invalid-payment-reference-number');
				return;
			});
		}

		function searchForRefNumberSuccess(resp) {
			if (resp.data.status == 'E') {
				/* gtm track api error */
				gtmService.trackApiError(resp.data.status, 'payment error due to status E');

				$rootScope.$broadcast('payment-error');				
				return;
			} else if (resp.data.status == 'P') {
				/* gtm track api error */
				gtmService.trackApiError(resp.data.status, 'payment already made');

				$rootScope.$broadcast('payment-already-made');
				return;
			} else {
				$rootScope.$broadcast('broadcast-no-field-errors');
			}

			vm.policyNumber = resp.data.policyNumber;
			vm.paymentType = resp.data.paymentType;
			vm.amount = resp.data.amount.toFixed(2);
			vm.showPaymentSection = true;
			var details = {
				amount: vm.amount,
				reference_number: vm.fieldValues.enterPaymentRef,
				insuranceType: vm.insuranceType,
				paymentType: vm.paymentType,
				referenceId: resp.data.referenceId
			};

			storage.setItem(
				'unauth-reference',
				util.b64EncodeUnicode(vm.fieldValues.enterPaymentRef)
			);

			/* track search ref sucess after button click */
			gtmService.trackPayBillVirtualBillFound(details.reference_number, details.referenceId);
			/* end track search ref sucess after button click */

			$rootScope.$broadcast('billUpdate', details);
			$rootScope.$broadcast('toggle-amount-due');
		}

		$scope.validNumber = function(event) {
			var key = $window.event ? event.keyCode : event.which;
			if (key === 8) {
				return true;
			} else if (key < 48 || key > 57) {
				event.preventDefault();
			} else {
				return true;
			}
		};

		vm.closeImageRefForPayment = function() {
			angular.element('#pay-img-ref').toggleClass('ng-hide');
		};
	}

	angular.module('qbePortal').component('paymentRefNum', {
		templateUrl: '/ngviews/components/qbPaymentRefNum.html',
		controller: paymentRefNumController,
		controllerAs: 'vm',
		bindings: {
			fieldKey: '@',
			validationSelector: '=',
			setHierarchy: '&',
			labelKey: '@',
			insuranceType: '@',
			ngModel: '=',
			policyCategory: '=',
			postBillPay: '=',
			validRef: '=',
			showPaymentSection: '=',
			paymentRefError: '=',
			fieldValues: '='
		}
	});
})();

(function () {
    'use strict';

    qbPremiumBreakdownController.$inject = ['$scope', '$window', '$rootScope', '$filter', 'labelService'];
    
    function qbPremiumBreakdownController($scope, $window, $rootScope, $filter, labelService) {
        var vm = this;

        vm.lookupLabel = function (fieldName) {
            return labelService.getGlobalOptionLabel('paymentSummary', fieldName);
        };
    }

    angular.module('qbePortal').component('qbPremiumBreakdown', {
        templateUrl: '/ngviews/components/qbPremiumBreakdown.html',
        controller: qbPremiumBreakdownController,
        controllerAs: 'vm',
        bindings: {
            paymentFrequency: '@',
            quoteResults: '=',
            monthlyResults: '='
        },
    });

})();
(function () {
	"use strict";

	angular
		.module("qbePortal")
		.controller("QBProgressBarController", QBProgressBarController);
	QBProgressBarController.$inject = [
		"$scope",
		"$state",
		"dynamicRouter",
		"MODULE_INFO",
		"labelService",
		"Util",
	];

	function QBProgressBarController(
		$scope,
		$state,
		dynamicRouter,
		MODULE_INFO,
		labelService,
		Util
	) {
		var vm = this;
		vm.selectedStep = null;
		vm.lastSelectedStep = null;
		vm.state = $state;

		$scope.$on("$stateChangeSuccess", function (
			event,
			toState,
			toParams,
			fromState,
			fromParams
		) {
			if (toState) {
				vm.selectedStep = toState.name;

				// hack to stop vm.selectedStep to nullifying
				if (vm.selectedStep !== vm.lastSelectedStep) {
					vm.lastSelectedStep = vm.selectedStep;
				}

				// display top banner
				displayTopBanner();
			}
		});

		$scope.$on("selected-quote-changed", function () {
			$scope.$root.$broadcast("hide-top-banner");
			displayTopBanner();
		});

		vm.getPage = function () {
			var page = vm.state.current.name.split(".")[1];

			if (page === "policy-start-date" || page === "ctp") {
				return false;
			} else {
				return true;
			}
		};

		function getStateByNumber(stepNumber) {
			var steps = dynamicRouter.getSteps();
			if (steps) return steps[stepNumber].stateName;

			return null;
		}

		function displayTopBanner() {
			var getPages = labelService.getObjectValue("topBanner", "pages");
			var bannerText = labelService.getObjectValue(
				"topBanner",
				"bannerText"
			);

			if (
				!Util.isUndefinedOrNull(getPages) &&
				!Util.isUndefinedOrNull(bannerText) &&
				bannerText != ""
			) {
				var pagesArray = getPages.split(",");
				var displayTopBanner = false;
				var declinePages = ["decline", "embargo", "referral", "error"];
				var currentPage = dynamicRouter
					.getCurrentState()
					.name.split(".");
				currentPage = currentPage[currentPage.length - 1];

				if (getPages.length > 0) {
					for (var i = 0; i < pagesArray.length; i++) {
						if (currentPage == pagesArray[i]) {
							displayTopBanner = true;
						}
					}

					for (var d = 0; d < declinePages.length; d++) {
						if (currentPage == declinePages[d]) {
							displayTopBanner = false;
						}
					}
				}

				if (displayTopBanner) {
					$scope.$root.$broadcast("show-top-banner", bannerText);
				} else {
					$scope.$root.$broadcast("hide-top-banner");
				}
			} else {
				return;
			}
		}

		vm.getSteps = function () {
			return dynamicRouter.getSteps();
		};

		vm.isCurrent = function (stepNumber) {
			return (
				getStateByNumber(stepNumber) ==
				dynamicRouter.getCurrentState().name
			);
		};

		vm.canMoveToStep = function (stepNumber) {
			return stepNumber < dynamicRouter.getCurrentState().number;
		};

		vm.moveToStep = function (stepNumber) {
			if (vm.canMoveToStep(stepNumber)) {
				$scope.$root.$broadcast("hide-top-banner");
				$state.go(getStateByNumber(stepNumber));
			}
		};

		vm.moveToSelectedStep = function () {
			if (!!vm.selectedStep) {
				$scope.$root.$broadcast("hide-top-banner");
				$state.go(vm.selectedStep);
			} else {
				// hack to stop vm.selectedStep to nullifying
				vm.selectedStep = vm.lastSelectedStep;
			}
		};
	}

	angular.module("qbePortal").component("qbProgressBar", {
		templateUrl: "../ngviews/components/qbProgressBar.html",
		controller: QBProgressBarController,
		controllerAs: "vm",
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('qbRangeBar', qbRangeBar);

	qbRangeBar.$inject = ['$scope', 'labelService', '$timeout'];

	function qbRangeBar($scope, labelService, $timeout) {
		var vm = this;
		void 0;

		vm.getAverageWidth = function () {
			var averageWidth = {'width': '10%'};

			if (!!vm.minimum && !!vm.maximum && !!vm.average) {

				vm.total = (vm.maximum - vm.minimum);
				vm.averageWidth = (vm.average - vm.minimum) / vm.total * 100;
				averageWidth = {'width': vm.averageWidth + '%'};
			}

			return averageWidth;
		};

		vm.getCirclePos = function () {
			if (!!vm.value) {
				if (vm.value >= vm.minimum && vm.value <= vm.maximum) {
					var pos = (vm.value - vm.minimum) / vm.total * 100;
					return {'left': pos + '%'};
				}
				else if (vm.value > vm.maximum) {
					vm.value = vm.maximum;
					return {'left': '100%'};
				}
				else if (vm.value < vm.minimum) {
					vm.value = vm.minimum;
					return {'left': '0%'};
				}
			}
			else {
				return {'left': '0%'};
			}
		};
		vm.getAveragePos = function () {
			if (!!vm.averageWidth) {
				var pos = (vm.averageWidth - 17) * -1;
				return {'left': pos + '%'};
			}
		};
	}

	angular.module('qbePortal').component('qbRangeBar', {
		templateUrl: '/ngviews/components/qbRangeBar.html',
		controller: qbRangeBar,
		controllerAs: 'vm',
		bindings: {
			value: '@',
			minimum: '<',
			maximum: '<',
			average: '<'
		}
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('QBRapidEstimateQuotesPanel', QBRapidEstimateQuotesPanel);
	QBRapidEstimateQuotesPanel.$inject = ['$scope', '$state', 'quoteModelFactory', 'labelService', 'portalServiceWrapper', 'userInputRepository', 'serviceResponseRepository', 'MAService', '$timeout', 'quoteOptions', 'gtmService', 'coverTypeResolver', 'quoteResultFilter' , 'storage'];

	function QBRapidEstimateQuotesPanel($scope, $state, quoteModelFactory, labelService, portalServiceWrapper, userInputRepository, serviceResponseRepository, MAService, $timeout, quoteOptions, gtmService, coverTypeResolver, quoteResultFilter, storage) {
		var vm = this,
			quoteHasCoverType = false;

		vm.formData = {};

		var quoteModel = quoteModelFactory.create();

		if (quoteModel.coverType) {
			quoteHasCoverType = true;
		}

		if (quoteHasCoverType) {
			vm.quoteModel = quoteModel.coverType[0];
		}

		$scope.$root.$on('process-rapid-estimates', displayRapidEstimateResults);

		function displayRapidEstimateResults(event, args) {
			var quotesTemp = [];
			vm.formData = args.formData;
			vm.scrollCTA = labelService.getGlobalOptionLabel('rapidEstimate', 'scrollCTA');
			vm.productType = labelService.getGlobalOptionLabel('rapidEstimate', 'productType');
			quoteOptions.clearQuoteResults();
			var mergedQuotes = quoteOptions.getMergedQuoteResults(args.results);
			angular.forEach(mergedQuotes, function (mergedQuote, index) {
				var quote = mergedQuote.getAnnual(),
					monthlyQuote = mergedQuote.getMonthly();

				if (!quote.quoteResult.errors) {
					var offering = quote.offering;
					var coverType = quote.coverType;
					var coverIndicator = offering ? offering : coverType;
					var coverDetails = labelService.getGlobalOption('coverTypes', coverIndicator) ;
					coverDetails.yearlyPayment =  quote.quoteResult.totalPremium;
					coverDetails.monthlyPayment = monthlyQuote.paymentPlan.installment;
					coverDetails.totalPremium = quote.quoteResult.totalPremium;
					coverDetails.offering = offering;
					coverDetails.coverType = coverType;
					coverDetails.coverTypeSubClass = coverDetails.coverTypeSubClass || 'standard' ;
					quotesTemp.push(
						coverDetails
					);
				}
			});

			quotesTemp = quoteResultFilter.filter(window.qbe.rapidEstimateFilter, quotesTemp);
			vm.quotes = quotesTemp;
			$scope.$root.$broadcast('show-rapid-estimates');
			$scope.$root.$broadcast('loading-animation-end');
			animateToResults();
		}

		function animateToResults() {
			$timeout(function () {
				var scrollAnchor = $('qb-rapid-estimate-quotes-panel');
				$('html, body').animate({
					scrollTop: scrollAnchor.offset().top
				}, 'slow');
			}, 100);
		}

		vm.apply = function (quote, paymentFrequency, applyFormPath) {
			$scope.$root.$broadcast('loading-animation-start');
			gtmService.trackEvent('rapid-estimate-apply');
			if (quote.offering)
				quoteOptions.setSelectedOffering(quote.offering);
			else {
				quoteOptions.setSelectedCoverType(quote.coverTypeClass, quote.coverTypeSubClass);
			}

			vm.formData.rapidEstimateUrl = window.location.href;
			userInputRepository.update(vm.formData);
			portalServiceWrapper.updateQuote(vm.formData);
			portalServiceWrapper.saveQuote('everyyear').then(function (resp) {
				performMAServices('apply-now');
				if (!applyFormPath){
					$scope.$emit('rapid-estimate-redirect') ;
				} else {
					storage.setItem('ignoreRapidEstimateRoute' , vm.productType );
					window.location = applyFormPath;
				}
			})
			.catch(function (err) {
				$scope.$root.$broadcast('error', {
					errorMessage: 'Save quote error',
					response: err
				});
			});
		}

		function performMAServices(eventName) {
			var form;
			switch (vm.productType) {
				case 'Car':
					form = vm.formData.vehicleForm;
					break;
				case 'Motorcycle':
					form = vm.formData.bikeForm;
					break;
				case 'Caravan':
					form = vm.formData.caravanForm;
					break;
				case 'Home':
					form = vm.formData.homeForm;
					break;
			}
			var policyEmail = form.tellUsMore ? form.tellUsMore.email : null;
			var campaignCode = form.tellUsMore ? form.tellUsMore.promotionalCode : null;
			var quoteResult = quoteOptions.getSelectedQuoteResult();
			var savedQuote = serviceResponseRepository.getLastResponseFrom('quote');
			var maData = {
				pageName: 'rapid-estimate',
				campaignCode: campaignCode,
				policyEmail: policyEmail,
				annualResult: quoteResult.getAnnual(),
				monthlyResult: quoteResult.getMonthly(),
				quoteId: savedQuote ? savedQuote.quoteID : null,
			};
			void 0;
			MAService.mergeContacts(eventName, maData)
		}

		$scope.$root.$broadcast('rapid-estimates-panel-initialised');
	}

	angular.module('qbePortal').component('qbRapidEstimateQuotesPanel', {
		templateUrl: '/ngviews/components/qbRapidEstimateQuotesPanel.html',
		controller: QBRapidEstimateQuotesPanel,
		controllerAs: 'vm',
		bindings: {
			applyFormPath: '@'
		}
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('RegoSearchController', RegoSearchController);

	RegoSearchController.$inject = ['$scope', 'STATES', 'regoSearchService', 'serviceResponseRepository', 'quoteModelFactory', 'labelService'];

	function RegoSearchController($scope, STATES, regoSearchService, serviceResponseRepository, quoteModelFactory, labelService) {
		var vm = this,
			searchType;

		vm.rego = '';
		vm.yearInput = null;
		vm.makeInput = '';
		vm.modelInput = '';
		vm.carOption = '';
		vm.states = STATES;
		vm.modelResponse = null;
		vm.makeResponse = null;

		vm.isMakeSearchInProgress = false;
		vm.isModelSearchInProgress = false;

		vm.isRegoSearchError = false;

		vm.bodyStyles = [];
		vm.engineSizes = [],
			vm.selectedBodyStyle = 'Hatchback';

		vm.resetSearchLabel = labelService.getLabelFor('resetSearch');

		vm.carOptions = '';
		//vm.chosenResult = '';
		var quoteModel = quoteModelFactory.create();
		quoteModel.regoDetails ? vm.chosenResult = quoteModel.regoDetails : vm.chosenResult = '';
		searchType = '';

		function existsInArray(array, searchTerm, property) {
			for (var i = 0, len = array.length; i < len; i++) {
				if (array[i][property] === searchTerm) {
					return true;
				}
			}
			return false;
		}


		function getPastYears() {
			var years = [];
			var prevYear = '';

			for (var i = 0; i < 100; i++) {
				prevYear = moment().subtract(i, 'year').format('Y');
				years.push({label: prevYear, value: prevYear});
			}

			return years;
		}

		function buildArray(data, array, property) {

			if (data.length >= 5) {
				data.forEach(function (object) {
					var item = object[property];

					if (!existsInArray(array, item, 'value')) {
						array.push({
							value: item,
							label: item
						});
					}
				});
			}
		}

		var yearsObject = getPastYears();

		vm.searchBy = function (type) {
			return searchType == type;
		}

		vm.showSearch = function (type) {
			vm.chosenResult = '';
			searchType = type;
		}

		vm.getYears = function () {
			return yearsObject;
		}

		vm.searchRegoNo = function (regoForm) {
			var isValid = regoForm.carRegoNumber.$valid
				&& regoForm.carRegoNumberState.$valid;
			vm.isRegoSearchError = false;
			if (isValid) {
				vm.update({
					name: 'regoDetails', value: {
						regoNumber: vm.rego,
						state: vm.selectedState,
					}
				});


				regoSearchService.search({
					rego: vm.rego,
					state: vm.selectedState,
				}, function (resp) {
					vm.chosenResult = resp;
					vm.update({name: 'regoSearchResponse', value: resp});
					serviceResponseRepository.update('regoSearch', resp);
				}, function (error) {
					vm.isRegoSearchError = true;
				});
			}
		}

		// On change of Year dropdown, trigger a search for the Make.
		vm.searchMake = function (yearInput) {
			vm.yearInput = yearInput;

			var tempYear = null;

			if (tempYear !== vm.yearInput.value) {
				vm.makeInput = undefined;
				vm.modelInput = undefined;
				vm.carOptions = '';
			}

			if (vm.yearInput.value !== '') {
				vm.isMakeSearchInProgress = true;
				tempYear = vm.yearInput.value;

				regoSearchService.searchMake({
					year: vm.yearInput.value
				}, function (resp) {
					vm.makeResponse = resp;
					vm.isMakeSearchInProgress = false;
				});
			}
		}

		// On change of the Make dropdown, trigger a search for Model
		vm.searchModel = function (makeInput) {
			vm.makeInput = makeInput;

			// console.info(makeInput);

			var tempMake = null;

			if (tempMake !== vm.makeInput.value) {
				vm.modelInput = undefined;
				vm.carOptions = '';
			}

			if (vm.makeInput !== '') {
				vm.isModelSearchInProgress = true;

				regoSearchService.searchModel({
					year: vm.yearInput.value,
					make: vm.makeInput.code
				}, function (resp) {
					vm.isModelSearchInProgress = false;
					vm.modelResponse = resp;
				});
			}
		}

		// Update the current car options based on engine/body filters
		vm.filterCarOptions = function (type) {

			if (type == 'bodyStyle') {
				vm.engineSizes = [];
				vm.selectedEngineSize = undefined;
			}

			// If only the body style is selected
			if (vm.selectedBodyStyle !== undefined && vm.selectedEngineSize == undefined) {
				vm.filteredCarOptions = vm.carOptions.filter(filterArrayByBody);
			}

			// If only the engine size is selected
			if (vm.selectedEngineSize !== undefined && vm.selectedBodyStyle == undefined) {
				vm.filteredCarOptions = vm.carOptions.filter(filterArrayByEngine);
			}

			// If both are selected
			if (vm.selectedEngineSize !== undefined && vm.selectedBodyStyle !== undefined) {
				vm.filteredCarOptions = vm.carOptions.filter(filterArrayByBodyAndEngine);
			}

			// Rebuild the engine size array


			buildArray(vm.filteredCarOptions, vm.engineSizes, 'engineSize');

		}

		// On change of the Model dropdown, trigger a final search for the car details
		vm.getCarDetails = function (modelInput) {
			vm.carOptions = '';
			vm.bodyStyles = [];
			vm.engineSizes = [];
			vm.selectedBodyStyle = undefined;
			vm.selectedEngineSize = undefined;

			vm.modelInput = modelInput;

			if (vm.modelInput !== undefined) {
				regoSearchService.searchCar({
					year: vm.yearInput.value,
					make: vm.makeInput.code,
					model: vm.modelInput.code
				}, function (resp) {
					buildArray(resp, vm.bodyStyles, 'bodyStyle');
					buildArray(resp, vm.engineSizes, 'engineSize');
					vm.carOptions = resp;
					vm.filteredCarOptions = resp;
				});
			} else {
				vm.carOptions = '';
				vm.chosenResult = '';
				vm.carOption = '';
			}

		}

		function filterArrayByBodyAndEngine(item) {
			return item.bodyStyle == vm.selectedBodyStyle.value && item.engineSize == vm.selectedEngineSize.value ? 1 : 0;
		}

		function filterArrayByBody(item) {
			return item.bodyStyle == vm.selectedBodyStyle.value ? 1 : 0;
		}

		function filterArrayByEngine(item) {
			return item.engineSize == vm.selectedEngineSize.value ? 1 : 0;
		}

		vm.showChosenCar = function (key) {
			vm.chosenResult = vm.filteredCarOptions[key];
			vm.update({name: 'regoSearchResponse', value: vm.chosenResult});
			serviceResponseRepository.update('regoSearch', vm.chosenResult);
		}

		vm.isCarSelected = function () {
			return vm.chosenResult !== '';
		}

		vm.resetSearch = function () {
			vm.chosenResult = '';
			serviceResponseRepository.update('regoSearch', null);
		}

		vm.registerHierarchy = function (name, setHierarchyFn) {
			vm.setHierarchy({name: name, setHierarchyFn: setHierarchyFn});
		}

	}

	angular.module('qbePortal').component('regoSearch', {
		templateUrl: '/ngviews/components/qbRegoSearch.html',
		controller: RegoSearchController,
		controllerAs: 'vm',
		bindings: {
			update: '&',
			setHierarchy: '&',
			validationSelector: '@',
		}
	});
})();

(function() {
	'use strict';

	angular.module('qbePortal').controller('QBSaveQuote', QBSaveQuote);

	QBSaveQuote.$inject = [
		'$scope',
		'quoteModelFactory',
		'portalServiceWrapper',
		'userInputRepository',
		'quoteOptions',
		'labelService',
		'ipCookie',
		'gtmService',
		'quoteRequestRepository',
	];

	function QBSaveQuote(
		$scope,
		quoteModelFactory,
		portalServiceWrapper,
		userInputRepository,
		quoteOptions,
		labelService,
		ipCookie,
		gtmService,
		quoteRequestRepository
	) {
		$scope.$root.$on('open-modal', openModal);

		var vm = this;

		vm.opened = false;
		vm.isError = false;

		function openModal() {
			vm.label = labelService.getLabelFor('saveQuoteEmail');
			var quoteModel = quoteModelFactory.create();

			vm.email = quoteModel.email;
			vm.quoteNo = quoteModel.quoteId;
			vm.opened = true;

			if (vm.email !== undefined && vm.email !== null) {
				vm.showForm = false;
				saveQuote();
			} else {
				vm.showForm = true;
			}
		}

		function saveQuote() {
			// Call MA service here to send email
			portalServiceWrapper.updateQuote(userInputRepository.get());

			var paymentFrequency = quoteOptions.getSelectedPaymentFrequencyForService();

			portalServiceWrapper
				.saveQuote(paymentFrequency)
				.then(function(resp) {
					$scope.$root.$broadcast('perform-ma-service', 'save');
					var quoteModel = quoteModelFactory.create();
					vm.email = quoteModel.email;
					vm.quoteNo = quoteModel.quoteId;

					ipCookie('QBE_portal_vehicle_quote_id', vm.quoteNo, {
						path: '/'
					});

					// Show mini spinner
					vm.showForm = false;

					// If quoteId found and email found, triggerGoal service quote
					var qr = quoteRequestRepository.getSaveQuoteRequest(paymentFrequency);
					if (qr && qr.quoteID && vm.email) {
						portalServiceWrapper.triggerGoalSaveQuote();
					}

					$scope.$root.$broadcast('save-quote-success');

					return resp;
				})
				.catch(function(err) {
					$scope.$root.$broadcast('error', {
						errorMessage: 'Save quote error',
						response: err
					});
					return err;
				});
		}

		vm.saveForm = function(form) {
			if (form.$valid) {
				gtmService.trackEvent('save');
				userInputRepository.update({ email: vm.email });
				saveQuote();
			} else {
				// console.info('Please enter an email');
				vm.isError = true;
			}
		};

		vm.closeModal = function() {
			vm.opened = false;
			vm.email = null; // clear email field
			$scope.$root.$broadcast('close-modal', { modal: 'saveQuote' });
		};

		vm.getSectionLabelFor = function(fieldName) {
			return labelService.getSectionLabelFor(fieldName);
		};

		vm.getSectionDescriptionFor = function(fieldName) {
			return labelService.getSectionDescriptionFor(fieldName);
		};
	}

	angular.module('qbePortal').component('qbSaveQuote', {
		templateUrl: '../ngviews/components/qbSaveQuote.html',
		controller: QBSaveQuote,
		controllerAs: 'vm',
		bindings: {
			email: '<'
		}
	});
})();

(function () {
	"use strict";

	angular
		.module("qbePortal")
		.controller("QBTopBannerController", QBTopBannerController);

	QBTopBannerController.$inject = ["$scope", "labelService", "$window"];

	function QBTopBannerController($scope, labelService, $window) {
		var vm = this;

		vm.showTopBanner = false;
		//vm.bannerText = $window.qbe.fieldLabels.topBanner.bannerText;

		vm.closeTopBanner = function () {
			vm.showTopBanner = false;
		};

		$scope.$root.$on("show-top-banner", function (event, bannerText) {
			vm.bannerText = bannerText;
			vm.showTopBanner = true;
		});

		$scope.$root.$on("hide-top-banner", function () {
			vm.showTopBanner = false;
		});
	}

	angular.module("qbePortal").component("qbTopBanner", {
		templateUrl: "/ngviews/components/qbTopBanner.html",
		controller: QBTopBannerController,
		controllerAs: "vm",
		bindings: {},
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('QBValidationController', QBValidationController);

	QBValidationController.$inject = ['$scope', 'validationService'];

	function QBValidationController($scope, validationService) {
		var vm = this, scope = $scope, validationMessages = {};

		var hasErrors = false, errors = {};

		var validationResult = null;

		// $scope.$on('field-error', onError);
		$scope.validationSelector = vm.validationSelector;
		// function onError (event, error) {
		// 	var currentFieldSelector = error.section + '.' + error.inputName ;
		// 	//console.log(vm.validationSelector + ' | ' + currentFieldSelector);
		// 	if (vm.validationSelector == currentFieldSelector ) {
		// 		hasErrors = true ;
		// 		errors[error.type] = error ;
		// 		console.log('field has error') ;
		// 		$scope.$emit('enable-field-error-class') ;
		// 	}
		// }

		vm.validationMessageFor = function (rule) {
			// if ( ! validationResult )
			validationResult = validationService.getFieldErrors(vm.validationSelector);
			return validationResult ? validationResult.errors[rule] : null;
		}

		vm.isInvalid = function (rule) {
			return validationService.isFieldInvalid(vm.validationSelector, rule); //, vm.messageKey) ;
			// return validationResult[rule] ;
		}
	}

	angular.module('qbePortal').component('qbValidation', {
		templateUrl: '/ngviews/components/qbValidation.html',
		controller: QBValidationController,
		controllerAs: 'vm',
		bindings: {
			validationSelector: '<',
			messageKey: '<',
		}
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('VehicleSubTypeSelector', VehicleSubTypeSelector);

	VehicleSubTypeSelector.$inject = ['$scope', 'serviceResponseRepository', 'quoteModelFactory', 'labelService'];

	function VehicleSubTypeSelector($scope, serviceResponseRepository, quoteModelFactory, labelService) {
		var vm = this;

		vm.registerHierarchy = function (name, setHierarchyFn) {
			vm.setHierarchy({name: name, setHierarchyFn: setHierarchyFn});
		}

		vm.onValueChanged = function () {
			vm.update({name: vm.name, value: vm.fieldValue});
		}

		vm.getOptions = function () {
			var options;

			switch (vm.vehicleType) {
				case 'caravan':
					options = labelService.getOptionsFor('caravanSubTypes');
					break;
				case 'campertrailer':
					options = labelService.getOptionsFor('camperTrailerSubTypes');
					break;
				case 'goodscarryingtrailer':
					options = labelService.getOptionsFor('goodsCarryingTrailerSubTypes');
					break;
			}

			return options;
		}

	}

	angular.module('qbePortal').component('vehicleSubTypeSelector', {
		templateUrl: '../ngviews/components/qbVehicleSubTypeSelector.html',
		controller: VehicleSubTypeSelector,
		controllerAs: 'vm',
		bindings: {
			name: '@',
			update: '&',
			setHierarchy: '&',
			validationSelector: '@',
			fieldValue: '<',
			vehicleType: '<',
			labelWildcard: '<'
		}
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('YearMakeModelSearchController', YearMakeModelSearchController);

	YearMakeModelSearchController.$inject = [
    '$rootScope',
		'$scope', 
		'regoSearchService', 
		'serviceResponseRepository', 
		'quoteModelFactory', 
		'labelService', 
		'storage'
	];

	function YearMakeModelSearchController(
    $rootScope,
		$scope, 
		regoSearchService, 
		serviceResponseRepository, 
		quoteModelFactory, 
		labelService, 
		storage) {
		var vm = this,
			searchType;

		vm.yearInput = null;
		vm.makeInput = '';
		vm.modelInput = '';
		vm.yearMakeModelResult = '';
		vm.modelResponse = null;
		vm.makeResponse = null;

		vm.bodyStyles = [];
		vm.engineSizes = [],
			vm.selectedBodyStyle = '';

		vm.resetSearchLabel = labelService.getLabelFor('resetSearch');

		vm.isMakeSearchInProgress= false ;
		vm.isModelSearchInProgress= false ;

		vm.yearMakeModelResults = '';

		var quoteModel = quoteModelFactory.create();
		vm.chosenResult = quoteModel.regoDetails ? quoteModel.regoDetails : null ;

		$scope.$on("recall-get-details", recallGetDetails);

		function recallGetDetails() {
			if (vm.modelInput){
				vm.getDetails(vm.modelInput);
			}
 		}

		function existsInArray(array, searchTerm, property) {
			for (var i = 0, len = array.length; i < len; i++) {
				if (array[i][property] === searchTerm) {
					return true;
				}
			}
			return false;
		}

		function getPastYears() {
			var years = [];
			var prevYear = '';

			for (var i = 0; i < 100; i++) {
				prevYear = moment().subtract(i, 'year').format('Y');
				years.push({label: prevYear, value: prevYear});
			}

			return years;
		}

		function buildArray(data, array, property) {

			if (data.length >= 5) {
				data.forEach(function (object) {
					var item = object[property];

					if (!existsInArray(array, item, 'value')) {
						array.push({
							value: item,
							label: item
						});
					}
				});
			}
		}

		var yearsObject = getPastYears();

		vm.searchBy = function (type) {
			return searchType == type;
		}

		vm.showSearch = function (type) {
			vm.chosenResult = null ;
			searchType = type;
		}

		vm.getYears = function () {
			return yearsObject;
		}

		vm.getPolicyStartDate = function() {
			return storage.getItem('policy-start-date');
		}

		// On change of Year dropdown, trigger a search for the Make.
		vm.searchMake = function (yearInput) {
			vm.yearInput = yearInput;

			var tempYear = null;

			if (tempYear !== vm.yearInput.value) {
				vm.makeInput = undefined;
				vm.modelInput = undefined;
				vm.yearMakeModelResults = '';
			}

			if (vm.yearInput.value !== '') {
				vm.isMakeSearchInProgress = true;
				vm.makeResponse = null;
				vm.modelResponse = null;
				tempYear = vm.yearInput.value;

				regoSearchService.searchMake({
					year: vm.yearInput.value,
					effectiveDate: vm.getPolicyStartDate(),
				}
				,function (resp) {
					vm.isMakeSearchInProgress = false
					vm.makeResponse = resp;
				});
			}
		}

		// On change of the Make dropdown, trigger a search for Model
		vm.searchModel = function (makeInput) {
			vm.makeInput = makeInput;

			var tempMake = null;

			if (tempMake !== vm.makeInput.value) {
				vm.modelInput = undefined;
				vm.yearMakeModelResults = '';
			}

			if (vm.makeInput !== '') {
				vm.isModelSearchInProgress = true;
				vm.modelResponse = null;

				regoSearchService.searchModel({
					year: vm.yearInput.value,
					make: vm.makeInput.code,
					effectiveDate: vm.getPolicyStartDate(),
				},function (resp) {
					vm.isModelSearchInProgress = false;
					vm.modelResponse = resp;
				});
			}
		}

		// Update the current car options based on engine/body filters
		vm.filterOptions = function (type) {

			if (type == 'bodyStyle') {
				vm.engineSizes = [];
				vm.selectedEngineSize = undefined;
			}

			// If only the body style is selected
			if (vm.selectedBodyStyle !== undefined && vm.selectedEngineSize == undefined) {
				vm.filteredOptions = vm.yearMakeModelResults.filter(filterArrayByBody);
			}

			// If only the engine size is selected
			if (vm.selectedEngineSize !== undefined && vm.selectedBodyStyle == undefined) {
				vm.filteredOptions = vm.yearMakeModelResults.filter(filterArrayByEngine);
			}

			// If both are selected
			if (vm.selectedEngineSize !== undefined && vm.selectedBodyStyle !== undefined) {
				vm.filteredOptions = vm.yearMakeModelResults.filter(filterArrayByBodyAndEngine);
			}

			// Rebuild the engine size array


			buildArray(vm.filteredOptions, vm.engineSizes, 'engineSize');

		}

		// On change of the Model dropdown, trigger a final search for the car details
		vm.getDetails = function (modelInput) {
			vm.yearMakeModelResults = '';
			vm.bodyStyles = [];
			vm.engineSizes = [];
			vm.selectedBodyStyle = undefined;
			vm.selectedEngineSize = undefined;

			vm.modelInput = modelInput;

			if (vm.modelInput !== undefined) {
				regoSearchService.searchCar({
					year: vm.yearInput.value,
					make: vm.makeInput.code,
					model: vm.modelInput.code,
					effectiveDate: vm.getPolicyStartDate(),
				}, function (resp) {
					buildArray(resp, vm.bodyStyles, 'bodyStyle');
					buildArray(resp, vm.engineSizes, 'engineSize');
					vm.yearMakeModelResults = resp;
					vm.filteredOptions = resp;
				});
			} else {
				vm.yearMakeModelResults = '';
				vm.chosenResult = '';
			}

		}

		function filterArrayByBodyAndEngine(item) {
			return item.bodyStyle == vm.selectedBodyStyle.value && item.engineSize == vm.selectedEngineSize.value ? 1 : 0;
		}

		function filterArrayByBody(item) {
			return item.bodyStyle == vm.selectedBodyStyle.value ? 1 : 0;
		}

		function filterArrayByEngine(item) {
			return item.engineSize == vm.selectedEngineSize.value ? 1 : 0;
		}

		function updateRepository() {
			vm.update({name: 'regoDetails', value: vm.chosenResult});
			serviceResponseRepository.update('regoSearch', vm.chosenResult);
		}

		vm.selectOption = function () {
			vm.chosenResult = vm.yearMakeModelResults[vm.yearMakeModelOption];
			updateRepository();

			$rootScope.$broadcast("bike-selected");
		}

		vm.isResultSelected = function () {
			return !!vm.chosenResult; // !== undefined && vm.chosenResult !== '';
		}

		vm.resetSearch = function () {
			vm.yearMakeModelOption = '';
			vm.chosenResult = null;
			vm.update({name: 'regoDetails', value: null});
			serviceResponseRepository.update('regoSearch', null);
		}

		vm.registerHierarchy = function (name, setHierarchyFn) {
			vm.setHierarchy({name: name, setHierarchyFn: setHierarchyFn});
		}

	}

	angular.module('qbePortal').component('yearMakeModelSearch', {
		templateUrl: '/ngviews/components/qbYearMakeModelSearch.html',
		controller: YearMakeModelSearchController,
		controllerAs: 'vm',
		bindings: {
			update: '&',
			setHierarchy: '&',
			validationSelector: '@',
			hideSubFilters: '<',
			labelWildcard: '<',
		}
	});
})();

(function () {

	angular.module('qbePortal').controller('QBYearsHeld', QBYearsHeld);

	QBYearsHeld.$inject = ['$scope', 'MODULE_INFO'];

	function QBYearsHeld($scope, MODULE_INFO) {
		var vm = this;

		vm.$onInit = function () {
			vm.fieldValue = vm.ngModel;
		}

		vm.registerHierarchy = function (name, setHierarchyFn) {
			vm.setHierarchy({
				name: name,
				setHierarchyFn: setHierarchyFn
			});
		}

		vm.onValueChanged = function () {
			vm.update({
				name: vm.name,
				value: vm.fieldValue
			});
		}

		// Calculate age using DoB.
		function calcAge() {

			return (moment(new Date()).diff(moment(vm.dob, 'DD/MM/YYYY'), 'years', true));

		}

		// Refine select options depending on age
		vm.getFilteredOptions = function () {

			var fullOptions = vm.options.slice();
			var age = calcAge();

			if (age > 17 && age <= 18) {
				fullOptions = fullOptions.splice(0, 2);
			} else if (age > 18 && age <= 19) {
				fullOptions = fullOptions.splice(0, 3);
			} else if (age > 19 && age <= 20) {
				fullOptions = fullOptions.splice(0, 4);
			} else if (age > 20 && age <= 21) {
				fullOptions = fullOptions.splice(0, 5);
			} else if (age > 21 && age <= 22) {
				fullOptions = fullOptions.splice(0, 6);
			}

			return fullOptions;

		}


	}

	angular.module('qbePortal').component('qbYearsHeld', {
		templateUrl: '../ngviews/components/qbYearsHeld.html',
		controller: QBYearsHeld,
		controllerAs: 'vm',
		bindings: {
			options: '<',
			name: '@',
			ngModel: '<',
			update: '&',
			setHierarchy: '&',
			dob: '<'
		}
	});
})();

(function () {
	'use strict';

	angular.module('qbePortal').controller('QBYesNoController', QBYesNoController);
	QBYesNoController.$inject = ['$scope' /*, '$state' */ ];

	function QBYesNoController($scope) {
		var vm = this;

		vm.$onInit = function () {
			vm.id = vm.id || vm.name;
			vm.inputName = (vm.sectionName ? (vm.sectionName + '_') : '') + vm.id;
			vm.yesFieldId = vm.inputName + '_yes';
			vm.noFieldId = vm.inputName + '_no';

			vm.registerHierarchy = function (name, setHierarchyFn) {
				vm.setHierarchy({
					name: name,
					setHierarchyFn: setHierarchyFn
				});
			}

			vm.onValueChanged = function () {
				vm.update({
					name: vm.name,
					value: vm.fieldValue
				});

				vm.valueChange();
				if (vm.commonValue !== undefined) {
					$scope.$emit('common-value-update', {
						name: vm.commonValue,
						value: (vm.fieldValue)
					});
				}

				if (vm.requote !== undefined) {
					$scope.$root.$broadcast('requote', vm.requote);
				}
			}

			vm.isRequired = function (condition) {
				if (condition) {

					// Unselect radios when no longer mandatory
					if (condition === 'false') {
						$('#' + vm.yesFieldId).attr('checked', false);
						$('#' + vm.noFieldId).attr('checked', false);
					}

					return condition === 'true';

					// Defaults to `true` if `required` attribute is not set
				} else {
					return true;
				}
			}
		}
	}

	angular.module('qbePortal').component('qbYesNo', {
		templateUrl: '/ngviews/components/qbYesNo.html',
		controller: QBYesNoController,
		controllerAs: 'vm',
		bindings: {
			name: '@',
			ariaLabel: '@',
			required: '@',
			update: '&',
			id: '@?',
			sectionName: '<',
			fieldValue: '<',
			commonValue: '@?',
			requote: '@?',
			valueChange: '&',
			tableData: '<', // data in the associated table.
		}
	});
})();

angular.module('qbePortal.routes').provider('dynamicRouter',['$stateProvider', dynamicRouterProvider]);

angular.module('qbePortal.routes')
    .config(['$locationProvider', 'dynamicRouterProvider', '$urlRouterProvider', function($locationProvider, dynamicRouterProvider, $urlRouterProvider) {

      $urlRouterProvider.otherwise("/404");

      $locationProvider.html5Mode({
        enabled: true,
      });
}]);

angular.module('qbePortal.routes.vehicle')
    .config(['$locationProvider', 'dynamicRouterProvider', '$urlRouterProvider', function($locationProvider, dynamicRouterProvider, $urlRouterProvider) {
       dynamicRouterProvider.init(window.routes, ['vehicle']) ;
}]);

angular.module('qbePortal.routes.bike')
    .config(['$locationProvider', 'dynamicRouterProvider', '$urlRouterProvider', function($locationProvider, dynamicRouterProvider, $urlRouterProvider) {
       dynamicRouterProvider.init(window.routes, ['bike']) ;
}]);

angular.module('qbePortal.routes.caravan')
    .config(['$locationProvider', 'dynamicRouterProvider', '$urlRouterProvider', function($locationProvider, dynamicRouterProvider, $urlRouterProvider) {
       dynamicRouterProvider.init(window.routes, ['caravan']) ;
}]);

angular.module('qbePortal.routes.home')
    .config(['$locationProvider', 'dynamicRouterProvider', '$urlRouterProvider', function($locationProvider, dynamicRouterProvider, $urlRouterProvider) {
       dynamicRouterProvider.init(window.routes, ['home']) ;
}]);

angular.module('qbePortal.routes.ctp')
    .config(['$locationProvider', 'dynamicRouterProvider', '$urlRouterProvider', function($locationProvider, dynamicRouterProvider, $urlRouterProvider) {
       dynamicRouterProvider.init(window.routes, ['ctp']) ;
}]);
    
angular.module('qbePortal.routes.payments')
    .config(['$locationProvider', 'dynamicRouterProvider', '$urlRouterProvider', function($locationProvider, dynamicRouterProvider, $urlRouterProvider) {
       dynamicRouterProvider.init(window.routes, ['payments']) ;
}]);
(function (app) {
	var routes = app.routes = {};

	routes.common = {
		error: {
			name: 'error',
			config: {
				controller: 'ErrorController',
				controllerAs: '$ctrl'
			}
		},
		decline: {
			name: 'decline',
			config: {
				controller: 'DeclineController',
				controllerAs: '$ctrl'
			}
		},
		referral: {
			name: 'referral',
			config: {
				controller: 'DeclineController',
				controllerAs: '$ctrl'
			}
		},
		embargo: {
			name: 'embargo',
			config: {
				controller: 'DeclineController',
				controllerAs: '$ctrl'
			}
		},
		cybersourcePaymentForm: {
			name: 'cybersourcePaymentForm',
			config: {
				controller: 'CybersourcePaymentFormController',
				controllerAs: '$ctrl'
			}
		},
		cybersourceCallback: {
			name: 'cybersourceCallback',
			config: {
				controller: 'CybersourceCallbackController',
				controllerAs: '$ctrl'
			}
		},
		paypalCallback: {
			name: 'paypalCallback',
			config: {
				controller: 'PaypalCallbackController',
				controllerAs: '$ctrl'
			}
		},
		policyStartDate: {
			name: 'policyStartDate',
			config: {
				controller: 'PolicyStartDateController',
				controllerAs: '$ctrl'
			}
		}
	};

	routes.vehicle = {
		home: {
			name: 'vehicle',
			config: {
				abstract: true,
				template: '<div ui-view></div><div ui-view="sidebar"></div>'
			}
		},
		steps: [{
				name: 'vehicle.vehicle',
				config: {
					views: {
						'@': {
							controller: 'FormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'vehicle.drivers',
				config: {
					views: {
						'@': {
							controller: 'FormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'vehicle.quote',
				config: {
					views: {
						'@': {
							controller: 'FormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'vehicle.contact',
				config: {
					views: {
						'@': {
							controller: 'FormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'vehicle.payment',
				config: {
					views: {
						'@': {
							controller: 'PaymentController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'vehicle.done',
				config: {
					views: {
						'@': {
							controller: 'FormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'vehicle.policy-start-date',
				config: {
					views: {
						'@': {
							controller: 'PolicyStartDateController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {}
					}
				}
			}
		]
	};

	routes.ctp = {
		home: {
			name: 'ctp',
			config: {
				abstract: true,
				template: '<div ui-view></div><div ui-view="sidebar"></div>'
			}
		},
		steps: [{
			name: 'ctp.ctp',
			config: {
				views: {
					'@': {
						controller: 'ctpFormController',
						controllerAs: '$ctrl',
					},
					'sidebar@': {},
					'header@': {},
					'meta@': {},
					'progressbar@': {},
					'headbar@': {}
				}
			}
		}]
	};

	routes.bike = {
		home: {
			name: 'bike',
			config: {
				abstract: true,
				template: '<div ui-view></div><div ui-view="sidebar"></div>'
			}
		},
		steps: [{
				name: 'bike.bike',
				config: {
					views: {
						'@': {
							controller: 'BikeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'bike.riders',
				config: {
					views: {
						'@': {
							controller: 'BikeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'bike.quote',
				config: {
					views: {
						'@': {
							controller: 'BikeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'bike.contact',
				config: {
					views: {
						'@': {
							controller: 'BikeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'bike.payment',
				config: {
					views: {
						'@': {
							controller: 'PaymentController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'bike.done',
				config: {
					views: {
						'@': {
							controller: 'BikeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'bike.policy-start-date',
				config: {
					views: {
						'@': {
							controller: 'PolicyStartDateController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {}
					}
				}
			}
		]
	};

	routes.home = {
		home: {
			name: 'home',
			config: {
				abstract: true,
				template: '<div ui-view></div><div ui-view="sidebar"></div>'
			}
		},
		steps: [{
				name: 'home.estimate',
				config: {
					views: {
						'@': {
							controller: 'HomeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'home.property',
				config: {
					views: {
						'@': {
							controller: 'HomeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'home.building',
				config: {
					views: {
						'@': {
							controller: 'HomeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				},
				condition: function () {
					return true;
				}
			},
			{
				name: 'home.covers',
				config: {
					views: {
						'@': {
							controller: 'HomeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'home.details',
				config: {
					views: {
						'@': {
							controller: 'HomeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'home.quote',
				config: {
					views: {
						'@': {
							controller: 'HomeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'home.contact',
				config: {
					views: {
						'@': {
							controller: 'HomeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'home.payment',
				config: {
					views: {
						'@': {
							controller: 'PaymentController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'home.done',
				config: {
					views: {
						'@': {
							controller: 'HomeFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'home.policy-start-date',
				config: {
					views: {
						'@': {
							controller: 'PolicyStartDateController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {}
					}
				}
			}
		]
	};


	routes.caravan = {
		home: {
			name: 'caravan',
			config: {
				abstract: true,
				template: '<div ui-view></div><div ui-view="sidebar"></div>'
			}
		},
		steps: [{
				name: 'caravan.caravan',
				config: {
					views: {
						'@': {
							controller: 'CaravanFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'caravan.drivers',
				config: {
					views: {
						'@': {
							controller: 'CaravanFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'caravan.quote',
				config: {
					views: {
						'@': {
							controller: 'CaravanFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'caravan.contact',
				config: {
					views: {
						'@': {
							controller: 'CaravanFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'caravan.payment',
				config: {
					views: {
						'@': {
							controller: 'PaymentController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'caravan.done',
				config: {
					views: {
						'@': {
							controller: 'CaravanFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {},
						'progressbar@': {},
						'headbar@': {}
					}
				}
			},
			{
				name: 'caravan.policy-start-date',
				config: {
					views: {
						'@': {
							controller: 'PolicyStartDateController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {}
					}
				}
			}
		]
	};

	routes.payments = {
		home: {
			name: 'payments',
			config: {
				abstract: true,
				template: '<div ui-view></div><div ui-view="sidebar"></div>'
			}
		},
		steps: [{
				name: 'payments.payments',
				config: {
					views: {
						'@': {
							controller: 'paymentsFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {}
					}
				}
			},
			{
				name: 'payments.complete',
				config: {
					views: {
						'@': {
							controller: 'paymentsFormController',
							controllerAs: '$ctrl',
						},
						'sidebar@': {},
						'header@': {},
						'meta@': {}
					}
				}
			}
		]
	};

})(window);
